import * as e from "maptalks";

import { Coordinate as t, Util as n, Point as r, Polygon as i, Extent as s, worker as o, Map as a, renderer as l } from "maptalks";

import { mat4 as c, vec3 as h, vec4 as d, mat3 as u, vec2 as f, quat as m, glMatrix as g, mat2 as _, mat2d as p, quat2 as v } from "gl-matrix";

import { buildTangents as x, packTangentFrame as y, buildNormals as b } from "@maptalks/tbn-packer";

import w from "@maptalks/regl";

import { GLContext as T } from "@maptalks/fusiongl";

export { GLContext } from "@maptalks/fusiongl";

const S = function() {
    if ("undefined" != typeof globalThis) return globalThis;
    if ("undefined" != typeof self) return self;
    if ("undefined" != typeof window) return window;
    throw new Error("unable to locate global object");
};

function M() {
    return S().maptalks_gltf_loader;
}

function A(e) {
    return !C(e) && ("string" == typeof e || null !== e.constructor && e.constructor === String);
}

function C(e) {
    return null == e;
}

function k(e) {
    return !C(e);
}

function O(e) {
    return !C(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
}

function E(e, ...t) {
    return Object.assign(e, ...t), e;
}

function P(e, ...t) {
    for (let n = 0; n < t.length; n++) {
        const r = t[n];
        for (const t in r) void 0 !== r[t] && null !== r[t] && (e[t] = r[t]);
    }
    return e;
}

function I(e) {
    return "number" == typeof e && !isNaN(e);
}

function R(e, t, n) {
    return e * (1 - n) + t * n;
}

function L(e) {
    return Array.isArray(e) || e instanceof Uint8Array || e instanceof Int8Array || e instanceof Uint16Array || e instanceof Int16Array || e instanceof Uint32Array || e instanceof Int32Array || e instanceof Uint8ClampedArray || e instanceof Float32Array || e instanceof Float64Array;
}

function F(e) {
    return Array.isArray(e) && Array || e instanceof Uint8Array && Uint8Array || e instanceof Int8Array && Int8Array || e instanceof Uint16Array && Uint16Array || e instanceof Int16Array && Int16Array || e instanceof Uint32Array && Uint32Array || e instanceof Int32Array && Int32Array || e instanceof Uint8ClampedArray && Uint8ClampedArray || e instanceof Float32Array && Float32Array || e instanceof Float64Array && Float64Array;
}

function H(e, t, n) {
    return Math.min(n, Math.max(t, e));
}

function D(e) {
    return void 0 === e.supportVAO && (e.supportVAO = function(e) {
        return !globalThis.MAPTALKS_DISABLE_VAO && !e.wgpu && e && e.hasExtension && e.hasExtension("oes_vertex_array_object");
    }(e)), e.supportVAO;
}

function N(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}

function B(e) {
    if (e.data) {
        if (e.data.BYTES_PER_ELEMENT) return e.data.length * e.data.BYTES_PER_ELEMENT;
        if (e.data.length) return 4 * e.data.length;
    } else {
        if (e.BYTES_PER_ELEMENT) return e.length * e.BYTES_PER_ELEMENT;
        if (e.length) return 4 * e.length;
        if (e.buffer && e.buffer.destroy) {
            const t = e.buffer._buffer;
            return t ? t.byteLength : e.buffer.size;
        }
    }
    return 0;
}

function U(e) {
    return e.width * e.height * G(e.format) * z(e.type) * ("textureCube" === e._reglType ? 6 : 1);
}

function z(e) {
    return "uint8" === e ? 1 : "uint16" === e || "float16" === e || "half float" === e ? 2 : "uint32" === e || "float" === e || "float32" === e ? 4 : 0;
}

function G(e) {
    return "depth" === e || "alpha" === e || "luminance" === e ? 1 : "luminance alpha" === e || "depth stencil" === e ? 2 : "srgba" === e || "rgb5 a1" === e || "rgba" === e.substring(0, 4) ? 4 : "srgb" === e || "rgb" === e.substring(0, 3) ? 3 : 1;
}

function V(e) {
    if (!e.componentType) return !1;
    const t = M().GLTFLoader.getTypedArrayCtor(e.componentType);
    return e.byteStride > 0 && e.byteStride !== e.itemSize * t.BYTES_PER_ELEMENT;
}

function j(e) {
    return e && (e.stride > 0 || V(e));
}

function W(e) {
    const t = e.getExtension && e, n = !t && e, r = "WEBGL_compressed_texture_", i = "texture-compression-", s = {
        "etc": t ? !!t.getExtension(r + "etc") : !!n.features.has(i + "etc2"),
        "etc1": t ? !!t.getExtension(r + "etc1") : !!n.features.has(i + "etc2"),
        "s3tc": t ? !!t.getExtension(r + "s3tc") : !!n.features.has(i + "bc"),
        "pvrtc": !!t && !!t.getExtension(r + "pvrtc"),
        "astc": t ? !!t.getExtension(r + "astc") : !!n.features.has(i + "astc"),
        "bc7": t ? !!t.getExtension("EXT_texture_compression_bptc") : !!n.features.has(i + "bc")
    };
    return s[r + "etc"] = s.etc, s[r + "etc1"] = s.etc1, s[r + "s3tc"] = s.s3tc, s[r + "pvrtc"] = s.pvrtc, 
    s[r + "astc"] = s.astc, s[r + "bc7"] = s.bc7, s;
}

function q(e) {
    let t = 0;
    const n = e && e.length || 0;
    if (!n) return t;
    let r;
    for (let i = 0; i < n; i++) r = e.charCodeAt(i), t = (t << 5) - t + r, t |= 0;
    return t;
}

function X(e) {
    return !(e & e - 1) && 0 !== e;
}

function K(e) {
    return Math.pow(2, Math.floor(Math.log(e) / Math.LN2));
}

function Z(e, t, n) {
    if (L(e)) return X(t) && X(n) ? e : function(e, t, n) {
        let r = t, i = n;
        X(t) || (r = K(t)), X(n) || (i = K(n));
        const s = new ImageData(new Uint8ClampedArray(e), t, n), o = document.createElement("canvas");
        o.width = t, o.height = n, o.getContext("2d").putImageData(s, 0, 0);
        const a = document.createElement("canvas");
        a.width = r, a.height = i, a.getContext("2d").drawImage(o, 0, 0, t, n, 0, 0, i, i), 
        console.warn(`Texture's size is not power of two, resize from (${t}, ${n}) to (${r}, ${i})`);
        let l = document.getElementById("_debug_resize_canvas");
        return l || (l = document.createElement("canvas"), l.id = "_debug_resize_canvas", 
        document.body.appendChild(l)), l.width = r, l.height = i, l.getContext("2d").drawImage(a, 0, 0), 
        a;
    }(e, t, n);
    if (X(e.width) && X(e.height)) return e;
    t = e.width, n = e.height, X(t) || (t = K(t)), X(n) || (n = K(n));
    const r = document.createElement("canvas");
    r.width = t, r.height = n, r.getContext("2d").drawImage(e, 0, 0, t, n);
    const i = e.src, s = i.lastIndexOf("/") + 1, o = i.substring(s);
    return console.warn(`Texture(${o})'s size is not power of two, resize from (${e.width}, ${e.height}) to (${t}, ${n})`), 
    r;
}

function Y(e) {
    return !!e.wgpu || (!e._gl || e._gl instanceof WebGL2RenderingContext);
}

function $(e) {
    return e && (e.dispose || e.destroy);
}

var J = Object.freeze({
    __proto__: null,
    clamp: H,
    defined: k,
    extend: E,
    extendWithoutNil: P,
    getArrayCtor: F,
    getBufferSize: B,
    getPosArrayType: function(e) {
        return (e = Math.abs(e)) < 128 ? Int8Array : e < 32768 ? Int16Array : Float32Array;
    },
    getSupportedFormats: W,
    getTexMemorySize: U,
    getTextureByteWidth: z,
    getTextureChannels: G,
    hasOwn: N,
    hashCode: q,
    interpolate: R,
    isArray: L,
    isFunction: O,
    isInStride: V,
    isInterleaved: j,
    isNil: C,
    isNumber: I,
    isPowerOfTwo: X,
    isString: A,
    isSupportVAO: D,
    isTextureDestroyed: function(e) {
        return e.device ? !e.texture : !e._texture || !e._texture.texture;
    },
    isTextureLike: $,
    lerp: function(e, t, n, r) {
        for (let i = 0; i < e.length; i++) e[i] = t[i] + r * (n[i] - t[i]);
        return e;
    },
    log2: function(e) {
        return Math.log2(e);
    },
    normalize: function(e, t) {
        let n = 0;
        for (let e = 0, r = t.length; e < r; e++) n += t[e];
        for (let r = 0, i = t.length; r < i; r++) e[r] = t[r] / n;
        return e;
    },
    resizeToPowerOfTwo: Z,
    set: function(e, t) {
        for (let n = 0; n < e.length; n++) e[n] = t[n];
        return e;
    },
    supportNPOT: Y
});

function Q(e) {
    return class extends e {
        on(e, t) {
            return this._events || (this._events = {
                type: [ t ]
            }), this._events[e] = this._events[e] || [], this._events[e].push(t), this;
        }
        once(e, t) {
            return this.on(e, this._wrapOnce(e, t));
        }
        off(e, t) {
            return this._events && this._events[e] ? (this._events[e].splice(this._events[e].indexOf(t), 1), 
            this) : this;
        }
        fire(e, t = {}) {
            if (!this._events || !this._events[e]) return this;
            t.target || (t.target = this);
            const n = this._events[e].slice(0);
            for (const e of n) e(t);
            return this;
        }
        _wrapOnce(e, t) {
            const n = this;
            let r = !1;
            return function i(s) {
                r || (r = !0, t(s), n.off(e, i));
            };
        }
    };
}

const ee = "__reshader_disposed", te = "not implemented";

var ne = Object.freeze({
    __proto__: null,
    ERROR_NOT_IMPLEMENTED: te,
    KEY_DISPOSED: ee,
    WEBGL_EXTENSIONS: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives" ],
    WEBGL_OPTIONAL_EXTENSIONS: [ "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_texture_filter_anisotropic" ]
});

const re = "_reshader_refCount";

let ie = class {};

class se extends(Q(ie)){
    constructor(e, t) {
        if (super(), O(e)) {
            this._texture = e, e = this.config = {};
            for (const t in this._texture) N(this._texture, t) && (O(this._texture[t]) || (e[t] = this._texture[t]));
        } else if (this.config = e || {}, this.resLoader = t, (e.url || e.promise) && !e.data) {
            this._loading = !0;
            const n = this;
            let r;
            if (e.promise) r = e.promise; else {
                let n;
                n = e.arrayBuffer ? t.getArrayBuffer : t.get, r = n.call(t, e.url);
            }
            e.data = t.getDefaultTexture(e.url), this.promise = r, r.then((e => (delete this.promise, 
            n._loading = !1, n.config ? (n.onLoad(e), Array.isArray(e) || (e = [ e ]), n.fire("complete", {
                target: this,
                resources: e
            }), e) : e))).catch((e => {
                console.error("error when loading texture image.", e), n.fire("error", {
                    target: this,
                    error: e
                });
            }));
        }
    }
    onLoad(e) {}
    isReady() {
        return !this._loading;
    }
    set(e, t) {
        return this.config[e] = t, this.dirty = !0, this;
    }
    get(e) {
        return this.config[e];
    }
    createREGLTexture(e) {
        return null;
    }
    getREGLTexture(e) {
        return this._texture || (this._texture = this.createREGLTexture(e), this.config.persistent || (this.config.data && (this.config.data instanceof ImageBitmap || (this.config.data = [])), 
        this.config.image && (this.config.image.array = []), this.config.mipmap && delete this.config.mipmap)), 
        this.dirty && this._update(), this._texture;
    }
    getMemorySize() {
        if (!this.config) return 0;
        const {width: e, height: t, type: n, format: r} = this.config;
        return e * t * z(n || "uint8") * G(r || "rgba");
    }
    _update() {
        throw new Error(te);
    }
    dispose() {
        this.config && this.config.url && (URL.revokeObjectURL(this.config.url), this.resLoader.disposeRes(this.config.url)), 
        this.config && this.config.data instanceof ImageBitmap && (this.config.data.close(), 
        this.config.data = []), this._texture && !this._texture[ee] && (this._texture[re] && this._texture[re]--, 
        this._texture[re] || (this._texture.destroy(), this._texture[ee] = !0, delete this._texture)), 
        delete this.resLoader, delete this._regl;
        const e = this.config && this.config.url;
        delete this.config, e && this.fire("disposed", {
            target: this,
            url: e
        });
    }
}

const oe = c.identity([]), ae = c.identity([]);

class le {
    constructor(e, t) {
        this.min = e || [ 1 / 0, 1 / 0, 1 / 0 ], this.max = t || [ -1 / 0, -1 / 0, -1 / 0 ], 
        this.updateVertex();
    }
    static copy(e, t) {
        h.copy(e.min, t.min), h.copy(e.max, t.max);
        for (let n = 0; n < t.vertex.length; n++) h.copy(e.vertex[n], t.vertex[n]);
        return e;
    }
    combine(e) {
        if (!e) return this;
        let t, n;
        return Array.isArray(e) ? (t = e[0], n = e[1]) : (t = e.min, n = e.max), t[0] < this.min[0] && (this.min[0] = t[0], 
        this._dirty = !0), t[1] < this.min[1] && (this.min[1] = t[1], this._dirty = !0), 
        t[2] < this.min[2] && (this.min[2] = t[2], this._dirty = !0), n[0] > this.max[0] && (this.max[0] = n[0], 
        this._dirty = !0), n[1] > this.max[1] && (this.max[1] = n[1], this._dirty = !0), 
        n[2] > this.max[2] && (this.max[2] = n[2], this._dirty = !0), this;
    }
    dirty() {
        return this._dirty = !0, this;
    }
    getCenter() {
        return this.center || (this.center = [ 0, 0, 0 ], this._dirty = !0), this._dirty && (h.add(this.center, this.min, this.max), 
        h.scale(this.center, this.center, .5)), this._dirty = !1, this.center;
    }
    containPoint(e) {
        const t = this.min, n = this.max;
        return t[0] <= e[0] && t[1] <= e[1] && t[2] <= e[2] && n[0] >= e[0] && n[1] >= e[1] && n[2] >= e[2];
    }
    isFinite() {
        const e = this.min, t = this.max;
        return isFinite(e[0]) && isFinite(e[1]) && isFinite(e[2]) && isFinite(t[0]) && isFinite(t[1]) && isFinite(t[2]);
    }
    updateVertex() {
        if (!this.vertex) {
            this.vertex = [];
            for (let e = 0; e < 8; e++) this.vertex.push([ 0, 0, 0 ]);
        }
        return this.vertex[0][0] = this.min[0], this.vertex[0][1] = this.min[1], this.vertex[0][2] = this.min[2], 
        this.vertex[1][0] = this.min[0], this.vertex[1][1] = this.min[1], this.vertex[1][2] = this.max[2], 
        this.vertex[2][0] = this.min[0], this.vertex[2][1] = this.max[1], this.vertex[2][2] = this.max[2], 
        this.vertex[3][0] = this.min[0], this.vertex[3][1] = this.max[1], this.vertex[3][2] = this.min[2], 
        this.vertex[4][0] = this.max[0], this.vertex[4][1] = this.min[1], this.vertex[4][2] = this.min[2], 
        this.vertex[5][0] = this.max[0], this.vertex[5][1] = this.min[1], this.vertex[5][2] = this.max[2], 
        this.vertex[6][0] = this.max[0], this.vertex[6][1] = this.max[1], this.vertex[6][2] = this.max[2], 
        this.vertex[7][0] = this.max[0], this.vertex[7][1] = this.max[1], this.vertex[7][2] = this.min[2], 
        this.vertex;
    }
    copy(e) {
        return e ? le.copy(e, this) : new le(this.min.slice(), this.max.slice());
    }
    equals(e) {
        if (!h.equals(this.min, e.min) || !h.equals(this.max, e.max)) return !1;
        const t = e.vertex;
        for (let e = 0; e < this.vertex.length; e++) if (!h.equals(t[e], this.vertex[e])) return !1;
        return !0;
    }
    transform(e, t) {
        if (e = e || ae, (t = t || ae)[1] || t[2] || t[4] || t[6] || t[8] || t[9]) {
            const n = this.vertex, r = c.multiply(oe, t, e);
            for (let e = 0; e < n.length; e++) h.transformMat4(this.vertex[e], this.vertex[e], r);
            const i = this.vertex.map((e => e[0])), s = this.vertex.map((e => e[1])), o = this.vertex.map((e => e[2])), a = Math.min(...i), l = Math.max(...i), d = Math.min(...s), u = Math.max(...s), f = Math.min(...o), m = Math.max(...o);
            h.set(this.min, a, d, f), h.set(this.max, l, u, m);
        } else {
            const n = c.multiply(oe, t, e);
            h.transformMat4(this.min, this.min, n), h.transformMat4(this.max, this.max, n);
        }
        return this;
    }
}

function ce(e, t, n = 2) {
    const r = t && t.length, i = r ? t[0] * n : e.length;
    let s = he(e, 0, i, n, !0);
    const o = [];
    if (!s || s.next === s.prev) return o;
    let a, l, c;
    if (r && (s = function(e, t, n, r) {
        const i = [];
        for (let n = 0, s = t.length; n < s; n++) {
            const o = he(e, t[n] * r, n < s - 1 ? t[n + 1] * r : e.length, r, !1);
            o === o.next && (o.steiner = !0), i.push(be(o));
        }
        i.sort(pe);
        for (let e = 0; e < i.length; e++) n = ve(i[e], n);
        return n;
    }(e, t, s, n)), e.length > 80 * n) {
        a = 1 / 0, l = 1 / 0;
        let t = -1 / 0, r = -1 / 0;
        for (let s = n; s < i; s += n) {
            const n = e[s], i = e[s + 1];
            n < a && (a = n), i < l && (l = i), n > t && (t = n), i > r && (r = i);
        }
        c = Math.max(t - a, r - l), c = 0 !== c ? 32767 / c : 0;
    }
    return ue(s, o, n, a, l, c, 0), o;
}

function he(e, t, n, r, i) {
    let s;
    if (i === function(e, t, n, r) {
        let i = 0;
        for (let s = t, o = n - r; s < n; s += r) i += (e[o] - e[s]) * (e[s + 1] + e[o + 1]), 
        o = s;
        return i;
    }(e, t, n, r) > 0) for (let i = t; i < n; i += r) s = Ie(i / r | 0, e[i], e[i + 1], s); else for (let i = n - r; i >= t; i -= r) s = Ie(i / r | 0, e[i], e[i + 1], s);
    return s && Ae(s, s.next) && (Re(s), s = s.next), s;
}

function de(e, t) {
    if (!e) return e;
    t || (t = e);
    let n, r = e;
    do {
        if (n = !1, r.steiner || !Ae(r, r.next) && 0 !== Me(r.prev, r, r.next)) r = r.next; else {
            if (Re(r), r = t = r.prev, r === r.next) break;
            n = !0;
        }
    } while (n || r !== t);
    return t;
}

function ue(e, t, n, r, i, s, o) {
    if (!e) return;
    !o && s && function(e, t, n, r) {
        let i = e;
        do {
            0 === i.z && (i.z = ye(i.x, i.y, t, n, r)), i.prevZ = i.prev, i.nextZ = i.next, 
            i = i.next;
        } while (i !== e);
        i.prevZ.nextZ = null, i.prevZ = null, function(e) {
            let t, n = 1;
            do {
                let r, i = e;
                e = null;
                let s = null;
                for (t = 0; i; ) {
                    t++;
                    let o = i, a = 0;
                    for (let e = 0; e < n && (a++, o = o.nextZ, o); e++) ;
                    let l = n;
                    for (;a > 0 || l > 0 && o; ) 0 !== a && (0 === l || !o || i.z <= o.z) ? (r = i, 
                    i = i.nextZ, a--) : (r = o, o = o.nextZ, l--), s ? s.nextZ = r : e = r, r.prevZ = s, 
                    s = r;
                    i = o;
                }
                s.nextZ = null, n *= 2;
            } while (t > 1);
        }(i);
    }(e, r, i, s);
    let a = e;
    for (;e.prev !== e.next; ) {
        const l = e.prev, c = e.next;
        if (s ? me(e, r, i, s) : fe(e)) t.push(l.i, e.i, c.i), Re(e), e = c.next, a = c.next; else if ((e = c) === a) {
            o ? 1 === o ? ue(e = ge(de(e), t), t, n, r, i, s, 2) : 2 === o && _e(e, t, n, r, i, s) : ue(de(e), t, n, r, i, s, 1);
            break;
        }
    }
}

function fe(e) {
    const t = e.prev, n = e, r = e.next;
    if (Me(t, n, r) >= 0) return !1;
    const i = t.x, s = n.x, o = r.x, a = t.y, l = n.y, c = r.y, h = Math.min(i, s, o), d = Math.min(a, l, c), u = Math.max(i, s, o), f = Math.max(a, l, c);
    let m = r.next;
    for (;m !== t; ) {
        if (m.x >= h && m.x <= u && m.y >= d && m.y <= f && Te(i, a, s, l, o, c, m.x, m.y) && Me(m.prev, m, m.next) >= 0) return !1;
        m = m.next;
    }
    return !0;
}

function me(e, t, n, r) {
    const i = e.prev, s = e, o = e.next;
    if (Me(i, s, o) >= 0) return !1;
    const a = i.x, l = s.x, c = o.x, h = i.y, d = s.y, u = o.y, f = Math.min(a, l, c), m = Math.min(h, d, u), g = Math.max(a, l, c), _ = Math.max(h, d, u), p = ye(f, m, t, n, r), v = ye(g, _, t, n, r);
    let x = e.prevZ, y = e.nextZ;
    for (;x && x.z >= p && y && y.z <= v; ) {
        if (x.x >= f && x.x <= g && x.y >= m && x.y <= _ && x !== i && x !== o && Te(a, h, l, d, c, u, x.x, x.y) && Me(x.prev, x, x.next) >= 0) return !1;
        if (x = x.prevZ, y.x >= f && y.x <= g && y.y >= m && y.y <= _ && y !== i && y !== o && Te(a, h, l, d, c, u, y.x, y.y) && Me(y.prev, y, y.next) >= 0) return !1;
        y = y.nextZ;
    }
    for (;x && x.z >= p; ) {
        if (x.x >= f && x.x <= g && x.y >= m && x.y <= _ && x !== i && x !== o && Te(a, h, l, d, c, u, x.x, x.y) && Me(x.prev, x, x.next) >= 0) return !1;
        x = x.prevZ;
    }
    for (;y && y.z <= v; ) {
        if (y.x >= f && y.x <= g && y.y >= m && y.y <= _ && y !== i && y !== o && Te(a, h, l, d, c, u, y.x, y.y) && Me(y.prev, y, y.next) >= 0) return !1;
        y = y.nextZ;
    }
    return !0;
}

function ge(e, t) {
    let n = e;
    do {
        const r = n.prev, i = n.next.next;
        !Ae(r, i) && Ce(r, n, n.next, i) && Ee(r, i) && Ee(i, r) && (t.push(r.i, n.i, i.i), 
        Re(n), Re(n.next), n = e = i), n = n.next;
    } while (n !== e);
    return de(n);
}

function _e(e, t, n, r, i, s) {
    let o = e;
    do {
        let e = o.next.next;
        for (;e !== o.prev; ) {
            if (o.i !== e.i && Se(o, e)) {
                let a = Pe(o, e);
                return o = de(o, o.next), a = de(a, a.next), ue(o, t, n, r, i, s, 0), void ue(a, t, n, r, i, s, 0);
            }
            e = e.next;
        }
        o = o.next;
    } while (o !== e);
}

function pe(e, t) {
    let n = e.x - t.x;
    if (0 === n && (n = e.y - t.y, 0 === n)) {
        n = (e.next.y - e.y) / (e.next.x - e.x) - (t.next.y - t.y) / (t.next.x - t.x);
    }
    return n;
}

function ve(e, t) {
    const n = function(e, t) {
        let n = t;
        const r = e.x, i = e.y;
        let s, o = -1 / 0;
        if (Ae(e, n)) return n;
        do {
            if (Ae(e, n.next)) return n.next;
            if (i <= n.y && i >= n.next.y && n.next.y !== n.y) {
                const e = n.x + (i - n.y) * (n.next.x - n.x) / (n.next.y - n.y);
                if (e <= r && e > o && (o = e, s = n.x < n.next.x ? n : n.next, e === r)) return s;
            }
            n = n.next;
        } while (n !== t);
        if (!s) return null;
        const a = s, l = s.x, c = s.y;
        let h = 1 / 0;
        n = s;
        do {
            if (r >= n.x && n.x >= l && r !== n.x && we(i < c ? r : o, i, l, c, i < c ? o : r, i, n.x, n.y)) {
                const t = Math.abs(i - n.y) / (r - n.x);
                Ee(n, e) && (t < h || t === h && (n.x > s.x || n.x === s.x && xe(s, n))) && (s = n, 
                h = t);
            }
            n = n.next;
        } while (n !== a);
        return s;
    }(e, t);
    if (!n) return t;
    const r = Pe(n, e);
    return de(r, r.next), de(n, n.next);
}

function xe(e, t) {
    return Me(e.prev, e, t.prev) < 0 && Me(t.next, e, e.next) < 0;
}

function ye(e, t, n, r, i) {
    return (e = 1431655765 & ((e = 858993459 & ((e = 252645135 & ((e = 16711935 & ((e = (e - n) * i | 0) | e << 8)) | e << 4)) | e << 2)) | e << 1)) | (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) << 1;
}

function be(e) {
    let t = e, n = e;
    do {
        (t.x < n.x || t.x === n.x && t.y < n.y) && (n = t), t = t.next;
    } while (t !== e);
    return n;
}

function we(e, t, n, r, i, s, o, a) {
    return (i - o) * (t - a) >= (e - o) * (s - a) && (e - o) * (r - a) >= (n - o) * (t - a) && (n - o) * (s - a) >= (i - o) * (r - a);
}

function Te(e, t, n, r, i, s, o, a) {
    return !(e === o && t === a) && we(e, t, n, r, i, s, o, a);
}

function Se(e, t) {
    return e.next.i !== t.i && e.prev.i !== t.i && !function(e, t) {
        let n = e;
        do {
            if (n.i !== e.i && n.next.i !== e.i && n.i !== t.i && n.next.i !== t.i && Ce(n, n.next, e, t)) return !0;
            n = n.next;
        } while (n !== e);
        return !1;
    }(e, t) && (Ee(e, t) && Ee(t, e) && function(e, t) {
        let n = e, r = !1;
        const i = (e.x + t.x) / 2, s = (e.y + t.y) / 2;
        do {
            n.y > s != n.next.y > s && n.next.y !== n.y && i < (n.next.x - n.x) * (s - n.y) / (n.next.y - n.y) + n.x && (r = !r), 
            n = n.next;
        } while (n !== e);
        return r;
    }(e, t) && (Me(e.prev, e, t.prev) || Me(e, t.prev, t)) || Ae(e, t) && Me(e.prev, e, e.next) > 0 && Me(t.prev, t, t.next) > 0);
}

function Me(e, t, n) {
    return (t.y - e.y) * (n.x - t.x) - (t.x - e.x) * (n.y - t.y);
}

function Ae(e, t) {
    return e.x === t.x && e.y === t.y;
}

function Ce(e, t, n, r) {
    const i = Oe(Me(e, t, n)), s = Oe(Me(e, t, r)), o = Oe(Me(n, r, e)), a = Oe(Me(n, r, t));
    return i !== s && o !== a || (!(0 !== i || !ke(e, n, t)) || (!(0 !== s || !ke(e, r, t)) || (!(0 !== o || !ke(n, e, r)) || !(0 !== a || !ke(n, t, r)))));
}

function ke(e, t, n) {
    return t.x <= Math.max(e.x, n.x) && t.x >= Math.min(e.x, n.x) && t.y <= Math.max(e.y, n.y) && t.y >= Math.min(e.y, n.y);
}

function Oe(e) {
    return e > 0 ? 1 : e < 0 ? -1 : 0;
}

function Ee(e, t) {
    return Me(e.prev, e, e.next) < 0 ? Me(e, t, e.next) >= 0 && Me(e, e.prev, t) >= 0 : Me(e, t, e.prev) < 0 || Me(e, e.next, t) < 0;
}

function Pe(e, t) {
    const n = Le(e.i, e.x, e.y), r = Le(t.i, t.x, t.y), i = e.next, s = t.prev;
    return e.next = t, t.prev = e, n.next = i, i.prev = n, r.next = n, n.prev = r, s.next = r, 
    r.prev = s, r;
}

function Ie(e, t, n, r) {
    const i = Le(e, t, n);
    return r ? (i.next = r.next, i.prev = r, r.next.prev = i, r.next = i) : (i.prev = i, 
    i.next = i), i;
}

function Re(e) {
    e.next.prev = e.prev, e.prev.next = e.next, e.prevZ && (e.prevZ.nextZ = e.nextZ), 
    e.nextZ && (e.nextZ.prevZ = e.prevZ);
}

function Le(e, t, n) {
    return {
        i: e,
        x: t,
        y: n,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: !1
    };
}

function Fe(e) {
    const t = [], n = [], r = e[0][0].length;
    let i = 0, s = 0;
    for (const o of e) {
        for (const e of o) for (let n = 0; n < r; n++) t.push(e[n]);
        s && (i += s, n.push(i)), s = o.length;
    }
    return {
        vertices: t,
        holes: n,
        dimensions: r
    };
}

function He(e) {
    let t;
    return Array.isArray(e) || e instanceof Float32Array ? t = "float32" : e instanceof Uint32Array ? t = "uint32" : e instanceof Int32Array ? t = "sint32" : e instanceof Uint16Array ? t = "uint16" : e instanceof Int16Array ? t = "sint16" : e instanceof Uint8Array ? t = "uint8" : e instanceof Int8Array && (t = "sint8"), 
    t;
}

const De = {
    5120: {
        name: "sint8",
        bytes: 1
    },
    5122: {
        name: "sint16",
        bytes: 2
    },
    5124: {
        name: "sint32",
        bytes: 4
    },
    5121: {
        name: "uint8",
        bytes: 1
    },
    5123: {
        name: "uint16",
        bytes: 2
    },
    5125: {
        name: "uint32",
        bytes: 4
    },
    5126: {
        name: "float32",
        bytes: 4
    }
};

function Ne(e, t) {
    const n = De[e].name;
    return t > 1 ? n + "x" + t : n;
}

const Be = {
    mat2x3f: {
        pad: [ 3, 1 ]
    },
    mat2x3h: {
        pad: [ 3, 1 ]
    },
    mat3x3f: {
        pad: [ 3, 1 ]
    },
    mat3x3h: {
        pad: [ 3, 1 ]
    },
    mat4x3f: {
        pad: [ 3, 1 ]
    },
    mat4x3h: {
        pad: [ 3, 1 ]
    },
    mat3x4f: {
        pad: [ 3, 1 ]
    },
    mat3x4h: {
        pad: [ 3, 1 ]
    }
};

function Ue(e, t) {
    return 0 === t ? e : Math.ceil(e / t) * t;
}

const ze = [], Ge = {
    5120: "int8",
    5122: "int16",
    5124: "int32",
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float"
}, Ve = {
    5120: 1,
    5122: 2,
    5124: 4,
    5121: 1,
    5123: 2,
    5125: 4,
    5126: 4
}, je = {
    "positionSize": 3,
    "primitive": "triangles",
    "positionAttribute": "aPosition",
    "normalAttribute": "aNormal",
    "uv0Attribute": "aTexCoord",
    "uv1Attribute": "aTexCoord1",
    "color0Attribute": "aColor0",
    "tangentAttribute": "aTangent",
    "pickingIdAttribute": "aPickingId",
    "textureCoordMatrixAttribute": "aTextureCoordMatrix"
};

let We = new Uint16Array(1024);

let qe = 1;

const Xe = "_reshader_refCount", Ke = {};

function Ze(e, t) {
    const n = e.name;
    (!Ke[n] || Ke[n].length < t) && (Ke[n] = new e(t));
    const r = Ke[n].subarray(0, t);
    return r.fill(0), r;
}

class Ye {
    static createElementBuffer(e, t) {
        if (e.wgpu) {
            if (Array.isArray(t)) {
                t = new (it(t))(t);
            }
            return rt(e, t, GPUBufferUsage.INDEX | GPUBufferUsage.COPY_DST, "index buffer");
        }
        return e.elements(t);
    }
    static createBuffer(e, t, n) {
        return e.wgpu ? rt(e, t, GPUBufferUsage.VERTEX | GPUBufferUsage.COPY_DST, n) : e.buffer(t);
    }
    static padGPUBufferAlignment(e, t) {
        if (0 === t) return e;
        const n = e.byteLength / t;
        if (n % 4 == 0) return e;
        const r = e.constructor, i = e.length / t;
        if (3 === i) {
            const s = st(i, n / i), o = Ze(r, s * t);
            for (let n = 0; n < t; n++) for (let t = 0; t < i; t++) o[n * s + t] = e[n * i + t];
            return o;
        }
        {
            const n = function(e, t) {
                if (e === Uint8Array || e === Uint8ClampedArray) return 1 === t ? Uint32Array : Uint16Array;
                if (e === Int8Array) return 1 === t ? Int32Array : Int16Array;
                if (e === Uint16Array) return Uint32Array;
                if (e === Int16Array) return Int32Array;
                throw new Error("sth unexpected in getPadArrayCtor");
            }(r, i), s = Ze(n, i * t);
            return s.set(e), s;
        }
    }
    constructor(e, t, n, r) {
        this._version = 0, this.data = e, this.elements = t, this.desc = E({}, je, r), this.semantic = function(e) {
            const t = {};
            for (const n in je) n.endsWith("Attribute") && (t[e[n]] = je[n]);
            return t;
        }(this.desc);
        const i = this._getPosAttribute();
        this.data[this.desc.positionAttribute] = i, n || (this.elements ? n = $e(this.elements) : i && i.length ? n = i.length / this.desc.positionSize : i && i.interleavedArray ? n = i.interleavedArray.length / this.desc.positionSize : i && i.array && (n = i.array.length / this.desc.positionSize)), 
        this.count = n, this.elements || (this.elements = n), this._isIndexed = !I(this.elements), 
        this.properties = {}, this._buffers = {}, this._vao = {}, this.getVertexCount(), 
        this._prepareData(!0), this.updateBoundingBox();
    }
    set version(e) {
        throw new Error("Geometry.version is read only.");
    }
    get version() {
        return this._version;
    }
    _getPosAttribute() {
        return this.data[this.desc.positionAttribute];
    }
    _prepareData(e) {
        if (!this.data) return;
        const t = this._buffers || {};
        for (const n in this.data) {
            const r = this.data[n];
            if (r) if (r.buffer && r.buffer.destroy) {
                const t = r.buffer;
                t[Xe] || (t[Xe] = 0), e && t[Xe]++;
            } else if (r && r.array) if (V(r)) {
                let e = r.array.buffer.__id;
                e || (e = r.array.buffer.__id = qe++), this.data[n] = {
                    buffer: e,
                    offset: r.byteOffset,
                    stride: r.byteStride,
                    type: Ge[r.componentType],
                    size: r.itemSize,
                    count: r.count,
                    componentType: r.componentType
                }, t[e] || (t[e] = {
                    data: r.array.buffer
                });
            } else this.data[n] = r.array;
        }
        this._buffers = t;
        const n = this.elements;
        n && n.array && (this.elements = n.array);
    }
    getBuffer(e) {
        return this.data[e] && this.data[e].buffer;
    }
    getAttrData(e) {
        const t = e.key, n = !this._reglData || !this._reglData[t];
        if (this._reglData || (this._reglData = {}), n) {
            const e = this._reglData[t] = {}, n = this.data, {positionAttribute: r, normalAttribute: i, uv0Attribute: s, uv1Attribute: o, tangentAttribute: a, color0Attribute: l, pickingIdAttribute: c, textureCoordMatrixAttribute: h} = this.desc;
            E(e, this.data), e.aPosition = n[r], n[i] && (e.aNormal = n[i]), n[s] && (e.aTexCoord = n[s]), 
            n[o] && (e.aTexCoord1 = n[o]), n[a] && (e.aTangent = n[a]), n[l] && (e.aColor0 = n[l]), 
            n[c] && (e.aPickingId = n[c]), n[h] && (e.aTextureCoordMatrix = n[h]);
        }
        return this._reglData[t];
    }
    getREGLData(e, t, n) {
        if (this.getAttrData(t), D(e) && !n) {
            const n = !this._reglData || !this._reglData[t.key], r = t && t.key || "default";
            if (!this._vao[r] || n || this._vao[r].dirty) {
                const n = this._reglData[t.key], i = this._vertexCount, s = [];
                for (let e = 0; e < t.length; e++) {
                    const r = t[e].name, o = n[r] && n[r].buffer;
                    if (o && o.destroy) void 0 !== n[r].stride ? s.push(n[r]) : s.push(o); else {
                        const e = n[r];
                        if (!e) {
                            this.desc.fillEmptyDataInMissingAttribute ? s.push(new Uint8Array(4 * i)) : s.push(ze);
                            continue;
                        }
                        const t = (e.data && L(e.data) ? e.data.length : e.length) / i;
                        e.data ? (e.dimension = t, s.push(e)) : s.push({
                            data: e,
                            dimension: t
                        });
                    }
                }
                const o = {
                    attributes: s,
                    primitive: this.getPrimitive()
                };
                if (this.elements && !I(this.elements)) if (this.elements.destroy) o.elements = this.elements; else {
                    o.elements = {
                        primitive: this.getPrimitive(),
                        data: this.elements
                    };
                    const e = this.getElementsType(this.elements);
                    e && (o.elements.type = e);
                }
                this._vao[r] ? this._vao[r].vao(o) : this._vao[r] = {
                    vao: e.vao(o)
                };
            }
            return delete this._vao[r].dirty, this._vao[r];
        }
        return this._reglData[t.key];
    }
    _isAttrChanged(e) {
        if (e === this._activeAttributes) return !1;
        if (e.length !== this._activeAttributes.length) return !0;
        for (let t = 0; t < e.length; t++) if (e[t] !== this._activeAttributes[t]) return !0;
        return !1;
    }
    generateBuffers(e) {
        this._bufferGen = !0;
        const t = !!e.wgpu, n = this._buffers;
        for (const t in n) n[t].buffer || (n[t].buffer = Ye.createBuffer(e, n[t].data, t)), 
        delete n[t].data;
        const r = this.desc.positionAttribute, i = this.desc.altitudeAttribute, s = this.data, o = this._vertexCount, a = {};
        for (const l in s) if (s[l]) {
            if (Array.isArray(s[l]) && (s[l] = new Float32Array(s[l])), void 0 === s[l].buffer || s[l].buffer instanceof ArrayBuffer) {
                const n = s[l].data ? s[l].data : s[l], c = n.length / o;
                let h = n;
                t && (h = Ye.padGPUBufferAlignment(n, o));
                const d = s[l].data ? s[l] : {};
                d.data = h, d.dimension = c;
                const u = Ye.createBuffer(e, d, l);
                u[Xe] = 1, a[l] = {
                    buffer: u
                }, l !== r && l !== i || (a[l].array = s[l]);
            } else s[l].buffer.destroy ? a[l] = s[l] : n[s[l].buffer] && (a[l] = E({}, s[l]), 
            a[l].buffer = n[s[l].buffer].buffer);
            (this.desc.static || l !== r) && delete s[l].array;
        }
        if (this.data = a, delete this._reglData, this.elements && !I(this.elements)) {
            if (this.getPrimitive(), this.elements, this.getElementsType(this.elements), !this.desc.static && !this.elements.destroy) {
                const e = this.elements;
                let t;
                if (t = Array.isArray(this.elements) ? it(this.elements) : this.elements.constructor, 
                e instanceof t) this.indices = new t(e); else {
                    this.indices = new t(e.length);
                    for (let t = 0; t < e.length; t++) this.indices[t] = e[t];
                }
            }
            this.elements = this.elements.destroy ? this.elements : Ye.createElementBuffer(e, this.elements);
            const t = this.elements;
            t[Xe] || (t[Xe] = 0), t[Xe]++;
        }
    }
    isBufferGenerated() {
        return this._bufferGen;
    }
    getVertexCount() {
        const {positionAttribute: e, positionSize: t, color0Attribute: n} = this.desc;
        let r = this.data[e];
        r.data && (r = r.data), r.array && (r = r.array), L(r) ? this._vertexCount = Math.ceil(r.length / t) : r && void 0 !== r.count && (this._vertexCount = r.count);
        const i = n;
        if (this.data[i]) {
            const e = this.data[i].data || this.data[i].array || this.data[i];
            Array.isArray(e) ? this._color0Size = e.length / this._vertexCount : this.data[i].buffer && this.data[i].buffer.destroy ? this._color0Size = this.data[i].buffer._buffer.dimension : e && e.itemSize && (this._color0Size = e.itemSize);
        }
        return this._vertexCount;
    }
    getColor0Size() {
        return this._color0Size || 0;
    }
    deleteData(e) {
        const t = this.data[e];
        return t ? (this._incrVersion(), t.buffer && t.buffer.destroy && t.buffer.destroy(), 
        delete this.data[e], delete this._reglData, this._markVAODirty(!1), this) : this;
    }
    updateData(e, t) {
        const n = this.data[e];
        if (!n) return this;
        let r;
        this._incrVersion(), this.data[e] = t, n.buffer && n.buffer.destroy && (r = n);
        const i = e === this.desc.positionAttribute;
        return i && this.updateBoundingBox(), this.getVertexCount(), r && (r.buffer.mapState ? (t = Ye.padGPUBufferAlignment(t, this._vertexCount), 
        r.buffer = this._updateGPUBuffer(r.buffer, t, 0, t.buffer.byteLength)) : r.buffer(t), 
        this.data[e] = r, i && (this.data[e].array = t)), this._prepareData(!1), i && (this._posDirty = !0), 
        delete this._reglData, this;
    }
    _updateGPUBuffer(e, t, n, r) {
        Array.isArray(t) && (r = 4 * (t = new Float32Array(t)).length);
        const i = e.device;
        if (r > e.size) {
            const n = rt(i, t, e.usage, e.label);
            return delete e.device, e.destroy(), n;
        }
        return i.wgpu.queue.writeBuffer(e, 0, t.buffer, n, r), e;
    }
    updateSubData(e, t, n) {
        const r = this.data[e];
        if (!r) return this;
        let i;
        if (this._incrVersion(), r.buffer && r.buffer.destroy && (i = r), e === this.desc.positionAttribute && this._updateSubBoundingBox(t), 
        i) if (i.buffer.mapState) {
            t = Ye.padGPUBufferAlignment(t, this._vertexCount);
            const e = i.buffer.bytesPerElement;
            if (t.BYTES_PER_ELEMENT !== e) {
                t = new (Je(t, e))(t);
            }
            i.buffer = this._updateGPUBuffer(i.buffer, t, n * e, t.buffer.byteLength);
        } else {
            const e = Ve[i.buffer._buffer.dtype];
            if (t.BYTES_PER_ELEMENT !== e) {
                t = new (Je(t, e))(t);
            }
            i.buffer.subdata(t, n * e);
        } else {
            const r = this.data[e].data ? this.data[e].data : this.data[e];
            for (let e = 0; e < t.length; e++) r[n + e] = t[e];
        }
        return this._prepareData(!1), this.desc.positionAttribute === e && (this._posDirty = !0), 
        delete this._reglData, this;
    }
    getPrimitive() {
        return this.desc.primitive;
    }
    getElements() {
        return this.elements;
    }
    setElements(e, t) {
        if (!e) throw new Error("elements data is invalid");
        this._incrVersion();
        const n = this.elements;
        if (this.count = void 0 === t ? $e(e) : t, e && e.destroy) this.elements = e; else if (n.destroy) if (n.mapState) {
            if (Array.isArray(e)) {
                e = new (it(e))(e);
            }
            let t = e, r = e.buffer.byteLength;
            r % 4 > 0 && (r = 4 * Math.ceil(r / 4), We.buffer.byteLength < r && (We = new Uint16Array(r / 2)), 
            We.fill(0), t = We.subarray(0, r / 2), t.set(e)), this.elements = this._updateGPUBuffer(n, t, 0, r);
        } else this.elements = n(e); else this.elements = e;
        return this._markVAODirty(!0), this._isIndexed = !I(e), this;
    }
    isIndexedElements() {
        return this._isIndexed;
    }
    deleteElements() {
        return this.elements && 0 !== this.elements.length ? (this._incrVersion(), this.elements && this.elements.destroy && !this.elements[ee] && (this.elements.destroy(), 
        this.elements[ee] = 1), this.elements = [], this._markVAODirty(!0), this) : this;
    }
    _markVAODirty(e) {
        if (this._vao) {
            for (const t in this._vao) e ? this._vao[t].vao.destroy() : this._vao[t].dirty = !0;
            e && (this._vao = {});
        }
    }
    setDrawCount(e) {
        return this._incrVersion(), this.count1 = e, this;
    }
    getDrawCount() {
        return this.count1 >= 0 ? this.count1 : this.count;
    }
    setDrawOffset(e) {
        return this._incrVersion(), this.offset = e, this;
    }
    getDrawOffset() {
        return this.offset || 0;
    }
    dispose() {
        if (this._deleteVAO(), this._forEachBuffer((e => {
            if (!e[ee]) {
                let t = e[Xe];
                t && t--, t <= 0 ? (e[ee] = !0, e.destroy()) : e[Xe] = t;
            }
        })), this.properties) {
            const e = this.properties.oldElementsBeforeHighlight;
            e && !e[ee] && e.destroy && (e.destroy(), e[ee] = !0), delete this.properties.oldElementsBeforeHighlight, 
            delete this.properties.hasInvisible;
        }
        this.data = {}, this._buffers = {}, delete this._reglData, this.count = 0, this.elements = [], 
        delete this._tempPosArray, this._disposed = !0;
    }
    _deleteVAO() {
        for (const e in this._vao) this._vao[e].vao.destroy();
        this._vao = {};
    }
    isDisposed() {
        return !!this._disposed;
    }
    updateBoundingBox() {
        let e = this.boundingBox;
        e || (e = this.boundingBox = new le);
        const t = this.desc.positionAttribute;
        let n, r, i = this.data[t];
        if (L(i) || (i.data ? i = i.data : j(i) ? i = this._getAttributeData(this.desc.positionAttribute) : i.array && (n = i.min, 
        r = i.max, i = i.array)), i && i.length) {
            const t = e.min, s = e.max;
            if (n && r) h.set(t, ...n), h.set(s, ...r); else {
                h.set(t, i[0], i[1], i[2]), h.set(s, i[0], i[1], i[2]);
                for (let e = 3; e < i.length; ) {
                    const n = i[e++], r = i[e++], o = i[e++];
                    n < t[0] && (t[0] = n), r < t[1] && (t[1] = r), o < t[2] && (t[2] = o), n > s[0] && (s[0] = n), 
                    r > s[1] && (s[1] = r), o > s[2] && (s[2] = o);
                }
            }
            e.updateVertex(), e.dirty();
        }
    }
    _updateSubBoundingBox(e) {
        const t = this.boundingBox, n = t.min, r = t.max, i = this.desc.positionSize;
        for (let t = 0; t < e.length; ) {
            const s = e[t++], o = e[t++];
            let a = 0;
            3 === i && (a = e[t++]), s < n[0] && (n[0] = s), o < n[1] && (n[1] = o), a < n[2] && (n[2] = a), 
            s > r[0] && (r[0] = s), o > r[1] && (r[1] = o), a > r[2] && (r[2] = a);
        }
        t.updateVertex(), t.dirty();
    }
    _getAttributeData(e) {
        const t = M(), n = this.data[e] && this.data[e].array ? this.data[e].array : this.data[e], r = n.buffer;
        if (j(n)) {
            const i = this._buffers[r] ? this._buffers[r].data : n.array, {count: s, size: o, stride: a, offset: l, componentType: c} = n, h = t.GLTFLoader.getTypedArrayCtor(c);
            if ((0 === a || a === o * h.BYTES_PER_ELEMENT) && l % h.BYTES_PER_ELEMENT == 0) return new h(i, l, s * o);
            if (e === this.desc.positionAttribute) return !this._tempPosArray || this._tempPosArray && this._tempPosArray.length < o * s ? (this._tempPosArray = new h(o * s), 
            t.GLTFLoader.readInterleavedArray(this._tempPosArray, i, s, o, a, l, c)) : this._posDirty ? (this._posDirty = !1, 
            t.GLTFLoader.readInterleavedArray(this._tempPosArray, i, s, o, a, l, c)) : this._tempPosArray;
            {
                const e = new h(o * s);
                return t.GLTFLoader.readInterleavedArray(e, i, s, o, a, l, c);
            }
        }
        return n;
    }
    createTangent(e = "aTangent", t) {
        this._incrVersion();
        const {normalAttribute: n, positionAttribute: r, uv0Attribute: i} = this.desc, s = this._getAttributeData(n), o = this._getAttributeData(r);
        let a;
        a = t && t.length ? t : x(o, s, this.data[i], this.elements);
        const l = this.data[e] = new Float32Array(a.length), c = [ 0, 0, 0, 0 ], u = [ 0, 0, 0 ], f = [ 0, 0, 0, 0 ];
        for (let e = 0; e < a.length; e += 4) {
            const t = e / 4 * 3;
            h.set(u, s[t], s[t + 1], s[t + 2]), d.set(c, a[e], a[e + 1], a[e + 2], a[e + 3]), 
            y(f, u, c), d.copy(l.subarray(e, e + 4), f);
        }
        delete this._reglData;
    }
    createNormal(e = "aNormal") {
        this._incrVersion();
        const t = this._getAttributeData(this.desc.positionAttribute);
        this.data[e] = b(t.array || t, this.elements), delete this._reglData;
    }
    createBarycentric(e = "aBarycentric") {
        if ("triangles" !== this.desc.primitive) throw new Error("Primitive must be triangles to create bary centric data");
        this._incrVersion();
        const t = new Uint8Array(3 * this._vertexCount);
        for (let e = 0, n = this.elements.length; e < n; ) for (let n = 0; n < 3; n++) {
            t[3 * this.elements[e++] + n] = 1;
        }
        this.data[e] = t, delete this._reglData;
    }
    buildUniqueVertex() {
        this._incrVersion();
        const e = this.data, t = this.elements;
        if (!L(t)) throw new Error("elements must be array to build unique vertex.");
        const n = Object.keys(e), r = {};
        let i = e[this.desc.positionAttribute];
        if (i = i.length ? i : i.array, !L(i)) throw new Error(this.desc.positionAttribute + " must be array to build unique vertex.");
        const s = this._vertexCount, o = t.length;
        for (let t = 0; t < n.length; t++) {
            const i = n[t], a = L(e[i]) ? e[i] : e[i].array, l = a.length / s;
            if (!L(a)) throw new Error(i + " must be array to build unique vertex.");
            r[i] = a;
            const c = F(a);
            e[i] = new c(o * l);
        }
        let a = 0;
        for (let i = 0; i < o; i++) {
            const o = t[i];
            for (let t = 0; t < n.length; t++) {
                const i = n[t], l = e[i], c = r[i].length / s;
                for (let e = 0; e < c; e++) l[a * c + e] = r[i][o * c + e];
            }
            t[i] = a++;
        }
        i = this.data[this.desc.positionAttribute], this._vertexCount = Math.ceil(i.length / this.desc.positionSize), 
        delete this._reglData;
    }
    getMemorySize() {
        let e = 0;
        for (const t in this.data) N(this.data, t) && (e += B(this.data[t]));
        if (this.elements) {
            const t = this.elements;
            t.destroy ? t._elements ? e += t._elements.buffer.byteLength : e += t.size : t.BYTES_PER_ELEMENT ? e += t.length * t.BYTES_PER_ELEMENT : t.length && (e += 4 * t.length);
        }
        return e;
    }
    _forEachBuffer(e) {
        this.elements && this.elements.destroy && e(this.elements);
        for (const t in this.data) N(this.data, t) && this.data[t] && this.data[t].buffer && this.data[t].buffer.destroy && e(this.data[t].buffer);
        for (const t in this._buffers) N(this._buffers, t) && this._buffers[t] && this._buffers[t].buffer && this._buffers[t].buffer.destroy && e(this._buffers[t].buffer);
    }
    getElementsType(e) {
        return e instanceof Uint8Array ? "uint8" : e instanceof Uint16Array ? "uint16" : e instanceof Uint32Array ? "uint32" : void 0;
    }
    _incrVersion() {
        this._version++;
    }
    getCommandKey(e) {
        if (e && e.wgpu) {
            const e = [];
            for (const t in this.data) {
                const n = this.data[t];
                n.byteStride ? e.push(`${t}(${n.byteOffset}/${n.byteStride}})`) : e.push(t);
            }
            return e.sort().join("-");
        }
        return "";
    }
    getBufferDescriptor(e) {
        const t = [];
        for (const n in e) {
            const r = e[n];
            t[r.location] = r;
        }
        const n = this.data, r = [], i = {};
        for (let s = 0; s < t.length; s++) {
            if (!t[s]) continue;
            const o = t[s].geoAttrName, a = n[o];
            if (!a) continue;
            const l = e[this.semantic[o] || o];
            if (!l) continue;
            const c = a.accessorName, h = a.byteStride;
            if (h && c) {
                const e = Ne(a.componentType, a.itemSize);
                let t = i[c];
                t ? t.attributes.push({
                    shaderLocation: l.location,
                    format: e,
                    offset: a.byteOffset
                }) : (t = {
                    arrayStride: h,
                    attributes: [ {
                        shaderLocation: l.location,
                        format: e,
                        offset: a.byteOffset
                    } ]
                }, i[c] = t, r[s] = t);
            } else {
                const e = Qe(a, l);
                r[s] = e;
            }
        }
        return r;
    }
}

function $e(e) {
    if (I(e)) return e;
    if (void 0 !== e.count) return e.count;
    if (e.destroy) return e._elements ? e._elements.vertCount : e.itemCount;
    if (void 0 !== e.length) return e.length;
    if (e.data) return e.data.length;
    throw new Error("invalid elements length");
}

function Je(e, t) {
    return e instanceof Uint8Array || e instanceof Uint16Array || e instanceof Uint32Array || e instanceof Uint8ClampedArray ? 1 === t ? Uint8Array : 2 === t ? Uint16Array : Uint32Array : e instanceof Int8Array || e instanceof Int16Array || e instanceof Int32Array ? 1 === t ? Int8Array : 2 === t ? Int16Array : Int32Array : e instanceof Float32Array || e instanceof Float64Array ? 4 === t ? Float32Array : Float64Array : null;
}

function Qe(e, t) {
    const n = e.data || e.array || e;
    let r = t.itemSize;
    if (e.buffer && !L(e)) {
        const n = e.buffer.bytesPerElement;
        r = st(r, n);
        const i = tt(e, r);
        return {
            arrayStride: r * n,
            attributes: [ {
                shaderLocation: t.location,
                format: i,
                offset: 0
            } ]
        };
    }
    if (L(n)) {
        let s, o;
        return e.componentType ? (s = Ne(e.componentType, e.itemSize), i = e.componentType, 
        o = De[i].bytes) : (s = tt(n, r), o = et(n)), r = st(r, o), {
            arrayStride: r * o,
            attributes: [ {
                shaderLocation: t.location,
                format: s,
                offset: 0
            } ]
        };
    }
    var i;
}

function et(e) {
    const t = nt(e);
    if (t.destroy) return t.bytesPerElement;
    if (t.BYTES_PER_ELEMENT) return t.BYTES_PER_ELEMENT;
    if (Array.isArray(t)) return 4;
    {
        const e = t;
        return M().GLTFLoader.getTypedArrayCtor(e.componentType).BYTES_PER_ELEMENT;
    }
}

function tt(e, t) {
    const n = nt(e);
    let r;
    return r = n.destroy ? n.itemType : He(n), t > 1 ? r + "x" + t : r;
}

function nt(e) {
    return e.data || e.buffer.destroy && e.buffer || e;
}

function rt(e, t, n, r) {
    t = t.data || t, Array.isArray(t[0]) && (t = Fe(t)), Array.isArray(t) && (t = new Float32Array(t));
    const i = t.constructor, s = Ue(t.byteLength, 4), o = e.wgpu.createBuffer({
        label: r,
        size: s,
        usage: n,
        mappedAtCreation: !0
    });
    return o.device = e, new i(o.getMappedRange()).set(t), o.unmap(), o.itemCount = t.length, 
    o.itemType = He(t), o.bytesPerElement = et(t), o;
}

function it(e) {
    let t = -1 / 0;
    for (let n = 0; n < e.length; n++) e[n] > t && (t = e[n]);
    return function(e) {
        return e < 65536 ? Uint16Array : Uint32Array;
    }(t);
}

function st(e, t) {
    const n = e * t;
    return n % 4 == 0 ? e : e + (4 - n % 4) / t;
}

const ot = [ "points", "lines", "line strip", "line loop", "triangles", "triangle strip", "triangle fan" ];

function at(e) {
    return ot[e];
}

const lt = {
    5121: "uint8",
    5123: "uint16",
    5125: "uint32",
    5126: "float",
    36193: "half float"
};

function ct(e) {
    return lt[e];
}

function ht(e) {
    return e instanceof Uint8Array ? "uint8" : e instanceof Int8Array ? "int8" : e instanceof Uint16Array ? "uint16" : e instanceof Int16Array ? "int16" : "float";
}

const dt = {
    6406: "alpha",
    6407: "rgb",
    6408: "rgba",
    6409: "luminance",
    6410: "luminance alpha",
    33776: "rgb s3tc dxt1",
    33777: "rgba s3tc dxt1",
    33778: "rgba s3tc dxt3",
    33779: "rgba s3tc dxt5",
    35840: "rgb pvrtc 4bppv1",
    35841: "rgb pvrtc 2bppv1",
    35842: "rgba pvrtc 4bppv1",
    35843: "rgba pvrtc 2bppv1",
    35986: "rgb atc",
    35987: "rgba atc explicit alpha",
    34798: "rgba atc interpolated alpha",
    36196: "rgb etc1",
    37492: "rgb etc2"
};

function ut(e) {
    return dt[e];
}

const ft = {
    9729: "linear",
    9728: "nearest"
};

function mt(e) {
    return ft[e];
}

const gt = {
    9729: "linear",
    9728: "nearest",
    9984: "nearest mipmap nearest",
    9985: "linear mipmap nearest",
    9986: "nearest mipmap linear",
    9987: "linear mipmap linear"
};

function _t(e) {
    return gt[e];
}

const pt = {
    10497: "repeat",
    33071: "clamp",
    33648: "mirror"
};

function vt(e) {
    return pt[e];
}

const xt = "__reshader_webgl_buffer", yt = "__reshader_webgl_tex";

function bt(e, t, n) {
    let r;
    if (L(t) ? t.buffer && void 0 !== t.byteOffset && (r = t) : t.array && t.array.buffer && void 0 !== t.array.byteOffset && (r = t.array), 
    !r) return null;
    const i = r.buffer, s = r.byteOffset;
    i[xt] || (i[xt] = {});
    let o = i[xt][s];
    if (!o) {
        const t = {};
        n && E(t, n), t.data = r, t.type || (t.type = ht(r)), o = e.buffer(t), i[xt][s] = o;
    }
    return o;
}

function wt(e, t) {
    const n = t.data;
    if (!n || !n.buffer) return e.texture(t);
    const r = n.buffer, i = n.byteOffset;
    r[yt] || (r[yt] = {});
    let s = r[yt][i];
    return s || (s = e.texture(t), r[yt][i] = s), s;
}

var Tt = Object.freeze({
    __proto__: null,
    getArrayType: ht,
    getMaterialFormat: ut,
    getMaterialType: ct,
    getPrimitive: at,
    getTextureMagFilter: mt,
    getTextureMinFilter: _t,
    getTextureWrap: vt,
    getUniqueREGLBuffer: bt,
    getUniqueTexture: wt
});

const St = [ 0, 0, 0 ], Mt = [ 0, 0, 0 ], At = [ 0, 0, 0 ], Ct = [], kt = [], Ot = [], Et = [ "a", "b", "c" ];

class Pt extends Ye {
    constructor(e, t, n, r) {
        super(e, t, n, {
            primitive: at(1),
            positionAttribute: r.positionAttribute
        });
    }
    _getPosAttribute() {
        const e = this.data[this.desc.positionAttribute];
        if (!e.length) return [];
        const t = Math.pow(10, 4), n = Math.cos(Math.PI / 180 * .8), r = this.elements, i = e.length ? e : e.array, s = r.length ? r ? r.length : i.length / 3 : r, o = [ 0, 0, 0 ], a = new Array(3), l = {}, c = [], h = new It;
        for (let e = 0; e < s; e += 3) {
            r.length ? (o[0] = r[e], o[1] = r[e + 1], o[2] = r[e + 2]) : (o[0] = e, o[1] = e + 1, 
            o[2] = e + 2), h.a = Rt(Ct, i, o[0]), h.b = Rt(kt, i, o[1]), h.c = Rt(Ot, i, o[2]);
            const s = h.getNormal(), d = h.a, u = h.b, f = h.c;
            if (a[0] = `${Math.round(d[0] * t)},${Math.round(d[1] * t)},${Math.round(d[2] * t)}`, 
            a[1] = `${Math.round(u[0] * t)},${Math.round(u[1] * t)},${Math.round(u[2] * t)}`, 
            a[2] = `${Math.round(f[0] * t)},${Math.round(f[1] * t)},${Math.round(f[2] * t)}`, 
            a[0] !== a[1] && a[1] !== a[2] && a[2] !== a[0]) for (let e = 0; e < 3; e++) this._calEdgeData(e, o, h, l, a, n, s, c);
        }
        for (const e in l) if (l[e]) {
            const {index0: t, index1: n} = l[e];
            c.push(i[3 * t], i[3 * t + 1], i[3 * t + 2]), c.push(i[3 * n], i[3 * n + 1], i[3 * n + 2]);
        }
        return this.elements = this._createElements(c), c;
    }
    _calEdgeData(e, t, n, r, i, s, o, a) {
        const l = (e + 1) % 3, c = i[e], d = i[l], u = n[Et[e]], f = n[Et[l]], m = `${c}_${d}`, g = `${d}_${c}`;
        if (g in r && r[g]) {
            h.dot(o, r[g].normal) <= s && (a.push(u[0], u[1], u[2]), a.push(f[0], f[1], f[2])), 
            r[g] = null;
        } else m in r || (r[m] = {
            index0: t[e],
            index1: t[l],
            normal: h.copy([ 0, 0, 0 ], o)
        });
    }
    _createElements(e) {
        const t = [], n = e.length / 3;
        for (let e = 0; e < n; e++) t.push(e);
        return t;
    }
}

class It {
    constructor(e = [ 0, 0, 0 ], t = [ 0, 0, 0 ], n = [ 0, 0, 0 ]) {
        this.a = e, this.b = t, this.c = n;
    }
    getNormal() {
        const e = h.sub(St, this.a, this.b), t = h.sub(Mt, this.a, this.c);
        h.cross(At, e, t);
        const n = h.length(At);
        return h.set(At, At[0] / n, At[1] / n, At[2] / n);
    }
}

function Rt(e, t, n) {
    return h.set(e, t[3 * n], t[3 * n + 1], t[3 * n + 2]);
}

class Lt {}

class Ft extends(Q(Lt)){
    constructor(e = {}, t) {
        super(), this._version = 0, this._propVerion = 0, this._texVersion = 0, this.uniforms = P({}, t || {}, e);
        for (const t in e) {
            const n = Object.getOwnPropertyDescriptor(e, t).get;
            n && Object.defineProperty(this.uniforms, t, {
                get: n
            });
        }
        this.unlit = !1, this._reglUniforms = {}, this.refCount = 0, this._bindedOnTextureComplete = (...e) => this._onTextureComplete.call(this, ...e), 
        this._genUniformKeys(), this._checkTextures();
    }
    set version(e) {
        throw new Error("Material.version is read only.");
    }
    get version() {
        return this._version;
    }
    get propVersion() {
        return this._propVerion;
    }
    get textureVersion() {
        return this._texVersion;
    }
    set doubleSided(e) {
        this.uniforms.doubleSided = e;
    }
    get doubleSided() {
        return !!this.uniforms.doubleSided;
    }
    getUniforms(e) {
        if (this._reglUniforms && !this.isDirty()) return this._reglUniforms;
        const t = this.uniforms, n = {};
        for (const r in t) if (this.isTexture(r)) Object.defineProperty(n, r, {
            enumerable: !0,
            configurable: !0,
            get: function() {
                return t[r].getREGLTexture(e);
            }
        }); else {
            Object.getOwnPropertyDescriptor(t, r).get ? Object.defineProperty(n, r, {
                enumerable: !0,
                configurable: !0,
                get: function() {
                    return t[r];
                }
            }) : n[r] = t[r];
        }
        return this._reglUniforms = n, this._uniformVer = this.version, n;
    }
    getMemorySize() {
        const e = this.uniforms;
        let t = 0;
        for (const n in e) this.isTexture(n) ? t += e[n].getMemorySize() : this.uniforms[n] && this.uniforms[n].destroy && (t += U(this.uniforms[n]));
        return t;
    }
    isReady() {
        return this._loadingCount <= 0;
    }
    hasUniform(e) {
        return Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    setUniform(e, t) {
        return this.set(e, t);
    }
    getUniform(e) {
        return this.get(e);
    }
    set(e, t, n = !0) {
        if (this.get(e) === t) return this;
        const r = C(this.uniforms[e]) && !C(t) || !C(this.uniforms[e]) && C(t);
        if (this.uniforms[e] && this.isTexture(e) && n && this.uniforms[e].dispose(), C(t)) C(this.uniforms[e]) || delete this.uniforms[e]; else if (this.uniforms[e] = t, 
        this._reglUniforms) {
            const n = Object.getOwnPropertyDescriptor(this._reglUniforms, e);
            n && !n.get && (this._propVerion++, this._reglUniforms[e] = t);
        }
        return this.isTexture(e) && (this._checkTextures(), this._texVersion++), r && (this._genUniformKeys(), 
        this._incrVersion()), this;
    }
    setFunctionUniform(e, t) {
        return this._genUniformKeys(), this._incrVersion(), Object.defineProperty(this.uniforms, e, {
            enumerable: !0,
            get: t
        }), this;
    }
    hasFunctionUniform(e) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    get(e) {
        return this.uniforms[e];
    }
    isDirty() {
        return this._uniformVer !== this.version;
    }
    appendDefines(e, t) {
        const n = this.uniforms;
        return n ? (n.jointTexture && (e.HAS_SKIN = 1), n.morphWeights1 && (e.HAS_MORPH = 1), 
        (n.khr_offset || n.khr_rotation || n.khr_scale) && (e.HAS_KHR_TEXTURE_TRANSFORM = 1), 
        e) : e;
    }
    hasSkinAnimation() {
        return !!(this.uniforms && this.uniforms.jointTexture && this.uniforms.skinAnimation);
    }
    isTexture(e) {
        return this.uniforms[e] instanceof se;
    }
    dispose() {
        for (const e in this.uniforms) {
            const t = this.uniforms[e];
            t && (t.dispose ? t.dispose() : t.destroy && !t[ee] && (t.destroy(), t[ee] = !0));
        }
        delete this.uniforms, delete this._reglUniforms, delete this._bindedOnTextureComplete, 
        this._disposed = !0;
    }
    isDisposed() {
        return !!this._disposed;
    }
    _checkTextures() {
        this._loadingCount = 0;
        for (const e in this.uniforms) if (this.isTexture(e)) {
            const t = this.uniforms[e];
            t.isReady() || (this._loadingCount++, t.on("complete", this._bindedOnTextureComplete));
        }
    }
    _onTextureComplete() {
        this._loadingCount--, this._incrVersion(), this._loadingCount <= 0 && (this._disposed || this.fire("complete"));
    }
    getUniformKeys() {
        return this._uniformKeys;
    }
    _genUniformKeys() {
        const e = [];
        for (const t in this.uniforms) N(this.uniforms, t) && !C(this.uniforms[t]) && e.push(t);
        this._uniformKeys = e.join();
    }
    _incrVersion() {
        this._version++;
    }
}

const Ht = {
    "time": 0,
    "seeThrough": !0,
    "thickness": .03,
    "fill": [ 1, .5137254902, .98, 1 ],
    "stroke": [ .7019607843, .9333333333, .2274509804, 1 ],
    "dashEnabled": !1,
    "dashAnimate": !1,
    "dashRepeats": 1,
    "dashLength": .8,
    "dashOverlap": !0,
    "insideAltColor": !1,
    "squeeze": !1,
    "squeezeMin": .5,
    "squeezeMax": 1,
    "dualStroke": !1,
    "secondThickness": .05,
    "opacity": 1,
    "noiseEnable": !1
};

const Dt = {
    "baseColorFactor": [ 1, 1, 1, 1 ],
    "materialShininess": 32,
    "environmentExposure": 1,
    "specularStrength": 32,
    "opacity": 1,
    "extrusionOpacity": 0,
    "extrusionOpacityRange": [ 0, 1.8 ],
    "baseColorTexture": null,
    "normalTexture": null,
    "emissiveTexture": null,
    "occlusionTexture": null,
    "uvScale": [ 1, 1 ],
    "uvOffset": [ 0, 0 ],
    "alphaTest": 0
};

class Nt extends Ft {
    constructor(e) {
        super(e, Dt);
    }
    static convertFrom(e) {
        const t = {};
        for (const n in Dt) t[n] = e.get(n);
        return new Nt(t);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms, r = t.data[t.desc.positionAttribute];
        r.buffer && r.buffer.itemType && r.buffer.itemType.startsWith("sint") && (e.POSITION_IS_INT = 1);
        const i = t.data[t.desc.normalAttribute];
        i && i.buffer && i.buffer.itemType && i.buffer.itemType.startsWith("sint") && (e.NORMAL_IS_INT = 1), 
        this.unlit && (e.SHADING_MODEL_UNLIT = 1), n.extrusionOpacity && (e.HAS_EXTRUSION_OPACITY = 1), 
        t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        return t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), 
        t.data.aVertexColorType && (e.HAS_VERTEX_COLOR = 1), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), 
        t.data[t.desc.uv0Attribute] ? (n.baseColorTexture && (e.HAS_BASECOLOR_MAP = 1), 
        n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (e.HAS_NORMAL_MAP = 1), (e.HAS_BASECOLOR_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP) && (e.HAS_MAP = 1), 
        e) : e;
    }
}

const Bt = {
    "baseColorFactor": [ 1, 1, 1, 1 ],
    "uvScale": [ 1, 1 ],
    "uvOffset": [ 0, 0 ],
    "opacity": 1,
    "envMapExposure": 128,
    "emissiveFactor": [ .1, .1, .1 ],
    "specularFactor": [ 0, 0, 0 ],
    "envRotationSin": 0,
    "envRotationCos": 1,
    "reflectivity": .01,
    "themingColor": [ 0, 0, 0, 0 ],
    "exposureBias": .6
};

const Ut = {
    "diffuseFactor": [ 1, 1, 1, 1 ],
    "specularFactor": [ 1, 1, 1 ],
    "glossinessFactor": 1,
    "diffuseTexture": null,
    "specularGlossinessTexture": null,
    "normalTexture": null,
    "emissiveTexture": null,
    "occlusionTexture": null
};

function zt(e) {
    return class extends e {
        constructor(...e) {
            let t = e[0];
            t = E({}, Ut, t || {}), super(t, e);
        }
        appendDefines(e, t) {
            if (super.appendDefines(e, t), e.SHADING_MODEL_SPECULAR_GLOSSINESS = 1, !t.data[t.desc.uv0Attribute]) return e;
            const n = this.uniforms;
            return n.diffuseTexture && (e.HAS_DIFFUSE_MAP = 1), n.specularGlossinessTexture && (e.HAS_SPECULARGLOSSINESS_MAP = 1), 
            (e.HAS_SPECULARGLOSSINESS_MAP || e.HAS_DIFFUSE_MAP) && (e.HAS_MAP = 1), e;
        }
    };
}

class Gt extends(zt(Nt)){}

class Vt {
    constructor() {
        this.constants = new Map, this.aliases = new Map, this.structs = new Map;
    }
}

class jt {
    constructor() {}
    get isAstNode() {
        return !0;
    }
    get astNodeType() {
        return "";
    }
    evaluate(e) {
        throw new Error("Cannot evaluate node");
    }
    evaluateString(e) {
        return this.evaluate(e).toString();
    }
    search(e) {}
    searchBlock(e, t) {
        if (e) {
            t(Wt.instance);
            for (const n of e) n instanceof Array ? this.searchBlock(n, t) : n.search(t);
            t(qt.instance);
        }
    }
}

class Wt extends jt {}

Wt.instance = new Wt;

class qt extends jt {}

qt.instance = new qt;

class Xt extends jt {
    constructor() {
        super();
    }
}

let Kt = class extends Xt {
    constructor(e, t, n, r, i, s) {
        super(), this.calls = new Set, this.name = e, this.args = t, this.returnType = n, 
        this.body = r, this.startLine = i, this.endLine = s;
    }
    get astNodeType() {
        return "function";
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
};

class Zt extends Xt {
    constructor(e) {
        super(), this.expression = e;
    }
    get astNodeType() {
        return "staticAssert";
    }
    search(e) {
        this.expression.search(e);
    }
}

class Yt extends Xt {
    constructor(e, t) {
        super(), this.condition = e, this.body = t;
    }
    get astNodeType() {
        return "while";
    }
    search(e) {
        this.condition.search(e), this.searchBlock(this.body, e);
    }
}

class $t extends Xt {
    constructor(e) {
        super(), this.body = e;
    }
    get astNodeType() {
        return "continuing";
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
}

class Jt extends Xt {
    constructor(e, t, n, r) {
        super(), this.init = e, this.condition = t, this.increment = n, this.body = r;
    }
    get astNodeType() {
        return "for";
    }
    search(e) {
        var t, n, r;
        null === (t = this.init) || void 0 === t || t.search(e), null === (n = this.condition) || void 0 === n || n.search(e), 
        null === (r = this.increment) || void 0 === r || r.search(e), this.searchBlock(this.body, e);
    }
}

class Qt extends Xt {
    constructor(e, t, n, r, i) {
        super(), this.name = e, this.type = t, this.storage = n, this.access = r, this.value = i;
    }
    get astNodeType() {
        return "var";
    }
    search(e) {
        var t;
        e(this), null === (t = this.value) || void 0 === t || t.search(e);
    }
}

class en extends Xt {
    constructor(e, t, n) {
        super(), this.name = e, this.type = t, this.value = n;
    }
    get astNodeType() {
        return "override";
    }
    search(e) {
        var t;
        null === (t = this.value) || void 0 === t || t.search(e);
    }
}

class tn extends Xt {
    constructor(e, t, n, r, i) {
        super(), this.name = e, this.type = t, this.storage = n, this.access = r, this.value = i;
    }
    get astNodeType() {
        return "let";
    }
    search(e) {
        var t;
        e(this), null === (t = this.value) || void 0 === t || t.search(e);
    }
}

class nn extends Xt {
    constructor(e, t, n, r, i) {
        super(), this.name = e, this.type = t, this.storage = n, this.access = r, this.value = i;
    }
    get astNodeType() {
        return "const";
    }
    evaluate(e) {
        return this.value.evaluate(e);
    }
    search(e) {
        var t;
        e(this), null === (t = this.value) || void 0 === t || t.search(e);
    }
}

var rn, sn, on, an, ln;

!function(e) {
    e.increment = "++", e.decrement = "--";
}(rn || (rn = {})), function(e) {
    e.parse = function(t) {
        const n = t;
        if ("parse" == n) throw new Error("Invalid value for IncrementOperator");
        return e[n];
    };
}(rn || (rn = {}));

class cn extends Xt {
    constructor(e, t) {
        super(), this.operator = e, this.variable = t;
    }
    get astNodeType() {
        return "increment";
    }
    search(e) {
        this.variable.search(e);
    }
}

!function(e) {
    e.assign = "=", e.addAssign = "+=", e.subtractAssin = "-=", e.multiplyAssign = "*=", 
    e.divideAssign = "/=", e.moduloAssign = "%=", e.andAssign = "&=", e.orAssign = "|=", 
    e.xorAssign = "^=", e.shiftLeftAssign = "<<=", e.shiftRightAssign = ">>=";
}(sn || (sn = {})), function(e) {
    e.parse = function(e) {
        const t = e;
        if ("parse" == t) throw new Error("Invalid value for AssignOperator");
        return t;
    };
}(sn || (sn = {}));

class hn extends Xt {
    constructor(e, t, n) {
        super(), this.operator = e, this.variable = t, this.value = n;
    }
    get astNodeType() {
        return "assign";
    }
    search(e) {
        this.variable.search(e), this.value.search(e);
    }
}

class dn extends Xt {
    constructor(e, t) {
        super(), this.name = e, this.args = t;
    }
    get astNodeType() {
        return "call";
    }
    search(e) {
        for (const t of this.args) t.search(e);
        e(this);
    }
}

class un extends Xt {
    constructor(e, t) {
        super(), this.body = e, this.continuing = t;
    }
    get astNodeType() {
        return "loop";
    }
}

class fn extends Xt {
    constructor(e, t) {
        super(), this.condition = e, this.body = t;
    }
    get astNodeType() {
        return "body";
    }
}

class mn extends Xt {
    constructor(e, t, n, r) {
        super(), this.condition = e, this.body = t, this.elseif = n, this.else = r;
    }
    get astNodeType() {
        return "if";
    }
    search(e) {
        this.condition.search(e), this.searchBlock(this.body, e), this.searchBlock(this.elseif, e), 
        this.searchBlock(this.else, e);
    }
}

class gn extends Xt {
    constructor(e) {
        super(), this.value = e;
    }
    get astNodeType() {
        return "return";
    }
    search(e) {
        var t;
        null === (t = this.value) || void 0 === t || t.search(e);
    }
}

class _n extends Xt {
    constructor(e) {
        super(), this.name = e;
    }
    get astNodeType() {
        return "enable";
    }
}

class pn extends Xt {
    constructor(e) {
        super(), this.extensions = e;
    }
    get astNodeType() {
        return "requires";
    }
}

class vn extends Xt {
    constructor(e, t) {
        super(), this.severity = e, this.rule = t;
    }
    get astNodeType() {
        return "diagnostic";
    }
}

class xn extends Xt {
    constructor(e, t) {
        super(), this.name = e, this.type = t;
    }
    get astNodeType() {
        return "alias";
    }
}

class yn extends Xt {
    constructor() {
        super();
    }
    get astNodeType() {
        return "discard";
    }
}

class bn extends Xt {
    constructor() {
        super();
    }
    get astNodeType() {
        return "break";
    }
}

class wn extends Xt {
    constructor() {
        super();
    }
    get astNodeType() {
        return "continue";
    }
}

class Tn extends Xt {
    constructor(e) {
        super(), this.name = e;
    }
    get astNodeType() {
        return "type";
    }
    get isStruct() {
        return !1;
    }
    get isArray() {
        return !1;
    }
}

class Sn extends Tn {
    constructor(e, t, n, r) {
        super(e), this.members = t, this.startLine = n, this.endLine = r;
    }
    get astNodeType() {
        return "struct";
    }
    get isStruct() {
        return !0;
    }
    getMemberIndex(e) {
        for (let t = 0; t < this.members.length; t++) if (this.members[t].name == e) return t;
        return -1;
    }
}

class Mn extends Tn {
    constructor(e, t, n) {
        super(e), this.format = t, this.access = n;
    }
    get astNodeType() {
        return "template";
    }
}

class An extends Tn {
    constructor(e, t, n, r) {
        super(e), this.storage = t, this.type = n, this.access = r;
    }
    get astNodeType() {
        return "pointer";
    }
}

class Cn extends Tn {
    constructor(e, t, n, r) {
        super(e), this.attributes = t, this.format = n, this.count = r;
    }
    get astNodeType() {
        return "array";
    }
    get isArray() {
        return !0;
    }
}

class kn extends Tn {
    constructor(e, t, n) {
        super(e), this.format = t, this.access = n;
    }
    get astNodeType() {
        return "sampler";
    }
}

class On extends jt {
    constructor() {
        super();
    }
}

class En extends On {
    constructor(e) {
        super(), this.value = e;
    }
    get astNodeType() {
        return "stringExpr";
    }
    toString() {
        return this.value;
    }
    evaluateString() {
        return this.value;
    }
}

class Pn extends On {
    constructor(e, t) {
        super(), this.type = e, this.args = t;
    }
    get astNodeType() {
        return "createExpr";
    }
    search(e) {
        if (e(this), this.args) for (const t of this.args) t.search(e);
    }
    evaluate(e) {
        return this.args[0].evaluate(e);
    }
}

class In extends On {
    constructor(e, t) {
        super(), this.name = e, this.args = t;
    }
    get astNodeType() {
        return "callExpr";
    }
    evaluate(e) {
        switch (this.name) {
          case "abs":
            return Math.abs(this.args[0].evaluate(e));

          case "acos":
            return Math.acos(this.args[0].evaluate(e));

          case "acosh":
            return Math.acosh(this.args[0].evaluate(e));

          case "asin":
            return Math.asin(this.args[0].evaluate(e));

          case "asinh":
            return Math.asinh(this.args[0].evaluate(e));

          case "atan":
            return Math.atan(this.args[0].evaluate(e));

          case "atan2":
            return Math.atan2(this.args[0].evaluate(e), this.args[1].evaluate(e));

          case "atanh":
            return Math.atanh(this.args[0].evaluate(e));

          case "ceil":
            return Math.ceil(this.args[0].evaluate(e));

          case "clamp":
            return Math.min(Math.max(this.args[0].evaluate(e), this.args[1].evaluate(e)), this.args[2].evaluate(e));

          case "cos":
            return Math.cos(this.args[0].evaluate(e));

          case "degrees":
            return 180 * this.args[0].evaluate(e) / Math.PI;

          case "distance":
            return Math.sqrt(Math.pow(this.args[0].evaluate(e) - this.args[1].evaluate(e), 2));

          case "dot":
          case "exp":
            return Math.exp(this.args[0].evaluate(e));

          case "exp2":
            return Math.pow(2, this.args[0].evaluate(e));

          case "floor":
            return Math.floor(this.args[0].evaluate(e));

          case "fma":
            return this.args[0].evaluate(e) * this.args[1].evaluate(e) + this.args[2].evaluate(e);

          case "fract":
          case "modf":
            return this.args[0].evaluate(e) - Math.floor(this.args[0].evaluate(e));

          case "inverseSqrt":
            return 1 / Math.sqrt(this.args[0].evaluate(e));

          case "log":
            return Math.log(this.args[0].evaluate(e));

          case "log2":
            return Math.log2(this.args[0].evaluate(e));

          case "max":
            return Math.max(this.args[0].evaluate(e), this.args[1].evaluate(e));

          case "min":
            return Math.min(this.args[0].evaluate(e), this.args[1].evaluate(e));

          case "mix":
            return this.args[0].evaluate(e) * (1 - this.args[2].evaluate(e)) + this.args[1].evaluate(e) * this.args[2].evaluate(e);

          case "pow":
            return Math.pow(this.args[0].evaluate(e), this.args[1].evaluate(e));

          case "radians":
            return this.args[0].evaluate(e) * Math.PI / 180;

          case "round":
            return Math.round(this.args[0].evaluate(e));

          case "sign":
            return Math.sign(this.args[0].evaluate(e));

          case "sin":
            return Math.sin(this.args[0].evaluate(e));

          case "sinh":
            return Math.sinh(this.args[0].evaluate(e));

          case "saturate":
            return Math.min(Math.max(this.args[0].evaluate(e), 0), 1);

          case "smoothstep":
            return this.args[0].evaluate(e) * this.args[0].evaluate(e) * (3 - 2 * this.args[0].evaluate(e));

          case "sqrt":
            return Math.sqrt(this.args[0].evaluate(e));

          case "step":
            return this.args[0].evaluate(e) < this.args[1].evaluate(e) ? 0 : 1;

          case "tan":
            return Math.tan(this.args[0].evaluate(e));

          case "tanh":
            return Math.tanh(this.args[0].evaluate(e));

          case "trunc":
            return Math.trunc(this.args[0].evaluate(e));

          default:
            throw new Error("Non const function: " + this.name);
        }
    }
    search(e) {
        for (const t of this.args) t.search(e);
        e(this);
    }
}

class Rn extends On {
    constructor(e) {
        super(), this.name = e;
    }
    get astNodeType() {
        return "varExpr";
    }
    search(e) {
        e(this), this.postfix && this.postfix.search(e);
    }
    evaluate(e) {
        const t = e.constants.get(this.name);
        if (!t) throw new Error("Cannot evaluate node");
        return t.evaluate(e);
    }
}

class Ln extends On {
    constructor(e, t) {
        super(), this.name = e, this.initializer = t;
    }
    get astNodeType() {
        return "constExpr";
    }
    evaluate(e) {
        var t, n;
        if (this.initializer instanceof Pn) {
            const r = null === (t = this.postfix) || void 0 === t ? void 0 : t.evaluateString(e), i = null === (n = this.initializer.type) || void 0 === n ? void 0 : n.name, s = e.structs.get(i), o = null == s ? void 0 : s.getMemberIndex(r);
            if (void 0 !== o && -1 != o) {
                return this.initializer.args[o].evaluate(e);
            }
            return this.initializer.evaluate(e);
        }
        return this.initializer.evaluate(e);
    }
    search(e) {
        this.initializer.search(e);
    }
}

class Fn extends On {
    constructor(e) {
        super(), this.value = e;
    }
    get astNodeType() {
        return "literalExpr";
    }
    evaluate() {
        return this.value;
    }
}

class Hn extends On {
    constructor(e, t) {
        super(), this.type = e, this.value = t;
    }
    get astNodeType() {
        return "bitcastExpr";
    }
    search(e) {
        this.value.search(e);
    }
}

class Dn extends On {
    constructor(e) {
        super(), this.contents = e;
    }
    get astNodeType() {
        return "groupExpr";
    }
    evaluate(e) {
        return this.contents[0].evaluate(e);
    }
    search(e) {
        this.searchBlock(this.contents, e);
    }
}

class Nn extends On {
    constructor(e) {
        super(), this.index = e;
    }
    search(e) {
        this.index.search(e);
    }
}

class Bn extends On {
    constructor() {
        super();
    }
}

class Un extends Bn {
    constructor(e, t) {
        super(), this.operator = e, this.right = t;
    }
    get astNodeType() {
        return "unaryOp";
    }
    evaluate(e) {
        switch (this.operator) {
          case "+":
            return this.right.evaluate(e);

          case "-":
            return -this.right.evaluate(e);

          case "!":
            return this.right.evaluate(e) ? 0 : 1;

          case "~":
            return ~this.right.evaluate(e);

          default:
            throw new Error("Unknown unary operator: " + this.operator);
        }
    }
    search(e) {
        this.right.search(e);
    }
}

class zn extends Bn {
    constructor(e, t, n) {
        super(), this.operator = e, this.left = t, this.right = n;
    }
    get astNodeType() {
        return "binaryOp";
    }
    evaluate(e) {
        switch (this.operator) {
          case "+":
            return this.left.evaluate(e) + this.right.evaluate(e);

          case "-":
            return this.left.evaluate(e) - this.right.evaluate(e);

          case "*":
            return this.left.evaluate(e) * this.right.evaluate(e);

          case "/":
            return this.left.evaluate(e) / this.right.evaluate(e);

          case "%":
            return this.left.evaluate(e) % this.right.evaluate(e);

          case "==":
            return this.left.evaluate(e) == this.right.evaluate(e) ? 1 : 0;

          case "!=":
            return this.left.evaluate(e) != this.right.evaluate(e) ? 1 : 0;

          case "<":
            return this.left.evaluate(e) < this.right.evaluate(e) ? 1 : 0;

          case ">":
            return this.left.evaluate(e) > this.right.evaluate(e) ? 1 : 0;

          case "<=":
            return this.left.evaluate(e) <= this.right.evaluate(e) ? 1 : 0;

          case ">=":
            return this.left.evaluate(e) >= this.right.evaluate(e) ? 1 : 0;

          case "&&":
            return this.left.evaluate(e) && this.right.evaluate(e) ? 1 : 0;

          case "||":
            return this.left.evaluate(e) || this.right.evaluate(e) ? 1 : 0;

          default:
            throw new Error(`Unknown operator ${this.operator}`);
        }
    }
    search(e) {
        this.left.search(e), this.right.search(e);
    }
}

class Gn extends jt {
    constructor() {
        super();
    }
}

class Vn extends Gn {
    constructor(e, t) {
        super(), this.selector = e, this.body = t;
    }
    get astNodeType() {
        return "case";
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
}

class jn extends Gn {
    constructor(e) {
        super(), this.body = e;
    }
    get astNodeType() {
        return "default";
    }
    search(e) {
        this.searchBlock(this.body, e);
    }
}

class Wn extends jt {
    constructor(e, t, n) {
        super(), this.name = e, this.type = t, this.attributes = n;
    }
    get astNodeType() {
        return "argument";
    }
}

class qn extends jt {
    constructor(e, t) {
        super(), this.condition = e, this.body = t;
    }
    get astNodeType() {
        return "elseif";
    }
    search(e) {
        this.condition.search(e), this.searchBlock(this.body, e);
    }
}

class Xn extends jt {
    constructor(e, t, n) {
        super(), this.name = e, this.type = t, this.attributes = n;
    }
    get astNodeType() {
        return "member";
    }
}

class Kn extends jt {
    constructor(e, t) {
        super(), this.name = e, this.value = t;
    }
    get astNodeType() {
        return "attribute";
    }
}

!function(e) {
    e[e.token = 0] = "token", e[e.keyword = 1] = "keyword", e[e.reserved = 2] = "reserved";
}(an || (an = {}));

class Zn {
    constructor(e, t, n) {
        this.name = e, this.type = t, this.rule = n;
    }
    toString() {
        return this.name;
    }
}

class Yn {}

on = Yn, Yn.none = new Zn("", an.reserved, ""), Yn.eof = new Zn("EOF", an.token, ""), 
Yn.reserved = {
    asm: new Zn("asm", an.reserved, "asm"),
    bf16: new Zn("bf16", an.reserved, "bf16"),
    do: new Zn("do", an.reserved, "do"),
    enum: new Zn("enum", an.reserved, "enum"),
    f16: new Zn("f16", an.reserved, "f16"),
    f64: new Zn("f64", an.reserved, "f64"),
    handle: new Zn("handle", an.reserved, "handle"),
    i8: new Zn("i8", an.reserved, "i8"),
    i16: new Zn("i16", an.reserved, "i16"),
    i64: new Zn("i64", an.reserved, "i64"),
    mat: new Zn("mat", an.reserved, "mat"),
    premerge: new Zn("premerge", an.reserved, "premerge"),
    regardless: new Zn("regardless", an.reserved, "regardless"),
    typedef: new Zn("typedef", an.reserved, "typedef"),
    u8: new Zn("u8", an.reserved, "u8"),
    u16: new Zn("u16", an.reserved, "u16"),
    u64: new Zn("u64", an.reserved, "u64"),
    unless: new Zn("unless", an.reserved, "unless"),
    using: new Zn("using", an.reserved, "using"),
    vec: new Zn("vec", an.reserved, "vec"),
    void: new Zn("void", an.reserved, "void")
}, Yn.keywords = {
    array: new Zn("array", an.keyword, "array"),
    atomic: new Zn("atomic", an.keyword, "atomic"),
    bool: new Zn("bool", an.keyword, "bool"),
    f32: new Zn("f32", an.keyword, "f32"),
    i32: new Zn("i32", an.keyword, "i32"),
    mat2x2: new Zn("mat2x2", an.keyword, "mat2x2"),
    mat2x3: new Zn("mat2x3", an.keyword, "mat2x3"),
    mat2x4: new Zn("mat2x4", an.keyword, "mat2x4"),
    mat3x2: new Zn("mat3x2", an.keyword, "mat3x2"),
    mat3x3: new Zn("mat3x3", an.keyword, "mat3x3"),
    mat3x4: new Zn("mat3x4", an.keyword, "mat3x4"),
    mat4x2: new Zn("mat4x2", an.keyword, "mat4x2"),
    mat4x3: new Zn("mat4x3", an.keyword, "mat4x3"),
    mat4x4: new Zn("mat4x4", an.keyword, "mat4x4"),
    ptr: new Zn("ptr", an.keyword, "ptr"),
    sampler: new Zn("sampler", an.keyword, "sampler"),
    sampler_comparison: new Zn("sampler_comparison", an.keyword, "sampler_comparison"),
    struct: new Zn("struct", an.keyword, "struct"),
    texture_1d: new Zn("texture_1d", an.keyword, "texture_1d"),
    texture_2d: new Zn("texture_2d", an.keyword, "texture_2d"),
    texture_2d_array: new Zn("texture_2d_array", an.keyword, "texture_2d_array"),
    texture_3d: new Zn("texture_3d", an.keyword, "texture_3d"),
    texture_cube: new Zn("texture_cube", an.keyword, "texture_cube"),
    texture_cube_array: new Zn("texture_cube_array", an.keyword, "texture_cube_array"),
    texture_multisampled_2d: new Zn("texture_multisampled_2d", an.keyword, "texture_multisampled_2d"),
    texture_storage_1d: new Zn("texture_storage_1d", an.keyword, "texture_storage_1d"),
    texture_storage_2d: new Zn("texture_storage_2d", an.keyword, "texture_storage_2d"),
    texture_storage_2d_array: new Zn("texture_storage_2d_array", an.keyword, "texture_storage_2d_array"),
    texture_storage_3d: new Zn("texture_storage_3d", an.keyword, "texture_storage_3d"),
    texture_depth_2d: new Zn("texture_depth_2d", an.keyword, "texture_depth_2d"),
    texture_depth_2d_array: new Zn("texture_depth_2d_array", an.keyword, "texture_depth_2d_array"),
    texture_depth_cube: new Zn("texture_depth_cube", an.keyword, "texture_depth_cube"),
    texture_depth_cube_array: new Zn("texture_depth_cube_array", an.keyword, "texture_depth_cube_array"),
    texture_depth_multisampled_2d: new Zn("texture_depth_multisampled_2d", an.keyword, "texture_depth_multisampled_2d"),
    texture_external: new Zn("texture_external", an.keyword, "texture_external"),
    u32: new Zn("u32", an.keyword, "u32"),
    vec2: new Zn("vec2", an.keyword, "vec2"),
    vec3: new Zn("vec3", an.keyword, "vec3"),
    vec4: new Zn("vec4", an.keyword, "vec4"),
    bitcast: new Zn("bitcast", an.keyword, "bitcast"),
    block: new Zn("block", an.keyword, "block"),
    break: new Zn("break", an.keyword, "break"),
    case: new Zn("case", an.keyword, "case"),
    continue: new Zn("continue", an.keyword, "continue"),
    continuing: new Zn("continuing", an.keyword, "continuing"),
    default: new Zn("default", an.keyword, "default"),
    diagnostic: new Zn("diagnostic", an.keyword, "diagnostic"),
    discard: new Zn("discard", an.keyword, "discard"),
    else: new Zn("else", an.keyword, "else"),
    enable: new Zn("enable", an.keyword, "enable"),
    fallthrough: new Zn("fallthrough", an.keyword, "fallthrough"),
    false: new Zn("false", an.keyword, "false"),
    fn: new Zn("fn", an.keyword, "fn"),
    for: new Zn("for", an.keyword, "for"),
    function: new Zn("function", an.keyword, "function"),
    if: new Zn("if", an.keyword, "if"),
    let: new Zn("let", an.keyword, "let"),
    const: new Zn("const", an.keyword, "const"),
    loop: new Zn("loop", an.keyword, "loop"),
    while: new Zn("while", an.keyword, "while"),
    private: new Zn("private", an.keyword, "private"),
    read: new Zn("read", an.keyword, "read"),
    read_write: new Zn("read_write", an.keyword, "read_write"),
    return: new Zn("return", an.keyword, "return"),
    requires: new Zn("requires", an.keyword, "requires"),
    storage: new Zn("storage", an.keyword, "storage"),
    switch: new Zn("switch", an.keyword, "switch"),
    true: new Zn("true", an.keyword, "true"),
    alias: new Zn("alias", an.keyword, "alias"),
    type: new Zn("type", an.keyword, "type"),
    uniform: new Zn("uniform", an.keyword, "uniform"),
    var: new Zn("var", an.keyword, "var"),
    override: new Zn("override", an.keyword, "override"),
    workgroup: new Zn("workgroup", an.keyword, "workgroup"),
    write: new Zn("write", an.keyword, "write"),
    r8unorm: new Zn("r8unorm", an.keyword, "r8unorm"),
    r8snorm: new Zn("r8snorm", an.keyword, "r8snorm"),
    r8uint: new Zn("r8uint", an.keyword, "r8uint"),
    r8sint: new Zn("r8sint", an.keyword, "r8sint"),
    r16uint: new Zn("r16uint", an.keyword, "r16uint"),
    r16sint: new Zn("r16sint", an.keyword, "r16sint"),
    r16float: new Zn("r16float", an.keyword, "r16float"),
    rg8unorm: new Zn("rg8unorm", an.keyword, "rg8unorm"),
    rg8snorm: new Zn("rg8snorm", an.keyword, "rg8snorm"),
    rg8uint: new Zn("rg8uint", an.keyword, "rg8uint"),
    rg8sint: new Zn("rg8sint", an.keyword, "rg8sint"),
    r32uint: new Zn("r32uint", an.keyword, "r32uint"),
    r32sint: new Zn("r32sint", an.keyword, "r32sint"),
    r32float: new Zn("r32float", an.keyword, "r32float"),
    rg16uint: new Zn("rg16uint", an.keyword, "rg16uint"),
    rg16sint: new Zn("rg16sint", an.keyword, "rg16sint"),
    rg16float: new Zn("rg16float", an.keyword, "rg16float"),
    rgba8unorm: new Zn("rgba8unorm", an.keyword, "rgba8unorm"),
    rgba8unorm_srgb: new Zn("rgba8unorm_srgb", an.keyword, "rgba8unorm_srgb"),
    rgba8snorm: new Zn("rgba8snorm", an.keyword, "rgba8snorm"),
    rgba8uint: new Zn("rgba8uint", an.keyword, "rgba8uint"),
    rgba8sint: new Zn("rgba8sint", an.keyword, "rgba8sint"),
    bgra8unorm: new Zn("bgra8unorm", an.keyword, "bgra8unorm"),
    bgra8unorm_srgb: new Zn("bgra8unorm_srgb", an.keyword, "bgra8unorm_srgb"),
    rgb10a2unorm: new Zn("rgb10a2unorm", an.keyword, "rgb10a2unorm"),
    rg11b10float: new Zn("rg11b10float", an.keyword, "rg11b10float"),
    rg32uint: new Zn("rg32uint", an.keyword, "rg32uint"),
    rg32sint: new Zn("rg32sint", an.keyword, "rg32sint"),
    rg32float: new Zn("rg32float", an.keyword, "rg32float"),
    rgba16uint: new Zn("rgba16uint", an.keyword, "rgba16uint"),
    rgba16sint: new Zn("rgba16sint", an.keyword, "rgba16sint"),
    rgba16float: new Zn("rgba16float", an.keyword, "rgba16float"),
    rgba32uint: new Zn("rgba32uint", an.keyword, "rgba32uint"),
    rgba32sint: new Zn("rgba32sint", an.keyword, "rgba32sint"),
    rgba32float: new Zn("rgba32float", an.keyword, "rgba32float"),
    static_assert: new Zn("static_assert", an.keyword, "static_assert")
}, Yn.tokens = {
    decimal_float_literal: new Zn("decimal_float_literal", an.token, /((-?[0-9]*\.[0-9]+|-?[0-9]+\.[0-9]*)((e|E)(\+|-)?[0-9]+)?f?)|(-?[0-9]+(e|E)(\+|-)?[0-9]+f?)|([0-9]+f)/),
    hex_float_literal: new Zn("hex_float_literal", an.token, /-?0x((([0-9a-fA-F]*\.[0-9a-fA-F]+|[0-9a-fA-F]+\.[0-9a-fA-F]*)((p|P)(\+|-)?[0-9]+f?)?)|([0-9a-fA-F]+(p|P)(\+|-)?[0-9]+f?))/),
    int_literal: new Zn("int_literal", an.token, /-?0x[0-9a-fA-F]+|0i?|-?[1-9][0-9]*i?/),
    uint_literal: new Zn("uint_literal", an.token, /0x[0-9a-fA-F]+u|0u|[1-9][0-9]*u/),
    ident: new Zn("ident", an.token, /[_a-zA-Z][0-9a-zA-Z_]*/),
    and: new Zn("and", an.token, "&"),
    and_and: new Zn("and_and", an.token, "&&"),
    arrow: new Zn("arrow ", an.token, "->"),
    attr: new Zn("attr", an.token, "@"),
    forward_slash: new Zn("forward_slash", an.token, "/"),
    bang: new Zn("bang", an.token, "!"),
    bracket_left: new Zn("bracket_left", an.token, "["),
    bracket_right: new Zn("bracket_right", an.token, "]"),
    brace_left: new Zn("brace_left", an.token, "{"),
    brace_right: new Zn("brace_right", an.token, "}"),
    colon: new Zn("colon", an.token, ":"),
    comma: new Zn("comma", an.token, ","),
    equal: new Zn("equal", an.token, "="),
    equal_equal: new Zn("equal_equal", an.token, "=="),
    not_equal: new Zn("not_equal", an.token, "!="),
    greater_than: new Zn("greater_than", an.token, ">"),
    greater_than_equal: new Zn("greater_than_equal", an.token, ">="),
    shift_right: new Zn("shift_right", an.token, ">>"),
    less_than: new Zn("less_than", an.token, "<"),
    less_than_equal: new Zn("less_than_equal", an.token, "<="),
    shift_left: new Zn("shift_left", an.token, "<<"),
    modulo: new Zn("modulo", an.token, "%"),
    minus: new Zn("minus", an.token, "-"),
    minus_minus: new Zn("minus_minus", an.token, "--"),
    period: new Zn("period", an.token, "."),
    plus: new Zn("plus", an.token, "+"),
    plus_plus: new Zn("plus_plus", an.token, "++"),
    or: new Zn("or", an.token, "|"),
    or_or: new Zn("or_or", an.token, "||"),
    paren_left: new Zn("paren_left", an.token, "("),
    paren_right: new Zn("paren_right", an.token, ")"),
    semicolon: new Zn("semicolon", an.token, ";"),
    star: new Zn("star", an.token, "*"),
    tilde: new Zn("tilde", an.token, "~"),
    underscore: new Zn("underscore", an.token, "_"),
    xor: new Zn("xor", an.token, "^"),
    plus_equal: new Zn("plus_equal", an.token, "+="),
    minus_equal: new Zn("minus_equal", an.token, "-="),
    times_equal: new Zn("times_equal", an.token, "*="),
    division_equal: new Zn("division_equal", an.token, "/="),
    modulo_equal: new Zn("modulo_equal", an.token, "%="),
    and_equal: new Zn("and_equal", an.token, "&="),
    or_equal: new Zn("or_equal", an.token, "|="),
    xor_equal: new Zn("xor_equal", an.token, "^="),
    shift_right_equal: new Zn("shift_right_equal", an.token, ">>="),
    shift_left_equal: new Zn("shift_left_equal", an.token, "<<=")
}, Yn.simpleTokens = {
    "@": on.tokens.attr,
    "{": on.tokens.brace_left,
    "}": on.tokens.brace_right,
    ":": on.tokens.colon,
    ",": on.tokens.comma,
    "(": on.tokens.paren_left,
    ")": on.tokens.paren_right,
    ";": on.tokens.semicolon
}, Yn.literalTokens = {
    "&": on.tokens.and,
    "&&": on.tokens.and_and,
    "->": on.tokens.arrow,
    "/": on.tokens.forward_slash,
    "!": on.tokens.bang,
    "[": on.tokens.bracket_left,
    "]": on.tokens.bracket_right,
    "=": on.tokens.equal,
    "==": on.tokens.equal_equal,
    "!=": on.tokens.not_equal,
    ">": on.tokens.greater_than,
    ">=": on.tokens.greater_than_equal,
    ">>": on.tokens.shift_right,
    "<": on.tokens.less_than,
    "<=": on.tokens.less_than_equal,
    "<<": on.tokens.shift_left,
    "%": on.tokens.modulo,
    "-": on.tokens.minus,
    "--": on.tokens.minus_minus,
    ".": on.tokens.period,
    "+": on.tokens.plus,
    "++": on.tokens.plus_plus,
    "|": on.tokens.or,
    "||": on.tokens.or_or,
    "*": on.tokens.star,
    "~": on.tokens.tilde,
    "_": on.tokens.underscore,
    "^": on.tokens.xor,
    "+=": on.tokens.plus_equal,
    "-=": on.tokens.minus_equal,
    "*=": on.tokens.times_equal,
    "/=": on.tokens.division_equal,
    "%=": on.tokens.modulo_equal,
    "&=": on.tokens.and_equal,
    "|=": on.tokens.or_equal,
    "^=": on.tokens.xor_equal,
    ">>=": on.tokens.shift_right_equal,
    "<<=": on.tokens.shift_left_equal
}, Yn.regexTokens = {
    decimal_float_literal: on.tokens.decimal_float_literal,
    hex_float_literal: on.tokens.hex_float_literal,
    int_literal: on.tokens.int_literal,
    uint_literal: on.tokens.uint_literal,
    ident: on.tokens.ident
}, Yn.storage_class = [ on.keywords.function, on.keywords.private, on.keywords.workgroup, on.keywords.uniform, on.keywords.storage ], 
Yn.access_mode = [ on.keywords.read, on.keywords.write, on.keywords.read_write ], 
Yn.sampler_type = [ on.keywords.sampler, on.keywords.sampler_comparison ], Yn.sampled_texture_type = [ on.keywords.texture_1d, on.keywords.texture_2d, on.keywords.texture_2d_array, on.keywords.texture_3d, on.keywords.texture_cube, on.keywords.texture_cube_array ], 
Yn.multisampled_texture_type = [ on.keywords.texture_multisampled_2d ], Yn.storage_texture_type = [ on.keywords.texture_storage_1d, on.keywords.texture_storage_2d, on.keywords.texture_storage_2d_array, on.keywords.texture_storage_3d ], 
Yn.depth_texture_type = [ on.keywords.texture_depth_2d, on.keywords.texture_depth_2d_array, on.keywords.texture_depth_cube, on.keywords.texture_depth_cube_array, on.keywords.texture_depth_multisampled_2d ], 
Yn.texture_external_type = [ on.keywords.texture_external ], Yn.any_texture_type = [ ...on.sampled_texture_type, ...on.multisampled_texture_type, ...on.storage_texture_type, ...on.depth_texture_type, ...on.texture_external_type ], 
Yn.texel_format = [ on.keywords.r8unorm, on.keywords.r8snorm, on.keywords.r8uint, on.keywords.r8sint, on.keywords.r16uint, on.keywords.r16sint, on.keywords.r16float, on.keywords.rg8unorm, on.keywords.rg8snorm, on.keywords.rg8uint, on.keywords.rg8sint, on.keywords.r32uint, on.keywords.r32sint, on.keywords.r32float, on.keywords.rg16uint, on.keywords.rg16sint, on.keywords.rg16float, on.keywords.rgba8unorm, on.keywords.rgba8unorm_srgb, on.keywords.rgba8snorm, on.keywords.rgba8uint, on.keywords.rgba8sint, on.keywords.bgra8unorm, on.keywords.bgra8unorm_srgb, on.keywords.rgb10a2unorm, on.keywords.rg11b10float, on.keywords.rg32uint, on.keywords.rg32sint, on.keywords.rg32float, on.keywords.rgba16uint, on.keywords.rgba16sint, on.keywords.rgba16float, on.keywords.rgba32uint, on.keywords.rgba32sint, on.keywords.rgba32float ], 
Yn.const_literal = [ on.tokens.int_literal, on.tokens.uint_literal, on.tokens.decimal_float_literal, on.tokens.hex_float_literal, on.keywords.true, on.keywords.false ], 
Yn.literal_or_ident = [ on.tokens.ident, on.tokens.int_literal, on.tokens.uint_literal, on.tokens.decimal_float_literal, on.tokens.hex_float_literal ], 
Yn.element_count_expression = [ on.tokens.int_literal, on.tokens.uint_literal, on.tokens.ident ], 
Yn.template_types = [ on.keywords.vec2, on.keywords.vec3, on.keywords.vec4, on.keywords.mat2x2, on.keywords.mat2x3, on.keywords.mat2x4, on.keywords.mat3x2, on.keywords.mat3x3, on.keywords.mat3x4, on.keywords.mat4x2, on.keywords.mat4x3, on.keywords.mat4x4, on.keywords.atomic, on.keywords.bitcast, ...on.any_texture_type ], 
Yn.attribute_name = [ on.tokens.ident, on.keywords.block, on.keywords.diagnostic ], 
Yn.assignment_operators = [ on.tokens.equal, on.tokens.plus_equal, on.tokens.minus_equal, on.tokens.times_equal, on.tokens.division_equal, on.tokens.modulo_equal, on.tokens.and_equal, on.tokens.or_equal, on.tokens.xor_equal, on.tokens.shift_right_equal, on.tokens.shift_left_equal ], 
Yn.increment_operators = [ on.tokens.plus_plus, on.tokens.minus_minus ];

class $n {
    constructor(e, t, n) {
        this.type = e, this.lexeme = t, this.line = n;
    }
    toString() {
        return this.lexeme;
    }
    isTemplateType() {
        return -1 != Yn.template_types.indexOf(this.type);
    }
    isArrayType() {
        return this.type == Yn.keywords.array;
    }
    isArrayOrTemplateType() {
        return this.isArrayType() || this.isTemplateType();
    }
}

class Jn {
    constructor(e) {
        this._tokens = [], this._start = 0, this._current = 0, this._line = 1, this._source = null != e ? e : "";
    }
    scanTokens() {
        for (;!this._isAtEnd(); ) if (this._start = this._current, !this.scanToken()) throw `Invalid syntax at line ${this._line}`;
        return this._tokens.push(new $n(Yn.eof, "", this._line)), this._tokens;
    }
    scanToken() {
        let e = this._advance();
        if ("\n" == e) return this._line++, !0;
        if (this._isWhitespace(e)) return !0;
        if ("/" == e) {
            if ("/" == this._peekAhead()) {
                for (;"\n" != e; ) {
                    if (this._isAtEnd()) return !0;
                    e = this._advance();
                }
                return this._line++, !0;
            }
            if ("*" == this._peekAhead()) {
                this._advance();
                let t = 1;
                for (;t > 0; ) {
                    if (this._isAtEnd()) return !0;
                    if (e = this._advance(), "\n" == e) this._line++; else if ("*" == e) {
                        if ("/" == this._peekAhead() && (this._advance(), t--, 0 == t)) return !0;
                    } else "/" == e && "*" == this._peekAhead() && (this._advance(), t++);
                }
                return !0;
            }
        }
        const t = Yn.simpleTokens[e];
        if (t) return this._addToken(t), !0;
        let n = Yn.none;
        const r = this._isAlpha(e), i = "_" === e;
        if (this._isAlphaNumeric(e)) {
            let t = this._peekAhead();
            for (;this._isAlphaNumeric(t); ) e += this._advance(), t = this._peekAhead();
        }
        if (r) {
            const t = Yn.keywords[e];
            if (t) return this._addToken(t), !0;
        }
        if (r || i) return this._addToken(Yn.tokens.ident), !0;
        for (;;) {
            let t = this._findType(e);
            const r = this._peekAhead();
            if ("-" == e && this._tokens.length > 0) {
                if ("=" == r) return this._current++, e += r, this._addToken(Yn.tokens.minus_equal), 
                !0;
                if ("-" == r) return this._current++, e += r, this._addToken(Yn.tokens.minus_minus), 
                !0;
                const n = this._tokens.length - 1;
                if ((-1 != Yn.literal_or_ident.indexOf(this._tokens[n].type) || this._tokens[n].type == Yn.tokens.paren_right) && ">" != r) return this._addToken(t), 
                !0;
            }
            if (">" == e && (">" == r || "=" == r)) {
                let e = !1, n = this._tokens.length - 1;
                for (let t = 0; t < 5 && n >= 0 && -1 === Yn.assignment_operators.indexOf(this._tokens[n].type); ++t, 
                --n) if (this._tokens[n].type === Yn.tokens.less_than) {
                    n > 0 && this._tokens[n - 1].isArrayOrTemplateType() && (e = !0);
                    break;
                }
                if (e) return this._addToken(t), !0;
            }
            if (t === Yn.none) {
                let r = e, i = 0;
                const s = 2;
                for (let e = 0; e < s; ++e) if (r += this._peekAhead(e), t = this._findType(r), 
                t !== Yn.none) {
                    i = e;
                    break;
                }
                if (t === Yn.none) return n !== Yn.none && (this._current--, this._addToken(n), 
                !0);
                e = r, this._current += i + 1;
            }
            if (n = t, this._isAtEnd()) break;
            e += this._advance();
        }
        return n !== Yn.none && (this._addToken(n), !0);
    }
    _findType(e) {
        for (const t in Yn.regexTokens) {
            const n = Yn.regexTokens[t];
            if (this._match(e, n.rule)) return n;
        }
        const t = Yn.literalTokens[e];
        return t || Yn.none;
    }
    _match(e, t) {
        const n = t.exec(e);
        return n && 0 == n.index && n[0] == e;
    }
    _isAtEnd() {
        return this._current >= this._source.length;
    }
    _isAlpha(e) {
        return e >= "a" && e <= "z" || e >= "A" && e <= "Z";
    }
    _isAlphaNumeric(e) {
        return e >= "a" && e <= "z" || e >= "A" && e <= "Z" || "_" == e || e >= "0" && e <= "9";
    }
    _isWhitespace(e) {
        return " " == e || "\t" == e || "\r" == e;
    }
    _advance(e = 0) {
        let t = this._source[this._current];
        return e = e || 0, e++, this._current += e, t;
    }
    _peekAhead(e = 0) {
        return e = e || 0, this._current + e >= this._source.length ? "\0" : this._source[this._current + e];
    }
    _addToken(e) {
        const t = this._source.substring(this._start, this._current);
        this._tokens.push(new $n(e, t, this._line));
    }
}

class Qn {
    constructor() {
        this._tokens = [], this._current = 0, this._currentLine = 0, this._context = new Vt, 
        this._deferArrayCountEval = [];
    }
    parse(e) {
        this._initialize(e), this._deferArrayCountEval.length = 0;
        const t = [];
        for (;!this._isAtEnd(); ) {
            const e = this._global_decl_or_directive();
            if (!e) break;
            t.push(e);
        }
        if (this._deferArrayCountEval.length > 0) {
            for (const e of this._deferArrayCountEval) {
                const t = e.arrayType, n = e.countNode;
                if (n instanceof Rn) {
                    const e = n.name, r = this._context.constants.get(e);
                    if (r) try {
                        const e = r.evaluate(this._context);
                        t.count = e;
                    } catch (e) {}
                }
            }
            this._deferArrayCountEval.length = 0;
        }
        return t;
    }
    _initialize(e) {
        if (e) if ("string" == typeof e) {
            const t = new Jn(e);
            this._tokens = t.scanTokens();
        } else this._tokens = e; else this._tokens = [];
        this._current = 0;
    }
    _error(e, t) {
        return {
            token: e,
            message: t,
            toString: function() {
                return `${t}`;
            }
        };
    }
    _isAtEnd() {
        return this._current >= this._tokens.length || this._peek().type == Yn.eof;
    }
    _match(e) {
        if (e instanceof Zn) return !!this._check(e) && (this._advance(), !0);
        for (let t = 0, n = e.length; t < n; ++t) {
            const n = e[t];
            if (this._check(n)) return this._advance(), !0;
        }
        return !1;
    }
    _consume(e, t) {
        if (this._check(e)) return this._advance();
        throw this._error(this._peek(), t);
    }
    _check(e) {
        if (this._isAtEnd()) return !1;
        const t = this._peek();
        if (e instanceof Array) {
            const n = t.type;
            return -1 != e.indexOf(n);
        }
        return t.type == e;
    }
    _advance() {
        var e, t;
        return this._currentLine = null !== (t = null === (e = this._peek()) || void 0 === e ? void 0 : e.line) && void 0 !== t ? t : -1, 
        this._isAtEnd() || this._current++, this._previous();
    }
    _peek() {
        return this._tokens[this._current];
    }
    _previous() {
        return this._tokens[this._current - 1];
    }
    _global_decl_or_directive() {
        for (;this._match(Yn.tokens.semicolon) && !this._isAtEnd(); ) ;
        if (this._match(Yn.keywords.alias)) {
            const e = this._type_alias();
            return this._consume(Yn.tokens.semicolon, "Expected ';'"), e;
        }
        if (this._match(Yn.keywords.diagnostic)) {
            const e = this._diagnostic();
            return this._consume(Yn.tokens.semicolon, "Expected ';'"), e;
        }
        if (this._match(Yn.keywords.requires)) {
            const e = this._requires_directive();
            return this._consume(Yn.tokens.semicolon, "Expected ';'"), e;
        }
        if (this._match(Yn.keywords.enable)) {
            const e = this._enable_directive();
            return this._consume(Yn.tokens.semicolon, "Expected ';'"), e;
        }
        const e = this._attribute();
        if (this._check(Yn.keywords.var)) {
            const t = this._global_variable_decl();
            return null != t && (t.attributes = e), this._consume(Yn.tokens.semicolon, "Expected ';'."), 
            t;
        }
        if (this._check(Yn.keywords.override)) {
            const t = this._override_variable_decl();
            return null != t && (t.attributes = e), this._consume(Yn.tokens.semicolon, "Expected ';'."), 
            t;
        }
        if (this._check(Yn.keywords.let)) {
            const t = this._global_let_decl();
            return null != t && (t.attributes = e), this._consume(Yn.tokens.semicolon, "Expected ';'."), 
            t;
        }
        if (this._check(Yn.keywords.const)) {
            const t = this._global_const_decl();
            return null != t && (t.attributes = e), this._consume(Yn.tokens.semicolon, "Expected ';'."), 
            t;
        }
        if (this._check(Yn.keywords.struct)) {
            const t = this._struct_decl();
            return null != t && (t.attributes = e), t;
        }
        if (this._check(Yn.keywords.fn)) {
            const t = this._function_decl();
            return null != t && (t.attributes = e), t;
        }
        return null;
    }
    _function_decl() {
        if (!this._match(Yn.keywords.fn)) return null;
        const e = this._currentLine, t = this._consume(Yn.tokens.ident, "Expected function name.").toString();
        this._consume(Yn.tokens.paren_left, "Expected '(' for function arguments.");
        const n = [];
        if (!this._check(Yn.tokens.paren_right)) do {
            if (this._check(Yn.tokens.paren_right)) break;
            const e = this._attribute(), t = this._consume(Yn.tokens.ident, "Expected argument name.").toString();
            this._consume(Yn.tokens.colon, "Expected ':' for argument type.");
            const r = this._attribute(), i = this._type_decl();
            null != i && (i.attributes = r, n.push(new Wn(t, i, e)));
        } while (this._match(Yn.tokens.comma));
        this._consume(Yn.tokens.paren_right, "Expected ')' after function arguments.");
        let r = null;
        if (this._match(Yn.tokens.arrow)) {
            const e = this._attribute();
            r = this._type_decl(), null != r && (r.attributes = e);
        }
        const i = this._compound_statement(), s = this._currentLine;
        return new Kt(t, n, r, i, e, s);
    }
    _compound_statement() {
        const e = [];
        for (this._consume(Yn.tokens.brace_left, "Expected '{' for block."); !this._check(Yn.tokens.brace_right); ) {
            const t = this._statement();
            null !== t && e.push(t);
        }
        return this._consume(Yn.tokens.brace_right, "Expected '}' for block."), e;
    }
    _statement() {
        for (;this._match(Yn.tokens.semicolon) && !this._isAtEnd(); ) ;
        if (this._check(Yn.tokens.attr) && this._attribute(), this._check(Yn.keywords.if)) return this._if_statement();
        if (this._check(Yn.keywords.switch)) return this._switch_statement();
        if (this._check(Yn.keywords.loop)) return this._loop_statement();
        if (this._check(Yn.keywords.for)) return this._for_statement();
        if (this._check(Yn.keywords.while)) return this._while_statement();
        if (this._check(Yn.keywords.continuing)) return this._continuing_statement();
        if (this._check(Yn.keywords.static_assert)) return this._static_assert_statement();
        if (this._check(Yn.tokens.brace_left)) return this._compound_statement();
        let e = null;
        return e = this._check(Yn.keywords.return) ? this._return_statement() : this._check([ Yn.keywords.var, Yn.keywords.let, Yn.keywords.const ]) ? this._variable_statement() : this._match(Yn.keywords.discard) ? new yn : this._match(Yn.keywords.break) ? new bn : this._match(Yn.keywords.continue) ? new wn : this._increment_decrement_statement() || this._func_call_statement() || this._assignment_statement(), 
        null != e && this._consume(Yn.tokens.semicolon, "Expected ';' after statement."), 
        e;
    }
    _static_assert_statement() {
        if (!this._match(Yn.keywords.static_assert)) return null;
        const e = this._optional_paren_expression();
        return new Zt(e);
    }
    _while_statement() {
        if (!this._match(Yn.keywords.while)) return null;
        const e = this._optional_paren_expression();
        this._check(Yn.tokens.attr) && this._attribute();
        const t = this._compound_statement();
        return new Yt(e, t);
    }
    _continuing_statement() {
        if (!this._match(Yn.keywords.continuing)) return null;
        const e = this._compound_statement();
        return new $t(e);
    }
    _for_statement() {
        if (!this._match(Yn.keywords.for)) return null;
        this._consume(Yn.tokens.paren_left, "Expected '('.");
        const e = this._check(Yn.tokens.semicolon) ? null : this._for_init();
        this._consume(Yn.tokens.semicolon, "Expected ';'.");
        const t = this._check(Yn.tokens.semicolon) ? null : this._short_circuit_or_expression();
        this._consume(Yn.tokens.semicolon, "Expected ';'.");
        const n = this._check(Yn.tokens.paren_right) ? null : this._for_increment();
        this._consume(Yn.tokens.paren_right, "Expected ')'."), this._check(Yn.tokens.attr) && this._attribute();
        const r = this._compound_statement();
        return new Jt(e, t, n, r);
    }
    _for_init() {
        return this._variable_statement() || this._func_call_statement() || this._assignment_statement();
    }
    _for_increment() {
        return this._func_call_statement() || this._increment_decrement_statement() || this._assignment_statement();
    }
    _variable_statement() {
        if (this._check(Yn.keywords.var)) {
            const e = this._variable_decl();
            if (null === e) throw this._error(this._peek(), "Variable declaration expected.");
            let t = null;
            return this._match(Yn.tokens.equal) && (t = this._short_circuit_or_expression()), 
            new Qt(e.name, e.type, e.storage, e.access, t);
        }
        if (this._match(Yn.keywords.let)) {
            const e = this._consume(Yn.tokens.ident, "Expected name for let.").toString();
            let t = null;
            if (this._match(Yn.tokens.colon)) {
                const e = this._attribute();
                t = this._type_decl(), null != t && (t.attributes = e);
            }
            this._consume(Yn.tokens.equal, "Expected '=' for let.");
            const n = this._short_circuit_or_expression();
            return new tn(e, t, null, null, n);
        }
        if (this._match(Yn.keywords.const)) {
            const e = this._consume(Yn.tokens.ident, "Expected name for const.").toString();
            let t = null;
            if (this._match(Yn.tokens.colon)) {
                const e = this._attribute();
                t = this._type_decl(), null != t && (t.attributes = e);
            }
            this._consume(Yn.tokens.equal, "Expected '=' for const.");
            const n = this._short_circuit_or_expression();
            return new nn(e, t, null, null, n);
        }
        return null;
    }
    _increment_decrement_statement() {
        const e = this._current, t = this._unary_expression();
        if (null == t) return null;
        if (!this._check(Yn.increment_operators)) return this._current = e, null;
        const n = this._consume(Yn.increment_operators, "Expected increment operator");
        return new cn(n.type === Yn.tokens.plus_plus ? rn.increment : rn.decrement, t);
    }
    _assignment_statement() {
        let e = null;
        if (this._check(Yn.tokens.brace_right)) return null;
        let t = this._match(Yn.tokens.underscore);
        if (t || (e = this._unary_expression()), !t && null == e) return null;
        const n = this._consume(Yn.assignment_operators, "Expected assignment operator."), r = this._short_circuit_or_expression();
        return new hn(sn.parse(n.lexeme), e, r);
    }
    _func_call_statement() {
        if (!this._check(Yn.tokens.ident)) return null;
        const e = this._current, t = this._consume(Yn.tokens.ident, "Expected function name."), n = this._argument_expression_list();
        return null === n ? (this._current = e, null) : new dn(t.lexeme, n);
    }
    _loop_statement() {
        if (!this._match(Yn.keywords.loop)) return null;
        this._check(Yn.tokens.attr) && this._attribute(), this._consume(Yn.tokens.brace_left, "Expected '{' for loop.");
        const e = [];
        let t = this._statement();
        for (;null !== t; ) {
            if (Array.isArray(t)) for (let n of t) e.push(n); else e.push(t);
            t = this._statement();
        }
        let n = null;
        return this._match(Yn.keywords.continuing) && (n = this._compound_statement()), 
        this._consume(Yn.tokens.brace_right, "Expected '}' for loop."), new un(e, n);
    }
    _switch_statement() {
        if (!this._match(Yn.keywords.switch)) return null;
        const e = this._optional_paren_expression();
        this._check(Yn.tokens.attr) && this._attribute(), this._consume(Yn.tokens.brace_left, "Expected '{' for switch.");
        const t = this._switch_body();
        if (null == t || 0 == t.length) throw this._error(this._previous(), "Expected 'case' or 'default'.");
        return this._consume(Yn.tokens.brace_right, "Expected '}' for switch."), new fn(e, t);
    }
    _switch_body() {
        const e = [];
        if (this._match(Yn.keywords.case)) {
            const t = this._case_selectors();
            this._match(Yn.tokens.colon), this._check(Yn.tokens.attr) && this._attribute(), 
            this._consume(Yn.tokens.brace_left, "Exected '{' for switch case.");
            const n = this._case_body();
            this._consume(Yn.tokens.brace_right, "Exected '}' for switch case."), e.push(new Vn(t, n));
        }
        if (this._match(Yn.keywords.default)) {
            this._match(Yn.tokens.colon), this._check(Yn.tokens.attr) && this._attribute(), 
            this._consume(Yn.tokens.brace_left, "Exected '{' for switch default.");
            const t = this._case_body();
            this._consume(Yn.tokens.brace_right, "Exected '}' for switch default."), e.push(new jn(t));
        }
        if (this._check([ Yn.keywords.default, Yn.keywords.case ])) {
            const t = this._switch_body();
            e.push(t[0]);
        }
        return e;
    }
    _case_selectors() {
        const e = [ this._shift_expression() ];
        for (;this._match(Yn.tokens.comma); ) e.push(this._shift_expression());
        return e;
    }
    _case_body() {
        if (this._match(Yn.keywords.fallthrough)) return this._consume(Yn.tokens.semicolon, "Expected ';'"), 
        [];
        let e = this._statement();
        if (null == e) return [];
        e instanceof Array || (e = [ e ]);
        const t = this._case_body();
        return 0 == t.length ? e : [ ...e, t[0] ];
    }
    _if_statement() {
        if (!this._match(Yn.keywords.if)) return null;
        const e = this._optional_paren_expression();
        this._check(Yn.tokens.attr) && this._attribute();
        const t = this._compound_statement();
        let n = [];
        this._match_elseif() && (this._check(Yn.tokens.attr) && this._attribute(), n = this._elseif_statement(n));
        let r = null;
        return this._match(Yn.keywords.else) && (this._check(Yn.tokens.attr) && this._attribute(), 
        r = this._compound_statement()), new mn(e, t, n, r);
    }
    _match_elseif() {
        return this._tokens[this._current].type === Yn.keywords.else && this._tokens[this._current + 1].type === Yn.keywords.if && (this._advance(), 
        this._advance(), !0);
    }
    _elseif_statement(e = []) {
        const t = this._optional_paren_expression(), n = this._compound_statement();
        return e.push(new qn(t, n)), this._match_elseif() && (this._check(Yn.tokens.attr) && this._attribute(), 
        this._elseif_statement(e)), e;
    }
    _return_statement() {
        if (!this._match(Yn.keywords.return)) return null;
        const e = this._short_circuit_or_expression();
        return new gn(e);
    }
    _short_circuit_or_expression() {
        let e = this._short_circuit_and_expr();
        for (;this._match(Yn.tokens.or_or); ) e = new zn(this._previous().toString(), e, this._short_circuit_and_expr());
        return e;
    }
    _short_circuit_and_expr() {
        let e = this._inclusive_or_expression();
        for (;this._match(Yn.tokens.and_and); ) e = new zn(this._previous().toString(), e, this._inclusive_or_expression());
        return e;
    }
    _inclusive_or_expression() {
        let e = this._exclusive_or_expression();
        for (;this._match(Yn.tokens.or); ) e = new zn(this._previous().toString(), e, this._exclusive_or_expression());
        return e;
    }
    _exclusive_or_expression() {
        let e = this._and_expression();
        for (;this._match(Yn.tokens.xor); ) e = new zn(this._previous().toString(), e, this._and_expression());
        return e;
    }
    _and_expression() {
        let e = this._equality_expression();
        for (;this._match(Yn.tokens.and); ) e = new zn(this._previous().toString(), e, this._equality_expression());
        return e;
    }
    _equality_expression() {
        const e = this._relational_expression();
        return this._match([ Yn.tokens.equal_equal, Yn.tokens.not_equal ]) ? new zn(this._previous().toString(), e, this._relational_expression()) : e;
    }
    _relational_expression() {
        let e = this._shift_expression();
        for (;this._match([ Yn.tokens.less_than, Yn.tokens.greater_than, Yn.tokens.less_than_equal, Yn.tokens.greater_than_equal ]); ) e = new zn(this._previous().toString(), e, this._shift_expression());
        return e;
    }
    _shift_expression() {
        let e = this._additive_expression();
        for (;this._match([ Yn.tokens.shift_left, Yn.tokens.shift_right ]); ) e = new zn(this._previous().toString(), e, this._additive_expression());
        return e;
    }
    _additive_expression() {
        let e = this._multiplicative_expression();
        for (;this._match([ Yn.tokens.plus, Yn.tokens.minus ]); ) e = new zn(this._previous().toString(), e, this._multiplicative_expression());
        return e;
    }
    _multiplicative_expression() {
        let e = this._unary_expression();
        for (;this._match([ Yn.tokens.star, Yn.tokens.forward_slash, Yn.tokens.modulo ]); ) e = new zn(this._previous().toString(), e, this._unary_expression());
        return e;
    }
    _unary_expression() {
        return this._match([ Yn.tokens.minus, Yn.tokens.bang, Yn.tokens.tilde, Yn.tokens.star, Yn.tokens.and ]) ? new Un(this._previous().toString(), this._unary_expression()) : this._singular_expression();
    }
    _singular_expression() {
        const e = this._primary_expression(), t = this._postfix_expression();
        return t && (e.postfix = t), e;
    }
    _postfix_expression() {
        if (this._match(Yn.tokens.bracket_left)) {
            const e = this._short_circuit_or_expression();
            this._consume(Yn.tokens.bracket_right, "Expected ']'.");
            const t = new Nn(e), n = this._postfix_expression();
            return n && (t.postfix = n), t;
        }
        if (this._match(Yn.tokens.period)) {
            const e = this._consume(Yn.tokens.ident, "Expected member name."), t = this._postfix_expression(), n = new En(e.lexeme);
            return t && (n.postfix = t), n;
        }
        return null;
    }
    _getStruct(e) {
        if (this._context.aliases.has(e)) {
            return this._context.aliases.get(e).type;
        }
        if (this._context.structs.has(e)) {
            return this._context.structs.get(e);
        }
        return null;
    }
    _primary_expression() {
        if (this._match(Yn.tokens.ident)) {
            const e = this._previous().toString();
            if (this._check(Yn.tokens.paren_left)) {
                const t = this._argument_expression_list(), n = this._getStruct(e);
                return null != n ? new Pn(n, t) : new In(e, t);
            }
            if (this._context.constants.has(e)) {
                const t = this._context.constants.get(e);
                return new Ln(e, t.value);
            }
            return new Rn(e);
        }
        if (this._match(Yn.const_literal)) return new Fn(parseFloat(this._previous().toString()));
        if (this._check(Yn.tokens.paren_left)) return this._paren_expression();
        if (this._match(Yn.keywords.bitcast)) {
            this._consume(Yn.tokens.less_than, "Expected '<'.");
            const e = this._type_decl();
            this._consume(Yn.tokens.greater_than, "Expected '>'.");
            const t = this._paren_expression();
            return new Hn(e, t);
        }
        const e = this._type_decl(), t = this._argument_expression_list();
        return new Pn(e, t);
    }
    _argument_expression_list() {
        if (!this._match(Yn.tokens.paren_left)) return null;
        const e = [];
        do {
            if (this._check(Yn.tokens.paren_right)) break;
            const t = this._short_circuit_or_expression();
            e.push(t);
        } while (this._match(Yn.tokens.comma));
        return this._consume(Yn.tokens.paren_right, "Expected ')' for agument list"), e;
    }
    _optional_paren_expression() {
        this._match(Yn.tokens.paren_left);
        const e = this._short_circuit_or_expression();
        return this._match(Yn.tokens.paren_right), new Dn([ e ]);
    }
    _paren_expression() {
        this._consume(Yn.tokens.paren_left, "Expected '('.");
        const e = this._short_circuit_or_expression();
        return this._consume(Yn.tokens.paren_right, "Expected ')'."), new Dn([ e ]);
    }
    _struct_decl() {
        if (!this._match(Yn.keywords.struct)) return null;
        const e = this._currentLine, t = this._consume(Yn.tokens.ident, "Expected name for struct.").toString();
        this._consume(Yn.tokens.brace_left, "Expected '{' for struct body.");
        const n = [];
        for (;!this._check(Yn.tokens.brace_right); ) {
            const e = this._attribute(), t = this._consume(Yn.tokens.ident, "Expected variable name.").toString();
            this._consume(Yn.tokens.colon, "Expected ':' for struct member type.");
            const r = this._attribute(), i = this._type_decl();
            null != i && (i.attributes = r), this._check(Yn.tokens.brace_right) ? this._match(Yn.tokens.comma) : this._consume(Yn.tokens.comma, "Expected ',' for struct member."), 
            n.push(new Xn(t, i, e));
        }
        this._consume(Yn.tokens.brace_right, "Expected '}' after struct body.");
        const r = this._currentLine, i = new Sn(t, n, e, r);
        return this._context.structs.set(t, i), i;
    }
    _global_variable_decl() {
        const e = this._variable_decl();
        return e && this._match(Yn.tokens.equal) && (e.value = this._const_expression()), 
        e;
    }
    _override_variable_decl() {
        const e = this._override_decl();
        return e && this._match(Yn.tokens.equal) && (e.value = this._const_expression()), 
        e;
    }
    _global_const_decl() {
        if (!this._match(Yn.keywords.const)) return null;
        const e = this._consume(Yn.tokens.ident, "Expected variable name");
        let t = null;
        if (this._match(Yn.tokens.colon)) {
            const e = this._attribute();
            t = this._type_decl(), null != t && (t.attributes = e);
        }
        let n = null;
        if (this._match(Yn.tokens.equal)) {
            const e = this._short_circuit_or_expression();
            if (e instanceof Pn) n = e; else if (e instanceof Ln && e.initializer instanceof Pn) n = e.initializer; else try {
                const t = e.evaluate(this._context);
                n = new Fn(t);
            } catch (t) {
                n = e;
            }
        }
        const r = new nn(e.toString(), t, "", "", n);
        return this._context.constants.set(r.name, r), r;
    }
    _global_let_decl() {
        if (!this._match(Yn.keywords.let)) return null;
        const e = this._consume(Yn.tokens.ident, "Expected variable name");
        let t = null;
        if (this._match(Yn.tokens.colon)) {
            const e = this._attribute();
            t = this._type_decl(), null != t && (t.attributes = e);
        }
        let n = null;
        return this._match(Yn.tokens.equal) && (n = this._const_expression()), new tn(e.toString(), t, "", "", n);
    }
    _const_expression() {
        return this._short_circuit_or_expression();
    }
    _variable_decl() {
        if (!this._match(Yn.keywords.var)) return null;
        let e = "", t = "";
        this._match(Yn.tokens.less_than) && (e = this._consume(Yn.storage_class, "Expected storage_class.").toString(), 
        this._match(Yn.tokens.comma) && (t = this._consume(Yn.access_mode, "Expected access_mode.").toString()), 
        this._consume(Yn.tokens.greater_than, "Expected '>'."));
        const n = this._consume(Yn.tokens.ident, "Expected variable name");
        let r = null;
        if (this._match(Yn.tokens.colon)) {
            const e = this._attribute();
            r = this._type_decl(), null != r && (r.attributes = e);
        }
        return new Qt(n.toString(), r, e, t, null);
    }
    _override_decl() {
        if (!this._match(Yn.keywords.override)) return null;
        const e = this._consume(Yn.tokens.ident, "Expected variable name");
        let t = null;
        if (this._match(Yn.tokens.colon)) {
            const e = this._attribute();
            t = this._type_decl(), null != t && (t.attributes = e);
        }
        return new en(e.toString(), t, null);
    }
    _diagnostic() {
        this._consume(Yn.tokens.paren_left, "Expected '('");
        const e = this._consume(Yn.tokens.ident, "Expected severity control name.");
        this._consume(Yn.tokens.comma, "Expected ','");
        const t = this._consume(Yn.tokens.ident, "Expected diagnostic rule name.");
        return this._consume(Yn.tokens.paren_right, "Expected ')'"), new vn(e.toString(), t.toString());
    }
    _enable_directive() {
        const e = this._consume(Yn.tokens.ident, "identity expected.");
        return new _n(e.toString());
    }
    _requires_directive() {
        const e = [ this._consume(Yn.tokens.ident, "identity expected.").toString() ];
        for (;this._match(Yn.tokens.comma); ) {
            const t = this._consume(Yn.tokens.ident, "identity expected.");
            e.push(t.toString());
        }
        return new pn(e);
    }
    _type_alias() {
        const e = this._consume(Yn.tokens.ident, "identity expected.");
        this._consume(Yn.tokens.equal, "Expected '=' for type alias.");
        let t = this._type_decl();
        if (null === t) throw this._error(this._peek(), "Expected Type for Alias.");
        this._context.aliases.has(t.name) && (t = this._context.aliases.get(t.name).type);
        const n = new xn(e.toString(), t);
        return this._context.aliases.set(n.name, n), n;
    }
    _type_decl() {
        if (this._check([ Yn.tokens.ident, ...Yn.texel_format, Yn.keywords.bool, Yn.keywords.f32, Yn.keywords.i32, Yn.keywords.u32 ])) {
            const e = this._advance(), t = e.toString();
            return this._context.structs.has(t) ? this._context.structs.get(t) : this._context.aliases.has(t) ? this._context.aliases.get(t).type : new Tn(e.toString());
        }
        let e = this._texture_sampler_types();
        if (e) return e;
        if (this._check(Yn.template_types)) {
            let e = this._advance().toString(), t = null, n = null;
            return this._match(Yn.tokens.less_than) && (t = this._type_decl(), n = null, this._match(Yn.tokens.comma) && (n = this._consume(Yn.access_mode, "Expected access_mode for pointer").toString()), 
            this._consume(Yn.tokens.greater_than, "Expected '>' for type.")), new Mn(e, t, n);
        }
        if (this._match(Yn.keywords.ptr)) {
            let e = this._previous().toString();
            this._consume(Yn.tokens.less_than, "Expected '<' for pointer.");
            const t = this._consume(Yn.storage_class, "Expected storage_class for pointer");
            this._consume(Yn.tokens.comma, "Expected ',' for pointer.");
            const n = this._type_decl();
            let r = null;
            return this._match(Yn.tokens.comma) && (r = this._consume(Yn.access_mode, "Expected access_mode for pointer").toString()), 
            this._consume(Yn.tokens.greater_than, "Expected '>' for pointer."), new An(e, t.toString(), n, r);
        }
        const t = this._attribute();
        if (this._match(Yn.keywords.array)) {
            let e = null, n = -1;
            const r = this._previous();
            let i = null;
            if (this._match(Yn.tokens.less_than)) {
                e = this._type_decl(), this._context.aliases.has(e.name) && (e = this._context.aliases.get(e.name).type);
                let t = "";
                if (this._match(Yn.tokens.comma)) {
                    i = this._shift_expression();
                    try {
                        t = i.evaluate(this._context).toString(), i = null;
                    } catch (e) {
                        t = "1";
                    }
                }
                this._consume(Yn.tokens.greater_than, "Expected '>' for array."), n = t ? parseInt(t) : 0;
            }
            const s = new Cn(r.toString(), t, e, n);
            return i && this._deferArrayCountEval.push({
                arrayType: s,
                countNode: i
            }), s;
        }
        return null;
    }
    _texture_sampler_types() {
        if (this._match(Yn.sampler_type)) return new kn(this._previous().toString(), null, null);
        if (this._match(Yn.depth_texture_type)) return new kn(this._previous().toString(), null, null);
        if (this._match(Yn.sampled_texture_type) || this._match(Yn.multisampled_texture_type)) {
            const e = this._previous();
            this._consume(Yn.tokens.less_than, "Expected '<' for sampler type.");
            const t = this._type_decl();
            return this._consume(Yn.tokens.greater_than, "Expected '>' for sampler type."), 
            new kn(e.toString(), t, null);
        }
        if (this._match(Yn.storage_texture_type)) {
            const e = this._previous();
            this._consume(Yn.tokens.less_than, "Expected '<' for sampler type.");
            const t = this._consume(Yn.texel_format, "Invalid texel format.").toString();
            this._consume(Yn.tokens.comma, "Expected ',' after texel format.");
            const n = this._consume(Yn.access_mode, "Expected access mode for storage texture type.").toString();
            return this._consume(Yn.tokens.greater_than, "Expected '>' for sampler type."), 
            new kn(e.toString(), t, n);
        }
        return null;
    }
    _attribute() {
        let e = [];
        for (;this._match(Yn.tokens.attr); ) {
            const t = this._consume(Yn.attribute_name, "Expected attribute name"), n = new Kn(t.toString(), null);
            if (this._match(Yn.tokens.paren_left)) {
                if (n.value = this._consume(Yn.literal_or_ident, "Expected attribute value").toString(), 
                this._check(Yn.tokens.comma)) {
                    this._advance();
                    do {
                        const e = this._consume(Yn.literal_or_ident, "Expected attribute value").toString();
                        n.value instanceof Array || (n.value = [ n.value ]), n.value.push(e);
                    } while (this._match(Yn.tokens.comma));
                }
                this._consume(Yn.tokens.paren_right, "Expected ')'");
            }
            e.push(n);
        }
        return 0 == e.length ? null : e;
    }
}

class er {
    constructor(e, t) {
        this.name = e, this.attributes = t, this.size = 0;
    }
    get isArray() {
        return !1;
    }
    get isStruct() {
        return !1;
    }
    get isTemplate() {
        return !1;
    }
}

class tr {
    constructor(e, t, n) {
        this.name = e, this.type = t, this.attributes = n, this.offset = 0, this.size = 0;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray || this.type.isTemplate ? this.type.format : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}

class nr extends er {
    constructor(e, t) {
        super(e, t), this.members = [], this.align = 0, this.startLine = -1, this.endLine = -1, 
        this.inUse = !1;
    }
    get isStruct() {
        return !0;
    }
}

class rr extends er {
    constructor(e, t) {
        super(e, t), this.count = 0, this.stride = 0;
    }
    get isArray() {
        return !0;
    }
}

class ir extends er {
    constructor(e, t, n, r) {
        super(e, n), this.format = t, this.access = r;
    }
    get isTemplate() {
        return !0;
    }
}

!function(e) {
    e[e.Uniform = 0] = "Uniform", e[e.Storage = 1] = "Storage", e[e.Texture = 2] = "Texture", 
    e[e.Sampler = 3] = "Sampler", e[e.StorageTexture = 4] = "StorageTexture";
}(ln || (ln = {}));

class sr {
    constructor(e, t, n, r, i, s, o) {
        this.name = e, this.type = t, this.group = n, this.binding = r, this.attributes = i, 
        this.resourceType = s, this.access = o;
    }
    get isArray() {
        return this.type.isArray;
    }
    get isStruct() {
        return this.type.isStruct;
    }
    get isTemplate() {
        return this.type.isTemplate;
    }
    get size() {
        return this.type.size;
    }
    get align() {
        return this.type.isStruct ? this.type.align : 0;
    }
    get members() {
        return this.type.isStruct ? this.type.members : null;
    }
    get format() {
        return this.type.isArray || this.type.isTemplate ? this.type.format : null;
    }
    get count() {
        return this.type.isArray ? this.type.count : 0;
    }
    get stride() {
        return this.type.isArray ? this.type.stride : this.size;
    }
}

class or {
    constructor(e, t) {
        this.name = e, this.type = t;
    }
}

class ar {
    constructor(e, t) {
        this.align = e, this.size = t;
    }
}

class lr {
    constructor(e, t, n, r) {
        this.name = e, this.type = t, this.locationType = n, this.location = r, this.interpolation = null;
    }
}

class cr {
    constructor(e, t, n, r) {
        this.name = e, this.type = t, this.locationType = n, this.location = r;
    }
}

class hr {
    constructor(e, t, n, r) {
        this.name = e, this.type = t, this.attributes = n, this.id = r;
    }
}

class dr {
    constructor(e, t) {
        this.name = e, this.type = t;
    }
}

class ur {
    constructor(e, t = null) {
        this.stage = null, this.inputs = [], this.outputs = [], this.arguments = [], this.returnType = null, 
        this.resources = [], this.overrides = [], this.startLine = -1, this.endLine = -1, 
        this.inUse = !1, this.calls = new Set, this.name = e, this.stage = t;
    }
}

class fr {
    constructor() {
        this.vertex = [], this.fragment = [], this.compute = [];
    }
}

class mr {
    constructor(e) {
        this.resources = null, this.inUse = !1, this.info = null, this.node = e;
    }
}

class gr {
    constructor(e) {
        this.uniforms = [], this.storage = [], this.textures = [], this.samplers = [], this.aliases = [], 
        this.overrides = [], this.structs = [], this.entry = new fr, this.functions = [], 
        this._types = new Map, this._functions = new Map, e && this.update(e);
    }
    _isStorageTexture(e) {
        return "texture_storage_1d" == e.name || "texture_storage_2d" == e.name || "texture_storage_2d_array" == e.name || "texture_storage_3d" == e.name;
    }
    update(e) {
        const t = (new Qn).parse(e);
        for (const e of t) e instanceof Kt && this._functions.set(e.name, new mr(e));
        for (const e of t) if (e instanceof Sn) {
            const t = this._getTypeInfo(e, null);
            t instanceof nr && this.structs.push(t);
        }
        for (const e of t) if (e instanceof xn) this.aliases.push(this._getAliasInfo(e)); else if (e instanceof en) {
            const t = e, n = this._getAttributeNum(t.attributes, "id", 0), r = null != t.type ? this._getTypeInfo(t.type, t.attributes) : null;
            this.overrides.push(new hr(t.name, r, t.attributes, n));
        } else if (this._isUniformVar(e)) {
            const t = e, n = this._getAttributeNum(t.attributes, "group", 0), r = this._getAttributeNum(t.attributes, "binding", 0), i = this._getTypeInfo(t.type, t.attributes), s = new sr(t.name, i, n, r, t.attributes, ln.Uniform, t.access);
            this.uniforms.push(s);
        } else if (this._isStorageVar(e)) {
            const t = e, n = this._getAttributeNum(t.attributes, "group", 0), r = this._getAttributeNum(t.attributes, "binding", 0), i = this._getTypeInfo(t.type, t.attributes), s = this._isStorageTexture(i), o = new sr(t.name, i, n, r, t.attributes, s ? ln.StorageTexture : ln.Storage, t.access);
            this.storage.push(o);
        } else if (this._isTextureVar(e)) {
            const t = e, n = this._getAttributeNum(t.attributes, "group", 0), r = this._getAttributeNum(t.attributes, "binding", 0), i = this._getTypeInfo(t.type, t.attributes), s = this._isStorageTexture(i), o = new sr(t.name, i, n, r, t.attributes, s ? ln.StorageTexture : ln.Texture, t.access);
            s ? this.storage.push(o) : this.textures.push(o);
        } else if (this._isSamplerVar(e)) {
            const t = e, n = this._getAttributeNum(t.attributes, "group", 0), r = this._getAttributeNum(t.attributes, "binding", 0), i = this._getTypeInfo(t.type, t.attributes), s = new sr(t.name, i, n, r, t.attributes, ln.Sampler, t.access);
            this.samplers.push(s);
        } else if (e instanceof Kt) {
            const t = this._getAttribute(e, "vertex"), n = this._getAttribute(e, "fragment"), r = this._getAttribute(e, "compute"), i = t || n || r, s = new ur(e.name, null == i ? void 0 : i.name);
            s.startLine = e.startLine, s.endLine = e.endLine, this.functions.push(s), this._functions.get(e.name).info = s, 
            i ? (this._functions.get(e.name).inUse = !0, s.inUse = !0, s.resources = this._findResources(e, !!i), 
            s.inputs = this._getInputs(e.args), s.outputs = this._getOutputs(e.returnType), 
            this.entry[i.name].push(s)) : (s.arguments = e.args.map((e => new dr(e.name, this._getTypeInfo(e.type, e.attributes)))), 
            s.returnType = e.returnType ? this._getTypeInfo(e.returnType, e.attributes) : null);
        } else ;
        for (const e of this._functions.values()) e.info && (e.info.inUse = e.inUse, this._addCalls(e.node, e.info.calls));
        for (const e of this._functions.values()) e.node.search((t => {
            var n;
            if ("varExpr" === t.astNodeType) {
                const r = t;
                for (const t of this.overrides) r.name == t.name && (null === (n = e.info) || void 0 === n || n.overrides.push(t));
            }
        }));
        for (const e of this.uniforms) this._markStructsInUse(e.type);
        for (const e of this.storage) this._markStructsInUse(e.type);
    }
    _markStructsInUse(e) {
        if (e) if (e.isStruct) {
            if (e.inUse = !0, e.members) for (const t of e.members) this._markStructsInUse(t.type);
        } else if (e.isArray) this._markStructsInUse(e.format); else if (e.isTemplate) e.format && this._markStructsInUse(e.format); else {
            const t = this._getAlias(e.name);
            t && this._markStructsInUse(t);
        }
    }
    _addCalls(e, t) {
        var n;
        for (const r of e.calls) {
            const e = null === (n = this._functions.get(r.name)) || void 0 === n ? void 0 : n.info;
            e && t.add(e);
        }
    }
    findResource(e, t) {
        for (const n of this.uniforms) if (n.group == e && n.binding == t) return n;
        for (const n of this.storage) if (n.group == e && n.binding == t) return n;
        for (const n of this.textures) if (n.group == e && n.binding == t) return n;
        for (const n of this.samplers) if (n.group == e && n.binding == t) return n;
        return null;
    }
    _findResource(e) {
        for (const t of this.uniforms) if (t.name == e) return t;
        for (const t of this.storage) if (t.name == e) return t;
        for (const t of this.textures) if (t.name == e) return t;
        for (const t of this.samplers) if (t.name == e) return t;
        return null;
    }
    _markStructsFromAST(e) {
        const t = this._getTypeInfo(e, null);
        this._markStructsInUse(t);
    }
    _findResources(e, t) {
        const n = [], r = this, i = [];
        return e.search((s => {
            if (s instanceof Wt) i.push({}); else if (s instanceof qt) i.pop(); else if (s instanceof Qt) {
                const e = s;
                t && null !== e.type && this._markStructsFromAST(e.type), i.length > 0 && (i[i.length - 1][e.name] = e);
            } else if (s instanceof Pn) {
                const e = s;
                t && null !== e.type && this._markStructsFromAST(e.type);
            } else if (s instanceof tn) {
                const e = s;
                t && null !== e.type && this._markStructsFromAST(e.type), i.length > 0 && (i[i.length - 1][e.name] = e);
            } else if (s instanceof Rn) {
                const e = s;
                if (i.length > 0) {
                    if (i[i.length - 1][e.name]) return;
                }
                const t = r._findResource(e.name);
                t && n.push(t);
            } else if (s instanceof In) {
                const i = s, o = r._functions.get(i.name);
                o && (t && (o.inUse = !0), e.calls.add(o.node), null === o.resources && (o.resources = r._findResources(o.node, t)), 
                n.push(...o.resources));
            } else if (s instanceof dn) {
                const i = s, o = r._functions.get(i.name);
                o && (t && (o.inUse = !0), e.calls.add(o.node), null === o.resources && (o.resources = r._findResources(o.node, t)), 
                n.push(...o.resources));
            }
        })), [ ...new Map(n.map((e => [ e.name, e ]))).values() ];
    }
    getBindGroups() {
        const e = [];
        function t(t, n) {
            t >= e.length && (e.length = t + 1), void 0 === e[t] && (e[t] = []), n >= e[t].length && (e[t].length = n + 1);
        }
        for (const n of this.uniforms) {
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        for (const n of this.storage) {
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        for (const n of this.textures) {
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        for (const n of this.samplers) {
            t(n.group, n.binding);
            e[n.group][n.binding] = n;
        }
        return e;
    }
    _getOutputs(e, t = void 0) {
        if (void 0 === t && (t = []), e instanceof Sn) this._getStructOutputs(e, t); else {
            const n = this._getOutputInfo(e);
            null !== n && t.push(n);
        }
        return t;
    }
    _getStructOutputs(e, t) {
        for (const n of e.members) if (n.type instanceof Sn) this._getStructOutputs(n.type, t); else {
            const e = this._getAttribute(n, "location") || this._getAttribute(n, "builtin");
            if (null !== e) {
                const r = this._getTypeInfo(n.type, n.type.attributes), i = this._parseInt(e.value), s = new cr(n.name, r, e.name, i);
                t.push(s);
            }
        }
    }
    _getOutputInfo(e) {
        const t = this._getAttribute(e, "location") || this._getAttribute(e, "builtin");
        if (null !== t) {
            const n = this._getTypeInfo(e, e.attributes), r = this._parseInt(t.value);
            return new cr("", n, t.name, r);
        }
        return null;
    }
    _getInputs(e, t = void 0) {
        void 0 === t && (t = []);
        for (const n of e) if (n.type instanceof Sn) this._getStructInputs(n.type, t); else {
            const e = this._getInputInfo(n);
            null !== e && t.push(e);
        }
        return t;
    }
    _getStructInputs(e, t) {
        for (const n of e.members) if (n.type instanceof Sn) this._getStructInputs(n.type, t); else {
            const e = this._getInputInfo(n);
            null !== e && t.push(e);
        }
    }
    _getInputInfo(e) {
        const t = this._getAttribute(e, "location") || this._getAttribute(e, "builtin");
        if (null !== t) {
            const n = this._getAttribute(e, "interpolation"), r = this._getTypeInfo(e.type, e.attributes), i = this._parseInt(t.value), s = new lr(e.name, r, t.name, i);
            return null !== n && (s.interpolation = this._parseString(n.value)), s;
        }
        return null;
    }
    _parseString(e) {
        return e instanceof Array && (e = e[0]), e;
    }
    _parseInt(e) {
        e instanceof Array && (e = e[0]);
        const t = parseInt(e);
        return isNaN(t) ? e : t;
    }
    _getAlias(e) {
        for (const t of this.aliases) if (t.name == e) return t.type;
        return null;
    }
    _getAliasInfo(e) {
        return new or(e.name, this._getTypeInfo(e.type, null));
    }
    _getTypeInfo(e, t) {
        if (this._types.has(e)) return this._types.get(e);
        if (e instanceof Cn) {
            const n = e, r = n.format ? this._getTypeInfo(n.format, n.attributes) : null, i = new rr(n.name, t);
            return i.format = r, i.count = n.count, this._types.set(e, i), this._updateTypeInfo(i), 
            i;
        }
        if (e instanceof Sn) {
            const n = e, r = new nr(n.name, t);
            r.startLine = n.startLine, r.endLine = n.endLine;
            for (const e of n.members) {
                const t = this._getTypeInfo(e.type, e.attributes);
                r.members.push(new tr(e.name, t, e.attributes));
            }
            return this._types.set(e, r), this._updateTypeInfo(r), r;
        }
        if (e instanceof kn) {
            const n = e, r = n.format instanceof Tn, i = n.format ? r ? this._getTypeInfo(n.format, null) : new er(n.format, null) : null, s = new ir(n.name, i, t, n.access);
            return this._types.set(e, s), this._updateTypeInfo(s), s;
        }
        if (e instanceof Mn) {
            const n = e, r = n.format ? this._getTypeInfo(n.format, null) : null, i = new ir(n.name, r, t, n.access);
            return this._types.set(e, i), this._updateTypeInfo(i), i;
        }
        const n = new er(e.name, t);
        return this._types.set(e, n), this._updateTypeInfo(n), n;
    }
    _updateTypeInfo(e) {
        var t, n;
        const r = this._getTypeSize(e);
        if (e.size = null !== (t = null == r ? void 0 : r.size) && void 0 !== t ? t : 0, 
        e instanceof rr && e.format) {
            const t = this._getTypeSize(e.format);
            e.stride = null !== (n = null == t ? void 0 : t.size) && void 0 !== n ? n : 0, this._updateTypeInfo(e.format);
        }
        e instanceof nr && this._updateStructInfo(e);
    }
    _updateStructInfo(e) {
        var t;
        let n = 0, r = 0, i = 0, s = 0;
        for (let o = 0, a = e.members.length; o < a; ++o) {
            const a = e.members[o], l = this._getTypeSize(a);
            if (!l) continue;
            null !== (t = this._getAlias(a.type.name)) && void 0 !== t || a.type;
            const c = l.align, h = l.size;
            n = this._roundUp(c, n + r), r = h, i = n, s = Math.max(s, c), a.offset = n, a.size = h, 
            this._updateTypeInfo(a.type);
        }
        e.size = this._roundUp(s, i + r), e.align = s;
    }
    _getTypeSize(e) {
        var t, n;
        if (null == e) return null;
        const r = this._getAttributeNum(e.attributes, "size", 0), i = this._getAttributeNum(e.attributes, "align", 0);
        if (e instanceof tr && (e = e.type), e instanceof er) {
            const t = this._getAlias(e.name);
            null !== t && (e = t);
        }
        {
            const n = gr._typeInfo[e.name];
            if (void 0 !== n) {
                const s = "f16" === (null === (t = e.format) || void 0 === t ? void 0 : t.name) ? 2 : 1;
                return new ar(Math.max(i, n.align / s), Math.max(r, n.size / s));
            }
        }
        {
            const t = gr._typeInfo[e.name.substring(0, e.name.length - 1)];
            if (t) {
                const n = "h" === e.name[e.name.length - 1] ? 2 : 1;
                return new ar(Math.max(i, t.align / n), Math.max(r, t.size / n));
            }
        }
        if (e instanceof rr) {
            let t = e, s = 8, o = 8;
            const a = this._getTypeSize(t.format);
            null !== a && (o = a.size, s = a.align);
            return o = t.count * this._getAttributeNum(null !== (n = null == e ? void 0 : e.attributes) && void 0 !== n ? n : null, "stride", this._roundUp(s, o)), 
            r && (o = r), new ar(Math.max(i, s), Math.max(r, o));
        }
        if (e instanceof nr) {
            let t = 0, n = 0, s = 0, o = 0, a = 0;
            for (const n of e.members) {
                const e = this._getTypeSize(n.type);
                null !== e && (t = Math.max(e.align, t), s = this._roundUp(e.align, s + o), o = e.size, 
                a = s);
            }
            return n = this._roundUp(t, a + o), new ar(Math.max(i, t), Math.max(r, n));
        }
        return null;
    }
    _isUniformVar(e) {
        return e instanceof Qt && "uniform" == e.storage;
    }
    _isStorageVar(e) {
        return e instanceof Qt && "storage" == e.storage;
    }
    _isTextureVar(e) {
        return e instanceof Qt && null !== e.type && -1 != gr._textureTypes.indexOf(e.type.name);
    }
    _isSamplerVar(e) {
        return e instanceof Qt && null !== e.type && -1 != gr._samplerTypes.indexOf(e.type.name);
    }
    _getAttribute(e, t) {
        const n = e;
        if (!n || !n.attributes) return null;
        const r = n.attributes;
        for (let e of r) if (e.name == t) return e;
        return null;
    }
    _getAttributeNum(e, t, n) {
        if (null === e) return n;
        for (let r of e) if (r.name == t) {
            let e = null !== r && null !== r.value ? r.value : n;
            return e instanceof Array && (e = e[0]), "number" == typeof e ? e : "string" == typeof e ? parseInt(e) : n;
        }
        return n;
    }
    _roundUp(e, t) {
        return Math.ceil(t / e) * e;
    }
}

gr._typeInfo = {
    f16: {
        align: 2,
        size: 2
    },
    i32: {
        align: 4,
        size: 4
    },
    u32: {
        align: 4,
        size: 4
    },
    f32: {
        align: 4,
        size: 4
    },
    atomic: {
        align: 4,
        size: 4
    },
    vec2: {
        align: 8,
        size: 8
    },
    vec3: {
        align: 16,
        size: 12
    },
    vec4: {
        align: 16,
        size: 16
    },
    mat2x2: {
        align: 8,
        size: 16
    },
    mat3x2: {
        align: 8,
        size: 24
    },
    mat4x2: {
        align: 8,
        size: 32
    },
    mat2x3: {
        align: 16,
        size: 32
    },
    mat3x3: {
        align: 16,
        size: 48
    },
    mat4x3: {
        align: 16,
        size: 64
    },
    mat2x4: {
        align: 16,
        size: 32
    },
    mat3x4: {
        align: 16,
        size: 48
    },
    mat4x4: {
        align: 16,
        size: 64
    }
}, gr._textureTypes = Yn.any_texture_type.map((e => e.name)), gr._samplerTypes = Yn.sampler_type.map((e => e.name));

class _r {
    constructor(e, t) {
        this.version = 0, this.bindgroupMapping = e, this.pool = t, this.allocation = {};
    }
    writeBuffer(e, t) {
        const n = this.bindgroupMapping, r = n.totalSize, i = this.allocation.gpuBuffer, s = this.pool.bufferAlignment;
        this.pool.alloc(this.allocation, r), i !== this.allocation.gpuBuffer && this.version++;
        let o = this.allocation.offset;
        const a = this.allocation.storage;
        for (let r = 0; r < n.length; r++) {
            const i = n[r], l = i.binding, c = i.members;
            if (c) {
                t.addItem(l, o);
                for (let t = 0; t < c.length; t++) {
                    const n = c[t], r = e[n.name];
                    void 0 === r && console.warn(`Uniform value ${n.name} is not provided`);
                    const i = o + n.offset, s = n.size;
                    this._fillValue(n.type, a, i, s, r);
                }
                o += Ue(i.size, s);
            } else if (i.resourceType === ln.Uniform) {
                t.addItem(l, o);
                const n = e[i.name], r = O(i.size) ? i.size() : i.size;
                this._fillValue(i.type, a, o, r, n), o += Ue(r, s);
            }
        }
    }
    _fillValue(e, t, n, r, i) {
        const s = new Float32Array(t, n, r / 4);
        if (L(i)) {
            const t = function(e) {
                return Be[e.name];
            }(e);
            if (!t) return void s.set(i);
            for (let e = 0; e < i.length; e++) {
                s[4 * Math.floor(e / 3) + e % 3] = i[e];
            }
        } else s[0] = i;
    }
    dispose() {
        delete this.pool, delete this.allocation;
    }
}

const pr = new Array(16);

let vr = 0;

class xr {
    constructor(e, t, n = {}) {
        this._version = 0, this._texVersion = 0, this._geometry = e, this._material = t, 
        this.transparent = !!n.transparent, this.bloom = !!n.bloom, this.ssr = !!n.ssr, 
        this._castShadow = C(n.castShadow) || n.castShadow, this.needUpdateShadow = !1, 
        this.picking = !!n.picking, this.disableVAO = !!n.disableVAO, this.uniforms = {}, 
        this._localTransform = c.identity(new Array(16)), this._positionMatrix = c.identity(new Array(16)), 
        this.properties = {}, this._dirtyUniforms = !0, this._dirtyGeometry = !0, Object.defineProperty(this, "uuid", {
            value: vr++
        }), vr > Number.MAX_VALUE - 10 && (vr = 0);
    }
    set material(e) {
        this._material !== e && this.setMaterial(e);
    }
    get material() {
        return this._material;
    }
    set version(e) {
        throw new Error("Mesh.version is read only.");
    }
    get version() {
        return this._version;
    }
    get textureVersion() {
        return this._texVersion;
    }
    get geometry() {
        return this._geometry;
    }
    set geometry(e) {
        this._geometry !== e && (this._incrVersion(), this._dirtyGeometry = !0), this._geometry = e;
    }
    set localTransform(e) {
        this._prevTMat || (this._prevTMat = new Array(16)), Array.isArray(e) && !c.exactEquals(this._prevTMat, e) && (this._incrVersion(), 
        this._prevTMat = c.copy(this._prevTMat, e)), this._localTransform = e;
    }
    get localTransform() {
        return O(this._localTransform) ? this._localTransform() : this._localTransform;
    }
    set positionMatrix(e) {
        this._prevPMat || (this._prevPMat = new Array(16)), Array.isArray(e) && !c.exactEquals(this._prevPMat, e) && (this._incrVersion(), 
        this._prevPMat = c.copy(this._prevPMat, e)), this._positionMatrix = e;
    }
    get positionMatrix() {
        return O(this._positionMatrix) ? this._positionMatrix() : this._positionMatrix;
    }
    get config() {
        return this._options || (this._options = {}), this._options.transparent = this.transparent, 
        this._options.castShadow = this.castShadow, this._options.bloom = this.bloom, this._options.ssr = this.ssr, 
        this._options.picking = this.picking, this._options;
    }
    get defines() {
        return this._getDefines();
    }
    set defines(e) {
        this.setDefines(e);
    }
    get castShadow() {
        return this._castShadow && (!this.material || !this.material.unlit);
    }
    set castShadow(e) {
        this._castShadow = e;
    }
    setMaterial(e) {
        return this._material = e, this._dirtyUniforms = !0, delete this._materialVer, this.dirtyDefines = !0, 
        this;
    }
    setParent(e) {
        return this.parent = e, this;
    }
    setLocalTransform(e) {
        return this.localTransform = e, this;
    }
    setPositionMatrix(e) {
        this.positionMatrix = e;
    }
    setUniform(e, t) {
        return this.uniforms[e] === t || ($(t) && this._texVersion++, this._updateUniformState(e), 
        this.uniforms[e] = t), this;
    }
    setFunctionUniform(e, t) {
        return this._updateUniformState(e), Object.defineProperty(this.uniforms, e, {
            enumerable: !0,
            get: t
        }), this;
    }
    hasFunctionUniform(e) {
        return !!this.uniforms && Object.prototype.hasOwnProperty.call(this.uniforms, e);
    }
    _updateUniformState(e) {
        void 0 === this.uniforms[e] ? this._dirtyUniforms = !0 : (this._dirtyProps = this._dirtyProps || [], 
        this._dirtyProps.push(e));
    }
    hasUniform(e) {
        return void 0 !== this.uniforms[e];
    }
    getUniform(e) {
        return this.uniforms[e];
    }
    getDefines() {
        const e = {};
        return E(e, this._getDefines()), this._material && this._geometry && this._material.appendDefines(e, this._geometry), 
        e;
    }
    _getDefines() {
        this._defines || (this._defines = {});
        const e = this._geometry, {positionAttribute: t, uv0Attribute: n, normalAttribute: r} = e.desc, i = e.data[t], s = e.data[n], o = e.data[r];
        return i && i.quantization && (this._defines.HAS_DRACO_POSITION = 1), s && s.quantization && (this._defines.HAS_DRACO_TEXCOORD = 1), 
        o && o.quantization && (this._defines.HAS_DRACO_NORMAL = 1), this._defines;
    }
    setDefines(e) {
        const t = this._bakDefines;
        return this._defines = e, this.dirtyDefines = !!t != !!e || !function(e, t) {
            if (!e && !t) return !0;
            const n = Object.getOwnPropertyNames(e), r = Object.getOwnPropertyNames(t);
            if (n.length !== r.length) return !1;
            for (let r = 0; r < n.length; r++) if (e[n[r]] !== t[n[r]]) return !1;
            return !0;
        }(t, e), this;
    }
    hasSkinAnimation() {
        return this._material && this._material.hasSkinAnimation();
    }
    _getDefinesKey() {
        return this._bakDefines = E({}, this._defines), this.dirtyDefines = !1, this._createDefinesKey(this.getDefines());
    }
    getCommandKey(e) {
        if (!this._commandKey || this.dirtyDefines || this._material && this._materialKeys !== this._material.getUniformKeys()) {
            let t = this.geometry.getCommandKey(e) + "_" + this._getDefinesKey();
            t += "_" + (I(this.getElements()) ? "count" : "elements"), t += "_" + +!!this.disableVAO, 
            this._material && (t += "_" + +!!this._material.doubleSided), this._commandKey = t, 
            this._material && (this._materialKeys = this._material.getUniformKeys());
        }
        return this._commandKey;
    }
    getRenderProps(e) {
        const t = this.getUniforms(e);
        return t.meshProperties = this.properties, t.geometryProperties = this._geometry.properties, 
        t.meshConfig = this.config, t.count = this._geometry.getDrawCount(), t.offset = this._geometry.getDrawOffset(), 
        t.primitive = this._geometry.getPrimitive(), t;
    }
    _getGeometryAttributes(e, t) {
        return this._geometry.getREGLData(e, t, this.disableVAO);
    }
    appendGeoAttributes(e, t, n) {
        E(e, this._getGeometryAttributes(t, n)), D(t) && !this.disableVAO || (e.elements = this._geometry.getElements());
    }
    getUniforms(e) {
        if (this._dirtyUniforms || this._dirtyGeometry || this._material && this._materialVer !== this._material.version) {
            this._uniformDescriptors = new Set, this._realUniforms = {}, this._prepareUniformsForDraco();
            const t = this.uniforms;
            for (const e in this.uniforms) if (N(this.uniforms, e)) {
                Object.getOwnPropertyDescriptor(t, e).get ? (this._uniformDescriptors.add(e), Object.defineProperty(this._realUniforms, e, {
                    enumerable: !0,
                    configurable: !0,
                    get: function() {
                        return t[e];
                    }
                })) : this._realUniforms[e] = t[e];
            }
            if (this._material) {
                const t = this._material.getUniforms(e);
                for (const e in t) if (N(t, e) && !N(this._realUniforms, e)) {
                    Object.getOwnPropertyDescriptor(t, e).get ? (this._uniformDescriptors.add(e), Object.defineProperty(this._realUniforms, e, {
                        enumerable: !0,
                        configurable: !0,
                        get: function() {
                            return t[e];
                        }
                    })) : void 0 === this._realUniforms[e] && (this._realUniforms[e] = t[e]);
                }
            }
            this._dirtyUniforms = !1, this._dirtyGeometry = !1, this._materialVer = this._material && this._material.version, 
            this._materialPropVer = this._material && this._material.propVersion, this._dirtyProps = null;
        } else if (this._dirtyProps || this._material && this._material.propVersion !== this._materialPropVer) {
            if (this._dirtyProps) for (const e of this._dirtyProps) this._realUniforms[e] = this.uniforms[e];
            if (this._material && this._material.propVersion !== this._materialPropVer) {
                const t = this._material.getUniforms(e);
                for (const e in t) if (N(t, e) && !this._uniformDescriptors.has(e)) {
                    Object.getOwnPropertyDescriptor(t, e).get || this._realUniforms[e] === t[e] || (this._realUniforms[e] = t[e]);
                }
                this._materialPropVer = this._material.propVersion;
            }
            this._dirtyProps = null;
        }
        return this._realUniforms.modelMatrix = this.localTransform, this._realUniforms.positionMatrix = this.positionMatrix, 
        this._realUniforms;
    }
    _prepareUniformsForDraco() {
        const e = this._geometry, t = e.data[e.desc.positionAttribute], n = e.data[e.desc.uv0Attribute], r = e.data[e.desc.normalAttribute];
        if (t && t.quantization) {
            const e = t.quantization, n = e.range / (1 << e.quantizationBits);
            this._realUniforms.minValues_pos = e.minValues, this._realUniforms.gltf_u_dec_position_normConstant = n;
        }
        if (n && n.quantization) {
            const e = n.quantization;
            this._realUniforms.minValues_tex = e.minValues;
            const t = e.range / (1 << e.quantizationBits);
            this._realUniforms.gltf_u_dec_texcoord_0_normConstant = t;
        }
        if (r && r.quantization) {
            const e = (1 << r.quantization.quantizationBits) - 1;
            this._realUniforms.gltf_u_dec_normal_rangeConstant = e;
        }
    }
    getMaterial() {
        return this._material;
    }
    getElements() {
        return this._geometry.getElements();
    }
    dispose() {
        if (delete this._geometry, delete this._material, delete this._bindGroupCache, delete this._commandKeyCache, 
        this.uniforms = null, this._meshBuffer) {
            for (const e in this._meshBuffer) this._meshBuffer[e].dispose();
            delete this._meshBuffer;
        }
        return this;
    }
    isValid() {
        return this._geometry && !this._geometry.isDisposed() && (!this._material || !this._material.isDisposed());
    }
    getBoundingBox() {
        return this._geometry ? (this._bbox || this.updateBoundingBox(), c.multiply(pr, this.localTransform, this.positionMatrix), 
        c.exactEquals(pr, this._currentTransform) && this._geometry.boundingBox.equals(this._geoBox) || this.updateBoundingBox(), 
        this._bboxArr) : null;
    }
    updateBoundingBox() {
        const e = this._geometry.boundingBox;
        this._bbox || (this._bbox = new le), this._bboxArr || (this._bboxArr = [ [ 0, 0, 0 ], [ 0, 0, 0 ] ]), 
        this._geoBox || (this._geoBox = new le), le.copy(this._bbox, e), this._bbox.updateVertex(), 
        "InstancedMesh" === this.constructor.name ? (this._bbox.transform(this.localTransform, this.positionMatrix), 
        this._currentTransform = c.multiply(this._currentTransform || new Array(16), this.positionMatrix, this.localTransform)) : (this._bbox.transform(this.positionMatrix, this.localTransform), 
        this._currentTransform = c.multiply(this._currentTransform || new Array(16), this.localTransform, this.positionMatrix)), 
        le.copy(this._geoBox, e), h.copy(this._bboxArr[0], this._bbox.min), h.copy(this._bboxArr[1], this._bbox.max);
    }
    _createDefinesKey(e) {
        const t = [];
        for (const n in e) t.push(n, e[n]);
        return t.join(",");
    }
    _incrVersion() {
        this._version++;
    }
    getMemorySize() {
        return (this.geometry && this.geometry.getMemorySize() || 0) + (this.material && this.material.getMemorySize() || 0);
    }
    getWorldTransform() {
        const e = this.parent;
        return e ? c.multiply(new Array(16), e.getWorldTransform(), this.localTransform) : this.localTransform;
    }
    writeDynamicBuffer(e, t, n, r, i) {
        this._meshBuffer || (this._meshBuffer = {});
        let s = this._meshBuffer[e];
        return s || (s = this._meshBuffer[e] = new _r(n, r)), s.writeBuffer(t, i), s;
    }
    getBindGroup(e) {
        return this._bindGroupCache || (this._bindGroupCache = {}), this._bindGroupCache[e];
    }
    setBindGroup(e, t) {
        return this._bindGroupCache[e] = t, this;
    }
    getShaderFnValues(e) {
        return this._commandKeyCache ? this._commandKeyCache[e] : null;
    }
    setShaderFnValues(e, t) {
        return this._commandKeyCache || (this._commandKeyCache = {}), this._commandKeyCache[e] = t, 
        this;
    }
}

class yr extends xr {
    constructor(e, t, n, r, i = {}) {
        super(n, r, i), this._instanceCount = t, this.instancedData = e || {}, this._checkInstancedProp(), 
        this._vao = {};
    }
    get instanceCount() {
        return this._instanceCount;
    }
    set instanceCount(e) {
        this._incrVersion(), this._instanceCount = e;
    }
    getMemorySize() {
        return super.getMemorySize() + this._getInstanceMemorySize();
    }
    _getInstanceMemorySize() {
        let e = 0;
        for (const t in this.instancedData) N(this.instancedData, t) && (e += B(this.instancedData[t]));
        return e;
    }
    _checkInstancedProp() {
        for (const e in this.instancedData) if (this.geometry.data[e]) throw new Error(`Duplicate attribute ${e} defined in geometry and instanced data`);
    }
    appendGeoAttributes(e, t, n) {
        const r = this.geometry.getAttrData(n);
        if (D(t)) {
            const i = n.key;
            if (!this._vao[i] || this._vao[i].dirty) {
                const e = n.map((e => e.name)), s = [];
                for (let t = 0; t < e.length; t++) {
                    const n = r[e[t]], i = n && n.buffer || this.instancedData[e[t]];
                    s.push(i);
                }
                const o = {
                    attributes: s,
                    primitive: this.geometry.getPrimitive()
                };
                this._vao[i] ? this._vao[i].vao(o) : this._vao[i] = {
                    vao: t.vao(o)
                }, delete this._vao[i].dirty;
            }
            E(e, this._vao[i]);
        } else E(e, r);
    }
    getDefines() {
        const e = super.getDefines();
        return e.HAS_INSTANCE = 1, e;
    }
    getCommandKey(e) {
        return "i_" + super.getCommandKey(e);
    }
    updateInstancedData(e, t) {
        const n = this.instancedData[e];
        if (this._incrVersion(), this.instancedData[e] = t, n && n.buffer && n.buffer.destroy && n.buffer.destroy(), 
        this._vao) for (const e in this._vao) this._vao[e].dirty = !0;
        return this;
    }
    getInstancedBuffer(e) {
        return this.instancedData[e] && this.instancedData[e].buffer;
    }
    generateInstancedBuffers(e) {
        const t = !!e && e.wgpu, n = this.instancedData, r = this.instanceCount, i = {};
        for (const s in n) {
            if (!n[s]) continue;
            Array.isArray(n[s]) ? n[s] = new Float32Array(n[s]) : t && L(n[s]) && (n[s] = Ye.padGPUBufferAlignment(n[s], r));
            const o = n[s];
            if (void 0 !== o.buffer && o.buffer.destroy) i[s] = o, i[s].divisor && (i[s].divisor = 1); else if (n[s].destroy) i[s] = {
                buffer: n[s],
                divisor: 1
            }; else {
                const t = {
                    data: n[s],
                    dimension: n[s].length / this._instanceCount
                };
                i[s] = {
                    buffer: Ye.createBuffer(e, t, s),
                    divisor: 1
                };
            }
        }
        return this.instancedData = i, this;
    }
    getRenderProps(e) {
        const t = super.getRenderProps(e);
        return D(e) || E(t, this.instancedData), t.elements = this.geometry.getElements(), 
        t.instances = this._instanceCount, t;
    }
    disposeInstancedData() {
        const e = this.instancedData;
        if (e) for (const t in e) {
            if (!e[t]) continue;
            const n = e[t].destroy ? e[t] : e[t].buffer;
            n.destroy && !n[ee] && (n[ee] = 1, n.destroy());
        }
        this.instancedData = {};
        for (const e in this._vao) this._vao[e].vao.destroy();
        this._vao = {};
    }
    getBufferDescriptor(e) {
        const t = [];
        for (const n in e) {
            const r = e[n];
            t[r.location] = r;
        }
        const n = this.instancedData, r = [];
        for (let i = 0; i < t.length; i++) {
            if (!t[i]) continue;
            const s = t[i].geoAttrName, o = n[s];
            if (!o) continue;
            const a = Qe(o, e[s]);
            a.stepMode = "instance", r[i] = a;
        }
        return r;
    }
}

const br = {};

class wr {
    constructor(e) {
        this.device = e;
    }
    render(e, t, n, r) {
        e.setUniforms(t || br), e.setFramebuffer(r);
        let i = 0;
        if (n) {
            const {opaques: t, transparents: r} = n.getSortedMeshes();
            i += e.draw(this.device, t), i += e.draw(this.device, r);
        } else i += e.draw(this.device);
        return i;
    }
    clear(e) {
        this.device.clear(e);
    }
    isWebGPU() {
        return !!this.device.wgpu;
    }
}

const Tr = {
    getArrayBuffer: (e, t) => Tr.get(e, {
        responseType: "arraybuffer"
    }, t),
    get: function(e, t, n) {
        const r = Tr._getClient(n);
        if (r.open("GET", e, !0), t) {
            for (const e in t.headers) r.setRequestHeader(e, t.headers[e]);
            r.withCredentials = "include" === t.credentials, t.responseType && (r.responseType = t.responseType);
        }
        return r.send(null), r;
    },
    _wrapCallback: function(e, t) {
        return function() {
            if (4 === e.readyState) if (200 === e.status) if ("arraybuffer" === e.responseType) {
                0 === e.response.byteLength ? t(new Error("http status 200 returned without content.")) : t(null, {
                    data: e.response,
                    cacheControl: e.getResponseHeader("Cache-Control"),
                    expires: e.getResponseHeader("Expires"),
                    contentType: e.getResponseHeader("Content-Type")
                });
            } else t(null, e.responseText); else t(new Error(e.statusText + "," + e.status));
        };
    },
    _getClient: function(e) {
        let t;
        try {
            t = new XMLHttpRequest;
        } catch (e) {
            try {
                t = new ActiveXObject("Msxml2.XMLHTTP");
            } catch (e) {
                try {
                    t = new ActiveXObject("Microsoft.XMLHTTP");
                } catch (e) {}
            }
        }
        return t.onreadystatechange = Tr._wrapCallback(t, e), t;
    }
};

class Sr {
    constructor(e, t) {
        this.defaultTexture = e, this.defaultCubeTexture = new Array(6), this.urlModifier = t, 
        this.resources = {};
    }
    setURLModifier(e) {
        this.urlModifier = e;
    }
    get(e) {
        return Array.isArray(e) ? this._loadImages(e) : this._loadImage(e);
    }
    getArrayBuffer(e) {
        if (Array.isArray(e)) {
            const t = e.map((e => this.getArrayBuffer(e)));
            return Promise.all(t);
        }
        return new Promise(((t, n) => {
            let r = e;
            this.urlModifier && (r = this.urlModifier(e)), Tr.getArrayBuffer(r, ((r, i) => {
                r ? n(r) : t({
                    url: e,
                    data: i
                });
            }));
        }));
    }
    disposeRes(e) {
        return Array.isArray(e) ? e.forEach((e => this._disposeOne(e))) : this._disposeOne(e), 
        this;
    }
    isLoading() {
        return this._count && this._count > 0;
    }
    getDefaultTexture(e) {
        return Array.isArray(e) ? this._getBlankTextures(e.length) : this.defaultTexture;
    }
    _disposeOne(e) {
        const t = this.resources;
        t[e] && (t[e].count--, t[e].count <= 0 && delete t[e]);
    }
    _loadImage(e) {
        const t = this.resources;
        if (t[e]) return Promise.resolve({
            url: e,
            data: t[e].image
        });
        return new Promise(((n, r) => {
            const i = new Image;
            i.crossOrigin = "anonymous", i.onload = function() {
                t[e] = {
                    image: i,
                    count: 1
                }, n({
                    url: e,
                    data: i
                });
            }, i.onerror = function(e) {
                r(e);
            }, i.onabort = function() {
                r(`image(${e}) loading aborted.`);
            }, this.urlModifier ? i.src = this.urlModifier(e) : i.src = e;
        }));
    }
    _loadImages(e) {
        const t = e.map((e => this._loadImage(e)));
        return Promise.all(t);
    }
    _getBlankTextures(e) {
        const t = new Array(e);
        for (let e = 0; e < 6; e++) t.push(this.defaultTexture);
        return t;
    }
}

class Mr extends(Q(Sr)){}

const Ar = [ 0, 0, 0 ], Cr = [ 0, 0, 0 ];

let kr, Or = 0;

function Er(e, t) {
    return h.transformMat4(Ar, e.geometry.boundingBox.getCenter(), e.localTransform), 
    h.transformMat4(Cr, t.geometry.boundingBox.getCenter(), t.localTransform), h.dist(Cr, kr) - h.dist(Ar, kr);
}

class Pr {
    constructor(e) {
        this._id = Or++, this.sortedMeshes = {}, this.setMeshes(e), this.dirty();
    }
    setMeshes(e) {
        if (this.clear(), !e || Array.isArray(e) && !e.length || e === this.meshes) return this;
        e = Array.isArray(e) ? e : [ e ], this.meshes = [];
        for (let t = 0; t < e.length; t++) {
            const n = e[t];
            n && this.meshes.push(n);
        }
        return this.dirty(), this;
    }
    addMesh(e) {
        if (!e || Array.isArray(e) && !e.length) return this;
        const t = Array.isArray(e) ? e : [ e ];
        for (let e = 0, n = t.length; e < n; e++) {
            const n = t[e];
            n && -1 === this.meshes.indexOf(n) && (this.meshes.push(n), this.dirty());
        }
        return this;
    }
    removeMesh(e) {
        if (!e || Array.isArray(e) && !e.length) return this;
        const t = Array.isArray(e) ? e : [ e ], n = [];
        for (let e = 0; e < t.length; e++) {
            const r = t[e];
            r && this.meshes.indexOf(r) >= 0 && n.push(r);
        }
        if (n.length > 0) {
            const e = [];
            for (let t = 0; t < this.meshes.length; t++) {
                const r = this.meshes[t];
                -1 === n.indexOf(r) && e.push(r);
            }
            this.meshes = e, this.dirty();
        }
        return this;
    }
    getMeshes() {
        return this.meshes || [];
    }
    clear() {
        return this.meshes = [], this.sortedMeshes.opaques = [], this.sortedMeshes.transparents = [], 
        this;
    }
    dirty() {
        return this._dirty = !0, this;
    }
    sortMeshes(e) {
        const t = this.meshes;
        this.sortFunction && t.sort(this.sortFunction);
        let n = this.sortedMeshes.transparents;
        if (this._dirty) {
            const e = this.sortedMeshes.opaques = [];
            n = this.sortedMeshes.transparents = [];
            for (let r = 0, i = t.length; r < i; r++) t[r].transparent ? n.push(t[r]) : e.push(t[r]);
        }
        e && n.length > 1 && (kr = e, n.sort(Er)), this._dirty = !1;
    }
    getSortedMeshes() {
        return this._dirty && this.sortMeshes(), this.sortedMeshes || {};
    }
}

const Ir = String.fromCharCode, Rr = 8, Lr = 32767;

function Fr(e, t, n, r) {
    if (e[3] > 0) {
        const i = Math.pow(2, e[3] - 128 - 8 + r);
        t[n + 0] = e[0] * i, t[n + 1] = e[1] * i, t[n + 2] = e[2] * i;
    } else t[n + 0] = 0, t[n + 1] = 0, t[n + 2] = 0;
    return t[n + 3] = 1, t;
}

function Hr(e, t, n, r) {
    let i = 0, s = 0, o = r;
    for (;o > 0; ) if (e[s][0] = t[n++], e[s][1] = t[n++], e[s][2] = t[n++], e[s][3] = t[n++], 
    1 === e[s][0] && 1 === e[s][1] && 1 === e[s][2]) {
        for (let t = e[s][3] << i >>> 0; t > 0; t--) a = e[s - 1], (l = e[s])[0] = a[0], 
        l[1] = a[1], l[2] = a[2], l[3] = a[3], s++, o--;
        i += 8;
    } else s++, o--, i = 0;
    var a, l;
    return n;
}

function Dr(e, t, n, r) {
    if (r < Rr | r > Lr) return Hr(e, t, n, r);
    let i = t[n++];
    if (2 !== i) return Hr(e, t, n - 1, r);
    if (e[0][1] = t[n++], e[0][2] = t[n++], i = t[n++], (e[0][2] << 8 >>> 0 | i) >>> 0 !== r) return null;
    for (let i = 0; i < 4; i++) for (let s = 0; s < r; ) {
        let r = t[n++];
        if (r > 128) {
            r = (127 & r) >>> 0;
            const o = t[n++];
            for (;r--; ) e[s++][i] = o;
        } else for (;r--; ) e[s++][i] = t[n++];
    }
    return n;
}

function Nr(e, t = 0) {
    const n = new Uint8Array(e), r = n.length;
    if ("#?" !== function(e, t, n) {
        let r = "";
        for (let i = t; i < n; i++) r += Ir(e[i]);
        return r;
    }(n, 0, 2)) return null;
    for (var i = 2; i < r && ("\n" !== Ir(n[i]) || "\n" !== Ir(n[i + 1])); i++) ;
    if (i >= r) return null;
    i += 2;
    let s = "";
    for (;i < r; i++) {
        const e = Ir(n[i]);
        if ("\n" === e) break;
        s += e;
    }
    const o = s.split(" "), a = parseInt(o[1]), l = parseInt(o[3]);
    if (!l || !a) return null;
    let c = i + 1;
    const h = [];
    for (let e = 0; e < l; e++) {
        h[e] = [];
        for (let t = 0; t < 4; t++) h[e][t] = 0;
    }
    const d = new Float32Array(l * a * 4);
    let u = 0;
    for (let e = 0; e < a; e++) {
        if (c = Dr(h, n, c, l), !c) return null;
        for (let e = 0; e < l; e++) Fr(h[e], d, u, t), u += 4;
    }
    return {
        width: l,
        height: a,
        pixels: d
    };
}

const Br = Ur();

function Ur() {
    const e = new ArrayBuffer(4), t = new Float32Array(e), n = new Uint32Array(e), r = new Uint32Array(512), i = new Uint32Array(512);
    for (let e = 0; e < 256; ++e) {
        const t = e - 127;
        t < -27 ? (r[e] = 0, r[256 | e] = 32768, i[e] = 24, i[256 | e] = 24) : t < -14 ? (r[e] = 1024 >> -t - 14, 
        r[256 | e] = 1024 >> -t - 14 | 32768, i[e] = -t - 1, i[256 | e] = -t - 1) : t <= 15 ? (r[e] = t + 15 << 10, 
        r[256 | e] = t + 15 << 10 | 32768, i[e] = 13, i[256 | e] = 13) : t < 128 ? (r[e] = 31744, 
        r[256 | e] = 64512, i[e] = 24, i[256 | e] = 24) : (r[e] = 31744, r[256 | e] = 64512, 
        i[e] = 13, i[256 | e] = 13);
    }
    const s = new Uint32Array(2048), o = new Uint32Array(64), a = new Uint32Array(64);
    for (let e = 1; e < 1024; ++e) {
        let t = e << 13, n = 0;
        for (;!(8388608 & t); ) t <<= 1, n -= 8388608;
        t &= -8388609, n += 947912704, s[e] = t | n;
    }
    for (let e = 1024; e < 2048; ++e) s[e] = 939524096 + (e - 1024 << 13);
    for (let e = 1; e < 31; ++e) o[e] = e << 23;
    o[31] = 1199570944, o[32] = 2147483648;
    for (let e = 33; e < 63; ++e) o[e] = 2147483648 + (e - 32 << 23);
    o[63] = 3347054592;
    for (let e = 1; e < 64; ++e) 32 !== e && (a[e] = 1024);
    return {
        floatView: t,
        uint32View: n,
        baseTable: r,
        shiftTable: i,
        mantissaTable: s,
        exponentTable: o,
        offsetTable: a
    };
}

const zr = {
    toHalfFloat: function(e) {
        Math.abs(e) > 65504 && console.warn("THREE.DataUtils.toHalfFloat(): Value out of range."), 
        e = H(e, -65504, 65504), Br.floatView[0] = e;
        const t = Br.uint32View[0], n = t >> 23 & 511;
        return Br.baseTable[n] + ((8388607 & t) >> Br.shiftTable[n]);
    },
    fromHalfFloat: function(e) {
        const t = e >> 10;
        return Br.uint32View[0] = Br.mantissaTable[Br.offsetTable[t] + (1023 & e)] + Br.exponentTable[t], 
        Br.floatView[0];
    }
}, Gr = 9728, Vr = 9729, jr = 9987;

var Wr = Object.freeze({
    __proto__: null,
    GL_LINEAR: Vr,
    GL_LINEAR_MIPMAP_LINEAR: jr,
    GL_NEAREST: Gr,
    MAG_FILTER: 10240,
    MIN_FILTER: 10241
});

class qr extends se {
    constructor() {
        super(...arguments), this._version = 0;
    }
    get version() {
        return this._version;
    }
    set version(e) {
        throw new Error("Texture2D.version is read only.");
    }
    onLoad({data: e}) {
        const t = this.config;
        if (t) {
            if (t.hdr) {
                if (!(e = Nr(e.data, 0))) throw new Error("Invalid hdr data" + (t.url ? ":" + t.url : ""));
                {
                    const n = new Uint16Array(e.pixels.length);
                    for (let t = 0; t < e.pixels.length; t++) n[t] = Math.min(zr.toHalfFloat(e.pixels[t]), 65504);
                    t.data = n, t.type = "float16", t.colorSpace = "browser", t.min = "linear", t.mag = "linear";
                }
            } else t.data = e;
            t.width = t.width || e.width, t.height = t.height || e.height, this._regl && this._checkNPOT(this._regl), 
            this._update();
        }
    }
    setConfig(e) {
        const t = e.data;
        e.image = t, e.width = e.width || t.width, e.height = e.height || t.height, this.config = e, 
        this.dirty = !!this._texture;
    }
    _update() {
        this._texture && !this._texture[ee] && (this._version++, O(this._texture) ? this._texture(this.config) : this._texture.update(this.config)), 
        this.dirty = !1;
    }
    setMinFilter(e) {
        this.config.min = _t(e), this._texture && this._texture.updateFilter && this._texture.updateFilter(), 
        this._texture && this._texture.texParameteri && this._texture.texParameteri(10241, e);
    }
    setMagFilter(e) {
        this.config.mag = mt(e), this._texture && this._texture.updateFilter && this._texture.updateFilter(), 
        this._texture && this._texture.texParameteri && this._texture.texParameteri(10240, e);
    }
    createREGLTexture(e) {
        if (this._regl = e, this._checkNPOT(e), L(this.config.data) || L(this.config.mipmap)) {
            const t = wt(e, this.config);
            return t[re] || (t[re] = 0), t[re]++, t;
        }
        return e.texture(this.config);
    }
    _checkNPOT(e) {
        const t = this.config;
        t.data && this._needPowerOf2(e) && (t.data instanceof Image ? (t.data = Z(t.data), 
        t.width = t.data.width, t.height = t.data.height) : t.hdr || !L(t.data) || X(t.width) && X(t.height) || (t.data = Z(t.data, t.width, t.height), 
        t.width = t.data.width, t.height = t.data.height));
    }
    _needPowerOf2(e) {
        if (Y(e)) return !1;
        const t = this.config;
        return t.wrap && "clamp" !== t.wrap || t.wrapS && "clamp" !== t.wrapS || t.wrapT && "clamp" !== t.wrapT || t.min && "nearest" !== t.min && "linear" !== t.min;
    }
}

class Xr extends Ye {
    constructor(e) {
        e = e || 0, super({
            aPosition: new Float32Array([ -1, -1, e, 1, -1, e, -1, 1, e, 1, 1, e ]),
            aNormal: new Float32Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1 ])
        }, new Uint16Array([ 0, 1, 3, 3, 2, 0 ]));
    }
}

const Kr = {
    vsm_shadow_vert: "\nuniform mat4 shadow_lightProjViewModelMatrix;\nvarying vec4 shadow_vLightSpacePos;\nvoid shadow_computeShadowPars(vec4 position) {\n    shadow_vLightSpacePos = shadow_lightProjViewModelMatrix * position;\n}",
    vsm_shadow_frag: "\nuniform sampler2D shadow_shadowMap;\nuniform float shadow_opacity;\nuniform vec3 shadow_color;\n#if defined(USE_ESM)\n    uniform float esm_shadow_threshold;\n#endif\nvarying vec4 shadow_vLightSpacePos;\n#ifdef PACK_FLOAT\n    #include <common_pack_float>\n#endif\n#if defined(USE_ESM)\nfloat esm(vec3 projCoords, vec4 shadowTexel) {\n    float compare = projCoords.z;\n    float c = 120.0;\n    #ifdef PACK_FLOAT\n        float depth = common_decodeDepth(shadowTexel);\n        if (depth >= 1.0 - 1E-6 || compare <= depth) {\n            return 1.0;\n        }\n    #else\n        float depth = shadowTexel.r;\n    #endif\n    depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, esm_shadow_threshold, 1.0);\n}\n#endif\nfloat shadow_computeShadow_coeff(sampler2D shadowMap, vec3 projCoords) {\n    vec2 uv = projCoords.xy;\n    vec4 shadowTexel = texture2D(shadowMap, uv);\n    #if defined(USE_ESM)\n        float esm_coeff = esm(projCoords, shadowTexel);\n        float coeff = esm_coeff * esm_coeff;\n    #endif\n    return 1.0 - (1.0 - coeff) * shadow_opacity;\n}\nfloat shadow_computeShadow() {\n    vec3 projCoords = shadow_vLightSpacePos.xyz / shadow_vLightSpacePos.w;\n    projCoords = projCoords * 0.5 + 0.5;\n    if(projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) return 1.0;\n    return shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n}\nvec3 shadow_blend(vec3 color, float coeff) {\n    color = color * coeff + shadow_color * shadow_opacity * (1.0 - coeff);\n    return color;\n}",
    fbo_picking_vert: "\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 1\n    attribute float aPickingId;\n#elif HAS_PICKING_ID == 2\n    uniform float uPickingId;\n#endif\n    varying float vPickingId;\n    varying float vFbo_picking_viewZ;\n    varying float vFbo_picking_visible;\n#endif\n    varying float vFbo_picking_fragDepth;\nvoid fbo_picking_setData(float viewPosZ, bool visible) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n        vPickingId = aPickingId;\n    #elif HAS_PICKING_ID == 2\n        vPickingId = uPickingId;\n    #endif\n        vFbo_picking_viewZ = viewPosZ;\n        vFbo_picking_visible = visible ? 1.0 : 0.0;\n    #endif\n    vFbo_picking_fragDepth = viewPosZ + 1.0;\n}",
    common_pack_float: "const float COMMON_FLOAT_MAX =  1.70141184e38;\nconst float COMMON_FLOAT_MIN = 1.17549435e-38;\nvec4 common_unpackFloat(highp float v) {\n    highp float av = abs(v);\n    if(av < COMMON_FLOAT_MIN) {\n        return vec4(0.0, 0.0, 0.0, 0.0);\n    } else if(v > COMMON_FLOAT_MAX) {\n        return vec4(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if(v < -COMMON_FLOAT_MAX) {\n        return vec4(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n    highp vec4 c = vec4(0,0,0,0);\n    highp float e = floor(log2(av));\n    highp float m = av * pow(2.0, -e) - 1.0;\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n    highp float ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n    c[0] += 128.0 * step(0.0, -v);\n    return c / 255.0;\n}\nvec4 common_encodeDepth(const in float depth) {\n    float alpha = 1.0;\n    vec4 pack = vec4(0.0);\n    pack.a = alpha;\n    const vec3 code = vec3(1.0, 255.0, 65025.0);\n    pack.rgb = vec3(code * depth);\n    pack.gb = fract(pack.gb);\n    pack.rg -= pack.gb * (1.0 / 256.0);\n    pack.b -= mod(pack.b, 4.0 / 255.0);\n    return pack;\n}\nfloat common_decodeDepth(const in vec4 pack) {\n    return pack.r + pack.g / 255.0;\n}\nvec4 encodeFloat32(float f) {\n    float e =5.0;\n    float F = abs(f);\n    float Sign = step(0.0,-f);\n    float Exponent = floor(log2(F));\n    float Mantissa = (exp2(- Exponent) * F);\n    Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));\n    vec4 rgba;\n    rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));\n    rgba[1] = 128.0 * mod(Exponent,2.0) + mod(floor(Mantissa*128.0),128.0);\n    rgba[2] = floor(mod(floor(Mantissa*exp2(23.0 -8.0)),exp2(8.0)));\n    rgba[3] = floor(exp2(23.0)*mod(Mantissa,exp2(-15.0)));\n    return rgba / 255.0;\n}\nfloat decodeFloat32(vec4 rgba) {\n    rgba *= 255.0;\n    float Sign = 1.0 - step(128.0,rgba[0])*2.0;\n    float Exponent = 2.0 * mod(rgba[0],128.0) + step(128.0,rgba[1]) - 127.0;\n    float Mantissa = mod(rgba[1],128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + float(0x800000);\n    float Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));\n    return Result;\n}",
    invert_matrix: "mat4 invert_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return inverse(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a00 = vector1.x, a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a10 = vector2.x, a11 = vector2.y, a12 = vector2.z, a13 = vector2.w;\n        float a20 = vector3.x, a21 = vector3.y, a22 = vector3.z, a23 = vector3.w;\n        float a30 = vector4.x, a31 = vector4.y, a32 = vector4.z, a33 = vector4.w;\n        float b00 = a00 * a11 - a01 * a10;\n        float b01 = a00 * a12 - a02 * a10;\n        float b02 = a00 * a13 - a03 * a10;\n        float b03 = a01 * a12 - a02 * a11;\n        float b04 = a01 * a13 - a03 * a11;\n        float b05 = a02 * a13 - a03 * a12;\n        float b06 = a20 * a31 - a21 * a30;\n        float b07 = a20 * a32 - a22 * a30;\n        float b08 = a20 * a33 - a23 * a30;\n        float b09 = a21 * a32 - a22 * a31;\n        float b10 = a21 * a33 - a23 * a31;\n        float b11 = a22 * a33 - a23 * a32;\n        float det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n        det = 1.0 / det;\n        mat4 m = mat4(\n            (a11 * b11 - a12 * b10 + a13 * b09) * det,\n            (a02 * b10 - a01 * b11 - a03 * b09) * det,\n            (a31 * b05 - a32 * b04 + a33 * b03) * det,\n            (a22 * b04 - a21 * b05 - a23 * b03) * det,\n            (a12 * b08 - a10 * b11 - a13 * b07) * det,\n            (a00 * b11 - a02 * b08 + a03 * b07) * det,\n            (a32 * b02 - a30 * b05 - a33 * b01) * det,\n            (a20 * b05 - a22 * b02 + a23 * b01) * det,\n            (a10 * b10 - a11 * b08 + a13 * b06) * det,\n            (a01 * b08 - a00 * b10 - a03 * b06) * det,\n            (a30 * b04 - a31 * b02 + a33 * b00) * det,\n            (a21 * b02 - a20 * b04 - a23 * b00) * det,\n            (a11 * b07 - a10 * b09 - a12 * b06) * det,\n            (a00 * b09 - a01 * b07 + a02 * b06) * det,\n            (a31 * b01 - a30 * b03 - a32 * b00) * det,\n            (a20 * b03 - a21 * b01 + a22 * b00) * det\n        );\n        return m;\n    #endif\n}\nmat4 transpose_matrix(mat4 matrix) {\n    #if __VERSION__ == 300\n        return transpose(matrix);\n    #else\n        vec4 vector1 = matrix[0], vector2 = matrix[1], vector3 = matrix[2], vector4 = matrix[3];\n        float a01 = vector1.y, a02 = vector1.z, a03 = vector1.w;\n        float a12 = vector2.z, a13 = vector2.w;\n        float a23 = vector3.w;\n        mat4 m = mat4(\n            vector1.x,\n            vector2.x,\n            vector3.x,\n            vector4.x,\n            a01,\n            vector2.y,\n            vector3.y,\n            vector4.y,\n            a02,\n            a12,\n            vector3.z,\n            vector4.z,\n            a03,\n            a13,\n            a23,\n            vector4.w\n        );\n        return m;\n    #endif\n}",
    get_output: "#include <invert_matrix>\n#include <draco_decode_vert>\n#ifdef HAS_INSTANCE\n    #include <instance_vert>\n    #ifdef HAS_INSTANCE_COLOR\n        varying vec4 vInstanceColor;\n    #endif\n#endif\n#ifdef HAS_SKIN\n    uniform int skinAnimation;\n    #include <skin_vert>\n#endif\n#include <mask_vert>\n#ifdef HAS_MORPH\n    attribute vec3 POSITION0;\n    attribute vec3 POSITION1;\n    attribute vec3 POSITION2;\n    attribute vec3 POSITION3;\n    attribute vec3 POSITION4;\n    attribute vec3 POSITION5;\n    attribute vec3 POSITION6;\n    attribute vec3 POSITION7;\n    #ifdef HAS_MORPHNORMALS\n        attribute vec3 NORMAL0;\n        attribute vec3 NORMAL1;\n        attribute vec3 NORMAL2;\n        attribute vec3 NORMAL3;\n    #endif\n    uniform vec4 morphWeights1;\n    uniform vec4 morphWeights2;\n#endif\n#ifdef HAS_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\n#endif\nmat4 getPositionMatrix() {\n    mat4 worldMatrix;\n    #ifdef HAS_INSTANCE\n        #ifdef HAS_INSTANCE_COLOR\n            vInstanceColor = instance_getInstanceColor();\n        #endif\n        mat4 attributeMatrix = instance_getAttributeMatrix();\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n            } else {\n                worldMatrix = attributeMatrix * positionMatrix;\n            }\n        #else\n            worldMatrix = attributeMatrix * positionMatrix;\n        #endif\n    #else\n        #ifdef HAS_SKIN\n            if (skinAnimation == 1) {\n                worldMatrix = skin_getSkinMatrix() * positionMatrix;\n            } else {\n                worldMatrix = positionMatrix;\n            }\n        #else\n            worldMatrix = positionMatrix;\n        #endif\n    #endif\n    return worldMatrix;\n}\n#ifdef HAS_MIN_ALTITUDE\n    uniform float minAltitude;\n#endif\n#ifdef HAS_TERRAIN_FLAT_MASK\n    uniform sampler2D flatMask;\n#endif\nvec4 getPosition(vec3 aPosition) {\n    vec3 position = decode_getPosition(aPosition);\n    #ifdef HAS_MORPH\n        vec4 POSITION = vec4(position + morphWeights1[0] * POSITION0 + morphWeights1[1] * POSITION1 + morphWeights1[2] * POSITION2 + morphWeights1[3] * POSITION3\n        + morphWeights2[0] * POSITION4 + morphWeights2[1] * POSITION5 + morphWeights2[2] * POSITION6 + morphWeights2[3] * POSITION7\n        , 1.0);\n    #else\n        vec4 POSITION = vec4(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        POSITION.z += aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_TERRAIN_FLAT_MASK\n        vec2 uv = aTexCoord;\n        uv.y = 1.0 - uv.y;\n        vec4 encodedHeight = texture2D(flatMask, uv);\n        if (length(encodedHeight) < 2.0) {\n            float maskHeight = decodeFloat32(encodedHeight);\n            POSITION.z = min(POSITION.z, maskHeight);\n        }\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        POSITION.z += minAltitude * 100.0;\n    #endif\n    return POSITION;\n}\nvec3 appendMorphNormal(vec3 NORMAL) {\n    #ifdef HAS_MORPHNORMALS\n        vec3 normal = NORMAL + morphWeights1[0] * NORMAL0 + morphWeights1[1] * NORMAL1 + morphWeights1[2] * NORMAL2 + morphWeights1[3] * NORMAL3;\n    #else\n        vec3 normal = NORMAL;\n    #endif\n    return normal;\n}",
    instance_vert: "attribute vec4 instance_vectorA;\nattribute vec4 instance_vectorB;\nattribute vec4 instance_vectorC;\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\nattribute float aTerrainAltitude;\nuniform float terrainAltitudeScale;\n#endif\nmat4 instance_getAttributeMatrix() {\n    mat4 mat =  mat4(\n        instance_vectorA.x, instance_vectorB.x, instance_vectorC.x, 0.0,\n        instance_vectorA.y, instance_vectorB.y, instance_vectorC.y, 0.0,\n        instance_vectorA.z, instance_vectorB.z, instance_vectorC.z, 0.0,\n        instance_vectorA.w, instance_vectorB.w, instance_vectorC.w, 1.0\n    );\n    #ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n        mat4 terrainMat = mat4(\n            1., 0., 0., 0.,\n            0., 1., 0., 0.,\n            0., 0., 1., 0.,\n            0., 0., aTerrainAltitude * terrainAltitudeScale, 1.\n        );\n        mat = terrainMat * mat;\n    #endif\n    return mat;\n}\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    attribute vec4 highlight_color;\n#endif\n#ifdef HAS_INSTANCE_COLOR\n   \n    attribute vec4 instance_color;\n    vec4 instance_getInstanceColor() {\n        vec4 color = instance_color;\n        #ifdef HAS_INSTANCE_HIGHLIGHT\n            color = instance_color * highlight_color;\n        #endif\n        return color;\n    }\n#endif",
    skin_vert: "attribute vec4 WEIGHTS_0;\nattribute vec4 JOINTS_0;\nuniform sampler2D jointTexture;\nuniform vec2 jointTextureSize;\nuniform float numJoints;\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\nmat4 skin_getBoneMatrix(float jointNdx) {\n    float v = (jointNdx + 0.5) / numJoints;\n    return mat4(\n        texture2D(jointTexture, vec2(ROW0_U, v)),\n        texture2D(jointTexture, vec2(ROW1_U, v)),\n        texture2D(jointTexture, vec2(ROW2_U, v)),\n        texture2D(jointTexture, vec2(ROW3_U, v)));\n}\nmat4 skin_getSkinMatrix() {\n        mat4 skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                        skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                        skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                        skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n        return skinMatrix;\n}",
    heatmap_render_vert: "#ifdef HAS_HEATMAP\nvarying vec2 heatmap_vTexCoord;\nvoid heatmap_compute(mat4 matrix, vec3 position) {\n    vec4 pos = matrix * vec4(position.xy, 0., 1.);\n    heatmap_vTexCoord = (1. + pos.xy / pos.w) / 2.;\n}\n#endif",
    heatmap_render_frag: "#ifdef HAS_HEATMAP\nuniform sampler2D heatmap_inputTexture;\nuniform sampler2D heatmap_colorRamp;\nuniform float heatmap_heatmapOpacity;\nvarying vec2 heatmap_vTexCoord;\nvec4 heatmap_getColor(vec4 color) {\n    float t = texture2D(heatmap_inputTexture, heatmap_vTexCoord).r;\n    vec4 heatmapColor = texture2D(heatmap_colorRamp, vec2(t, 0.5)) * heatmap_heatmapOpacity;\n    return color * (1.0 - heatmapColor.a) + heatmapColor * heatmapColor.a;\n}\n#endif",
    line_extrusion_vert: "#ifdef IS_LINE_EXTRUSION\n    #define ALTITUDE_SCALE 32767.0;\n    #define EXTRUDE_SCALE 63.0;\n    attribute vec2 aExtrude;\n    #ifdef HAS_LINE_WIDTH\n        attribute float aLineWidth;\n    #else\n        uniform float lineWidth;\n    #endif\n    #ifdef HAS_LINE_HEIGHT\n        attribute float aLineHeight;\n    #else\n        uniform float lineHeight;\n    #endif\n    uniform float linePixelScale;\n    vec3 getLineExtrudePosition(vec3 position) {\n        #ifdef HAS_LINE_WIDTH\n            float lineWidth = aLineWidth / 2.0;\n        #endif\n        #ifdef HAS_LINE_HEIGHT\n            float lineHeight = aLineHeight / 10.0;\n        #endif\n        float halfwidth = lineWidth / 2.0;\n        float outset = halfwidth;\n        vec2 dist = outset * aExtrude / EXTRUDE_SCALE;\n        position.z *= lineHeight / ALTITUDE_SCALE;\n        return position + vec3(dist, 0.0) * linePixelScale;\n    }\n#endif",
    gl2_vert: "#if __VERSION__ == 300\n    #define texture2D texture\n    #define varying out\n    #define attribute in\n#endif",
    gl2_frag: "#if __VERSION__ == 300\n    #define varying in\n    #define gl_FragDepthEXT gl_FragDepth\n    #define texture2D texture\n    #define textureCube texture\n    #define texture2DProj textureProj\n    #define texture2DLodEXT textureLod\n    #define texture2DProjLodEXT textureProjLod\n    #define textureCubeLodEXT textureLod\n    #define texture2DGradEXT textureGrad\n    #define texture2DProjGradEXT textureProjGrad\n    #define textureCubeGradEXT textureGrad\n    out vec4 glFragColor;\n#else\n    vec4 glFragColor;\n#endif",
    hsv_frag: "\nconst mediump vec4 HSV_K0 = vec4(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst mediump vec4 HSV_K1 = vec4(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst mediump float HSV_E = 1.0e-10;\nvec3 hsv_rgb2hsv(vec3 c) {\n    vec4 K = HSV_K0;\n    vec4 p = mix(vec4(c.bg, K.wz), vec4(c.gb, K.xy), step(c.b, c.g));\n    vec4 q = mix(vec4(p.xyw, c.r), vec4(c.r, p.yzx), step(p.x, c.r));\n    float d = q.x - min(q.w, q.y);\n    float e = HSV_E;\n    return vec3(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\nvec3 hsv_hsv2rgb(vec3 c) {\n    vec4 K = HSV_K1;\n    vec3 p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, 0.0, 1.0), c.y);\n}\nvec4 hsv_apply(vec4 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return vec4(hsv_hsv2rgb(hsv), c.a);\n}\nvec3 hsv_apply(vec3 c, vec3 hsvOffset) {\n    vec3 hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, 0.0, 1.0);\n    return hsv_hsv2rgb(hsv);\n}\nmat4 contrastMatrix(float contrast)\n{\n    float t = (1.0 - contrast) / 2.0;\n    return mat4(\n        contrast, 0., 0., 0.,\n        0., contrast, 0., 0.,\n        0., 0., contrast, 0.,\n        t, t, t, 1\n    );\n}",
    snow_frag: "#ifdef HAS_SNOW\n    float lerp(float a, float b, float w) {\n        return a + w * (b - a);\n    }\n    vec3 snow(vec4 sceneColor, vec3 normalColor, float height) {\n        float snowIntense = normalColor.b;\n        vec3 fixedC = vec3(1.0, 1.0, 1.0);\n        if (height < 1.0) {\n            float r = lerp(0.5, fixedC.x, snowIntense);\n            float g = lerp(0.5, fixedC.y, snowIntense);\n            float b = lerp(0.5, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        } else {\n            float r = lerp(sceneColor.r, fixedC.x, snowIntense);\n            float g = lerp(sceneColor.g, fixedC.y, snowIntense);\n            float b = lerp(sceneColor.b, fixedC.z, snowIntense);\n            return vec3(r, g, b);\n        }\n    }\n#endif",
    draco_decode_vert: "#if defined(HAS_TANGENT)\n    attribute vec4 aTangent;\n#elif defined(HAS_NORMAL)\n    #ifdef HAS_DRACO_NORMAL\n        attribute vec2 aNormal;\n        uniform float gltf_u_dec_normal_rangeConstant;\n    #else\n        attribute vec3 aNormal;\n    #endif\n#endif\n#ifdef HAS_DRACO_POSITION\n    uniform float gltf_u_dec_position_normConstant;\n    uniform vec3 minValues_pos;\n    vec3 decodeDracoPosition(vec3 aPosition) {\n        return minValues_pos + aPosition * gltf_u_dec_position_normConstant;\n    }\n#endif\n#ifdef HAS_DRACO_TEXCOORD\n    uniform vec2 minValues_tex;\n    uniform float gltf_u_dec_texcoord_0_normConstant;\n    vec2 decodeDracoTexcoord(vec2 aTexCoord) {\n        return minValues_tex + aTexCoord * gltf_u_dec_texcoord_0_normConstant;\n    }\n#endif\n#ifdef HAS_WEB3D_quantized_attributes_TEXCOORD\n    uniform mat3 decodeMatrix;\n#endif\n#ifdef HAS_DRACO_NORMAL\n    float czm_signNotZero(float value) {\n        return value >= 0.0 ? 1.0 : -1.0;\n    }\n    vec2 czm_signNotZero(vec2 value) {\n        return vec2(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n    vec3 decodeDracoNormal(vec2 encoded, float range)\n    {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        vec3 v = vec3(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n    vec3 decode_getNormal(vec2 aNormal) {\n        return decodeDracoNormal(aNormal, gltf_u_dec_normal_rangeConstant).zxy;\n    }\n#endif\n#ifdef HAS_COMPRESSED_INT16\n    #ifdef HAS_COMPRESSED_INT16_POSITION\n      uniform vec2 compressedPositionRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_0\n      uniform vec2 compressedTexcoordRange_0;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_TEXCOORD_1\n      uniform vec2 compressedTexcoordRange_1;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n      uniform vec2 compressedNormalRange;\n    #endif\n    #ifdef HAS_COMPRESSED_INT16_RATIO\n      uniform float compressed_ratio;\n    #endif\n    float int16ToFloat32(float value, vec2 range) {\n        float v = (value >= 32768.0) ? -(65536.0 - value) / 32768.0 : value / 32767.0;\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n#endif\nvec3 decode_getPosition(vec3 aPosition) {\n    vec3 position = aPosition;\n    #if defined(HAS_COMPRESSED_INT16) && defined(HAS_COMPRESSED_INT16_POSITION)\n        float x = int16ToFloat32(aPosition.x, compressedPositionRange);\n        float y = int16ToFloat32(aPosition.y, compressedPositionRange);\n        float z = int16ToFloat32(aPosition.z, compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n          position = vec3(x / compressed_ratio, y / compressed_ratio, z);\n        #else\n          position = vec3(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n}\nvec2 decode_getTexcoord(vec2 aTexCoord) {\n    vec2 texcoord = aTexCoord;\n    #if defined(HAS_COMPRESSED_INT16) && (defined(HAS_COMPRESSED_INT16_TEXCOORD_0) || defined(HAS_COMPRESSED_INT16_TEXCOORD_1))\n        float x = int16ToFloat32(aTexCoord.x, compressedTexcoordRange_0);\n        float y = int16ToFloat32(aTexCoord.y, compressedTexcoordRange_0);\n        texcoord = vec2(x, y);\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #elif defined(HAS_WEB3D_quantized_attributes_TEXCOORD)\n        vec3 web3dTexcoord = decodeMatrix * vec3(texcoord, 1.0);\n        return vec2(web3dTexcoord.x, web3dTexcoord.y);\n    #else\n        return texcoord;\n    #endif\n}\nvec3 decode_getNormal(vec3 aNormal) {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, compressedNormalRange);\n    #endif\n    return aNormal;\n}",
    highlight_vert: "#if defined(HAS_HIGHLIGHT_COLOR)\n    attribute vec4 aHighlightColor;\n    varying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    attribute float aHighlightOpacity;\n    varying float vHighlightOpacity;\n#endif\nvoid highlight_setVarying() {\n    #if defined(HAS_HIGHLIGHT_COLOR)\n        vHighlightColor = aHighlightColor / 255.0;\n    #endif\n    #if defined(HAS_HIGHLIGHT_OPACITY)\n        vHighlightOpacity = aHighlightOpacity / 255.0;\n    #endif\n}",
    highlight_frag: "#if defined(HAS_HIGHLIGHT_COLOR)\n\tvarying vec4 vHighlightColor;\n#endif\n#if defined(HAS_HIGHLIGHT_OPACITY)\n    varying float vHighlightOpacity;\n#endif\nvec4 highlight_blendColor(vec4 color) {\n\tvec4 outColor;\n\t#if defined(HAS_HIGHLIGHT_COLOR)\n\t\tcolor.rgb = color.rgb * (1.0 - vHighlightColor.a) + vHighlightColor.rgb * vHighlightColor.a;\n\t\t#ifndef HAS_HIGHLIGHT_COLOR_POINT\n        \tcolor.a = color.a * (1.0 - vHighlightColor.a) + vHighlightColor.a;\n        #endif\n        outColor = color;\n\t#else\n\t\toutColor = color;\n\t#endif\n\t#if defined(HAS_HIGHLIGHT_OPACITY)\n\t\toutColor *= vHighlightOpacity;\n\t#endif\n\treturn outColor;\n}",
    mask_vert: "#ifdef HAS_MASK_EXTENT\n    uniform vec4 mask_extent;\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_maskMode;\n    uniform float mask_hasFlatOut;\n    uniform mat4 viewMatrix;\n    uniform float mask_heightRatio;\n    uniform float mask_heightOffset;\n    varying vec4 vWorldPosition;\n    varying vec2 vUVInExtent;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    const float CLIPINSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float ELEVATE_MODE = 0.7;\n    float random (vec2 st) {\n        return fract(sin(dot(st.xy,vec2(12.9898,78.233)))*43758.5453123) * 0.1;\n    }\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    float getFlatHeight(float maskMode, float flatHeight, float height) {\n      if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n          return flatHeight + height;\n      } else {\n        return flatHeight;\n      }\n    }\n    vec4 getNoErrorPosition(vec4 position, vec4 wPosition) {\n      vec4 realPos = modelViewMatrix * position;      vec4 pos = viewMatrix * wPosition;      vec4 tempPos = viewMatrix * modelMatrix * position;      float deltaX = realPos.x - tempPos.x;\n      float deltaY = realPos.y - tempPos.y;\n      float deltaZ = realPos.z - tempPos.z;\n      pos.x = pos.x + deltaX;\n      pos.y = pos.y + deltaY;\n      pos.z = pos.z + deltaZ;\n      return pos;\n    }\n    vec4 getMaskPosition(vec4 position, mat4 modelMatrix) {\n        vWorldPosition = modelMatrix * position;\n        float w = mask_extent.z - mask_extent.x;\n        float h = mask_extent.y - mask_extent.w;\n        vec2 uvInExtent = vec2((vWorldPosition.x - mask_extent.x) / abs(w), 1.0 - (vWorldPosition.y - mask_extent.w) / h);\n        vec4 extentColor = texture2D(mask_colorExtent, uvInExtent);\n        vec3 maskOptionColor = texture2D(mask_modeExtent, uvInExtent).rgb;\n        float maskMode = maskOptionColor.r;\n        float flatHeight = maskOptionColor.g / mask_heightRatio + mask_heightOffset;\n        float height = getFlatHeight(maskMode, flatHeight, vWorldPosition.z);\n        vec4 wPosition = vec4(vWorldPosition.x, vWorldPosition.y, height, vWorldPosition.w);\n        vUVInExtent = uvInExtent;\n        vHeightRatio = mask_heightRatio;\n        vHeightOffset = mask_heightOffset;\n        if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n            return modelViewMatrix * position;;\n        } else if (mask_hasFlatOut == 1.0) {\n            return getNoErrorPosition(position, wPosition);\n        }\n        if (isInExtent(extentColor) == true && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n            return getNoErrorPosition(position, wPosition);\n        } if (isInExtent(extentColor) == true && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n            return getNoErrorPosition(position, wPosition);\n        } else {\n            return modelViewMatrix * position;\n        }\n    }\n#endif",
    mask_frag: "#ifdef HAS_MASK_EXTENT\n    uniform sampler2D mask_colorExtent;\n    uniform sampler2D mask_modeExtent;\n    uniform float mask_hasClipOut;\n    varying float vHeightRatio;\n    varying float vHeightOffset;\n    varying vec2 vUVInExtent;\n    varying vec4 vWorldPosition;\n    const float CLIPINSIDE_MODE = 0.1;\n    const float CLIPOUTSIDE_MODE = 0.2;\n    const float FLATINSIDE_MODE = 0.3;\n    const float FLATOUTSIDE_MODE = 0.4;\n    const float COLOR_MODE = 0.5;\n    const float VIDEO_MODE = 0.6;\n    bool isInExtent(vec4 color) {\n        return length(color.rgb) > 0.0;\n    }\n    vec4 setMask(vec4 glFragColor) {\n        vec4 extentColor = texture2D(mask_colorExtent, vUVInExtent);\n        vec4 modeColor = texture2D(mask_modeExtent, vUVInExtent);\n        float maskMode = modeColor.r;\n        float minHeight = modeColor.b / vHeightRatio + vHeightOffset;\n        float maxHeight = modeColor.a / vHeightRatio + vHeightOffset;\n        if (maskMode > CLIPINSIDE_MODE && maskMode <= CLIPOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                return glFragColor;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                return glFragColor;\n            } else {\n              discard;\n            }\n        } else if (mask_hasClipOut == 1.0) {\n            discard;\n        }\n        if (isInExtent(extentColor) == true && maskMode <= CLIPINSIDE_MODE && maskMode > 0.0) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                discard;\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                discard;\n            } else {\n              return glFragColor;\n            }\n        } else if (isInExtent(extentColor) == true && maskMode <= VIDEO_MODE && maskMode > FLATOUTSIDE_MODE) {\n            if (minHeight == 0.0 && maxHeight == 0.0) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            } else if (vWorldPosition.z >= minHeight && vWorldPosition.z <= maxHeight) {\n                glFragColor = vec4(mix(extentColor.rgb, glFragColor.rgb, 1.0 - extentColor.a), glFragColor.a);\n            }\n        }\n        return glFragColor;\n    }\n#endif",
    compute_texcoord_frag: "#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    uniform vec2 khr_offset;\n    uniform float khr_rotation;\n    uniform vec2 khr_scale;\n    vec2 khr_tex_transformTexCoord(vec2 texCoords, vec2 offset, float rotation, vec2 scale) {\n        rotation = -rotation;\n        mat3 transform = mat3(\n        cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0, -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0, offset.x, offset.y, 1.0);\n        vec2 transformedTexCoords = (transform * vec3(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\nvarying highp vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\n    varying vec4 vUvRegion;\n#endif\nvec2 computeTexCoord(vec2 texCoord) {\n    #ifdef HAS_I3S_UVREGION\n        vec2 atlasScale = vUvRegion.zw - vUvRegion.xy;\n        vec2 uvAtlas = fract(texCoord) * atlasScale + vUvRegion.xy;\n        return uvAtlas;\n    #elif defined(HAS_KHR_TEXTURE_TRANSFORM)\n        return khr_tex_transformTexCoord(texCoord, khr_offset, khr_rotation, khr_scale);\n    #else\n        return texCoord;\n    #endif\n}",
    terrain_normal_frag: "#ifdef HAS_TERRAIN_NORMAL\n    uniform sampler2D terrainHeightTexture;\n    uniform vec2 terrainHeightMapResolution;\n    uniform vec2 terrainResolution;\n    uniform vec4 terrainUnpackFactors;\n    float getHeight(vec2 uv) {\n        vec4 color = texture2D(terrainHeightTexture, uv) * 255.0;\n        color.a = -1.0;\n        return dot(color, terrainUnpackFactors) / 4.0;\n    }\n    vec3 convertTerrainHeightToNormalMap(vec2 uv) {\n        uv.y = 1.0 - uv.y;\n        vec2 epsilon = 1.0 / terrainHeightMapResolution;\n        float a = getHeight(uv + vec2(-epsilon.x, -epsilon.y));\n        float b = getHeight(uv + vec2(0, -epsilon.y));\n        float c = getHeight(uv + vec2(epsilon.x, -epsilon.y));\n        float d = getHeight(uv + vec2(-epsilon.x, 0));\n        float e = getHeight(uv + vec2(epsilon.x, 0));\n        float f = getHeight(uv + vec2(-epsilon.x, epsilon.y));\n        float g = getHeight(uv + vec2(0, epsilon.y));\n        float h = getHeight(uv + vec2(epsilon.x, epsilon.y));\n        vec2 dxy = vec2(\n            (c + e + e + h) - (a + d + d + f),\n            (f + g + g + h) - (a + b + b + c)\n        );\n        return normalize(vec3(dxy / epsilon, terrainResolution ));\n    }\n#endif",
    vertex_color_vert: "#ifdef HAS_VERTEX_COLOR\nattribute float aVertexColorType;\nuniform vec4 vertexColorsOfType[VERTEX_TYPES_COUNT];\nvarying vec4 vertexColor_color;\nvoid vertexColor_update() {\n    vertexColor_color = vertexColorsOfType[int(aVertexColorType)];\n}\n#endif\n//用于识别顶点颜色类型: topPolygonFill 还是 bottomPolygonFill",
    vertex_color_frag: "#ifdef HAS_VERTEX_COLOR\nvarying vec4 vertexColor_color;\nvec4 vertexColor_get() {\n\treturn vertexColor_color;\n}\n#endif",
    excavate_vert: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform vec4 excavateExtent;\n  varying vec2 vCoordinateTexcoord;\n  varying float vExcavateHeight;\n  float getWorldHeight(vec4 localPosition) {\n    vec4 wPosition = modelMatrix * localPosition;\n    return wPosition.z;\n  }\n  vec2 getCoordinateTexcoord(vec4 localPosition) {\n    vec4 wPosition = modelMatrix * localPosition;\n    float x = (wPosition.x - excavateExtent.x) / (excavateExtent.z - excavateExtent.x);\n    float y = (wPosition.y - excavateExtent.y) / (excavateExtent.w - excavateExtent.y);\n    return vec2(x, y);\n  }\n#endif",
    excavate_frag: "#ifdef HAS_EXCAVATE_ANALYSIS\n  uniform sampler2D heightmap;\n  uniform float excavateHeight;\n  varying vec2 vCoordinateTexcoord;\n  varying float vExcavateHeight;\n  const vec2 range = vec2(-100.0, 1000.0);\n  float decodeHeight(const in vec4 pack) {\n      return pack.r + pack.g / 255.0;\n  }\n  vec4 excavateColor(vec4 fragColor) {\n      float samplerHeight = decodeHeight(texture2D(heightmap, vCoordinateTexcoord));\n      float realHeight = samplerHeight * (range.y - range.x) + range.x;\n      if(realHeight < range.x || realHeight > range.y) {\n          realHeight = 0.0;\n      }\n      if(vExcavateHeight > realHeight) {\n          discard;\n      }\n      return fragColor;\n  }\n#endif",
    srgb_frag: "vec3 linearTosRGB(const in vec3 color) {\n    return vec3(\n        color.r < 0.0031308 ? color.r * 12.92 : 1.055 * pow(color.r, 1.0/2.4) - 0.055,\n        color.g < 0.0031308 ? color.g * 12.92 : 1.055 * pow(color.g, 1.0/2.4) - 0.055,\n        color.b < 0.0031308 ? color.b * 12.92 : 1.055 * pow(color.b, 1.0/2.4) - 0.055\n    );\n}\nvec3 sRGBToLinear(const in vec3 color) {\n    return vec3(\n        color.r < 0.04045 ? color.r * (1.0 / 12.92) : pow((color.r + 0.055) * (1.0 / 1.055), 2.4),\n        color.g < 0.04045 ? color.g * (1.0 / 12.92) : pow((color.g + 0.055) * (1.0 / 1.055), 2.4),\n        color.b < 0.04045 ? color.b * (1.0 / 12.92) : pow((color.b + 0.055) * (1.0 / 1.055), 2.4)\n    );\n}",
    mesh_picking_vert: "attribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <fbo_picking_vert>\n#include <get_output>\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    vec4 localPosition = getPosition(aPosition);\n    gl_Position = projViewModelMatrix * localPositionMatrix * localPosition;\n    fbo_picking_setData(gl_Position.w, true);\n}",
    rgbm_frag: "vec4 encodeRGBM(const in vec3 color, const in float range) {\n    if(range <= 0.0) return vec4(color, 1.0);\n    vec4 rgbm;\n    vec3 col = color / range;\n    rgbm.a = clamp( max( max( col.r, col.g ), max( col.b, 1e-6 ) ), 0.0, 1.0 );\n    rgbm.a = ceil( rgbm.a * 255.0 ) / 255.0;\n    rgbm.rgb = col / rgbm.a;\n    return rgbm;\n}\nvec3 decodeRGBM(const in vec4 color, const in float range) {\n    if(range <= 0.0) return color.rgb;\n    return range * color.rgb * color.a;\n}"
};

var Zr = {
    register(e, t) {
        if (Kr[e]) throw new Error(`Key of ${e} is already registered in ShaderLib.`);
        Kr[e] = t;
    },
    compile: e => $r(e),
    get: e => Kr[e]
};

const Yr = /^[ \t]*#include +<([\w\d.]+)>/gm;

function $r(e) {
    return e.replace(Yr, Jr);
}

function Jr(e, t) {
    const n = Kr[t];
    if (!n) throw new Error("Can not resolve #include <" + t + ">");
    return $r(n);
}

const Qr = "\n// 矩阵求逆函数\nfn invert_matrix(matrix: mat4x4f) -> mat4x4f {\n    let vector1 = matrix[0];\n    let vector2 = matrix[1];\n    let vector3 = matrix[2];\n    let vector4 = matrix[3];\n\n    let a00 = vector1.x;\n    let a01 = vector1.y;\n    let a02 = vector1.z;\n    let a03 = vector1.w;\n\n    let a10 = vector2.x;\n    let a11 = vector2.y;\n    let a12 = vector2.z;\n    let a13 = vector2.w;\n\n    let a20 = vector3.x;\n    let a21 = vector3.y;\n    let a22 = vector3.z;\n    let a23 = vector3.w;\n\n    let a30 = vector4.x;\n    let a31 = vector4.y;\n    let a32 = vector4.z;\n    let a33 = vector4.w;\n\n    let b00 = a00 * a11 - a01 * a10;\n    let b01 = a00 * a12 - a02 * a10;\n    let b02 = a00 * a13 - a03 * a10;\n    let b03 = a01 * a12 - a02 * a11;\n    let b04 = a01 * a13 - a03 * a11;\n    let b05 = a02 * a13 - a03 * a12;\n    let b06 = a20 * a31 - a21 * a30;\n    let b07 = a20 * a32 - a22 * a30;\n    let b08 = a20 * a33 - a23 * a30;\n    let b09 = a21 * a32 - a22 * a31;\n    let b10 = a21 * a33 - a23 * a31;\n    let b11 = a22 * a33 - a23 * a32;\n\n    // 计算行列式\n    var det = b00 * b11 - b01 * b10 + b02 * b09 + b03 * b08 - b04 * b07 + b05 * b06;\n    det = 1.0 / det;\n\n    let m = mat4x4f(\n        (a11 * b11 - a12 * b10 + a13 * b09) * det,\n        (a02 * b10 - a01 * b11 - a03 * b09) * det,\n        (a31 * b05 - a32 * b04 + a33 * b03) * det,\n        (a22 * b04 - a21 * b05 - a23 * b03) * det,\n        (a12 * b08 - a10 * b11 - a13 * b07) * det,\n        (a00 * b11 - a02 * b08 + a03 * b07) * det,\n        (a32 * b02 - a30 * b05 - a33 * b01) * det,\n        (a20 * b05 - a22 * b02 + a23 * b01) * det,\n        (a10 * b10 - a11 * b08 + a13 * b06) * det,\n        (a01 * b08 - a00 * b10 - a03 * b06) * det,\n        (a30 * b04 - a31 * b02 + a33 * b00) * det,\n        (a21 * b02 - a20 * b04 - a23 * b00) * det,\n        (a11 * b07 - a10 * b09 - a12 * b06) * det,\n        (a00 * b09 - a01 * b07 + a02 * b06) * det,\n        (a31 * b01 - a30 * b03 - a32 * b00) * det,\n        (a20 * b03 - a21 * b01 + a22 * b00) * det\n    );\n\n    return m;\n}\n\n// 矩阵转置函数\nfn transpose_matrix(matrix: mat4x4f) -> mat4x4f {\n    let vector1 = matrix[0];\n    let vector2 = matrix[1];\n    let vector3 = matrix[2];\n    let vector4 = matrix[3];\n\n    let a01 = vector1.y;\n    let a02 = vector1.z;\n    let a03 = vector1.w;\n\n    let a12 = vector2.z;\n    let a13 = vector2.w;\n\n    let a23 = vector3.w;\n\n    let m = mat4x4f(\n        vector1.x,\n        vector2.x,\n        vector3.x,\n        vector4.x,\n        a01,\n        vector2.y,\n        vector3.y,\n        vector4.y,\n        a02,\n        a12,\n        vector3.z,\n        vector4.z,\n        a03,\n        a13,\n        a23,\n        vector4.w\n    );\n\n    return m;\n}\n";

const ei = "\nconst COMMON_FLOAT_MAX: f32 = 1.70141184e38;\nconst COMMON_FLOAT_MIN: f32 = 1.17549435e-38;\n\nfn common_packFloat(val: vec4f) -> f32 {\n    let scl = floor(255.0 * val + 0.5);\n    let sgn = select(-1.0, 1.0, scl.a < 128.0);\n    let exn = (scl.a * 2.0 % 256.0) + floor(scl.b / 128.0) - 127.0;\n    let man = 1.0 +\n        (scl.r / 8388608.0) +\n        (scl.g / 32768.0) +\n        (scl.b % 128.0) / 128.0;\n    return sgn * man * pow(2.0, exn);\n}\n\nfn common_unpackFloat(v: f32) -> vec4f {\n    let av = abs(v);\n\n    // Handle special cases\n    if (av < COMMON_FLOAT_MIN) {\n        return vec4f(0.0, 0.0, 0.0, 0.0);\n    } else if (v > COMMON_FLOAT_MAX) {\n        return vec4f(127.0, 128.0, 0.0, 0.0) / 255.0;\n    } else if (v < -COMMON_FLOAT_MAX) {\n        return vec4f(255.0, 128.0, 0.0, 0.0) / 255.0;\n    }\n\n    var c = vec4f(0.0, 0.0, 0.0, 0.0);\n\n    // Compute exponent and mantissa\n    let e = floor(log2(av));\n    var m = av * pow(2.0, -e) - 1.0;\n\n    // Unpack mantissa\n    c[1] = floor(128.0 * m);\n    m -= c[1] / 128.0;\n    c[2] = floor(32768.0 * m);\n    m -= c[2] / 32768.0;\n    c[3] = floor(8388608.0 * m);\n\n    // Unpack exponent\n    var ebias = e + 127.0;\n    c[0] = floor(ebias / 2.0);\n    ebias -= c[0] * 2.0;\n    c[1] += floor(ebias) * 128.0;\n\n    // Unpack sign bit\n    c[0] += 128.0 * step(0.0, -v);\n\n    // Scale back to range\n    return c / 255.0;\n}\n\nfn common_encodeDepth(depth: f32) -> vec4f {\n    let alpha = 1.0;\n    var pack = vec4f(0.0);\n    pack.a = alpha;\n    const code = vec3f(1.0, 255.0, 65025.0);\n    pack = vec4f(vec3f(code * depth), pack.a);\n    pack = vec4f(pack.r, fract(pack.gb), pack.a);\n    pack.r -= pack.g * (1.0 / 256.0);\n    pack.g -= pack.b * (1.0 / 256.0);\n    pack.b -= (pack.b % (4.0 / 255.0));\n    return pack;\n}\n\nfn common_decodeDepth(pack: vec4f) -> f32 {\n    return pack.r + pack.g / 255.0;\n}\n\n// https://cloud.tencent.com/developer/ask/sof/103481834\nfn encodeFloat32(f: f32) -> vec4f {\n    var e = 5.0;\n\n    var F = abs(f);\n    var Sign = step(0.0, -f);\n    var Exponent = floor(log2(F));\n    var Mantissa = (exp2(- Exponent) * F);\n    Exponent = floor(log2(F) + 127.0) + floor(log2(Mantissa));\n    var rgba = vec4(0.0);\n    rgba[0] = 128.0 * Sign  + floor(Exponent*exp2(-1.0));\n    rgba[1] = 128.0 * (Exponent % 2.0) + (floor(Mantissa*128.0) % 128.0);\n    rgba[2] = floor((floor(Mantissa*exp2(23.0 -8.0)) % exp2(8.0)));\n    rgba[3] = floor(exp2(23.0)*(Mantissa % exp2(-15.0)));\n    return rgba / 255.0;\n}\n\nfn decodeFloat32(inputRgba: vec4f) -> f32 {\n    var rgba = inputRgba * 255.0;\n    var Sign = 1.0 - step(128.0,rgba[0])*2.0;\n    var Exponent = 2.0 * (rgba[0] % 128.0) + step(128.0,rgba[1]) - 127.0;\n    var Mantissa = (rgba[1] % 128.0)*65536.0 + rgba[2]*256.0 +rgba[3] + 0x800000;\n    var Result =  Sign * exp2(Exponent) * (Mantissa * exp2(-23.0 ));\n    return Result;\n}\n";

const ti = {
    instance: {
        vert: "\n@group(0) @binding($b) var<uniform> terrainAltitudeScale: f32;\n\n// 获取实例属性矩阵函数\nfn instance_getAttributeMatrix(\n    input: VertexInput\n) -> mat4x4f {\n    let vectorA = input.instance_vectorA;\n    let vectorB = input.instance_vectorB;\n    let vectorC = input.instance_vectorC;\n    var mat = mat4x4f(\n        vectorA.x, vectorB.x, vectorC.x, 0.0,\n        vectorA.y, vectorB.y, vectorC.y, 0.0,\n        vectorA.z, vectorB.z, vectorC.z, 0.0,\n        vectorA.w, vectorB.w, vectorC.w, 1.0\n    );\n\n#ifdef HAS_INSTANCE_TERRAIN_ALTITUDE\n    var terrainMat = mat4x4f(\n        1.0, 0.0, 0.0, 0.0,\n        0.0, 1.0, 0.0, 0.0,\n        0.0, 0.0, 1.0, 0.0,\n        0.0, 0.0, aTerrainAltitude * terrainAltitudeScale, 1.0\n    );\n    mat = terrainMat * mat;\n#endif\n\n    return mat;\n}\n\n#ifdef HAS_INSTANCE_COLOR\n// 获取实例颜色函数\nfn instance_getInstanceColor(instance_color: vec4f) -> vec4f {\n    var color = instance_color;\n#ifdef HAS_INSTANCE_HIGHLIGHT\n    color = instance_color * highlight_color;\n#endif\n    return color;\n}\n#endif\n",
        attributes: [ {
            name: "instance_vectorA",
            type: "vec4f"
        }, {
            name: "instance_vectorB",
            type: "vec4f"
        }, {
            name: "instance_vectorC",
            type: "vec4f"
        }, {
            defines: [ "HAS_INSTANCE_TERRAIN_ALTITUDE" ],
            name: "aTerrainAltitude",
            type: "f32"
        }, {
            defines: [ "HAS_INSTANCE_HIGHLIGHT" ],
            name: "highlight_color",
            type: "vec4f"
        }, {
            defines: [ "HAS_INSTANCE_COLOR" ],
            name: "instance_color",
            type: "vec4f"
        } ],
        defines: [ "HAS_INSTANCE" ]
    },
    invert_matrix: {
        vert: Qr,
        frag: Qr
    },
    line_extrusion: {
        vert: "\n    #define ALTITUDE_SCALE 32767.0\n    #define EXTRUDE_SCALE 63.0\n\n    struct LineExtrusionVertex {\n        linePixelScale: f32,\n        #if HAS_LINE_WIDTH\n        #else\n            lineWidth: f32,\n        #endif\n        #if HAS_LINE_HEIGHT\n        #else\n            lineHeight: f32,\n        #endif\n    }\n\n    @group(0) @binding($b) var<uniform> lineExtrusionVertex : LineExtrusionVertex;\n\n    fn getLineExtrudePosition(position: vec3f, input: VertexInput) -> vec3f {\n        let uniforms = lineExtrusionVertex;\n        #if HAS_LINE_WIDTH\n            let lineWidth = f32(input.aLineWidth) / 2.0;\n        #else\n            let lineWidth = uniforms.lineWidth;\n        #endif\n        #if HAS_LINE_HEIGHT\n            // aLineHeight单位是分米\n            let lineHeight = f32(input.aLineHeight) / 10.0;\n        #else\n            let lineHeight = uniforms.lineHeight;\n        #endif\n\n        let halfwidth = lineWidth / 2.0;\n        let outset = halfwidth;\n        let dist = outset * vec2f(input.aExtrude.xy) / EXTRUDE_SCALE;\n        let z_scaled = position.z * (lineHeight / ALTITUDE_SCALE);\n        return position + vec3f(dist, 0.0) * uniforms.linePixelScale;\n    }\n",
        attributes: [ {
            name: "aExtrude",
            type: "vec2i"
        }, {
            defines: [ "HAS_LINE_WIDTH" ],
            name: "aLineWidth",
            type: "u32"
        }, {
            defines: [ "HAS_LINE_HEIGHT" ],
            name: "aLineHeight",
            type: "f32"
        } ],
        defines: [ "IS_LINE_EXTRUSION" ]
    },
    mask: {
        defines: [ "HAS_MASK_EXTENT" ],
        vert: "\n#ifdef HAS_MASK_EXTENT\nstruct MaskUniforms {\n    mask_extent: vec4f,\n    mask_maskMode: f32,\n    mask_hasFlatOut: f32,\n    viewMatrix: mat4x4f,\n    mask_heightRatio: f32,\n    mask_heightOffset: f32,\n};\n\n@group(0) @binding($b) var<uniform> maskUniforms: MaskUniforms;\n@group(0) @binding($b) var mask_colorExtentSampler: sampler;\n@group(0) @binding($b) var mask_colorExtent: texture_2d<f32>;\n@group(0) @binding($b) var mask_modeExtentSampler: sampler;\n@group(0) @binding($b) var mask_modeExtent: texture_2d<f32>;\n\nconst CLIPINSIDE_MODE: f32 = 0.2;\nconst FLATINSIDE_MODE: f32 = 0.3;\nconst FLATOUTSIDE_MODE: f32 = 0.4;\nconst ELEVATE_MODE: f32 = 0.7;\n\nfn random(st: vec2f) -> f32 {\n    return fract(sin(dot(st, vec2f(12.9898, 78.233))) * 43758.5453123) * 0.1;\n}\n\nfn isInExtent(color: vec4f) -> bool {\n    return length(color.rgb) > 0.0;\n}\n\nfn getFlatHeight(maskMode: f32, flatHeight: f32, height: f32) -> f32 {\n    if (maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n        return flatHeight + height;\n    } else {\n        return flatHeight;\n    }\n}\n\nfn getNoErrorPosition(position: vec4f, wPosition: vec4f) -> vec4f {\n    let realPos = uniforms.modelViewMatrix * position; // 未压平，采用 vm 矩阵的坐标\n    let pos = maskUniforms.viewMatrix * wPosition; // 压平的坐标\n    let tempPos = maskUniforms.viewMatrix * uniforms.modelMatrix * position; // 未压平而采用 v*m 矩阵的坐标\n    let deltaX = realPos.x - tempPos.x;\n    let deltaY = realPos.y - tempPos.y;\n    let deltaZ = realPos.z - tempPos.z;\n    pos.x = pos.x + deltaX;\n    pos.y = pos.y + deltaY;\n    pos.z = pos.z + deltaZ;\n    return pos;\n}\n\nfn getMaskPosition(position: vec4f, modelMatrix: mat4x4f, vertexOutput: VertexOutput) -> vec4f {\n    vertexOutput.vWorldPosition = modelMatrix * position;\n    let w = maskUniforms.mask_extent.z - maskUniforms.mask_extent.x;\n    let h = maskUniforms.mask_extent.y - maskUniforms.mask_extent.w;\n    let uvInExtent = vec2f((vertexOutput.vWorldPosition.x - maskUniforms.mask_extent.x) / abs(w), 1.0 - (vertexOutput.vWorldPosition.y - maskUniforms.mask_extent.w) / h);\n    let extentColor = textureSample(mask_colorExtent, mask_colorExtentSampler, uvInExtent);\n    let maskOptionColor = textureSample(mask_modeExtent, mask_modeExtentSampler, uvInExtent).rgb;\n    let maskMode = maskOptionColor.r;\n    let flatHeight = maskOptionColor.g / maskUniforms.mask_heightRatio + maskUniforms.mask_heightOffset;\n    let height = getFlatHeight(maskMode, flatHeight, vertexOutput.vWorldPosition.z);\n    let wPosition = vec4f(vertexOutput.vWorldPosition.x, vertexOutput.vWorldPosition.y, height, vertexOutput.vWorldPosition.w);\n    vertexOutput.vUVInExtent = uvInExtent;\n    vertexOutput.vHeightRatio = maskUniforms.mask_heightRatio;\n    vertexOutput.vHeightOffset = maskUniforms.mask_heightOffset;\n    if (maskMode <= FLATOUTSIDE_MODE && maskMode > FLATINSIDE_MODE) {\n        return uniforms.modelViewMatrix * position;\n    } else if (maskUniforms.mask_hasFlatOut == 1.0) {\n        return getNoErrorPosition(position, wPosition);\n    }\n    if (isInExtent(extentColor) && maskMode <= FLATINSIDE_MODE && maskMode > CLIPINSIDE_MODE) {\n        return getNoErrorPosition(position, wPosition);\n    }\n    if (isInExtent(extentColor) && maskMode <= ELEVATE_MODE && maskMode > 0.6) {\n        return getNoErrorPosition(position, wPosition);\n    } else {\n        return uniforms.modelViewMatrix * position;\n    }\n}\n#endif\n",
        varyings: [ {
            name: "vWorldPosition",
            type: "vec4f"
        }, {
            name: "vUVInExtent",
            type: "vec2f"
        }, {
            name: "vHeightRatio",
            type: "f32"
        }, {
            name: "vHeightOffset",
            type: "f32"
        } ]
    },
    get_output: {
        attributes: [ {
            defines: [ "HAS_MORPH" ],
            name: "POSITION0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION1",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION2",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION3",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION4",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION5",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION6",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH" ],
            name: "POSITION7",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL0",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL1",
            type: "vec3f"
        }, {
            defines: [ "HAS_MORPH", "HAS_MORPHNORMALS" ],
            name: "NORMAL2",
            type: "vec3f"
        }, {
            defines: [ "HAS_TERRAIN_ALTITUDE" ],
            name: "aTerrainAltitude",
            type: "f32"
        } ],
        varyings: [ {
            defines: [ "HAS_INSTANCE_COLOR", "HAS_INSTANCE" ],
            name: "vInstanceColor",
            type: "vec4f"
        } ],
        vert: "\n#include <invert_matrix>\n#include <draco_decode_vert>\n\n\n#include <instance_vert>\n\n\n#ifdef HAS_SKIN\n    struct SkinUniforms {\n        skinAnimation: i32,\n    };\n    @group(0) @binding($b) var<uniform> skinUniforms: SkinUniforms;\n    #include <skin_vert>\n#endif\n\n#include <mask_vert>\n\n#ifdef HAS_MORPH\n    struct MorphUniforms {\n        morphWeights1: vec4f,\n        morphWeights2: vec4f,\n    };\n    @group(0) @binding($b) var<uniform> morphUniforms: MorphUniforms;\n#endif\n\n#ifdef HAS_MIN_ALTITUDE\n    struct AltitudeUniforms {\n        minAltitude: f32,\n    };\n    @group(0) @binding($b) var<uniform> altitudeUniforms: AltitudeUniforms;\n#endif\n\n#ifdef HAS_TERRAIN_FLAT_MASK\n    @group(0) @binding($b) var flatMask: texture_2d<f32>;\n    @group(0) @binding($b) var flatMaskSampler: sampler;\n#endif\n\nfn getPositionMatrix(input: VertexInput, vertexOutput: ptr<function, VertexOutput>, positionMatrix: mat4x4f) -> mat4x4f {\n    var worldMatrix: mat4x4f;\n#ifdef HAS_INSTANCE\n    let attributeMatrix = instance_getAttributeMatrix(input);\n    #ifdef HAS_INSTANCE_COLOR\n        vertexOutput.vInstanceColor = instance_getInstanceColor();\n    #endif\n    #ifdef HAS_SKIN\n        if (skinUniforms.skinAnimation == 1) {\n            worldMatrix = attributeMatrix * positionMatrix * skin_getSkinMatrix();\n        } else {\n            worldMatrix = attributeMatrix * positionMatrix;\n        }\n    #else\n        worldMatrix = attributeMatrix * positionMatrix;\n    #endif\n#else\n    #ifdef HAS_SKIN\n        if (skinUniforms.skinAnimation == 1) {\n            worldMatrix = skin_getSkinMatrix() * positionMatrix;\n        } else {\n            worldMatrix = positionMatrix;\n        }\n    #else\n        worldMatrix = positionMatrix;\n    #endif\n#endif\n    return worldMatrix;\n}\n\nfn getPosition(inputPosition: vec3f, vertexInput: VertexInput) -> vec4f {\n    var position = decode_getPosition(inputPosition);\n    #ifdef HAS_MORPH\n        let outputPosition = vec4f(position +\n            morphUniforms.morphWeights1[0] * vertexInput.POSITION0 +\n            morphUniforms.morphWeights1[1] * vertexInput.POSITION1 +\n            morphUniforms.morphWeights1[2] * vertexInput.POSITION2 +\n            morphUniforms.morphWeights1[3] * vertexInput.POSITION3 +\n            morphUniforms.morphWeights2[0] * vertexInput.POSITION4 +\n            morphUniforms.morphWeights2[1] * vertexInput.POSITION5 +\n            morphUniforms.morphWeights2[2] * vertexInput.POSITION6 +\n            morphUniforms.morphWeights2[3] * vertexInput.POSITION7, 1.0);\n    #else\n        var outputPosition = vec4f(position, 1.0);\n    #endif\n    #ifdef HAS_TERRAIN_ALTITUDE\n        outputPosition.z += vertexInput.aTerrainAltitude * 100.0;\n    #endif\n    #ifdef HAS_TERRAIN_FLAT_MASK\n        var uv = aTexCoord;\n        uv.y = 1.0 - uv.y;\n        let encodedHeight = textureSample(flatMask, flatMaskSampler, uv);\n        if (length(encodedHeight) < 2.0) {\n            let maskHeight = decodeFloat32(encodedHeight);\n            outputPosition.z = min(outputPosition.z, maskHeight);\n        }\n    #endif\n    #ifdef HAS_MIN_ALTITUDE\n        outputPosition.z += altitudeUniforms.minAltitude * 100.0;\n    #endif\n    return outputPosition;\n}\n\nfn appendMorphNormal(inputNormal: vec3f, vertexInput: VertexInput) -> vec3f {\n    #ifdef HAS_MORPHNORMALS\n        let normal = inputNormal +\n            morphUniforms.morphWeights1[0] * vertexInput.NORMAL0 +\n            morphUniforms.morphWeights1[1] * vertexInput.NORMAL1 +\n            morphUniforms.morphWeights1[2] * vertexInput.NORMAL2 +\n            morphUniforms.morphWeights1[3] * vertexInput.NORMAL3;\n    #else\n        let normal = inputNormal;\n    #endif\n    return normal;\n}\n"
    },
    skin: {
        vert: "\n// 定义 uniform 变量\nstruct JoinUniforms {\n    numJoints: f32,                     // 关节数量\n};\n\n@group(0) @binding($b) var<uniform> joinUniforms: JoinUniforms;\n\n// 定义采样器\n@group(0) @binding($b) var jointTextureSampler: sampler;\n@group(0) @binding($b) var jointTexture: texture_2df,      // 关节纹理\n\n// 定义采样点坐标\n#define ROW0_U ((0.5 + 0.0) / 4.)\n#define ROW1_U ((0.5 + 1.0) / 4.)\n#define ROW2_U ((0.5 + 2.0) / 4.)\n#define ROW3_U ((0.5 + 3.0) / 4.)\n\n// 获取骨骼矩阵函数\nfn skin_getBoneMatrix(jointNdx: f32) -> mat4x4f {\n    let v = (jointNdx + 0.5) / joinUniforms.numJoints;\n    return mat4x4f(\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW0_U, v)),\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW1_U, v)),\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW2_U, v)),\n        textureSample(jointTexture, jointTextureSampler, vec2f(ROW3_U, v))\n    );\n}\n\n// 获取皮肤矩阵函数\nfn skin_getSkinMatrix(JOINTS_0: vec4f, WEIGHTS_0: vec4f) -> mat4x4f {\n    var skinMatrix = skin_getBoneMatrix(JOINTS_0[0]) * WEIGHTS_0[0] +\n                     skin_getBoneMatrix(JOINTS_0[1]) * WEIGHTS_0[1] +\n                     skin_getBoneMatrix(JOINTS_0[2]) * WEIGHTS_0[2] +\n                     skin_getBoneMatrix(JOINTS_0[3]) * WEIGHTS_0[3];\n    return skinMatrix;\n}\n",
        attributes: [ {
            name: "WEIGHTS_0",
            type: "vec4f"
        }, {
            name: "JOINTS_0",
            type: "vec4f"
        } ],
        defines: [ "HAS_SKIN" ]
    },
    vertex_color: {
        vert: "\nstruct VertexColorsUniforms {\n    vertexColorsOfType: array<vec4f, VERTEX_TYPES_COUNT>\n}\n\n@group(0) @binding($b) var<uniform> vertexColors: VertexColorsUniforms;\n\nfn vertexColor_update(input: VertexInput, output: ptr<function, VertexOutput>) {\n    // 将 aVertexColorType 转换为整数索引\n    let index: i32 = i32(input.aVertexColorType);\n    // 获取对应的颜色\n    output.vertexColorColor = vertexColors.vertexColorsOfType[index];\n}\n\n",
        frag: "\nfn vertexColor_get(input: VertexOutput) -> vec4<f32> {\n    return input.vertexColorColor;\n}\n",
        attributes: [ {
            name: "aVertexColorType",
            type: "u32"
        } ],
        varyings: [ {
            name: "vertexColorColor",
            type: "vec4f"
        } ],
        defines: [ "HAS_VERTEX_COLOR" ]
    },
    vsm_shadow: {
        defines: e => e.HAS_SHADOWING && !e.HAS_BLOOM,
        vert: "\nstruct ShadowUniforms {\n    shadow_lightProjViewModelMatrix: mat4x4f,\n};\n\n@group(0) @binding($b) var<uniform> shadowUniforms: ShadowUniforms;\n\nfn shadow_computeShadowPars(position: vec4f, vertexOutput: ptr<function, VertexOutput>) {\n    vertexOutput.shadow_vLightSpacePos = shadowUniforms.shadow_lightProjViewModelMatrix * position;\n}\n",
        frag: "\nstruct ShadowUniforms {\n    shadow_opacity: f32,\n    shadow_color: vec3f,\n    esm_shadow_threshold: f32\n};\n\n@group(0) @binding($b) var<uniform> shadowUniforms: ShadowUniforms;\n@group(0) @binding($b) var shadow_shadowMapSampler: sampler;\n@group(0) @binding($b) var shadow_shadowMap: texture_2d<f32>;\n\n\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\n\nfn esm(projCoords: vec3f, shadowTexel: vec4f) -> f32 {\n    let compare = projCoords.z;\n    let c = 120.0;\n#ifdef PACK_FLOAT\n    var depth = common_decodeDepth(shadowTexel);\n    if (depth >= 1.0 - 1E-6 || compare <= depth) {\n        return 1.0;\n    }\n#else\n    var depth = shadowTexel.r;\n#endif\n\n    depth = exp(-c * min(compare - depth, 0.05));\n    return clamp(depth, shadowUniforms.esm_shadow_threshold, 1.0);\n}\n\nfn shadow_computeShadow_coeff(shadowMap: texture_2d<f32>, projCoords: vec3f) -> f32 {\n    var uv = projCoords.xy;\n    let shadowTexel = textureSample(shadowMap, shadow_shadowMapSampler, uv);\n    let esm_coeff = esm(projCoords, shadowTexel);\n    let coeff = esm_coeff * esm_coeff;\n    return 1.0 - (1.0 - coeff) * shadowUniforms.shadow_opacity;\n\n    // return shadowTexel.r;\n}\n\nfn shadow_computeShadow(vertexOutput: VertexOutput) -> f32 {\n    var projCoords = vertexOutput.shadow_vLightSpacePos.xyz / vertexOutput.shadow_vLightSpacePos.w;\n    // projCoords = projCoords * 0.5 + 0.5;\n    projCoords = vec3(projCoords.xy * 0.5 + 0.5, projCoords.z);\n    let coeff = shadow_computeShadow_coeff(shadow_shadowMap, projCoords);\n    if (projCoords.z >= 1.0 || projCoords.x < 0.0 || projCoords.x > 1.0 || projCoords.y < 0.0 || projCoords.y > 1.0) {\n        return 1.0;\n    }\n    return coeff;\n}\n\nfn shadow_blend(color: vec3f, coeff: f32) -> vec3f {\n    return color * coeff + shadowUniforms.shadow_color * shadowUniforms.shadow_opacity * (1.0 - coeff);\n}\n",
        varyings: [ {
            name: "shadow_vLightSpacePos",
            type: "vec4f",
            defines: [ "HAS_SHADOWING" ]
        } ]
    },
    draco_decode: {
        vert: "\n#if HAS_DRACO_NORMAL || HAS_DRACO_POSITION || HAS_DRACO_TEXCOORD || HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD || HAS_COMPRESSED_INT16\n    // 定义 uniform 变量\n    struct DracoUniforms {\n        #if HAS_DRACO_NORMAL\n            gltf_u_dec_normal_rangeConstant: f32,\n        #endif\n\n        #if HAS_DRACO_POSITION\n            minValues_pos: vec3f,\n            gltf_u_dec_position_normConstant: f32,\n        #endif\n\n        #if HAS_DRACO_TEXCOORD\n            minValues_tex: vec2f,\n            gltf_u_dec_texcoord_0_normConstant: f32,\n        #endif\n\n        #if HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD\n            decodeMatrix: mat3x3f,\n        #endif\n\n    #if HAS_COMPRESSED_INT16\n        #if HAS_COMPRESSED_INT16_POSITION\n            compressedPositionRange: vec2f, // 压缩位置范围\n        #endif\n        #if HAS_COMPRESSED_INT16_TEXCOORD_0\n            compressedTexcoordRange_0: vec2f, // 压缩纹理坐标范围 0\n        #endif\n        #if HAS_COMPRESSED_INT16_TEXCOORD_1\n            compressedTexcoordRange_1: vec2f, // 压缩纹理坐标范围 1\n        #endif\n        #if HAS_COMPRESSED_INT16_NORMAL\n            compressedNormalRange: vec2f, // 压缩法线范围\n        #endif\n        #if HAS_COMPRESSED_INT16_RATIO\n            compressed_ratio: f32, // 压缩比例\n        #endif\n    #endif\n    };\n\n    @group(0) @binding($b) var<uniform> dracoUniforms: DracoUniforms;\n#endif\n\n    // Draco 位置解码函数\n    #ifdef HAS_DRACO_POSITION\n    fn decodeDracoPosition(aPosition: vec3f) -> vec3f {\n        return dracoUniforms.minValues_pos + aPosition * dracoUniforms.gltf_u_dec_position_normConstant;\n    }\n    #endif\n\n    // Draco 纹理坐标解码函数\n    #ifdef HAS_DRACO_TEXCOORD\n    fn decodeDracoTexcoord(aTexCoord: vec2f) -> vec2f {\n        return dracoUniforms.minValues_tex + aTexCoord * dracoUniforms.gltf_u_dec_texcoord_0_normConstant;\n    }\n    #endif\n\n    // Draco 法线解码函数\n    #ifdef HAS_DRACO_NORMAL\n    fn czm_signNotZero(value: f32) -> f32 {\n        return select(-1.0, 1.0, value >= 0.0);\n    }\n\n    fn czm_signNotZero(value: vec2f) -> vec2f {\n        return vec2f(czm_signNotZero(value.x), czm_signNotZero(value.y));\n    }\n\n    fn decodeDracoNormal(encoded: vec2f, range: f32) -> vec3f {\n        if (encoded.x == 0.0 && encoded.y == 0.0) {\n            return vec3f(0.0, 0.0, 0.0);\n        }\n        encoded = encoded / range * 2.0 - 1.0;\n        var v = vec3f(encoded.x, encoded.y, 1.0 - abs(encoded.x) - abs(encoded.y));\n        if (v.z < 0.0) {\n            v.xy = (1.0 - abs(v.yx)) * czm_signNotZero(v.xy);\n        }\n        return normalize(v);\n    }\n\n    fn decode_getNormal(aNormal: vec2f) -> vec3f {\n        return decodeDracoNormal(aNormal, dracoUniforms.gltf_u_dec_normal_rangeConstant).zxy;\n    }\n    #endif\n\n    // 压缩属性解码函数\n    #ifdef HAS_COMPRESSED_INT16\n    fn int16ToFloat32(value: f32, range: vec2f) -> f32 {\n        let v = select(value / 32767.0, -(65536.0 - value) / 32768.0, value >= 32768.0);\n        return (v + 1.0) * (range.y - range.x) / 2.0 + range.x;\n    }\n    #endif\n\n    // 顶点位置解码函数\n    fn decode_getPosition(aPosition: vec3f) -> vec3f {\n        var position = aPosition;\n    #if HAS_COMPRESSED_INT16 && HAS_COMPRESSED_INT16_POSITION\n        let x = int16ToFloat32(aPosition.x, dracoUniforms.compressedPositionRange);\n        let y = int16ToFloat32(aPosition.y, dracoUniforms.compressedPositionRange);\n        let z = int16ToFloat32(aPosition.z, dracoUniforms.compressedPositionRange);\n        #ifdef HAS_COMPRESSED_INT16_RATIO\n            position = vec3f(x / dracoUniforms.compressed_ratio, y / dracoUniforms.compressed_ratio, z);\n        #else\n            position = vec3f(x, y, z);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_POSITION\n        return decodeDracoPosition(position);\n    #else\n        return position;\n    #endif\n    }\n\n    // 纹理坐标解码函数\n    fn decode_getTexcoord(aTexCoord: vec2f) -> vec2f {\n        var texcoord = aTexCoord;\n    // if HAS_COMPRESSED_INT16 && (HAS_COMPRESSED_INT16_TEXCOORD_0 || HAS_COMPRESSED_INT16_TEXCOORD_1)\n    #if HAS_COMPRESSED_INT16\n        #if HAS_COMPRESSED_INT16_TEXCOORD_0 || HAS_COMPRESSED_INT16_TEXCOORD_1\n            let x = int16ToFloat32(aTexCoord.x, dracoUniforms.compressedTexcoordRange_0);\n            let y = int16ToFloat32(aTexCoord.y, dracoUniforms.compressedTexcoordRange_0);\n            texcoord = vec2f(x, y);\n        #endif\n    #endif\n    #ifdef HAS_DRACO_TEXCOORD\n        return decodeDracoTexcoord(texcoord);\n    #else\n        #if HAS_WEB3D_QUANTIZED_ATTRIBUTES_TEXCOORD\n            let web3dTexcoord = dracoUniforms.decodeMatrix * vec3f(texcoord, 1.0);\n            return vec2f(web3dTexcoord.x, web3dTexcoord.y);\n        #else\n            return texcoord;\n        #endif\n    #endif\n    }\n\n    // 法线解码函数\n    fn decode_getNormal(aNormal: vec3f) -> vec3f {\n    #ifdef HAS_COMPRESSED_INT16_NORMAL\n        aNormal.x = int16ToFloat32(aNormal.x, dracoUniforms.compressedNormalRange);\n        aNormal.y = int16ToFloat32(aNormal.y, dracoUniforms.compressedNormalRange);\n        aNormal.z = int16ToFloat32(aNormal.z, dracoUniforms.compressedNormalRange);\n    #endif\n        return aNormal;\n    }\n"
    },
    highlight: {
        defines: e => e.HAS_HIGHLIGHT_OPACITY || e.HAS_HIGHLIGHT_COLOR,
        vert: "\n\n    // 顶点着色器函数\n    fn highlight_setVarying(input: VertexInput, output: ptr<function, VertexOutput>) {\n        // 如果有高亮颜色\n    #if HAS_HIGHLIGHT_COLOR\n        output.vHighlightColor = vec4f(input.aHighlightColor) / 255.0;\n    #endif\n\n        // 如果有高亮透明度\n    #if HAS_HIGHLIGHT_OPACITY\n        output.vHighlightOpacity = f32(input.aHighlightOpacity) / 255.0;\n    #endif\n    }\n",
        frag: "\n    // 高亮颜色混合函数\n    fn highlight_blendColor(color: vec4f, output: VertexOutput) -> vec4f {\n        var outColor: vec4f = color;\n\n        // 如果有高亮颜色\n        #if HAS_HIGHLIGHT_COLOR\n            let highlightColor = output.vHighlightColor;\n            let opacity = highlightColor.a;\n            outColor = vec4f(outColor.rgb * (1.0 - opacity) + highlightColor.rgb * opacity, outColor.a);\n            #if HAS_HIGHLIGHT_COLOR_POINT\n            #else\n            // 如果没有高亮颜色点\n                outColor.a = outColor.a * (1.0 - opacity) + opacity;\n            #endif\n        #endif\n\n            // 如果有高亮透明度\n        #if HAS_HIGHLIGHT_OPACITY\n            outColor *= output.vHighlightOpacity;\n        #endif\n\n        return outColor;\n    }\n",
        attributes: [ {
            defines: [ "HAS_HIGHLIGHT_COLOR" ],
            name: "aHighlightColor",
            type: "vec4u"
        }, {
            defines: [ "HAS_HIGHLIGHT_OPACITY" ],
            name: "aHighlightOpacity",
            type: "u32"
        } ],
        varyings: [ {
            defines: [ "HAS_HIGHLIGHT_COLOR" ],
            name: "vHighlightColor",
            type: "vec4f"
        }, {
            defines: [ "HAS_HIGHLIGHT_OPACITY" ],
            name: "vHighlightOpacity",
            type: "f32"
        } ]
    },
    compute_texcoord: {
        defines: [ "HAS_MAP" ],
        frag: "\n#ifdef HAS_KHR_TEXTURE_TRANSFORM\n    struct TextureTransformUniforms {\n        offset: vec2f,\n        rotation: f32,\n        scale: vec2f,\n    };\n\n    @group(0) @binding($b) var<uniform> textureTransformUniforms: TextureTransformUniforms;\n\n    fn khr_tex_transformTexCoord(texCoords: vec2f, offset: vec2f, rotation: f32, scale: vec2f) -> vec2f {\n        rotation = -rotation;\n        let transform = mat3x3f(\n            cos(rotation) * scale.x, sin(rotation) * scale.x, 0.0,\n            -sin(rotation) * scale.y, cos(rotation) * scale.y, 0.0,\n            offset.x, offset.y, 1.0\n        );\n        let transformedTexCoords = (transform * vec3f(fract(texCoords), 1.0)).xy;\n        return transformedTexCoords;\n    }\n#endif\n\nfn computeTexCoord(texCoord: vec2f, vertexOutput: VertexOutput) -> vec2f {\n    #ifdef HAS_I3S_UVREGION\n        let atlasScale = vertexOutput.vUvRegion.zw - vertexOutput.vUvRegion.xy;\n        let uvAtlas = fract(texCoord) * atlasScale + vertexOutput.vUvRegion.xy;\n        return uvAtlas;\n    #elif HAS_KHR_TEXTURE_TRANSFORM\n        let uniforms = textureTransformUniforms;\n        return khr_tex_transformTexCoord(texCoord, uniforms.offset, uniforms.rotation, uniforms.scale);\n    #else\n        return texCoord;\n    #endif\n}\n"
    },
    fbo_picking: {
        vert: "\n//--------------------------\n// Picking\n//\n// #define ENABLE_PICKING 整型 是否开启PICKING\n//\n// uniform int batchId geometry的批次id\n//\n//\n// fn fbo_picking_setData(viewPosZ: f32, visible: bool)\n//   设置picking数据,必须在设置gl_Position后调用\n//\n// 示例：\n// fbo_picking_setData(output.position.w, true);\n//--------------------------\n\n#ifdef ENABLE_PICKING\n#if HAS_PICKING_ID == 2\n    struct PickingUniforms {\n        uPickingId: f32,\n    }\n    @group(0) @binding($b) var<uniform> pickingUniforms: PickingUniforms;\n#endif\n#endif\n\nfn fbo_picking_setData(input: VertexInput, output: ptr<function, VertexOutput>, viewPosZ: f32, visible: bool) {\n    #ifdef ENABLE_PICKING\n    #if HAS_PICKING_ID == 1\n       output.vPickingId = input.aPickingId;\n    #elif HAS_PICKING_ID == 2\n        output.vPickingId = pickingUniforms.uPickingId;\n    #endif\n        output.vFbo_picking_viewZ = viewPosZ;\n        output.vFbo_picking_visible = select(0.0, 1.0, visible);\n    #endif\n    output.vFbo_picking_fragDepth = viewPosZ + 1.0;\n}\n",
        attributes: [ {
            defines: e => 1 === e.HAS_PICKING_ID,
            name: "aPickingId",
            type: "f32"
        } ],
        varyings: [ {
            defines: [ "ENABLE_PICKING" ],
            name: "vFbo_picking_visible",
            type: "f32"
        }, {
            defines: [ "ENABLE_PICKING" ],
            name: "vPickingId",
            type: "f32"
        }, {
            defines: [ "ENABLE_PICKING" ],
            name: "vFbo_picking_viewZ",
            type: "f32"
        }, {
            name: "vFbo_picking_fragDepth",
            type: "f32"
        } ]
    },
    common_pack_float: {
        vert: ei,
        frag: ei
    },
    excavate: {
        defines: [ "HAS_EXCAVATE_ANALYSIS" ],
        vert: "\n#ifdef HAS_EXCAVATE_ANALYSIS\nstruct ExcavateUniforms {\n    excavateExtent: vec4f\n};\n\n@group(0) @binding($b) var<uniform> excavateUniforms: ExcavateUniforms;\n\nfn getWorldHeight(localPosition: vec4f, modelMatrix: mat4x4f) -> f32 {\n    let wPosition = uniforms.modelMatrix * localPosition;\n    return wPosition.z;\n}\n\nfn getCoordinateTexcoord(localPosition: vec4f, modelMatrix: mat4x4f) -> vec2f {\n    let wPosition = modelMatrix * localPositionMatrix;\n    let x = (wPosition.x - excavateUniforms.excavateExtent.x) /\n           (excavateUniforms.excavateExtent.z - excavateUniforms.excavateExtent.x);\n    let y = (wPosition.y - excavateUniforms.excavateExtent.y) /\n           (excavateUniforms.excavateExtent.w - excavateUniforms.excavateExtent.y);\n    return vec2f(x, y);\n}\n\n#endif\n",
        frag: "\n#ifdef HAS_EXCAVATE_ANALYSIS\nstruct ExcavateUniforms {\n    excavateHeight: f32,\n    heightRange: vec2f  // Replaces the const range\n};\n\n@group(0) @binding($b) var<uniform> excavateUniforms: ExcavateUniforms;\n@group(0) @binding($b) var heightmap: texture_2d<f32>;\n@group(0) @binding($b) var heightmapSampler: sampler;\n\n\nfn decodeHeight(pack: vec4f) -> f32 {\n    return pack.r + pack.g / 255.0;\n}\n\nfn excavateColor(fragColor: vec4f, vertexOutput: VertexOutput) -> vec4f {\n    let samplerHeight = decodeHeight(textureSample(heightmap, heightmapSampler, vertexOutput.vCoordinateTexcoord));\n    let realHeight = samplerHeight * (excavateUniforms.heightRange.y - excavateUniforms.heightRange.x) + excavateUniforms.heightRange.x;\n\n    let validHeight = select(\n        0.0,\n        realHeight,\n        realHeight >= excavateUniforms.heightRange.x && realHeight <= excavateUniforms.heightRange.y\n    );\n\n    if (vertexOutput.vExcavateHeight > validHeight) {\n        discard;\n    }\n    return fragColor;\n}\n#endif\n",
        varyings: [ {
            name: "vCoordinateTexcoord",
            type: "vec2f"
        }, {
            name: "vExcavateHeight",
            type: "f32"
        } ]
    },
    hsv: {
        frag: "\nconst HSV_K0 = vec4f(0.0, -1.0 / 3.0, 2.0 / 3.0, -1.0);\nconst HSV_K1 = vec4f(1.0, 2.0 / 3.0, 1.0 / 3.0, 3.0);\nconst HSV_E = 1.0e-10;\n\nfn hsv_rgb2hsv(c: vec3f) -> vec3f {\n    var K = HSV_K0;\n    var p = mix(vec4f(c.bg, K.wz), vec4f(c.gb, K.xy), select(0.0, 1.0, c.b <= c.g));\n    var q = mix(vec4f(p.xyw, c.r), vec4f(c.r, p.yzx), select(0.0, 1.0, p.x <= c.r));\n\n    // Alternative implementation commented out\n    // var p = select(vec4f(c.gb, K.xy), vec4f(c.bg, K.wz), c.g < c.b);\n    // var q = select(vec4f(c.r, p.yzx), vec4f(p.xyw, c.r), c.r < p.x);\n\n    let d = q.x - min(q.w, q.y);\n    let e = HSV_E;\n    return vec3f(abs(q.z + (q.w - q.y) / (6.0 * d + e)), d / (q.x + e), q.x);\n}\n\nfn hsv_hsv2rgb(c: vec3f) -> vec3f {\n    let K = HSV_K1;\n    let p = abs(fract(c.xxx + K.xyz) * 6.0 - K.www);\n    return c.z * mix(K.xxx, clamp(p - K.xxx, vec3f(0.0), vec3f(1.0)), c.y);\n}\n\nfn hsv_apply4(c: vec4f, hsvOffset: vec3f) -> vec4f {\n    var hsv = hsv_rgb2hsv(c.rgb);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, vec3f(0), vec3f(1));\n    return vec4f(hsv_hsv2rgb(hsv), c.a);\n}\n\nfn hsv_apply3(c: vec3f, hsvOffset: vec3f) -> vec3f {\n    var hsv = hsv_rgb2hsv(c);\n    hsv += hsv * hsvOffset;\n    hsv = clamp(hsv, vec3f(0), vec3f(1));\n    return hsv_hsv2rgb(hsv);\n}\n\nfn contrastMatrix(contrast: f32) -> mat4x4f {\n    let t = (1.0 - contrast) / 2.0;\n    return mat4x4f(\n        vec4f(contrast, 0.0, 0.0, 0.0),\n        vec4f(0.0, contrast, 0.0, 0.0),\n        vec4f(0.0, 0.0, contrast, 0.0),\n        vec4f(t, t, t, 1.0)\n    );\n}\n"
    },
    srgb: {
        frag: "\nfn linearTosRGB(color: vec3f) -> vec3f {\n    return vec3f(\n        select(1.055 * pow(color.r, 1.0/2.4) - 0.055, color.r * 12.92, color.r < 0.0031308),\n        select(1.055 * pow(color.g, 1.0/2.4) - 0.055, color.g * 12.92, color.g < 0.0031308),\n        select(1.055 * pow(color.b, 1.0/2.4) - 0.055, color.b * 12.92, color.b < 0.0031308)\n    );\n}\n\nfn sRGBToLinear(color: vec3f) -> vec3f {\n    return vec3f(\n        select(pow((color.r + 0.055) * (1.0 / 1.055), 2.4), color.r * (1.0 / 12.92), color.r < 0.04045),\n        select(pow((color.g + 0.055) * (1.0 / 1.055), 2.4), color.g * (1.0 / 12.92), color.g < 0.04045),\n        select(pow((color.b + 0.055) * (1.0 / 1.055), 2.4), color.b * (1.0 / 12.92), color.b < 0.04045)\n    );\n}\n"
    },
    snow: {
        defines: [ "HAS_SNOW" ],
        frag: "\n#ifdef HAS_SNOW\nstruct SnowUniforms {\n    snowHeightThreshold: f32  // Added as a configurable uniform\n};\n\n@group(0) @binding($b) var<uniform> snowUniforms: SnowUniforms;\n\nfn lerp(a: f32, b: f32, w: f32) -> f32 {\n    return a + w * (b - a);\n}\n\nfn snow(sceneColor: vec4f, normalColor: vec3f, height: f32) -> vec3f {\n    let snowIntense = normalColor.b;\n    let fixedC = vec3f(1.0, 1.0, 1.0);\n\n    if (height < snowUniforms.snowHeightThreshold) {\n        let r = lerp(0.5, fixedC.x, snowIntense);\n        let g = lerp(0.5, fixedC.y, snowIntense);\n        let b = lerp(0.5, fixedC.z, snowIntense);\n        return vec3f(r, g, b);\n    } else {\n        let r = lerp(sceneColor.r, fixedC.x, snowIntense);\n        let g = lerp(sceneColor.g, fixedC.y, snowIntense);\n        let b = lerp(sceneColor.b, fixedC.z, snowIntense);\n        return vec3f(r, g, b);\n    }\n}\n#endif\n"
    },
    terrain_normal: {
        defines: [ "HAS_TERRAIN_NORMAL" ],
        frag: "\n#ifdef HAS_TERRAIN_NORMAL\nstruct TerrainNormalUniforms {\n    terrainHeightMapResolution: vec2f,\n    terrainResolution: vec2f,\n    terrainHeightScale: f32,\n    terrainTileResolution: f32,\n    terrainUnpackFactors: vec4f\n};\n\n@group(0) @binding($b) var<uniform> terrainNormalUniforms: TerrainNormalUniforms;\n@group(0) @binding($b) var terrainHeightTexture: texture_2d<f32>;\n@group(0) @binding($b) var terrainHeightSampler: sampler;\n\nfn getHeight(uv: vec2f) -> f32 {\n    let color = textureSample(terrainHeightTexture, terrainHeightSampler, uv) * 255.0;\n    let colorWithAlpha = vec4f(color.rgb, -1.0);\n    return dot(colorWithAlpha, terrainNormalUniforms.terrainUnpackFactors) / 4.0;\n}\n\nfn convertTerrainHeightToNormalMap(uv: vec2f) -> vec3f {\n    let flippedUV = vec2f(uv.x, 1.0 - uv.y);\n    let epsilon = 1.0 / terrainNormalUniforms.terrainHeightMapResolution;\n\n    let a = getHeight(flippedUV + vec2f(-epsilon.x, -epsilon.y));\n    let b = getHeight(flippedUV + vec2f(0.0, -epsilon.y));\n    let c = getHeight(flippedUV + vec2f(epsilon.x, -epsilon.y));\n    let d = getHeight(flippedUV + vec2f(-epsilon.x, 0.0));\n    let e = getHeight(flippedUV + vec2f(epsilon.x, 0.0));\n    let f = getHeight(flippedUV + vec2f(-epsilon.x, epsilon.y));\n    let g = getHeight(flippedUV + vec2f(0.0, epsilon.y));\n    let h = getHeight(flippedUV + vec2f(epsilon.x, epsilon.y));\n\n    let dxy = vec2f(\n        (c + e + e + h) - (a + d + d + f),\n        (f + g + g + h) - (a + b + b + c)\n    );\n    return normalize(vec3f(dxy / epsilon, terrainNormalUniforms.terrainResolution.x));\n}\n#endif\n"
    },
    mesh_picking: {
        vert: "\n#include <fbo_picking_vert>\n#include <get_output>\n\nstruct VertexInput {\n    #ifdef POSITION_IS_INT\n        @location($i) aPosition: vec4i,\n    #else\n        @location($i) aPosition: vec3f,\n    #endif\n}\n\nstruct Uniforms {\n    projViewModelMatrix: mat4x4f,\n    modelMatrix: mat4x4f,\n    positionMatrix: mat4x4f,\n}\n\n@group(0) @binding($b) var<uniform> uniforms: Uniforms;\n\nstruct VertexOutput {\n    @builtin(position) position: vec4f,\n    // 其他varying变量可以在这里添加\n}\n\n@vertex\nfn main(input: VertexInput) -> VertexOutput {\n    var output: VertexOutput;\n\n    let localPositionMatrix = getPositionMatrix(input, &output, uniforms.modelMatrix);\n    let localPosition = getPosition(vec3f(input.aPosition.xyz), input);\n\n    output.position = uniforms.projViewModelMatrix * localPositionMatrix * localPosition;\n    // 传入Position的depth值\n    fbo_picking_setData(input, &output, output.position.w, true);\n\n    return output;\n}\n"
    },
    rgbm: {
        frag: "\nfn encodeRGBM(color: vec3f, range: f32) -> vec4f {\n    if (range <= 0.0) {\n        return vec4f(color, 1.0);\n    }\n    var rgbm: vec4f;\n    let col = color / range;\n    rgbm.a = clamp(max(max(col.r, col.g), max(col.b, 1e-6)), 0.0, 1.0);\n    rgbm.a = ceil(rgbm.a * 255.0) / 255.0;\n    rgbm = vec4f(col / rgbm.a, rgbm.a);\n    return rgbm;\n}\n\nfn decodeRGBM(color: vec4f, range: f32) -> vec3f {\n    if (range <= 0.0) {\n        return color.rgb;\n    }\n    return range * color.rgb * color.a;\n}\n"
    }
};

var ni = {
    register(e, t) {
        if (ti[e]) throw new Error(`Key of ${e} is already registered in WgslShaderLib.`);
        ti[e] = t;
    },
    compile: (e, t) => new oi(e, t).compile(),
    get: e => ti[e]
};

const ri = /^[ \t]*#include +<([\w\d.]+)>/gm, ii = /\bstruct\s+VertexInput\b/, si = /\bstruct\s+VertexOutput\b/;

class oi {
    constructor(e, t) {
        this.defines = t, this.source = e, this.isVert = e.indexOf("@vertex") > -1, this.varyings = [], 
        this.attributes = [];
    }
    compile() {
        let e = this.source;
        return e = this.parseIncludes(e), this.isVert && (e = this.fillAttributes(e), e = this.fillVaryings(e)), 
        e;
    }
    parseIncludes(e) {
        return e.replace(ri, ((e, t) => {
            let n = t;
            (t.endsWith("_vert") || t.endsWith("_frag")) && (n = t.substring(0, t.length - 5));
            const r = ti[n];
            if (!r) throw new Error("Can not resolve #include <" + t + ">");
            if (r.defines && !this.checkDefines(r.defines)) return "";
            if (r.varyings) for (let e = 0; e < r.varyings.length; e++) {
                const t = r.varyings[e];
                t.defines && !this.checkDefines(t.defines) || this.varyings.push(t);
            }
            if (r.attributes) for (let e = 0; e < r.attributes.length; e++) {
                const t = r.attributes[e];
                t.defines && !this.checkDefines(t.defines) || this.attributes.push(t);
            }
            return this.parseIncludes(this.isVert ? r.vert : r.frag);
        }));
    }
    fillAttributes(e) {
        return this.fillStruct(e, ii, "$i", this.attributes);
    }
    fillVaryings(e) {
        const t = this.isVert ? "$o" : "$i";
        return this.fillStruct(e, si, t, this.varyings);
    }
    fillStruct(e, t, n, r) {
        if (!r.length) return e;
        const i = e.search(t), s = e.indexOf("}", i), o = e.substring(0, s), a = e.substring(s), l = [];
        for (let e = 0; e < r.length; e++) {
            const {name: t, type: i} = r[e];
            l.push(`@location(${n}) ${t}: ${i},`);
        }
        return o + l.join("\n") + "\n" + a;
    }
    checkDefines(e) {
        if (Array.isArray(e)) for (let t = 0; t < e.length; t++) {
            const n = e[t];
            if (!this.defines[n]) return !1;
        } else if (!e(this.defines)) return !1;
        return !0;
    }
}

const ai = {
    "=": "equal",
    "<": "less",
    "<=": "less-equal",
    "lequal": "less-equal",
    ">": "greater",
    "!=": "not-equal",
    "notequal": "not-equal",
    ">=": "greater-equal",
    "gequal": "greater-equal"
};

function li(e) {
    return ai[e] || e;
}

const ci = {
    "triangles": "triangle-list",
    "triangle strip": "triangle-strip",
    "lines": "line-list"
};

const hi = {
    0: "zero",
    1: "one",
    "src color": "src",
    "one minus src color": "one-minus-src",
    "src alpha": "src-alpha",
    "one minus src alpha": "one-minus-src-alpha",
    "dst color": "dst",
    "one minus dst color": "one-minus-dst",
    "dst alpha": "dst-alpha",
    "one minus dst alpha": "one-minus-dst-alpha"
};

function di(e) {
    return hi[e] || e;
}

const ui = {
    "clamp": "clamp-to-edge",
    "mirror": "mirror-repeat"
};

function fi(e, t, n, r, i) {
    const s = {
        magFilter: t
    };
    return "nearest" === e || "linear" === e ? s.minFilter = e : "linear mipmap linear" === e || "mipmap" === e ? (s.minFilter = "linear", 
    s.mipmapFilter = "linear") : "nearest mipmap nearest" === e ? (s.minFilter = "linear", 
    s.mipmapFilter = "nearest") : "nearest mipmap linear" === e ? (s.minFilter = "nearest", 
    s.mipmapFilter = "linear") : "linear mipmap nearest" === e && (s.minFilter = "linear", 
    s.mipmapFilter = "nearest"), s.addressModeU = ui[n || "clamp"] || n, s.addressModeV = ui[r || "clamp"] || r, 
    i && (s.compare = i), s;
}

function mi(e, t) {
    if ("depth stencil" === (e = e || "rgba") || "depth24 stencil8" === e) return {
        format: "depth24plus-stencil8",
        bytesPerTexel: 4,
        isDepthStencil: !0
    };
    if ("depth" === e) return {
        format: "depth24plus",
        bytesPerTexel: 4,
        isDepthStencil: !1
    };
    if ("alpha" === e) return {
        format: "r8unorm",
        bytesPerTexel: 1,
        isDepthStencil: !1
    };
    if ("uint8" === (t = t || "uint8")) {
        let t = e;
        return "rgba" === e && (t = "rgba8unorm"), {
            format: t,
            bytesPerTexel: 4,
            isDepthStencil: !1
        };
    }
    return "float16" === t || "half float" === t ? {
        format: "r16float",
        bytesPerTexel: 2,
        isDepthStencil: !1
    } : "float" === t ? {
        format: "r32float",
        bytesPerTexel: 4,
        isDepthStencil: !1
    } : {
        format: e,
        bytesPerTexel: 4,
        isDepthStencil: !1
    };
}

class gi {
    readFromREGLCommand(e, t, n, r) {
        e || (e = {});
        const i = t.getMaterial();
        let s = !1;
        i && (s = i.doubleSided);
        const o = t.geometry.desc.primitive;
        this.topology = function(e) {
            return ci[e] || "triangle-list";
        }(o);
        const a = !r || !!r.depthTexture, l = !r || r.depthTexture && r.depthTexture.gpuFormat.isDepthStencil;
        let c, h;
        if (this.functionProps = [], a && e.polygonOffset && _i(e.polygonOffset.enable, n)) if (this.topology.startsWith("triangle")) {
            const t = e.polygonOffset.offset;
            t && !C(t.units) && (O(t.units) ? (c = t.units(null, n), this.functionProps.push({
                func: t.units,
                v: c
            })) : c = t.units), t && !C(t.factor) && (O(t.factor) ? (h = t.factor(null, n), 
            this.functionProps.push({
                func: t.factor,
                v: h
            })) : h = t.factor);
        } else c = 0, h = 0;
        this.depthBias = c, this.depthBiasSlopeScale = h;
        let d = "always", u = !1;
        const f = e.depth;
        if (a && f && _i(f.enable, n)) {
            if (f.func) {
                let e = f.func;
                O(f.func) && (e = e(null, n), this.functionProps.push({
                    func: f.func,
                    v: e
                })), d = li(e);
            }
            u = !0, C(f.mask) || (O(f.mask) ? (u = f.mask(null, n), this.functionProps.push({
                func: f.mask,
                v: u
            })) : u = !!f.mask);
        }
        this.depthCompare = d, this.depthWriteEnabled = u;
        let m = "always", g = "keep";
        const _ = e.stencil;
        if (l && _ && _i(_.enable, n)) {
            if (_.op && (g = _.op.zpass, O(g))) {
                g = g(null, n), this.functionProps.push({
                    func: _.op.zpass,
                    v: g
                });
            }
            if (_.func) {
                let e = _.func.cmp;
                e || (e = "always");
                let t = e;
                O(t) && (t = e(null, n), this.functionProps.push({
                    func: e,
                    v: t
                })), m = li(t);
            }
        }
        let p, v, x, y;
        this.stencilFrontCompare = m, this.stencilFrontPassOp = g;
        const b = e.blend;
        if (b && _i(b.enable, n) && b.func) {
            const e = b.func;
            if (e.src) {
                let t = e.src;
                O(e.src) && (t = e.src(null, n), this.functionProps.push({
                    func: e.src,
                    v: t
                })), p = di(t), x = p;
            }
            if (e.dst) {
                let t = e.dst;
                O(e.dst) && (t = e.dst(null, n), this.functionProps.push({
                    func: e.dst,
                    v: t
                })), v = di(t), y = v;
            }
            if (e.srcAlpha) {
                let t = e.srcAlpha;
                O(e.srcAlpha) && (t = e.srcAlpha(null, n) || this.functionProps.push({
                    func: e.srcAlpha,
                    v: t
                })), p = di(t);
            }
            if (e.srcRGB) {
                let t = e.srcRGB;
                O(e.srcRGB) && (t = e.srcRGB(null, n) || this.functionProps.push({
                    func: e.srcRGB,
                    v: t
                })), x = di(t);
            }
            if (e.dstAlpha) {
                let t = e.dstAlpha;
                O(e.dstAlpha) && (t = e.dstAlpha(null, n) || this.functionProps.push({
                    func: e.dstAlpha,
                    v: t
                })), v = di(t);
            }
            if (e.dstRGB) {
                let t = e.dstRGB;
                O(e.dstRGB) && (t = e.dstRGB(null, n) || this.functionProps.push({
                    func: e.dstRGB,
                    v: t
                })), y = di(t);
            }
        }
        this.blendAlphaDst = v, this.blendAlphaSrc = p, this.blendColorDst = y, this.blendColorSrc = x;
        let w = "none";
        if (!s) {
            const t = e.cull;
            t && _i(t.enable, n) && (w = "back", t.face && (w = t.face, O(t.face) && (w = t.face(null, n) || this.functionProps.push({
                func: t.face,
                v: w
            }))));
        }
        this.cullMode = w, this.frontFace = e.frontFace;
        let T = e.colorMask;
        if (T) {
            O(T) && (T = T(null, n), this.functionProps.push({
                func: e.colorMask,
                v: T
            }));
            let t = 0;
            T[0] && (t |= GPUColorWrite.RED), T[1] && (t |= GPUColorWrite.GREEN), T[2] && (t |= GPUColorWrite.BLUE), 
            T[3] && (t |= GPUColorWrite.ALPHA), this.writeMask = t;
        }
    }
    generateValuesKey(e) {
        return e.map((e => Array.isArray(e) ? e.join() : e)).join("-");
    }
    getFnValuesKey() {
        return this.generateValuesKey(this.functionProps.map((e => e.v)));
    }
    getSignatureKey() {
        return (this.depthBias || 0) + "-" + (this.depthBiasSlopeScale || 0) + "-" + (this.depthCompare || 0) + "-" + (this.depthWriteEnabled || 0) + (this.stencilFrontCompare || 0) + "-" + (this.stencilFrontPassOp || 0) + (this.blendAlphaSrc || 0) + "-" + (this.blendAlphaDst || 0) + "-" + (this.blendColorSrc || 0) + "-" + (this.blendColorDst || 0) + (this.cullMode || 0) + "-" + (this.frontFace || 0) + "-" + (this.topology || 0) + "-" + (this.writeMask || 0);
    }
}

function _i(e, t) {
    return O(e) ? !!(e = e(null, t)) : !!e;
}

let pi = new ArrayBuffer(4194304);

class vi {
    constructor(e, t) {
        this._bindGroups = [], this.device = e, this.config = t, this.gpuFormat = mi(t.format, t.type), 
        this._updateTexture();
    }
    get width() {
        return this.texture && this.texture.width || this.config && this.config.width;
    }
    get height() {
        return this.texture && this.texture.height || this.config && this.config.height;
    }
    updateFilter() {
        this._clearBindGroups();
    }
    _clearBindGroups() {
        if (this._bindGroups.length) {
            for (let e = 0; e < this._bindGroups.length; e++) this._bindGroups[e].outdated = !0;
            this._bindGroups = [];
        }
    }
    resize(e, t) {
        this.texture && this.texture.width === e && this.texture.height === t || (this.config.width = e, 
        this.config.height = t, this._updateTexture());
    }
    update(e) {
        E(this.config, e), this.gpuFormat = mi(this.config.format, this.config.type), this._updateTexture();
    }
    _updateTexture() {
        const e = this.config, t = this.device.wgpu;
        let n;
        this.texture && (this.texture.destroy(), this._clearBindGroups());
        {
            let r = O(e.width) ? e.width() : e.width, i = O(e.height) ? e.height() : e.height;
            if (void 0 === r || void 0 === i) {
                const t = e.data;
                if (t) if (L(e.data)) {
                    const t = e.data.length;
                    r = Math.sqrt(t / 4), i = r;
                } else r = t.width, i = t.height; else r = i = 1;
            }
            const s = this.gpuFormat.format, o = {
                size: [ r, i, 1 ],
                format: s,
                usage: "depth24plus" === s || "depth24plus-stencil8" === s ? GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.RENDER_ATTACHMENT : GPUTextureUsage.TEXTURE_BINDING | GPUTextureUsage.COPY_SRC | GPUTextureUsage.COPY_DST | GPUTextureUsage.RENDER_ATTACHMENT
            };
            if (e.sampleCount && (o.sampleCount = e.sampleCount), n = t.createTexture(o), e.data) if (L(e.data)) {
                const s = e.data, o = !e.type || "uint8" === e.type;
                let a;
                a = Array.isArray(s) ? o ? s.length : 4 * s.length : s.byteLength;
                const l = (!e.format || "rgba" === e.format) && e.premultiplyAlpha;
                let c;
                if ((l || Array.isArray(s)) && (pi.byteLength < a && (pi = new ArrayBuffer(a)), 
                c = o ? new Uint8Array(pi, 0, a) : new Float32Array(pi, 0, a / 4)), l) {
                    const e = o ? 255 : 1;
                    for (let t = 0; t < s.length; t += 4) {
                        const n = s[t + 3] / e;
                        c[t] = s[t] * n, c[t + 1] = s[t + 1] * n, c[t + 2] = s[t + 2] * n, c[t + 3] = s[t + 3];
                    }
                } else if (Array.isArray(s)) for (let e = 0; e < s.length; e++) c[e] = s[e]; else c = s;
                t.queue.writeTexture({
                    texture: n
                }, c.buffer, {
                    bytesPerRow: r * this.gpuFormat.bytesPerTexel
                }, [ r, i ]);
            } else t.queue.copyExternalImageToTexture({
                source: e.data,
                flipY: !!this.config.flipY
            }, {
                texture: n,
                premultipliedAlpha: !!this.config.premultiplyAlpha
            }, [ r, i ]);
        }
        this.texture = n;
    }
    getView(e) {
        return this.texture.createView(e);
    }
    addBindGroup(e) {
        this._bindGroups.push(e);
    }
    destroy() {
        this.texture && (this.texture.destroy(), delete this.texture), delete this._bindGroups;
    }
}

class xi {
    constructor(e, t) {
        this.device = e, this.options = t, this._update();
    }
    get color() {
        return [ this.colorTexture ];
    }
    resize(e, t) {
        if ((!this.colorTexture || e !== this.colorTexture.width || t !== this.colorTexture.height) && (this.options.width = e, 
        this.options.height = t, this.width = e, this.height = t, this.colorTexture && this.colorTexture.resize(e, t), 
        this.depthTexture && this.depthTexture.resize(e, t), this._renderPass)) {
            const e = this._renderPass.colorAttachments[0];
            e && e.view && this.colorTexture && (e.view = this.colorTexture.getView());
            const t = this._renderPass.depthStencilAttachment;
            t && t.view && this.depthTexture && (t.view = this.depthTexture.getView());
        }
    }
    _update() {
        let e = this.options.colors && this.options.colors[0] || this.options.color;
        const t = this.options.colorFormat, n = this.options.colorType;
        let r, i;
        e ? (r = e.width, i = e.height) : (t || n) && (e = !0), C(this.options.width) || (r = this.options.width), 
        C(this.options.height) || (i = this.options.height), this.width = r, this.height = i, 
        !e || e instanceof vi || (!0 === e && (e = {
            width: r,
            height: i
        }), e.width || (e.width = r), e.height || (e.height = i), e.format || (e.format = t || "rgba"), 
        e.type || (e.type = n || "uint8"), this._ownColor = !0, e = new vi(this.device, e));
        let s = this.options.depth;
        s && (!0 === s ? (this._ownDepthTexture = !0, s = new vi(this.device, {
            width: r,
            height: i,
            format: "depth"
        })) : s instanceof vi || (this._ownDepthTexture = !0, s = new vi(this.device, s)));
        const o = this.options.depthStencil;
        if (o && (!0 === o ? (this._ownDepthTexture = !0, s = new vi(this.device, {
            width: r,
            height: i,
            format: "depth stencil"
        })) : o instanceof vi ? s = o : (this._ownDepthTexture = !0, s = new vi(this.device, o))), 
        this.colorTexture = e, this.depthTexture = s, this._renderPass = {
            colorAttachments: []
        }, null !== e && (this._renderPass.colorAttachments[0] = {
            view: this.colorTexture && this.colorTexture.getView(),
            clearValue: [ 0, 0, 0, 0 ],
            loadOp: "load",
            storeOp: "store"
        }), s) {
            const e = this._renderPass.depthStencilAttachment = {
                view: this.depthTexture.getView(),
                depthClearValue: 1,
                depthLoadOp: "load",
                depthStoreOp: "store"
            };
            s.gpuFormat.isDepthStencil && (e.stencilReadOnly = !1, e.stencilClearValue = 0, 
            e.stencilLoadOp = "load", e.stencilStoreOp = "store");
        }
    }
    getRenderPassDescriptor() {
        const e = this._renderPass.colorAttachments[0], t = this._renderPass.depthStencilAttachment;
        let n, r;
        if (!this.colorTexture) {
            const t = this.device.context.getCurrentTexture();
            n = t.width, r = t.height, e.view = t.createView(), e.view.label = "default canvas view";
        }
        if (e && (e.loadOp = this.colorLoadOp || "load", e.clearValue = this.colorClearValue || [ 0, 0, 0, 0 ]), 
        t) {
            t.depthLoadOp = this.depthLoadOp || "load", t.depthClearValue = this.depthClearValue || 1;
            const e = this.depthTexture;
            e.gpuFormat.isDepthStencil && (t.stencilLoadOp = this.stencilLoadOp || "load", t.stencilClearValue = this.stencilClearValue || 0), 
            e && n && r && (e.width !== n || e.height !== r) && (e.resize(n, r), t.view = e.getView());
        }
        return this._resetClearOptions(), this._renderPass;
    }
    setClearOptions(e) {
        e.color && (this.colorLoadOp = "clear", this.colorClearValue = e.color), e.depth && (this.depthLoadOp = "clear", 
        this.depthClearValue = e.depth), e.stencil && (this.stencilLoadOp = "clear", this.stencilClearValue = e.stencil);
    }
    _resetClearOptions() {
        this.colorLoadOp = null, this.colorClearValue = null, this.depthLoadOp = null, this.depthClearValue = null, 
        this.stencilLoadOp = null, this.stencilClearValue = null;
    }
    destroy() {
        this._ownColor && this.colorTexture && (this.colorTexture.destroy(), delete this.colorTexture), 
        this._ownDepthTexture && this.depthTexture && (this.depthTexture.destroy(), delete this.depthTexture, 
        delete this._ownDepthTexture);
    }
}

let yi = 0;

class bi {
    constructor(e, t, n) {
        this.name = e, this.uuid = yi++, this.groups = t.groups, this.alignment = n, this._parse(t);
    }
    getShaderUniforms() {
        return this._shaderUniforms;
    }
    getMeshUniforms() {
        return this._meshUniforms;
    }
    _parse(e) {
        this._shaderUniforms = [], this._shaderUniforms.index = 0, this._shaderUniforms.totalSize = 0, 
        this._meshUniforms = [], this._meshUniforms.index = 0, this._meshUniforms.totalSize = 0;
        const t = e.groups;
        if (!t) return;
        const n = t[0];
        if (n) for (let e = 0; e < n.length; e++) {
            const t = n[e];
            if (t) if (t.isGlobal) {
                let e = this._shaderUniforms.index;
                this._shaderUniforms[e++] = t, this._shaderUniforms.index = e, this._shaderUniforms.totalSize += Ue(t.size, this.alignment);
            } else {
                let e = this._meshUniforms.index;
                this._meshUniforms[e++] = t, this._meshUniforms.index = e, this._meshUniforms.totalSize += Ue(t.size, this.alignment);
            }
        }
    }
    createFormatBindGroup(e, t, n, r, i, s) {
        const o = this.name + "-" + t.uuid;
        if (!this.groups) return {
            bindGroup: e.wgpu.createBindGroup({
                layout: r,
                label: o,
                entries: []
            }),
            outdated: !1,
            uniformTextures: {}
        };
        const a = this.groups[0], l = [], c = [];
        for (let r = 0; r < a.length; r++) {
            const o = a[r];
            if (!o) continue;
            const h = o.name;
            if (o.resourceType === ln.Sampler) {
                const r = h.substring(0, h.length - 7);
                let i = n && n[r] || t.getUniform(r) || t.material && t.material.getUniform(r);
                if (i instanceof xi && (i = i.colorTexture), !i) continue;
                const {min: s, mag: a, compare: c, wrap: d} = i.config;
                let {wrapS: u, wrapT: f} = i.config;
                d && !u && (u = d), d && !f && (f = d);
                const m = fi(s, a, u, f, c), g = e.wgpu.createSampler(m);
                l.push({
                    binding: o.binding,
                    resource: g
                });
            } else if (o.resourceType === ln.Texture) {
                const r = n && n[h] || t.getUniform(h) || t.material && t.material.getUniform(h);
                let i, s = r;
                if (s instanceof se && (s = r.getREGLTexture(e)), s instanceof xi && (s = s.colorTexture), 
                !s) continue;
                c.push(s), s.gpuFormat.isDepthStencil && (i = {
                    aspect: "depth-only"
                }), l.push({
                    binding: o.binding,
                    resource: s.getView(i)
                });
            } else {
                const e = o.isGlobal ? i.allocation : s.allocation;
                l.push({
                    binding: o.binding,
                    resource: {
                        buffer: e.gpuBuffer,
                        size: Ue(o.size, this.alignment)
                    }
                });
            }
        }
        const h = e.wgpu.createBindGroup({
            layout: r,
            label: o,
            entries: l
        });
        for (let e = 0; e < c.length; e++) c[e].addBindGroup(h);
        return {
            bindGroup: h,
            outdated: !1,
            uniformTextures: {}
        };
    }
    copyTextures(e, t) {
        for (const n in t) {
            if ("meshObject" === n) continue;
            let r;
            try {
                r = t[n];
            } catch (e) {
                continue;
            }
            $(r) && (e.uniformTextures[n] = r);
        }
    }
    dispose() {
        delete this._shaderUniforms, delete this._meshUniforms, delete this.groups;
    }
}

const wi = /\s*#define\s+(\w+)\s+([^\n]+)/g, Ti = /#([^\s]*)(\s*)/gm, Si = /#[^\s]*\s*\b[0-9A-Z][0-9A-Z_&&\|=! ]+\b/g;

function Mi(e, t) {
    var n;
    if (!e) return;
    const r = e.matchAll(wi), i = {};
    for (const e of r) i[e[1]] = e[2];
    let s = Ci(e = e.replace(/#define.*$/gm, ""), i);
    const o = null === (n = s.match(Si)) || void 0 === n ? void 0 : n.filter((e => !!isNaN(e) && "" != e)).map((e => {
        const t = e.indexOf(" ");
        return e.substring(t).trim();
    })), {normalizeDefines: a, constValues: l} = function(e, t) {
        var n;
        const r = new Set, i = null === (n = null == e ? void 0 : e.map) || void 0 === n ? void 0 : n.call(e, (e => ki(e, t, r))), s = {};
        for (const e in t) r.has(e) || (s[e] = t[e]);
        return {
            normalizeDefines: i,
            constValues: s
        };
    }(o, t);
    s = Ci(s, l);
    const c = function(e, t) {
        let n = e;
        const r = (null == t ? void 0 : t.map((e => {
            const t = n.indexOf(e), r = n.slice(0, t);
            return n = n.slice(t + e.length), r;
        }))) || [];
        (null == r ? void 0 : r.length) && r.push(n);
        return r;
    }(s, o);
    return c.length > 0 ? function(e, t) {
        const n = [];
        let r = new Ai(!0);
        r.elseIsValid = !1;
        const i = (e, t) => {
            if (e.index + e[0].length != t.length) throw new Error(`#${e[1]} must be immediately followed by a template expression (ie: \${value})`);
        };
        for (let s = 0; s < e.length; ++s) {
            const o = e[s], a = o.matchAll(Ti);
            let l = 0, c = !1;
            for (const e of a) {
                switch (r.appendStringToCurrentBranch(o.substring(l, e.index)), e[1]) {
                  case "if":
                  case "ifdef":
                  case "ifndef":
                    i(e, o), c = !0, n.push(r);
                    const a = "ifndef" === e[1] ? !t[s] : !!t[s];
                    r = new Ai(a);
                    break;

                  case "elif":
                    i(e, o), c = !0, r.pushBranch(e[1], t[s]);
                    break;

                  case "else":
                    r.pushBranch(e[1], !0), r.appendStringToCurrentBranch(e[2]);
                    break;

                  case "endif":
                    if (!n.length) throw new Error(`#${e[1]} not preceeded by an #if`);
                    const l = r.resolve();
                    r = n.pop(), r.appendStringToCurrentBranch(l, e[2]);
                    break;

                  default:
                    r.appendStringToCurrentBranch(e[0]);
                }
                l = e.index + e[0].length;
            }
            l != o.length && r.appendStringToCurrentBranch(o.substring(l, o.length)), !c && t.length > s && r.appendStringToCurrentBranch(t[s]);
        }
        if (n.length) throw new Error("Mismatched #if/#endif count");
        return r.resolve();
    }(c, a) : s;
}

class Ai {
    constructor(e) {
        this.elseIsValid = !0, this.branches = [], this.pushBranch("if", e);
    }
    pushBranch(e, t) {
        if (!this.elseIsValid) throw new Error(`#${e} not preceeded by an #if or #elif`);
        this.elseIsValid = "if" === e || "elif" === e, this.branches.push({
            expression: !!t,
            string: ""
        });
    }
    appendStringToCurrentBranch(...e) {
        for (const t of e) this.branches[this.branches.length - 1].string += t;
    }
    resolve() {
        for (const e of this.branches) if (e.expression) return e.string;
        return "";
    }
}

function Ci(e, t) {
    var n;
    if (!t) return e;
    let r = e;
    const i = Object.keys(t);
    return null === (n = null == i ? void 0 : i.forEach) || void 0 === n || n.call(i, (e => {
        const n = new RegExp("\\b" + e + "\\b", "g");
        r = r.replace(n, t[e] + "");
    })), r;
}

function ki(e, t, n) {
    if ((null == e ? void 0 : e.includes("&&")) || (null == e ? void 0 : e.includes("||"))) {
        if (e.includes("&&")) {
            const r = e.split("&&").map((e => e.trim()));
            return function(e, t, n) {
                var r;
                let i = 0;
                return null === (r = null == e ? void 0 : e.forEach) || void 0 === r || r.call(e, (e => i += Number(Oi(t, e, n) || 0) > 1 ? 1 : Number(Oi(t, e, n) || 0))), 
                i === e.length;
            }(r, t, n);
        }
        const r = e.split("||").map((e => e.trim()));
        return !function(e, t, n) {
            var r;
            let i = 0;
            return null === (r = null == e ? void 0 : e.forEach) || void 0 === r || r.call(e, (e => {
                const r = Oi(t, e, n);
                return i += r ? 1 : 0;
            })), 0 === i;
        }(r, t, n);
    }
    return Oi(t, e, n);
}

function Oi(e, t, n) {
    if (t && t.startsWith && t.startsWith("!")) return t = t.substring(1), n && n.add(t), 
    !e[t];
    if (t && t.includes && (t.includes("==") || t.includes("!="))) {
        const r = t.includes("=="), i = t.split(r ? "==" : "!=").map((e => e.trim()));
        return n && n.add(i[0]), r ? e[i[0]] === +i[1] : e[i[0]] !== +i[1];
    }
    return n && n.add(t), e[t];
}

var Ei = Object.freeze({
    __proto__: null,
    WGSLParseDefines: Mi,
    getDefineConditionValue: ki
});

const Pi = /struct\s+VertexOutput\s*\{[\s\S]*?\}/;

class Ii {
    constructor(e, t, n, r, i, s, o, a) {
        this.name = e, this.device = t, this.vert = n, this.frag = r, this.mesh = i, this.contextDesc = s, 
        this.defines = o, this.uniformValues = a;
    }
    build(e, t) {
        const n = this.mesh, r = this.device, i = this.defines;
        let s = Ui(this.vert), o = Ui(this.frag);
        try {
            s = Mi(s, i);
        } catch (e) {
            throw e.message = this.name + "(vert):" + e.message, console.error(e), e;
        }
        try {
            o = Mi(o, i);
        } catch (e) {
            throw e.message = this.name + "(frag):" + e.message, console.error(e), e;
        }
        s = Ni(s), o && (o = Ni(o));
        const {source: a, index: l} = Bi(s, 0);
        if (s = a, o) {
            const {source: e} = Bi(o, l);
            o = e;
            const t = s.match(Pi);
            if (t) {
                const e = function(e) {
                    const t = e.lastIndexOf("#define");
                    if (-1 !== t) {
                        return e.indexOf("\n", t) + 1;
                    }
                    return 0;
                }(s);
                o = o.substring(0, e) + t[0] + "\n" + o.substring(e);
            }
        }
        let c;
        try {
            c = new gr(s);
        } catch (e) {
            throw console.error("WGSL Reflect vert error in " + this.name, e), console.error(s), 
            e;
        }
        const h = this._formatBufferInfo(c, n);
        let d;
        if (o) try {
            d = new gr(o);
        } catch (e) {
            throw console.error("WGSL Reflect frag error in " + this.name, e), console.error(o), 
            e;
        }
        const u = c.getBindGroups();
        let f = [];
        d && (f = d.getBindGroups());
        const m = this._createCommandBindGroupLayout(u, f, n, this.uniformValues), g = this._createCommandPipeline(r, s, h, o, m, n, e, t), _ = this._createBindGroupMapping(u, f, n), p = r.wgpu.limits.minUniformBufferOffsetAlignment;
        return {
            uid: "-1",
            layout: m,
            pipeline: g,
            vertexInfo: h,
            bindGroupFormat: new bi(this.name, _, p),
            bindGroupMapping: _,
            activeAttributes: this._getActiveAttributes()
        };
    }
    _getActiveAttributes() {
        const e = [ {
            name: "position",
            type: 1
        } ];
        return e.key = e.map((e => e.name)).join(), e;
    }
    _createCommandBindGroupLayout(e, t, n, r) {
        const i = [];
        for (let t = 0; t < e.length; t++) {
            const s = e[t];
            for (let e = 0; e < s.length; e++) {
                const t = s[e];
                if (!t) continue;
                const o = this._createLayoutEntry(t.binding, GPUShaderStage.VERTEX, t, n, r);
                i.push(o);
            }
        }
        for (let e = 0; e < t.length; e++) {
            const s = t[e];
            for (let e = 0; e < s.length; e++) {
                const t = s[e];
                if (!t) continue;
                const o = this._createLayoutEntry(t.binding, GPUShaderStage.FRAGMENT, t, n, r);
                i.push(o);
            }
        }
        return i.sort(Fi), this.device.wgpu.createBindGroupLayout({
            label: this.name + "-bindgrouplayout",
            entries: i
        });
    }
    _createLayoutEntry(e, t, n, r, i) {
        if (n.resourceType === ln.Sampler) {
            const s = {};
            if (n.type && "sampler_comparison" === n.type.name) s.type = "comparison"; else {
                const e = n.name.replace("Sampler", ""), {format: t} = this._getTextureInfo(e, r, i);
                t && t.startsWith("depth") && (s.type = "non-filtering");
            }
            return {
                binding: e,
                visibility: t,
                sampler: s
            };
        }
        if (n.resourceType === ln.Texture) {
            const s = n.name, {format: o, multisampled: a} = this._getTextureInfo(s, r, i);
            let l = a ? "unfilterable-float" : "float";
            return o && o.startsWith("depth") && (l = "depth"), {
                binding: e,
                visibility: t,
                texture: {
                    multisampled: a,
                    sampleType: l
                }
            };
        }
        return {
            binding: e,
            visibility: t,
            buffer: {
                type: "uniform",
                hasDynamicOffset: !0
            }
        };
    }
    _getTextureInfo(e, t, n) {
        let r, i = n[e] || t.material && t.material.get(e), s = !1;
        return i instanceof xi && (i = i.colorTexture), i && (i instanceof qr ? r = i.config.type : i instanceof vi && (r = i.gpuFormat.format), 
        s = !!(i.config && i.config.sampleCount > 1)), {
            format: r,
            multisampled: s
        };
    }
    _formatBufferInfo(e, t) {
        const n = e.entry.vertex[0].inputs, r = {};
        for (let e = 0; e < n.length; e++) {
            r[n[e].name] = n[e];
        }
        const i = {}, s = t.geometry.data, o = t.geometry.semantic, a = new Set;
        for (const e in s) {
            const t = o[e] || e, n = r[t];
            n && (a.add(t), i[t] = {
                geoAttrName: e,
                location: n.location,
                itemSize: Li(n.type)
            });
        }
        for (const e in r) if (!a.has(e)) {
            const t = r[e];
            i[e] = {
                geoAttrName: e,
                location: t.location,
                itemSize: Li(t.type)
            };
        }
        if (t instanceof yr) {
            const e = t.instancedData;
            for (const t in e) r[t] && (i[t] = {
                geoAttrName: t,
                location: r[t].location,
                itemSize: Li(r[t].type)
            });
        }
        return i;
    }
    _createBindGroupMapping(e, t, n) {
        const r = {};
        return this._parseGroupMapping(r, e[0], n, "vert"), this._parseGroupMapping(r, t[0], n, "frag"), 
        r;
    }
    _parseGroupMapping(e, t, n, r) {
        if (t) for (let i = 0; i < t.length; i++) {
            const s = t[i];
            if (!s) continue;
            const {group: o, binding: a} = s, l = s.members;
            let c = !1;
            if (l && l.length) for (let e = 0; e < l.length; e++) {
                const t = l[e].name;
                if (Ri(n, t, this.contextDesc)) {
                    if (c) throw new Error("Found a mesh uniform in global struct:" + t + "(" + s.name + ") in " + this.name + "_" + r);
                } else {
                    if (!c && e > 0) throw new Error("Found a global uniform in mesh struct:" + t + "(" + s.name + ") in " + this.name + "_" + r);
                    c = !0;
                }
            } else {
                Ri(n, s.name, this.contextDesc) || (c = !0);
            }
            e.groups = e.groups || [], e.groups[o] = e.groups[o] || [], s.isGlobal = c, s.index = e.groups[o][a] = s;
        }
    }
    _createCommandPipeline(e, t, n, r, i, s, o, a) {
        const l = e.wgpu, c = l.createShaderModule({
            label: this.name + "-vertmodule",
            code: t
        });
        let h;
        r && (h = l.createShaderModule({
            label: this.name + "-fragmodule",
            code: r
        })), this._presentationFormat || (this._presentationFormat = navigator.gpu.getPreferredCanvasFormat());
        const d = s.geometry.getBufferDescriptor(n);
        if (s instanceof yr) {
            const e = s.getBufferDescriptor(n);
            for (let t = 0; t < e.length; t++) e[t] && (d[t] = e[t]);
        }
        const u = l.createPipelineLayout({
            label: this.name + "-pipelinelayout",
            bindGroupLayouts: [ i ]
        }), f = {
            label: this.name + "-pipeline",
            layout: u,
            vertex: {
                module: c,
                buffers: d
            },
            primitive: {
                topology: o.topology,
                cullMode: o.cullMode
            }
        }, m = a && a.colorTexture && a.colorTexture.config.sampleCount;
        m && (f.multisample = {
            count: m
        });
        if (!a || !!a.depthTexture) {
            const e = a && a.depthTexture;
            f.depthStencil = {
                depthBias: o.depthBias,
                depthBiasSlopeScale: o.depthBiasSlopeScale,
                depthWriteEnabled: o.depthWriteEnabled,
                depthCompare: o.depthCompare,
                format: !e || e.gpuFormat.isDepthStencil ? "depth24plus-stencil8" : "depth24plus"
            };
        }
        if (h) {
            const e = a && a.colorTexture && a.colorTexture.gpuFormat.format, t = o.writeMask;
            f.fragment = {
                module: h,
                targets: [ {
                    format: e || this._presentationFormat,
                    writeMask: C(t) ? GPUColorWrite.ALL : t
                } ]
            };
        }
        if (f.depthStencil && o.stencilFrontCompare && (f.depthStencil.stencilBack = f.depthStencil.stencilFront = {
            compare: o.stencilFrontCompare,
            passOp: o.stencilFrontPassOp
        }), h && o.blendAlphaDst) {
            const e = f.fragment.targets;
            for (const t of e) t.blend = {
                color: {
                    srcFactor: o.blendColorSrc,
                    dstFactor: o.blendColorDst,
                    operation: "add"
                },
                alpha: {
                    srcFactor: o.blendAlphaSrc,
                    dstFactor: o.blendAlphaDst,
                    operation: "add"
                }
            };
        }
        return l.createRenderPipeline(f);
    }
}

function Ri(e, t, n) {
    return "modelMatrix" === t || "positionMatrix" === t || "projViewModelMatrix" === t || "modelViewMatrix" === t || "modelNormalMatrix" === t || "polygonFill" === t || "polygonOpacity" === t || "lineColor" === t || "lineOpacity" === t || (n[t] && !n[t].global || e.hasUniform(t) || e.material && e.material.hasUniform(t));
}

function Li(e) {
    return e.name.startsWith("vec") ? parseInt(e.name[3]) : 1;
}

function Fi(e, t) {
    return e.binding - t.binding;
}

let Hi = 0;

const Di = () => "" + Hi++;

function Ni(e) {
    Hi = 0;
    const t = e.replaceAll("$i", Di);
    Hi = 0;
    return t.replaceAll("$o", Di);
}

function Bi(e, t) {
    return Hi = t, {
        source: e.replaceAll("$b", Di),
        index: Hi
    };
}

function Ui(e) {
    return e ? e.replace(/[ \t]*\/\/.*\n/g, "").replace(/[ \t]*\/\*[\s\S]*?\*\//g, "") : e;
}

class zi {
    constructor() {
        this.items = [], this.offsets = [], this.index = 0;
    }
    reset() {
        this.index = 0;
    }
    addItem(e, t) {
        const n = this.index++, r = this.items[n];
        r ? (r.binding = e, r.offset = t) : this.items[n] = {
            binding: e,
            offset: t
        };
    }
    addItems(e) {
        for (let t = 0; t < e.length; t++) this.addItem(e[t].binding, e[t].offset);
    }
    getItems() {
        return this.items.slice(0, this.index);
    }
    getDynamicOffsets() {
        const e = this.getItems();
        e.sort(((e, t) => e.binding - t.binding)), this.offsets.length = e.length;
        for (let t = 0; t < e.length; t++) this.offsets[t] = e[t].offset;
        return this.offsets;
    }
}

const Gi = "function", Vi = "array";

let ji = 0;

const Wi = {};

class qi {
    constructor({vert: e, frag: t, wgslVert: n, wgslFrag: r, uniforms: i, defines: s, extraCommandProps: o, name: a}) {
        this.name = a, this.vert = e, this.frag = t, this.wgslVert = n, this.wgslFrag = r, 
        this.commandId = 0;
        const l = ji++;
        Object.defineProperty(this, "uid", {
            enumerable: !0,
            configurable: !1,
            get: () => l
        }), this.setDefines(s && E({}, s) || {}), i = this.uniforms = (i || []).slice(), 
        this.contextDesc = {};
        for (let e = 0, t = i.length; e < t; e++) {
            const t = i[e];
            if (A(t)) if (t.indexOf("[") > 0) {
                const {name: e, len: n} = Xi(t);
                this.contextDesc[e] = {
                    name: e,
                    type: "array",
                    length: n
                };
            } else this.contextDesc[t] = null; else if (t.name.indexOf("[") > 0) {
                const {name: e, len: n} = Xi(t.name);
                this.contextDesc[e] = {
                    name: e,
                    type: "array",
                    length: n,
                    fn: t.fn
                };
            } else this.contextDesc[t.name] = t;
        }
        this.extraCommandProps = o && E({}, o) || {}, this.commands = {}, this._compileSource();
    }
    set shaderDefines(e) {
        this._shaderDefines = e, this.dkey = Object.keys(this._shaderDefines).join();
    }
    get shaderDefines() {
        return this._shaderDefines || {};
    }
    setDefines(e) {
        this.shaderDefines = e;
    }
    setFramebuffer(e) {
        return this.context.framebuffer = e, this;
    }
    run(e, t, n) {
        return t(n);
    }
    getShaderCommandKey(e, t, n) {
        return this.dkey || "default";
    }
    getVersion(e, t) {
        if ("#version" === t.substring(0, 8)) return "";
        return 0 === e.limits.version.indexOf("WebGL 2.0") && 300 === this.version ? "#version 300 es\n" : "#version 100\n";
    }
    getActiveVars(e, t, n, r) {
        const i = r;
        if (Wi[i]) return Wi[i];
        const s = e._gl, o = s.createProgram(), a = s.createShader(35633);
        s.shaderSource(a, t), s.compileShader(a);
        const l = s.createShader(35632);
        s.shaderSource(l, n), s.compileShader(l), s.attachShader(o, l), s.attachShader(o, a), 
        s.linkProgram(o);
        const c = s.getProgramParameter(o, 35721), h = [];
        for (let e = 0; e < c; ++e) {
            const t = s.getActiveAttrib(o, e);
            t && h.push({
                name: t.name,
                type: t.type
            });
        }
        const d = s.getProgramParameter(o, 35718), u = [];
        for (let e = 0; e < d; ++e) {
            const t = s.getActiveUniform(o, e);
            let n = t.name;
            t.name.indexOf("[") > 0 && (n = n.replace("[0]", "")), u.push(n);
        }
        return s.deleteProgram(o), s.deleteShader(a), s.deleteShader(l), Wi[i] = {
            activeUniforms: u,
            activeAttributes: h
        }, Wi[i];
    }
    _insertDefines(e, t) {
        const n = [];
        for (const e in t) N(t, e) && !O(t[e]) && n.push(`#define ${e} ${t[e]}\n`);
        return n.join("") + e;
    }
    createMeshCommand(e, t, n = {}, r) {
        const i = t.getDefines(), s = t.getElements(), o = t instanceof yr, a = t.disableVAO, l = D(e) && !a, c = E({}, this.shaderDefines || {}, i || {}), h = this._insertDefines(this.vert, c), d = this.getVersion(e, h) + h, u = this._insertDefines(this.frag, c), f = this.getVersion(e, u) + u, m = q(d) + "_" + q(f), {activeAttributes: g, activeUniforms: _} = this.getActiveVars(e, d, f, m), p = {};
        g.forEach(((t, n) => {
            const r = t.name;
            p[r] = l ? n : e.prop(r);
        }));
        const v = {};
        _.forEach((t => {
            v[t] = e.prop(t);
        }));
        const x = this.contextDesc;
        for (const t in x) if (x[t] && x[t].type === Gi) v[t] = x[t].fn; else if (x[t] && x[t].type === Vi) {
            const n = x[t].name, r = x[t].length;
            for (let t = 0; t < r; t++) {
                const r = `${n}[${t}]`;
                v[r] = e.prop(r);
            }
        } else v[t] = e.prop(t);
        const y = {
            vert: d,
            frag: f,
            uniforms: v,
            attributes: p
        };
        l && (y.vao = e.prop("vao")), l && !o || !s || I(s) || (y.elements = e.prop("elements")), 
        y.count = e.prop("count"), y.offset = e.prop("offset"), y.primitive = e.prop("primitive"), 
        y.framebuffer = e.prop("framebuffer"), o && (y.instances = e.prop("instances")), 
        E(y, this.extraCommandProps, n);
        const b = e(y);
        return g.key = g.map((e => e.name)).join(), b.activeAttributes = g, b;
    }
    dispose() {
        for (const e in this.commands) {
            const t = this.commands[e];
            t && (t.destroy && !t[ee] && (t[ee] = !0, t.destroy()));
        }
        this.commands = {}, delete this.vert, delete this.frag;
    }
    appendDescUniforms(e, t) {
        const n = t, r = this.contextDesc;
        for (const i in r) if (r[i]) if ("array" === r[i].type) {
            const s = i, o = r[i].length;
            let a = t[i];
            if (r[i].fn && (a = r[i].fn(null, t)), !a) continue;
            if (a.length !== o) throw new Error(`${s} uniform's length is not ${o}`);
            n[s] = n[s] || {};
            for (let t = 0; t < o; t++) n[s][`${t}`] = a[t].getREGLTexture ? a[t].getREGLTexture(e) : a[t];
        } else "function" === r[i].type && (Object.getOwnPropertyDescriptor(n, i) || Object.defineProperty(n, i, {
            configurable: !1,
            enumerable: !0,
            get: function() {
                return r[i].fn(null, t);
            }
        }));
        return n;
    }
    setUniforms(e) {
        if (e.modelMatrix || e.positionMatrix) throw new Error("modelMatrix or positionMatrix is reserved uniform name for Mesh, please change to another name");
        return this.contextKeys = e ? Object.keys(e).join() : null, this.context = e, this;
    }
    _compileSource() {
        this.vert && (this.vert = Zr.compile(this.vert)), this.frag && (this.frag = Zr.compile(this.frag));
    }
}

function Xi(e) {
    const t = e.indexOf("["), n = e.indexOf("]");
    return {
        name: e.substring(0, t),
        len: +e.substring(t + 1, n)
    };
}

const Ki = new gi;

class Zi extends qi {
    getShaderCommandKey(e, t, n) {
        if (e && e.wgpu) {
            const e = t.getShaderFnValues(this.uid);
            if (e) {
                const {funcs: t, key: r, commandKey: i} = e;
                if (!t.length) return i;
                const s = t.map((e => e(null, n)));
                if (Ki.generateValuesKey(s) === r) return i;
            }
            const r = this._gpuFramebuffer, i = this.extraCommandProps;
            Ki.readFromREGLCommand(i, t, n, r);
            const s = Ki.getSignatureKey();
            return t.setShaderFnValues(this.uid, {
                funcs: Ki.functionProps.map((e => e.func)),
                key: Ki.getFnValuesKey(),
                commandKey: s
            }), s;
        }
        return super.getShaderCommandKey(e, t, n);
    }
    createMeshCommand(e, t, n, r) {
        if (e && e.wgpu) {
            const i = this.context, s = this._gpuFramebuffer, o = E({}, this.shaderDefines || {}, t.getDefines()), {vert: a, frag: l} = this._compileWGSLSource(o), c = new Ii(this.name, e, a, l, t, this.contextDesc, o, i), h = new gi, d = E({}, this.extraCommandProps || {}, n || {});
            h.readFromREGLCommand(d, t, r, s);
            const u = c.build(h, s);
            return u.uid = this.uid + "-" + this.commandId++, u;
        }
        return super.createMeshCommand(e, t, n);
    }
    _compileWGSLSource(e) {
        const t = ni.compile(this.wgslVert, e);
        let n;
        return this.wgslFrag && (n = ni.compile(this.wgslFrag, e)), {
            vert: t,
            frag: n
        };
    }
    run(e, t, n) {
        if (!e.wgpu) return super.run(e, t, n);
        if (!n || !n.length) return;
        const r = e;
        this.isGPU = !0;
        const i = r.dynamicBufferPool, s = this._getCurrentRenderPassEncoder(r);
        s.setPipeline(t.pipeline);
        const {uid: o, bindGroupFormat: a, vertexInfo: l, layout: c} = t;
        this._buffers || (this._buffers = {});
        let h = this._buffers[o];
        h || (h = this._buffers[o] = new _r(a.getShaderUniforms(), i)), this._dynamicOffsets || (this._dynamicOffsets = new zi), 
        this._shaderDynamicOffsets || (this._shaderDynamicOffsets = new zi), this._shaderDynamicOffsets.reset(), 
        h.writeBuffer(n[0], this._shaderDynamicOffsets);
        const d = this._shaderDynamicOffsets.getItems();
        for (let e = 0; e < n.length; e++) {
            this._dynamicOffsets.reset();
            const t = n[e].meshObject, u = t.writeDynamicBuffer(o, n[e], a.getMeshUniforms(), i, this._dynamicOffsets), f = a.uuid + "-" + u.version + "-" + h.version + "-" + t.textureVersion + "-" + (t.material && t.material.textureVersion || 0);
            let m = t.getBindGroup(f);
            m && !this._checkBindGroupTextures(m, n[e]) && (m.outdated = !0), m && !m.outdated || (m = a.createFormatBindGroup(r, t, n[e], c, h, u), 
            a.copyTextures(m, n[e]), t.setBindGroup(f, m)), this._dynamicOffsets.addItems(d);
            const g = this._dynamicOffsets.getDynamicOffsets();
            let _;
            s.setBindGroup(0, m.bindGroup, g), t instanceof yr && (_ = t);
            for (const e in l) {
                const n = l[e];
                let r = t.geometry.getBuffer(n.geoAttrName || e);
                !r && _ && (r = _.getInstancedBuffer(e)), s.setVertexBuffer(n.location, r, 0, r.byteLength);
            }
            const p = t.getElements(), v = t.geometry.getDrawOffset(), x = t.geometry.getDrawCount();
            let y = 1;
            _ && (y = _.instanceCount), t.geometry.isIndexedElements() ? (s.setIndexBuffer(p, p.itemType), 
            s.drawIndexed(x, y, v)) : s.draw(x, y, v), r.incrDrawCall();
        }
        s.end();
    }
    _checkBindGroupTextures(e, t) {
        if (!e.uniformTextures) return !0;
        const n = e.uniformTextures;
        for (const e in n) if (n[e] !== t[e]) return !1;
        return !0;
    }
    _getCurrentRenderPassEncoder(e) {
        return e.getRenderPassEncoder(this._gpuFramebuffer);
    }
    setFramebuffer(e) {
        return e ? e.getRenderPassDescriptor ? (this._gpuFramebuffer = e, this) : super.setFramebuffer(e) : this._gpuFramebuffer ? (this._gpuFramebuffer = null, 
        this) : super.setFramebuffer(e);
    }
    dispose() {
        if (!this.isGPU) return void super.dispose();
        for (const e in this._buffers) this._buffers[e] && this._buffers[e].dispose();
        const e = this.gpuCommands;
        if (e) for (let t = 0; t < e.length; t++) e[t] && e[t].bindGroupFormat && e[t].bindGroupFormat.dispose();
    }
}

class Yi extends Zi {
    draw(e, t) {
        if (!t || !t.length) return 0;
        const n = [];
        let r, i = 0;
        for (let s = 0, o = t.length; s < o; s++) {
            if (!t[s].isValid()) {
                s === o - 1 && r && n.length && this.run(e, r, n);
                continue;
            }
            if (!t[s]._geometry.getDrawCount() || !this._runFilter(t[s])) {
                s === o - 1 && r && n.length && this.run(e, r, n);
                continue;
            }
            const a = t[s].getRenderProps(e);
            this._ensureContextDefines(a), a.shaderContext = this.context, a.meshObject = t[s], 
            this.appendDescUniforms(e, a);
            const l = this.getMeshCommand(e, t[s], a);
            t[s].appendGeoAttributes(a, e, l.activeAttributes), n.length && r !== l && (this.run(e, r, n), 
            n.length = 0), n.push(a), i++, s < o - 1 ? r = l : s === o - 1 && this.run(e, l, n);
        }
        return i;
    }
    _ensureContextDefines(e) {
        if (this.context && (e.contextKeys || (e.contextKeys = {}), e.contextKeys[this.uid] !== this.contextKeys)) {
            for (const t in this.context) "framebuffer" === t || Object.getOwnPropertyDescriptor(e, t) || Object.defineProperty(e, t, {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.shaderContext[t];
                }
            });
            Object.getOwnPropertyDescriptor(e, "framebuffer") || Object.defineProperty(e, "framebuffer", {
                configurable: !1,
                enumerable: !0,
                get: function() {
                    return this.targetFramebuffer || this.shaderContext && this.shaderContext.framebuffer;
                }
            }), e.contextKeys[this.uid] = this.contextKeys;
        }
    }
    _runFilter(e) {
        const t = this.filter;
        if (!t) return !0;
        if (Array.isArray(t)) {
            for (let n = 0; n < t.length; n++) if (!t[n](e)) return !1;
            return !0;
        }
        return t(e);
    }
    getMeshCommand(e, t, n) {
        this._cmdKeys || (this._cmdKeys = {});
        const r = t.getMaterial();
        let i = !1;
        r && (i = r.doubleSided);
        const s = this.getShaderCommandKey(e, t, n);
        let o = this._cmdKeys[s];
        o || (o = this._cmdKeys[s] = {});
        const a = t.getCommandKey(e);
        o[a] || (o[a] = s + "_" + t.getCommandKey());
        const l = o[a];
        let c = this.commands[l];
        if (!c) {
            const r = {};
            i && this.extraCommandProps && (r.cull = {
                enable: !1
            }), c = this.commands[l] = this.createMeshCommand(e, t, r, n);
        }
        return c;
    }
}

var $i = "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}";

const Ji = new Float32Array([ -1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, -1 ]), Qi = new Float32Array([ 0, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 0 ]);

class es extends Yi {
    constructor(e) {
        e.vert = e.vert || $i, e.wgslVert = e.wgslVert || "", e.extraCommandProps = e.extraCommandProps || {}, 
        e.extraCommandProps.depth || (e.extraCommandProps.depth = {
            enable: !1,
            mask: !1
        }), e.extraCommandProps.stencil || (e.extraCommandProps.stencil = {
            enable: !1
        }), super(e);
    }
    draw(e) {
        return this._quadMesh || this._createQuadMesh(e), super.draw(e, this._quadMesh);
    }
    getMeshCommand(e) {
        const t = this.dkey || "";
        return this.commands[t + "_quad"] || (this.commands[t + "_quad"] = this.createMeshCommand(e, this._quadMesh[0])), 
        this.commands[t + "_quad"];
    }
    _createQuadMesh(e) {
        const t = new Ye({
            aPosition: Ji,
            aTexCoord: Qi
        }, null, Ji.length / 2, {
            positionSize: 2,
            primitive: "triangles"
        });
        t.generateBuffers(e), this._quadMesh = [ new xr(t) ];
    }
    dispose() {
        if (this._quadMesh) {
            const e = this._quadMesh[0];
            e.geometry.dispose(), e.dispose();
        }
        return delete this._quadMesh, super.dispose();
    }
}

class ts extends es {
    constructor() {
        super({
            name: "fxaa",
            frag: "#define SHADER_NAME FXAA\nprecision mediump float;\nvarying vec2 vTexCoord;\nuniform float enableFXAA;\nuniform float enableToneMapping;\nuniform float enableSharpen;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\n#ifdef HAS_NOAA_TEX\nuniform sampler2D noAaTextureSource;\n#endif\n#ifdef HAS_POINT_TEX\nuniform sampler2D pointTextureSource;\n#endif\n#ifdef HAS_TAA_TEX\nuniform sampler2D taaTextureSource;\n#ifdef HAS_FXAA_TEX\nuniform sampler2D fxaaTextureSource;\n#endif\n#endif\nuniform float pixelRatio;\nuniform float sharpFactor;\n#ifdef HAS_OUTLINE_TEX\nuniform sampler2D textureOutline;\nuniform float highlightFactor;\nuniform float outlineFactor;\nuniform float outlineWidth;\nuniform vec3 outlineColor;\n#endif\nvec2 c;\nvec4 d(vec2 e) {\n  \n#ifdef HAS_TAA_TEX\nvec4 f = texture2D(textureSource, e);\n  vec4 taa = texture2D(taaTextureSource, e);\n#ifdef HAS_FXAA_TEX\nvec4 h = texture2D(fxaaTextureSource, e);\n#else\nvec4 h = vec4(.0);\n#endif\nvec4 i = taa + f * (1. - taa.a);\n  return h + i * (1. - h.a);\n#else\nreturn texture2D(textureSource, e);\n#endif\n}\nvec3 j(const in vec3 k, const float l) {\n  vec2 m = pixelRatio / resolution.xy;\n  float n = .0;\n  vec4 o = texture2D(textureSource, c + m * vec2(-1., -1.));\n  o.rgb = mix(vec3(.0), o.rgb, sign(o.a));\n  n += mix(.0, 1., sign(o.a));\n  vec4 u = texture2D(textureSource, c + m * vec2(1.));\n  u.rgb = mix(vec3(.0), u.rgb, sign(u.a));\n  n += mix(.0, 1., sign(u.a));\n  vec4 v = texture2D(textureSource, c + m * vec2(1., -1.));\n  v.rgb = mix(vec3(.0), v.rgb, sign(v.a));\n  n += mix(.0, 1., sign(v.a));\n  vec4 A = texture2D(textureSource, c + m * vec2(-1., 1.));\n  A.rgb = mix(vec3(.0), A.rgb, sign(A.a));\n  n += mix(.0, 1., sign(A.a));\n  return k + l * (n * k - o.rgb - v.rgb - A.rgb - u.rgb);\n}\nvec4 B(const in vec4 k) {\n  return vec4(j(k.rgb, sharpFactor), k.a);\n}\nvec3 C(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float D = 2.43;\n  const float E = .59;\n  const float F = .14;\n  return (x * (a * x + b)) / (x * (D * x + E) + F);\n}\nvec3 G(vec3 k) {\n  k = k / (k + vec3(1.));\n  return k = pow(k, vec3(1. / 2.2));\n}\n#ifdef HAS_OUTLINE_TEX\nvec4 H() {\n  float I = 2.;\n  float J = 1.;\n  float K = pixelRatio / resolution[0] * outlineWidth;\n  float L = pixelRatio / resolution[1] * outlineWidth;\n  vec4 M = (texture2D(textureOutline, c + vec2(K, L)));\n  vec4 N = (texture2D(textureOutline, c + vec2(K, .0)));\n  vec4 O = (texture2D(textureOutline, c + vec2(K, -L)));\n  vec4 P = (texture2D(textureOutline, c + vec2(.0, -L)));\n  vec4 Q = (texture2D(textureOutline, c + vec2(-K, -L)));\n  vec4 R = (texture2D(textureOutline, c + vec2(-K, .0)));\n  vec4 S = (texture2D(textureOutline, c + vec2(-K, L)));\n  vec4 T = (texture2D(textureOutline, c + vec2(.0, L)));\n  vec4 U = -I * R + I * N + -J * S + J * M + -J * Q + J * O;\n  vec4 V = -I * P + I * T + -J * Q + J * S + -J * O + J * M;\n  float W = sqrt(dot(V, V) + dot(U, U));\n  bool X = W < 1. / 65025.;\n  vec3 Y = (texture2D(textureOutline, c)).r * outlineColor;\n  if(Y == vec3(.0) || (highlightFactor == .0 && X)) {\n    return vec4(.0);\n  }\n  float Z = X ? highlightFactor : min(1., sqrt(W) * outlineFactor);\n  return Z * vec4(Y, 1.);\n}\nvec4 ba(const in vec4 k) {\n  vec4 H = H();\n  return H + vec4(k) * (1. - H.a);\n}\n#endif\nvoid main() {\n  c = vTexCoord;\n  vec4 k;\n  if(enableFXAA == 1.) {\n    \n  } else {\n    k = d(vTexCoord);\n  }\n  if(enableSharpen == 1.) {\n    k = B(k);\n  }\n#if defined(HAS_NOAA_TEX) || defined(HAS_POINT_TEX)\nvec4 bb = vec4(.0);\n  vec4 bc = vec4(.0);\n#ifdef HAS_POINT_TEX\nbb = texture2D(pointTextureSource, vTexCoord);\n#endif\n#ifdef HAS_NOAA_TEX\nbc = texture2D(noAaTextureSource, vTexCoord);\n#endif\nvec4 bd = bb + bc * (1. - bb.a);\n  k = bd + k * (1. - bd.a);\n#endif\nif(enableToneMapping == 1.) {\n    k.rgb = G(k.rgb);\n  }\n#ifdef HAS_OUTLINE_TEX\nk = ba(k);\n#endif\ngl_FragColor = k;\n}",
            wgslFrag: "",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        const n = (this.dkey || "") + "_fxaa";
        return this.commands[n] || (this.commands[n] = this.createMeshCommand(e, t)), this.commands[n];
    }
}

var ns = "#include <gl2_vert>\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nuniform mat4 projViewModelMatrix;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}", rs = "precision mediump float;\n#include <gl2_frag>\nuniform sampler2D baseColorTexture;\nuniform float opacity;\nuniform vec4 baseColor;\nuniform float alphaTest;\n#ifdef HAS_DEBUG\nuniform sampler2D debugTexture;\n#endif\nvarying vec2 vTexCoord;\nvoid main() {\n  glFragColor = texture2D(baseColorTexture, vTexCoord);\n  glFragColor *= baseColor;\n#ifdef HAS_DEBUG\nvec4 c = texture2D(debugTexture, vTexCoord);\n  glFragColor = vec4(c.rgb + glFragColor.rgb * (1. - c.a), c.a + glFragColor.a * (1. - c.a));\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n  glFragColor *= opacity;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class is extends Yi {
    constructor(e) {
        const t = [], n = e && e.extraCommandProps || {};
        e.vert = ns, e.frag = rs, super({
            name: "image",
            vert: ns,
            frag: rs,
            wgslVert: "",
            wgslFrag: "",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, n) {
                    return c.multiply(t, n.projViewMatrix, n.modelMatrix);
                }
            } ],
            extraCommandProps: n
        });
    }
    getMeshCommand(e, t) {
        const n = t.getCommandKey(e);
        return this.commands["image_" + n] || (this.commands["image_" + n] = this.createMeshCommand(e, t)), 
        this.commands["image_" + n];
    }
}

class ss extends es {
    constructor() {
        super({
            vert: $i,
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec2 resolution;\nuniform sampler2D textureSource;\nuniform float enableVignette;\nuniform float enableGrain;\nuniform float enableLut;\nuniform float timeGrain;\nuniform float grainFactor;\nuniform vec2 lensRadius;\nuniform float frameMod;\nuniform sampler2D lookupTable;\n#include <srgb_frag>\nfloat c(const in vec2 d) {\n  vec3 e = fract(vec3(d.xyx) * .1031);\n  e += dot(e, e.yzx + 19.19);\n  return fract((e.x + e.y) * e.z);\n}\nfloat f() {\n  float h = c(gl_FragCoord.xy + 1000.0 * fract(timeGrain));\n  float i = h * 2. - 1.;\n  h = i * inversesqrt(abs(i));\n  h = max(-1., h);\n  h = h - sign(i) + .5;\n  return (h + .5) * .5;\n}\nvec4 j(const in vec4 k) {\n  float l = f();\n  return vec4(mix(k.rgb, k.rgb * (k.rgb + (1. - k.rgb) * 2. * l), grainFactor), k.a);\n}\nfloat m(const in vec2 d, const in float n) {\n  vec3 o = vec3(.06711056, .00583715, 52.9829189);\n  return fract(o.z * fract(dot(d.xy + n * vec2(47., 17.) * .695, o.xy)));\n}\nfloat u() {\n  vec2 v = lensRadius;\n  v.y = min(v.y, v.x - 1e-4);\n  float A = m(gl_FragCoord.xy, frameMod);\n  A = (v.x - v.y) * (v.x + v.y) * .07 * (A - .5);\n  return smoothstep(v.x, v.y, A + distance(vTexCoord, vec2(.5)));\n}\nvec4 B(const in vec4 k) {\n  float l = u();\n  return vec4(linearTosRGB(sRGBToLinear(k.rgb) * l), clamp(k.a + (1. - l), .0, 1.));\n}\nvec4 C(in vec4 D, in sampler2D E) {\n  mediump float F = D.b * 63.;\n  mediump vec2 G;\n  G.y = floor(floor(F) / 8.);\n  G.x = floor(F) - G.y * 8.;\n  mediump vec2 H;\n  H.y = floor(ceil(F) / 8.);\n  H.x = ceil(F) - H.y * 8.;\n  highp vec2 I;\n  I.x = G.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  I.y = G.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nI.y = 1. - I.y;\n#endif\nhighp vec2 J;\n  J.x = H.x * .125 + .5 / 512. + (.125 - 1. / 512.) * D.r;\n  J.y = H.y * .125 + .5 / 512. + (.125 - 1. / 512.) * D.g;\n#ifdef LUT_FLIP_Y\nJ.y = 1. - J.y;\n#endif\nlowp vec4 K = texture2D(E, I);\n  lowp vec4 L = texture2D(E, J);\n  lowp vec4 M = mix(K, L, fract(F));\n  return M;\n}\nvoid main() {\n  vec4 k = texture2D(textureSource, vTexCoord);\n  if(enableLut == 1.) {\n    k = C(k, lookupTable);\n  }\n  if(enableVignette == 1.) {\n    k = B(k);\n  }\n  if(enableGrain == 1.) {\n    k = j(k);\n  }\n  gl_FragColor = k;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.postprocess || (this.commands.postprocess = this.createMeshCommand(e, t)), 
        this.commands.postprocess;
    }
}

const os = [ [ .263385, -.0252475 ], [ -.38545, .054485 ], [ -.139795, -.5379925 ], [ -.2793775, .6875475 ], [ .7139025, .4710925 ], [ .90044, -.16422 ], [ .4481775, -.82799 ], [ -.9253375, -.2910625 ], [ .3468025, 1.02292 ], [ -1.13742, .33522 ], [ -.7676225, -.9123175 ], [ -.2005775, -1.1774125 ], [ -.926525, .96876 ], [ 1.12909, -.7500325 ], [ .9603, 1.14625 ] ], as = os.length, ls = [ 0, 0 ];

for (let e = 0; e < os.length; e++) ls[0] += os[e][0], ls[1] += os[e][1];

ls[0] /= as, ls[1] /= as;

class cs {
    constructor(e) {
        this._frameNum = 0, this._ratio = e || .05, this._avg = [ ls[0] * this._ratio, ls[1] * this._ratio ];
    }
    getRatio() {
        return this._ratio;
    }
    setRatio(e) {
        this._ratio !== e && (this._ratio = e, this.reset()), this._avg = [ ls[0] * this._ratio, ls[1] * this._ratio ];
    }
    getAverage() {
        return this._avg;
    }
    reset() {
        this._frameNum = 0;
    }
    getJitter(e) {
        const t = this._frameNum % as, n = this._ratio;
        return f.set(e, os[t][0] * n, os[t][1] * n), e;
    }
    frame() {
        this._frameNum++, this._frameNum % as == 0 && (this._frameNum = 0);
    }
    getSampleCount() {
        return as;
    }
}

class hs {
    constructor(e, t, n = 5) {
        this._regl = e, this._renderer = new wr(e), this._inputRGBM = t, this._level = n;
    }
    render(e, t) {
        this._initShaders(), this._createTextures(e), this._blur(e, t || 0);
        const n = {
            blurTex0: this._blur01Tex,
            blurTex1: this._blur11Tex,
            blurTex2: this._blur21Tex,
            blurTex3: this._blur31Tex,
            blurTex4: this._blur41Tex
        };
        return this._level > 5 && (n.blurTex5 = this._blur51Tex, n.blurTex6 = this._blur61Tex), 
        n;
    }
    _blur(e, t) {
        let n = this._blurUniforms;
        if (n || (n = this._blurUniforms = {
            "rgbmRange": 7,
            "blurDir": [ 0, 0 ],
            "outSize": [ 0, 0 ],
            "pixelRatio": [ 1, 1 ],
            "outputSize": [ 0, 0 ]
        }), f.set(n.outSize, e.width, e.height), e.config && e.config.sampleCount > 1) {
            const e = {
                "HAS_MULTISAMPLED": 1
            };
            this._blur0Shader.setDefines(e);
        } else this._blur0Shader.setDefines({});
        this._blurOnce(this._blur0Shader, e, this._blur00FBO, this._blur01FBO, .5, t), this._blurOnce(this._blur1Shader, this._blur01FBO.color[0], this._blur10FBO, this._blur11FBO, .5), 
        this._blurOnce(this._blur2Shader, this._blur11FBO.color[0], this._blur20FBO, this._blur21FBO, .5), 
        this._blurOnce(this._blur3Shader, this._blur21FBO.color[0], this._blur30FBO, this._blur31FBO, .5), 
        this._blurOnce(this._blur4Shader, this._blur31FBO.color[0], this._blur40FBO, this._blur41FBO, .5), 
        this._level > 5 && (this._blurOnce(this._blur5Shader, this._blur41FBO.color[0], this._blur50FBO, this._blur51FBO, .5), 
        this._blurOnce(this._blur6Shader, this._blur51FBO.color[0], this._blur60FBO, this._blur51FBO, .5));
    }
    _blurOnce(e, t, n, r, i, s) {
        const o = Math.ceil(i * t.width), a = Math.ceil(i * t.height);
        n.width === o && n.height === a || n.resize(o, a), r.width === o && r.height === a || r.resize(o, a);
        const l = this._blurUniforms;
        l.luminThreshold = s, l.TextureBlurInput = t, l.inputRGBM = +this._inputRGBM, f.set(l.blurDir, 0, 1), 
        f.set(l.outputSize, n.width, n.height), this._renderer.render(e, l, null, n), e.shaderDefines && e.shaderDefines.HAS_MULTISAMPLED && e.setDefines({}), 
        l.luminThreshold = 0, l.inputRGBM = 1, f.set(l.blurDir, 1, 0), l.TextureBlurInput = n.color[0], 
        this._renderer.render(e, l, null, r);
    }
    dispose() {
        this._blur0Shader && (this._blur0Shader.dispose(), delete this._blur0Shader, this._blur1Shader.dispose(), 
        this._blur2Shader.dispose(), this._blur3Shader.dispose(), this._blur4Shader.dispose(), 
        this._blur5Shader && (this._blur5Shader.dispose(), this._blur6Shader.dispose(), 
        delete this._blur5Shader)), this._blur00Tex && (delete this._blur00Tex, this._blur00FBO.destroy(), 
        this._blur01FBO.destroy(), this._blur10FBO.destroy(), this._blur11FBO.destroy(), 
        this._blur20FBO.destroy(), this._blur21FBO.destroy(), this._blur30FBO.destroy(), 
        this._blur31FBO.destroy(), this._blur40FBO.destroy(), this._blur41FBO.destroy(), 
        this._blur50FBO && (this._blur50FBO.destroy(), this._blur51FBO.destroy(), this._blur60FBO.destroy(), 
        this._blur61FBO.destroy()));
    }
    _createTextures(e) {
        if (this._blur00Tex) return;
        let t = e.width, n = e.height;
        this._blur00Tex = this._createColorTex(e, t, n), this._blur00FBO = this._createBlurFBO(this._blur00Tex), 
        this._blur01Tex = this._createColorTex(e), this._blur01FBO = this._createBlurFBO(this._blur01Tex), 
        t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur10Tex = this._createColorTex(e, t, n), 
        this._blur10FBO = this._createBlurFBO(this._blur10Tex), this._blur11Tex = this._createColorTex(e, t, n), 
        this._blur11FBO = this._createBlurFBO(this._blur11Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), 
        this._blur20Tex = this._createColorTex(e, t, n), this._blur20FBO = this._createBlurFBO(this._blur20Tex), 
        this._blur21Tex = this._createColorTex(e, t, n), this._blur21FBO = this._createBlurFBO(this._blur21Tex), 
        t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur30Tex = this._createColorTex(e, t, n), 
        this._blur30FBO = this._createBlurFBO(this._blur30Tex), this._blur31Tex = this._createColorTex(e, t, n), 
        this._blur31FBO = this._createBlurFBO(this._blur31Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), 
        this._blur40Tex = this._createColorTex(e, t, n), this._blur40FBO = this._createBlurFBO(this._blur40Tex), 
        this._blur41Tex = this._createColorTex(e, t, n), this._blur41FBO = this._createBlurFBO(this._blur41Tex), 
        this._level > 5 && (t = Math.ceil(t / 2), n = Math.ceil(n / 2), this._blur50Tex = this._createColorTex(e, t, n), 
        this._blur50FBO = this._createBlurFBO(this._blur50Tex), this._blur51Tex = this._createColorTex(e, t, n), 
        this._blur51FBO = this._createBlurFBO(this._blur51Tex), t = Math.ceil(t / 2), n = Math.ceil(n / 2), 
        this._blur60Tex = this._createColorTex(e, t, n), this._blur60FBO = this._createBlurFBO(this._blur60Tex), 
        this._blur61Tex = this._createColorTex(e, t, n), this._blur61FBO = this._createBlurFBO(this._blur61Tex));
    }
    _createColorTex(e, t, n) {
        const r = this._regl, i = t || e.width, s = n || e.height;
        return r.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: i,
            height: s
        });
    }
    _createBlurFBO(e) {
        return this._regl.framebuffer({
            width: e.width,
            height: e.height,
            colors: [ e ],
            depth: !1,
            stencil: !1
        });
    }
    _initShaders() {
        if (!this._blur0Shader) {
            const e = {
                vert: $i,
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t) => t.outputSize[0],
                        height: (e, t) => t.outputSize[1]
                    }
                },
                frag: "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\nuniform float inputRGBM;\nuniform float luminThreshold;\n#define SHADER_NAME GAUSSIAN_BLUR0\nconst vec3 c = vec3(.2126, .7152, .0722);\nfloat d(const in vec3 e) {\n  return dot(e, c);\n}\nvec4 f(vec4 e) {\n  float h = max(sign(d(e.rgb) - luminThreshold), .0);\n  return e * h;\n}\nvec2 i;\nvec4 j(const in vec3 e, const in float k) {\n  vec4 l;\n  vec3 m = e / k;\n  l.a = clamp(max(max(m.r, m.g), max(m.b, 1e-6)), .0, 1.);\n  l.a = ceil(l.a * 255.) / 255.;\n  l.rgb = m / l.a;\n  return l;\n}\nvec3 n(const in vec4 e, const in float k) {\n  if(inputRGBM == .0)\n    return e.rgb;\n  return k * e.rgb * e.a;\n}\nvec4 o() {\n  vec3 u = .375 * (f(vec4(n(texture2D(TextureBlurInput, i.xy), rgbmRange), 1.))).rgb;\n  vec2 v;\n  vec2 A = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  v = A * 1.2;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy + v.xy), rgbmRange), 1.))).rgb;\n  u += .3125 * (f(vec4(n(texture2D(TextureBlurInput, i.xy - v.xy), rgbmRange), 1.))).rgb;\n  return vec4(u, 1.);\n}\nvoid main(void) {\n  i = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = o();\n  e = j(e.rgb, rgbmRange);\n  gl_FragColor = e;\n}",
                wgslFrag: "",
                name: "blur0"
            };
            this._blur0Shader = new es(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR1\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .3125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.2857142857142858;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}", 
            e.wgslFrag = "", e.name = "blur1", this._blur1Shader = new es(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR2\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .2734375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.3333333333333333;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .328125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.111111111111111;\n  e += .03515625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .03515625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}", 
            e.wgslFrag = "", e.name = "blur2", this._blur2Shader = new es(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR3\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .24609375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.3636363636363635;\n  e += .322265625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .322265625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.1818181818181817;\n  e += .0537109375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .0537109375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}", 
            e.wgslFrag = "", e.name = "blur3", this._blur3Shader = new es(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR4\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .2255859375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  f = h * 1.3846153846153846;\n  e += .314208984375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .314208984375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.230769230769231;\n  e += .06982421875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .06982421875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 5.076923076923077;\n  e += .003173828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .003173828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}", 
            e.wgslFrag = "", e.name = "blur4", this._blur4Shader = new es(e), this._level > 5 && (e.frag = "precision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR5\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .20947265625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  h *= outSize.y * .00075;\n  f = h * 1.4;\n  e += .30548095703125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .30548095703125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.2666666666666666;\n  e += .08331298828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .08331298828125 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 5.133333333333334;\n  e += .00640869140625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .00640869140625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}", 
            e.wgslFrag = "", e.name = "blur5", this._blur5Shader = new es(e), e.frag = "#version 100\nprecision highp float;\nuniform float rgbmRange;\nuniform sampler2D TextureBlurInput;\nuniform vec2 blurDir;\nuniform vec2 outSize;\nuniform vec2 pixelRatio;\nuniform vec2 outputSize;\n#define SHADER_NAME GAUSSIAN_BLUR6\nvec2 c;\n#include <rgbm_frag>\nvec4 d() {\n  vec3 e = .196380615234375 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy), rgbmRange), 1.)).rgb;\n  vec2 f;\n  vec2 h = pixelRatio.xy * blurDir.xy / outputSize.xy;\n  h *= outSize.y * .00075;\n  f = h * 1.411764705882353;\n  e += .2967529296875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .2967529296875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 3.2941176470588234;\n  e += .09442138671875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .09442138671875 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  f = h * 5.176470588235294;\n  e += .0103759765625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy + f.xy), rgbmRange), 1.)).rgb;\n  e += .0103759765625 * (vec4(decodeRGBM(texture2D(TextureBlurInput, c.xy - f.xy), rgbmRange), 1.)).rgb;\n  return vec4(e, 1.);\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 i = d();\n  i = encodeRGBM(i.rgb, rgbmRange);\n  gl_FragColor = i;\n}", 
            e.wgslFrag = "", e.name = "blur6", this._blur6Shader = new es(e));
        }
    }
}

class ds {
    constructor(e) {
        this._regl = e, this._renderer = new wr(e);
    }
    render(e, t, n, r, i, s, o, a, l) {
        this._initShaders(), this._createTextures(e);
        const c = this._blurPass.render(t, n);
        return this._combine(e, c, t, r, i, s, o, a, l);
    }
    _combine(e, t, n, r, i, s, o, a, l) {
        l || this._combineTex.width === e.width && this._combineTex.height === e.height || this._combineFBO.resize(e.width, e.height);
        let c = this._combineUniforms;
        const {blurTex0: h, blurTex1: d, blurTex2: u, blurTex3: m, blurTex4: g} = t;
        c || (c = this._combineUniforms = {
            "bloomFactor": 0,
            "bloomRadius": 0,
            "rgbmRange": 7,
            "TextureBloomBlur1": h,
            "TextureBloomBlur2": d,
            "TextureBloomBlur3": u,
            "TextureBloomBlur4": m,
            "TextureBloomBlur5": g,
            "TextureInput": null,
            "TextureSource": null,
            "outputSize": [ 0, 0 ]
        }), c.noAaTextureSource = s, c.pointTextureSource = o, c.enableAA = a, c.bloomFactor = r, 
        c.bloomRadius = i, c.TextureInput = n, c.TextureSource = e, f.set(c.outputSize, e.width, e.height);
        const _ = {};
        return e.config && e.config.sampleCount > 1 && (_.HAS_MULTISAMPLED = 1), this._combineShader.setDefines(_), 
        this._renderer.render(this._combineShader, c, null, l ? null : this._combineFBO), 
        l ? null : this._combineTex;
    }
    dispose() {
        this._combineFBO && (this._combineFBO.destroy(), delete this._combineFBO), this._blurPass && (this._blurPass.dispose(), 
        delete this._blurPass), delete this._uniforms;
    }
    _createTextures(e) {
        if (this._combineTex) return;
        const t = e.width, n = e.height;
        this._combineTex = this._createColorTex(e, t, n, "uint8"), this._combineFBO = this._createBlurFBO(this._combineTex);
    }
    _createColorTex(e, t, n, r) {
        const i = this._renderer.device, s = r, o = t || e.width, a = n || e.height;
        return i.texture({
            min: "linear",
            mag: "linear",
            type: s,
            width: o,
            height: a
        });
    }
    _createBlurFBO(e) {
        return this._renderer.device.framebuffer({
            width: e.width,
            height: e.height,
            colors: [ e ],
            depth: !1,
            stencil: !1
        });
    }
    _initShaders() {
        if (!this._combineShader) {
            const e = {
                x: 0,
                y: 0,
                width: (e, t) => t.outputSize[0],
                height: (e, t) => t.outputSize[1]
            };
            this._blurPass = new hs(this._regl, !1), this._combineShader = new es({
                name: "bloom-combine",
                vert: $i,
                frag: "precision highp float;\nuniform float bloomFactor;\nuniform float bloomRadius;\nuniform float rgbmRange;\nuniform sampler2D TextureBloomBlur1;\nuniform sampler2D TextureBloomBlur2;\nuniform sampler2D TextureBloomBlur3;\nuniform sampler2D TextureBloomBlur4;\nuniform sampler2D TextureBloomBlur5;\nuniform sampler2D TextureInput;\nuniform sampler2D TextureSource;\nuniform float enableAA;\nuniform vec2 outputSize;\n#define SHADER_NAME bloomCombine\nvec2 c;\n#include <srgb_frag>\nvec3 d(const in vec4 e, const in float f) {\n  if(f <= .0)\n    return e.rgb;\n  return f * e.rgb * e.a;\n}\nfloat h(const float i, const float j) {\n  return mix(i, j * 2. - i, bloomRadius);\n}\nvec4 k() {\n  vec3 l = vec3(.0);\n  const float m = .6;\n  const float n = 1.1;\n  const float o = .9;\n  const float u = .6;\n  const float v = .3;\n  const float A = .1;\n  l += (vec4(d(texture2D(TextureBloomBlur1, c), rgbmRange), 1.)).rgb * h(n, m);\n  l += (vec4(d(texture2D(TextureBloomBlur2, c), rgbmRange), 1.)).rgb * h(o, m);\n  l += (vec4(d(texture2D(TextureBloomBlur3, c), rgbmRange), 1.)).rgb * h(u, m);\n  l += (vec4(d(texture2D(TextureBloomBlur4, c), rgbmRange), 1.)).rgb * h(v, m);\n  l += (vec4(d(texture2D(TextureBloomBlur5, c), rgbmRange), 1.)).rgb * h(A, m);\n  vec4 B;\n  if(enableAA == 1.) {\n    \n  } else {\n    B = texture2D(TextureInput, c);\n  }\n  B.rgb = mix(vec3(.0), B.rgb, sign(B.a));\n  vec4 C = texture2D(TextureSource, c);\n  float D = sqrt((l.r + l.g + l.b) / 3.);\n  vec4 E = vec4(linearTosRGB(l * bloomFactor), D);\n  return B + C * (1. - B.a) + E;\n}\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 e = k();\n  gl_FragColor = e;\n}",
                wgslVert: "",
                wgslFrag: "",
                extraCommandProps: {
                    viewport: e
                }
            });
        }
    }
}

class us extends es {
    constructor() {
        const e = [];
        super({
            name: "copy-depth",
            vert: $i,
            frag: "precision highp float;\n#include <gl2_frag>\n#define SHADER_NAME COPY_DEPTH\nuniform sampler2D TextureDepth;\nuniform vec2 textureSize;\n#include <common_pack_float>\nvoid main(void) {\n  vec2 c = gl_FragCoord.xy / textureSize.xy;\n  float d = texture2D(TextureDepth, c).r;\n  glFragColor = common_encodeDepth(d);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            wgslVert: "",
            wgslFrag: "",
            uniforms: [ {
                name: "textureSize",
                type: "function",
                fn: (t, n) => (e[0] = n.TextureDepth.width, e[1] = n.TextureDepth.height, e)
            } ],
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.TextureDepth.width,
                    height: (e, t) => t.TextureDepth.height
                }
            }
        }), this.version = 300;
    }
    getMeshCommand(e, t) {
        return this.commands.copy_depth || (this.commands.copy_depth = this.createMeshCommand(e, t)), 
        this.commands.copy_depth;
    }
}

class fs {
    static getUniformDeclares() {
        const e = [ [ 0, 0, 0, 0 ], [ 0, 0, 0, 0 ] ], t = new Array(16);
        return [ {
            name: "invProjMatrix",
            type: "function",
            fn: (e, n) => c.invert(t, n.projMatrix)
        }, {
            name: "outputFovInfo",
            type: "array",
            length: 2,
            fn: function(t, n) {
                const r = Math.tan(.5 * n.fov), i = n.outSize[0] / n.outSize[1] * r;
                return d.set(e[0], i, r, i, -r), d.set(e[1], -i, r, -i, -r), e;
            }
        }, {
            name: "reprojViewProjMatrix",
            type: "function",
            fn: (e, t) => c.multiply([], t.prevProjViewMatrix, t.cameraWorldMatrix)
        } ];
    }
    static getDefines() {
        return {
            "HAS_SSR": 1
        };
    }
    constructor(e) {
        this._regl = e, this._renderer = new wr(e), this._inputRGBM = 0;
    }
    setup(e) {
        this._initShaders(), this._createTextures(e);
    }
    getSSRUniforms(e, t, n) {
        if (!this._depthCopy) return null;
        const r = this._depthCopy;
        return {
            "TextureDepth": r,
            "TextureReflected": this.getMipmapTexture(),
            "ssrFactor": t || 1,
            "ssrQuality": n || 2,
            "outSize": [ r.width, r.height ],
            "fov": e.getFov() * Math.PI / 180,
            "prevProjViewMatrix": this._projViewMatrix || e.projViewMatrix,
            "cameraWorldMatrix": e.cameraWorldMatrix
        };
    }
    genMipMap(e, t, n) {
        return this.setup(e), this._mipmap(e), this.copyDepthTex(t), this._projViewMatrix || (this._projViewMatrix = []), 
        c.copy(this._projViewMatrix, n), delete this._depthCopied, this._outputTex;
    }
    getPrevProjViewMatrix() {
        return this._projViewMatrix;
    }
    copyDepthTex(e) {
        if (this._depthCopied) return null;
        if (this.setup(e), this._depthCopy) e.width === this._depthCopy.width && e.height === this._depthCopy.height || this._depthCopyFBO.resize(e.width, e.height); else {
            const t = {
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "uint8",
                width: e.width,
                height: e.height
            };
            this._depthCopy = this._regl.texture(t);
            const n = {
                width: e.width,
                height: e.height,
                colors: [ this._depthCopy ],
                colorFormat: "rgba"
            };
            this._depthCopyFBO = this._regl.framebuffer(n);
        }
        const t = {};
        return e.texture && e.texture.sampleCount > 1 && (t.HAS_MULTISAMPLED = 1), this._copyDepthShader.setDefines(t), 
        this._renderer.render(this._copyDepthShader, {
            "TextureDepth": e
        }, null, this._depthCopyFBO), this._depthCopied = !0, this._depthCopy;
    }
    _mipmap(e) {
        const t = this._targetFBO, n = Math.ceil(.5 * e.width), r = Math.ceil(.5 * e.height);
        t.width === n && t.height === r || t.resize(n, r);
        let i = this._blurUniforms;
        i || (i = this._blurUniforms = {
            "rgbmRange": 7,
            "outputSize": [ 0, 0 ],
            "inputSize": [ 0, 0 ]
        }), i.TextureInput = e, i.inputRGBM = +this._inputRGBM, f.set(i.outputSize, t.width, t.height), 
        f.set(i.inputSize, e.width, e.height);
        const s = {};
        e.texture && e.texture.sampleCount > 1 && (s.HAS_MULTISAMPLED = 1), this._ssrQuadShader.setDefines(s), 
        this._renderer.render(this._ssrQuadShader, i, null, t);
    }
    getMipmapTexture() {
        return this._outputTex || (this._outputTex = this._renderer.regl.texture({
            type: "uint8",
            width: 2,
            height: 2
        })), this._outputTex;
    }
    dispose() {
        this._copyDepthShader && (this._ssrQuadShader.dispose(), this._copyDepthShader.dispose(), 
        this._targetFBO.destroy(), delete this._copyDepthShader), this._depthCopy && (this._depthCopyFBO.destroy(), 
        delete this._depthCopy, delete this._depthCopyFBO);
    }
    _initShaders() {
        if (!this._copyDepthShader) {
            this._copyDepthShader = new us;
            const e = {
                name: "ssr-mipmap-quad",
                frag: "#version 100\nprecision mediump float;\nuniform sampler2D TextureInput;\nuniform vec2 outputSize;\n#define SHADER_NAME QUAD\nvec2 c;\nvoid main(void) {\n  c = gl_FragCoord.xy / outputSize.xy;\n  vec4 d = texture2D(TextureInput, c.xy);\n  gl_FragColor = d;\n}",
                wgslFrag: "",
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t) => t.outputSize[0],
                        height: (e, t) => t.outputSize[1]
                    }
                }
            };
            this._ssrQuadShader = new es(e);
        }
    }
    _createTextures(e) {
        if (!this._targetFBO) {
            const t = this._regl;
            this._outputTex && this._outputTex.destroy(), this._outputTex = t.texture({
                min: "linear",
                mag: "linear",
                type: "uint8",
                width: e.width,
                height: e.height
            }), this._targetFBO = t.framebuffer({
                width: e.width,
                height: e.height,
                colors: [ this._outputTex ],
                depth: !1,
                stencil: !1
            });
        }
    }
}

class ms extends Yi {
    constructor(e) {
        const t = e && e.extraCommandProps || {}, n = [];
        super({
            vert: "#define SHADER_NAME HEATMAP\nuniform mat4 projViewModelMatrix;\nuniform float extrudeScale;\nuniform float heatmapIntensity;\nattribute vec3 aPosition;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nattribute highp float aWeight;\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\nuniform mediump float heatmapRadius;\nconst highp float c = 1. / 255. / 16.;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float d = aWeight / 255.;\n  weight = d;\n#else\nhighp float d = heatmapWeight;\n#endif\nmediump float e = heatmapRadius;\n  vec2 f = vec2(mod(aPosition.xy, 2.) * 2. - 1.);\n  float h = sqrt(-2. * log(c / d / heatmapIntensity / GAUSS_COEF)) / 3.;\n  vExtrude = h * f;\n  vec2 i = vExtrude * e * extrudeScale;\n  vec4 j = vec4(floor(aPosition.xy * .5) + i, aPosition.z, 1);\n  gl_Position = projViewModelMatrix * j;\n}",
            frag: "#define SHADER_NAME HEATMAP\nprecision mediump float;\nuniform highp float heatmapIntensity;\nvarying vec2 vExtrude;\n#ifdef HAS_HEAT_WEIGHT\nvarying highp float weight;\n#else\nuniform highp float heatmapWeight;\n#endif\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n  \n#ifdef HAS_HEAT_WEIGHT\nhighp float c = weight;\n#else\nhighp float c = heatmapWeight;\n#endif\nfloat d = -.5 * 3. * 3. * dot(vExtrude, vExtrude);\n  float e = c * heatmapIntensity * GAUSS_COEF * exp(d);\n  gl_FragColor = vec4(e, 1., 1., 1.);\n}",
            uniforms: [ {
                name: "extrudeScale",
                type: "function",
                fn: function(e, t) {
                    return t.resolution / t.dataResolution * t.tileRatio;
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(n, t.projViewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: E({}, t, {
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one"
                    },
                    equation: "add"
                }
            })
        });
    }
}

var gs = [ -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, 1, -1, -1, -1, -1, 1, -1, -1, 1, -1, -1, 1, 1, -1, -1, 1, 1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, -1, -1, 1, -1, 1, 1, 1, 1, 1, 1, 1, 1, 1, -1, 1, -1, -1, 1, -1, 1, -1, 1, 1, -1, 1, 1, 1, 1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, 1, -1, -1, 1, -1, -1, -1, -1, 1, 1, -1, 1 ], _s = "#define SHADER_NAME SKYBOX\n#if __VERSION__ == 100\n#ifdef GL_EXT_shader_texture_lod\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\nprecision highp float;\n#define saturate(x)        clamp(x, 0.0, 1.0)\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\nvarying vec3 vWorldPos;\n#ifdef USE_AMBIENT\nuniform vec3 diffuseSPH[9];\n#else\nuniform samplerCube cubeMap;\nuniform float bias;\nuniform float size;\n#endif\nuniform float environmentExposure;\nuniform float backgroundIntensity;\nvec4 c(const in samplerCube d, const in vec3 e, const in float f, const in float h) {\n  vec3 i = e;\n  return textureCubeLod(d, i, h);\n}\nvec3 j(const in vec3 k, const in vec3 l[9]) {\n  float x = k.x;\n  float y = k.y;\n  float z = k.z;\n  vec3 m = (l[0] + l[1] * x + l[2] * y + l[3] * z + l[4] * z * x + l[5] * y * z + l[6] * y * x + l[7] * (3. * z * z - 1.) + l[8] * (x * x - y * y));\n  return max(m, vec3(.0));\n}\nfloat n(const in vec2 o) {\n  vec3 u = fract(vec3(o.xyx) * .1031);\n  u += dot(u, u.yzx + 19.19);\n  return fract((u.x + u.y) * u.z);\n}\n#if defined(TONE_MAPPING)\nconst float v = 1.;\nvec3 A(vec3 B) {\n  vec3 a = B * (B + .0245786) - .000090537;\n  vec3 b = B * (.983729 * B + .4329510) + .238081;\n  return a / b;\n}\nvec3 C(vec3 D) {\n  const mat3 E = mat3(vec3(.59719, .07600, .02840), vec3(.35458, .90834, .13383), vec3(.04823, .01566, .83777));\n  const mat3 F = mat3(vec3(1.60475, -.10208, -.00327), vec3(-.53108, 1.10813, -.07276), vec3(-.07367, -.00605, 1.07602));\n  D *= v / .6;\n  D = E * D;\n  D = A(D);\n  D = F * D;\n  return saturate(D);\n}\nvec3 G(vec3 D) {\n  return C(D);\n}\nvec4 H(in vec4 I) {\n  return vec4(mix(pow(I.rgb, vec3(.41666)) * 1.055 - vec3(.055), I.rgb * 12.92, vec3(lessThanEqual(I.rgb, vec3(.0031308)))), I.a);\n}\nvec4 J(vec4 I) {\n  return (H(I));\n}\n#endif\nvoid main() {\n  vec4 K;\n#ifdef USE_AMBIENT\nvec3 k = normalize(vWorldPos + mix(-.5 / 255., .5 / 255., n(gl_FragCoord.xy)) * 2.);\n  K = vec4(j(k, diffuseSPH), 1.);\n#else\nK = c(cubeMap, vWorldPos, size, bias);\n#endif\nK.rgb *= environmentExposure;\n  K.rgb *= backgroundIntensity;\n  glFragColor = K;\n  if(length(hsv) > .0) {\n    glFragColor.rgb = hsv_apply(clamp(glFragColor.rgb, .0, 1.), hsv);\n  }\n#if defined(TONE_MAPPING)\nglFragColor.rgb = G(glFragColor.rgb);\n  glFragColor = J(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}";

class ps extends Yi {
    constructor() {
        super({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat3 transformMatrix;\nvarying vec3 vWorldPos;\nvoid main() {\n  vWorldPos = aPosition;\n  mat4 c = mat4(mat3(viewMatrix) * transformMatrix);\n  vec4 d = projMatrix * c * vec4(vWorldPos, 1.);\n  gl_Position = d.xyww;\n}",
            frag: _s,
            extraCommandProps: {
                depth: {
                    enable: !0,
                    range: [ 1, 1 ],
                    func: "lequal"
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        }), this.version = 300;
    }
    setMode(e, t) {
        const n = {};
        return e && (n.TONE_MAPPING = 1), 0 === t && (n.USE_AMBIENT = 1), this._skyboxMesh ? this._skyboxMesh[0].setDefines(n) : this._meshDefines = n, 
        this;
    }
    draw(e) {
        return this._skyboxMesh || this._createSkyboxMesh(e), super.draw(e, this._skyboxMesh);
    }
    _createSkyboxMesh(e) {
        const t = new Ye({
            aPosition: new Int8Array(gs)
        }, null, gs.length / 3);
        t.generateBuffers(e), this._skyboxMesh = [ new xr(t) ], this._meshDefines && (this._skyboxMesh[0].setDefines(this._meshDefines), 
        delete this._meshDefines);
    }
    dispose() {
        if (this._skyboxMesh) {
            const e = this._skyboxMesh[0];
            e.geometry.dispose(), e.dispose();
        }
        return delete this._skyboxMesh, super.dispose();
    }
}

class vs extends Yi {
    constructor(e, t) {
        const n = {
            blend: {
                enable: !0,
                func: {
                    src: "one",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: e
        };
        t && t.extraCommandProps && E(n, t.extraCommandProps);
        const r = [];
        super({
            vert: "#define SHADER_NAME HEATMAP_DISPLAY\nuniform mat4 projViewModelMatrix;\nattribute vec3 aPosition;\nvoid main() {\n  gl_Position = projViewModelMatrix * vec4(aPosition, 1.);\n}",
            frag: "#define SHADER_NAME HEATMAP_DISPLAY\nprecision mediump float;\nuniform sampler2D inputTexture;\nuniform sampler2D colorRamp;\nuniform vec2 textureOutputSize;\nuniform float heatmapOpacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / textureOutputSize.xy;\n  float t = texture2D(inputTexture, c).r;\n  vec4 d = texture2D(colorRamp, vec2(t, .5));\n  gl_FragColor = d * heatmapOpacity;\n}",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(r, t.projViewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: n
        });
    }
}

class xs extends es {
    constructor() {
        super({
            name: "copy",
            wgslFrag: "",
            frag: "precision highp float;\nuniform sampler2D texture;\nuniform vec2 size;\nuniform float enableSharpen;\nuniform float sharpFactor;\nuniform float pixelRatio;\nvec2 c;\nvec3 d(const in vec3 e, const float f) {\n  vec2 h = pixelRatio / size.xy;\n  float i = .0;\n  vec4 j = texture2D(texture, c + h * vec2(-1., -1.));\n  j.rgb = mix(vec3(.0), j.rgb, sign(j.a));\n  i += mix(.0, 1., sign(j.a));\n  vec4 k = texture2D(texture, c + h * vec2(1.));\n  k.rgb = mix(vec3(.0), k.rgb, sign(k.a));\n  i += mix(.0, 1., sign(k.a));\n  vec4 l = texture2D(texture, c + h * vec2(1., -1.));\n  l.rgb = mix(vec3(.0), l.rgb, sign(l.a));\n  i += mix(.0, 1., sign(l.a));\n  vec4 m = texture2D(texture, c + h * vec2(-1., 1.));\n  m.rgb = mix(vec3(.0), m.rgb, sign(m.a));\n  i += mix(.0, 1., sign(m.a));\n  return e + f * (i * e - j.rgb - l.rgb - m.rgb - k.rgb);\n}\nvoid main() {\n  c = gl_FragCoord.xy / size;\n  vec4 e = texture2D(texture, c);\n  if(enableSharpen == 1.) {\n    e.rgb = d(e.rgb, sharpFactor);\n  }\n  gl_FragColor = e;\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.size[0],
                    height: (e, t) => t.size[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        const n = (this.dkey || "") + "_copy";
        return this.commands[n] || (this.commands[n] = this.createMeshCommand(e, t)), this.commands[n];
    }
}

const ys = [], bs = [];

class ws extends es {
    constructor() {
        super({
            vert: $i,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform sampler2D sceneMap;\nuniform sampler2D scanEffectMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  vec4 d = texture2D(scanEffectMap, vTexCoord);\n  glFragColor = c + d;\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
}

const Ts = [];

class Ss {
    constructor(e, t, n) {
        this._regl = e, this._layer = n, this._viewport = t, this._init();
    }
    _init() {
        this._shader = new Yi({
            vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec4 vWorldPosition;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  vec4 e = modelMatrix * d * c;\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vWorldPosition = e;\n}",
            frag: "precision mediump float;\nvarying vec4 vWorldPosition;\nuniform vec2 fogDist;\nuniform vec3 cameraPosition;\nuniform float rainDepth;\nvoid main() {\n  vec3 c = vec3(vWorldPosition[0] - cameraPosition[0], vWorldPosition[1] - cameraPosition[1], vWorldPosition[2] - cameraPosition[2]);\n  float d = length(c);\n  float e = clamp(1. - (d - fogDist.x) / (fogDist.y - fogDist.x), .0, 1.);\n  if(vWorldPosition[2] < rainDepth) {\n    gl_FragColor = vec4(e, .0, .0, 1.);\n  } else {\n    gl_FragColor = vec4(e, 1., .0, 1.);\n  }\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(Ts, t.viewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this._viewport
            }
        });
        const e = this._layer.getRenderer().createFBOInfo();
        this._fbo = this._regl.framebuffer(e), this._scene = new Pr, this.renderer = new wr(this._regl);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this._fbo
        }), this._scene.setMeshes(e);
        const n = {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            cameraPosition: t.cameraPosition,
            fogDist: t.fogDist,
            rainDepth: t.rainDepth
        };
        return this.renderer.render(this._shader, n, this._scene, this._fbo), this._fbo;
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = O(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = O(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}

class Ms extends es {
    constructor() {
        super({
            vert: $i,
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_RAIN\nuniform sampler2D ripplesMap;\n#endif\n#ifdef HAS_SNOW\nuniform sampler2D normalMap;\n#endif\n#ifdef HAS_FOG\nuniform vec3 fogColor;\n#endif\nuniform sampler2D sceneMap;\nuniform sampler2D mixFactorMap;\nuniform float time;\nuniform vec2 resolution;\nuniform float snowIntensity;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\n#define HASHSCALE1 .1031\n#define HASHSCALE3 vec3(.1031, .1030, .0973)\n#define HASHSCALE4 vec3(.1031, .1030, .0973, .1099)\nfloat d = .5;\nfloat e = .2;\nfloat f = .5;\nfloat h = 20.;\nfloat i(float p) {\n  vec3 j = fract(vec3(p) * HASHSCALE1);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.x + j.y) * j.z);\n}\nvec2 k(vec2 p) {\n  vec3 j = fract(vec3(p.xyx) * HASHSCALE3);\n  j += dot(j, j.yzx + 19.19);\n  return fract((j.xx + j.yz) * j.zy);\n}\nvec2 l(vec2 m) {\n  float x = fract(sin(dot(m.xy, vec2(122.9898, 783.233))) * 43758.5453);\n  float y = fract(sin(dot(m.xy, vec2(457.6537, 537.2793))) * 37573.5913);\n  return vec2(x, y);\n}\nvec3 n(vec2 o, float u) {\n  vec3 v = vec3(.0);\n  o = o * (2. + u);\n  float A = e * snowIntensity;\n  float B = o.y * (((i(u) * 2. - 1.) * .5 + 1.) * A);\n  float C = (f * time);\n  o += vec2(B, C);\n  vec2 D = k(floor(o) + 31.1759 * u);\n  o = fract(o);\n  o -= (D * 2. - 1.) * .35;\n  o -= .5;\n  float r = length(o);\n  float E = .05 * (1. + .3 * sin(time * d));\n  float F = smoothstep(E, -E, r);\n  vec3 G = vec3(F) * D.x;\n  return G;\n}\nvec3 H() {\n  vec3 v = vec3(0);\n  vec2 o = gl_FragCoord.xy / resolution.xy;\n  o *= vec2(resolution.x / resolution.y, 1.);\n  float I = h * snowIntensity;\n  for(float J = 0.; J < I; J++) {\n    v += n(o, J);\n  }\n  return v;\n}\nvec3 K(vec4 L, vec4 M, float N) {\n  float O = M.b;\n  vec3 P = vec3(1.);\n  if(N < 1.) {\n    float r = c(.5, P.x, O);\n    float g = c(.5, P.y, O);\n    float b = c(.5, P.z, O);\n    return vec3(r, g, b);\n  } else {\n    float r = c(L.r, P.x, O);\n    float g = c(L.g, P.y, O);\n    float b = c(L.b, P.z, O);\n    return vec3(r, g, b);\n  }\n}\nvoid main() {\n  vec4 L = texture2D(sceneMap, vTexCoord);\n  glFragColor = L;\n  vec4 Q = texture2D(mixFactorMap, vTexCoord);\n#ifdef HAS_RAIN\nvec4 R = texture2D(ripplesMap, vTexCoord);\n  if(Q.g < 1.) {\n    L = mix(L, R, .4);\n  }\n  glFragColor = L;\n#endif\n#ifdef HAS_SNOW\nvec3 S = H();\n  glFragColor = vec4(L.rgb + S, L.a);\n#endif\n#ifdef HAS_FOG\nfloat T = Q.r;\n  vec3 U = mix(fogColor, glFragColor.rgb, T);\n  glFragColor = vec4(U, L.a);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.resolution[0],
                    height: (e, t) => t.resolution[1]
                }
            }
        });
    }
}

const As = [], Cs = [ .03, .03, .03 ], ks = [], Os = [], Es = [], Ps = c.fromRotationTranslation([], m.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class Is {
    constructor(e, t) {
        this._regl = e, this._viewport = t, this._init();
    }
    _init() {
        this._shader = new Yi({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nvarying vec2 vTexCoord;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\nuniform float rippleRadius;\nuniform float density;\nuniform float time;\nvec3 c(vec2 p) {\n  vec3 q = vec3(dot(p, vec2(127.1, 311.7)), dot(p, vec2(269.5, 183.3)), dot(p, vec2(419.2, 371.9)));\n  return fract(sin(q) * 43758.5453);\n}\nfloat d(in vec2 x) {\n  vec2 e = x * density / 4000.0;\n  vec2 p = floor(e);\n  vec2 f = fract(e);\n  float h = .0;\n  for(int i = -4; i <= 4; i++)\n    for(int k = -4; k <= 4; k++) {\n      vec2 g = vec2(float(k), float(i));\n      vec3 l = c(p + g);\n      vec2 r = g - f + l.xy;\n      float m = sqrt(dot(r, r));\n      float n = max(mix(smoothstep(.99, .999, max(cos(m - time * 2. + (l.x + l.y) * 5.), 0.)), 0., m), 0.);\n      h += n;\n    }\n  return h;\n}\nvoid main() {\n  vec2 u = vTexCoord;\n  float A = 24. / (rippleRadius * .01);\n  float f = d(A * u) * smoothstep(.0, .4, sin(u.x * 3.151592) * sin(u.y * 3.141592));\n  vec3 B = vec3(-dFdx(f), -dFdy(f), -dFdy(f));\n  glFragColor = vec4(B, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(As, t.viewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._shader.version = 300, this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: this._viewport.width(),
                height: this._viewport.height(),
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._scene = new Pr, this.renderer = new wr(this._regl);
    }
    _transformRipples(e) {
        const t = e.coordinateToPointAtRes(e.getCenter(), e.getGLRes()), n = e.getGLScale() / e.getGLScale(this._fixZoom), r = h.set(Os, n, n, n), i = h.multiply(r, Cs, r), s = c.identity(Es);
        c.fromRotationTranslationScale(s, m.fromEuler(ks, 0, 0, 0), [ t.x, t.y, 0 ], i), 
        c.multiply(s, s, Ps), this._mesh.setLocalTransform(s);
    }
    _createRipplesMask(e) {
        this._fixZoom = e.getZoom();
        const t = 800 * Math.pow(2, 16.685648411389433 - this._fixZoom), n = [ -t, 0, -t, t, 0, -t, -t, 0, t, t, 0, t ], r = {};
        r.POSITION = n, r.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], r.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const i = new Ye(r, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        i.generateBuffers(this._regl);
        const s = new Ft;
        return new xr(i, s);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this._fbo
        }), this._mesh = this._mesh || this._createRipplesMask(e), this._scene.setMeshes(this._mesh), 
        this._transformRipples(e);
        const n = {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            time: t.time,
            rippleRadius: t.rippleRadius,
            density: t.density
        };
        return this.renderer.render(this._shader, n, this._scene, this._fbo), this._fbo;
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = O(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = O(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}

var Rs = "attribute vec3 aPosition;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\n#ifdef HAS_TEXTURE\nattribute vec2 aTexCoord;\nvarying vec2 uv;\nvarying vec4 vPos;\n#endif\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = c * getPosition(aPosition);\n  gl_Position = projViewModelMatrix * d;\n#ifdef HAS_TEXTURE\nuv = aTexCoord;\n  vPos = getPosition(aPosition);\n#endif\n}";

const Ls = [ 0, 0, 0, 1 ];

class Fs {
    constructor(e, t) {
        this.regl = e, this._viewport = t, this.renderer = new wr(e), this._init();
    }
    _init() {
        this._maskColorFbo = this.renderer.device.framebuffer({
            color: this.renderer.device.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._maskModeFbo = this.renderer.device.framebuffer({
            color: this.renderer.device.texture({
                width: 1,
                height: 1,
                wrap: "clamp",
                mag: "nearest",
                min: "nearest"
            }),
            depth: !0
        });
        const e = [ {
            name: "projViewModelMatrix",
            type: "function",
            fn: (e, t) => c.multiply([], t.projViewMatrix, t.modelMatrix)
        } ];
        this._maskColorShader = new Yi({
            vert: Rs,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec4 maskColor;\n#ifdef HAS_TEXTURE\nuniform sampler2D maskTexture;\nvarying vec2 uv;\nuniform vec3 mask_position0;\nuniform vec3 mask_position1;\nuniform vec3 mask_position2;\nuniform vec3 mask_position3;\nvarying vec4 vPos;\nvec2 c(vec2 d, vec2 a, vec2 b, vec2 e, vec2 f) {\n  vec2 h = vec2(.5);\n  for(int i = 0; i < 10; i++) {\n    float j = h.x;\n    float k = h.y;\n    vec2 l = (1. - j) * (1. - k) * a + j * (1. - k) * b + j * k * e + (1. - j) * k * f;\n    vec2 m = d - l;\n    if(length(m) < .001)\n      break;\n    vec2 n = -(1. - k) * a + (1. - k) * b + k * e - k * f;\n    vec2 o = -(1. - j) * a - j * b + j * e + (1. - j) * f;\n    float A = n.x * o.y - n.y * o.x;\n    if(abs(A) > .0001) {\n      vec2 B = vec2((m.x * o.y - m.y * o.x) / A, (m.y * n.x - m.x * n.y) / A);\n      h += B;\n    }\n    h = clamp(h, .0, 1.);\n  }\n  return h;\n}\n#endif\nvoid main() {\n  \n#ifdef HAS_TEXTURE\nvec2 d = vPos.xy;\n  vec2 C = c(d, mask_position0.xy, mask_position1.xy, mask_position2.xy, mask_position3.xy);\n  gl_FragColor = texture2D(maskTexture, C);\n  gl_FragColor.a *= maskColor.a;\n#else\nif(maskColor.a == .0) {\n    discard;\n  }\n  gl_FragColor = maskColor;\n#endif\n}",
            uniforms: e,
            extraCommandProps: {
                viewport: this._viewport,
                depth: {
                    enable: !0,
                    func: "lequal"
                }
            }
        }), this._maskModeShader = new Yi({
            vert: Rs,
            frag: "#ifdef GL_ES\nprecision highp float;\n#endif\nuniform float maskMode;\n#ifdef HAS_MASK_FLAT\nuniform float flatHeight;\n#endif\n#ifdef HAS_MASK_COLOR\nuniform vec2 heightRange;\n#endif\nvoid main() {\n  \n#if defined(HAS_MASK_FLAT)\ngl_FragColor = vec4(maskMode, flatHeight, .0, 1.);\n#elif defined(HAS_MASK_COLOR)\ngl_FragColor = vec4(maskMode, .0, heightRange.x, heightRange.y);\n#else\ngl_FragColor = vec4(maskMode, .0, .0, .0);\n#endif\n}",
            uniforms: e,
            extraCommandProps: {
                viewport: this._viewport
            }
        }), this._scene = new Pr;
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: Ls,
            depth: 1,
            framebuffer: this._maskColorFbo
        }), this.renderer.clear({
            color: Ls,
            depth: 1,
            framebuffer: this._maskModeFbo
        }), this._scene.setMeshes(e);
        const n = {
            projViewMatrix: t
        };
        return this.renderer.render(this._maskColorShader, n, this._scene, this._maskColorFbo), 
        this.renderer.render(this._maskModeShader, n, this._scene, this._maskModeFbo), {
            colorExtent: this._maskColorFbo,
            modeExtent: this._maskModeFbo
        };
    }
    _resize() {
        const e = O(this._viewport.width) ? this._viewport.width() : this._viewport.width.data(), t = O(this._viewport.height) ? this._viewport.height() : this._viewport.height.data();
        !this._maskColorFbo || this._maskColorFbo.width === e && this._maskColorFbo.height === t || (this._maskColorFbo.resize(e, t), 
        this._maskModeFbo.resize(e, t));
    }
    dispose() {
        this._maskColorFbo && (this._maskColorFbo.destroy(), delete this._maskColorFbo), 
        this._maskModeFbo && (this._maskModeFbo.destroy(), delete this._maskModeFbo), this._maskColorShader && (this._maskColorShader.dispose(), 
        delete this._maskColorShader), this._maskModeShader && (this._maskModeShader.dispose(), 
        delete this._maskModeShader);
    }
}

const Hs = "\n#ifdef GL_ES\n  precision highp float;\n#endif\nuniform mat3 ring;\n\nuniform float effectTime;\nvarying vec4 vWorldPosition;\n\nvec3 hsb2rgb(in vec3 c) {\n    vec3 rgb = clamp(abs(mod(c.x * 6.0 + vec3(0.0,4.0,2.0), 6.0)-3.0)-1.0, 0.0, 1.0 );\n    rgb = rgb*rgb*(3.0-2.0*rgb);\n    return c.z * mix( vec3(1.0), rgb, c.y);\n}\n\nvec4 glowring(vec4 worldPos, vec2 center, float radius, float speed, vec3 effectColor, float direction, float height) {\n  vec2 dir = vec2(worldPos.xy) - center;\n  float len = length(dir);\n  if (len > radius) {\n    return vec4(0.0);\n  } else {\n    vec2 uv = vec2(0.0);\n    if (direction == 0.0) {\n      vec2 lefttop = vec2(center.x - radius, center.y + radius);\n      vec2 rightbottom = vec2(center.x + radius, center.y - radius);\n      uv = vec2(abs(worldPos.x - lefttop.x) / (2.0 * radius), abs(worldPos.y - rightbottom.y) / (2.0 * radius));\n      uv.x -= 0.5;\n      uv.y -= 0.5;\n    } else {\n      if (worldPos.z < 0.1) {\n        return vec4(0.0);\n      }\n      uv = vec2(0.0, worldPos.z / height);\n    }\n    float itime = (effectTime / 2.0) * speed;\n    float r = length(uv) * 3.0;\n    vec3 color = hsb2rgb(effectColor);\n\n    float a = pow(r, 2.0);\n    float b = sin(r * 0.8 - 1.6);\n    float c = sin(r - 0.010);\n    float s = sin(a - itime * 3.0 + b) * c;\n    float t = abs(1.0 / (s * 10.8)) - 0.01;\n    color *= t;\n    vec4 newColor = vec4(color, t);\n    return newColor;\n  }\n}\n\nvoid main() {\n    vec4 color = vec4(0.0);\n    gl_FragColor = color;\n}\n", Ds = [];

class Ns {
    constructor(e, t, n) {
        this._regl = e, this._layer = n, this._viewport = t, this._init(), this._effectsLength = 0;
    }
    _init() {
        const e = this._layer.getRenderer().createFBOInfo();
        this._fbo = this._regl.framebuffer(e), this._scene = new Pr, this.renderer = new wr(this._regl);
    }
    render(e, t) {
        this._resize(), this.renderer.clear({
            color: [ 0, 0, 0, 1 ],
            depth: 1,
            framebuffer: this._fbo
        }), this._scene.setMeshes(e);
        const n = t.effectInfos;
        if (!this._shader || n.length !== this._effectsLength) {
            this._shader && this._shader.dispose();
            const e = this._createFragSource(n);
            this._shader = new Yi({
                vert: "#include <gl2_vert>\n#define SHADER_NAME SCANEFFECT\nprecision highp float;\nattribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vWorldPosition;\nvoid main()\n{\n    mat4 localPositionMatrix = getPositionMatrix();\n    #ifdef IS_LINE_EXTRUSION\n        vec3 linePosition = getLineExtrudePosition(aPosition);\n        //linePixelScale = tileRatio * resolution / tileResolution\n        vec4 localVertex = getPosition(linePosition);\n    #else\n        vec4 localVertex = getPosition(aPosition);\n    #endif\n    vec4 worldPosition = modelMatrix * localPositionMatrix * localVertex;\n    vWorldPosition = worldPosition;\n    gl_Position = projMatrix * modelViewMatrix * localPositionMatrix * localVertex;\n}\n",
                frag: e,
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: function(e, t) {
                        return c.multiply(Ds, t.viewMatrix, t.modelMatrix);
                    }
                } ],
                extraCommandProps: {
                    viewport: this._viewport
                }
            }), this._effectsLength = n.length;
        }
        const r = {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            effectTime: t.effectTime,
            minAltitude: 0
        };
        return this._updateUniforms(r, n), this.renderer.render(this._shader, r, this._scene, this._fbo), 
        this._fbo;
    }
    _createFragSource(e) {
        let t = "";
        for (let n = 0; n < e.length; n++) t += `uniform mat3 ring${n};\n`;
        t = Hs.replace("uniform mat3 ring;", t);
        let n = "";
        for (let t = 0; t < e.length; t++) n += `\n                vec2 center${t} = vec2(ring${t}[0][0], ring${t}[0][1]);\n                float radius${t} = ring${t}[0][2];\n                float speed${t} = ring${t}[1][0];\n                vec3 color${t} = vec3(ring${t}[1][1], ring${t}[1][2], ring${t}[2][0]);\n                float direction${t} = ring${t}[2][1];\n                float height${t} = ring${t}[2][2];\n                vec4 ringColor${t} = glowring(vWorldPosition, center${t}, radius${t}, speed${t}, color${t}, direction${t}, height${t});\n                color += ringColor${t};\n            `;
        return n += "gl_FragColor = color;", t = t.replace("gl_FragColor = color;", n), 
        t;
    }
    _updateUniforms(e, t) {
        for (let n = 0; n < t.length; n++) e[`ring${n}`] = t[n];
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && this._shader.dispose();
    }
    _resize() {
        const e = O(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = O(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
}

const Bs = [], Us = {
    width: 4,
    type: "float"
};

class zs {
    constructor(e, t, n) {
        this._regl = e, this.joints = t, this.inverseBindMatrices = [], this.jointMatrices = [], 
        this.jointData = new Float32Array(16 * t.length);
        for (let e = 0; e < t.length; ++e) this.inverseBindMatrices.push(new Float32Array(n.buffer, n.byteOffset + 16 * Float32Array.BYTES_PER_ELEMENT * e, 16)), 
        this.jointMatrices.push(new Float32Array(this.jointData.buffer, 16 * Float32Array.BYTES_PER_ELEMENT * e, 16));
        this.jointTextureSize = [ 4, 6 ];
    }
    update(e, t, n) {
        c.invert(Bs, e);
        for (let e = 0; e < this.joints.length; ++e) {
            const n = this.joints[e], r = this.jointMatrices[e];
            c.multiply(r, Bs, t[n.nodeIndex]), c.multiply(r, r, this.inverseBindMatrices[e]);
        }
        Us.height = this.joints.length, Us.data = this.jointData;
        const r = Us;
        return n ? n(r) : n = this._regl.texture(r), n;
    }
}

const Gs = [ 0, 0, 0 ], Vs = [ 0, 0, 0, 1 ], js = [ 1, 1, 1 ], Ws = [];

class qs {
    constructor(e = [ 0, 0, 0 ], t = [ 0, 0, 0, 1 ], n = [ 1, 1, 1 ]) {
        this.translation = e, this.rotation = t, this.scale = n;
    }
    getMatrix() {
        return c.fromRotationTranslationScale(Ws, this.rotation, this.translation, this.scale);
    }
    decompose(e) {
        c.getTranslation(this.translation, e), c.getRotation(this.rotation, e), c.getScaling(this.scale, e);
    }
    update(e) {
        e && (e.translation && !h.equals(e.translation, Gs) && h.copy(this.translation, e.translation), 
        e.rotation && !m.equals(e.rotation, Vs) && m.copy(this.rotation, e.rotation), e.scale && !h.equals(e.scale, js) && h.copy(this.scale, e.scale));
    }
}

class Xs {
    constructor(e) {
        this._init(e);
    }
    _init(e) {
        this.bbox = e.bbox, this.geometry = e.geometry, this.nodeMatrix = e.nodeMatrix, 
        this.materialInfo = e.materialInfo, this.extraInfo = e.extraInfo, this.animationMatrix = e.animationMatrix, 
        this.morphWeights = e.morphWeights, this.skin = e.skin, this.nodeIndex = e.nodeIndex;
    }
    copyEdgeGeometry() {
        this.copyGeometry || (this.copyGeometry = this._copyEdgeGeometry(this.geometry));
    }
    createCopyBarycentric() {
        this.copyGeometry && !this.copyGeometry.data.aBarycentric && (this.copyGeometry.buildUniqueVertex(), 
        this.copyGeometry.createBarycentric("aBarycentric"));
    }
    _copyEdgeGeometry(e) {
        const t = e.data, n = e.indices || e.elements, r = {};
        for (const n in t) if (n === e.desc.positionAttribute) if (L(t[n])) r[n] = t[n].slice(); else if (t[n].buffer && t[n].buffer.destroy) r[n] = {
            buffer: t[n].buffer
        }, L(t[n].array) && (r[n].array = t[n].array.slice()); else {
            const t = e._getAttributeData(n);
            n !== e.desc.positionAttribute ? r[n] = t : r[n] = t.slice();
        }
        const i = void 0 !== n.length ? n.slice() : n, s = JSON.parse(JSON.stringify(e.desc)), o = new Pt(r, i, 0, s);
        return o.properties = e.properties, o;
    }
}

const Ks = [ 1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1 ];

let Zs = 0;

const Ys = [], $s = [];

class Js {
    constructor(e, t) {
        this.gltf = e, this.regl = t, this.geometries = [], t && (this._emptyTexture = t.texture({
            width: 2,
            height: 2
        }));
    }
    getMeshesInfo() {
        if (!this.gltf) return null;
        if (this.geometries.length) return this.geometries;
        this._createTextures(this.gltf.textures), this._createSkins(this.gltf.skins);
        return this.gltf.scenes[0].nodes.forEach((e => {
            this._parserNode(e, this.geometries);
        })), this._checkBaseColorFactor(), this.geometries;
    }
    getGLTFBBox(e) {
        if (!this.gltf) return null;
        const t = this.geometries;
        if (!t || !t.length) return null;
        const n = [ 1 / 0, 1 / 0, 1 / 0 ], r = [ -1 / 0, -1 / 0, -1 / 0 ];
        for (let e = 0; e < t.length; e++) {
            const i = t[e].bbox, s = i.min, o = i.max;
            s[0] < n[0] && (n[0] = s[0]), s[1] < n[1] && (n[1] = s[1]), s[2] < n[2] && (n[2] = s[2]), 
            o[0] > r[0] && (r[0] = o[0]), o[1] > r[1] && (r[1] = o[1]), o[2] > r[2] && (r[2] = o[2]);
        }
        const i = new le(n, r);
        return e && i.transform(e), i;
    }
    _createSkins(e) {
        if (e) {
            this._skinMap = {};
            for (let t = 0; t < e.length; t++) {
                const n = e[t];
                n.joints = n.joints.map((e => this.gltf.nodes[e])), this._skinMap[t] = new zs(this.regl, n.joints, n.inverseBindMatrices.array), 
                delete n.inverseBindMatrices;
            }
        }
    }
    _createTextures(e) {
        if (e) {
            this._textureMap = {};
            for (let t = 0; t < e.length; t++) {
                const n = e[t];
                this._textureMap[t] || (this._textureMap[t] = this._toTexture(n), delete n.image);
            }
        }
    }
    _checkBaseColorFactor() {
        if (!this._checkBaseColorFactorAlpha()) for (let e = 0; e < this.geometries.length; e++) {
            const t = this.geometries[e].materialInfo.baseColorFactor;
            t && 0 === t[3] && (t[3] = 1);
        }
    }
    _checkBaseColorFactorAlpha() {
        for (let e = 0; e < this.geometries.length; e++) {
            const t = this.geometries[e].materialInfo.baseColorFactor;
            if (t && t[3] > 0) return !0;
        }
        return !1;
    }
    dispose() {
        this._emptyTexture && this._emptyTexture.destroy();
        const e = this.getMeshesInfo();
        if (e) {
            e.forEach((e => {
                e.geometry.dispose();
                for (const t in e.materialInfo) {
                    const n = e.materialInfo[t];
                    n && n.destroy && !n[ee] && n.destroy();
                }
            }));
            for (const e in this._textureMap) {
                const t = this._textureMap[e];
                t && t.destroy && !t[ee] && t.destroy();
            }
            delete this.gltf;
        }
    }
    updateAnimation(e, t, n, r, i, s, o, a) {
        const l = this.gltf;
        if (!l) return;
        const c = M();
        if (Zs = l.animations ? c.GLTFLoader.getAnimationTimeSpan(l, r) : null, !Zs) return;
        e -= i;
        let h = 0;
        h = t || !t && this._isFirstLoop(e, n, r, i) ? e * n * .001 % (Zs.max - Zs.min) + Zs.min : e * n * .001 + Zs.min, 
        l.scenes[0].nodes.forEach((e => {
            this._updateNodeMatrix(r, h, e, null, s, a);
        }));
        for (const e in this.gltf.nodes) {
            const t = this.gltf.nodes[e], n = s[t.nodeIndex];
            if (t.skin && n) {
                const e = t.skin.update(n, s, o[t.nodeIndex] && o[t.nodeIndex].jointTexture);
                o[t.nodeIndex] || (o[t.nodeIndex] = {
                    jointTextureSize: t.skin.jointTextureSize,
                    numJoints: t.skin.joints.length
                }), o[t.nodeIndex].jointTexture = e;
            }
        }
    }
    _isFirstLoop(e, t, n, r) {
        const i = this.gltf;
        if (!r || !i) return !0;
        const s = M();
        return Zs = i.animations ? s.GLTFLoader.getAnimationTimeSpan(i, n) : null, e * t * .001 / (Zs.max - Zs.min) < 1;
    }
    hasSkinAnimation() {
        return !!this._isAnimation;
    }
    _updateNodeMatrix(e, t, n, r, i, s) {
        n.trs && (s ? s.indexOf(Number(n.nodeIndex)) > -1 && this._updateNodeTRS(n, t, e) : this._updateNodeTRS(n, t, e)), 
        i[n.nodeIndex] = r ? c.multiply(i[n.nodeIndex] || [], r, n.matrix || n.trs.getMatrix()) : c.copy(i[n.nodeIndex] || [], n.matrix || n.trs.getMatrix()), 
        n.children && n.children.forEach((r => {
            this._updateNodeMatrix(e, t, r, i[n.nodeIndex], i, s);
        }));
    }
    _updateNodeTRS(e, t, n) {
        const r = M().GLTFLoader.getAnimationClip(this.gltf, Number(e.nodeIndex), t, n);
        r.weights && this._updateMorph(e, r.weights), e.trs.update(r);
    }
    _updateMorph(e, t) {
        const n = t.length;
        if (!e.influencesList) {
            e.influencesList = [];
            for (let t = 0; t < n; t++) e.influencesList[t] = [ t, 0 ];
        }
        const r = e.influencesList;
        for (let e = 0; e < r.length; e++) {
            const n = r[e];
            n[0] = e, n[1] = t[e];
        }
        r.sort(eo);
        const i = [];
        for (let e = 0; e < 8; e++) i[e] = [ e, 0 ];
        for (let e = 0; e < 8; e++) e < n && r[e][1] ? (i[e][0] = r[e][0], i[e][1] = r[e][1]) : (i[e][0] = Number.MAX_SAFE_INTEGER, 
        i[e][1] = 0);
        i.sort(Qs);
        e.geometries.forEach((e => {
            const t = e.properties.morphTargets;
            for (let n = 0; n < 8; n++) {
                const r = i[n], s = r[0], o = r[1];
                s !== Number.MAX_SAFE_INTEGER && o ? (e.updateData("POSITION" + n, t["POSITION_" + s].array), 
                e.properties.morphWeights[n] = o) : e.properties.morphWeights[n] = 0;
            }
        }));
    }
    _parserNode(e, t, n) {
        if (e.isParsed) return;
        e.nodeMatrix = e.nodeMatrix || c.identity([]), e.localMatrix = e.localMatrix || c.identity([]), 
        e.matrix ? (e.trs = new qs, e.trs.decompose(e.matrix)) : e.trs = new qs(e.translation, e.rotation, e.scale), 
        e.localMatrix = e.trs.getMatrix(), n ? c.multiply(e.nodeMatrix, n, e.matrix || e.localMatrix) : c.copy(e.nodeMatrix, e.matrix || e.localMatrix);
        const r = e.nodeMatrix;
        if (e.children) for (let n = 0; n < e.children.length; n++) {
            const i = e.children[n];
            this._parserNode(i, t, r);
        }
        if (k(e.skin)) {
            this._isAnimation = !0;
            const t = e.skin;
            e.trs = new qs, e.skin = this._skinMap[t];
        }
        if (k(e.mesh)) {
            const n = e.mesh;
            e.mesh = this.gltf.meshes[n], e.mesh.node = e, e.geometries = e.geometries || [], 
            e.mesh.primitives.forEach((n => {
                const i = this._createMaterialInfo(n.material), s = function(e, t, n) {
                    const r = e.attributes, i = r.COLOR_0;
                    if (i && i.array instanceof Float32Array) {
                        const e = new Uint8Array(i.array.length);
                        for (let t = 0; t < e.length; t++) e[t] = Math.round(255 * i.array[t]);
                        i.array = e;
                    } else if (i && (i.array instanceof Uint16Array || i.array instanceof Int16Array || i.array instanceof Uint32Array || i.array instanceof Int32Array)) {
                        const e = new Uint8Array(i.array);
                        i.array = e;
                    }
                    n && r.TEXCOORD_0 && !r.TEXCOORD_0 && (r.TEXCOORD_1 = r.TEXCOORD_0);
                    const s = {};
                    for (const e in r) s[e] = E({}, r[e]), t && (s[e].buffer = bt(t, r[e], {
                        dimension: r[e].itemSize
                    }));
                    if (e.morphTargets) {
                        const e = j(s.POSITION) ? s.POSITION.itemSize * s.POSITION.count : s.POSITION.array.length;
                        for (let t = 0; t < 8; t++) s[`POSITION${t}`] || (s[`POSITION${t}`] = new Float32Array(e).fill(0));
                        for (let e = 0; e < 4; e++) {
                            const t = s.NORMAL.array ? s.NORMAL.array.length : s.NORMAL.length;
                            s[`NORMAL${e}`] || (s[`NORMAL${e}`] = new Float32Array(t).fill(0));
                        }
                    }
                    let o = e.indices;
                    o && void 0 === o.bufferView && o.array && (o = o.array);
                    const a = new Ye(s, o, 0, {
                        primitive: I(e.mode) ? at(e.mode) : e.mode,
                        positionAttribute: "POSITION",
                        normalAttribute: "NORMAL",
                        uv0Attribute: "TEXCOORD_0",
                        uv1Attribute: "TEXCOORD_1",
                        color0Attribute: "COLOR_0"
                    });
                    e.morphTargets && (a.properties.morphWeights = []);
                    e.mode > 3 && !a.data.NORMAL && a.createNormal("NORMAL");
                    return a;
                }(n, this.regl, i.occlusionTexture);
                s.properties.morphTargets = n.morphTargets, e.geometries.push(s);
                let o = s.boundingBox.copy();
                o = o.transform(c.identity(Ys), r);
                const a = {
                    geometry: s,
                    bbox: o,
                    nodeMatrix: r,
                    materialInfo: i,
                    extraInfo: this._createExtralInfo(n.material),
                    animationMatrix: e.trs.getMatrix(),
                    morphWeights: e.weights,
                    nodeIndex: e.nodeIndex
                };
                e.skin && (a.skin = {
                    jointTextureSize: [ 4, 6 ],
                    numJoints: e.skin.joints.length,
                    jointTexture: e.skin.jointTexture
                });
                const l = new Xs(a);
                t.push(l);
            }));
        }
        e.isParsed = !0;
    }
    _createMaterialInfo(e) {
        const t = {};
        if (this.gltf.materials && this.gltf.materials[e]) {
            const n = this.gltf.materials[e], r = n.pbrMetallicRoughness;
            if (r) {
                const e = r.metallicRoughnessTexture, n = r.baseColorTexture;
                n && (t.baseColorTexture = this._getTexture(n), n.KHR_texture_transform && (t.khr_offset = n.KHR_texture_transform.offset || [ 0, 0 ], 
                t.khr_rotation = n.KHR_texture_transform.rotation || 0, t.khr_scale = n.KHR_texture_transform.scale || [ 1, 1 ])), 
                r.baseColorFactor && (t.baseColorFactor = r.baseColorFactor), e ? t.metallicRoughnessTexture = this._getTexture(e) : (t.metallicFactor = k(r.metallicFactor) ? r.metallicFactor : 1, 
                t.roughnessFactor = k(r.roughnessFactor) ? r.roughnessFactor : 1);
            }
            const i = n.extensions;
            if (i && i.KHR_materials_pbrSpecularGlossiness) {
                const e = i.KHR_materials_pbrSpecularGlossiness;
                t.name = "pbrSpecularGlossiness";
                for (const n in e) k(e[n].index) ? t[n] = this._getTexture(e[n]) : t[n] = e[n];
            }
            n.normalTexture && (t.normalTexture = this._getTexture(n.normalTexture)), n.occlusionTexture && (t.occlusionTexture = this._getTexture(n.occlusionTexture)), 
            n.emissiveTexture && (t.emissiveTexture = this._getTexture(n.emissiveTexture)), 
            n.emissiveFactor && (t.emissiveFactor = n.emissiveFactor), t.alphaCutoff = n.alphaCutoff || .5, 
            t.doubleSided = n.doubleSided, t.alphaMode = n.alphaMode || "OPAQUE";
        }
        return t;
    }
    _createExtralInfo(e) {
        const t = {};
        if (this.gltf.materials && this.gltf.materials[e]) {
            const n = this.gltf.materials[e];
            t.doubleSided = n.doubleSided, t.alphaMode = n.alphaMode || "OPAQUE";
        }
        return t;
    }
    _getTexture(e) {
        const t = e.extensions, n = e.index;
        if (!k(n)) return null;
        t && t.KHR_texture_transform && (e.KHR_texture_transform = t.KHR_texture_transform);
        const r = this._textureMap[n];
        return r.texInfo = e, r;
    }
    _toTexture(e) {
        if (!e) return this._emptyTexture;
        const t = e.image.array, n = e.sampler || {}, r = e.image.width, i = e.image.height;
        return new qr({
            width: r,
            height: i,
            data: t,
            mag: mt(n.magFilter) || "linear",
            min: _t(n.minFilter) || "linear mipmap linear",
            wrapS: vt(n.wrapS) || "repeat",
            wrapT: vt(n.wrapT) || "repeat"
        });
    }
    arrangeAlongLine(e, t, n, r, i, s, o) {
        const a = [], l = this._getRotationZ(e, t), c = (e.z || 0) - (t.z || 0), h = this._getRotationXY(n, c);
        let d = this._calBoxWidth(r, s, o);
        d /= i;
        const u = Math.sqrt(n * n + c * c), f = Math.floor(u / d);
        let m = o.direction || 0;
        if (1 === m ? m = 2 : 2 === m && (m = 1), f >= 1) {
            for (let n = 1; n <= f; n++) {
                const r = d * (n - .5) / u, i = {
                    coordinates: to(e, t, r),
                    t: r,
                    scale: [ 1, 1, 1 ],
                    rotation: [ 0, 0, l ],
                    rotationZ: l,
                    rotationXY: h
                };
                a.push(i);
            }
            if (o.scaleVertex) {
                const n = (d * f + (u - d * f) / 2) / u, r = (u - d * f) / d, i = [ 1, 1, 1 ];
                i[m] = r;
                const s = {
                    coordinates: to(e, t, n),
                    t: n,
                    scale: i,
                    rotation: [ 0, 0, l ],
                    rotationZ: l,
                    rotationXY: h
                };
                a.push(s);
            }
        } else if (o.scaleVertex) {
            const n = u / d, r = [ 1, 1, 1 ];
            r[m] = n;
            const i = {
                coordinates: to(e, t, .5),
                t: .5,
                scale: r,
                rotation: [ 0, 0, l ],
                rotationZ: l,
                rotationXY: h
            };
            a.push(i);
        }
        return a;
    }
    calModelHeightScale(e, t) {
        const n = this.getGLTFBBox(), r = t / Math.abs(n.max[1] - n.min[1]);
        return h.set(e, r, r, r);
    }
    _calBoxWidth(e, t, n) {
        const r = c.multiply(Ys, t, Ks), i = this.getGLTFBBox(r), s = n.direction || 0, o = h.sub($s, i.max, i.min);
        h.multiply(o, o, e);
        const a = n.gapLength;
        return o[s] + a;
    }
    _getRotationZ(e, t) {
        return function(e, t, n, r) {
            const i = n - e, s = r - t;
            return Math.atan2(s, i);
        }(t.x, t.y, e.x, e.y) / Math.PI * 180;
    }
    _getRotationXY(e, t) {
        return 180 * Math.atan(t / e) / Math.PI;
    }
}

function Qs(e, t) {
    return e[0] - t[0];
}

function eo(e, t) {
    return Math.abs(t[1]) - Math.abs(e[1]);
}

function to(e, t, n) {
    const r = no(e.x, t.x, n), i = no(e.y, t.y, n), s = no(e.z || 0, t.z || 0, n);
    return new e.constructor(r, i, s);
}

function no(e, t, n) {
    return e + n * (t - e);
}

function ro(e, t) {
    const {Ajax: n} = M(), {fetchOptions: r, gltfLoaderOptions: i, urlModifier: s} = t, o = i || {};
    o.urlModifier = s;
    const a = e.lastIndexOf("/"), l = e.slice(0, a), c = e.slice(e.lastIndexOf(".")).toLowerCase();
    return ".gltf" === c ? n.getJSON(e, r, s).then((e => so(l, e, o))) : ".glb" === c ? n.getArrayBuffer(e, r, s).then((e => so(l, {
        buffer: e.data,
        byteOffset: 0
    }, o))) : null;
}

function io(e, t) {
    return new Js(e, t);
}

function so(e, t, n) {
    const {GLTFLoader: r} = M();
    return new r(e, t, n).load();
}

var oo = Object.freeze({
    __proto__: null,
    exportGLTFPack: io,
    load: ro,
    loadGLTF: so
});

const ao = [ -1, 0, -1, 1, 0, -1, -1, 0, 1, 1, 0, 1 ], lo = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], co = [ 3, 1, 0, 0, 2, 3 ], ho = [ 0, 0, 1, 0, 0, 1, 1, 1 ], uo = {
    vertices: [ -.8111000061035156, 2.0102999210357666, -.8111000061035156, 0, .010300000198185444, -0, -.8111000061035156, 2.0102999210357666, .8111000061035156, -.8111000061035156, 2.0102999210357666, .8111000061035156, 0, .010300000198185444, -0, .8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, .8111000061035156, 0, .010300000198185444, -0, .8111000061035156, 2.0102999210357666, -.8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, 0, .010300000198185444, -0, -.8111000061035156, 2.0102999210357666, -.8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, -.8111000061035156, 2.0102999210357666, -.8111000061035156, 0, 2.9419000148773193, -0, .8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, -.8111000061035156, 0, 2.9419000148773193, -0, -.8111000061035156, 2.0102999210357666, -.8111000061035156, -.8111000061035156, 2.0102999210357666, .8111000061035156, 0, 2.9419000148773193, -0, -.8111000061035156, 2.0102999210357666, .8111000061035156, .8111000061035156, 2.0102999210357666, .8111000061035156, 0, 2.9419000148773193, -0 ],
    normals: [ -.9267006516456604, -.3758002817630768, -0, -.9267006516456604, -.3758002817630768, -0, -.9267006516456604, -.3758002817630768, -0, 0, -.3758002817630768, .9267006516456604, 0, -.3758002817630768, .9267006516456604, 0, -.3758002817630768, .9267006516456604, .9267006516456604, -.3758002817630768, -0, .9267006516456604, -.3758002817630768, -0, .9267006516456604, -.3758002817630768, -0, 0, -.3758002817630768, -.9267006516456604, 0, -.3758002817630768, -.9267006516456604, 0, -.3758002817630768, -.9267006516456604, 0, .656676173210144, -.7541726231575012, 0, .656676173210144, -.7541726231575012, 0, .656676173210144, -.7541726231575012, .7541726231575012, .656676173210144, -0, .7541726231575012, .656676173210144, -0, .7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, -.7541726231575012, .656676173210144, -0, 0, .656676173210144, .7541726231575012, 0, .656676173210144, .7541726231575012, 0, .656676173210144, .7541726231575012 ],
    indices: [ 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23 ]
}, fo = [ "cube", "plane", "pyramid" ], mo = {
    "cube": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array([ 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1 ])
                    },
                    NORMAL: {
                        array: new Int8Array([ 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1 ])
                    },
                    TEXCOORD_0: {
                        array: new Int8Array([ 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1, 0, 0, 1, 0, 0, 1, 1, 1 ])
                    }
                },
                indices: new Uint16Array([ 0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23 ]),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    },
    "plane-cube": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array(ao)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(ho)
                    }
                },
                indices: new Uint16Array(co),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, -60, 0 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 60, 0 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 60, 0, 0 ],
                rotation: [ 0, 0, .7071067811865475, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ -60, 0, 0 ],
                rotation: [ 0, 0, .7071067811865475, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 0, 60 ],
                rotation: [ .7071067811865475, 0, 0, .7071067811865476 ]
            }, {
                mesh: 0,
                scale: [ 60, 60, 60 ],
                translation: [ 0, 0, -60 ],
                rotation: [ .7071067811865475, 0, 0, .7071067811865476 ]
            } ]
        } ]
    },
    "plane": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Int8Array(ao)
                    },
                    NORMAL: {
                        array: new Int8Array(lo)
                    },
                    TEXCOORD_0: {
                        array: new Int8Array(ho)
                    }
                },
                indices: new Uint16Array(co),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    },
    "pyramid": {
        meshes: [ {
            primitives: [ {
                attributes: {
                    POSITION: {
                        array: new Float32Array(uo.vertices)
                    },
                    NORMAL: {
                        array: new Float32Array(uo.normals)
                    },
                    TEXCOORD_0: {
                        array: new Float32Array(uo.uv)
                    }
                },
                indices: new Uint16Array(uo.indices),
                mode: 4
            } ]
        } ],
        scenes: [ {
            nodes: [ {
                mesh: 0,
                scale: [ 60, 60, 60 ]
            } ]
        } ]
    }
};

const go = function() {
    const e = [ 0, 0, 0 ], t = 90 * Math.PI / 180, n = [ 0, 0, 0, 0 ], r = new Array(16);
    return function(i, s, o, a, l, h) {
        const d = [ c.lookAt([], e, [ 1, 0, 0 ], h && h[0] || [ 0, -1, 0 ]), c.lookAt([], e, [ -1, 0, 0 ], h && h[1] || [ 0, -1, 0 ]), c.lookAt([], e, [ 0, 1, 0 ], h && h[2] || [ 0, 0, 1 ]), c.lookAt([], e, [ 0, -1, 0 ], h && h[3] || [ 0, 0, -1 ]), c.lookAt([], e, [ 0, 0, 1 ], h && h[4] || [ 0, -1, 0 ]), c.lookAt([], e, [ 0, 0, -1 ], h && h[5] || [ 0, -1, 0 ]) ], u = {
            context: {
                viewMatrix: function(e, t, n) {
                    return d[n];
                },
                projMatrix: c.perspective(r, t, 1, .5, 1.1)
            }
        };
        s && (s.faces ? u.framebuffer = function(e, t, n) {
            return s.faces[n];
        } : u.framebuffer = s);
        return i(u)(6, ((e, t, r) => {
            const c = {
                color: n,
                depth: 1
            };
            s && (c.framebuffer = s.faces ? s.faces[r] : s), i.clear(c), o(a), l && l();
        })), s;
    };
}();

var _o = {
    vertices: [ 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, 1, -1, -1, 1, -1, -1, 1, 1, -1, 1, 1, -1, 1, -1, -1, -1, -1, -1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1 ],
    textures: [ 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 0 ],
    indices: [ 0, 1, 2, 0, 2, 3, 4, 5, 6, 4, 6, 7, 8, 9, 10, 8, 10, 11, 12, 13, 14, 12, 14, 15, 16, 17, 18, 16, 18, 19, 20, 21, 22, 20, 22, 23 ]
}, po = "#define SHADER_NAME CUBE_MAP\nattribute vec3 aPosition;\nvarying vec3 vWorldPos;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nvoid main() {\n  vWorldPos = aPosition;\n  gl_Position = projMatrix * viewMatrix * vec4(vWorldPos, 1.);\n}", vo = "#define SHADER_NAME CUBEMAP\nprecision highp float;\nuniform samplerCube cubeMap;\nuniform float exposure;\nvarying vec3 vWorldPos;\n#ifdef ENCODE_RGBM\nvec4 c(const in vec3 d, const in float e) {\n  if(e <= .0)\n    return vec4(d, 1.);\n  vec4 f;\n  vec3 h = d / e;\n  f.a = clamp(max(max(h.r, h.g), max(h.b, 1e-6)), .0, 1.);\n  f.a = ceil(f.a * 255.) / 255.;\n  f.rgb = h / f.a;\n  return f;\n}\n#endif\nvoid main() {\n  vec4 i = textureCube(cubeMap, vWorldPos);\n  i.rgb *= exposure;\n#ifdef ENCODE_RGBM\ni = c(i.rgb, 7.);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = i;\n#endif\n}", xo = "precision highp float;\n#define PI 3.1415926\nvarying vec3 vWorldPos;\nuniform sampler2D equirectangularMap;\nconst vec2 c = vec2(.1591, .3183);\nvec2 d(vec3 e) {\n  vec2 f = vec2(atan(e.y, e.x), asin(e.z));\n  f *= c;\n  f += .5;\n  return f;\n}\nvoid main() {\n  vec2 f = d(normalize(vWorldPos));\n  vec4 h = texture2D(equirectangularMap, f);\n  gl_FragColor = vec4(h.rgb, 1.);\n}", yo = "#define SHADER_NAME PBR_prefilter\nprecision highp float;\nvarying vec3 vWorldPos;\nuniform samplerCube environmentMap;\nuniform sampler2D distributionMap;\nuniform float roughness;\nuniform float resolution;\nconst float c = 3.14159265359;\nfloat d(vec3 e, vec3 f, float h) {\n  float a = h * h;\n  float i = a * a;\n  float j = max(dot(e, f), .0);\n  float k = j * j;\n  float l = i;\n  float m = (k * (i - 1.) + 1.);\n  m = c * m * m;\n  return l / m;\n}\nvec3 n(float o, vec3 e, float h) {\n  vec4 u = texture2D(distributionMap, vec2(h, o));\n  vec3 f = u.xyz;\n  float v = sign(u.w - .5);\n  float A = sign(u.w - 200.0 / 255. * clamp(v, .0, 1.) - .15);\n  f.x *= v;\n  f.y *= A;\n  vec3 B = abs(e.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 C = normalize(cross(B, e));\n  vec3 D = cross(e, C);\n  vec3 E = C * f.x + D * f.y + e * f.z;\n  return normalize(E);\n}\nvoid main() {\n  vec3 e = normalize(vWorldPos);\n  vec3 F = e;\n  vec3 G = F;\n  const int I = 1024;\n  vec3 J = vec3(.0);\n  float K = .0;\n  for(int L = 0; L < I; ++L) {\n    vec3 f = n(float(L) / float(I), e, roughness);\n    vec3 M = normalize(2. * dot(G, f) * f - G);\n    float O = max(dot(e, M), .0);\n    if(O > .0) {\n      J += textureCube(environmentMap, M).rgb * O;\n      K += O;\n    }\n  }\n  J = J / K;\n  gl_FragColor = vec4(J, 1.);\n}", bo = "precision highp float;\nvarying vec2 vTexCoords;\nuniform sampler2D distributionMap;\nconst float c = 3.14159265359;\nvec4 d(float a, float b) {\n  a *= 65535.;\n  b *= 65535.;\n  vec4 rgba;\n  rgba[0] = mod(a, 255.);\n  rgba[1] = (a - rgba[0]) / 65280.0;\n  rgba[2] = mod(b, 255.);\n  rgba[3] = (b - rgba[2]) / 65280.0;\n  return rgba;\n}\nvec3 e(float f, vec3 h, float i) {\n  vec4 j = texture2D(distributionMap, vec2(i, f));\n  vec3 k = j.xyz;\n  float l = sign(j.w - .5);\n  float m = sign(j.w - clamp(l, .0, 1.) * 200.0 / 255. - .15);\n  k.x *= l;\n  k.y *= m;\n  vec3 n = abs(h.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 o = normalize(cross(n, h));\n  vec3 u = cross(h, o);\n  vec3 v = o * k.x + u * k.y + h * k.z;\n  return normalize(v);\n}\nfloat A(float B, float i) {\n  float a = i;\n  float C = (a * a) / 2.;\n  float D = B;\n  float E = B * (1. - C) + C;\n  return D / E;\n}\nfloat F(float B, float G, float i) {\n  float I = A(B, i);\n  float J = A(G, i);\n  return J * I;\n}\nvec2 K(float B, float i) {\n  vec3 L;\n  L.x = sqrt(1. - B * B);\n  L.y = .0;\n  L.z = B;\n  float M = .0;\n  float O = .0;\n  vec3 h = vec3(.0, .0, 1.);\n  const int P = 1024;\n  for(int Q = 0; Q < P; ++Q) {\n    vec3 k = e(float(Q) / float(P), h, i);\n    vec3 R = normalize(2. * dot(L, k) * k - L);\n    float G = max(R.z, .0);\n    float S = max(k.z, .0);\n    float T = max(dot(L, k), .0);\n    float B = max(dot(h, L), .0);\n    if(G > .0) {\n      float U = F(B, G, i);\n      float W = (U * T) / (S * B);\n      float X = pow(1. - T, 5.);\n      M += (1. - X) * W;\n      O += X * W;\n    }\n  }\n  M /= float(P);\n  O /= float(P);\n  return vec2(M, O);\n}\nvoid main() {\n  vec2 Y = K(vTexCoords.x, vTexCoords.y);\n  gl_FragColor = d(Y.x, Y.y);\n}", wo = "attribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoords;\nvoid main() {\n  vTexCoords = aTexCoord;\n  gl_Position = vec4(aPosition, 1.);\n}";

/*!
 * from claygl
 * https://github.com/pissang/claygl/
 * License: BSD-2-Clause
 */
function To(e, t) {
    const n = e[0], r = e[1], i = e[2];
    return 0 === t ? 1 : 1 === t ? n : 2 === t ? r : 3 === t ? i : 4 === t ? n * i : 5 === t ? r * i : 6 === t ? n * r : 7 === t ? 3 * i * i - 1 : n * n - r * r;
}

const So = {
    px: [ 2, 1, 0, -1, -1, 1 ],
    nx: [ 2, 1, 0, 1, -1, -1 ],
    py: [ 0, 2, 1, 1, -1, -1 ],
    ny: [ 0, 2, 1, 1, 1, 1 ],
    pz: [ 0, 1, 2, -1, -1, -1 ],
    nz: [ 0, 1, 2, 1, -1, 1 ]
}, Mo = [ "px", "nx", "py", "ny", "pz", "nz" ];

let Ao;

const Co = Zr.compile(_s);

function ko(e, t = {}, n) {
    e = Io(e);
    const r = t.envTexture, i = t.envCubeSize || 512, s = t.sampleSize || 1024, o = t.roughnessLevels || 256, a = t.prefilterCubeSize || 256;
    let l, c = !1;
    if (Array.isArray(r)) {
        const t = e.cube({
            flipY: !0,
            faces: r
        });
        l = function(e, t, n) {
            const r = e({
                frag: Co,
                vert: po,
                attributes: {
                    "aPosition": _o.vertices
                },
                uniforms: {
                    "hsv": [ 0, 0, 0 ],
                    "projMatrix": e.context("projMatrix"),
                    "viewMatrix": e.context("viewMatrix"),
                    "cubeMap": t,
                    "bias": 0,
                    "size": t.width,
                    "environmentExposure": 1,
                    "backgroundIntensity": 1
                },
                elements: _o.indices
            }), i = e.cube({
                width: n,
                height: n,
                min: "linear",
                mag: "linear",
                format: "rgba"
            }), s = e.framebufferCube({
                radius: n,
                color: i
            });
            return go(e, s, r, {
                size: n
            }, null, [ [ 0, 0, -1 ], [ 0, 0, -1 ], [ 0, 0, 1 ], [ 0, 0, 1 ], [ 0, -1, 0 ], [ 0, -1, 0 ] ]), 
            r.destroy(), s;
        }(e, t, i), t.destroy();
    } else l = function(e, t, n) {
        if (!Ho(e)) throw new Error("HDR is not supported for lack of support for float 16 texture");
        n = n || 512;
        const r = e({
            frag: xo,
            vert: po,
            attributes: {
                "aPosition": _o.vertices
            },
            uniforms: {
                "projMatrix": e.context("projMatrix"),
                "viewMatrix": e.context("viewMatrix"),
                "equirectangularMap": t
            },
            elements: _o.indices
        }), i = e.cube({
            width: n,
            height: n,
            min: "linear mipmap linear",
            mag: "linear",
            type: "float16",
            format: "rgba"
        }), s = e.framebufferCube({
            radius: n,
            color: i
        });
        return go(e, s, r), r.destroy(), s;
    }(e, r, i), c = !0;
    const {prefilterMap: d, prefilterMipmap: u} = function(e, t, n, r, i, s) {
        const o = function(e, t, n, r, i, s) {
            r = r || 1024, i = i || 256;
            const o = Lo(r, i), a = e.texture({
                data: o,
                width: i,
                height: r,
                min: "nearest",
                mag: "nearest"
            }), l = e({
                frag: yo,
                vert: po,
                attributes: {
                    "aPosition": _o.vertices
                },
                uniforms: {
                    "projMatrix": e.context("projMatrix"),
                    "viewMatrix": e.context("viewMatrix"),
                    "environmentMap": t,
                    "distributionMap": a,
                    "roughness": e.prop("roughness"),
                    "resolution": n
                },
                elements: _o.indices,
                viewport: {
                    x: 0,
                    y: 0,
                    width: e.prop("size"),
                    height: e.prop("size")
                }
            });
            let c = n;
            const h = e.texture({
                radius: n,
                min: "linear",
                mag: "linear",
                type: s ? "float" : "uint8"
            }), d = e.framebuffer({
                radius: n,
                color: h
            }), u = Math.log(c) / Math.log(2), f = [];
            for (let t = 0; t <= u; t++) {
                let n = 0;
                go(e, d, l, {
                    roughness: t / (u - 1),
                    size: c
                }, (function() {
                    const t = e.read({
                        framebuffer: d
                    });
                    let r = t;
                    if (s) {
                        r = new Uint16Array(t.length);
                        for (let e = 0; e < t.length; e++) r[e] = Math.min(zr.toHalfFloat(t[e]), 65504);
                    }
                    f[n] || (f[n] = {
                        mipmap: []
                    }), f[n].mipmap.push(r), n++;
                })), c /= 2, d.resize(c);
            }
            return a.destroy(), d.destroy(), l.destroy(), f;
        }(e, t, n, r, i, s), a = e.cube({
            radius: n,
            min: "linear",
            mag: "linear",
            type: s ? "float16" : "uint8",
            faces: o,
            format: "rgba"
        });
        return {
            prefilterMap: a,
            prefilterMipmap: o
        };
    }(e, l, a, s, o, c);
    let f;
    if (!t.ignoreSH) {
        const r = a, i = e => {
            const t = [];
            for (let n = 0; n < e.length; n++) t.push(...e[n]);
            return t;
        }, s = Oo(e, d, r, !1, t.environmentExposure, !0), {projectEnvironmentMapCPU: o} = t;
        if (o) return void o({
            cubePixels: s,
            width: r,
            height: r
        }, (e => {
            f = i(e), n(m());
        }));
        f = function(e, t, n) {
            const r = new Array(9), i = [], s = [], o = [];
            for (let a = 0; a < 9; a++) {
                const l = [ 0, 0, 0 ];
                for (let r = 0; r < Mo.length; r++) {
                    const c = e[r], d = [ 0, 0, 0 ];
                    let u = 0, f = 0;
                    const m = So[Mo[r]];
                    for (let e = 0; e < n; e++) for (let r = 0; r < t; r++) {
                        i[0] = r / (t - 1) * 2 - 1, i[1] = e / (n - 1) * 2 - 1, i[2] = -1, h.normalize(i, i), 
                        o[0] = i[m[0]] * m[3], o[1] = i[m[1]] * m[4], o[2] = i[m[2]] * m[5], s[0] = c[f++] / 255, 
                        s[1] = c[f++] / 255, s[2] = c[f++] / 255;
                        const l = c[f++] / 255 * 7;
                        s[0] *= l, s[1] *= l, s[2] *= l, h.scaleAndAdd(d, d, s, To(o, a) * -i[2]), u += -i[2];
                    }
                    h.scaleAndAdd(l, l, d, 1 / u);
                }
                r[a] = h.scale(l, l, 1 / 6);
            }
            return r;
        }(s, r, r), f = i(f);
    }
    function m() {
        const n = {
            envMap: l,
            isHDR: c,
            prefilterMap: d
        };
        return f && (n.sh = f), "array" === t.format && (n.envMap = {
            width: l.width,
            height: l.height,
            faces: Oo(e, l, i, c)
        }, n.prefilterMap = {
            width: d.width,
            height: d.height,
            faces: u
        }, l.destroy(), d.destroy()), n;
    }
    if (!n) return m();
    n(m());
}

function Oo(e, t, n, r, i = 1, s = !1) {
    const o = e({
        frag: (s ? "#define ENCODE_RGBM\n" : "") + vo,
        vert: po,
        attributes: {
            "aPosition": _o.vertices
        },
        uniforms: {
            "projMatrix": e.context("projMatrix"),
            "viewMatrix": e.context("viewMatrix"),
            "cubeMap": t,
            "exposure": i
        },
        elements: _o.indices
    }), a = [], l = e.texture({
        radius: n,
        min: "linear",
        mag: "linear",
        type: r ? "float" : "uint8",
        format: "rgba"
    }), c = e.framebuffer({
        radius: n,
        color: l
    });
    return go(e, c, o, {
        size: n
    }, (function() {
        const t = e.read();
        if (r) {
            const e = new Uint16Array(t.length);
            for (let n = 0; n < t.length; n++) e[n] = Math.min(zr.toHalfFloat(t[n]), 65504);
            a.push(e);
        } else a.push(t);
    })), o.destroy(), c.destroy(), a;
}

const Eo = new Int8Array([ -1, 1, 0, -1, -1, 0, 1, 1, 0, 1, -1, 0 ]), Po = new Int8Array([ 0, 1, 0, 0, 1, 1, 1, 0 ]);

function Io(e) {
    return e.vao && e || function() {
        if (!Ao) {
            const e = document.createElement("canvas").getContext("webgl");
            Ao = w({
                optionalExtensions: [ "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear" ],
                attributes: {
                    alpha: !0,
                    depth: !0,
                    stencil: !0,
                    preserveDrawingBuffer: !0
                },
                gl: e
            }), Ao.on("lost", (() => {
                Ao.destroy(), Ao = null;
            }));
        }
        return Ao;
    }();
}

function Ro(e, t, n, r) {
    const i = Io(e);
    t = t || 256;
    const s = Lo(n = n || 1024, r = r || 256), o = i.texture({
        data: s,
        width: r,
        height: n,
        min: "nearest",
        mag: "nearest"
    }), a = i.buffer({
        data: Eo,
        name: "aPosition"
    }), l = i.buffer({
        data: Po,
        name: "aTexCoord"
    }), c = i.framebuffer({
        radius: t,
        colorType: "uint8",
        colorFormat: "rgba",
        min: "linear",
        mag: "linear"
    }), h = i({
        frag: bo,
        vert: wo,
        attributes: {
            "aPosition": {
                buffer: a
            },
            "aTexCoord": {
                buffer: l
            }
        },
        uniforms: {
            "distributionMap": o
        },
        framebuffer: c,
        viewport: {
            x: 0,
            y: 0,
            width: t,
            height: t
        },
        count: Eo.length / 3,
        primitive: "triangle strip"
    });
    if (h(), e.wgpu) {
        const t = i.read({
            framebuffer: c
        });
        return new vi(e, {
            data: t,
            width: c.width,
            height: c.height
        });
    }
    return h.destroy(), a.destroy(), l.destroy(), o.destroy(), c;
}

function Lo(e, t) {
    const n = new Float32Array(e * t * 4);
    for (let r = 0; r < e; r++) {
        const {x: i, y: s} = Fo(r, e);
        for (let e = 0; e < t; e++) {
            const o = e / t, a = o * o, l = 2 * Math.PI * i, c = Math.sqrt((1 - s) / (1 + (a * a - 1) * s)), h = Math.sqrt(1 - c * c), d = 4 * (r * t + e), u = h * Math.cos(l), f = h * Math.sin(l);
            n[d] = Math.abs(255 * u), n[d + 1] = Math.abs(255 * f), n[d + 2] = 255 * c, n[d + 3] = (u > 0 ? 200 : 0) + (f > 0 ? 55 : 0);
        }
    }
    return n;
}

function Fo(e, t) {
    let n = (e << 16 | e >>> 16) >>> 0;
    return n = ((1431655765 & n) << 1 | (2863311530 & n) >>> 1) >>> 0, n = ((858993459 & n) << 2 | (3435973836 & n) >>> 2) >>> 0, 
    n = ((252645135 & n) << 4 | (4042322160 & n) >>> 4) >>> 0, n = (((16711935 & n) << 8 | (4278255360 & n) >>> 8) >>> 0) / 4294967296, 
    {
        x: e / t,
        y: n
    };
}

function Ho(e) {
    return e._gl instanceof WebGL2RenderingContext || e.hasExtension("OES_texture_half_float");
}

var Do = Object.freeze({
    __proto__: null,
    createIBLMaps: function(e, t = {}) {
        return ko(e, t);
    },
    createIBLMapsAsync: function(e, t = {}) {
        return new Promise((n => {
            ko(e, t, (e => {
                e.updateTime = t.updateTime, n(e);
            }));
        }));
    },
    generateDFGLUT: Ro,
    supportFloat16: Ho
});

const No = {
    "uvScale": [ 1, 1 ],
    "uvOffset": [ 0, 0 ],
    "uvRotation": 0,
    "textureOrigin": null,
    "textureWidth": null,
    "baseColorFactor": [ 1, 1, 1, 1 ],
    "emissiveFactor": [ 0, 0, 0 ],
    "baseColorIntensity": 1,
    "emitColorFactor": 1,
    "occlusionFactor": 1,
    "roughnessFactor": .4,
    "metallicFactor": 0,
    "normalMapFactor": 1,
    "specularF0": .5,
    "emitMultiplicative": 1,
    "normalMapFlipY": 0,
    "outputSRGB": 1,
    "baseColorTexture": null,
    "normalTexture": null,
    "occlusionTexture": null,
    "metallicRoughnessTexture": null,
    "emissiveTexture": null,
    "uvOrigin": [ 0, 0 ],
    "noiseTexture": null,
    "specularAAVariance": 20,
    "specularAAThreshold": 20,
    "hsv": [ 0, 0, 0 ],
    "contrast": 1,
    "bumpTexture": null,
    "bumpScale": .05,
    "bumpMinLayers": 5,
    "bumpMaxLayers": 20,
    "alphaTest": 0
};

class Bo extends Ft {
    constructor(e) {
        const t = E({}, No);
        (e.metallicRoughnessTexture || e.metallicRoughnessTexture) && (t.roughnessFactor = 1, 
        t.metallicFactor = 1), super(e, t);
    }
    appendDefines(e, t) {
        super.appendDefines(e, t);
        const n = this.uniforms, r = t.data[t.desc.positionAttribute];
        r.buffer && r.buffer.itemType && r.buffer.itemType.startsWith("sint") && (e.POSITION_IS_INT = 1);
        const i = t.data[t.desc.normalAttribute];
        i && i.buffer && i.buffer.itemType && i.buffer.itemType.startsWith("sint") && (e.NORMAL_IS_INT = 1), 
        n.GAMMA_CORRECT_INPUT && (e.GAMMA_CORRECT_INPUT = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
        if (t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), 
        t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1), 
        t.data.aVertexColorType && (e.HAS_VERTEX_COLOR = 1), !t.data[t.desc.uv0Attribute]) return e;
        n.baseColorTexture && (e.HAS_ALBEDO_MAP = 1), n.metallicRoughnessTexture && (e.HAS_METALLICROUGHNESS_MAP = 1), 
        n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), 
        n.normalTexture && (e.HAS_NORMAL_MAP = 1), n.bumpTexture && (e.HAS_BUMP_MAP = 1), 
        n.skinTexture && (e.HAS_SKIN_MAP = 1), (e.HAS_ALBEDO_MAP || e.HAS_METALLICROUGHNESS_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP || e.HAS_BUMP_MAP || e.HAS_SKIN_MAP) && (e.HAS_MAP = 1), 
        n.noiseTexture && (e.HAS_RANDOM_TEX = 1), t.data[t.desc.tangentAttribute] ? e.HAS_TANGENT = 1 : t.data[t.desc.normalAttribute] && (e.HAS_NORMAL = 1);
        const s = n.alphaMode && n.alphaMode.toUpperCase();
        return "MASK" === s ? e.ALPHA_MODE = 1 : "OPAQUE" === s && (e.ALPHA_MODE = 2), e;
    }
}

class Uo extends(zt(Bo)){}

function zo(e, t, n) {
    if (n.ambientUpdate) {
        const {iblTexes: r} = e, i = n.target;
        r ? (jo(r), e.iblTexes = Vo(t, i)) : e.iblTexes = Vo(t, i), i.getRenderer().setToRedraw();
    }
}

const Go = [ 0, 0 ];

function Vo(e, t) {
    const n = t.getLightManager(), r = n && n.getAmbientResource();
    if (!r) return null;
    const i = r.isHDR;
    return {
        "prefilterMap": e.cube({
            width: r.prefilterMap.width,
            height: r.prefilterMap.height,
            faces: r.prefilterMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: i ? "float16" : "uint8"
        }),
        "envMap": e.cube({
            width: r.envMap.width,
            height: r.envMap.height,
            faces: r.envMap.faces,
            min: "linear",
            mag: "linear",
            format: "rgba",
            type: i ? "float16" : "uint8"
        }),
        "sh": r.sh
    };
}

function jo(e) {
    for (const t in e) e[t] && e[t].destroy && e[t].destroy(), delete e[t];
}

var Wo = Object.freeze({
    __proto__: null,
    createIBLTextures: Vo,
    disposeIBLTextures: jo,
    getIBLResOnCanvas: function(e) {
        const {dfgLUT: t, iblTexes: n} = e;
        return {
            dfgLUT: t,
            iblTexes: n
        };
    },
    getPBRUniforms: function(e, t, n, r, i) {
        const s = e.viewMatrix, o = e.projMatrix, a = e.cameraPosition, l = e.getRenderer().canvas, c = function(e, t) {
            const n = e.getLightManager(), r = n && n.getAmbientResource(), i = n && n.getAmbientLight() || {}, s = n && n.getDirectionalLight() || {};
            let o;
            if (r) {
                const e = t.prefilterMap.width, n = Math.log(e) / Math.log(2);
                o = {
                    "prefilterMap": t.prefilterMap,
                    "diffuseSPH": t.sh,
                    "prefilterMiplevel": [ n, n ],
                    "prefilterSize": [ e, e ],
                    "hdrHSV": i.hsv || [ 0, 0, 0 ]
                };
            } else o = {
                "ambientColor": i.color || [ .2, .2, .2 ]
            };
            return o.environmentExposure = I(i.exposure) ? i.exposure : 1, o.environmentOrientation = i.orientation || 0, 
            o.light0_diffuse = [ ...s.color || [ 1, 1, 1 ], 1 ], o.light0_viewDirection = s.direction || [ 1, 1, -1 ], 
            o;
        }(e, t), h = E({
            viewMatrix: s,
            projMatrix: o,
            projViewMatrix: e.projViewMatrix,
            cameraPosition: a,
            outSize: [ l.width, l.height ],
            cameraNearFar: [ e.cameraNear, e.cameraFar ]
        }, c);
        return h.brdfLUT = n, r && r.renderUniforms && E(h, r.renderUniforms), h.halton = i || Go, 
        h;
    },
    isSupported: function(e) {
        return !!e.wgpu || e.hasExtension("EXT_shader_texture_lod");
    },
    loginIBLResOnCanvas: function(e, t, n) {
        if (!e.dfgLUT && (e.dfgLUT = Ro(t), e.dfgLUT.mtkRefCount = 0, n)) {
            const r = (...n) => zo.call(this, e, t, ...n);
            n.on("updatelights", r), e._iblResListener = r;
        }
        e.dfgLUT.mtkRefCount++;
        const r = n.getLightManager();
        return r && r.getAmbientResource() ? (e.iblTexes || (e.iblTexes = Vo(t, n)), {
            dfgLUT: e.dfgLUT,
            iblTexes: e.iblTexes
        }) : {
            dfgLUT: e.dfgLUT,
            iblTexes: null
        };
    },
    logoutIBLResOnCanvas: function(e, t) {
        let n = !1;
        if (e.dfgLUT && (e.dfgLUT.mtkRefCount--, e.dfgLUT.mtkRefCount <= 0)) {
            if (n = !0, t) {
                const n = e._iblResListener;
                t.off("updatelights", n);
            }
            e.dfgLUT.destroy(), delete e.dfgLUT;
        }
        e.iblTexes && n && (jo(e.iblTexes), delete e.iblTexes);
    }
});

class qo extends Yi {
    constructor(e) {
        super({
            name: "shadow-map",
            vert: "attribute vec3 aPosition;\nuniform mat4 lightProjViewModelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\n#include <line_extrusion_vert>\n#include <get_output>\nvarying vec4 vPosition;\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 d = getLineExtrudePosition(aPosition);\n  vec4 e = getPosition(d);\n#else\nvec4 e = getPosition(aPosition);\n#endif\ngl_Position = lightProjViewModelMatrix * c * e;\n  vPosition = gl_Position;\n}",
            frag: "#define SHADER_NAME vsm_mapping\nprecision highp float;\nvarying vec4 vPosition;\n#ifdef PACK_FLOAT\n#include <common_pack_float>\n#endif\nvoid main() {\n  \n#if defined(USE_ESM)\n#ifdef PACK_FLOAT\ngl_FragColor = common_encodeDepth(gl_FragCoord.z);\n#else\ngl_FragColor = vec4(gl_FragCoord.z, .0, .0, 1.);\n#endif\n#endif\n}",
            wgslVert: "",
            wgslFrag: "",
            uniforms: [ {
                name: "lightProjViewModelMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply([], t.lightProjViewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {},
            defines: e
        });
    }
    setDefines(e) {
        return e.POSITION_TYPE_3 || (e.POSITION_TYPE_3 = "vec3f"), super.setDefines(e);
    }
    filter(e) {
        return e.castShadow;
    }
}

class Xo extends es {
    constructor({blurOffset: e}) {
        super({
            name: "box-shadow-blur",
            frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\n#include <common_pack_float>\nvoid main() {\n  float c = .0;\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      float f = common_decodeDepth(texture2D(textureSource, e));\n      float s = max(.0, sign(1. - f));\n      d += sign(f) * s;\n      c += f;\n    }\n  float h = c / max(1., d);\n  gl_FragColor = common_encodeDepth(h);\n}",
            wgslFrag: "",
            defines: {
                "BOXBLUR_OFFSET": e || 2
            }
        }), this._blurOffset = e || 2;
    }
    getMeshCommand(e, t) {
        const n = this.dkey + "_box_shadow_blur_" + this._blurOffset;
        return this.commands[n] || (this.commands[n] = this.createMeshCommand(e, t)), this.commands[n];
    }
}

let Ko = null, Zo = null;

class Yo {
    constructor(e, {width: t, height: n, blurOffset: r, defines: i}) {
        this.renderer = e, this.width = t || 512, this.height = n || 512, this.blurOffset = C(r) ? 2 : r, 
        this._init(i);
    }
    render(e, {cameraProjViewMatrix: t, lightDir: n, farPlane: r, cameraLookAt: i}) {
        return {
            lightProjViewMatrix: this._renderShadow(e, t, n, r, i),
            shadowMap: this.blurTex || this.depthTex,
            depthFBO: this.depthFBO,
            blurFBO: this.blurFBO
        };
    }
    resize(e, t) {
        return this.depthTex && (this.depthTex.resize(e, t), this.depthFBO.resize(e, t)), 
        this.width = e, this.blurFBO && (this.blurTex.resize(e, t), this.blurFBO.resize(e, t)), 
        this.height = t, this;
    }
    _renderShadow(e, t, n, r, i) {
        const s = this.renderer, o = Ko(t);
        if (r) for (let e = 4; e < 8; e++) o[e] = r[e - 4];
        const a = Zo(i, o, n);
        if (s.clear({
            color: [ 1, 0, 0, 1 ],
            depth: 1,
            framebuffer: this.depthFBO
        }), s.render(this.shadowMapShader, {
            lightProjViewMatrix: a
        }, e, this.depthFBO), this.blurFBO) {
            this.boxBlurShader || (this.boxBlurShader = new Xo({
                blurOffset: this.blurOffset
            })), s.clear({
                color: [ 1, 0, 0, 1 ],
                depth: 1,
                framebuffer: this.blurFBO
            });
            const e = this.depthTex, t = this.boxBlurShader.shaderDefines;
            e.texture && e.texture.sampleCount > 1 ? t.HAS_MULTISAMPLED = 1 : delete t.HAS_MULTISAMPLED, 
            this.boxBlurShader.setDefines(t), s.render(this.boxBlurShader, {
                resolution: [ e.width, e.height ],
                textureSource: e
            }, null, this.blurFBO);
        }
        return a;
    }
    _init(e) {
        const t = this.renderer.device, n = "uint8", r = this.width, i = this.height;
        this.depthTex = t.texture({
            width: r,
            height: i,
            format: "rgba",
            type: n,
            min: "nearest",
            mag: "nearest"
        }), this.shadowMapShader = new qo(e), this.shadowMapShader.filter = e => e.castShadow, 
        this.depthFBO = t.framebuffer({
            color: this.depthTex
        }), this.blurOffset <= 0 || (this.blurTex = t.texture({
            width: r,
            height: i,
            format: "rgba",
            type: n,
            min: "linear",
            mag: "linear"
        }), this.blurFBO = t.framebuffer({
            color: this.blurTex
        }));
    }
    dispose() {
        this.depthTex && (this.depthTex.destroy(), this.depthFBO.destroy(), delete this.depthTex, 
        delete this.depthFBO), this.blurTex && (this.blurTex.destroy(), this.blurFBO.destroy(), 
        delete this.blurTex, delete this.blurFBO), this.shadowMapShader && (this.shadowMapShader.dispose(), 
        delete this.shadowMapShader), this.boxBlurShader && (this.boxBlurShader.dispose(), 
        delete this.boxBlurShader);
    }
}

Ko = function() {
    const e = [ [ -1, -1, -1, 1 ], [ 1, -1, -1, 1 ], [ 1, 1, -1, 1 ], [ -1, 1, -1, 1 ], [ -1, -1, 1, 1 ], [ 1, -1, 1, 1 ], [ 1, 1, 1, 1 ], [ -1, 1, 1, 1 ] ], t = new Array(16);
    return function(n) {
        c.invert(t, n);
        const r = [];
        for (let n = 0; n < e.length; n++) {
            const i = d.transformMat4([], e[n], t);
            d.scale(i, i, 1 / i[3]), r.push(i);
        }
        return r;
    };
}(), Zo = function() {
    let e = new Array(4);
    const t = new Array(3), n = [ 0, 0, 0, 0 ], r = [ 0, 1, 0 ], i = new Array(3);
    let s = new Array(16), o = new Array(16);
    const a = new Array(16), l = [ 1, 1, 1 ], u = [ 0, 0, 0 ];
    return function(f, m, g) {
        d.set(n, ...f, 1), h.scale(t, g, -1), s = c.lookAt(s, h.add(i, n, h.normalize(i, t)), n, r), 
        d.transformMat4(e, m[0], s);
        let _ = e[2], p = e[2], v = e[0], x = e[0], y = e[1], b = e[1];
        for (let t = 1; t < 8; t++) e = d.transformMat4(e, m[t], s), e[2] > p && (p = e[2]), 
        e[2] < _ && (_ = e[2]), e[0] > x && (x = e[0]), e[0] < v && (v = e[0]), e[1] > b && (b = e[1]), 
        e[1] < y && (y = e[1]);
        o = c.ortho(o, -1, 1, -1, 1, -p, -_);
        const w = l[0] = 2 / (x - v), T = l[1] = -2 / (b - y);
        u[0] = -.5 * (v + x) * w, u[1] = -.5 * (y + b) * T, c.identity(a), c.translate(a, a, u), 
        c.scale(a, a, l);
        const S = c.multiply(o, a, o);
        return c.multiply(new Array(16), S, s);
    };
}();

class $o extends Yi {
    constructor(e) {
        const t = [];
        super({
            name: "shadow_display",
            vert: "#define SHADER_NAME SHADOW_DISPLAY\nattribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\n#include <vsm_shadow_vert>\nvoid main() {\n  vec4 c = vec4(aPosition, 1.);\n  gl_Position = projViewModelMatrix * c;\n  shadow_computeShadowPars(c);\n}",
            frag: "#define SHADER_NAME SHADOW_DISPLAY\nprecision mediump float;\nuniform vec3 color;\n#include <vsm_shadow_frag>\nvoid main() {\n  float c = shadow_computeShadow();\n  float d = 1. - c;\n  gl_FragColor = vec4(color * d, d);\n}",
            wgslVert: "",
            wgslFrag: "",
            uniforms: [ {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, n) {
                    return c.multiply(t, n.projViewMatrix, n.modelMatrix);
                }
            } ],
            defines: e || {
                "USE_ESM": 1
            },
            extraCommandProps: {
                depth: {
                    enable: !0,
                    mask: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: (e, t) => t.globalTexSize[0],
                    height: (e, t) => t.globalTexSize[1]
                }
            }
        });
    }
    getMeshCommand(e, t) {
        return this.commands.shadow_display || (this.commands.shadow_display = this.createMeshCommand(e, t)), 
        this.commands.shadow_display;
    }
}

function Jo(e) {
    return 256 * e[2] * 256 + 256 * e[1] + e[0];
}

const Qo = new Uint8Array(4), ea = new Float32Array(Qo.buffer);

let ta, na;

const ra = [ 1, 1 ], ia = "\n    vec3 unpack(highp float f) {\n        highp vec3 color;\n        color.b = floor(f / 65536.0);\n        color.g = floor((f - color.b * 65536.0) / 256.0);\n        color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);\n        // now we have a vec3 with the 3 components in range [0..255]. Let's normalize it!\n        return color / 255.0;\n    }\n", sa = "\nfn unpack(f: f32) -> vec3f {\n    var color: vec3f;\n    color.b = floor(f / 65536.0);\n    color.g = floor((f - color.b * 65536.0) / 256.0);\n    color.r = f - floor(color.b * 65536.0) - floor(color.g * 256.0);\n    return color / 255.0;\n}\n", oa = `\n    precision highp float;\n\n    varying float vPickingId;\n    varying float vFbo_picking_visible;\n\n    uniform float fbo_picking_meshId;\n\n    ${ia}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId + 1.0), (fbo_picking_meshId + 1.0) / 255.0);\n    }\n`, aa = `\n    ${sa}  // Assuming unpack function is defined in this include\n\n    struct PickingUniforms {\n        fbo_picking_meshId: f32,\n    };\n\n    @group(0) @binding($b) var<uniform> pickingUniforms: PickingUniforms;\n\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        if (vertexOutput.vFbo_picking_visible == 0.0) {\n            discard;\n        }\n\n        let rgb = unpack(vertexOutput.vPickingId + 1);\n        let alpha = (pickingUniforms.fbo_picking_meshId + 1) / 255.0;\n        return vec4f(rgb, alpha);\n        // return vec4f(1.0, 0.0, 0.0, 1.0);\n    }\n`, la = `\n    precision highp float;\n\n    uniform int fbo_picking_meshId;\n    varying float vFbo_picking_visible;\n\n    ${ia}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(float(fbo_picking_meshId + 1.0)), 1.0);\n        // gl_FragColor = vec4(unpack(float(35)), 1.0);\n    }\n`, ca = `\n    ${sa}\n\n    struct PickingUniforms {\n        fbo_picking_meshId: f32,\n    };\n\n    @group(0) @binding(0) var<uniform> pickingUniforms: PickingUniforms;\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        if (vertexOutput.vFbo_picking_visible == 0.0) {\n            discard;\n        }\n\n        let meshIdFloat = pickingUniforms.fbo_picking_meshId + 1.0;\n        let rgb = unpack(meshIdFloat);\n\n        return vec4f(rgb, 1.0);\n    }\n`, ha = `\n    precision highp float;\n\n    varying float vFbo_picking_visible;\n    varying float vPickingId;\n\n    ${ia}\n\n    void main() {\n        if (vFbo_picking_visible == 0.0) {\n            discard;\n            return;\n        }\n        gl_FragColor = vec4(unpack(vPickingId + 1.0), 1.0);\n    }\n`, da = `\n    ${sa}\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        if (vertexOutput.vFbo_picking_visible == 0.0) {\n            discard;\n        }\n        let rgb = unpack(vertexOutput.vPickingId + 1.0);\n        return vec4f(rgb, 1.0);\n    }\n`;

function ua(e, t, n) {
    const r = t[0], i = t[1], s = t[2], o = 1 / (n[3] * r + n[7] * i + n[11] * s + n[15]);
    return e[0] = (n[0] * r + n[4] * i + n[8] * s + n[12]) * o, e[1] = (n[1] * r + n[5] * i + n[9] * s + n[13]) * o, 
    e[2] = (n[2] * r + n[6] * i + n[10] * s + n[14]) * o, e;
}

function fa(e) {
    return I(e) && (ra[0] = ra[1] = e, e = ra), e;
}

const ma = e => e && e.geometry && void 0 === e.geometry.properties.shaderHash, ga = [], _a = [], pa = [ {
    name: "modelViewMatrix",
    type: "function",
    fn: (e, t) => c.multiply(ga, t.viewMatrix, t.modelMatrix)
}, {
    name: "modelViewProjMatrix",
    type: "function",
    fn: (e, t) => {
        const n = c.multiply(ga, t.viewMatrix, t.modelMatrix);
        return c.multiply(ga, t.projMatrix, n);
    }
}, {
    name: "modelMatrixInverse",
    type: "function",
    fn: (e, t) => c.invert(ga, t.modelMatrix)
}, {
    name: "projMatrixInverse",
    type: "function",
    fn: (e, t) => c.invert(ga, t.projMatrix)
}, {
    name: "modelViewMatrixInverse",
    type: "function",
    fn: (e, t) => (c.multiply(ga, t.viewMatrix, t.modelMatrix), c.invert(ga, ga))
}, {
    name: "modelViewProjMatrixInverse",
    type: "function",
    fn: (e, t) => {
        const n = c.multiply(ga, t.viewMatrix, t.modelMatrix);
        return c.multiply(ga, t.projMatrix, n), c.invert(ga, ga);
    }
}, {
    name: "modelInverseTransposeMatrix",
    type: "function",
    fn: (e, t) => {
        const n = u.fromMat4(_a, t.modelMatrix), r = u.transpose(n, n);
        return u.invert(r, r);
    }
}, {
    name: "modelViewInverseTransposeMatrix",
    type: "function",
    fn: (e, t) => {
        const n = c.multiply(ga, t.viewMatrix, t.modelMatrix), r = u.fromMat4(_a, n), i = u.transpose(r, r);
        return u.invert(i, i);
    }
} ], va = {
    "LOCAL": "positionMatrix",
    "MODEL": "modelMatrix",
    "VIEW": "viewMatrix",
    "PROJECTION": "projMatrix",
    "MODELVIEW": "modelViewMatrix",
    "MODELVIEWPROJECTION": "modelViewProjMatrix",
    "MODELINVERSE": "modelMatrixInverse",
    "VIEWINVERSE": "viewMatrixInverse",
    "PROJECTIONINVERSE": "projMatrixInverse",
    "MODELVIEWINVERSE": "modelViewMatrixInverse",
    "MODELVIEWPROJECTIONINVERSE": "modelViewProjMatrixInverse",
    "MODELINVERSETRANSPOSE": "modelInverseTransposeMatrix",
    "MODELVIEWINVERSETRANSPOSE": "modelViewInverseTransposeMatrix",
    "VIEWPORT": "viewport",
    "JOINTMATRIX": "jointMatrix",
    "ALPHACUTOFF": "alphaCutoff"
};

class xa {
    constructor(e, t, n) {
        this.activeBuffer = null, this.device = e, this.usedBuffers = [], this.poolBuffers = [], 
        this.bufferSize = t, this.bufferAlignment = n;
    }
    destroy() {
        this.poolBuffers.forEach((e => {
            e.gpuBuffer.destroy();
        })), this.poolBuffers.length = 0, this.usedBuffers.length = 0, this.activeBuffer = null;
    }
    alloc(e, t) {
        if (this.activeBuffer) {
            const e = Ue(this.activeBuffer.size, this.bufferAlignment);
            this.bufferSize - e < t && this.scheduleSubmit();
        }
        this.activeBuffer || (this.activeBuffer = this.poolBuffers.pop(), this.activeBuffer || (this.activeBuffer = {
            gpuBuffer: this.createBuffer(this.device, this.bufferSize),
            storage: new ArrayBuffer(this.bufferSize),
            offset: 0,
            size: 0
        }), this.activeBuffer.offset = 0, this.activeBuffer.size = 0);
        const n = this.activeBuffer, r = Ue(n.size, this.bufferAlignment);
        e.gpuBuffer = n.gpuBuffer, e.offset = r, e.storage = n.storage, n.size = r + t;
    }
    createBuffer(e, t) {
        return e.createBuffer({
            size: t,
            usage: GPUBufferUsage.UNIFORM | GPUBufferUsage.COPY_DST
        });
    }
    scheduleSubmit() {
        this.activeBuffer && (this.usedBuffers.push(this.activeBuffer), this.activeBuffer = null);
    }
    submit() {
        this.scheduleSubmit();
        const e = this.usedBuffers.length;
        if (e) {
            const t = this.device, n = this.poolBuffers;
            for (let r = e - 1; r >= 0; r--) {
                const e = this.usedBuffers[r], {storage: i, gpuBuffer: s, offset: o, size: a} = e;
                t.queue.writeBuffer(s, 0, i, o, a), n.push(e);
            }
            this.usedBuffers.length = 0;
        }
    }
}

let ya = 0;

class ba {
    constructor(e, t, n) {
        this.commandBuffers = [], this._readTargets = {}, this.wgpu = e, this.adapter = n;
        const r = navigator.gpu.getPreferredCanvasFormat();
        t.configure({
            device: e,
            format: r,
            alphaMode: "premultiplied"
        }), this.context = t;
        const i = e.limits;
        this.dynamicBufferPool = new xa(e, 1048576, i.minUniformBufferOffsetAlignment);
    }
    hasExtension(e) {
        return this._supportedFormats || (this._supportedFormats = W(this.wgpu)), this._supportedFormats[e], 
        !0;
    }
    getCommandEncoder() {
        let e = this.commandEncoder;
        return e || (e = this.wgpu.createCommandEncoder(), this.commandEncoder = e), e;
    }
    endCommandEncoder() {
        const {commandEncoder: e} = this;
        if (e) {
            const t = e.finish();
            this.addCommandBuffer(t, !1), this.commandEncoder = null;
        }
    }
    getDefaultFramebuffer() {
        let e = this._defaultFramebuffer;
        if (!e) {
            const t = this.context.canvas;
            e = this._defaultFramebuffer = new xi(this, {
                width: t.width,
                height: t.height,
                depthStencil: !0
            }), e.uid = ya++;
        }
        return e;
    }
    getRenderPassEncoder(e) {
        const t = (e = e || this.getDefaultFramebuffer()).getRenderPassDescriptor();
        return this.getCommandEncoder().beginRenderPass(t);
    }
    addCommandBuffer(e, t) {
        t ? this.commandBuffers.unshift(e) : this.commandBuffers.push(e);
    }
    submit() {
        this.endCommandEncoder(), this.dynamicBufferPool.submit(), this.commandBuffers.length > 0 && (this.wgpu.queue.submit(this.commandBuffers), 
        this.commandBuffers.length = 0);
    }
    preserveDrawingBuffer(e) {
        e.width = this.context.canvas.width, e.height = this.context.canvas.height, e.getContext("2d").drawImage(this.context.canvas, 0, 0);
    }
    buffer(e) {
        return Ye.createBuffer(this, e, e.name);
    }
    elements(e) {
        const t = e.data || e;
        return Ye.createElementBuffer(this, t);
    }
    framebuffer(e, t) {
        let n;
        return I(e) ? (void 0 === t && (t = e), n = {
            color: !0,
            depthStencil: !0,
            width: e,
            height: t
        }) : n = e, new xi(this, n);
    }
    texture(e, t) {
        let n = e;
        return I(e) && (n = {
            width: e,
            height: I(t) ? t : e
        }), new vi(this, n);
    }
    clear(e) {
        const t = e.framebuffer || this.getDefaultFramebuffer();
        t.setClearOptions(e), this._renderToClear(t);
    }
    read(e) {
        const t = e.framebuffer || this._defaultFramebuffer, n = t.width, r = t.height;
        let {width: i, height: s} = e;
        i || (i = n), s || (s = r);
        const o = this.wgpu;
        this.submit();
        const a = {
            x: e.x,
            y: r - e.y - s,
            z: 0
        }, l = e.pixels || new Uint8Array(i * s * 4);
        if (t === this._defaultFramebuffer) {
            const e = new OffscreenCanvas(i, s).getContext("2d", {
                willReadFrequently: !0
            });
            e.drawImage(this.context.canvas, a.x, a.y, i, s, 0, 0, i, s);
            const t = e.getImageData(0, 0, i, s).data;
            for (let e = 0; e < l.length; e += 4) l[e] = t[e], l[e + 1] = t[e + 1], l[e + 2] = t[e + 2], 
            l[e + 3] = t[e + 3];
            return l;
        }
        const c = [ "opaque", "premultiplied" ], h = c.map((() => new OffscreenCanvas(i, s)));
        return h.map(((e, t) => {
            const n = e.getContext("webgpu");
            return n.configure({
                device: o,
                format: "rgba8unorm",
                usage: GPUTextureUsage.COPY_DST,
                alphaMode: c[t]
            }), n.getCurrentTexture();
        })).map(((e, n) => {
            const r = o.createCommandEncoder();
            r.copyTextureToTexture({
                texture: t.colorTexture.texture,
                origin: a
            }, {
                texture: e
            }, {
                width: i,
                height: s
            }), this.wgpu.queue.submit([ r.finish() ]);
            const d = new OffscreenCanvas(i, s).getContext("2d", {
                willReadFrequently: !0
            });
            d.scale(1, -1), d.drawImage(h[n], 0, -s);
            const u = d.getImageData(0, 0, i, s).data, f = c[n];
            for (let e = 0; e < l.length; e += 4) "premultiplied" === f ? l[e + 3] = u[e + 3] : (l[e] = u[e], 
            l[e + 1] = u[e + 1], l[e + 2] = u[e + 2]);
        })), l;
    }
    destroy() {
        this._defaultFramebuffer && (this._defaultFramebuffer.destroy(), delete this._defaultFramebuffer), 
        this.dynamicBufferPool && (this.dynamicBufferPool.destroy(), delete this.dynamicBufferPool);
        for (const e in this._readTargets) {
            const t = this._readTargets[e];
            t && t.destroy();
        }
        this._readTargets = {}, this._emptyPipelines = {};
    }
    incrDrawCall() {
        this._drawCount++;
    }
    resetDrawCalls() {
        this._drawCount = 0;
    }
    getDrawCalls() {
        return this._drawCount;
    }
    _renderToClear(e) {
        const t = this.getRenderPassEncoder(e), n = this._getEmptyPipeline(e);
        t.setPipeline(n), t.draw(3), t.end(), this.submit();
    }
    _getEmptyPipeline(e) {
        const t = !!e.colorTexture, n = e.colorTexture && e.colorTexture.config.sampleCount, r = !!e.depthTexture;
        this._emptyPipelines = this._emptyPipelines || {};
        const i = t + "-" + r + "-" + n;
        if (this._emptyPipelines[i]) return this._emptyPipelines[i];
        const s = this.wgpu, o = s.createShaderModule({
            label: "empty shader",
            code: "\n            @vertex fn vs(\n                @builtin(vertex_index) vertexIndex : u32\n            ) -> @builtin(position) vec4f {\n                let pos = array(\n                    vec2f( 0.0,  0.5),\n                    vec2f(-0.5, -0.5),\n                    vec2f( 0.5, -0.5)\n                );\n                return vec4f(pos[vertexIndex], 0.0, 1.0);\n            }\n            @fragment fn fs() -> @location(0) vec4f {\n                return vec4f(0, 0, 0, 0);\n            }\n            "
        });
        let a;
        a = e.colorTexture ? e.colorTexture.gpuFormat.format : navigator.gpu.getPreferredCanvasFormat();
        const l = {
            layout: "auto",
            vertex: {
                module: o
            },
            fragment: {
                module: o,
                targets: [ {
                    format: a
                } ]
            }
        };
        r && (l.depthStencil = {
            depthWriteEnabled: !1,
            depthCompare: "always",
            format: "depth24plus-stencil8"
        }), n > 1 && (l.multisample = {
            count: n
        });
        const c = s.createRenderPipeline(l);
        return this._emptyPipelines[i] = c, this._emptyPipelines[i];
    }
}

const wa = {
    parseHDR: Nr
}, Ta = {
    PBRHelper: Do,
    StandardMaterial: Bo,
    StandardSpecularGlossinessMaterial: Uo,
    StandardShader: class extends Yi {
        constructor(e = {}) {
            let t = e.extraCommandProps || {};
            const n = e.uniforms;
            t = E({}, t);
            const r = e.defines || {}, i = [], s = [], o = [], a = [], l = [], h = [ {
                name: "modelNormalMatrix",
                type: "function",
                fn: (e, t) => u.fromMat4(i, t.modelMatrix)
            }, {
                name: "modelViewNormalMatrix",
                type: "function",
                fn: (e, t) => {
                    const n = c.multiply(s, t.viewMatrix, t.modelMatrix), r = c.invert(n, n), i = c.transpose(r, r);
                    return u.fromMat4(o, i);
                }
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: (e, t) => c.multiply(a, t.viewMatrix, t.modelMatrix)
            }, {
                name: "environmentTransform",
                type: "function",
                global: !0,
                fn: (e, t) => {
                    const n = t.environmentOrientation || 0;
                    return u.fromRotation(l, Math.PI * n / 180);
                }
            } ];
            n && h.push(...n);
            const d = {
                vert: e.vert || "#include <gl2_vert>\n#define SHADER_NAME PBR\nattribute vec3 aPosition;\n#if defined(HAS_MAP) || defined(HAS_TERRAIN_FLAT_MASK)\nattribute vec2 aTexCoord;\n#include <common_pack_float>\n#endif\n#if defined(HAS_MAP)\nuniform vec2 uvOrigin;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nuniform float uvRotation;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\nvec3 c;\nvec3 d;\nvec4 e;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform mediump vec3 cameraPosition;\nuniform mat3 modelNormalMatrix;\n#ifdef HAS_SSR\nuniform mat3 modelViewNormalMatrix;\nvarying vec3 vViewNormal;\n#ifdef HAS_TANGENT\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelNormal;\nvarying vec4 vViewVertex;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\nvarying vec3 vModelVertex;\n#if defined(HAS_MAP)\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#endif\n#ifdef HAS_OPACITY\nattribute float aOpacity;\n#endif\nvarying float vOpacity;\n#include <highlight_vert>\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\nvarying vec3 vColor0;\n#else\nattribute vec4 aColor0;\nvarying vec4 vColor0;\n#endif\n#endif\n#include <line_extrusion_vert>\n#include <get_output>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#include <heatmap_render_vert>\n#include <vertex_color_vert>\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#if __VERSION__ == 100\nmat3 f(in mat3 h) {\n  vec3 i = h[0];\n  vec3 j = h[1];\n  vec3 k = h[2];\n  return mat3(vec3(i.x, j.x, k.x), vec3(i.y, j.y, k.y), vec3(i.z, j.z, k.z));\n}\n#else\nmat3 f(in mat3 h) {\n  return transpose(h);\n}\n#endif\n#endif\nvoid l(const highp vec4 q, out highp vec3 m) {\n  m = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid l(const highp vec4 q, out highp vec3 m, out highp vec3 t) {\n  l(q, m);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\nconst float o = .5;\nvec2 u(vec2 v, float A) {\n  return vec2(cos(A) * (v.x - o) + sin(A) * (v.y - o) + o, cos(A) * (v.y - o) - sin(A) * (v.x - o) + o);\n}\n#if defined(HAS_MAP)\nvec2 B(vec2 v) {\n  vec2 C = decode_getTexcoord(v);\n#ifdef HAS_RANDOM_TEX\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale + uvOffset;\n  return mod(D, 1.) + E;\n#else\nvec2 D = uvOrigin;\n  vec2 E = C * uvScale;\n  if(uvRotation != .0) {\n    D = u(D, uvRotation);\n    E = u(E, uvRotation);\n  }\n  return mod(D, 1.) + E + uvOffset;\n#endif\n}\n#endif\n#ifdef PICKING_MODE\n#include <fbo_picking_vert>\n#endif\n#include <excavate_vert>\nvoid main() {\n  mat4 F = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec3 G = getLineExtrudePosition(aPosition);\n  vec4 H = getPosition(G);\n#else\nvec4 H = getPosition(aPosition);\n#endif\nvModelVertex = (modelMatrix * H).xyz;\n  vec4 I = F * H;\n  vec4 J = modelViewMatrix * I;\n  vViewVertex = J;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(I, modelMatrix);\n#else\ngl_Position = projMatrix * J;\n#endif\n#ifdef PICKING_MODE\nfloat K = 1.;\n#if defined(HAS_COLOR)\nK *= aColor.a;\n#endif\n#if defined(HAS_COLOR0) && COLOR0_SIZE == 4\nK *= aColor0.a;\n#endif\nfbo_picking_setData(gl_Position.w, K != .0);\n#else\n#if defined(HAS_MAP)\nvTexCoord = B(aTexCoord);\n#ifdef HAS_AO_MAP\nvTexCoord1 = B(aTexCoord1);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\n#endif\n#if defined(HAS_TANGENT) || defined(HAS_NORMAL)\nmat3 L = mat3(F);\n  mat3 M = modelNormalMatrix * L;\n#if defined(HAS_TANGENT)\nvec3 t;\n  l(aTangent, d, t);\n  vModelTangent = vec4(M * t, aTangent.w);\n#else\nd = decode_getNormal(aNormal);\n#endif\nvec3 N = d;\n  vModelNormal = M * N;\n#else\nd = vec3(.0);\n  vModelNormal = vec3(.0);\n#endif\n#if defined(HAS_TANGENT)\nvModelBiTangent = cross(vModelNormal, vModelTangent.xyz) * sign(aTangent.w);\n#endif\n#ifdef HAS_SSR\nmat3 O = modelViewNormalMatrix * L;\n  vViewNormal = O * d;\n#if defined(HAS_TANGENT)\nvec4 P = vec4(t, aTangent.w);\n  vViewTangent = vec4(O * P.xyz, P.w);\n#endif\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#endif\n#ifdef HAS_OPACITY\nvOpacity = aOpacity / 255.;\n#else\nvOpacity = 1.;\n#endif\nhighlight_setVarying();\n#if defined(HAS_COLOR0)\nvColor0 = aColor0 / 255.;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(I);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * F, H);\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nmat3 Q = f(mat3(vModelTangent.xyz, vModelBiTangent, vModelNormal));\n  vTangentViewPos = Q * cameraPosition;\n  vTangentFragPos = Q * vModelVertex;\n#endif\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nvCoordinateTexcoord = getCoordinateTexcoord(I);\n  vExcavateHeight = getWorldHeight(I);\n#endif\n#endif\n}",
                frag: e.frag || "#define PI 3.141593\n#define RECIPROCAL_PI 1.0\n#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\n#include <srgb_frag>\nuniform vec3 hsv;\nuniform float contrast;\nstruct MaterialUniforms {\n  vec2 roughnessMetalness;\n  vec3 albedo;\n  float alpha;\n  vec3 normal;\n  vec3 emit;\n  float ao;\n  vec3 specularColor;\n  float glossiness;\n  vec4 skinColor;\n} c;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\nuniform float glossinessFactor;\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\nuniform vec3 emissiveFactor;\nuniform vec4 baseColorFactor;\nuniform float baseColorIntensity;\nuniform float emitColorFactor;\nuniform float occlusionFactor;\nuniform float environmentExposure;\nuniform float roughnessFactor;\nuniform float metallicFactor;\nuniform float normalMapFactor;\nuniform float specularF0;\nuniform int emitMultiplicative;\nuniform int normalMapFlipY;\nuniform int outputSRGB;\nuniform mat3 environmentTransform;\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nuniform sampler2D metallicRoughnessTexture;\n#endif\n#if defined(HAS_EMISSIVE_MAP)\nuniform sampler2D emissiveTexture;\n#endif\n#if defined(HAS_AO_MAP)\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nuniform sampler2D normalTexture;\n#endif\n#if defined(HAS_SKIN_MAP)\nuniform sampler2D skinTexture;\n#endif\n#if defined(ALPHA_MODE) && ALPHA_MODE == 1\nuniform float alphaCutoff;\n#endif\n#ifdef HAS_RANDOM_TEX\nuniform highp vec2 uvOrigin;\nuniform sampler2D noiseTexture;\n#endif\nuniform sampler2D brdfLUT;\n#if defined(HAS_IBL_LIGHTING)\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\nuniform vec2 cameraNearFar;\nuniform vec3 light0_viewDirection;\nuniform vec4 light0_diffuse;\n#ifdef HAS_SSR\nvarying vec3 vViewNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vViewTangent;\n#endif\n#endif\nvarying vec3 vModelVertex;\nvarying vec4 vViewVertex;\n#if defined(HAS_MAP)\n#include <compute_texcoord_frag>\n#endif\nvarying vec3 vModelNormal;\n#if defined(HAS_TANGENT)\nvarying vec4 vModelTangent;\nvarying vec3 vModelBiTangent;\n#endif\n#if defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvarying vec3 vColor0;\n#else\nvarying vec4 vColor0;\n#endif\n#endif\n#if defined(HAS_COLOR)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\nvarying float vOpacity;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D linePatternFile;\nuniform vec2 atlasSize;\nuniform float flipY;\nuniform float currentTime;\nuniform float animSpeedScale;\n#ifdef HAS_PATTERN_ANIM\nvarying float vLinePatternAnimSpeed;\n#else\nuniform float linePatternAnimSpeed;\n#endif\n#ifdef HAS_PATTERN_GAP\nvarying float vLinePatternGap;\n#else\nuniform float linePatternGap;\n#endif\nuniform vec4 linePatternGapColor;\nuniform vec2 uvScale;\nvarying float vPatternHeight;\nvarying float vLinesofar;\nvarying vec4 vTexInfo;\nvarying float vNormalY;\nvec2 d(vec2 e) {\n  vec2 f = mod(e, 1.);\n  vec2 h = vTexInfo.xy;\n  vec2 i = vTexInfo.zw;\n  return (h + f * i) / atlasSize;\n}\n#endif\n#include <heatmap_render_frag>\n#include <snow_frag>\n#include <mask_frag>\n#include <terrain_normal_frag>\n#include <vertex_color_frag>\n#include <excavate_frag>\n#ifdef HAS_RANDOM_TEX\nconst float j = .5;\nvec2 k(vec2 f, float l) {\n  return vec2(cos(l) * (f.x - j) + sin(l) * (f.y - j) + j, cos(l) * (f.y - j) - sin(l) * (f.x - j) + j);\n}\nfloat m(vec3 n) {\n  return n.x + n.y + n.z;\n}\n#endif\nvec4 o(sampler2D u, in vec2 f) {\n  \n#ifdef HAS_RANDOM_TEX\nhighp vec2 A = uvOrigin;\n  highp vec2 B = f + A - mod(A, 1.);\n  float C = texture2D(noiseTexture, .005 * B).x;\n  vec2 D = dFdx(B);\n  vec2 E = dFdx(B);\n  float F = C * 8.;\n  float G = fract(F);\n#if 1\nfloat H = floor(F);\n  float I = H + 1.;\n#else\nfloat H = floor(F + .5);\n  float I = floor(F);\n  G = min(G, 1. - G) * 2.;\n#endif\nvec2 J = sin(vec2(3., 7.) * H);\n  vec2 K = sin(vec2(3., 7.) * I);\n  float L = .5;\n  vec4 M = texture2DGradEXT(u, f + L * J, D, E);\n  vec4 N = texture2DGradEXT(u, f + L * K, D, E);\n  return mix(M, N, smoothstep(.2, .8, G - .1 * m(M.xyz - N.xyz)));\n#else\nreturn texture2D(u, f);\n#endif\n}\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nuniform sampler2D bumpTexture;\nuniform float bumpScale;\nuniform float bumpMaxLayers;\nuniform float bumpMinLayers;\nvec2 O(vec2 f, vec3 P) {\n  float Q = mix(bumpMaxLayers, bumpMinLayers, abs(dot(vec3(.0, .0, 1.), P)));\n  float R = 1. / Q;\n  float S = .0;\n  vec2 T = P.xy * bumpScale / (P.z * Q);\n  vec2 U = f;\n  float V = o(bumpTexture, U).r;\n  for(int W = 0; W < 30; W++) {\n    S += R;\n    U -= T;\n    V = o(bumpTexture, U).r;\n    if(V < S) {\n      break;\n    }\n  }\n  vec2 X = U + T;\n  float Y = V - S;\n  float Z = o(bumpTexture, X).r - S + R;\n  return mix(U, X, Y / (Y - Z));\n}\nvarying vec3 vTangentViewPos;\nvarying vec3 vTangentFragPos;\n#endif\n#define SHADER_NAME PBR\nvec3 ba() {\n  return c.albedo;\n}\nfloat bb() {\n  return c.alpha;\n}\nfloat bc() {\n  return c.roughnessMetalness.y;\n}\nfloat bd() {\n  \n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn 1. - c.glossiness;\n#else\nreturn c.roughnessMetalness.x;\n#endif\n}\nvec3 be() {\n  return c.emit;\n}\nvec4 bf() {\n  return c.skinColor;\n}\nvec3 bg() {\n  return c.normal;\n}\nfloat bh() {\n  return c.ao;\n}\nfloat bi(const in vec4 bj) {\n  return bj.r + bj.g / 255.;\n}\nvec3 bk(const in float bl, in vec3 bm, const in vec3 t, const in vec3 b, in vec3 bn) {\n  bm.xy = bl * bm.xy;\n  mat3 bo = mat3(t, b, bn);\n  return normalize(bo * bm);\n}\nfloat bp(const float bq, const vec3 bm, const vec3 br) {\n  float bs = clamp(dot(bm, br), 0., 1.);\n  float a = bq * bq;\n  float bt = a * a;\n  float bu = (bs * bt - bs) * bs + 1.;\n  return bt / (PI * bu * bu);\n}\nvec3 bv(const vec3 bw, const float bx, const in vec3 by, const in vec3 br) {\n  float bz = clamp(dot(by, br), 0., 1.);\n  bz = pow(1. - bz, 5.);\n  return bx * bz + (1. - bz) * bw;\n}\nfloat bA(const in vec3 bm, const in vec3 bB, const in float bq, const float bC) {\n  float bD = clamp(dot(bm, bB), 0., 1.);\n  float a = bq * bq;\n  float bE = bD * (bC * (1. - a) + a);\n  float bF = bC * (bD * (1. - a) + a);\n  return .5 / (bF + bE);\n}\nvec3 bG(const float bq, const vec3 bm, const vec3 bB, const vec3 by, const vec3 bH, const float bC, const float bx) {\n  vec3 br = normalize(bB + by);\n  float bI = bp(bq, bm, br);\n  float bJ = bA(bm, bB, bq, bC);\n  vec3 bK = bv(bH, bx, by, br);\n  return (bI * bJ * PI) * bK;\n}\nvec3 bL(const in vec3 bM) {\n  return RECIPROCAL_PI * bM;\n}\nvoid bN(const in vec3 bm, const in vec3 bB, const in float bC, const in float bq, const in vec3 bO, const in vec3 bH, const in vec3 bP, const in vec3 by, const in float bx, out vec3 bQ, out vec3 bR) {\n  if(bC <= .0) {\n    bR = bQ = vec3(.0);\n    return;\n  }\n  vec3 a = bC * bP;\n  vec3 bS = bG(bq, bm, bB, by, bH, bC, bx);\n  bR = a * bS;\n  bQ = a * bL(bO);\n}\n#if defined(HAS_IBL_LIGHTING)\nvec3 bT(const in vec3 bm) {\n  vec3 bn = environmentTransform * bm;\n  float x = bn.x;\n  float y = bn.y;\n  float z = bn.z;\n  vec3 bU = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bU = hsv_apply(bU, hdrHSV);\n  }\n  return max(bU, vec3(.0));\n}\nvec3 bV(const in float bq, const in vec3 bW) {\n  vec3 bX = bW;\n  float bY = prefilterMiplevel.x;\n  float bZ = min(bY, bq * prefilterMiplevel.y);\n  vec3 ca = textureCubeLod(prefilterMap, bX, bZ).rgb;\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(ca, hdrHSV);\n  } else {\n    return ca;\n  }\n}\nvec3 cb(const in vec3 cc, const in vec3 bB, const in float bq, const in vec3 cd, const in vec3 bO) {\n  float ce = 1. - bq;\n  vec3 bW = mix(cc, reflect(-bB, cc), ce * (sqrt(ce) + bq));\n  float bl = clamp(1. + dot(bW, cd), .0, 1.);\n  vec3 cf = bV(bq, environmentTransform * bW) * bl * bl;\n  return cf;\n}\n#else\nvec3 cb(const in vec3 bm, const in vec3 cg, const in float bq, const in vec3 cd, const in vec3 bO) {\n  return ambientColor * bL(bO);\n}\n#endif\nvec3 ch(const in vec3 ci, const in float bq, const in float bD, const in float bx) {\n  vec4 rgba = texture2D(brdfLUT, vec2(bD, bq)) * vec4(255., 65280.0, 255., 65280.0);\n  float b = (rgba[3] + rgba[2]);\n  float a = (rgba[1] + rgba[0]);\n  return (ci * a + b * bx) / 65535.;\n}\nvec3 cj(const in vec3 bm, const in vec3 cg, const in float bD, const in float bq, const in vec3 bH, const in vec3 cd, const in float bx, const in vec3 bO) {\n  return cb(bm, cg, bq, cd, bO) * ch(bH, bq, bD, bx);\n}\nfloat ck(const in float cl, const in float bD) {\n  float bu = bD + cl;\n  return clamp(bu * bu - 1. + cl, .0, 1.);\n}\nvoid cm() {\n  \n#ifdef HAS_MAP\nvec2 f = computeTexCoord(vTexCoord);\n#endif\n#ifdef HAS_UV_FLIP\nf.y = 1. - f.y;\n#endif\n#if defined(HAS_BUMP_MAP) && defined(HAS_TANGENT)\nf = O(f, normalize(vTangentViewPos - vTangentFragPos));\n#endif\nc.albedo = baseColorIntensity * baseColorFactor.rgb;\n  c.alpha = baseColorFactor.a * vOpacity;\n#if defined(HAS_PATTERN)\nfloat cn = vLinesofar;\n  vec2 i = vTexInfo.zw;\n#ifdef HAS_PATTERN_GAP\nfloat co = vLinePatternGap;\n#else\nfloat co = linePatternGap;\n#endif\n#ifdef HAS_PATTERN_ANIM\nfloat cp = vLinePatternAnimSpeed;\n#else\nfloat cp = linePatternAnimSpeed;\n#endif\nfloat cq = ceil(i.x * vPatternHeight / i.y);\n  float cr = cq * (1. + co);\n  cp /= animSpeedScale;\n  cn += mod(currentTime * -cp * .2, cr);\n  float cs = mod(cn / cr, 1.);\n  float ct = mod(flipY * vNormalY, 1.);\n  vec2 f = d(vec2(cs * (1. + co) * uvScale[0], ct * uvScale[1]));\n  vec4 cu = texture2D(linePatternFile, f);\n  float cv = clamp(sign(1. / (1. + co) - cs) + .000001, .0, 1.);\n  cu = mix(linePatternGapColor, cu, cv);\n#ifdef IS_SQUARE_TUBE\nfloat n = clamp(sign(abs(vNormalY) - .999999), .0, 1.);\n  cu = mix(cu, vec4(1.), n);\n#endif\nc.albedo *= cu.rgb;\n  c.alpha *= cu.a;\n#endif\n#if defined(HAS_ALBEDO_MAP)\nvec4 cw = o(baseColorTexture, f);\n  c.albedo *= sRGBToLinear(cw.rgb);\n  c.alpha *= cw.a;\n#endif\n#if defined(HAS_SKIN_MAP)\nvec4 cx = o(skinTexture, f);\n  c.skinColor = cx;\n#endif\n#if defined(HAS_COLOR0)\nc.albedo *= vColor0.rgb;\n#if COLOR0_SIZE == 4\nc.alpha *= vColor0.a;\n#endif\n#endif\n#if defined(HAS_COLOR)\nc.albedo *= vColor.rgb;\n  c.alpha *= vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nc.albedo *= lineColor.rgb;\n  c.alpha *= lineColor.a;\n#else\nc.albedo *= polygonFill.rgb;\n  c.alpha *= polygonFill.a;\n#endif\n#if defined(HAS_INSTANCE_COLOR)\nc.albedo *= vInstanceColor.rgb;\n  c.alpha *= vInstanceColor.a;\n#endif\n#if defined(HAS_METALLICROUGHNESS_MAP)\nc.roughnessMetalness = o(metallicRoughnessTexture, f).gb * vec2(roughnessFactor, metallicFactor);\n#else\nc.roughnessMetalness = vec2(roughnessFactor, metallicFactor);\n#endif\nc.emit = emissiveFactor;\n#if defined(HAS_EMISSIVE_MAP)\nif(emitMultiplicative == 1) {\n    c.emit *= sRGBToLinear(o(emissiveTexture, f).rgb);\n  } else {\n    c.emit += sRGBToLinear(o(emissiveTexture, f).rgb);\n  }\n#endif\nc.emit *= emitColorFactor;\n#if defined(HAS_AO_MAP)\nvec2 cy = computeTexCoord(vTexCoord1);\n  c.ao = o(occlusionTexture, cy).r;\n#else\nc.ao = 1.;\n#endif\nc.ao *= occlusionFactor;\n#if defined(HAS_NORMAL_MAP) && defined(HAS_TANGENT)\nvec3 cz = o(normalTexture, f).xyz * 2. - 1.;\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#else\nc.normal = normalize(vModelNormal);\n#endif\n#if defined(HAS_TERRAIN_NORMAL) && defined(HAS_TANGENT)\nvec3 cz = convertTerrainHeightToNormalMap(f);\n  cz.y = normalMapFlipY == 1 ? -cz.y : cz.y;\n  c.normal = cz;\n#endif\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nc.albedo *= diffuseFactor.rgb;\n  c.alpha *= diffuseFactor.a;\n#if defined(HAS_DIFFUSE_MAP)\nvec4 cA = o(diffuseTexture, f);\n  c.albedo *= sRGBToLinear(cA.rgb);\n  c.alpha *= cA.a;\n#endif\nc.specularColor = specularFactor;\n  c.glossiness = glossinessFactor;\n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nvec4 cB = o(specularGlossinessTexture, f);\n  c.specularColor *= sRGBToLinear(cB.rgb);\n  c.glossiness *= cB.a;\n#endif\n#endif\n}\nvec3 cC(const vec3 x) {\n  const float a = 2.51;\n  const float b = .03;\n  const float cD = 2.43;\n  const float bu = .59;\n  const float cE = .14;\n  return (x * (a * x + b)) / (x * (cD * x + bu) + cE);\n}\nvec3 cF(vec3 cG) {\n  cG = cC(cG);\n  return cG = pow(cG, vec3(1. / 2.2));\n}\nuniform float specularAAVariance;\nuniform float specularAAThreshold;\nfloat cH(float bq, const vec3 cI) {\n  \n#if defined(GL_OES_standard_derivatives) || __VERSION__ == 300\nvec3 cJ = dFdx(cI);\n  vec3 cK = dFdy(cI);\n  float cL = specularAAVariance * (dot(cJ, cJ) + dot(cK, cK));\n  float cM = min(2. * cL, specularAAThreshold);\n  float cN = saturate(bq * bq + cM);\n  return sqrt(cN);\n#else\nreturn bq;\n#endif\n}\n#ifdef HAS_SSR\nuniform sampler2D TextureDepth;\nuniform highp vec2 outSize;\nuniform float ssrFactor;\nuniform float ssrQuality;\nuniform sampler2D TextureReflected;\nuniform highp mat4 projMatrix;\nuniform mat4 invProjMatrix;\nuniform vec4 outputFovInfo[2];\nuniform mat4 reprojViewProjMatrix;\nvec3 cO(const in mat4 cP, const in vec3 cQ) {\n  vec4 cR = cP * vec4(cQ, 1.);\n  return vec3(.5 + .5 * cR.xy / cR.w, cR.w);\n}\nvec3 cS(const in float cT, const in vec2 f) {\n  return texture2D(TextureReflected, f).rgb;\n}\nfloat cU(float cV) {\n  highp mat4 cP = projMatrix;\n  highp float z = cV * 2. - 1.;\n  return -cP[3].z / (z + cP[2].z);\n}\nfloat cW(const vec2 f) {\n  float cV = bi(texture2D(TextureDepth, f));\n  return cV;\n}\nfloat cX(const in vec2 cY, const in float cZ) {\n  vec3 da = vec3(.06711056, .00583715, 52.9829189);\n  return fract(da.z * fract(dot(cY.xy + cZ * vec2(47., 17.) * .695, da.xy))) * .5;\n}\nvec3 db(const in float cZ, const in vec3 dc, const in vec3 dd, const in vec3 de, const in vec3 cg, const in float df) {\n  vec2 dg;\n  dg.x = cX(gl_FragCoord.yx, cZ);\n  dg.y = fract(dg.x * 52.9829189);\n  dg.y = mix(dg.y, 1., .7);\n  float dh = 2. * 3.14159 * dg.x;\n  float di = pow(max(dg.y, .000001), df / (2. - df));\n  float dj = sqrt(1. - di * di);\n  vec3 dk = vec3(dj * cos(dh), dj * sin(dh), di);\n  dk = dk.x * dc + dk.y * dd + dk.z * de;\n  return normalize((2. * dot(cg, dk)) * dk - cg);\n}\nfloat dl(const in float cZ) {\n  return (cX(gl_FragCoord.xy, cZ) - .5);\n}\nvec3 dm(const in vec3 dn, const in float dp, const in vec3 dq) {\n  vec3 dr = cO(projMatrix, vViewVertex.xyz + dq * dp);\n  dr.z = 1. / dr.z;\n  dr -= dn;\n  float ds = min(1., .99 * (1. - dn.x) / max(1e-5, dr.x));\n  float dt = min(1., .99 * (1. - dn.y) / max(1e-5, dr.y));\n  float dw = min(1., .99 * dn.x / max(1e-5, -dr.x));\n  float dx = min(1., .99 * dn.y / max(1e-5, -dr.y));\n  return dr * min(ds, dt) * min(dw, dx);\n}\nfloat dy(const in vec3 dn, const in vec3 dr, inout float dz, inout float dA) {\n  float dB = (dA + dz) * .5;\n  vec3 dC = dn + dr * dB;\n  float z = cW(dC.xy);\n  float cV = cU(z);\n  float dD = -1. / dC.z;\n  dz = cV > dD ? dz : dB;\n  dA = cV > dD ? dB : dA;\n  return dB;\n}\nvec4 dE(const in vec3 dn, const in float dp, in float dF, const in vec3 dq, const in float bq, const in float cZ) {\n  int dG = 20;\n  float dH = 1. / float(dG);\n  dF *= dH;\n  vec3 dr = dm(dn, dp, dq);\n  float dI = dH;\n  vec3 dJ = vec3(.0, dI, 1.);\n  vec3 dC;\n  float z, cV, dD, dK, dL, dM;\n  bool dN;\n  float dO = 1.;\n  float dB;\n  for(int W = 0; W < dG; W++) {\n    dC = dn + dr * dJ.y;\n    z = cW(dC.xy);\n    cV = cU(z);\n    dD = -1. / dC.z;\n    float dP = clamp(sign(.999 - z), .0, 1.);\n    dK = dP * (dD - cV);\n    dK *= clamp(sign(abs(dK) - dp * dH * dH), .0, 1.);\n    dN = abs(dK + dF) < dF;\n    dL = clamp(dJ.x / (dJ.x - dK), .0, 1.);\n    dM = dN ? dJ.y + dL * dH - dH : 1.;\n    dJ.z = min(dJ.z, dM);\n    dJ.x = dK;\n    if(dN) {\n      float dz = dJ.y - dH;\n      float dA = dJ.y;\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dB = dy(dn, dr, dz, dA);\n      dO = dB;\n      break;\n    }\n    dJ.y += dH;\n  }\n  return vec4(dn + dr * dO, 1. - dO);\n}\nvec4 dQ(in vec4 dR, const in float dS, const in vec3 dT, const in vec3 dU, const in float bq) {\n  vec4 dV = mix(outputFovInfo[0], outputFovInfo[1], dR.x);\n  dR.xyz = vec3(mix(dV.xy, dV.zw, dR.y), 1.) * -1. / dR.z;\n  dR.xyz = (reprojViewProjMatrix * vec4(dR.xyz, 1.)).xyw;\n  dR.xy /= dR.z;\n  float dW = clamp(6. - 6. * max(abs(dR.x), abs(dR.y)), .0, 1.);\n  dR.xy = .5 + .5 * dR.xy;\n  vec3 dX = dU * cS(bq * (1. - dR.w), dR.xy);\n  return vec4(mix(dT, dX, dS * dW), 1.);\n}\nvec3 ssr(const in vec3 dT, const in vec3 dU, const in float bq, const in vec3 bm, const in vec3 cg) {\n  float dY = .0;\n  vec4 bU = vec4(.0);\n  float df = bq * bq;\n  df = df * df;\n  vec3 dZ = abs(bm.z) < .999 ? vec3(.0, .0, 1.) : vec3(1., .0, .0);\n  vec3 dc = normalize(cross(dZ, bm));\n  vec3 dd = cross(bm, dc);\n  float dS = ssrFactor * clamp(-4. * dot(cg, bm) + 3.8, .0, 1.);\n  dS *= clamp(4.7 - bq * 5., .0, 1.);\n  vec3 dn = cO(projMatrix, vViewVertex.xyz);\n  dn.z = 1. / dn.z;\n  vec3 dq = db(dY, dc, dd, bm, cg, df);\n  float dp = mix(cameraNearFar.y + vViewVertex.z, -vViewVertex.z - cameraNearFar.x, dq.z * .5 + .5);\n  float dF = .5 * dp;\n  vec4 dR;\n  if(dot(dq, bm) > .001 && dS > .0) {\n    dR = dE(dn, dp, dF, dq, bq, dY);\n    if(dR.w > .0)\n      bU += dQ(dR, dS, dT, dU, bq);\n    \n  }\n  return bU.w > .0 ? bU.rgb / bU.w : dT;\n}\n#endif\n#include <highlight_frag>\nvec4 ea(in vec4 eb) {\n  return vec4(mix(pow(eb.rgb, vec3(.41666)) * 1.055 - vec3(.055), eb.rgb * 12.92, vec3(lessThanEqual(eb.rgb, vec3(.0031308)))), eb.a);\n}\nvec4 ec(vec4 eb) {\n  return (ea(eb));\n}\nvoid main() {\n  cm();\n  vec3 cg = normalize(cameraPosition - vModelVertex.xyz);\n#if defined(HAS_DOUBLE_SIDE)\nvec3 cd = gl_FrontFacing ? normalize(vModelNormal) : -normalize(vModelNormal);\n#else\nvec3 cd = normalize(vModelNormal);\n#endif\n#if defined(HAS_TANGENT)\nvec4 ed;\n  ed = vModelTangent;\n#if defined(HAS_DOUBLE_SIDE)\ned.xyz = gl_FrontFacing ? normalize(ed.xyz) : -normalize(ed.xyz);\n#else\ned.xyz = normalize(ed.xyz);\n#endif\nvec3 ee = normalize(vModelBiTangent);\n#endif\nfloat bw = .08 * specularF0;\n  float ef = bc();\n  vec3 bO = ba();\n#if defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nvec3 eg = c.specularColor;\n#else\nvec3 eg = mix(vec3(bw), bO, ef);\n#endif\nbO *= 1. - ef;\n  float eh = clamp(50.0 * eg.g, .0, 1.);\n  float ei = bd();\n  if(specularAAVariance > .0) {\n    ei = cH(ei, cd);\n  }\n  vec3 ej = be();\n  vec3 ek = bg();\n  vec3 el = vec3(ek);\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nel = bk(normalMapFactor, el, ed.xyz, ee, cd);\n#endif\nvec3 cA = vec3(.0);\n  vec3 bH = vec3(.0);\n#if defined(HAS_IBL_LIGHTING)\ncA = bO * bT(el) * .5;\n#else\ncA = bO * ambientColor;\n#endif\nfloat bD = dot(el, cg);\n  bH = cj(el, cg, bD, ei, eg, cd, eh, bO);\n  float em;\n  float en = 1.;\n  float eo = bh();\n  cA *= environmentExposure * eo;\n#ifdef HAS_IBL_LIGHTING\nen = ck(eo, bD);\n#endif\n#ifdef HAS_SSR\nvec3 ep = normalize(gl_FrontFacing ? vViewNormal : -vViewNormal);\n  vec3 eq = ep;\n#if defined(HAS_TANGENT) && (defined(HAS_NORMAL_MAP) || defined(HAS_TERRAIN_NORMAL))\nvec4 er;\n  er = vViewTangent;\n  er = gl_FrontFacing ? er : -er;\n  er.xyz = normalize(er.xyz);\n  vec3 es = normalize(cross(ep, er.xyz)) * er.w;\n  eq = bk(normalMapFactor, ek, er.xyz, es, ep);\n#endif\nbH = ssr(bH, eg * en, ei, eq, -normalize(vViewVertex.xyz));\n#endif\nbH *= environmentExposure * en;\n  vec3 et, eu;\n  vec3 ev = vModelNormal;\n  vec3 ew = -light0_viewDirection;\n  float ex = saturate(dot(ew, el));\n  bN(el, cg, ex, max(.045, ei), bO, eg, light0_diffuse.rgb, ew, eh, eu, et);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ey = shadow_computeShadow();\n  eu = shadow_blend(eu, ey).rgb;\n  et = shadow_blend(et, ey).rgb;\n#endif\ncA += eu;\n  bH += et;\n  cA += ej;\n  vec3 ez = bH + cA;\n  if(outputSRGB == 1)\n    ez = linearTosRGB(ez);\n  \n#ifdef HAS_SKIN_MAP\nvec4 eA = bf();\n  ez.rgb = ez.rgb * (1. - eA.a) + eA.rgb * eA.a;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nez.rgb = shadow_blend(ez.rgb, ey).rgb;\n#endif\n#endif\nfloat eB = bb();\n  if(eB < alphaTest) {\n    discard;\n  }\n#if defined(ALPHA_MODE)\n#if ALPHA_MODE == 1\nif(eB < alphaCutoff) {\n    discard;\n  } else {\n    eB = 1.;\n  }\n#else\neB = 1.;\n#endif\n#endif\n#if defined(IS_LINE_EXTRUSION)\neB *= lineOpacity;\n#else\neB *= polygonOpacity;\n#endif\nglFragColor = vec4(ez * eB, eB);\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_EXCAVATE_ANALYSIS\nglFragColor = excavateColor(glFragColor);\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_SNOW\nglFragColor.rgb = snow(glFragColor, bg(), 1.);\n#endif\nif(contrast != 1.) {\n    glFragColor = contrastMatrix(contrast) * glFragColor;\n  }\n  if(length(hsv) > .0) {\n    glFragColor = hsv_apply(glFragColor, hsv);\n  }\n#ifdef OUTPUT_NORMAL\nglFragColor = vec4(cd, 1.);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                wgslVert: e.wgslVert || "",
                wgslFrag: e.wgslFrag || "",
                uniforms: h,
                extraCommandProps: t,
                defines: r
            };
            d.name = e.name || "standard", super(d), this.version = 300;
        }
        getGeometryDefines(e) {
            const t = {};
            return e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), 
            e.data[e.desc.colorAttribute] && (t.HAS_COLOR = 1), e.data[e.desc.color0Attribute] && (t.HAS_COLOR0 = 1, 
            t.COLOR0_SIZE = e.getColor0Size()), t;
        }
    },
    StandardDepthShader: class extends Yi {
        constructor(e = {}) {
            const t = [];
            super({
                vert: "#define SHADER_NAME depth_vert\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projMatrix;\nuniform vec2 outSize;\nuniform vec2 halton;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n#ifdef IS_LINE_EXTRUSION\nvec4 d = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 d = getPosition(aPosition);\n#endif\nvec4 e = modelViewMatrix * c * d;\n  mat4 f = projMatrix;\n  f[2].xy += halton.xy / outSize.xy;\n  gl_Position = f * e;\n}",
                frag: "#define SHADER_NAME depth_frag\nprecision highp float;\nvoid main() {\n  gl_FragColor = vec4(1., .0, .0, 1.);\n}",
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (e, n) => c.multiply(t, n.viewMatrix, n.modelMatrix)
                } ],
                extraCommandProps: e.extraCommandProps,
                defines: e.defines
            });
        }
    },
    PBRUtils: Wo
}, Sa = ce;

Sa.flatten = Fe;

var Ma = Object.freeze({
    __proto__: null,
    AbstractTexture: se,
    BloomPass: ds,
    BoundingBox: le,
    BoxBlurShader: class extends es {
        constructor({blurOffset: e}) {
            super({
                vert: $i,
                frag: "precision highp float;\nvarying vec2 vTexCoord;\nuniform sampler2D textureSource;\nuniform vec2 resolution;\nuniform float ignoreTransparent;\nvoid main() {\n  vec4 c = vec4(.0);\n  float d = .0;\n  for(int x = -BOXBLUR_OFFSET; x <= BOXBLUR_OFFSET; ++x)\n    for(int y = -BOXBLUR_OFFSET; y <= BOXBLUR_OFFSET; ++y) {\n      vec2 e = vTexCoord.st + vec2(float(x) / resolution.x, float(y) / resolution.y);\n      e = clamp(e, .0, 1.);\n      vec4 f = texture2D(textureSource, e);\n      float h;\n      if(ignoreTransparent == 1.) {\n        h = sign(f.a);\n      } else {\n        h = 1.;\n      }\n      d += h;\n      c += h * f;\n    }\n  gl_FragColor = c / max(d, 1.) * clamp(sign(d - 1.), .0, 1.);\n}",
                defines: {
                    "BOXBLUR_OFFSET": e || 2
                },
                extraCommandProps: {
                    viewport: {
                        x: 0,
                        y: 0,
                        width: (e, t) => t.resolution[0],
                        height: (e, t) => t.resolution[1]
                    }
                }
            }), this._blurOffset = e || 2;
        }
        getMeshCommand(e, t) {
            const n = "box_blur_" + this._blurOffset;
            return this.commands[n] || (this.commands[n] = this.createMeshCommand(e, t)), this.commands[n];
        }
    },
    Constants: ne,
    CopyShader: xs,
    EdgeGeometry: Pt,
    EdgeShader: class extends Yi {
        constructor(e = {}) {
            const t = [], n = e.uniforms, r = [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, n) {
                    return c.multiply(t, n.viewMatrix, n.modelMatrix);
                }
            } ];
            n && r.push(...n), super({
                vert: "attribute vec3 aPosition;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 modelViewMatrix;\n#include <get_output>\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_Position = projMatrix * modelViewMatrix * d * c;\n}",
                frag: "precision mediump float;\nuniform vec4 lineColor;\nuniform float lineOpacity;\nvoid main() {\n  gl_FragColor = lineColor;\n  gl_FragColor.a *= lineOpacity;\n}",
                uniforms: r,
                defines: e.defines || {},
                extraCommandProps: e.extraCommandProps || {}
            });
        }
    },
    ExtentPass: Fs,
    FBORayPicking: class {
        constructor(e, {name: t, vert: n, wgslVert: r, uniforms: i, defines: s, extraCommandProps: o, enableStencil: a}, l, c) {
            this._renderer = e, this._fbo = l, this._map = c, this._clearFbo(l), this._name = t || "fboraypicking", 
            this._vert = n, this._wgslVert = r, this._uniforms = i, this._defines = s, this._extraCommandProps = E({}, o), 
            delete this._extraCommandProps.blend, a ? this._extraCommandProps.stencil = {
                enable: a,
                mask: 255,
                func: {
                    cmp: "<",
                    ref: 1,
                    mask: 255
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            } : delete this._extraCommandProps.stencil, this._currentMeshes = [], this._init();
        }
        _init() {
            const e = [];
            this._uniforms && e.push(...this._uniforms);
            const t = {
                "ENABLE_PICKING": 1,
                "HAS_PICKING_ID": 1
            };
            if (this._defines) for (const e in this._defines) t[e] = this._defines[e];
            const n = this._vert, r = this._wgslVert, i = this._extraCommandProps;
            this._shader0 = new Yi({
                name: this._name + "-0",
                vert: n,
                frag: oa,
                wgslVert: r,
                wgslFrag: aa,
                uniforms: e,
                defines: t,
                extraCommandProps: i
            }), this._shader2 = new Yi({
                name: this._name + "-2",
                vert: n,
                frag: ha,
                wgslVert: r,
                wgslFrag: da,
                uniforms: e,
                defines: t,
                extraCommandProps: i
            });
            const s = {
                "ENABLE_PICKING": 1,
                "HAS_PICKING_ID": 1
            };
            if (this._defines) for (const e in this._defines) s[e] = this._defines[e];
            this._shader1 = new Yi({
                name: this._name + "-1",
                vert: n,
                frag: la,
                wgslVert: r,
                wgslFrag: ca,
                uniforms: e,
                defines: s,
                extraCommandProps: i
            }), this._depthShader = new Yi({
                name: this._name + "-depth",
                vert: n,
                frag: "\n    #ifdef GL_ES\n        precision highp float;\n    #endif\n    #if __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n        #extension GL_EXT_frag_depth : enable\n    #endif\n    #include <gl2_frag>\n    #include <common_pack_float>\n    varying float vFbo_picking_viewZ;\n    uniform float logDepthBufFC;\n    varying float vFbo_picking_fragDepth;\n\n    const float PackUpscale = 256. / 255.;\n    const float UnpackDownscale = 255. / 256.;\n    const vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\n    const vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\n    const float ShiftRight8 = 1. / 256.;\n    vec4 packDepthToRGBA(const in float v ) {\n        vec4 r = vec4(fract(v * PackFactors), v);\n        r.yzw -= r.xyz * ShiftRight8;\n        return r * PackUpscale;\n    }\n\n    void main() {\n        float fragDepth = vFbo_picking_fragDepth > 1.0 ? vFbo_picking_fragDepth : vFbo_picking_viewZ + 1.0;\n        #if __VERSION__ == 300 || __VERSION__ == 100 && defined(GL_EXT_frag_depth)\n            gl_FragDepthEXT = log2(fragDepth) * logDepthBufFC * 0.5;\n        #endif\n        vec4 depthColor = packDepthToRGBA(fragDepth - 1.0);\n        glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));\n        #if __VERSION__ == 100\n            gl_FragColor = glFragColor;\n        #endif\n    }\n",
                wgslVert: r,
                wgslFrag: "\n    #include <common_pack_float>\n\n    struct DepthPackingUniforms {\n        logDepthBufFC: f32,\n    };\n\n    @group(0) @binding($b) var<uniform> depthPackingUniforms: DepthPackingUniforms;\n\n    const PackUpscale = 256.0 / 255.0;\n    const UnpackDownscale = 255.0 / 256.0;\n    const PackFactors = vec3f(256.0 * 256.0 * 256.0, 256.0 * 256.0, 256.0);\n    const UnpackFactors = UnpackDownscale / vec4f(PackFactors, 1.0);\n    const ShiftRight8 = 1.0 / 256.0;\n\n    fn packDepthToRGBA(v: f32) -> vec4f {\n        var r = vec4f(fract(v * PackFactors), v);\n        // r.yzw -= r.xyz * ShiftRight8;\n        r = vec4f(r.x, r.yzw - r.xyz * ShiftRight8);\n        return r * PackUpscale;\n    }\n\n    @fragment\n    fn main(vertexOutput: VertexOutput) -> @location(0) vec4f {\n        let fragDepth = select(\n            vertexOutput.vFbo_picking_viewZ + 1.0,\n            vertexOutput.vFbo_picking_fragDepth,\n            vertexOutput.vFbo_picking_fragDepth > 1.0\n        );\n\n        let depthColor = packDepthToRGBA(fragDepth - 1.0);\n        var glFragColor = common_unpackFloat(dot(depthColor, UnpackFactors));\n\n        return glFragColor;\n    }\n",
                uniforms: e,
                defines: s,
                extraCommandProps: i
            }), this._scene = new Pr, this._scene1 = new Pr;
        }
        filter() {
            return !0;
        }
        render(e, t, n = !1) {
            if (!e || !e.length) return this;
            const r = this._fbo;
            n && this.clear(), e = e.filter((e => e && e.isValid && e.isValid())), this._scene.setMeshes(e);
            const i = this._getShader(e, n);
            i.filter = this.filter, this._currentShader && i !== this._currentShader && this.clear(), 
            this._currentShader = i, e.forEach(((e, t) => {
                e.setUniform("fbo_picking_meshId", t + this._currentMeshes.length);
            }));
            for (let t = 0; t < e.length; t++) this._currentMeshes.push(e[t]);
            return this._renderer.render(i, t, this._scene, r), this;
        }
        pickAll(e, t, n, r, i) {
            n = fa(n);
            const {meshIds: s, pickingIds: o, coords: a, points: l} = this._pick(e, t, n, r, i), c = [];
            if (o && s) {
                const e = {};
                for (let t = 0; t < s.length; t++) {
                    const n = `${o[t]}_${s[t]}`;
                    null == s[t] || null == o[t] || e[n] || (e[n] = !0, c.push({
                        meshId: s[t],
                        pickingId: o[t],
                        point: l[t] || null,
                        coordinate: a[t] || null
                    }));
                }
            }
            return c;
        }
        pick(e, t, n, r, i = {}) {
            n = fa(n);
            const {meshIds: s, pickingIds: o, width: a, coords: l, points: c} = this._pick(e, t, n, r, i);
            if (o && s) {
                const e = [];
                for (let t = 0; t <= n[0]; t++) e.push(t), t > 0 && e.push(-t);
                for (let t = 0; t < e.length; t++) for (let r = 0; r < e.length; r++) {
                    const i = (e[r] + n[1]) * a + (e[t] + n[0]);
                    if (null != s[i]) return {
                        meshId: s[i],
                        pickingId: o[i],
                        point: c[i] || null,
                        coordinate: l[i] || null
                    };
                }
            }
            return {
                pickingId: null,
                meshId: null,
                point: null
            };
        }
        _pick(e, t, n, r, i = {}) {
            const s = this._currentShader, o = this._currentMeshes;
            if (!s || !o || !o.length) return {
                pickingId: null,
                meshId: null,
                point: null
            };
            e = Math.round(e), t = Math.round(t);
            const a = this._fbo;
            if (e <= 2 || e >= a.width - 2 || t <= 2 || t >= a.height - 2) return {
                pickingId: null,
                meshId: null,
                point: null
            };
            const {px: l, py: c, width: h, height: d} = this._getParams(e, t, n, a), u = new Uint8Array(4 * h * d), f = this._renderer.device.read({
                data: u,
                x: l,
                y: c,
                framebuffer: a,
                width: h,
                height: d
            }), m = [];
            let g = [];
            for (let e = 0; e < f.length; e += 4) {
                const {pickingId: t, meshId: n} = this._packData(f.subarray(e, e + 4), s);
                m.push(n), g.push(t);
            }
            const _ = {}, p = m.filter((e => null != e && !_[e] && (_[e] = 1, !0))).map((e => o[e]));
            let v;
            for (let e = 0; e < p.length; e++) if (p[e] && p[e].geometry) {
                v = p[e];
                break;
            }
            if (!v) return {
                pickingId: null,
                meshId: null,
                point: null
            };
            const x = v.geometry.desc.pickingIdAttribute;
            m.length && s === this._shader1 && (void 0 !== v.getUniform("uPickingId") || v.geometry.data[x]) && (g = this._getPickingId(l, c, h, d, u, p, r));
            const y = [], b = [];
            if (m.length && i.returnPoint) {
                const {viewMatrix: n, projMatrix: s} = i, o = this._pickDepth(l, c, h, d, u, p, r);
                for (let r = 0; r < o.length; r++) if (o[r] && null != m[r]) {
                    const i = this._getWorldPos(e, t, o[r], n, s), a = this._convertPickPoint(i);
                    y.push(i), b.push(a);
                } else y.push(null), b.push(null);
            }
            return {
                meshIds: m,
                pickingIds: g,
                coords: b,
                points: y,
                width: h,
                height: d
            };
        }
        _convertPickPoint(e) {
            const t = this._map;
            if (!t) return null;
            const n = t.getGLRes();
            if (!ta) {
                const e = t.getCenter();
                na = new e.constructor(0, 0, 0);
                const n = t.coordToPoint(e);
                ta = new n.constructor(0, 0);
            }
            ta.set(e[0], e[1]);
            const r = t.pointAtResToCoord(ta, n, na), i = t.pointAtResToAltitude(e[2], n);
            return [ r.x, r.y, i ];
        }
        clear() {
            return this._fbo && this._clearFbo(this._fbo), this._currentMeshes = [], delete this._currentShader, 
            this;
        }
        getMeshAt(e) {
            return this._currentMeshes ? this._currentMeshes[e] : null;
        }
        getRenderedMeshes() {
            return this._currentMeshes;
        }
        dispose() {
            this.clear(), this._shader0 && this._shader0.dispose(), this._shader1 && this._shader1.dispose(), 
            this._shader2 && this._shader2.dispose(), this._scene && this._scene.clear(), this._scene1 && this._scene1.clear();
        }
        _getWorldPos(e, t, n, r, i) {
            const s = this._fbo, o = [], a = s.width / 2 || 1, l = s.height / 2 || 1, h = [ (e - a) / a, (l - t) / l, 0, 1 ], d = [ (e - a) / a, (l - t) / l, 1, 1 ], u = c.invert(o, i), f = [], m = [];
            ua(f, h, u), ua(m, d, u);
            const g = -f[2], _ = (n - g) / (-m[2] - g), p = c.multiply(o, i, r), v = c.invert(o, p), x = ua(h, h, v), y = ua(d, d, v);
            return [ R(x[0], y[0], _), R(x[1], y[1], _), R(x[2], y[2], _) ];
        }
        _getPickingId(e, t, n, r, i, s, o) {
            const a = this._renderer.device, l = this._getFBO1();
            this._clearFbo(l), this._scene1.setMeshes(s), this._renderer.render(this._shader2, o, this._scene1, l);
            const c = a.read({
                data: i,
                x: e,
                y: t,
                framebuffer: l,
                width: n,
                height: r
            }), h = [];
            for (let e = 0; e < c.length; e += 4) h.push(Jo(c.subarray(e, e + 4)));
            return h;
        }
        _pickDepth(e, t, n, r, i, s, o) {
            const a = this._renderer.device, l = this._getFBO1();
            this._scene1.setMeshes(s), this._clearFbo(l), o.logDepthBufFC = 2 / (Math.log(this._map.cameraFar + 1) / Math.LN2), 
            this._renderer.render(this._depthShader, o, this._scene1, l);
            const c = a.read({
                data: i,
                x: e,
                y: t,
                framebuffer: l,
                width: n,
                height: r
            }), h = [];
            for (let e = 0; e < c.length; e += 4) h.push((d = c.subarray(e, e + 4), Qo[0] = d[3], 
            Qo[1] = d[2], Qo[2] = d[1], Qo[3] = d[0], ea[0]));
            var d;
            return h;
        }
        _packData(e, t) {
            if (0 === e[0] && 0 === e[1] && 0 === e[2] && 0 === e[3]) return {
                meshId: null,
                pickingId: null
            };
            let n = null, r = null;
            return t === this._shader1 ? r = Jo(e) - 1 : t === this._shader0 ? (r = e[3] - 1, 
            n = Jo(e) - 1) : (r = null, n = Jo(e) - 1), {
                meshId: r,
                pickingId: n
            };
        }
        _clearFbo(e) {
            this._renderer.device.clear({
                color: [ 0, 0, 0, 0 ],
                depth: 1,
                stencil: 255,
                framebuffer: e
            });
        }
        _getShader(e, t) {
            return t && e.length < 255 ? this._shader0 : this._shader1;
        }
        _getFBO1() {
            const e = this._renderer.device, t = this._fbo;
            return this._fbo1 ? this._fbo1.width === t.width && this._fbo1.height === t.height || this._fbo1.resize(t.width, t.height) : this._fbo1 = e.framebuffer(t.width, t.height), 
            this._fbo1;
        }
        _debugFBO(e) {
            const t = this._renderer.device.read({
                data: new Uint8Array(4 * e.width * e.height),
                x: 0,
                y: 0,
                framebuffer: e,
                width: e.width,
                height: e.height
            }), n = document.createElement("canvas");
            n.width = e.width, n.height = e.height, document.body.appendChild(n);
            for (let e = 0; e < t.length; e += 4) 255 !== t[e + 3] && (t[e + 3] = 255);
            n.getContext("2d").putImageData(new ImageData(new Uint8ClampedArray(t), e.width), 0, 0);
        }
        _getParams(e, t, n, r) {
            const i = n[0], s = n[1];
            e -= i, t = r.height - t;
            let o = 2 * i + 1, a = 2 * s + 1;
            const l = e + o, c = (t -= s) + a;
            return l > r.width && (o -= l - r.width), c > r.height && (a -= c - r.height), {
                px: e = e < 0 ? 0 : e,
                py: t = t < 0 ? 0 : t,
                width: o,
                height: a
            };
        }
        getPickingVert() {
            return this._vert;
        }
        getPickingWGSLVert() {
            return this._wgslVert;
        }
        getUniformDeclares() {
            return this._uniforms;
        }
    },
    FogPass: Ss,
    FogShader: Ms,
    FxaaShader: ts,
    GLTFHelper: oo,
    GLTFManager: class {
        constructor(e, t) {
            this.regl = e, this.resourceMap = {}, this.options = t || {};
        }
        getGLTF(e) {
            return this.resourceMap[e];
        }
        loginGLTF(e, t) {
            if (this.resourceMap[e]) this.resourceMap[e].refCount += 1; else {
                if (mo[e]) {
                    const t = function(e) {
                        let t = null;
                        return mo[e] && (t = {
                            meshes: mo[e].meshes
                        }, t.scenes = JSON.parse(JSON.stringify(mo[e].scenes))), t;
                    }(e);
                    this.resourceMap[e] = this._exportGLTFResource(t, e, !1);
                } else this.resourceMap[e] = t ? t(e).then((t => (this.resourceMap[e] = this._exportGLTFResource(t, e), 
                this.resourceMap[e]))) : this._loadGLTFModel(e);
                this.resourceMap[e].refCount = 1;
            }
        }
        logoutGLTF(e) {
            if (this.resourceMap[e] && (this.resourceMap[e].refCount -= 1, this.resourceMap[e].refCount < 1)) {
                const t = this.resourceMap[e].resources;
                if (t) for (let e = 0; e < t.length; e++) t[e].geometry.dispose(), t[e].copyGeometry && t[e].copyGeometry.dispose(), 
                t[e].material && t[e].material.dispose();
                this.resourceMap[e].gltfPack && this.resourceMap[e].gltfPack.dispose(), delete this.resourceMap[e];
            }
        }
        isSimpleModel(e) {
            return mo[e];
        }
        addSimpleModel(e, t) {
            !function(e, t) {
                "string" == typeof e && fo.indexOf(e) < 0 && (mo[e] = t);
            }(e, t);
        }
        removeSimpleModel(e) {
            delete mo[e];
        }
        _exportGLTFResource(e, t, n = !0) {
            if (!e) return null;
            const r = io(e, n ? this.regl : null), i = r.getMeshesInfo();
            return {
                bbox: r.getGLTFBBox(),
                gltfPack: r,
                resources: i,
                json: e.json,
                refCount: this.resourceMap[t] ? this.resourceMap[t].refCount : 0
            };
        }
        fetchGLTF(e) {
            return ro(e, this.options).then((e => e));
        }
        _loadGLTFModel(e) {
            return this.fetchGLTF(e).then((t => (this.resourceMap[e] = this._exportGLTFResource(t, e), 
            this.resourceMap[e])));
        }
    },
    Geometry: Ye,
    GraphicsDevice: ba,
    GraphicsFramebuffer: xi,
    GraphicsTexture: vi,
    HDR: wa,
    HeatmapDisplayShader: vs,
    HeatmapShader: ms,
    ImageShader: is,
    InstancedMesh: yr,
    Jitter: cs,
    KHRTechniquesWebglManager: class {
        constructor(e, t, n) {
            this._regl = e, this._khrShaders = {}, this._commandProps = t, this._resLoader = n;
        }
        getExcludeFilter() {
            return ma;
        }
        forEachShader(e) {
            for (const t in this._khrShaders) {
                const n = this._khrShaders[t];
                e(n.shader, n.filter, n.uniformSemantics);
            }
        }
        createMesh(e, t, n, r) {
            const i = t.extensions.KHR_techniques_webgl, s = t.materials[e.material].extensions.KHR_techniques_webgl, {technique: o, values: a} = s, l = i.techniques[o], c = i.programs[l.program], h = i.shaders[c.vertexShader], d = i.shaders[c.fragmentShader];
            d.content = function(e) {
                if (e && e.indexOf("precision") < 0) return "precision mediump float;\n" + e;
                return e;
            }(d.content);
            const u = q(h.content) + "-" + q(d.content);
            this._khrShaders[u] || (this._khrShaders[u] = this._createTechniqueShader(u, i, o, this._commandProps, r));
            const {attributeSemantics: f} = this._khrShaders[u], m = this._createGeometry(e, f, n, u), g = E({}, a);
            for (const e in a) if (l.uniforms[e] && 35678 === l.uniforms[e].type) {
                const n = a[e].index, r = t.textures[n];
                g[e] = this._getTexture(r);
            }
            return {
                geometry: m,
                material: new Ft(g)
            };
        }
        _createGeometry(e, t, n, r) {
            const i = e.attributes, s = "COLOR_0";
            if (i[s]) {
                const e = i[s].array || i[s];
                if (e instanceof Float32Array) {
                    const t = new Uint8Array(e.length);
                    for (let n = 0; n < t.length; n++) t[n] = Math.round(255 * e[n]);
                    i[s].array ? (i[s].array = t, i[s].componentType = 5121) : i[s] = t;
                }
            }
            const o = {};
            for (const e in i) {
                const n = bt(this._regl, i[e], {
                    dimension: i[e].itemSize,
                    name: e
                }), r = t[e] || e;
                o[r] = {
                    buffer: n
                }, i[e].quantization && (o[r].quantization = i[e].quantization), r === t.POSITION && (o[r].array = i[e].array);
            }
            const a = new Ye(o, e.indices.array ? e.indices.array : e.indices, 0, {
                positionAttribute: t.POSITION,
                normalAttribute: t.NORMAL,
                uv0Attribute: t.TEXCOORD_0,
                uv1Attribute: t.TEXCOORD_1,
                color0Attribute: t.COLOR_0,
                tangentAttribute: t.TANGENT,
                textureCoordMatrixAttribute: t.TextureCoordMatrix,
                primitive: void 0 === e.mode ? "triangles" : at(e.mode)
            });
            a.generateBuffers(this._regl, {
                excludeElementsInVAO: n
            }), a.properties.shaderHash = r;
            const l = a.data[a.desc.positionAttribute];
            return l && l.array && delete l.array, a;
        }
        _getTexture(e) {
            const t = {
                type: e.type ? ct(e.type) : "uint8",
                format: e.format ? ut(e.format) : "rgba",
                flipY: !!e.flipY
            }, n = e.image;
            n.array ? t.data = n.array : n.mipmap && (t.mipmap = n.mipmap), t.width = n.width, 
            t.height = n.height;
            const r = e.sampler || e.texture.sampler;
            return r && (r.magFilter && (t.mag = mt(r.magFilter)), r.minFilter && (t.min = _t(r.minFilter)), 
            r.wrapS && (t.wrapS = vt(r.wrapS)), r.wrapT && (t.wrapT = vt(r.wrapT))), new qr(t, this._resLoader);
        }
        _createTechniqueShader(e, t, n, r, i) {
            const {techniques: s, programs: o, shaders: a} = t, l = s[n], c = o[l.program], h = a[c.vertexShader].content, d = a[c.fragmentShader].content, u = {};
            for (const e in l.uniforms) {
                const t = l.uniforms[e];
                t.semantic && (u[t.semantic] = e);
            }
            const f = pa.slice();
            for (const e in u) {
                const t = u[e];
                f.push({
                    name: t,
                    type: "function",
                    fn: (t, n) => n[va[e]]
                });
            }
            const m = new Yi({
                vert: h,
                frag: d,
                uniforms: f,
                extraCommandProps: r
            });
            i && (m.version = 300);
            const g = {};
            for (const e in l.attributes) {
                g[l.attributes[e].semantic] = e;
            }
            return {
                shader: m,
                filter: t => t && t.geometry && t.geometry.properties.shaderHash === e,
                uniformSemantics: u,
                attributeSemantics: g
            };
        }
        dispose() {
            for (const e in this._khrShaders) {
                const {shader: t} = this._khrShaders[e];
                t.dispose();
            }
            this._khrShaders = {};
        }
    },
    Material: Ft,
    Mesh: xr,
    MeshShader: Yi,
    PhongMaterial: Nt,
    PhongShader: class extends Yi {
        constructor(e = {}) {
            const t = [], n = [], r = e.uniforms, i = [ {
                name: "modelNormalMatrix",
                type: "function",
                fn: function(e, n) {
                    return u.fromMat4(t, n.modelMatrix);
                }
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(n, t.viewMatrix, t.modelMatrix);
                }
            } ];
            r && i.push(...r), super({
                name: "phong",
                vert: e.vert || "#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#if defined(HAS_AO_MAP)\nattribute vec2 aTexCoord1;\nvarying vec2 vTexCoord1;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\nvarying vec4 vColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nvarying vec3 vFragPos;\nvarying vec3 vNormal;\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <highlight_vert>\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nattribute float aExtrusionOpacity;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_TANGENT)\nvarying vec4 vTangent;\n#endif\nvoid c(const highp vec4 q, out highp vec3 d) {\n  d = vec3(.0, .0, 1.) + vec3(2., -2., -2.) * q.x * q.zwx + vec3(2., 2., -2.) * q.y * q.wzy;\n}\nvoid c(const highp vec4 q, out highp vec3 d, out highp vec3 t) {\n  c(q, d);\n  t = vec3(1., .0, .0) + vec3(-2., 2., -2.) * q.y * q.yxw + vec3(-2., 2., 2.) * q.z * q.zwx;\n}\n#include <vertex_color_vert>\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 e = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 e = getPosition(aPosition);\n#endif\nmat4 f = getPositionMatrix();\n  vFragPos = vec3(modelMatrix * f * e);\n#if defined(HAS_NORMAL) || defined(HAS_TANGENT)\nmat3 h = modelNormalMatrix * mat3(f);\n  vec3 i;\n#if defined(HAS_TANGENT)\nvec3 t;\n  c(aTangent, i, t);\n  vTangent = vec4(h * t, aTangent.w);\n#else\ni = decode_getNormal(aNormal);\n#endif\nvec3 j = appendMorphNormal(i);\n  vNormal = normalize(h * j);\n#else\nvNormal = vec3(.0);\n#endif\nmat4 k = projMatrix;\n  k[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = k * getMaskPosition(f * e, modelMatrix);\n#else\ngl_Position = k * modelViewMatrix * f * e;\n#endif\n#ifdef HAS_MAP\nvec2 l = decode_getTexcoord(aTexCoord);\n  vTexCoord = l * uvScale + uvOffset;\n#endif\n#ifdef HAS_AO_MAP\nvec2 m = decode_getTexcoord(aTexCoord1);\n  vTexCoord1 = m * uvScale + uvOffset;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nvExtrusionOpacity = aExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(f * e);\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * f, e);\n#endif\n#ifdef HAS_I3S_UVREGION\nvUvRegion = uvRegion / 65535.;\n#endif\nhighlight_setVarying();\n#ifdef HAS_VERTEX_COLOR\nvertexColor_update();\n#endif\n}",
                frag: e.frag || "precision mediump float;\n#include <gl2_frag>\nuniform vec4 baseColorFactor;\nuniform float materialShininess;\nuniform float environmentExposure;\nuniform float specularStrength;\nuniform vec3 light0_viewDirection;\nuniform vec3 ambientColor;\nuniform vec4 light0_diffuse;\nuniform vec3 lightSpecular;\nuniform vec3 cameraPosition;\nuniform float alphaTest;\n#ifdef HAS_TOON\nuniform float toons;\nuniform float specularToons;\n#endif\n#ifdef HAS_TANGENT\nvarying vec4 vTangent;\n#endif\n#ifdef HAS_MAP\n#include <compute_texcoord_frag>\n#endif\nvarying vec3 vNormal;\nvarying vec3 vFragPos;\n#ifdef HAS_INSTANCE_COLOR\nvarying vec4 vInstanceColor;\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_EXTRUSION_OPACITY\nuniform vec2 extrusionOpacityRange;\nvarying float vExtrusionOpacity;\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#elif defined(IS_LINE_EXTRUSION)\nuniform vec4 lineColor;\n#else\nuniform vec4 polygonFill;\n#endif\n#ifdef HAS_LAYER_OPACITY\nuniform float layerOpacity;\n#endif\n#ifdef IS_LINE_EXTRUSION\nuniform float lineOpacity;\n#else\nuniform float polygonOpacity;\n#endif\n#ifdef HAS_AO_MAP\nuniform sampler2D occlusionTexture;\nvarying vec2 vTexCoord1;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\nuniform vec3 specularFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#include <heatmap_render_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#include <highlight_frag>\n#include <mask_frag>\n#include <vertex_color_frag>\nvec3 c() {\n  \n#if defined(HAS_NORMAL_MAP)\nvec3 d = normalize(vNormal);\n  vec3 e = texture2D(normalTexture, computeTexCoord(vTexCoord)).xyz * 2. - 1.;\n#if defined(HAS_TANGENT)\nvec3 t = normalize(vTangent.xyz);\n  vec3 b = normalize(cross(d, t) * sign(vTangent.w));\n  mat3 f = mat3(t, b, d);\n  return normalize(f * e);\n#else\nreturn normalize(e);\n#endif\n#else\nreturn normalize(vNormal);\n#endif\n}\nvec4 h() {\n  \n#if defined(HAS_BASECOLOR_MAP)\nreturn texture2D(baseColorTexture, computeTexCoord(vTexCoord));\n#elif defined(HAS_DIFFUSE_MAP)\nreturn texture2D(diffuseTexture, computeTexCoord(vTexCoord));\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn diffuseFactor;\n#else\nreturn baseColorFactor;\n#endif\n}\nvec3 i() {\n  \n#if defined(HAS_SPECULARGLOSSINESS_MAP)\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#elif defined(SHADING_MODEL_SPECULAR_GLOSSINESS)\nreturn specularFactor;\n#else\nreturn vec3(1.);\n#endif\n}\nvoid main() {\n  vec4 j = h();\n#ifdef SHADING_MODEL_UNLIT\nvec3 k = vec3(1.);\n#else\nvec3 k = ambientColor;\n#endif\nvec3 l = environmentExposure * k * j.rgb;\n#ifdef HAS_INSTANCE_COLOR\nl *= vInstanceColor.rgb;\n#endif\nvec3 m = c();\n  vec3 o = normalize(-light0_viewDirection);\n  float u = max(dot(m, o), .0);\n#ifdef HAS_TOON\nfloat v = floor(u * toons);\n  u = v / toons;\n#endif\n#ifdef SHADING_MODEL_UNLIT\nvec3 A = vec3(.0);\n#else\nvec3 A = light0_diffuse.rgb;\n#endif\nvec3 B = A * u * j.rgb;\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvec3 C = vColor.rgb;\n#elif defined(IS_LINE_EXTRUSION)\nvec3 C = lineColor.rgb;\n#else\nvec3 C = polygonFill.rgb;\n#endif\n#ifdef HAS_INSTANCE_COLOR\nC *= vInstanceColor.rgb;\n#endif\nl *= C.rgb;\n  B *= C.rgb;\n  vec3 D = normalize(cameraPosition - vFragPos);\n  vec3 E = normalize(o + D);\n  float F = pow(max(dot(m, E), .0), materialShininess);\n#ifdef HAS_TOON\nfloat G = floor(F * specularToons);\n  F = G / specularToons;\n#endif\n#ifdef SHADING_MODEL_UNLIT\nvec3 H = vec3(.0);\n#else\nvec3 H = lightSpecular;\n#endif\nvec3 I = specularStrength * H * F * i();\n#ifdef HAS_OCCLUSION_MAP\nfloat J = texture2D(occlusionTexture, computeTexCoord(vTexCoord1)).r;\n  l *= J;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat K = shadow_computeShadow();\n  B = shadow_blend(B, K).rgb;\n  I = shadow_blend(I, K).rgb;\n  l = shadow_blend(l, K).rgb;\n#endif\nvec3 L = l + B + I;\n#ifdef HAS_EMISSIVE_MAP\nvec3 M = texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n  L += M;\n#endif\n#ifdef IS_LINE_EXTRUSION\nglFragColor = vec4(L, lineOpacity * j.a);\n#else\nglFragColor = vec4(L, polygonOpacity * j.a);\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nfloat N = vColor.a;\n#elif defined(IS_LINE_EXTRUSION)\nfloat N = lineColor.a;\n#else\nfloat N = polygonFill.a;\n#endif\nglFragColor *= N;\n#ifdef HAS_EXTRUSION_OPACITY\nfloat O = extrusionOpacityRange.x;\n  float P = extrusionOpacityRange.y;\n  float Q = O + vExtrusionOpacity * (P - O);\n  Q = clamp(Q, .0, 1.);\n  glFragColor *= Q;\n#endif\nif(glFragColor.a < alphaTest) {\n    discard;\n  }\n#ifdef HAS_VERTEX_COLOR\nglFragColor *= vertexColor_get();\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\nglFragColor = highlight_blendColor(glFragColor);\n#ifdef HAS_LAYER_OPACITY\nglFragColor *= layerOpacity;\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                wgslVert: "",
                wgslFrag: "",
                uniforms: i,
                defines: e.defines || {},
                extraCommandProps: e.extraCommandProps || {}
            }), this.version = 300;
        }
        getGeometryDefines(e) {
            const t = {};
            return e.data[e.desc.tangentAttribute] ? t.HAS_TANGENT = 1 : e.data[e.desc.normalAttribute] && (t.HAS_NORMAL = 1), 
            t;
        }
    },
    PhongSpecularGlossinessMaterial: Gt,
    Plane: Xr,
    PointLineShader: class extends Yi {
        constructor(e = {}) {
            const t = [];
            super({
                vert: "attribute vec3 aPosition;\n#ifdef HAS_COLOR0\nattribute vec4 aColor0;\nvarying vec4 vColor;\n#endif\nuniform mat4 modelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nuniform mat4 projViewModelMatrix;\nuniform float pointSize;\n#if defined(HAS_MAP)\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#endif\n#include <get_output>\n#include <heatmap_render_vert>\n#ifdef HAS_FLOODANALYSE\nvarying float vHeight;\n#endif\nvoid main() {\n  vec4 c = getPosition(aPosition);\n  mat4 d = getPositionMatrix();\n  gl_PointSize = pointSize;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * d * c;\n#endif\n#ifdef HAS_COLOR0\nvColor = aColor0 / 255.;\n#endif\n#ifdef HAS_MAP\nvTexCoord = aTexCoord;\n#endif\n#ifdef HAS_HEATMAP\nheatmap_compute(projMatrix * modelViewMatrix * d, c);\n#endif\n}",
                frag: "precision mediump float;\n#include <gl2_frag>\n#if defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#include <heatmap_render_frag>\nuniform vec4 baseColorFactor;\n#if defined(HAS_MAP)\n#if defined(HAS_ALBEDO_MAP)\nuniform sampler2D baseColorTexture;\n#endif\n#if defined(HAS_DIFFUSE_MAP)\nuniform sampler2D diffuseTexture;\n#endif\nvarying vec2 vTexCoord;\n#endif\n#include <mask_frag>\nvoid main() {\n  \n#ifdef HAS_COLOR0\nglFragColor = vColor * baseColorFactor;\n#else\nglFragColor = vec4(1.) * baseColorFactor;\n#endif\n#ifdef HAS_MAP\n#ifdef HAS_ALBEDO_MAP\nglFragColor *= texture2D(baseColorTexture, vTexCoord);\n#endif\n#ifdef HAS_DIFFUSE_MAP\nglFragColor *= texture2D(diffuseTexture, vTexCoord);\n#endif\n#endif\n#ifdef HAS_HEATMAP\nglFragColor = heatmap_getColor(glFragColor);\n#endif\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: [ {
                    name: "projViewModelMatrix",
                    type: "function",
                    fn: (e, n) => c.multiply(t, n.projViewMatrix, n.modelMatrix)
                } ],
                defines: e.defines || {},
                extraCommandProps: e.extraCommandProps || {}
            });
        }
    },
    PostProcessShader: ss,
    QuadShader: es,
    REGLHelper: Tt,
    RainRipplesPass: Is,
    Renderer: wr,
    ResourceLoader: Mr,
    ScanEffectPass: Ns,
    ScanEffectShader: ws,
    Scene: Pr,
    Shader: Zi,
    ShaderLib: Zr,
    ShadowDisplayShader: $o,
    ShadowMapShader: qo,
    ShadowPass: Yo,
    SkyboxShader: ps,
    SsrPass: fs,
    StandardLiteMaterial: class extends Ft {
        constructor(e) {
            super(e, Bt);
        }
        appendDefines(e, t) {
            super.appendDefines(e, t);
            const n = this.uniforms;
            n.extrusionOpacity && (e.HAS_EXTRUSION_OPACITY = 1), t.data[t.desc.colorAttribute] && (e.HAS_COLOR = 1);
            return t.data[t.desc.color0Attribute] && (e.HAS_COLOR0 = 1, e.COLOR0_SIZE = t.getColor0Size()), 
            t.data[t.desc.uv0Attribute] ? (n.baseColorTexture && (e.HAS_BASECOLOR_MAP = 1), 
            n.occlusionTexture && t.data[t.desc.uv1Attribute] && (e.HAS_AO_MAP = 1), n.emissiveTexture && (e.HAS_EMISSIVE_MAP = 1), 
            n.normalTexture && (e.HAS_NORMAL_MAP = 1), (e.HAS_BASECOLOR_MAP || e.HAS_AO_MAP || e.HAS_EMISSIVE_MAP || e.HAS_NORMAL_MAP) && (e.HAS_MAP = 1), 
            e.ALPHATEST = .01, e.GAMMA_INPUT = 1, e.GAMMA_FACTOR = 1, e.TONEMAP_OUTPUT = 1, 
            e.ENVMAP_MODE_REFLECTION = 1, e.ENV_RGBM = 1, e.IRR_RGBM = 1, e) : e;
        }
    },
    StandardLiteShader: class extends Yi {
        constructor(e = {}) {
            const t = [], n = e.uniforms, r = [ {
                name: "viewMatrixInverse",
                type: "function",
                fn: (e, t) => c.invert(ys, t.viewMatrix)
            }, {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, n) {
                    return c.multiply(t, n.viewMatrix, n.modelMatrix);
                }
            }, {
                name: "environmentTransform",
                type: "function",
                fn: (e, t) => {
                    const n = t.environmentOrientation || 0;
                    return u.fromRotation(bs, Math.PI * n / 180);
                }
            } ];
            n && r.push(...n), super({
                vert: "precision mediump float;\n#include <gl2_vert>\nattribute vec3 aPosition;\n#include <line_extrusion_vert>\n#ifdef HAS_MAP\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\n#ifdef HAS_I3S_UVREGION\nattribute vec4 uvRegion;\nvarying vec4 vUvRegion;\n#endif\n#endif\n#if defined(HAS_COLOR)\nattribute vec4 aColor;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nattribute vec3 aColor0;\n#else\nattribute vec4 aColor0;\n#endif\nvarying vec4 vColor;\n#endif\nuniform mat4 projMatrix;\nuniform mat3 modelNormalMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 positionMatrix;\nuniform vec2 halton;\nuniform vec2 outSize;\nuniform mat4 projViewMatrix;\n#include <get_output>\n#include <heatmap_render_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvarying vec3 vViewPosition;\nvoid main() {\n  \n#ifdef IS_LINE_EXTRUSION\nvec4 c = getPosition(getLineExtrudePosition(aPosition));\n#else\nvec4 c = getPosition(aPosition);\n#endif\nmat4 d = getPositionMatrix();\n  mat4 e = projMatrix;\n  e[2].xy += halton.xy / outSize.xy;\n#ifdef HAS_MASK_EXTENT\ngl_Position = e * getMaskPosition(d * c, modelMatrix);\n#else\ngl_Position = e * modelViewMatrix * d * c;\n#endif\nvec4 f = modelViewMatrix * d * c;\n  vViewPosition = -f.xyz;\n#ifdef HAS_MAP\nvec2 h = decode_getTexcoord(aTexCoord);\n  vTexCoord = h * uvScale + uvOffset;\n#endif\n#if defined(HAS_COLOR)\nvColor = aColor / 255.;\n#elif defined(HAS_COLOR0)\n#if COLOR0_SIZE == 3\nvColor = vec4(aColor0 / 255., 1.);\n#else\nvColor = aColor0 / 255.;\n#endif\n#endif\n}",
                frag: "#if __VERSION__ == 100\n#if defined(GL_EXT_shader_texture_lod)\n#extension GL_EXT_shader_texture_lod : enable\n#define textureCubeLod(tex, uv, lod) textureCubeLodEXT(tex, uv, lod)\n#else\n#define textureCubeLod(tex, uv, lod) textureCube(tex, uv, lod)\n#endif\n#if defined(GL_OES_standard_derivatives)\n#extension GL_OES_standard_derivatives : enable\n#endif\n#else\n#define textureCubeLod(tex, uv, lod) textureLod(tex, uv, lod)\n#endif\n#define saturate(x)        clamp(x, 0.0, 1.0)\nprecision mediump float;\n#include <gl2_frag>\n#include <hsv_frag>\nuniform vec3 hsv;\n#define GET_BASEMAP(UV) (texture2D(baseColorTexture, (UV)))\nuniform mat4 viewMatrix;\nuniform mat4 projMatrix;\nuniform vec3 cameraPosition;\n#if defined(HAS_IBL_LIGHTING)\nuniform mat4 viewMatrixInverse;\n#endif\nuniform vec4 baseColorFactor;\nuniform vec3 emissiveFactor;\nuniform vec3 specularFactor;\nuniform float opacity;\nuniform float envRotationSin;\nuniform float envRotationCos;\nuniform float rgbmRange;\n#if defined(HAS_MAP)\n#include <compute_texcoord_frag>\n#endif\n#ifdef HAS_BASECOLOR_MAP\nuniform sampler2D baseColorTexture;\n#endif\n#ifdef HAS_NORMAL_MAP\nuniform sampler2D normalTexture;\nvec3 c(vec3 d, vec3 e) {\n  vec3 f = dFdx(d.xyz);\n  vec3 h = dFdy(d.xyz);\n  vec3 i = normalize(f - h);\n  vec3 j = normalize(-f + h);\n  vec3 k = normalize(e);\n  vec3 l = texture2D(normalTexture, computeTexCoord(vTexCoord)).rgb * 2. - 1.;\n  mat3 m = mat3(i, j, k);\n  return normalize(m * l);\n}\n#endif\n#ifdef HAS_EMISSIVE_MAP\nuniform sampler2D emissiveTexture;\n#endif\n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\nuniform vec4 diffuseFactor;\n#ifdef HAS_DIFFUSE_MAP\nuniform sampler2D diffuseTexture;\n#endif\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nuniform sampler2D specularGlossinessTexture;\n#endif\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#if defined(HAS_COLOR) || defined(HAS_COLOR0)\nvarying vec4 vColor;\n#endif\n#ifdef GAMMA_INPUT\nvec3 n(vec3 o) {\n  return o * o;\n}\nfloat n(float o) {\n  return o * o;\n}\n#else\nvec3 n(vec3 o) {\n  return o;\n}\nfloat n(float o) {\n  return o;\n}\n#endif\nvec3 u() {\n  \n#ifdef SHADING_MODEL_SPECULAR_GLOSSINESS\n#ifdef HAS_SPECULARGLOSSINESS_MAP\nreturn texture2D(specularGlossinessTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn specularFactor;\n#endif\n#else\nreturn specularFactor;\n#endif\n}\nvec3 v() {\n  \n#ifdef HAS_EMISSIVE_MAP\nreturn texture2D(emissiveTexture, computeTexCoord(vTexCoord)).rgb;\n#else\nreturn emissiveFactor;\n#endif\n}\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT > 0\nuniform float exposureBias;\nfloat A(vec3 rgb) {\n  return dot(rgb, vec3(.299, .587, .114));\n}\nfloat B(vec3 rgb) {\n  return dot(rgb, vec3(.212671, .715160, .072169));\n}\nvec3 C(vec3 xyz) {\n  vec3 D = vec3(3.240479, -1.53715, -.498535);\n  vec3 E = vec3(-.969256, 1.875992, .041556);\n  vec3 F = vec3(.055648, -.204043, 1.057311);\n  vec3 rgb;\n  rgb.b = dot(xyz, F);\n  rgb.g = dot(xyz, E);\n  rgb.r = dot(xyz, D);\n  return rgb;\n}\nvec3 H(vec3 rgb) {\n  vec3 I = vec3(.412453, .35758, .180423);\n  vec3 J = vec3(.212671, .71516, .0721688);\n  vec3 K = vec3(.0193338, .119194, .950227);\n  vec3 xyz;\n  xyz.x = dot(rgb, I);\n  xyz.y = dot(rgb, J);\n  xyz.z = dot(rgb, K);\n  return xyz;\n}\nvec3 L(vec3 xyz) {\n  float M = xyz.x + xyz.y + xyz.z;\n  M = 1. / M;\n  vec3 O;\n  O.z = xyz.y;\n  O.x = xyz.x * M;\n  O.y = xyz.y * M;\n  return O;\n}\nvec3 P(vec3 O) {\n  float x = O.x;\n  float y = O.y;\n  float J = O.z;\n  vec3 xyz;\n  xyz.y = J;\n  xyz.x = x * (J / y);\n  xyz.z = (1. - x - y) * (J / y);\n  return xyz;\n}\nfloat Q(float x) {\n  float U = pow(x, 1.60525727);\n  float V = ((1.05542877 * 4.68037409) * U) / (4.68037409 * U + 1.);\n  return clamp(V, .0, 1.);\n}\nconst float W = 1. / .18;\nfloat ba(float x) {\n  x *= W;\n  const float bb = .2;\n  const float F = .34;\n  const float bc = .002;\n  const float bd = 1.68;\n  const float be = .0005;\n  const float bf = .252;\n  const float bg = 1. / .833837;\n  return ((x * (bb * x + bc * F) + bd * be) / (x * (bb * x + F) + bd * bf) - be / bf) * bg;\n}\nvec3 bh(vec3 x) {\n  x *= W;\n  const float bb = .27;\n  const float F = .29;\n  const float bc = .052;\n  const float bd = .2;\n  const float bf = .18;\n  const float bg = 1. / .897105;\n  return ((x * (bb * x + bc * F)) / (x * (bb * x + F) + bd * bf)) * bg;\n}\nvec3 bi(vec3 x) {\n  vec3 bj = x.rgb;\n  bj = min(bj, vec3(3.));\n  float bk = B(bj);\n  if(bk > .0) {\n    float bl = Q(bk);\n    bj = bj * (bl / bk);\n    bj = clamp(bj, vec3(.0), vec3(1.));\n  }\n  float bm = 1. / 2.2;\n  bj = pow(bj, vec3(bm));\n  return bj;\n}\n#endif\n#endif\n#if defined(IRR_RGBM) || defined(ENV_RGBM) || defined(ENV_GAMMA) || defined(IRR_GAMMA)\nuniform float envMapExposure;\n#endif\nuniform vec4 themingColor;\nuniform mat3 environmentTransform;\nvec3 bn(vec3 bo, vec3 bp) {\n  \n#if defined(HAS_SHADOWMAP)\nfloat bq = dot(shadowLightDir, bp);\n  float br = (bq + 1.) / 2.;\n  br = min(1., br * 1.5);\n  float bs = 1.;\n  vec3 bt = bo * min(bs, br);\n  return bt;\n#else\nreturn bo;\n#endif\n}\n#ifdef HAS_IBL_LIGHTING\nuniform float reflectivity;\nuniform vec3 hdrHSV;\nuniform samplerCube prefilterMap;\nuniform vec3 diffuseSPH[9];\nuniform vec2 prefilterMiplevel;\nuniform vec2 prefilterSize;\n#else\nuniform vec3 ambientColor;\n#endif\n#if defined(HAS_IBL_LIGHTING)\nvec3 bu(const in vec3 bv) {\n  vec3 bw = environmentTransform * bv;\n  float x = bw.x;\n  float y = bw.y;\n  float z = bw.z;\n  vec3 bt = (diffuseSPH[0] + diffuseSPH[1] * x + diffuseSPH[2] * y + diffuseSPH[3] * z + diffuseSPH[4] * z * x + diffuseSPH[5] * y * z + diffuseSPH[6] * y * x + diffuseSPH[7] * (3. * z * z - 1.) + diffuseSPH[8] * (x * x - y * y));\n  if(length(hdrHSV) > .0) {\n    bt = hsv_apply(bt, hdrHSV);\n  }\n  return max(bt, vec3(.0));\n}\nvec3 bx(const in vec4 by, const in float bz) {\n  if(bz <= .0)\n    return by.rgb;\n  return bz * by.rgb * by.a;\n}\nfloat bA(const in float bB) {\n  return bB;\n}\nvec3 bC(const in float bD, const in vec3 D) {\n  vec3 bE = D;\n  float bF = prefilterMiplevel.x;\n  float bG = min(bF, bA(bD) * prefilterMiplevel.y);\n  vec3 bH = bx(textureCubeLod(prefilterMap, bE, bG), rgbmRange);\n  if(length(hdrHSV) > .0) {\n    return hsv_apply(bH, hdrHSV);\n  } else {\n    return bH;\n  }\n}\nvec3 bI(const in vec3 k, const in vec3 D, const in float bJ) {\n  float bK = 1. - bJ;\n  float bL = bK * (sqrt(bK) + bJ);\n  return mix(k, D, bL);\n}\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  vec3 D = reflect(-bN, bv);\n  D = bI(bv, D, bO);\n  vec3 bQ = bC(bO, environmentTransform * D);\n  float bR = clamp(1. + dot(D, bP), .0, 1.);\n  bQ *= bR * bR;\n  return bQ;\n}\n#else\nvec3 bM(const in vec3 bv, const in vec3 bN, const in float bO, const in vec3 bP) {\n  return ambientColor;\n}\n#endif\nvarying highp vec3 vViewPosition;\nvec3 bS(vec3 bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\nfloat bW(float bT, float bU) {\n  float bV = max(1. - bU, .0);\n  return bT + (1. - bT) * pow(bV, 5.);\n}\n#include <srgb_frag>\nvoid main() {\n  glFragColor = vec4(vec3(1.), opacity);\n#ifdef HAS_BASECOLOR_MAP\nvec4 bX = GET_BASEMAP(computeTexCoord(vTexCoord));\n#ifdef GAMMA_INPUT\nbX.xyz *= bX.xyz;\n#endif\nglFragColor = glFragColor * bX;\n#endif\n#ifdef ALPHATEST\nif(glFragColor.a < ALPHATEST)\n    discard;\n  \n#endif\nfloat bY = 1.;\n  vec3 bZ = dFdx(vViewPosition);\n  vec3 ca = dFdy(vViewPosition);\n  vec3 bv = normalize(cross(bZ, ca));\n  vec3 cb;\n  if(projMatrix[3][3] == .0) {\n    cb = normalize(vViewPosition);\n  } else {\n    cb = vec3(.0, .0, 1.);\n  }\n  bv = faceforward(bv, -cb, bv);\n  vec3 cc = bv;\n#ifdef HAS_NORMAL_MAP\nbv = c(-vViewPosition, bv);\n#endif\nvec3 cd = vec3(.0);\n  vec3 ce = vec3(.0);\n#ifdef HAS_IBL_LIGHTING\nvec3 bp = mat3(viewMatrixInverse) * bv;\n  vec3 cf = glFragColor.rgb * bu(bp) * .5;\n  cf = bn(cf, bp);\n  cd += n(baseColorFactor.rgb) * cf;\n#endif\nvec3 cg = v();\n#ifdef METAL\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb) + ce);\n#else\nglFragColor.xyz = glFragColor.xyz * (n(cg) + cd + n(baseColorFactor.rgb)) + ce;\n#endif\nvec3 ch;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat ci = shadow_computeShadow();\n  ch = shadow_blend(ch, ci).rgb;\n#endif\n#ifdef HAS_COLOR\nglFragColor = glFragColor * vColor;\n#endif\nglFragColor.rgb += ch;\n  glFragColor.rgb = linearTosRGB(glFragColor.rgb);\n#if defined(HAS_IBL_LIGHTING)\nvec3 cj;\n#if defined(HAS_NORMAL_MAP)\n#ifdef ENVMAP_MODE_REFLECTION\ncj = reflect(-cb, bv);\n#else\ncj = refract(-cb, bv, 1.);\n#endif\n#else\ncj = reflect(-cb, bv);\n#endif\ncj = mat3(viewMatrixInverse) * cj;\n  float ck = 1.;\n  vec3 cl;\n#ifdef HAS_IBL_LIGHTING\ncl = vec3(.0);\n#elif\ncl = ambientColor;\n#endif\ncl *= ck;\n  float bV = dot(cb, bv);\n  if(bV < -1e-2 || reflectivity == .0)\n    bV = 1.;\n  else\n    bV = max(1e-6, bV);\n  vec3 cm;\n  vec3 cn = u();\n#ifdef METAL\ncm = n(cn);\n#else\ncm = bS(n(cn), bV) * (1. - envRotationSin);\n  glFragColor.a = mix(glFragColor.a, bW(glFragColor.a, bV), reflectivity) * envRotationCos;\n  float co = pow(1. - bV * .5, 5.);\n  float cp = (28. / 23.) * (1. - co) * (1. - co);\n  glFragColor.rgb *= cp * (1. - n(cn));\n#endif\nglFragColor.rgb += cl.rgb * bY * cm.rgb;\n#endif\n#if defined(TONEMAP_OUTPUT)\n#if TONEMAP_OUTPUT == 1\nglFragColor.rgb = bi(exposureBias * glFragColor.rgb);\n#elif TONEMAP_OUTPUT == 2\nglFragColor.rgb = bh(exposureBias * glFragColor.rgb);\n#endif\n#endif\nglFragColor.rgb = mix(glFragColor.rgb, themingColor.rgb, themingColor.a);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: r,
                defines: e.defines || {},
                extraCommandProps: e.extraCommandProps || {}
            }), this.version = 300;
        }
    },
    Texture2D: qr,
    Util: J,
    WGSLParseDefines: Ei,
    WaterShader: class extends Yi {
        constructor(e = {}) {
            super({
                vert: "const float c = 3.141592653589793;\nuniform mat4 projMatrix;\nuniform mat4 viewMatrix;\nuniform mat4 modelMatrix;\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nattribute vec3 aNormal;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nvec4 d(mat4 e, mat4 f, vec3 h) {\n  return e * modelMatrix * f * vec4(h, 1.);\n}\nvec3 i(in vec3 h, in vec3 j) {\n  return normalize(h + j);\n}\nmat3 k(in vec3 l) {\n  vec3 t = normalize(cross(vec3(.0, .0, 1.), l));\n  vec3 b = normalize(cross(l, t));\n  return mat3(t, b, l);\n}\nvoid m() {\n  \n}\nvoid main(void) {\n  vuv = aTexCoord;\n  vpos = (modelMatrix * vec4(aPosition, 1.)).xyz;\n  vnormal = aNormal;\n  vtbnMatrix = k(vnormal);\n  gl_Position = d(projMatrix, viewMatrix, vpos);\n  m();\n}",
                frag: "precision highp float;\nprecision highp sampler2D;\nuniform sampler2D texWaveNormal;\nuniform sampler2D texWavePerturbation;\nuniform vec3 octaveTextureRepeat;\nuniform vec4 waveParams;\nuniform vec2 waveDirection;\nuniform vec4 waterColor;\nuniform vec3 lightingDirection;\nuniform vec3 lightingIntensity;\nuniform vec3 camPos;\nuniform float timeElapsed;\nvarying vec2 vuv;\nvarying vec3 vpos;\nvarying vec3 vnormal;\nvarying mat3 vtbnMatrix;\nconst vec2 c = vec2(6. / 25., 5. / 24.);\nvec2 d(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rg - 1.;\n}\nfloat h(vec2 f) {\n  return texture2D(texWavePerturbation, f).b;\n}\nvec3 i(sampler2D e, vec2 f) {\n  return 2. * texture2D(e, f).rgb - 1.;\n}\nfloat j(vec2 f, float k) {\n  return fract(k);\n}\nfloat l(vec2 f, float k) {\n  float m = j(f, k);\n  return 1. - abs(1. - 2. * m);\n}\nvec3 n(sampler2D o, vec2 f, float k, float u) {\n  float v = waveParams[2];\n  float A = waveParams[3];\n  vec2 B = d(o, f) * v;\n  float m = j(f, k + u);\n  float C = l(f, k + u);\n  vec2 D = f;\n  D -= B * (m + A);\n  D += u;\n  D += (k - m) * c;\n  return vec3(D, C);\n}\nconst float E = .3737;\nconst float F = 7.77;\nvec3 G(sampler2D H, sampler2D I, vec2 f, vec2 J, float k) {\n  float K = waveParams[0];\n  vec2 L = k * -J;\n  float M = h(f * E) * F;\n  vec3 N = n(I, f + L, k + M, .0);\n  vec3 O = n(I, f + L, k + M, .5);\n  vec3 P = i(H, N.xy) * N.z;\n  vec3 Q = i(H, O.xy) * O.z;\n  vec3 R = normalize(P + Q);\n  R.xy *= K;\n  R.z = sqrt(1. - dot(R.xy, R.xy));\n  return R;\n}\nvec3 S(vec2 f, float k) {\n  float T = waveParams[1];\n  return G(texWaveNormal, texWavePerturbation, f * T, waveDirection, k);\n}\nconst float U = 3.141592653589793;\nconst float V = 1. / U;\nconst float W = .3183098861837907;\nconst float X = 1.570796326794897;\nstruct PBRShadingWater {\n  float NdotL;\n  float NdotV;\n  float NdotH;\n  float VdotH;\n  float LdotH;\n  float VdotN;\n};\nfloat Y = 2.2;\nvec3 Z(float ba, vec3 bb, float bc) {\n  return bb + (bc - bb) * pow(1. - ba, 5.);\n}\nfloat bd(float be, float bf) {\n  float bg = bf * bf;\n  float bh = be * be;\n  float bi = pow((bh * (bg - 1.) + 1.), Y) * U;\n  return bg / bi;\n}\nfloat bj(float bk) {\n  return .25 / (bk * bk);\n}\nvec3 bl(in PBRShadingWater bm, float bf, vec3 bn, float bo) {\n  vec3 bp = Z(bm.VdotH, bn, bo);\n  float bq = bd(bm.NdotH, bf);\n  float br = bj(bm.LdotH);\n  return (bq * br) * bp;\n}\nvec3 bs(const vec3 x) {\n  return (x * (2.51 * x + .03)) / (x * (2.43 * x + .59) + .14);\n}\nconst float bt = 2.2;\nconst float bu = .4545454545;\nvec4 bv(vec4 bw) {\n  return vec4(pow(bw.rgb, vec3(bu)), bw.w);\n}\nvec3 bx(vec3 bw) {\n  return pow(bw, vec3(bt));\n}\nconst vec3 by = vec3(.02, 1., 5.);\nconst vec2 bz = vec2(.02, .1);\nconst float bf = .06;\nconst vec3 bA = vec3(0, .6, .9);\nconst vec3 bB = vec3(.72, .92, 1.);\nPBRShadingWater bC;\nvec3 bD(in float bE, in vec3 bF, in vec3 bG) {\n  float bH = pow((1. - bE), by[2]);\n  return mix(bG, bF, bH);\n}\nvec3 bI(in vec3 bJ, in vec3 bK, in vec3 bL, vec3 bw, in vec3 bM, in vec3 bN, in float bO) {\n  vec3 bP = bx(bw);\n  vec3 bQ = normalize(bL + bK);\n  bC.NdotL = clamp(dot(bJ, bL), .0, 1.);\n  bC.NdotV = clamp(dot(bJ, bK), .001, 1.);\n  bC.VdotN = clamp(dot(bK, bJ), .001, 1.);\n  bC.NdotH = clamp(dot(bJ, bQ), .0, 1.);\n  bC.VdotH = clamp(dot(bK, bQ), .0, 1.);\n  bC.LdotH = clamp(dot(bL, bQ), .0, 1.);\n  float bR = max(dot(bN, bK), .0);\n  vec3 bS = bx(bB);\n  vec3 bT = bx(bA);\n  vec3 bB = bD(bR, bS, bT);\n  float bU = max(dot(bN, bL), .0);\n  bB *= .1 + bU * .9;\n  float bV = clamp(bO, .8, 1.);\n  vec3 bW = Z(bC.VdotN, vec3(by[0]), by[1]) * bB * bV;\n  vec3 bX = bP * mix(bB, bU * bM * V, 2. / 3.) * bV;\n  vec3 bY = vec3(.0);\n  if(bR > .0 && bU > .0) {\n    vec3 bZ = bl(bC, bf, vec3(bz[0]), bz[1]);\n    vec3 ca = bM * V * bO;\n    bY = bC.NdotL * ca * bZ;\n  }\n  return bs(bW + bX + bY);\n}\nvoid main() {\n  vec3 bN = vnormal;\n  vec3 cb = S(vuv, timeElapsed);\n  vec3 bJ = normalize(vtbnMatrix * cb);\n  vec3 bK = -normalize(vpos - camPos);\n  vec3 bL = normalize(-lightingDirection);\n  float bO = 1.;\n  vec4 cc = vec4(bI(bJ, bK, bL, waterColor.rgb, lightingIntensity, bN, bO), waterColor.w);\n  gl_FragColor = bv(cc);\n}",
                defines: e.defines || {},
                extraCommandProps: e.extraCommandProps || {}
            });
        }
    },
    WebGLConstants: Wr,
    WgslShaderLib: ni,
    WireFrameMaterial: class extends Ft {
        constructor(e) {
            super(e, Ht);
        }
    },
    WireframeShader: class extends Yi {
        constructor(e = {}) {
            let t = e.extraCommandProps || {};
            const n = [];
            t = E({}, t, {
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                },
                sample: {
                    alpha: !0
                }
            }), super({
                vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec3 aBarycentric;\nvarying vec3 vBarycentric;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 projMatrix;\nuniform mat4 positionMatrix;\nvarying vec3 vPosition;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(c * d, modelMatrix);\n#else\ngl_Position = projMatrix * modelViewMatrix * c * d;\n#endif\nvBarycentric = aBarycentric;\n  vPosition = aPosition;\n}",
                frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec3 vBarycentric;\nuniform float time;\nuniform float thickness;\nuniform float secondThickness;\nuniform float dashRepeats;\nuniform float dashLength;\nuniform bool dashOverlap;\nuniform bool dashEnabled;\nuniform bool dashAnimate;\nuniform bool seeThrough;\nuniform bool insideAltColor;\nuniform bool dualStroke;\nuniform bool squeeze;\nuniform float squeezeMin;\nuniform float squeezeMax;\nuniform vec4 stroke;\nuniform vec4 fill;\nuniform float opacity;\nuniform bool noiseEnable;\nvarying vec3 vPosition;\n#ifdef HAS_INSTANCE\nvarying vec4 vInstanceColor;\n#endif\n#include <mask_frag>\n#define F4 0.309016994374947451\n#define halfDist 0.5\nvec4 c(vec4 x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nfloat c(float x) {\n  return x - floor(x * (1. / 289.)) * 289.;\n}\nvec4 d(vec4 x) {\n  return c((x * 34. + 1.) * x);\n}\nfloat d(float x) {\n  return c((x * 34. + 1.) * x);\n}\nvec4 e(vec4 r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nfloat e(float r) {\n  return 1.79284291400159 - .85373472095314 * r;\n}\nvec4 f(float h, vec4 i) {\n  const vec4 k = vec4(1., 1., 1., -1.);\n  vec4 p, s;\n  p.xyz = floor(fract(vec3(h) * i.xyz) * 7.) * i.z - 1.;\n  p.w = 1.5 - dot(abs(p.xyz), k.xyz);\n  s = vec4(lessThan(p, vec4(.0)));\n  p.xyz = p.xyz + (s.xyz * 2. - 1.) * s.www;\n  return p;\n}\nfloat l(vec4 m) {\n  const vec4 n = vec4(.138196601125011, .276393202250021, .414589803375032, -.447213595499958);\n  vec4 o = floor(m + dot(m, vec4(F4)));\n  vec4 u = m - o + dot(o, n.xxxx);\n  vec4 A;\n  vec3 B = step(u.yzw, u.xxx);\n  vec3 D = step(u.zww, u.yyz);\n  A.x = B.x + B.y + B.z;\n  A.yzw = 1. - B;\n  A.y += D.x + D.y;\n  A.zw += 1. - D.xy;\n  A.z += D.z;\n  A.w += 1. - D.z;\n  vec4 E = clamp(A, .0, 1.);\n  vec4 F = clamp(A - 1., .0, 1.);\n  vec4 G = clamp(A - 2., .0, 1.);\n  vec4 H = u - G + n.xxxx;\n  vec4 I = u - F + n.yyyy;\n  vec4 J = u - E + n.zzzz;\n  vec4 K = u + n.wwww;\n  o = c(o);\n  float L = d(d(d(d(o.w) + o.z) + o.y) + o.x);\n  vec4 M = d(d(d(d(o.w + vec4(G.w, F.w, E.w, 1.)) + o.z + vec4(G.z, F.z, E.z, 1.)) + o.y + vec4(G.y, F.y, E.y, 1.)) + o.x + vec4(G.x, F.x, E.x, 1.));\n  vec4 i = vec4(1. / 294., 1. / 49., 1. / 7., .0);\n  vec4 N = f(L, i);\n  vec4 O = f(M.x, i);\n  vec4 P = f(M.y, i);\n  vec4 Q = f(M.z, i);\n  vec4 R = f(M.w, i);\n  vec4 S = e(vec4(dot(N, N), dot(O, O), dot(P, P), dot(Q, Q)));\n  N *= S.x;\n  O *= S.y;\n  P *= S.z;\n  Q *= S.w;\n  R *= e(dot(R, R));\n  vec3 T = max(.6 - vec3(dot(u, u), dot(H, H), dot(I, I)), .0);\n  vec2 U = max(.6 - vec2(dot(J, J), dot(K, K)), .0);\n  T = T * T;\n  U = U * U;\n  return 49. * (dot(T * T, vec3(dot(N, u), dot(O, H), dot(P, I))) + dot(U * U, vec2(dot(Q, J), dot(R, K))));\n}\nconst float V = 3.14159265359;\nfloat W(float X, float Y) {\n  float Z = fwidth(Y) * halfDist;\n  return smoothstep(X - Z, X + Z, Y);\n}\nvec4 ba(vec3 bb) {\n  float bc = min(min(bb.x, bb.y), bb.z);\n  float bd = .0;\n  if(noiseEnable)\n    bd += l(vec4(vPosition.xyz * 80.0, time * halfDist)) * .12;\n  bc += bd;\n  float be = max(bb.x, bb.y);\n  if(bb.y < bb.x && bb.y < bb.z) {\n    be = 1. - be;\n  }\n  float bf = thickness;\n  if(squeeze) {\n    bf *= mix(squeezeMin, squeezeMax, (1. - sin(be * V)));\n  }\n  if(dashEnabled) {\n    float bg = 1. / dashRepeats * dashLength / 2.;\n    if(!dashOverlap) {\n      bg += 1. / dashRepeats / 2.;\n    }\n    if(dashAnimate) {\n      bg += time * .22;\n    }\n    float bh = fract((be + bg) * dashRepeats);\n    bf *= 1. - W(dashLength, bh);\n  }\n  float bi = 1. - W(bf, bc);\n#ifdef HAS_INSTANCE\nvec4 bj = vInstanceColor;\n#else\nvec4 bj = stroke;\n#endif\nvec4 bk = vec4(.0);\n  if(seeThrough) {\n    bk = vec4(bj.xyz, bi);\n    if(insideAltColor && !gl_FrontFacing) {\n      bk.rgb = fill.xyz;\n    }\n  } else {\n    vec3 bl = mix(fill.xyz, bj.xyz, bi);\n    bk.a = fill.a;\n    if(dualStroke) {\n      float bm = 1. - W(secondThickness, bc);\n      vec3 bn = mix(fill.xyz, stroke.xyz, abs(bm - bi));\n      bk.rgb = bn;\n    } else {\n      bk.rgb = bl;\n    }\n  }\n  return bk;\n}\nvoid main() {\n  glFragColor = ba(vBarycentric);\n  glFragColor *= halfDist + opacity;\n#ifdef HAS_MASK_EXTENT\nglFragColor = setMask(glFragColor);\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
                uniforms: [ {
                    name: "modelViewMatrix",
                    type: "function",
                    fn: (e, t) => c.multiply(n, t.viewMatrix, t.modelMatrix)
                } ],
                extraCommandProps: t
            }), this.version = 300;
        }
    },
    earcut: Sa,
    glMatrix: g,
    mat2: _,
    mat2d: p,
    mat3: u,
    mat4: c,
    pbr: Ta,
    quat: m,
    quat2: v,
    vec2: f,
    vec3: h,
    vec4: d
});

function Aa(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}

var Ca = {
    exports: {}
}, ka = {
    exports: {}
}, Oa = function(e) {
    return !(!e || "string" == typeof e) && (e instanceof Array || Array.isArray(e) || e.length >= 0 && (e.splice instanceof Function || Object.getOwnPropertyDescriptor(e, e.length - 1) && "String" !== e.constructor.name));
}, Ea = Array.prototype.concat, Pa = Array.prototype.slice, Ia = ka.exports = function(e) {
    for (var t = [], n = 0, r = e.length; n < r; n++) {
        var i = e[n];
        Oa(i) ? t = Ea.call(t, Pa.call(i)) : t.push(i);
    }
    return t;
};

Ia.wrap = function(e) {
    return function() {
        return e(Ia(arguments));
    };
};

var Ra = ka.exports, La = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, Fa = Ra, Ha = Object.hasOwnProperty, Da = Object.create(null);

for (var Na in La) Ha.call(La, Na) && (Da[La[Na]] = Na);

var Ba = Ca.exports = {
    to: {},
    get: {}
};

function Ua(e, t, n) {
    return Math.min(Math.max(t, e), n);
}

function za(e) {
    var t = Math.round(e).toString(16).toUpperCase();
    return t.length < 2 ? "0" + t : t;
}

Ba.get = function(e) {
    var t, n;
    switch (e.substring(0, 3).toLowerCase()) {
      case "hsl":
        t = Ba.get.hsl(e), n = "hsl";
        break;

      case "hwb":
        t = Ba.get.hwb(e), n = "hwb";
        break;

      default:
        t = Ba.get.rgb(e), n = "rgb";
    }
    return t ? {
        model: n,
        value: t
    } : null;
}, Ba.get.rgb = function(e) {
    if (!e) return null;
    var t, n, r, i = [ 0, 0, 0, 1 ];
    if (t = e.match(/^#([a-f0-9]{6})([a-f0-9]{2})?$/i)) {
        for (r = t[2], t = t[1], n = 0; n < 3; n++) {
            var s = 2 * n;
            i[n] = parseInt(t.slice(s, s + 2), 16);
        }
        r && (i[3] = parseInt(r, 16) / 255);
    } else if (t = e.match(/^#([a-f0-9]{3,4})$/i)) {
        for (r = (t = t[1])[3], n = 0; n < 3; n++) i[n] = parseInt(t[n] + t[n], 16);
        r && (i[3] = parseInt(r + r, 16) / 255);
    } else if (t = e.match(/^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/)) {
        for (n = 0; n < 3; n++) i[n] = parseInt(t[n + 1], 0);
        t[4] && (t[5] ? i[3] = .01 * parseFloat(t[4]) : i[3] = parseFloat(t[4]));
    } else {
        if (!(t = e.match(/^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/))) return (t = e.match(/^(\w+)$/)) ? "transparent" === t[1] ? [ 0, 0, 0, 0 ] : Ha.call(La, t[1]) ? ((i = La[t[1]])[3] = 1, 
        i) : null : null;
        for (n = 0; n < 3; n++) i[n] = Math.round(2.55 * parseFloat(t[n + 1]));
        t[4] && (t[5] ? i[3] = .01 * parseFloat(t[4]) : i[3] = parseFloat(t[4]));
    }
    for (n = 0; n < 3; n++) i[n] = Ua(i[n], 0, 255);
    return i[3] = Ua(i[3], 0, 1), i;
}, Ba.get.hsl = function(e) {
    if (!e) return null;
    var t = e.match(/^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (t) {
        var n = parseFloat(t[4]);
        return [ (parseFloat(t[1]) % 360 + 360) % 360, Ua(parseFloat(t[2]), 0, 100), Ua(parseFloat(t[3]), 0, 100), Ua(isNaN(n) ? 1 : n, 0, 1) ];
    }
    return null;
}, Ba.get.hwb = function(e) {
    if (!e) return null;
    var t = e.match(/^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/);
    if (t) {
        var n = parseFloat(t[4]);
        return [ (parseFloat(t[1]) % 360 + 360) % 360, Ua(parseFloat(t[2]), 0, 100), Ua(parseFloat(t[3]), 0, 100), Ua(isNaN(n) ? 1 : n, 0, 1) ];
    }
    return null;
}, Ba.to.hex = function() {
    var e = Fa(arguments);
    return "#" + za(e[0]) + za(e[1]) + za(e[2]) + (e[3] < 1 ? za(Math.round(255 * e[3])) : "");
}, Ba.to.rgb = function() {
    var e = Fa(arguments);
    return e.length < 4 || 1 === e[3] ? "rgb(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ")" : "rgba(" + Math.round(e[0]) + ", " + Math.round(e[1]) + ", " + Math.round(e[2]) + ", " + e[3] + ")";
}, Ba.to.rgb.percent = function() {
    var e = Fa(arguments), t = Math.round(e[0] / 255 * 100), n = Math.round(e[1] / 255 * 100), r = Math.round(e[2] / 255 * 100);
    return e.length < 4 || 1 === e[3] ? "rgb(" + t + "%, " + n + "%, " + r + "%)" : "rgba(" + t + "%, " + n + "%, " + r + "%, " + e[3] + ")";
}, Ba.to.hsl = function() {
    var e = Fa(arguments);
    return e.length < 4 || 1 === e[3] ? "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)" : "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + e[3] + ")";
}, Ba.to.hwb = function() {
    var e = Fa(arguments), t = "";
    return e.length >= 4 && 1 !== e[3] && (t = ", " + e[3]), "hwb(" + e[0] + ", " + e[1] + "%, " + e[2] + "%" + t + ")";
}, Ba.to.keyword = function(e) {
    return Da[e.slice(0, 3)];
};

var Ga = Ca.exports, Va = {
    exports: {}
}, ja = {
    "aliceblue": [ 240, 248, 255 ],
    "antiquewhite": [ 250, 235, 215 ],
    "aqua": [ 0, 255, 255 ],
    "aquamarine": [ 127, 255, 212 ],
    "azure": [ 240, 255, 255 ],
    "beige": [ 245, 245, 220 ],
    "bisque": [ 255, 228, 196 ],
    "black": [ 0, 0, 0 ],
    "blanchedalmond": [ 255, 235, 205 ],
    "blue": [ 0, 0, 255 ],
    "blueviolet": [ 138, 43, 226 ],
    "brown": [ 165, 42, 42 ],
    "burlywood": [ 222, 184, 135 ],
    "cadetblue": [ 95, 158, 160 ],
    "chartreuse": [ 127, 255, 0 ],
    "chocolate": [ 210, 105, 30 ],
    "coral": [ 255, 127, 80 ],
    "cornflowerblue": [ 100, 149, 237 ],
    "cornsilk": [ 255, 248, 220 ],
    "crimson": [ 220, 20, 60 ],
    "cyan": [ 0, 255, 255 ],
    "darkblue": [ 0, 0, 139 ],
    "darkcyan": [ 0, 139, 139 ],
    "darkgoldenrod": [ 184, 134, 11 ],
    "darkgray": [ 169, 169, 169 ],
    "darkgreen": [ 0, 100, 0 ],
    "darkgrey": [ 169, 169, 169 ],
    "darkkhaki": [ 189, 183, 107 ],
    "darkmagenta": [ 139, 0, 139 ],
    "darkolivegreen": [ 85, 107, 47 ],
    "darkorange": [ 255, 140, 0 ],
    "darkorchid": [ 153, 50, 204 ],
    "darkred": [ 139, 0, 0 ],
    "darksalmon": [ 233, 150, 122 ],
    "darkseagreen": [ 143, 188, 143 ],
    "darkslateblue": [ 72, 61, 139 ],
    "darkslategray": [ 47, 79, 79 ],
    "darkslategrey": [ 47, 79, 79 ],
    "darkturquoise": [ 0, 206, 209 ],
    "darkviolet": [ 148, 0, 211 ],
    "deeppink": [ 255, 20, 147 ],
    "deepskyblue": [ 0, 191, 255 ],
    "dimgray": [ 105, 105, 105 ],
    "dimgrey": [ 105, 105, 105 ],
    "dodgerblue": [ 30, 144, 255 ],
    "firebrick": [ 178, 34, 34 ],
    "floralwhite": [ 255, 250, 240 ],
    "forestgreen": [ 34, 139, 34 ],
    "fuchsia": [ 255, 0, 255 ],
    "gainsboro": [ 220, 220, 220 ],
    "ghostwhite": [ 248, 248, 255 ],
    "gold": [ 255, 215, 0 ],
    "goldenrod": [ 218, 165, 32 ],
    "gray": [ 128, 128, 128 ],
    "green": [ 0, 128, 0 ],
    "greenyellow": [ 173, 255, 47 ],
    "grey": [ 128, 128, 128 ],
    "honeydew": [ 240, 255, 240 ],
    "hotpink": [ 255, 105, 180 ],
    "indianred": [ 205, 92, 92 ],
    "indigo": [ 75, 0, 130 ],
    "ivory": [ 255, 255, 240 ],
    "khaki": [ 240, 230, 140 ],
    "lavender": [ 230, 230, 250 ],
    "lavenderblush": [ 255, 240, 245 ],
    "lawngreen": [ 124, 252, 0 ],
    "lemonchiffon": [ 255, 250, 205 ],
    "lightblue": [ 173, 216, 230 ],
    "lightcoral": [ 240, 128, 128 ],
    "lightcyan": [ 224, 255, 255 ],
    "lightgoldenrodyellow": [ 250, 250, 210 ],
    "lightgray": [ 211, 211, 211 ],
    "lightgreen": [ 144, 238, 144 ],
    "lightgrey": [ 211, 211, 211 ],
    "lightpink": [ 255, 182, 193 ],
    "lightsalmon": [ 255, 160, 122 ],
    "lightseagreen": [ 32, 178, 170 ],
    "lightskyblue": [ 135, 206, 250 ],
    "lightslategray": [ 119, 136, 153 ],
    "lightslategrey": [ 119, 136, 153 ],
    "lightsteelblue": [ 176, 196, 222 ],
    "lightyellow": [ 255, 255, 224 ],
    "lime": [ 0, 255, 0 ],
    "limegreen": [ 50, 205, 50 ],
    "linen": [ 250, 240, 230 ],
    "magenta": [ 255, 0, 255 ],
    "maroon": [ 128, 0, 0 ],
    "mediumaquamarine": [ 102, 205, 170 ],
    "mediumblue": [ 0, 0, 205 ],
    "mediumorchid": [ 186, 85, 211 ],
    "mediumpurple": [ 147, 112, 219 ],
    "mediumseagreen": [ 60, 179, 113 ],
    "mediumslateblue": [ 123, 104, 238 ],
    "mediumspringgreen": [ 0, 250, 154 ],
    "mediumturquoise": [ 72, 209, 204 ],
    "mediumvioletred": [ 199, 21, 133 ],
    "midnightblue": [ 25, 25, 112 ],
    "mintcream": [ 245, 255, 250 ],
    "mistyrose": [ 255, 228, 225 ],
    "moccasin": [ 255, 228, 181 ],
    "navajowhite": [ 255, 222, 173 ],
    "navy": [ 0, 0, 128 ],
    "oldlace": [ 253, 245, 230 ],
    "olive": [ 128, 128, 0 ],
    "olivedrab": [ 107, 142, 35 ],
    "orange": [ 255, 165, 0 ],
    "orangered": [ 255, 69, 0 ],
    "orchid": [ 218, 112, 214 ],
    "palegoldenrod": [ 238, 232, 170 ],
    "palegreen": [ 152, 251, 152 ],
    "paleturquoise": [ 175, 238, 238 ],
    "palevioletred": [ 219, 112, 147 ],
    "papayawhip": [ 255, 239, 213 ],
    "peachpuff": [ 255, 218, 185 ],
    "peru": [ 205, 133, 63 ],
    "pink": [ 255, 192, 203 ],
    "plum": [ 221, 160, 221 ],
    "powderblue": [ 176, 224, 230 ],
    "purple": [ 128, 0, 128 ],
    "rebeccapurple": [ 102, 51, 153 ],
    "red": [ 255, 0, 0 ],
    "rosybrown": [ 188, 143, 143 ],
    "royalblue": [ 65, 105, 225 ],
    "saddlebrown": [ 139, 69, 19 ],
    "salmon": [ 250, 128, 114 ],
    "sandybrown": [ 244, 164, 96 ],
    "seagreen": [ 46, 139, 87 ],
    "seashell": [ 255, 245, 238 ],
    "sienna": [ 160, 82, 45 ],
    "silver": [ 192, 192, 192 ],
    "skyblue": [ 135, 206, 235 ],
    "slateblue": [ 106, 90, 205 ],
    "slategray": [ 112, 128, 144 ],
    "slategrey": [ 112, 128, 144 ],
    "snow": [ 255, 250, 250 ],
    "springgreen": [ 0, 255, 127 ],
    "steelblue": [ 70, 130, 180 ],
    "tan": [ 210, 180, 140 ],
    "teal": [ 0, 128, 128 ],
    "thistle": [ 216, 191, 216 ],
    "tomato": [ 255, 99, 71 ],
    "turquoise": [ 64, 224, 208 ],
    "violet": [ 238, 130, 238 ],
    "wheat": [ 245, 222, 179 ],
    "white": [ 255, 255, 255 ],
    "whitesmoke": [ 245, 245, 245 ],
    "yellow": [ 255, 255, 0 ],
    "yellowgreen": [ 154, 205, 50 ]
}, Wa = {};

for (var qa in ja) ja.hasOwnProperty(qa) && (Wa[ja[qa]] = qa);

var Xa = Va.exports = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [ "hex" ]
    },
    keyword: {
        channels: 1,
        labels: [ "keyword" ]
    },
    ansi16: {
        channels: 1,
        labels: [ "ansi16" ]
    },
    ansi256: {
        channels: 1,
        labels: [ "ansi256" ]
    },
    hcg: {
        channels: 3,
        labels: [ "h", "c", "g" ]
    },
    apple: {
        channels: 3,
        labels: [ "r16", "g16", "b16" ]
    },
    gray: {
        channels: 1,
        labels: [ "gray" ]
    }
};

for (var Ka in Xa) if (Xa.hasOwnProperty(Ka)) {
    if (!("channels" in Xa[Ka])) throw new Error("missing channels property: " + Ka);
    if (!("labels" in Xa[Ka])) throw new Error("missing channel labels property: " + Ka);
    if (Xa[Ka].labels.length !== Xa[Ka].channels) throw new Error("channel and label counts mismatch: " + Ka);
    var Za = Xa[Ka].channels, Ya = Xa[Ka].labels;
    delete Xa[Ka].channels, delete Xa[Ka].labels, Object.defineProperty(Xa[Ka], "channels", {
        value: Za
    }), Object.defineProperty(Xa[Ka], "labels", {
        value: Ya
    });
}

Xa.rgb.hsl = function(e) {
    var t, n, r = e[0] / 255, i = e[1] / 255, s = e[2] / 255, o = Math.min(r, i, s), a = Math.max(r, i, s), l = a - o;
    return a === o ? t = 0 : r === a ? t = (i - s) / l : i === a ? t = 2 + (s - r) / l : s === a && (t = 4 + (r - i) / l), 
    (t = Math.min(60 * t, 360)) < 0 && (t += 360), n = (o + a) / 2, [ t, 100 * (a === o ? 0 : n <= .5 ? l / (a + o) : l / (2 - a - o)), 100 * n ];
}, Xa.rgb.hsv = function(e) {
    var t, n, r, i, s, o = e[0] / 255, a = e[1] / 255, l = e[2] / 255, c = Math.max(o, a, l), h = c - Math.min(o, a, l), d = function(e) {
        return (c - e) / 6 / h + .5;
    };
    return 0 === h ? i = s = 0 : (s = h / c, t = d(o), n = d(a), r = d(l), o === c ? i = r - n : a === c ? i = 1 / 3 + t - r : l === c && (i = 2 / 3 + n - t), 
    i < 0 ? i += 1 : i > 1 && (i -= 1)), [ 360 * i, 100 * s, 100 * c ];
}, Xa.rgb.hwb = function(e) {
    var t = e[0], n = e[1], r = e[2];
    return [ Xa.rgb.hsl(e)[0], 100 * (1 / 255 * Math.min(t, Math.min(n, r))), 100 * (r = 1 - 1 / 255 * Math.max(t, Math.max(n, r))) ];
}, Xa.rgb.cmyk = function(e) {
    var t, n = e[0] / 255, r = e[1] / 255, i = e[2] / 255;
    return [ 100 * ((1 - n - (t = Math.min(1 - n, 1 - r, 1 - i))) / (1 - t) || 0), 100 * ((1 - r - t) / (1 - t) || 0), 100 * ((1 - i - t) / (1 - t) || 0), 100 * t ];
}, Xa.rgb.keyword = function(e) {
    var t = Wa[e];
    if (t) return t;
    var n, r, i, s = 1 / 0;
    for (var o in ja) if (ja.hasOwnProperty(o)) {
        var a = ja[o], l = (r = e, i = a, Math.pow(r[0] - i[0], 2) + Math.pow(r[1] - i[1], 2) + Math.pow(r[2] - i[2], 2));
        l < s && (s = l, n = o);
    }
    return n;
}, Xa.keyword.rgb = function(e) {
    return ja[e];
}, Xa.rgb.xyz = function(e) {
    var t = e[0] / 255, n = e[1] / 255, r = e[2] / 255;
    return [ 100 * (.4124 * (t = t > .04045 ? Math.pow((t + .055) / 1.055, 2.4) : t / 12.92) + .3576 * (n = n > .04045 ? Math.pow((n + .055) / 1.055, 2.4) : n / 12.92) + .1805 * (r = r > .04045 ? Math.pow((r + .055) / 1.055, 2.4) : r / 12.92)), 100 * (.2126 * t + .7152 * n + .0722 * r), 100 * (.0193 * t + .1192 * n + .9505 * r) ];
}, Xa.rgb.lab = function(e) {
    var t = Xa.rgb.xyz(e), n = t[0], r = t[1], i = t[2];
    return r /= 100, i /= 108.883, n = (n /= 95.047) > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116, 
    [ 116 * (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116) - 16, 500 * (n - r), 200 * (r - (i = i > .008856 ? Math.pow(i, 1 / 3) : 7.787 * i + 16 / 116)) ];
}, Xa.hsl.rgb = function(e) {
    var t, n, r, i, s, o = e[0] / 360, a = e[1] / 100, l = e[2] / 100;
    if (0 === a) return [ s = 255 * l, s, s ];
    t = 2 * l - (n = l < .5 ? l * (1 + a) : l + a - l * a), i = [ 0, 0, 0 ];
    for (var c = 0; c < 3; c++) (r = o + 1 / 3 * -(c - 1)) < 0 && r++, r > 1 && r--, 
    s = 6 * r < 1 ? t + 6 * (n - t) * r : 2 * r < 1 ? n : 3 * r < 2 ? t + (n - t) * (2 / 3 - r) * 6 : t, 
    i[c] = 255 * s;
    return i;
}, Xa.hsl.hsv = function(e) {
    var t = e[0], n = e[1] / 100, r = e[2] / 100, i = n, s = Math.max(r, .01);
    return n *= (r *= 2) <= 1 ? r : 2 - r, i *= s <= 1 ? s : 2 - s, [ t, 100 * (0 === r ? 2 * i / (s + i) : 2 * n / (r + n)), 100 * ((r + n) / 2) ];
}, Xa.hsv.rgb = function(e) {
    var t = e[0] / 60, n = e[1] / 100, r = e[2] / 100, i = Math.floor(t) % 6, s = t - Math.floor(t), o = 255 * r * (1 - n), a = 255 * r * (1 - n * s), l = 255 * r * (1 - n * (1 - s));
    switch (r *= 255, i) {
      case 0:
        return [ r, l, o ];

      case 1:
        return [ a, r, o ];

      case 2:
        return [ o, r, l ];

      case 3:
        return [ o, a, r ];

      case 4:
        return [ l, o, r ];

      case 5:
        return [ r, o, a ];
    }
}, Xa.hsv.hsl = function(e) {
    var t, n, r, i = e[0], s = e[1] / 100, o = e[2] / 100, a = Math.max(o, .01);
    return r = (2 - s) * o, n = s * a, [ i, 100 * (n = (n /= (t = (2 - s) * a) <= 1 ? t : 2 - t) || 0), 100 * (r /= 2) ];
}, Xa.hwb.rgb = function(e) {
    var t, n, r, i, s, o, a, l = e[0] / 360, c = e[1] / 100, h = e[2] / 100, d = c + h;
    switch (d > 1 && (c /= d, h /= d), r = 6 * l - (t = Math.floor(6 * l)), 1 & t && (r = 1 - r), 
    i = c + r * ((n = 1 - h) - c), t) {
      default:
      case 6:
      case 0:
        s = n, o = i, a = c;
        break;

      case 1:
        s = i, o = n, a = c;
        break;

      case 2:
        s = c, o = n, a = i;
        break;

      case 3:
        s = c, o = i, a = n;
        break;

      case 4:
        s = i, o = c, a = n;
        break;

      case 5:
        s = n, o = c, a = i;
    }
    return [ 255 * s, 255 * o, 255 * a ];
}, Xa.cmyk.rgb = function(e) {
    var t = e[0] / 100, n = e[1] / 100, r = e[2] / 100, i = e[3] / 100;
    return [ 255 * (1 - Math.min(1, t * (1 - i) + i)), 255 * (1 - Math.min(1, n * (1 - i) + i)), 255 * (1 - Math.min(1, r * (1 - i) + i)) ];
}, Xa.xyz.rgb = function(e) {
    var t, n, r, i = e[0] / 100, s = e[1] / 100, o = e[2] / 100;
    return n = -.9689 * i + 1.8758 * s + .0415 * o, r = .0557 * i + -.204 * s + 1.057 * o, 
    t = (t = 3.2406 * i + -1.5372 * s + -.4986 * o) > .0031308 ? 1.055 * Math.pow(t, 1 / 2.4) - .055 : 12.92 * t, 
    n = n > .0031308 ? 1.055 * Math.pow(n, 1 / 2.4) - .055 : 12.92 * n, r = r > .0031308 ? 1.055 * Math.pow(r, 1 / 2.4) - .055 : 12.92 * r, 
    [ 255 * (t = Math.min(Math.max(0, t), 1)), 255 * (n = Math.min(Math.max(0, n), 1)), 255 * (r = Math.min(Math.max(0, r), 1)) ];
}, Xa.xyz.lab = function(e) {
    var t = e[0], n = e[1], r = e[2];
    return n /= 100, r /= 108.883, t = (t /= 95.047) > .008856 ? Math.pow(t, 1 / 3) : 7.787 * t + 16 / 116, 
    [ 116 * (n = n > .008856 ? Math.pow(n, 1 / 3) : 7.787 * n + 16 / 116) - 16, 500 * (t - n), 200 * (n - (r = r > .008856 ? Math.pow(r, 1 / 3) : 7.787 * r + 16 / 116)) ];
}, Xa.lab.xyz = function(e) {
    var t, n, r, i = e[0];
    t = e[1] / 500 + (n = (i + 16) / 116), r = n - e[2] / 200;
    var s = Math.pow(n, 3), o = Math.pow(t, 3), a = Math.pow(r, 3);
    return n = s > .008856 ? s : (n - 16 / 116) / 7.787, t = o > .008856 ? o : (t - 16 / 116) / 7.787, 
    r = a > .008856 ? a : (r - 16 / 116) / 7.787, [ t *= 95.047, n *= 100, r *= 108.883 ];
}, Xa.lab.lch = function(e) {
    var t, n = e[0], r = e[1], i = e[2];
    return (t = 360 * Math.atan2(i, r) / 2 / Math.PI) < 0 && (t += 360), [ n, Math.sqrt(r * r + i * i), t ];
}, Xa.lch.lab = function(e) {
    var t, n = e[0], r = e[1];
    return t = e[2] / 360 * 2 * Math.PI, [ n, r * Math.cos(t), r * Math.sin(t) ];
}, Xa.rgb.ansi16 = function(e) {
    var t = e[0], n = e[1], r = e[2], i = 1 in arguments ? arguments[1] : Xa.rgb.hsv(e)[2];
    if (0 === (i = Math.round(i / 50))) return 30;
    var s = 30 + (Math.round(r / 255) << 2 | Math.round(n / 255) << 1 | Math.round(t / 255));
    return 2 === i && (s += 60), s;
}, Xa.hsv.ansi16 = function(e) {
    return Xa.rgb.ansi16(Xa.hsv.rgb(e), e[2]);
}, Xa.rgb.ansi256 = function(e) {
    var t = e[0], n = e[1], r = e[2];
    return t === n && n === r ? t < 8 ? 16 : t > 248 ? 231 : Math.round((t - 8) / 247 * 24) + 232 : 16 + 36 * Math.round(t / 255 * 5) + 6 * Math.round(n / 255 * 5) + Math.round(r / 255 * 5);
}, Xa.ansi16.rgb = function(e) {
    var t = e % 10;
    if (0 === t || 7 === t) return e > 50 && (t += 3.5), [ t = t / 10.5 * 255, t, t ];
    var n = .5 * (1 + ~~(e > 50));
    return [ (1 & t) * n * 255, (t >> 1 & 1) * n * 255, (t >> 2 & 1) * n * 255 ];
}, Xa.ansi256.rgb = function(e) {
    if (e >= 232) {
        var t = 10 * (e - 232) + 8;
        return [ t, t, t ];
    }
    var n;
    return e -= 16, [ Math.floor(e / 36) / 5 * 255, Math.floor((n = e % 36) / 6) / 5 * 255, n % 6 / 5 * 255 ];
}, Xa.rgb.hex = function(e) {
    var t = (((255 & Math.round(e[0])) << 16) + ((255 & Math.round(e[1])) << 8) + (255 & Math.round(e[2]))).toString(16).toUpperCase();
    return "000000".substring(t.length) + t;
}, Xa.hex.rgb = function(e) {
    var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!t) return [ 0, 0, 0 ];
    var n = t[0];
    3 === t[0].length && (n = n.split("").map((function(e) {
        return e + e;
    })).join(""));
    var r = parseInt(n, 16);
    return [ r >> 16 & 255, r >> 8 & 255, 255 & r ];
}, Xa.rgb.hcg = function(e) {
    var t, n = e[0] / 255, r = e[1] / 255, i = e[2] / 255, s = Math.max(Math.max(n, r), i), o = Math.min(Math.min(n, r), i), a = s - o;
    return t = a <= 0 ? 0 : s === n ? (r - i) / a % 6 : s === r ? 2 + (i - n) / a : 4 + (n - r) / a + 4, 
    t /= 6, [ 360 * (t %= 1), 100 * a, 100 * (a < 1 ? o / (1 - a) : 0) ];
}, Xa.hsl.hcg = function(e) {
    var t = e[1] / 100, n = e[2] / 100, r = 1, i = 0;
    return (r = n < .5 ? 2 * t * n : 2 * t * (1 - n)) < 1 && (i = (n - .5 * r) / (1 - r)), 
    [ e[0], 100 * r, 100 * i ];
}, Xa.hsv.hcg = function(e) {
    var t = e[1] / 100, n = e[2] / 100, r = t * n, i = 0;
    return r < 1 && (i = (n - r) / (1 - r)), [ e[0], 100 * r, 100 * i ];
}, Xa.hcg.rgb = function(e) {
    var t = e[0] / 360, n = e[1] / 100, r = e[2] / 100;
    if (0 === n) return [ 255 * r, 255 * r, 255 * r ];
    var i, s = [ 0, 0, 0 ], o = t % 1 * 6, a = o % 1, l = 1 - a;
    switch (Math.floor(o)) {
      case 0:
        s[0] = 1, s[1] = a, s[2] = 0;
        break;

      case 1:
        s[0] = l, s[1] = 1, s[2] = 0;
        break;

      case 2:
        s[0] = 0, s[1] = 1, s[2] = a;
        break;

      case 3:
        s[0] = 0, s[1] = l, s[2] = 1;
        break;

      case 4:
        s[0] = a, s[1] = 0, s[2] = 1;
        break;

      default:
        s[0] = 1, s[1] = 0, s[2] = l;
    }
    return i = (1 - n) * r, [ 255 * (n * s[0] + i), 255 * (n * s[1] + i), 255 * (n * s[2] + i) ];
}, Xa.hcg.hsv = function(e) {
    var t = e[1] / 100, n = t + e[2] / 100 * (1 - t), r = 0;
    return n > 0 && (r = t / n), [ e[0], 100 * r, 100 * n ];
}, Xa.hcg.hsl = function(e) {
    var t = e[1] / 100, n = e[2] / 100 * (1 - t) + .5 * t, r = 0;
    return n > 0 && n < .5 ? r = t / (2 * n) : n >= .5 && n < 1 && (r = t / (2 * (1 - n))), 
    [ e[0], 100 * r, 100 * n ];
}, Xa.hcg.hwb = function(e) {
    var t = e[1] / 100, n = t + e[2] / 100 * (1 - t);
    return [ e[0], 100 * (n - t), 100 * (1 - n) ];
}, Xa.hwb.hcg = function(e) {
    var t = e[1] / 100, n = 1 - e[2] / 100, r = n - t, i = 0;
    return r < 1 && (i = (n - r) / (1 - r)), [ e[0], 100 * r, 100 * i ];
}, Xa.apple.rgb = function(e) {
    return [ e[0] / 65535 * 255, e[1] / 65535 * 255, e[2] / 65535 * 255 ];
}, Xa.rgb.apple = function(e) {
    return [ e[0] / 255 * 65535, e[1] / 255 * 65535, e[2] / 255 * 65535 ];
}, Xa.gray.rgb = function(e) {
    return [ e[0] / 100 * 255, e[0] / 100 * 255, e[0] / 100 * 255 ];
}, Xa.gray.hsl = Xa.gray.hsv = function(e) {
    return [ 0, 0, e[0] ];
}, Xa.gray.hwb = function(e) {
    return [ 0, 100, e[0] ];
}, Xa.gray.cmyk = function(e) {
    return [ 0, 0, 0, e[0] ];
}, Xa.gray.lab = function(e) {
    return [ e[0], 0, 0 ];
}, Xa.gray.hex = function(e) {
    var t = 255 & Math.round(e[0] / 100 * 255), n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
    return "000000".substring(n.length) + n;
}, Xa.rgb.gray = function(e) {
    return [ (e[0] + e[1] + e[2]) / 3 / 255 * 100 ];
};

var $a = Va.exports, Ja = $a;

function Qa(e) {
    var t = function() {
        for (var e = {}, t = Object.keys(Ja), n = t.length, r = 0; r < n; r++) e[t[r]] = {
            distance: -1,
            parent: null
        };
        return e;
    }(), n = [ e ];
    for (t[e].distance = 0; n.length; ) for (var r = n.pop(), i = Object.keys(Ja[r]), s = i.length, o = 0; o < s; o++) {
        var a = i[o], l = t[a];
        -1 === l.distance && (l.distance = t[r].distance + 1, l.parent = r, n.unshift(a));
    }
    return t;
}

function el(e, t) {
    return function(n) {
        return t(e(n));
    };
}

function tl(e, t) {
    for (var n = [ t[e].parent, e ], r = Ja[t[e].parent][e], i = t[e].parent; t[i].parent; ) n.unshift(t[i].parent), 
    r = el(Ja[t[i].parent][i], r), i = t[i].parent;
    return r.conversion = n, r;
}

var nl = $a, rl = function(e) {
    for (var t = Qa(e), n = {}, r = Object.keys(t), i = r.length, s = 0; s < i; s++) {
        var o = r[s];
        null !== t[o].parent && (n[o] = tl(o, t));
    }
    return n;
}, il = {};

Object.keys(nl).forEach((function(e) {
    il[e] = {}, Object.defineProperty(il[e], "channels", {
        value: nl[e].channels
    }), Object.defineProperty(il[e], "labels", {
        value: nl[e].labels
    });
    var t = rl(e);
    Object.keys(t).forEach((function(n) {
        var r = t[n];
        il[e][n] = function(e) {
            var t = function(t) {
                if (null == t) return t;
                arguments.length > 1 && (t = Array.prototype.slice.call(arguments));
                var n = e(t);
                if ("object" == typeof n) for (var r = n.length, i = 0; i < r; i++) n[i] = Math.round(n[i]);
                return n;
            };
            return "conversion" in e && (t.conversion = e.conversion), t;
        }(r), il[e][n].raw = function(e) {
            var t = function(t) {
                return null == t ? t : (arguments.length > 1 && (t = Array.prototype.slice.call(arguments)), 
                e(t));
            };
            return "conversion" in e && (t.conversion = e.conversion), t;
        }(r);
    }));
}));

var sl = Ga, ol = il, al = [].slice, ll = [ "keyword", "gray", "hex" ], cl = {};

Object.keys(ol).forEach((function(e) {
    cl[al.call(ol[e].labels).sort().join("")] = e;
}));

var hl = {};

function dl(e, t) {
    if (!(this instanceof dl)) return new dl(e, t);
    if (t && t in ll && (t = null), t && !(t in ol)) throw new Error("Unknown model: " + t);
    var n, r;
    if (null == e) this.model = "rgb", this.color = [ 0, 0, 0 ], this.valpha = 1; else if (e instanceof dl) this.model = e.model, 
    this.color = e.color.slice(), this.valpha = e.valpha; else if ("string" == typeof e) {
        var i = sl.get(e);
        if (null === i) throw new Error("Unable to parse color from string: " + e);
        this.model = i.model, r = ol[this.model].channels, this.color = i.value.slice(0, r), 
        this.valpha = "number" == typeof i.value[r] ? i.value[r] : 1;
    } else if (e.length) {
        this.model = t || "rgb", r = ol[this.model].channels;
        var s = al.call(e, 0, r);
        this.color = ml(s, r), this.valpha = "number" == typeof e[r] ? e[r] : 1;
    } else if ("number" == typeof e) e &= 16777215, this.model = "rgb", this.color = [ e >> 16 & 255, e >> 8 & 255, 255 & e ], 
    this.valpha = 1; else {
        this.valpha = 1;
        var o = Object.keys(e);
        "alpha" in e && (o.splice(o.indexOf("alpha"), 1), this.valpha = "number" == typeof e.alpha ? e.alpha : 0);
        var a = o.sort().join("");
        if (!(a in cl)) throw new Error("Unable to parse color from object: " + JSON.stringify(e));
        this.model = cl[a];
        var l = ol[this.model].labels, c = [];
        for (n = 0; n < l.length; n++) c.push(e[l[n]]);
        this.color = ml(c);
    }
    if (hl[this.model]) for (r = ol[this.model].channels, n = 0; n < r; n++) {
        var h = hl[this.model][n];
        h && (this.color[n] = h(this.color[n]));
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha)), Object.freeze && Object.freeze(this);
}

function ul(e, t, n) {
    return (e = Array.isArray(e) ? e : [ e ]).forEach((function(e) {
        (hl[e] || (hl[e] = []))[t] = n;
    })), e = e[0], function(r) {
        var i;
        return arguments.length ? (n && (r = n(r)), (i = this[e]()).color[t] = r, i) : (i = this[e]().color[t], 
        n && (i = n(i)), i);
    };
}

function fl(e) {
    return function(t) {
        return Math.max(0, Math.min(e, t));
    };
}

function ml(e, t) {
    for (var n = 0; n < t; n++) "number" != typeof e[n] && (e[n] = 0);
    return e;
}

dl.prototype = {
    toString: function() {
        return this.string();
    },
    toJSON: function() {
        return this[this.model]();
    },
    string: function(e) {
        var t = this.model in sl.to ? this : this.rgb(), n = 1 === (t = t.round("number" == typeof e ? e : 1)).valpha ? t.color : t.color.concat(this.valpha);
        return sl.to[t.model](n);
    },
    percentString: function(e) {
        var t = this.rgb().round("number" == typeof e ? e : 1), n = 1 === t.valpha ? t.color : t.color.concat(this.valpha);
        return sl.to.rgb.percent(n);
    },
    array: function() {
        return 1 === this.valpha ? this.color.slice() : this.color.concat(this.valpha);
    },
    object: function() {
        for (var e = {}, t = ol[this.model].channels, n = ol[this.model].labels, r = 0; r < t; r++) e[n[r]] = this.color[r];
        return 1 !== this.valpha && (e.alpha = this.valpha), e;
    },
    unitArray: function() {
        var e = this.rgb().color;
        return e[0] /= 255, e[1] /= 255, e[2] /= 255, 1 !== this.valpha && e.push(this.valpha), 
        e;
    },
    unitObject: function() {
        var e = this.rgb().object();
        return e.r /= 255, e.g /= 255, e.b /= 255, 1 !== this.valpha && (e.alpha = this.valpha), 
        e;
    },
    round: function(e) {
        return e = Math.max(e || 0, 0), new dl(this.color.map(function(e) {
            return function(t) {
                return function(e, t) {
                    return Number(e.toFixed(t));
                }(t, e);
            };
        }(e)).concat(this.valpha), this.model);
    },
    alpha: function(e) {
        return arguments.length ? new dl(this.color.concat(Math.max(0, Math.min(1, e))), this.model) : this.valpha;
    },
    red: ul("rgb", 0, fl(255)),
    green: ul("rgb", 1, fl(255)),
    blue: ul("rgb", 2, fl(255)),
    hue: ul([ "hsl", "hsv", "hsl", "hwb", "hcg" ], 0, (function(e) {
        return (e % 360 + 360) % 360;
    })),
    saturationl: ul("hsl", 1, fl(100)),
    lightness: ul("hsl", 2, fl(100)),
    saturationv: ul("hsv", 1, fl(100)),
    value: ul("hsv", 2, fl(100)),
    chroma: ul("hcg", 1, fl(100)),
    gray: ul("hcg", 2, fl(100)),
    white: ul("hwb", 1, fl(100)),
    wblack: ul("hwb", 2, fl(100)),
    cyan: ul("cmyk", 0, fl(100)),
    magenta: ul("cmyk", 1, fl(100)),
    yellow: ul("cmyk", 2, fl(100)),
    black: ul("cmyk", 3, fl(100)),
    x: ul("xyz", 0, fl(100)),
    y: ul("xyz", 1, fl(100)),
    z: ul("xyz", 2, fl(100)),
    l: ul("lab", 0, fl(100)),
    a: ul("lab", 1),
    b: ul("lab", 2),
    keyword: function(e) {
        return arguments.length ? new dl(e) : ol[this.model].keyword(this.color);
    },
    hex: function(e) {
        return arguments.length ? new dl(e) : sl.to.hex(this.rgb().round().color);
    },
    rgbNumber: function() {
        var e = this.rgb().color;
        return (255 & e[0]) << 16 | (255 & e[1]) << 8 | 255 & e[2];
    },
    luminosity: function() {
        for (var e = this.rgb().color, t = [], n = 0; n < e.length; n++) {
            var r = e[n] / 255;
            t[n] = r <= .03928 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
        }
        return .2126 * t[0] + .7152 * t[1] + .0722 * t[2];
    },
    contrast: function(e) {
        var t = this.luminosity(), n = e.luminosity();
        return t > n ? (t + .05) / (n + .05) : (n + .05) / (t + .05);
    },
    level: function(e) {
        var t = this.contrast(e);
        return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
    },
    isDark: function() {
        var e = this.rgb().color;
        return (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3 < 128;
    },
    isLight: function() {
        return !this.isDark();
    },
    negate: function() {
        for (var e = this.rgb(), t = 0; t < 3; t++) e.color[t] = 255 - e.color[t];
        return e;
    },
    lighten: function(e) {
        var t = this.hsl();
        return t.color[2] += t.color[2] * e, t;
    },
    darken: function(e) {
        var t = this.hsl();
        return t.color[2] -= t.color[2] * e, t;
    },
    saturate: function(e) {
        var t = this.hsl();
        return t.color[1] += t.color[1] * e, t;
    },
    desaturate: function(e) {
        var t = this.hsl();
        return t.color[1] -= t.color[1] * e, t;
    },
    whiten: function(e) {
        var t = this.hwb();
        return t.color[1] += t.color[1] * e, t;
    },
    blacken: function(e) {
        var t = this.hwb();
        return t.color[2] += t.color[2] * e, t;
    },
    grayscale: function() {
        var e = this.rgb().color, t = .3 * e[0] + .59 * e[1] + .11 * e[2];
        return dl.rgb(t, t, t);
    },
    fade: function(e) {
        return this.alpha(this.valpha - this.valpha * e);
    },
    opaquer: function(e) {
        return this.alpha(this.valpha + this.valpha * e);
    },
    rotate: function(e) {
        var t = this.hsl(), n = t.color[0];
        return n = (n = (n + e) % 360) < 0 ? 360 + n : n, t.color[0] = n, t;
    },
    mix: function(e, t) {
        if (!e || !e.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof e);
        var n = e.rgb(), r = this.rgb(), i = void 0 === t ? .5 : t, s = 2 * i - 1, o = n.alpha() - r.alpha(), a = ((s * o == -1 ? s : (s + o) / (1 + s * o)) + 1) / 2, l = 1 - a;
        return dl.rgb(a * n.red() + l * r.red(), a * n.green() + l * r.green(), a * n.blue() + l * r.blue(), n.alpha() * i + r.alpha() * (1 - i));
    }
}, Object.keys(ol).forEach((function(e) {
    if (-1 === ll.indexOf(e)) {
        var t = ol[e].channels;
        dl.prototype[e] = function() {
            if (this.model === e) return new dl(this);
            if (arguments.length) return new dl(arguments, e);
            var n, r = "number" == typeof arguments[t] ? t : this.valpha;
            return new dl((n = ol[this.model][e].raw(this.color), Array.isArray(n) ? n : [ n ]).concat(r), e);
        }, dl[e] = function(n) {
            return "number" == typeof n && (n = ml(al.call(arguments), t)), new dl(n, e);
        };
    }
}));

var gl = Aa(dl);

const _l = "function" == typeof Object.assign, pl = [];

function vl(e) {
    if (_l) Object.assign.apply(Object, arguments); else for (let t = 1; t < arguments.length; t++) {
        const n = arguments[t];
        for (const t in n) e[t] = n[t];
    }
    return e;
}

function xl(e) {
    return null == e;
}

function yl(e) {
    return "number" == typeof e && !isNaN(e);
}

function bl(e) {
    return !xl(e) && ("function" == typeof e || null !== e.constructor && e.constructor === Function);
}

const wl = [];

function Tl(e, t) {
    const n = t._get2DExtentAtRes(t.getGLRes()), r = n.getWidth(), i = n.getHeight(), s = e;
    c.identity(s);
    const o = h.copy(pl, t.cameraLookAt);
    return o[2] = 0, c.translate(s, s, o), c.scale(s, s, h.set(wl, r, i, 1)), s;
}

function Sl(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
}

function Ml(e) {
    for (let t = 1; t < arguments.length; t++) {
        const n = arguments[t];
        if (n) for (let t = 0, r = n.length; t < r; t++) e.push(n[t]);
    }
    return e.length;
}

const Al = {};

function Cl(e, t) {
    if (!Array.isArray(t)) {
        const e = t;
        t = Al[e] = Al[e] || gl(t).unitArray();
    }
    for (let n = 0; n < t.length; n++) e[n] = t[n];
    return 3 === t.length && (e[3] = 1), e;
}

function kl(e, t) {
    if (!Array.isArray(t)) {
        const e = t;
        t = Al[e] = Al[e] || gl(t).unitArray();
    }
    for (let n = 0; n < t.length; n++) e[n] = 255 * t[n];
    return 3 === e.length && e.push(255), e;
}

function Ol(e, n, r = 0) {
    if (!(e && n instanceof t)) return null;
    const i = e.coordinateToPointAtRes(n, e.getGLRes());
    return [ i.x, i.y, r ];
}

const El = [ 0, 0 ], Pl = [ 0, 0, 0 ];

let Il;

class Rl {
    static getUniformDeclares() {
        const e = [], t = [];
        return t.push({
            name: "shadow_lightProjViewModelMatrix",
            type: "function",
            fn: function(t, n) {
                const r = n.shadow_lightProjViewMatrix, i = n.modelMatrix;
                return c.multiply(e, r, i);
            }
        }), t;
    }
    constructor(e, t) {
        this.renderer = new wr(e), this._esmShadowThreshold = .3, this._layer = t, this._init();
    }
    resize() {
        const e = this.canvas;
        e.width = this._layer.getRenderer().canvas.width, e.height = this._layer.getRenderer().canvas.height;
    }
    _init() {
        const e = (this._layer._getSceneConfig() || {}).shadow || {}, t = this._getShadowRes(), n = this.getDefines();
        this._shadowPass = new Yo(this.renderer, {
            width: t,
            height: t,
            blurOffset: e.blurOffset,
            defines: n
        }), this._shadowDisplayShader = new $o(n), this._createGround();
    }
    _getShadowRes() {
        let e = 2048;
        const t = ((this._layer._getSceneConfig() || {}).shadow || {}).quality;
        return "medium" === t ? e = 1024 : "low" === t && (e = 512), e;
    }
    getDefines() {
        return {
            "HAS_SHADOWING": 1,
            "PACK_FLOAT": 1,
            "USE_ESM": 1
        };
    }
    render(e, t, n, r, i, s, o, a, l, d) {
        this._transformGround();
        const u = this._layer.getMap(), f = this._getShadowRes();
        let m, g;
        if (d || f !== this._shadowPass.width || this._shadowChanged(u, o, !!e)) {
            f !== this._shadowPass.width && this._shadowPass.resize(f, f), this._tempMat0 = this._tempMat0 || [], 
            this._tempMat1 = this._tempMat1 || [];
            const r = c.multiply(this._tempMat0, t, n), i = h.normalize(this._tempMat1, s);
            Il || (Il = u.getContainerExtent());
            let a = u.height;
            u.getPitch() > 62 && (a = u._getVisualHeight(62));
            const l = Il.set(0, u.height - a, u.width, u.height).convertTo((e => u._containerPointToPointAtRes(e, u.getGLRes()))).toArray();
            e && o.addMesh(this._ground);
            const d = l.map((e => [ e.x, e.y, 0, 1 ])), {lightProjViewMatrix: _, shadowMap: p, blurFBO: v} = this._shadowPass.render(o, {
                cameraProjViewMatrix: r,
                lightDir: i,
                farPlane: d,
                cameraLookAt: u.cameraLookAt
            });
            m = this._lightProjViewMatrix = _, g = this._shadowMap = p, this._blurFBO = v, this._renderedShadows = o.getMeshes().reduce(((e, t) => (t.castShadow && t.geometry && (e[t.uuid] = {
                v0: t.version,
                v1: t.geometry.version
            }), e)), {}), this._renderedView = {
                count: o.getMeshes().length - +!!e,
                displayShadow: !!e
            }, this._updated = !0;
        } else m = this._lightProjViewMatrix, g = this._shadowMap, this._updated = !1;
        this._projMatrix = t, this._viewMatrix = n, xl(i) && (i = 1), e && o.getMeshes().length && this.displayShadow(r, i, a, l);
        return {
            "shadow_lightProjViewMatrix": m,
            "shadow_shadowMap": g,
            "shadow_opacity": i,
            "shadow_color": r || Pl,
            "esm_shadow_threshold": this._esmShadowThreshold
        };
    }
    displayShadow(e, t, n, r) {
        const i = this._lightProjViewMatrix, s = this._ground, o = this._groundLightProjViewModelMatrix || [], a = this._projViewMatrix || [], l = this._layer.getRenderer().canvas, h = this._texSize = this._texSize || [];
        h[0] = l.width, h[1] = l.height, this.renderer.render(this._shadowDisplayShader, {
            "halton": n || El,
            "globalTexSize": h,
            "projMatrix": this._projMatrix,
            "viewMatrix": this._viewMatrix,
            "projViewMatrix": c.multiply(a, this._projMatrix, this._viewMatrix),
            "shadow_lightProjViewModelMatrix": c.multiply(o, i, s.localTransform),
            "shadow_shadowMap": this._shadowMap,
            "esm_shadow_threshold": this._esmShadowThreshold,
            "shadow_opacity": t,
            "shadow_color": Pl,
            "color": e || Pl
        }, this._groundScene, r);
    }
    dispose() {
        this._shadowPass.dispose(), this._shadowDisplayShader.dispose(), this._ground && (this._ground.geometry.dispose(), 
        this._ground.dispose()), delete this.renderer;
    }
    isUpdated() {
        return !1 !== this._updated;
    }
    _shadowChanged(e, t, n) {
        if (!this._renderedShadows) return !0;
        const r = this._renderedView;
        if (t.getMeshes().length !== r.count || n !== r.displayShadow) return !0;
        const i = t.getMeshes();
        for (let e = 0; e < i.length; e++) {
            const t = this._renderedShadows[i[e].uuid];
            if (i[e].castShadow && (i[e].hasSkinAnimation() || !t || t.v0 !== i[e].version || t.v1 !== i[e].geometry.version)) return !0;
        }
        return !1;
    }
    _createGround() {
        const e = new Xr;
        e.generateBuffers(this.renderer.device), this._ground = new xr(e), this._groundScene = new Pr([ this._ground ]);
    }
    _transformGround() {
        const e = this._layer.getMap(), t = Tl(this._ground.localTransform, e);
        this._ground.setLocalTransform(t);
    }
}

const Ll = [ 0, 0 ], Fl = new e.Coordinate(0, 0), Hl = new e.Coordinate(0, 0), Dl = [], Nl = [], Bl = [];

function Ul(e, t, n, r) {
    const i = e.getGLRes(), s = e.distanceToPointAtRes(t, t, i, n ? Fl : null, Hl);
    return r ? s.y : s.x;
}

const {getIBLResOnCanvas: zl, logoutIBLResOnCanvas: Gl, getPBRUniforms: Vl, loginIBLResOnCanvas: jl} = Ta.PBRUtils, Wl = [ 0, 0 ], ql = [ 1, 1 ], Xl = [], Kl = [], Zl = [], Yl = [], $l = [];

class Jl {
    static getGroundTransform(e, t) {
        return Tl(e, t);
    }
    constructor(e, t) {
        this._regl = e, this.renderer = new wr(e), this._layer = t, this._loader = new Mr(null), 
        this._bindOnMaterialComplete = (...e) => this._onMaterialComplete.call(this, ...e), 
        this._init();
        const n = this.getMap().getRenderer().canvas;
        jl(n, e, this.getMap());
    }
    needToRedraw() {
        const e = this._getUVOffsetAnim();
        return e && (e[0] || e[1]);
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    getSymbol() {
        const e = this._layer.getGroundConfig();
        return e && e.symbol;
    }
    isEnable() {
        const e = this._layer.getGroundConfig();
        return e && e.enable;
    }
    paint(e) {
        if (!this.isEnable()) return !1;
        const t = this._getShader();
        if (this._isInSSRPhase(e) && t === this._fillShader) return !1;
        const n = this._getGroundDefines(e);
        n && this._ground.setDefines(n), this._ground.material !== this.material && this._ground.setMaterial(this.material);
        const r = this._layer.getGroundConfig();
        (r && r.symbol).ssr ? this._ground.ssr = 1 : this._ground.ssr = 0, this._transformGround();
        const i = this._getUniformValues(e);
        i.offsetFactor = e.offsetFactor, i.offsetUnits = e.offsetUnits;
        const s = e && e.renderTarget && e.renderTarget.fbo, o = this._layer.getRenderer();
        return t === this._fillShader ? (this.renderer.render(t, i, this._groundScene, s), 
        o.setCanvasUpdated && o.setCanvasUpdated(), !0) : (t.filter = e.sceneFilter, this.renderer.render(t, i, this._groundScene, s), 
        o.setCanvasUpdated && o.setCanvasUpdated(), !0);
    }
    _isInSSRPhase(e) {
        return !(!this._layer.getRenderer().isEnableSSR || !this._layer.getRenderer().isEnableSSR()) && !(!e || !e.ssr);
    }
    update() {
        const e = this._layer.getGroundConfig();
        if (!e) return;
        const t = e && e.symbol, n = e.urlModifier;
        if (t) {
            this._polygonFill = this._parseColor(t.polygonFill || [ 1, 1, 1, 1 ]), this._polygonOpacity = void 0 === t.polygonOpacity ? 1 : t.polygonOpacity;
            const e = t.polygonPatternFile;
            if (e) {
                if (!this._polygonPatternFile || this._polygonPatternFile._pattern_src !== e) {
                    const t = new Image;
                    t.onload = () => {
                        this._polygonPatternFile && this._polygonPatternFile.destroy(), this._polygonPatternFile = this._createPatternTexture(t), 
                        this._polygonPatternFile._pattern_src = e, this.setToRedraw();
                    }, t.src = n && n(e) || e;
                }
            } else this._polygonPatternFile && (this._polygonPatternFile.destroy(), delete this._polygonPatternFile);
        } else this._polygonFill = [ 1, 1, 1, 1 ], this._polygonOpacity = 1, this._polygonPatternFile && (this._polygonPatternFile.destroy(), 
        delete this._polygonPatternFile);
        this._updateMaterial();
    }
    setToRedraw() {
        const e = this._layer.getRenderer();
        e && e.setToRedraw();
    }
    dispose() {
        this.material && (this.material.dispose(), delete this.material), this._ground && (this._ground.geometry.dispose(), 
        this._ground.material && this._ground.material.dispose(), this._ground.dispose(), 
        delete this._ground), this._polygonPatternFile && (this._polygonPatternFile.destroy(), 
        delete this._polygonPatternFile), this._fillShader && (this._fillShader.dispose(), 
        delete this._fillShader), this._standardShader && (this._standardShader.dispose(), 
        delete this._standardShader), this._disposeIblTextures();
    }
    _getShader() {
        const e = this._layer.getGroundConfig();
        if (!e || !e.renderPlugin) return this._fillShader;
        const t = e.renderPlugin.type;
        if ("lit" === t) return this._standardShader;
        if ("fill" === t) return this._fillShader;
        throw new Error("unsupported render plugin of " + t + " for layer ground");
    }
    _getUniformValues(e) {
        const t = this._getCommonUniforms(e);
        t.polygonFill = this._polygonFill, t.polygonOpacity = this._polygonOpacity;
        return this._getShader() === this._fillShader && this._polygonPatternFile && (t.polygonPatternFile = this._polygonPatternFile), 
        t;
    }
    _getCommonUniforms(e) {
        let t;
        if ("lit" === this._layer.getGroundConfig().renderPlugin.type) {
            const n = this.getMap().getRenderer().canvas, {iblTexes: r, dfgLUT: i} = zl(n);
            t = Vl(this.getMap(), r, i, e && e.ssr, e && e.jitter);
        } else {
            t = {
                projViewMatrix: this.getMap().projViewMatrix
            };
        }
        return this._setIncludeUniformValues(t, e), t;
    }
    _setIncludeUniformValues(e, t) {
        const n = t && t.includes;
        if (n) for (const r in n) n[r] && t[r].renderUniforms && vl(e, t[r].renderUniforms);
    }
    _disposeIblTextures() {
        const e = this.getMap().getRenderer().canvas;
        Gl(e, this.getMap());
    }
    _init() {
        const e = this._getExtraCommandProps(), t = Rl.getUniformDeclares(), n = [];
        t.push({
            name: "projViewModelMatrix",
            type: "function",
            fn: function(e, t) {
                return c.multiply(n, t.projViewMatrix, t.modelMatrix);
            }
        }), this._fillShader = new Yi({
            name: "ground-fill",
            vert: "#define SHADER_NAME BACK_FILL\nattribute vec3 aPosition;\nuniform mat4 projViewModelMatrix;\nuniform mat4 modelMatrix;\n#ifdef HAS_PATTERN\nattribute vec2 aTexCoord;\nuniform vec2 uvScale;\nuniform vec2 uvOffset;\nvarying vec2 vTexCoord;\n#endif\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvoid main() {\n  \n#ifdef HAS_PATTERN\nvTexCoord = aTexCoord * uvScale + uvOffset;\n#endif\nvec3 c = vec3(aPosition);\n  gl_Position = projViewModelMatrix * vec4(c, 1.);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(vec4(c, 1.));\n#endif\n}",
            frag: "#define SHADER_NAME BACK_FILL\nprecision mediump float;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\n#ifdef HAS_PATTERN\nuniform sampler2D polygonPatternFile;\nvarying vec2 vTexCoord;\n#endif\nuniform vec4 polygonFill;\nuniform float polygonOpacity;\nvoid main() {\n  \n#ifdef HAS_PATTERN\nvec4 c = texture2D(polygonPatternFile, vTexCoord);\n#else\nvec4 c = polygonFill;\n#endif\ngl_FragColor = c * polygonOpacity;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat d = shadow_computeShadow();\n  gl_FragColor.rgb = shadow_blend(gl_FragColor.rgb, d);\n#endif\n}",
            wgslVert: "",
            wgslFrag: "",
            uniforms: t,
            extraCommandProps: e,
            defines: {}
        });
        const r = Rl.getUniformDeclares();
        r.push(...fs.getUniformDeclares()), this._standardShader = new Ta.StandardShader({
            uniforms: r,
            extraCommandProps: e
        }), this._createGround(), this.update();
    }
    _getExtraCommandProps() {
        const e = [ 0, 1 ], t = this._layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => t.width,
                height: () => t.height
            },
            cull: {
                enable: !0
            },
            depth: {
                enable: !0,
                mask: () => {
                    const e = this._layer.getGroundConfig();
                    return e.depth || void 0 === e.depth;
                },
                range: () => {
                    const t = this._layer.getGroundConfig(), n = t && t.renderPlugin.sceneConfig;
                    return n && n.depthRange || e;
                },
                func: "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: "src alpha",
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            polygonOffset: {
                enable: !0,
                offset: {
                    factor: (e, t) => t.offsetFactor,
                    units: (e, t) => t.offsetUnits
                }
            }
        };
    }
    _hasIBL() {
        const e = this.getMap().getLightManager();
        return !!(e && e.getAmbientResource());
    }
    _createGround() {
        const e = new Xr;
        e.data.aTexCoord = new Float32Array([ 0, 0, 1, 0, 0, 1, 1, 1 ]), e.createTangent(), 
        e.generateBuffers(this.renderer.device), this._ground = new xr(e, null, {
            castShadow: !1
        });
        const t = this._standardShader.getGeometryDefines(e);
        this._ground.setDefines(t), this._groundScene = new Pr([ this._ground ]);
    }
    _transformGround() {
        const e = this.getMap(), t = Jl.getGroundTransform(this._ground.localTransform, e);
        this._ground.setLocalTransform(t);
        const n = e.getGLRes(), r = e._get2DExtentAtRes(n), i = r.getWidth(), s = r.getHeight(), o = e.cameraLookAt, a = o[0] - i, l = o[1] - s, c = this._polygonPatternFile ? this._polygonPatternFile.width / this._polygonPatternFile.height : 1, h = this.getSymbol(), d = this.material ? this.material.get("textureOrigin") : h.polygonPatternFileOrigin, u = !!(this.material ? this.material.get("uvOffsetInMeter") : h.uvOffsetInMeter), m = (this.material ? this.material.get("uvOffset") : h.uvOffset) || Wl, g = this.material && this.material.get("uvScale") || ql, _ = this.material ? this.material.get("textureWidth") : h.polygonPatternFileWidth, p = this.material ? _ * (g[1] / g[0]) : h.polygonPatternFileHeight, v = this._getUVOffsetAnim(), [x, y, b, w, T] = function(e, t, n, r, i, s, o, a, l, c, h) {
            const d = e.getGLRes();
            r && (Fl.set(r[0], r[1]), e.coordToPointAtRes(Fl, d, Hl), t -= Hl.x, n -= Hl.y);
            const u = r ? Fl : null;
            c = f.copy(Nl, c);
            const m = !l && c || Ll;
            let g = l && c || Ll;
            g = f.copy(Dl, g), g[0] && (g[0] = Ul(e, g[0], u)), g[1] && (g[1] = Ul(e, g[1], u, 1));
            let _ = .5;
            i && (_ = Ul(e, i, u));
            let p = _ / o;
            if (s && (p = Ul(e, s, u, 1)), h && (h[0] || h[1])) {
                const t = performance.now() / 1e3;
                let n = h[0], r = h[1];
                l && (n = -Ul(e, h[0], u), r = -Ul(e, h[1], u, 1)), h[0] && (l ? g[0] = t * n : m[0] = t * n), 
                h[1] && (l ? g[1] = t * r : m[1] = t * r);
            }
            const v = (t + g[0]) / (_ / a[0]), x = (n - g[1]) / (p / a[1]);
            return Bl[0] = _ / a[0], Bl[1] = p / a[1], Bl[2] = v, Bl[3] = x, Bl[4] = m, Bl;
        }(e, a, l, d, _, p, c, g, u, m, v), S = 2 * r.getWidth() / x, M = 2 * r.getHeight() / y;
        if (!this.material) return this._ground.setUniform("uvScale", f.set(Xl, S, M)), 
        void this._ground.setUniform("uvOffset", f.set(Kl, b % 1 + T[0], w % 1 + T[1]));
        this._ground.setUniform("uvScale", f.set($l, S, M)), this._ground.setUniform("uvOffset", f.set(Zl, b % 1 + T[0], w % 1 + T[1])), 
        this._ground.setUniform("uvOrigin", f.set(Yl, b - b % 1, w - w % 1)), this._ground.setUniform("uvRotation", 0);
    }
    _getGroundDefines(e) {
        let t = !1;
        const n = this._ground.defines, r = this._layer._getSceneConfig && this._layer._getSceneConfig(), i = this._layer.getGroundConfig();
        function s(e, r) {
            e ? n[r] || (n[r] = 1, t = !0) : n[r] && (delete n[r], t = !0);
        }
        s(this._hasIBL(), "HAS_IBL_LIGHTING");
        s(e && e.ssr && i && i.symbol && i.symbol.ssr, "HAS_SSR");
        const o = e && r && r.shadow && r.shadow.enable;
        s(o, "HAS_SHADOWING"), s(o, "USE_ESM");
        return s(!!this._polygonPatternFile, "HAS_PATTERN"), t ? n : null;
    }
    _updateMaterial() {
        const e = this.getSymbol() && this.getSymbol().material || {}, t = {};
        let n = !1;
        const r = this._layer.getGroundConfig();
        this._loader.setURLModifier(r.urlModifier);
        for (const r in e) if (Sl(e, r)) if (r.indexOf("Texture") > 0) {
            let i = e[r];
            if (!i) continue;
            i = "string" == typeof i ? {
                url: i,
                wrap: "repeat"
            } : i, i.flipY = !0, i.min = "linear mipmap linear", i.mag = "linear", i.flipY = !0, 
            t[r] = new qr(i, this._loader), n = !0;
        } else t[r] = e[r];
        this.material ? (this._loadingMaterial = new Ta.StandardMaterial(t), this._loadingMaterial.isReady() ? this._onMaterialComplete() : this._loadingMaterial.once("complete", this._bindOnMaterialComplete)) : (this.material = new Ta.StandardMaterial(t), 
        this.material.once("complete", this._bindOnMaterialComplete, this)), n || this._onMaterialComplete();
    }
    _onMaterialComplete() {
        this._loadingMaterial && (this.material.dispose(), this.material = this._loadingMaterial, 
        delete this._loadingMaterial), this.setToRedraw();
    }
    _createPatternTexture(e) {
        e = Z(e);
        const t = this._regl, n = {
            width: e.width,
            height: e.height,
            data: e,
            mag: "linear",
            min: "linear mipmap linear",
            flipY: !0,
            wrap: "repeat"
        };
        return t.texture(n);
    }
    _parseColor(e) {
        return Cl([], e);
    }
    _getUVOffsetAnim() {
        return this.material && this.material.get("uvOffsetAnim");
    }
    getRenderMeshes() {
        return this._groundScene.getMeshes();
    }
}

const {createIBLTextures: Ql, disposeIBLTextures: ec} = Ta.PBRUtils, tc = [ 0, 0, 0 ], nc = [], rc = [];

class ic {
    constructor(e, t) {
        this._maxLevel = 4, this._regl = e, this.renderer = new wr(e), this._layer = t, 
        this._init(), this._updateMode();
    }
    paint(e) {
        if (!this.isEnable() || !this._resource) return;
        const t = this._getUniformValues(e), n = e && e.renderTarget && e.renderTarget.fbo;
        this.renderer.render(this._shader, t, null, n);
    }
    update() {
        const e = this.getMap();
        if (!e || !this.isEnable()) return;
        const t = e.getLightManager(), n = t && t.getAmbientResource();
        n !== this._resource && this._iblTexes && (ec(this._iblTexes), delete this._iblTexes), 
        this._resource = n, this._updateMode();
    }
    dispose() {
        this._shader.dispose(), ec(this._iblTexes), delete this._shader, delete this._iblTexes, 
        delete this._resource;
    }
    getMap() {
        return this._layer.getMap();
    }
    _updateMode() {
        if (!this._resource) return;
        const e = this._layer._getSceneConfig().environment || {};
        this._shader.setMode(e.toneMapping, e.mode ? 1 : 0);
    }
    isEnable() {
        const e = this._layer._getSceneConfig();
        return this._hasIBL() && e && e.environment && e.environment.enable;
    }
    _hasIBL() {
        const e = this.getMap().getLightManager();
        return !!(e && e.getAmbientResource());
    }
    _getUniformValues() {
        const e = this.getMap(), t = this.getMap().getLightManager(), n = t && t.getAmbientLight();
        let r = this._iblTexes;
        r || (r = this._iblTexes = Ql(this._regl, e));
        const i = this._layer.getRenderer().canvas, s = this._layer._getSceneConfig().environment || {}, o = s.level || 0, a = r.prefilterMap.width, l = this._transform = this._transform || [], c = n && n.hsv || tc, d = s.brightness || 0, f = s.intensity || 1;
        return h.copy(nc, c), d && (nc[2] += d), rc[0] = i.width, rc[1] = i.height, {
            "cubeMap": r.prefilterMap,
            "bias": o,
            "size": a / Math.pow(2, Math.max(0, o - 1)),
            "environmentExposure": yl(n && n.exposure) ? n.exposure : 1,
            "backgroundIntensity": f,
            "diffuseSPH": r.sh,
            "viewMatrix": e.viewMatrix,
            "projMatrix": e.projMatrix,
            "resolution": rc,
            "hsv": nc,
            "transformMatrix": u.fromRotation(l, n && Math.PI / 180 * -n.orientation || 0)
        };
    }
    _init() {
        const e = this.getMap();
        if (e.on("updatelights", this.update, this), this._shader = new ps, e.options.lights) {
            const e = this.getMap().getLightManager().getAmbientResource();
            this._resource = e;
        }
    }
}

const sc = [], oc = [ .03, .03, .03 ], ac = [], lc = [], cc = [], hc = [ 1, 1, 1 ], dc = [ -1200, -1200, 0 ], uc = [ 1200, 1200, 1e3 ], fc = {
    min: [],
    max: []
}, mc = c.fromRotationTranslation([], m.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class gc {
    constructor(e, t) {
        this._regl = e, this.renderer = new wr(e), this._layer = t, this._timer = new _c, 
        this._init();
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    _init() {
        const e = this._layer.getRenderer().canvas, t = {
            x: 0,
            y: 0,
            width: () => e.width,
            height: () => e.height
        };
        this._shader = new Yi({
            vert: "attribute vec3 aPosition;\nattribute vec3 aNormal;\nattribute vec2 aTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform vec3 cameraPosition;\nuniform float top;\nuniform float bottom;\nuniform float time;\nvarying vec2 vTexCoord;\n#include <get_output>\nfloat c(float x, float y) {\n  return atan(y, x);\n}\nvec2 d(vec2 e, vec2 f, vec2 h) {\n  vec2 i = vec2(.0);\n  float j = distance(h, f);\n  float a = c(e.x - f.x, e.y - f.y);\n  h.x > f.x ? a -= .785 : a += .785;\n  i.x = cos(a) * j;\n  i.y = sin(a) * j;\n  return i + f;\n  return i;\n}\nvoid main() {\n  vec4 k = getPosition(aPosition);\n  mat4 l = getPositionMatrix();\n  vec2 m = d(vec2(cameraPosition.x, cameraPosition.z), vec2(aNormal.x, aNormal.z), vec2(k.x, k.z));\n  float n = top - bottom;\n  float y = aNormal.y - bottom - n * time;\n  y = y + (y < .0 ? n : .0);\n  float o = (1. - y / n) * (1. - y / n);\n  y = n * (1. - o);\n  y += bottom;\n  y += aPosition.y - aNormal.y;\n  k = vec4(m.x, y, m.y, 1.);\n  gl_Position = projMatrix * modelViewMatrix * l * k;\n  vTexCoord = aTexCoord;\n}",
            frag: "precision mediump float;\nvarying vec2 vTexCoord;\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D rainMap;\nvoid main() {\n  vec4 c = texture2D(rainMap, vTexCoord);\n  vec4 d = vec4(diffuse, opacity);\n  d *= c;\n  gl_FragColor = d;\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(sc, t.viewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: t,
                depth: {
                    enable: !0,
                    mask: !1,
                    func: "less",
                    range: [ 0, 1 ]
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "src alpha",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        }), this._createScene();
    }
    _createScene() {
        const e = this._regl.texture({
            width: 2,
            height: 2
        });
        if (this._mesh = this._createRain(), !this._mesh) return;
        this._scene = new Pr(this._mesh);
        const t = this._getRainConfig();
        t.rainTexture ? this._creatRainTexture(t.rainTexture).then((e => {
            this._mesh.material.set("rainMap", e);
        })) : (this._mesh.material.set("rainMap", e), console.warn("should set rain texture."));
    }
    _createRain() {
        const e = this.getMap(), t = this._getRainConfig();
        if (!t) return null;
        this._fixZoom = e.getZoom();
        const n = this._getFixExtent(), r = this._rainDensity = t.density, i = this._rainWidth = t.rainWidth || 1, s = this._rainHeight = t.rainHeight || 1, o = [], a = [], l = [], c = [];
        for (let e = 0; e < r; e++) {
            const t = {};
            t.x = Math.random() * (n.max[0] - n.min[0]) + n.min[0], t.y = Math.random() * (n.max[2] - n.min[2]) + n.min[2], 
            t.z = Math.random() * (n.max[1] - n.min[1]) + n.min[1];
            const r = (n.max[2] - n.min[2]) / 37.5 * s, h = r / 3 * i;
            o.push(t.x + h, t.y + r, t.z, t.x - h, t.y + r, t.z, t.x - h, t.y, t.z, t.x + h, t.y, t.z), 
            a.push(t.x, t.y - r / 2, t.z, t.x, t.y - r / 2, t.z, t.x, t.y - r / 2, t.z, t.x, t.y - r / 2, t.z), 
            l.push(1, 1, 0, 1, 0, 0, 1, 0), c.push(4 * e + 0, 4 * e + 1, 4 * e + 2, 4 * e + 0, 4 * e + 2, 4 * e + 3);
        }
        const h = {};
        h.POSITION = o, h.NORMAL = a, h.TEXCOORD_0 = l;
        const d = new Ye(h, c, 0, {
            primitive: "triangles",
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        d.generateBuffers(this.renderer.device);
        const u = new Ft({
            rainMap: this._regl.texture({
                width: 2,
                height: 2
            }),
            diffuse: t.color || [ 1, 1, 1 ],
            opacity: t.opacity || 1
        }), f = new xr(d, u);
        return f.setUniform("top", n.max[2]), f.setUniform("bottom", n.min[2]), this._transformRain(f), 
        f.transparent = !0, f;
    }
    _creatRainTexture(e) {
        const t = new Image;
        return t.src = this._rainTexture = e, new Promise(((e, n) => {
            t.onload = () => {
                const n = this._regl.texture({
                    mag: "linear",
                    min: "linear mipmap nearest",
                    wrapS: "clamp",
                    wrapT: "clamp",
                    data: t
                });
                e(n);
            }, t.onerror = e => {
                n(e);
            };
        }));
    }
    paint(e) {
        if (!this._scene) return;
        const t = this._getRainConfig(), n = {}, r = this.getMap();
        n.projMatrix = r.projMatrix, n.viewMatrix = r.viewMatrix, n.cameraPosition = r.cameraPosition;
        const i = t.speed || 1, s = this._timer.getElapsedTime() / (2 / i) % 1;
        n.time = s, this._mesh.material.set("diffuse", t.color || hc), this._mesh.material.set("opacity", t.opacity || 1), 
        this._transformRain(this._mesh);
        const o = e && e.renderTarget && e.renderTarget.fbo;
        this.renderer.render(this._shader, n, this._scene, o), this._layer.getRenderer().setCanvasUpdated();
    }
    _transformRain(e) {
        const t = this.getMap(), n = t.coordinateToPointAtRes(t.getCenter(), t.getGLRes()), r = t.getGLScale() / t.getGLScale(this._fixZoom), i = h.set(lc, r, r, r), s = h.multiply(i, oc, i), o = c.identity(cc), a = this._getRainConfig(), l = t.getBearing();
        c.fromRotationTranslationScale(o, m.fromEuler(ac, a.windDirectionX || 0, a.windDirectionY || 0, 90 - l), [ n.x, n.y, 0 ], s), 
        c.multiply(o, o, mc), e.setLocalTransform(o);
    }
    setToRedraw() {
        const e = this._layer.getRenderer();
        e && e.setToRedraw();
    }
    update() {
        const e = this._getRainConfig();
        if (e) {
            if (this._mesh || this._createScene(), e.density !== this._rainDensity || e.rainWidth !== this._rainWidth || e.rainHeight !== this._rainHeight) {
                const e = this._mesh.material.get("rainMap");
                this._mesh.geometry.dispose(), this._mesh.dispose(), this._scene.clear(), this._mesh = this._createRain(), 
                this._mesh.material.set("rainMap", e), this._scene.setMeshes(this._mesh);
            }
            e.rainTexture !== this._rainTexture && this._creatRainTexture(e.rainTexture).then((e => {
                this._mesh.material.set("rainMap", e);
            }));
        }
    }
    dispose() {
        this._mesh && (this._mesh.geometry.dispose(), this._mesh.material && this._mesh.material.dispose(), 
        this._mesh.dispose(), delete this._mesh), this._shader && (this._shader.dispose(), 
        delete this._shader);
    }
    isEnable() {
        const e = this._getRainConfig();
        return e && e.enable;
    }
    _getRainConfig() {
        const e = this._layer.getWeatherConfig();
        return e && e.rain;
    }
    _getFixExtent() {
        const e = 16.685648411389433 - this.getMap().getZoom();
        return h.scale(fc.min, dc, Math.pow(2, e)), h.scale(fc.max, uc, Math.pow(2, e)), 
        fc;
    }
}

class _c {
    constructor(e) {
        this.autoStart = void 0 === e || e, this.startTime = 0, this.oldTime = 0, this.elapsedTime = 0, 
        this.running = !1;
    }
    start() {
        this.startTime = ("undefined" == typeof performance ? Date : performance).now(), 
        this.oldTime = this.startTime, this.elapsedTime = 0, this.running = !0;
    }
    stop() {
        this.getElapsedTime(), this.running = !1, this.autoStart = !1;
    }
    getElapsedTime() {
        return this.getDelta(), this.elapsedTime;
    }
    getDelta() {
        let e = 0;
        if (this.autoStart && !this.running) return this.start(), 0;
        if (this.running) {
            const t = ("undefined" == typeof performance ? Date : performance).now();
            e = (t - this.oldTime) / 1e3, this.oldTime = t, this.elapsedTime += e;
        }
        return 0;
    }
}

const pc = [], vc = [ .03, .03, .03 ], xc = [], yc = [], bc = [], wc = c.fromRotationTranslation([], m.fromEuler([], 90, 0, 0), [ 0, 0, 0 ]);

class Tc {
    constructor(e, t) {
        this._regl = e, this._layer = t, this._init();
    }
    _init() {
        const e = this._layer.getRenderer().canvas, t = {
            x: 0,
            y: 0,
            width: () => e.width,
            height: () => e.height
        };
        this._shader = new Yi({
            vert: "#include <gl2_vert>\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\n#include <get_output>\nvoid main() {\n  mat4 c = getPositionMatrix();\n  vec4 d = getPosition(aPosition);\n  gl_Position = projMatrix * modelViewMatrix * c * d;\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nprecision mediump float;\nuniform sampler2D perlinTexture;\nvarying vec2 vTexCoord;\nfloat c(float a, float b, float w) {\n  return a + w * (b - a);\n}\nvoid main() {\n  float d = texture2D(perlinTexture, vTexCoord).r;\n  vec3 e = vec3(1.);\n  float r = c(.5, e.x, d);\n  float g = c(.5, e.y, d);\n  float b = c(.5, e.z, d);\n  glFragColor = vec4(r, g, b, 1.);\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            uniforms: [ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(pc, t.viewMatrix, t.modelMatrix);
                }
            } ],
            extraCommandProps: {
                viewport: t
            }
        }), this._shader.version = 300, this._scene = new Pr, this._groundMask = this._createGroundMask(), 
        this._scene.setMeshes(this._groundMask), this.renderer = new wr(this._regl);
        const n = this._getSnowConfig();
        n && (n.snowGroundTexture ? this._createSnowTexture(n.snowGroundTexture) : (this._groundNormal = this._regl.texture({
            width: 2,
            height: 2
        }), console.warn("should set snow ground texture.")));
    }
    render(e) {
        this._groundNormal && this._groundMask.material.set("perlinTexture", this._groundNormal);
        const t = this._layer.getMap();
        this._transformMask(t);
        const n = {
            projMatrix: t.projMatrix,
            viewMatrix: t.viewMatrix,
            cameraPosition: t.cameraPosition
        }, r = e && e.renderTarget && e.renderTarget.fbo;
        this.renderer.render(this._shader, n, this._scene, r), this._layer.getRenderer().setCanvasUpdated();
    }
    _transformMask(e) {
        const t = e.coordinateToPointAtRes(e.getCenter(), e.getGLRes()), n = e.getGLScale() / e.getGLScale(this._fixZoom), r = h.set(yc, n, n, n), i = h.multiply(r, vc, r), s = c.identity(bc);
        c.fromRotationTranslationScale(s, m.fromEuler(xc, 0, 0, 0), [ t.x, t.y, .005 ], i), 
        c.multiply(s, s, wc), this._groundMask.setLocalTransform(s);
    }
    _createSnowTexture(e) {
        const t = new Image;
        t.onload = () => {
            this._groundNormal = this._regl.texture({
                mag: "linear",
                min: "linear mipmap nearest",
                wrapS: "repeat",
                wrapT: "repeat",
                data: t
            });
        }, t.onerror = e => {
            console.log(e);
        }, t.src = this._snowGroundTexture = e;
    }
    _createGroundMask() {
        const e = this._layer.getMap();
        this._fixZoom = e.getZoom();
        const t = 16e3 * Math.pow(2, 16.685648411389433 - this._fixZoom), n = [ -t, 0, -t, t, 0, -t, -t, 0, t, t, 0, t ], r = {};
        r.POSITION = n, r.NORMAL = [ 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0 ], r.TEXCOORD_0 = [ 0, 0, 1, 0, 0, 1, 1, 1 ];
        const i = new Ye(r, [ 3, 1, 0, 0, 2, 3 ], 0, {
            positionAttribute: "POSITION",
            normalAttribute: "NORMAL",
            uv0Attribute: "TEXCOORD_0"
        });
        i.generateBuffers(this._regl);
        const s = new Ft({
            perlinTexture: this._regl.texture({
                width: 2,
                height: 2
            })
        });
        return new xr(i, s);
    }
    getMeshes() {
        return this._groundMask;
    }
    dispose() {
        this._groundMask && (this._groundMask.geometry.dispose(), this._groundMask.material && this._groundMask.material.dispose(), 
        this._groundMask.dispose(), delete this._groundMask), this._shader && (this._shader.dispose(), 
        delete this._shader);
    }
    update() {
        const e = this._getSnowConfig();
        e && e.snowGroundTexture === !this._snowGroundTexture && this._createSnowTexture(e.snowGroundTexture);
    }
    isEnable() {
        const e = this._getSnowConfig();
        return e && e.enable;
    }
    _getSnowConfig() {
        const e = this._layer.getWeatherConfig();
        return e && e.snow;
    }
}

const Sc = [];

class Mc {
    constructor(e, t, n) {
        this._regl = e, this._layer = t, this._config = n, this._init();
    }
    _init() {
        this.renderer = new wr(this._regl);
        const e = this._layer.getRenderer(), t = this._viewport = {
            x: 0,
            y: 0,
            width: () => e.canvas ? e.canvas.width : 1,
            height: () => e.canvas ? e.canvas.height : 1
        };
        this._width = t.width, this._height = t.height, this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: e.canvas ? e.canvas.width : 1,
                height: e.canvas ? e.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this._regl.texture({
            width: 2,
            height: 2
        }), this._rainPainter = new gc(this._regl, this._layer), this._rainRipplesPass = new Is(this._regl, t), 
        this._snowPainter = new Tc(this._regl, this._layer), this._fogPass = new Ss(this._regl, t, this._layer), 
        this._weatherShader = new Ms, this._weatherShader.version = 300;
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    renderScene(e) {
        this.renderSnowMask(e), this.renderRain(e);
    }
    renderRain(e) {
        this.isEnableRain() && this._rainPainter.paint(e);
    }
    renderSnowMask(e) {
        if (!this.isEnableSnow() || !this._showSnowGround()) return;
        const t = this.getMap();
        this._snowPainter.render(e, t);
    }
    paint(e, t) {
        if (!t || !t.length) return e;
        this._resize();
        const n = this._layer.getWeatherConfig(), r = {};
        if (this.isEnableRain() ? (r.ripplesMap = this._renderRainRipples(), this._weatherShader.shaderDefines.HAS_RAIN = 1) : delete this._weatherShader.shaderDefines.HAS_RAIN, 
        this.isEnableSnow() ? (this._weatherShader.shaderDefines.HAS_SNOW = 1, r.snowIntensity = I(n.snow.snowIntensity) ? n.snow.snowIntensity : .5, 
        t.forEach((e => {
            e.defines.HAS_SNOW = 1;
        }))) : (delete this._weatherShader.shaderDefines.HAS_SNOW, t.forEach((e => {
            delete e.defines.HAS_SNOW;
        }))), this.isEnableFog()) {
            const e = n.fog;
            r.fogColor = e.color || [ .9, .9, .9 ], this._weatherShader.shaderDefines.HAS_FOG = 1;
        } else delete this._weatherShader.shaderDefines.HAS_FOG;
        return this._weatherShader.setDefines(this._weatherShader.shaderDefines), r.mixFactorMap = this._renderMixFactor(t) || this.EMPTY_TEXTURE, 
        r.sceneMap = e, r.time = this._getTimeSpan() / 1e3, r.resolution = f.set(Sc, this._fbo.width, this._fbo.height), 
        this.renderer.render(this._weatherShader, r, null, this._fbo), this._renderMeshes = t, 
        this._fbo;
    }
    _renderMixFactor(e) {
        const t = {}, n = this.getMap(), r = n.getZoom(), i = Math.pow(2, 16.685648411389433 - r), s = this._layer.getWeatherConfig(), o = s.fog;
        if (!o || !o.enable) return null;
        const a = o.start || .1, l = o.end || 100;
        t.projMatrix = n.projMatrix, t.viewMatrix = n.viewMatrix, t.cameraPosition = n.cameraPosition, 
        t.fogDist = [ a * i, l * i ], t.rainDepth = n.altitudeToPoint(s.rain && s.rain.rainDepth || .1, n.getGLRes());
        const c = this._fogPass.render(e, t);
        return this._layer.getRenderer()._getFBOColor(c);
    }
    _renderRainRipples() {
        const e = this.getMap(), t = this._layer.getWeatherConfig(), n = t.rain.rippleRadius || 24, r = {};
        r.projMatrix = e.projMatrix, r.viewMatrix = e.viewMatrix, r.time = this._getTimeSpan() / 1e3, 
        r.rippleRadius = n, r.density = t.rain.density || 2e3;
        return this._rainRipplesPass.render(e, r);
    }
    _getTimeSpan() {
        if (!this._layer) return 0;
        if (void 0 === this._currentFrameTime && (this._currentFrameTime = 0), this.isPlaying()) {
            const e = this._layer.getRenderer();
            this._currentFrameTime = e.getFrameTime();
        }
        return this._currentFrameTime;
    }
    isEnable() {
        const e = this._layer.getWeatherConfig();
        return e && e.enable;
    }
    isEnableRain() {
        const e = this._layer.getWeatherConfig();
        return e && e.enable && e.rain && e.rain.enable;
    }
    isEnableFog() {
        const e = this._layer.getWeatherConfig();
        return e && e.enable && e.fog && e.fog.enable;
    }
    isEnableSnow() {
        const e = this._layer.getWeatherConfig();
        return e && e.enable && e.snow && e.snow.enable;
    }
    _showSnowGround() {
        const e = this._layer.getWeatherConfig();
        return this.isEnableSnow() && !1 === e.snow.showGround;
    }
    isPlaying() {
        const e = this._layer.getWeatherConfig();
        return !!e && !1 !== e.playing;
    }
    _hasWeather() {
        return this.isEnableRain() || this.isEnableFog() || this.isEnableSnow();
    }
    update() {
        !this.isEnable() && this._renderMeshes && this._renderMeshes.forEach((e => {
            delete e.defines.HAS_SNOW, delete e.defines.HAS_RAIN, delete e.defines.HAS_FOG;
        })), this.isEnableRain() && (this._rainPainter = this._rainPainter || new gc(this._regl, this._layer), 
        this._rainPainter.update()), this.isEnableSnow() && (this._snowPainter = this._snowPainter || new Tc(this._regl, this._layer), 
        this._snowPainter.update());
    }
    getShadowMeshes() {
        return this._snowPainter.getMeshes();
    }
    _resize() {
        const e = this._width(), t = this._height();
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._weatherShader && (this._weatherShader.dispose(), 
        delete this._weatherShader), this._rainPainter && (this._rainPainter.dispose(), 
        delete this._rainPainter), this._snowPainter && (this._snowPainter.dispose(), delete this._snowPainter);
    }
}

const Ac = [], Cc = e => !!e.bloom, kc = e => !!e.ssr;

class Oc {
    constructor(e, t) {
        this._regl = e, this._layer = t, this._renderer = new wr(e), this._fxaaShader = new ts, 
        this._copyShader = new xs, this._ssrPass = new fs(this._regl);
    }
    setContextIncludes() {}
    bloom(e, t, n, r, i, s, o) {
        this._bloomPass || (this._bloomPass = new ds(this._regl));
        const a = this._layer.getRenderer()._getFBOColor(this._bloomFBO);
        return this._bloomPass.render(e, a, r, i, s, t, n, o);
    }
    drawBloom(e) {
        const t = this._layer.getRenderer(), n = this._regl, r = this._bloomFBO;
        if (r) {
            const {width: t, height: i} = e;
            r.width === t && r.height === i || r.resize(t, i), n.clear({
                color: [ 0, 0, 0, 0 ],
                framebuffer: r
            });
        } else {
            const t = this._createFBOInfo(e);
            this._bloomFBO = n.framebuffer(t);
        }
        const i = t.getFrameTime(), s = t.getFrameEvent(), o = t.getFrameContext(), a = o.renderMode, l = o.sceneFilter, c = o.renderTarget;
        return o.isPostProcess = !0, o.renderMode = "default", o.sceneFilter = Cc, o.renderTarget = {
            fbo: this._bloomFBO,
            getFramebuffer: Ec,
            getDepthTexture: Pc
        }, t.resetDrawCalls(), s ? t.forEachRenderer((e => {
            t.clearStencil(e, r), e.drawOnInteracting(s, i, o);
        })) : t.forEachRenderer((e => {
            t.clearStencil(e, r), e.draw(i, o);
        })), delete o.isPostProcess, o.renderMode = a, o.sceneFilter = l, o.renderTarget = c, 
        t.getDrawCalls();
    }
    genSsrMipmap(e, t) {
        const n = this._layer.getMap().projViewMatrix;
        this._ssrPass.genMipMap(e, t, n);
    }
    getPrevSsrProjViewMatrix() {
        return this._ssrPass && this._ssrPass.getPrevProjViewMatrix();
    }
    drawSSR(e, t, n) {
        n && this._ssrPass.copyDepthTex(e);
        const r = this._layer.getRenderer(), i = r.getFrameTime(), s = r.getFrameEvent(), o = r.getFrameContext();
        o.isPostProcess = !0, o.ssr = this.getSSRContext();
        const a = o.renderMode, l = o.sceneFilter;
        o.renderMode = "default", o.sceneFilter = kc, o.renderTarget.fbo = t;
        let c = !1;
        s ? r.forEachRenderer((e => {
            r.clearStencil(e, t), c || (r.resetDrawCalls(), c = !0), e.drawOnInteracting(s, i, o);
        })) : r.forEachRenderer((e => {
            r.clearStencil(e, t), c || (r.resetDrawCalls(), c = !0), e.draw(i, o);
        }));
        const h = r.drawGround();
        return delete o.ssr, delete o.isPostProcess, o.renderMode = a, o.sceneFilter = l, 
        this._ssrPainted = r.getDrawCalls() > 0, h;
    }
    getSSRUniforms() {
        const e = this._layer._getSceneConfig(), t = e && e.postProcess, n = this._layer.getMap();
        return this._ssrPass.getSSRUniforms(n, t.ssr.factor, t.ssr.quality);
    }
    getSSRContext() {
        const e = this._layer._getSceneConfig(), t = e && e.postProcess, n = this._layer.getMap(), r = this._ssrPass.getSSRUniforms(n, t.ssr.factor, t.ssr.quality);
        if (!r) return null;
        return {
            renderUniforms: r,
            defines: {
                "HAS_SSR": 1
            }
        };
    }
    fxaa(e, t, n, r, i, s, o, a, l, c, h, d) {
        !e || e.width === t.fbo && e.height === t.height || e.resize(t.width, t.height);
        const u = {};
        a ? u.HAS_OUTLINE_TEX = 1 : delete u.HAS_OUTLINE_TEX;
        !0 === this._layer.options.antialias ? u.HAS_MULTISAMPLED = 1 : delete u.HAS_MULTISAMPLED, 
        this._fxaaShader.setDefines(u), this._renderer.render(this._fxaaShader, {
            textureSource: t,
            resolution: f.set(Ac, t.width, t.height),
            enableFXAA: n,
            enableToneMapping: r,
            enableSharpen: i,
            pixelRatio: s,
            sharpFactor: o,
            textureOutline: a,
            highlightFactor: l,
            outlineFactor: c,
            outlineWidth: h,
            outlineColor: d
        }, null, e);
    }
    renderFBOToScreen(e, t, n, r) {
        this._copyFBOSize || (this._copyFBOSize = []), this._copyFBOSize[0] = e.width, this._copyFBOSize[1] = e.height;
        const i = {}, s = this._layer.getRenderer(), o = e.color && s._getFBOColor(e) || e;
        o.texture && o.texture.sampleCount > 1 ? i.HAS_MULTISAMPLED = 1 : delete i.HAS_MULTISAMPLED, 
        this._copyShader.setDefines(i), this._renderer.render(this._copyShader, {
            texture: o,
            size: this._copyFBOSize,
            enableSharpen: +!!t,
            sharpFactor: n,
            pixelRatio: r
        });
    }
    postprocess(e, t, n) {
        this._postProcessShader || (this._postProcessShader = new ss);
        const r = this._layer && this._layer.getRenderer(), i = n || r._getFBOColor(e);
        return t.resolution = f.set(Ac, i.width, i.height), t.textureSource = i, t.timeGrain = performance.now(), 
        this._renderer.render(this._postProcessShader, t), this._target;
    }
    dispose() {
        this._bloomFBO && (this._bloomFBO.destroy(), delete this._bloomFBO), this._bloomPass && (this._bloomPass.dispose(), 
        delete this._bloomPass), this._postProcessShader && (this._postProcessShader.dispose(), 
        delete this._postProcessShader), this._fxaaShader && (this._fxaaShader.dispose(), 
        delete this._fxaaShader), this._copyShader && (this._copyShader.dispose(), delete this._copyShader);
    }
    _createFBOInfo(e, t) {
        const {width: n, height: r} = this._layer.getRenderer().canvas, i = this._regl;
        let s;
        if (this._layer.getRenderer()._isUseMultiSample()) s = i.renderbuffer({
            width: n,
            height: r,
            samples: this._layer.options.multiSamples,
            format: "rgba8"
        }); else {
            const e = this._layer.options.antialias ? 4 : 1;
            s = i.texture({
                min: "nearest",
                mag: "nearest",
                format: t || "rgba",
                width: n,
                height: r,
                sampleCount: e
            });
        }
        const o = {
            width: n,
            height: r,
            colors: [ s ]
        };
        return e && (o.depthStencil = e), o;
    }
}

function Ec(e) {
    return e._framebuffer.framebuffer;
}

function Pc(e) {
    return e.depthStencil._texture.texture;
}

class Ic extends es {
    constructor(e) {
        super({
            vert: "#if __VERSION__ == 300\n#define attribute in\n#define varying out\n#endif\nattribute vec2 aPosition;\nattribute vec2 aTexCoord;\nvarying vec2 vTexCoord;\nvoid main() {\n  gl_Position = vec4(aPosition, 0., 1.);\n  vTexCoord = aTexCoord;\n}",
            frag: "#if __VERSION__ == 100\n#ifdef GL_OES_standard_derivatives\n#extension GL_OES_standard_derivatives : enable\n#endif\n#endif\nprecision mediump float;\n#include <gl2_frag>\nvarying vec2 vTexCoord;\n#ifdef HAS_FLOODANALYSE\nuniform vec3 flood_waterColor;\nuniform float flood_waterOpacity;\nuniform sampler2D floodMap;\n#endif\n#ifdef HAS_SKYLINE\nuniform sampler2D skylineMap;\n#endif\n#ifdef HAS_VIEWSHED\nuniform vec4 viewshed_visibleColor;\nuniform vec4 viewshed_invisibleColor;\nuniform sampler2D viewshedMap;\n#endif\n#ifdef HAS_INSIGHT\nuniform vec4 insight_visibleColor;\nuniform vec4 insight_invisibleColor;\nuniform sampler2D insightMap;\n#endif\n#ifdef HAS_CUT\nuniform sampler2D meshesMap;\nuniform sampler2D invisibleMap;\n#endif\n#ifdef HAS_EXCAVATE\nuniform sampler2D excavateMap;\n#endif\n#ifdef HAS_CROSSCUT\nuniform sampler2D crosscutMap;\nuniform vec4 cutLineColor;\n#endif\n#ifdef HAS_HEIGHTLIMIT\nuniform vec3 limitColor;\nuniform sampler2D heightLimitMap;\n#endif\nuniform sampler2D sceneMap;\nvoid main() {\n  vec4 c = texture2D(sceneMap, vTexCoord);\n  glFragColor = c;\n#ifdef HAS_VIEWSHED\nvec4 d = texture2D(viewshedMap, vTexCoord);\n  if(d.r > .99) {\n    glFragColor = vec4(mix(viewshed_invisibleColor.rgb, c.rgb, viewshed_invisibleColor.a), c.a);\n  } else if(d.g > .99) {\n    glFragColor = vec4(mix(viewshed_visibleColor.rgb, c.rgb, viewshed_visibleColor.a), c.a);\n  } else if(d.a < .01) {\n    glFragColor = vec4(d.rgb, 1.);\n  }\n  \n  \n#endif\n#ifdef HAS_FLOODANALYSE\nvec4 e = texture2D(floodMap, vTexCoord);\n  if(e.r > .0) {\n    glFragColor = vec4(mix(glFragColor.rgb, flood_waterColor, flood_waterOpacity), glFragColor.a);\n  }\n#endif\n#ifdef HAS_SKYLINE\nvec4 f = texture2D(skylineMap, vTexCoord);\n  if(f.r > .0 || f.g > .0 || f.b > .0) {\n    glFragColor = f;\n  }\n#endif\n#ifdef HAS_INSIGHT\nvec4 h = texture2D(insightMap, vTexCoord);\n  if(h.g > .0) {\n    glFragColor = insight_visibleColor;\n  } else if(h.r > .0) {\n    glFragColor = insight_invisibleColor;\n  }\n  \n#endif\n#ifdef HAS_CUT\nvec4 i = texture2D(invisibleMap, vTexCoord);\n  vec4 j = texture2D(meshesMap, vTexCoord);\n  if(i.r == 1. && i.g == .0 && i.b == .0) {\n    glFragColor = j;\n  } else if(i.r == .0 && i.g == 1. && i.b == .0) {\n    glFragColor = j;\n  } else if(i.r == .0 && i.g == .0 && i.b == 1.) {\n    glFragColor = c;\n  }\n  \n  \n#endif\n#ifdef HAS_EXCAVATE\nvec4 k = texture2D(excavateMap, vTexCoord);\n  if(k.r == 1. && k.g == .0 && k.b == .0) {\n    glFragColor = c;\n  } else {\n    glFragColor = k;\n  }\n#endif\n#ifdef HAS_CROSSCUT\nvec4 l = texture2D(crosscutMap, vTexCoord);\n  if(l.r > .0) {\n    glFragColor = vec4(mix(cutLineColor.rgb, glFragColor.rgb, .99), glFragColor.a);\n  }\n#endif\n#ifdef HAS_HEIGHTLIMIT\nvec4 m = texture2D(heightLimitMap, vTexCoord);\n  if(m.r > .0) {\n    glFragColor = vec4(mix(limitColor, glFragColor.rgb, .6), glFragColor.a);\n  }\n#endif\n#if __VERSION__ == 100\ngl_FragColor = glFragColor;\n#endif\n}",
            extraCommandProps: {
                viewport: e,
                cull: {
                    enable: !0
                },
                blend: {
                    enable: !0,
                    func: {
                        srcRGB: "src alpha",
                        srcAlpha: 1,
                        dstRGB: "one minus src alpha",
                        dstAlpha: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
    }
}

class Rc {
    constructor(e, t, n) {
        this._regl = e, this._layer = t, this._config = n, this._init();
    }
    _init() {
        this.renderer = new wr(this._regl);
        const e = this._layer.getRenderer(), t = this._viewport = {
            x: 0,
            y: 0,
            width: () => e.canvas ? e.canvas.width : 1,
            height: () => e.canvas ? e.canvas.height : 1
        };
        this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: e.canvas ? e.canvas.width : 1,
                height: e.canvas ? e.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this._shader = new Ic(t);
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    paint(e, t) {
        if (!t && t.length) return e;
        this._resize();
        const n = {}, r = this._layer._analysisTaskList;
        if (!this._hasAnalysis()) return e;
        this._regl.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            stencil: 0,
            framebuffer: this._fbo
        }), delete this._shader.shaderDefines.HAS_FLOODANALYSE, delete this._shader.shaderDefines.HAS_VIEWSHED, 
        delete this._shader.shaderDefines.HAS_SKYLINE, delete this._shader.shaderDefines.HAS_INSIGHT, 
        delete this._shader.shaderDefines.HAS_CUT, delete this._shader.shaderDefines.HAS_CROSSCUT, 
        delete this._shader.shaderDefines.HAS_HEIGHTLIMIT;
        for (let e = 0; e < r.length; e++) {
            const i = r[e];
            if (!i.isEnable()) continue;
            const s = i.getDefines();
            vl(this._shader.shaderDefines, s);
            const o = this.getMap(), a = o.width, l = o.height, c = this._getToAnalysisMeshes(t, i.getExcludeLayers()), h = i.renderAnalysis(c, a, l);
            h && vl(n, h);
        }
        return n.sceneMap = e, this._shader.setDefines(this._shader.shaderDefines), this.renderer.render(this._shader, n, null, this._fbo), 
        this._fbo;
    }
    _getToAnalysisMeshes(e, t) {
        let n = [];
        for (let r = 0; r < e.length; r++) {
            if (t.indexOf(e[r].getId()) > -1) continue;
            const i = e[r].getRenderer();
            if (i && i.getAnalysisMeshes) {
                const e = i.getAnalysisMeshes();
                e.forEach((e => {
                    e.setUniform("useAnalysis", 1);
                })), n = n.concat(e);
            }
        }
        return n;
    }
    _resize() {
        const e = n.isFunction(this._viewport.width.data) ? this._viewport.width.data() : this._viewport.width, t = n.isFunction(this._viewport.height.data) ? this._viewport.height.data() : this._viewport.height;
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
    _hasAnalysis() {
        const e = this._layer && this._layer._analysisTaskList;
        if (!e) return !1;
        for (let t = 0; t < e.length; t++) if (e[t].isEnable()) return !0;
        return !1;
    }
}

const Lc = [], Fc = new e.Coordinate(0, 0);

let Hc = {};

class Dc {
    constructor(e, t) {
        this._regl = e, this._layer = t, this._init();
    }
    _init() {
        this.renderer = new wr(this._regl);
        const e = this._layer.getRenderer(), t = this._viewport = {
            x: 0,
            y: 0,
            width: () => e.canvas ? e.canvas.width : 1,
            height: () => e.canvas ? e.canvas.height : 1
        };
        this._width = t.width, this._height = t.height, this._fbo = this._regl.framebuffer({
            color: this._regl.texture({
                width: e.canvas ? e.canvas.width : 1,
                height: e.canvas ? e.canvas.height : 1,
                wrap: "clamp",
                mag: "linear",
                min: "linear"
            }),
            depth: !0
        }), this.EMPTY_TEXTURE = this._regl.texture({
            width: 2,
            height: 2
        }), this._shader = new ws, this._pass = new Ns(this._regl, t, this._layer), this._shader.version = 300;
    }
    getMap() {
        return this._layer && this._layer.getMap();
    }
    paint(e, t) {
        if (!t || !t.length) return e;
        const n = this._layer.getMap();
        this._resize();
        const r = this._layer.getScanEffectConfig(), i = {}, {effects: s} = r, o = n.getGLRes(), a = [];
        this._effectLength !== s.length && (Hc = {});
        for (let e = 0; e < s.length; e++) {
            const {center: t, radius: r, speed: i, color: l, direction: c, height: h} = s[e], d = Nc(t), f = n.coordinateToPointAtRes(d, o, Fc).toArray(), m = n.distanceToPointAtRes(r, 0, o).x, g = "vertical" === c ? 1 : 0, _ = n.altitudeToPoint(h || 0, o);
            Hc[e] = Hc[e] || [];
            const p = u.set(Hc[e], f[0], f[1], m, i, l[0], l[1], l[2], g, _);
            a.push(p);
        }
        const l = {
            projMatrix: n.projMatrix,
            viewMatrix: n.viewMatrix,
            effectInfos: a,
            effectTime: this._getTimeSpan() / 1e3
        }, c = this._layer.getRenderer(), h = this._pass.render(t, l) || this.EMPTY_TEXTURE;
        return i.scanEffectMap = c._getFBOColor(h), i.sceneMap = e, i.resolution = f.set(Lc, this._fbo.width, this._fbo.height), 
        this.renderer.render(this._shader, i, null, this._fbo), this._fbo;
    }
    _getTimeSpan() {
        if (!this._layer) return 0;
        if (void 0 === this._currentFrameTime && (this._currentFrameTime = 0), this.isPlaying()) {
            const e = this._layer.getRenderer();
            this._currentFrameTime = e.getFrameTime();
        }
        return this._currentFrameTime;
    }
    isPlaying() {
        const e = this._layer.getScanEffectConfig();
        return !!e && !1 !== e.playing;
    }
    _resize() {
        const e = this._width(), t = this._height();
        !this._fbo || this._fbo.width === e && this._fbo.height === t || this._fbo.resize(e, t);
    }
    dispose() {
        this._fbo && this._fbo.destroy(), this._shader && (this._shader.dispose(), delete this._shader), 
        this._pass && this._pass.dispose();
    }
}

function Nc(e) {
    return Array.isArray(e) ? (Fc.x = e[0], Fc.y = e[1], Fc) : e;
}

function Bc(e, t, n, r, i) {
    const s = {
        alpha: !0,
        depth: !0,
        stencil: !0,
        preserveDrawingBuffer: t
    }, o = function(e, t, n) {
        const r = n ? [ "webgl", "experimental-webgl" ] : [ "webgl2", "webgl", "experimental-webgl" ];
        let i = null;
        for (let n = 0; n < r.length; ++n) {
            try {
                i = e.getContext(r[n], t);
            } catch (e) {}
            if (i) break;
        }
        i || console.error("Browser doesn't support WebGL.");
        return i;
    }(e, s, n);
    !function(e, t, n) {
        t && t.forEach((t => {
            e.getExtension(t);
        }));
        n && n.forEach((t => {
            e.getExtension(t);
        }));
    }(o, r, i), o.wrap = () => new T(o);
    const a = o.wrap(), l = w({
        gl: a,
        attributes: s,
        extensions: r,
        optionalExtensions: i
    }), c = {
        gl: o,
        reglGL: a,
        regl: l,
        device: l,
        getImageData: (t, n, r, i) => {
            const s = new Uint8Array(r * i * 4);
            return l.read({
                x: t,
                y: e.height - n,
                width: r,
                height: i,
                data: s
            }), new ImageData(new Uint8ClampedArray(s.buffer), r, i);
        }
    };
    return {
        gl: o,
        reglGL: a,
        regl: l,
        context: c
    };
}

const Uc = function(e) {
    return class extends e {
        createContext() {
            this.createCanvas();
            const e = this.getMap(), {preserveDrawingBuffer: t, onlyWebGL1: n, extensions: r, optionalExtensions: i} = e.options, {gl: s, regl: o, reglGL: a, context: l} = Bc(this.canvas, t, n, r, i);
            this.gl = s, this.regl = o, this.reglGL = a, this.context = l, this.context.device = o, 
            this.device = this.regl;
        }
    };
}, {LayerAbstractRenderer: zc} = e.renderer, Gc = [ 0, 0, 0, 0 ], Vc = [ 1, 1, -1 ], jc = [ 0, 0 ], Wc = e => !e.bloom && !e.ssr, qc = e => !e.bloom, Xc = e => !e.ssr;

class Kc extends(Uc(zc)){
    setToRedraw() {
        this.setRetireFrames(), super.setToRedraw();
    }
    onAdd() {
        super.onAdd();
        this.getMap().getRenderer().ready && this.prepareCanvas();
    }
    updateSceneConfig() {
        this._groundPainter && this._groundPainter.update(), this._envPainter && this._envPainter.update(), 
        this._weatherPainter && this._weatherPainter.update(), this.setToRedraw();
    }
    render(...e) {
        this.getMap() && this.layer.isVisible() && (this.forEachRenderer((e => {
            e._replacedDrawFn || (e.draw = this._buildDrawFn(e.draw), e.drawOnInteracting = this._buildDrawOnInteractingFn(e.drawOnInteracting), 
            e.setToRedraw = this._buildSetToRedrawFn(e.setToRedraw), e._replacedDrawFn = !0);
        })), this.prepareRender(), this.prepareCanvas(), this.layer._updatePolygonOffset(), 
        this._toRedraw = !1, this._renderChildLayers("render", e), this._renderOutlines(), 
        this._postProcess());
    }
    prepareCanvas() {
        super.prepareCanvas(), this.resizeCanvas(), this.forEachRenderer((e => {
            e.prepareCanvas();
        }));
    }
    drawOnInteracting(...e) {
        this.getMap() && this.layer.isVisible() && (this.layer._updatePolygonOffset(), this._toRedraw = !1, 
        this._renderChildLayers("drawOnInteracting", e), this._renderOutlines(), this._postProcess());
    }
    _renderChildLayers(e, t) {
        this._renderMode = "default";
        const n = this.hasRenderTarget(), r = this._getDrawContext(t);
        if (n && (this._drawContext.renderTarget = this._getFramebufferTarget()), this._envPainter.paint(r), 
        this.drawGround(!0), !n) return void this._renderInMode("default", null, e, t, !0);
        const i = this.layer._getSceneConfig(), s = i && i.postProcess, o = this.isSSROn();
        r.jitter = jc;
        const a = this.layer.getGroundConfig();
        r.hasSSRGround = !!(o && a && a.enable && a.symbol && a.symbol.ssr), this._renderInMode("default", this._targetFBO, e, t, !0), 
        o && this._postProcessor.drawSSR(this._blitDepthTex(), this._targetFBO);
        s.bloom && s.bloom.enable && (this._bloomPainted = this._postProcessor.drawBloom(this._depthTex)), 
        2 === o && this._postProcessor.drawSSR(this._blitDepthTex(), this._targetFBO, !0), 
        this._weatherPainter.renderScene(r);
    }
    _renderInMode(e, t, n, r, i) {
        this._renderMode = e;
        const s = this._getDrawContext(r);
        s.renderMode = this._renderMode, s.renderTarget && (s.renderTarget.fbo = t), i && (s.isFinalRender = !0), 
        this.forEachRenderer(((e, i) => {
            i.isVisible() && (this.clearStencil(e, t), e[n].apply(e, r));
        }));
    }
    _getDrawContext(e) {
        let t = e[0];
        return Zc(t) || (t = e[1]), t !== this._contextFrameTime && (this.forEachRenderer(((e, t) => {
            t.isVisible() && e.needRetireFrames && e.needRetireFrames() && this.setRetireFrames();
        })), this._drawContext = this._prepareDrawContext(t), this._contextFrameTime = t, 
        this._frameEvent = Zc(e[0]) ? null : e[0]), this._drawContext;
    }
    _renderOutlines() {
        if (!this.isEnableOutline()) return;
        const e = this._getOutlineFBO();
        this.resetDrawCalls(), this.forEachRenderer(((t, n) => {
            n.isVisible() && t.drawOutline && t.drawOutline(e);
        })), this._outlineCounts = this.getDrawCalls();
    }
    _getOutlineFBO() {
        const {width: e, height: t} = this.canvas;
        let n = this._outlineFBO;
        if (n) e === n.width && t === n.height || n.resize(e, t); else {
            const r = this.device && this.device.wgpu ? "rgba" : "rgba4", i = this.layer.options.antialias ? 4 : 1, s = this.device.texture({
                width: e,
                height: t,
                format: r,
                sampleCount: i
            });
            n = this._outlineFBO = this.device.framebuffer({
                width: e,
                height: t,
                colors: [ s ],
                depth: !1,
                stencil: !1
            });
        }
        return n;
    }
    _getFBOColor(e) {
        if (this._isUseMultiSample()) {
            const t = this._getBlitFBO(e);
            return t.width !== e.width || t.height !== e.height ? t.resize(e.width, e.height) : this.regl.clear({
                color: [ 0, 0, 0, 0 ],
                framebuffer: t
            }), t.blit(e), t.color[0];
        }
        return e.color[0];
    }
    _blitDepthTex() {
        if (!!this.device.wgpu || this._depthTex.subimage) return this._depthTex;
        const {width: e, height: t} = this._depthTex;
        if (!this._blitDepthFBO) {
            const n = this.regl, r = {
                depthStencil: n.texture({
                    min: "nearest",
                    mag: "nearest",
                    mipmap: !1,
                    type: "depth stencil",
                    width: e,
                    height: t,
                    format: "depth stencil"
                }),
                colors: [ n.renderbuffer({
                    width: e,
                    height: t,
                    format: "rgba4"
                }) ],
                colorFormat: "rgba4",
                width: e,
                height: t
            };
            this._blitDepthFBO = n.framebuffer(r);
        }
        return this._blitDepthFBO.width === e && this._blitDepthFBO.height === t || this._blitDepthFBO.resize(e, t), 
        this.regl.clear({
            color: [ 0, 0, 0, 0 ],
            depth: 1,
            framebuffer: this._blitDepthFBO
        }), this._blitDepthFBO.blit(this._targetFBO, 256, "nearest"), this._blitDepthFBO.depthStencil;
    }
    _getBlitFBO(e) {
        if (this._blitFBOs || (this._blitFBOs = []), !e._blitFBO) {
            const t = this._createSimpleFBOInfo(!0, e.width, e.height), n = this.regl.framebuffer(t);
            this._blitFBOs.push(n), e._blitFBO = n;
        }
        return e._blitFBO;
    }
    _isUseMultiSample() {
        if (this.device && this.device.wgpu) return !1;
        return 0 === this.regl.limits.version.indexOf("WebGL 2.0") && this.layer.options.antialias;
    }
    hasRenderTarget() {
        const e = this.layer._getSceneConfig(), t = e && e.postProcess;
        return !(!t || !t.enable);
    }
    testIfNeedRedraw() {
        if (this.layer.options.forceRedrawPerFrame) return !0;
        if (this._toRedraw) return this._toRedraw = !1, !0;
        if (this.getMap().isInteracting() && (this._groundPainter && this._groundPainter.isEnable() || this._envPainter && this._envPainter.isEnable())) return !0;
        if (this._weatherPainter && this._weatherPainter.isEnable()) return !0;
        if (this.isEnableScanEffect()) return !0;
        const e = this.layer.getTerrainLayer();
        if (e) {
            const t = e.getRenderer();
            if (t && t.testIfNeedRedraw()) return this._needUpdateSSR = !0, !0;
        }
        const t = this._getLayers();
        for (const e of t) {
            if (!e) continue;
            const t = e.getRenderer();
            if (t && t.testIfNeedRedraw()) return this._needUpdateSSR = !0, !0;
        }
        return !1;
    }
    isRenderComplete() {
        const e = this._getLayers();
        for (const t of e) {
            const e = t.getRenderer();
            if (e && !e.isRenderComplete()) return !1;
        }
        return !0;
    }
    mustRenderOnInteracting() {
        const e = this._getLayers();
        for (const t of e) {
            const e = t.getRenderer();
            if (e && e.mustRenderOnInteracting()) return !0;
        }
        return !1;
    }
    isCanvasUpdated() {
        if (super.isCanvasUpdated()) return !0;
        const e = this._getLayers();
        for (const t of e) {
            const e = t.getRenderer();
            if (e && e.isCanvasUpdated()) return !0;
        }
        return !1;
    }
    isBlank() {
        if (this._groundPainter && this._groundPainter.isEnable()) return !1;
        if (this._envPainter && this._envPainter.isEnable()) return !1;
        const e = this.layer.getTerrainLayer();
        if (e) {
            const t = e.getRenderer();
            if (t && !t.isBlank()) return !1;
        }
        const t = this._getLayers();
        for (const e of t) {
            const t = e.getRenderer();
            if (t && !t.isBlank()) return !1;
        }
        return !0;
    }
    initContext() {
        if (super.initContext(), !this.context) return;
        this.forEachRenderer((e => {
            e.canvas && e.initContext();
        }));
        const e = this.layer, {regl: t, gl: n, reglGL: r, device: i} = this.context;
        this.device = i || t, this.regl = t, this.reglGL = r, this.gl = n, this.canvas.gl = this.gl, 
        this._jitter = [ 0, 0 ];
        const s = t || i;
        this._groundPainter = new Jl(s, this.layer), this._envPainter = new ic(s, this.layer);
        const o = this.layer.getWeatherConfig();
        this._weatherPainter = new Mc(s, e, o), this._analysisPainter = new Rc(s, e), this._scanEffectPainter = new Dc(s, e);
        const a = this.layer._getSceneConfig() || {}, l = a && a.postProcess, c = l && l.antialias && l.antialias.jitterRatio || .2;
        this._jitGetter = new cs(c), this._postProcessor = new Oc(s, this.layer, this._jitGetter), 
        this._shadowProcess = new Rl(s, this.layer);
    }
    clearContext() {
        super.clearContext(), this._clearFramebuffers();
    }
    _clearFramebuffers() {
        const e = this.device;
        this._targetFBO && e.clear({
            color: Gc,
            depth: 1,
            stencil: 0,
            framebuffer: this._targetFBO
        }), this._outlineFBO && e.clear({
            color: Gc,
            depth: 1,
            stencil: 0,
            framebuffer: this._outlineFBO
        });
    }
    resizeCanvas() {
        const e = this.canvas.width, t = this.canvas.height;
        !this._targetFBO || this._targetFBO.width === e && this._targetFBO.height === t || (super.resizeCanvas(), 
        this._targetFBO.resize(e, t), this._clearFramebuffers(), this.forEachRenderer((e => {
            e.canvas && e.resizeCanvas();
        })));
    }
    _getLayers() {
        return this.layer._getLayers();
    }
    forEachRenderer(e) {
        const t = this._getLayers();
        for (const n of t) {
            if (!n.isVisible() || !n.options.beneathTerrain) continue;
            const t = n.getRenderer();
            t && e(t, n);
        }
        const n = this.layer.getTerrainLayer();
        if (n) {
            const t = n.getRenderer();
            t && e(t, n);
        }
        for (const n of t) {
            if (!n.isVisible() || n.options.beneathTerrain) continue;
            const t = n.getRenderer();
            t && e(t, n);
        }
    }
    clearStencil(e, t) {
        const n = {
            stencil: e.getStencilValue ? e.getStencilValue() : 255
        };
        t && (n.framebuffer = t), this.device.clear(n);
    }
    onRemove() {
        if (!this.canvas) return void super.onRemove();
        const e = this.canvas.pickingFBO;
        e && e.destroy && !e.___disposed && (e.___disposed = !0, e.destroy()), this._destroyFramebuffers(), 
        this._groundPainter && (this._groundPainter.dispose(), delete this._groundPainter), 
        this._envPainter && (this._envPainter.dispose(), delete this._envPainter), this._shadowProcess && (this._shadowProcess.dispose(), 
        delete this._shadowProcess), this._postProcessor && (this._postProcessor.dispose(), 
        delete this._postProcessor), this._outlineFBO && (this._outlineFBO.destroy(), delete this._outlineFBO), 
        this._weatherPainter && (this._weatherPainter.dispose(), delete this._weatherPainter), 
        delete this.gl, delete this.regl, super.onRemove();
    }
    hitDetect() {
        return !1;
    }
    _destroyFramebuffers() {
        if (this._targetFBO && (this._targetFBO.destroy(), delete this._targetFBO, this._postFBO && (this._postFBO.destroy(), 
        delete this._postFBO), this._blitDepthFBO && (this._blitDepthFBO.destroy(), delete this._blitDepthFBO), 
        this._blitFBOs)) {
            for (let e = 0; e < this._blitFBOs.length; e++) this._blitFBOs[e] && this._blitFBOs[e].destroy();
            delete this._blitFBOs;
        }
    }
    setRetireFrames() {
        this._needRetireFrames = !0;
    }
    getFrameTime() {
        return this._contextFrameTime;
    }
    getFrameEvent() {
        return this._frameEvent;
    }
    getFrameContext() {
        return this._drawContext;
    }
    drawGround(e) {
        const t = this.layer.getGroundConfig();
        if (!t || !t.enable) return !1;
        if (!this._groundPainter) return !1;
        const n = this.getFrameContext(), r = n.jitter;
        n.jitter = jc;
        const i = this.layer.getPolygonOffsetCount();
        let s;
        n.offsetFactor = i + 1, n.offsetUnits = i + 1, e && (s = n.sceneFilter, delete n.sceneFilter);
        const o = this._groundPainter.paint(n);
        return this._groundPainter.needToRedraw() && this.setToRedraw(), s && (n.sceneFilter = s), 
        n.jitter = r, o;
    }
    _buildDrawFn(e) {
        const t = this;
        return function(n, r) {
            return (r = r || t._drawContext) && r.renderTarget && (r.renderTarget.getFramebuffer = Yc, 
            r.renderTarget.getDepthTexture = $c), e.call(this, n, r);
        };
    }
    _buildDrawOnInteractingFn(e) {
        const t = this;
        return function(n, r, i) {
            return (i = i || t._drawContext) && i.renderTarget && (i.renderTarget.getFramebuffer = Yc, 
            i.renderTarget.getDepthTexture = $c), e.call(this, n, r, i);
        };
    }
    _buildSetToRedrawFn(e) {
        return function(...t) {
            return e.apply(this, t);
        };
    }
    isEnableSSR() {
        const e = this.layer._getSceneConfig(), t = e && e.postProcess;
        return t && t.enable && t.ssr && t.ssr.enable;
    }
    isSSROn() {
        const e = this.isEnableSSR(), t = this.getMap();
        if (!e || t.getPitch() <= -.001) return 0;
        const n = t.projViewMatrix, r = this._postProcessor.getPrevSsrProjViewMatrix();
        return r && c.exactEquals(r, n) ? 1 : 2;
    }
    isEnableTAA() {
        return !1;
    }
    isEnableSSAO() {
        return !1;
    }
    isEnableOutline() {
        const e = this.layer._getSceneConfig(), t = e && e.postProcess;
        return t && t.enable && t.outline && t.outline.enable;
    }
    isEnableWeather() {
        const e = this.layer._getSceneConfig(), t = e && e.weather;
        return t && t.enable;
    }
    _getViewStates() {
        const e = this.layer.getMap();
        if (!this._renderedView) {
            this._renderedView = {
                center: e.getCenter(),
                bearing: e.getBearing(),
                pitch: e.getPitch(),
                res: e.getResolution()
            };
            let t = !1;
            if (e.options.lights) {
                const n = e.getLightManager().getDirectionalLight().direction || Vc;
                this._renderedView.lightDirection = h.copy([], n), t = !0;
            }
            return {
                viewChanged: !0,
                lightDirectionChanged: t
            };
        }
        const t = e.getResolution() / this._renderedView.res, n = e.coordToContainerPoint(this._renderedView.center), r = this.layer.options.viewMoveThreshold, i = n._sub(e.width / 2, e.height / 2).mag() > r || t < .95 || t > 1.05;
        let s = !1;
        if (e.options.lights) {
            const t = e.getLightManager().getDirectionalLight().direction || Vc;
            s = !h.equals(this._renderedView.lightDirection || [], t), s && (this._renderedView.lightDirection = h.copy([], t));
        }
        return i && (this._renderedView.center = e.getCenter(), this._renderedView.bearing = e.getBearing(), 
        this._renderedView.pitch = e.getPitch(), this._renderedView.res = e.getResolution()), 
        {
            viewChanged: i,
            lightDirectionChanged: s
        };
    }
    _prepareDrawContext(e) {
        const t = this.layer._getSceneConfig(), n = t && t.postProcess, r = t && t.weather, i = {
            timestamp: e,
            renderMode: this._renderMode || "default",
            includes: {},
            states: this._getViewStates(),
            testSceneFilter: e => !i.sceneFilter || i.sceneFilter(e),
            isFinalRender: !1,
            weather: {
                fog: r && r.fog
            }
        }, s = n && n.antialias && n.antialias.jitterRatio || .2, o = this._jitGetter;
        o && o.setRatio(s);
        const a = this.isSSROn();
        let l;
        if (n && n.enable) {
            if (this.isEnableTAA()) {
                (this.getMap().isInteracting() || this._needRetireFrames) && o.reset(), o.getJitter(this._jitter), 
                o.frame();
            } else f.set(this._jitter, 0, 0);
            i.jitter = this._jitter;
            const e = n.bloom && n.bloom.enable;
            e && a ? (i.bloom = 1, i.sceneFilter = Wc) : e ? (i.bloom = 1, i.sceneFilter = qc) : a && (i.sceneFilter = Xc), 
            l = this._getFramebufferTarget(), l && (i.renderTarget = l);
        } else this._destroyFramebuffers();
        return "noAa" !== this._renderMode && (this._shadowContext = this._prepareShadowContext(i), 
        this._shadowContext && (i.includes.shadow = 1), this._includesState = this._updateIncludesState(i)), 
        this._shadowContext && (i.shadow = this._shadowContext, i.includes.shadow = 1), 
        i.states.includesChanged = this._includesState, n && n.enable && this._postProcessor && this._postProcessor.setContextIncludes(i), 
        i;
    }
    _renderAnalysis(e) {
        const t = this._getLayers().filter((e => e.isVisible()));
        return this.layer.getTerrainLayer() && t.push(this.layer.getTerrainLayer()), this._analysisPainter.paint(e, t);
    }
    _updateIncludesState(e) {
        let t = !1;
        const n = Object.keys(e.includes), r = this._prevIncludeKeys;
        if (r) {
            const e = n.filter((e => -1 === r.indexOf(e))).concat(r.filter((e => -1 === n.indexOf(e))));
            e.length && (t = e.reduce(((e, t) => (e[t] = 1, e)), {}));
        }
        return this._prevIncludeKeys = n, t;
    }
    _prepareShadowContext(e) {
        const t = this.layer._getSceneConfig();
        if (!t || !t.shadow || !t.shadow.enable) return this._shadowProcess && (this._shadowProcess.dispose(), 
        delete this._shadowProcess), null;
        this._shadowProcess || (this._shadowProcess = new Rl(this.device, this.layer));
        const n = {
            config: t.shadow,
            defines: this._shadowProcess.getDefines(),
            uniformDeclares: Rl.getUniformDeclares()
        };
        return n.renderUniforms = this._renderShadow(e), n;
    }
    _renderShadow(e) {
        const t = e.renderTarget && e.renderTarget.fbo, n = this.layer._getSceneConfig(), r = [];
        let i = e.states.lightDirectionChanged || e.states.viewChanged;
        this.forEachRenderer(((e, t) => {
            if (!e.getShadowMeshes || !t.isVisible()) return;
            const n = e.getShadowMeshes();
            if (Array.isArray(n)) for (let e = 0; e < n.length; e++) n[e] && (n[e].needUpdateShadow && (i = !0, 
            n[e].needUpdateShadow = !1), n[e].hasFunctionUniform && (n[e].hasFunctionUniform("minAltitude") || n[e].setFunctionUniform("minAltitude", (() => t && t.options.altitude || 0)), 
            r.push(n[e])));
        })), this._shadowScene || (this._shadowScene = new Pr), this._shadowScene.setMeshes(r);
        const s = this.getMap(), o = n.shadow, a = s.getLightManager(), l = a && a.getDirectionalLight().direction || Vc, c = !n.ground || !n.ground.enable;
        return this._shadowProcess.render(c, s.projMatrix, s.viewMatrix, o.color, o.opacity, l, this._shadowScene, this._jitter, t, i);
    }
    _renderWeather(e) {
        let t = [];
        if (this.forEachRenderer(((e, n) => {
            if (!e.getAnalysisMeshes || !n.isVisible()) return;
            const r = e.getAnalysisMeshes();
            t = t.concat(r);
        })), this._groundPainter) {
            const e = this._groundPainter.getRenderMeshes();
            t = t.concat(e);
        }
        const n = this.layer.getWeatherConfig();
        return this._weatherPainter.paint(e, t, n);
    }
    _renderScanEffect(e) {
        let t = [];
        if (this.forEachRenderer(((e, n) => {
            if (!e.getAnalysisMeshes || !n.isVisible()) return;
            const r = e.getAnalysisMeshes();
            t = t.concat(r);
        })), this._groundPainter) {
            const e = this._groundPainter.getRenderMeshes();
            t = t.concat(e);
        }
        return this._scanEffectPainter.paint(e, t);
    }
    getGroundMesh() {
        if (this._groundPainter) {
            return this._groundPainter.getRenderMeshes();
        }
        return [];
    }
    _getFramebufferTarget() {
        const e = this.layer._getSceneConfig(), t = e && e.postProcess;
        if (!this._targetFBO) {
            const e = this.device;
            let n = this._depthTex;
            (!n || !n._texture || n._texture.refCount <= 0) && (n = null);
            const r = this.createFBOInfo(t, n);
            this._depthTex = r.depth || r.depthStencil, this._targetFBO = e.framebuffer(r), 
            this._clearFramebuffers();
        }
        return {
            fbo: this._targetFBO
        };
    }
    _createSimpleFBOInfo(e, t, n) {
        t = t || this.canvas.width, n = n || this.canvas.height;
        const r = this.device, i = this._isUseMultiSample(), s = this.layer.options.antialias;
        let o;
        if (!e && i) o = r.renderbuffer({
            width: t,
            height: n,
            samples: this.layer.options.multiSamples,
            format: "rgba8"
        }); else {
            const e = s ? 4 : 1, i = "uint8";
            o = r.texture({
                min: "nearest",
                mag: "nearest",
                type: i,
                width: t,
                height: n,
                sampleCount: e
            });
        }
        return {
            width: t,
            height: n,
            colors: [ o ],
            colorFormat: i ? "rgba8" : "rgba"
        };
    }
    createFBOInfo(e, t) {
        let {width: n, height: r} = this.canvas;
        n = n || 1, r = r || 1;
        const i = this.device, s = this._createSimpleFBOInfo(), o = this._isUseMultiSample(), a = !this.regl || i.hasExtension("WEBGL_depth_texture");
        if (o) {
            const e = t || i.renderbuffer({
                width: n,
                height: r,
                format: "depth24 stencil8",
                samples: this.layer.options.multiSamples
            });
            s.depthStencil = e;
        } else if (a) {
            const e = this.layer.options.antialias ? 4 : 1, o = t || i.texture({
                min: "nearest",
                mag: "nearest",
                mipmap: !1,
                type: "depth stencil",
                width: n,
                height: r,
                format: "depth stencil",
                sampleCount: e
            });
            s.depthStencil = o;
        } else {
            const e = t || i.renderbuffer({
                width: n,
                height: r,
                format: "depth stencil"
            });
            s.depthStencil = e;
        }
        return s;
    }
    _postProcess() {
        if (!this._targetFBO) return void (this._needRetireFrames = !1);
        const e = this.layer._getSceneConfig(), t = e && e.postProcess;
        if (!t || !t.enable) {
            if (this.isEnableWeather()) throw new Error("you must enable the post process to turn on weather");
            return;
        }
        this.layer.fire("postprocessstart");
        const n = this.layer.getMap();
        let r = t.sharpen && t.sharpen.factor;
        r || 0 === r || (r = .2);
        let i = 0, s = .2, o = .3, a = 1, l = [ 1, 1, 0 ];
        t.outline && (i = +!!t.outline.enable, s = Jc(t.outline, "highlightFactor", s), 
        o = Jc(t.outline, "outlineFactor", o), a = Jc(t.outline, "outlineWidth", a), l = Jc(t.outline, "outlineColor", l));
        const c = t.ssr && t.ssr.enable, h = t.bloom && t.bloom.enable, d = this._analysisPainter._hasAnalysis(), u = this._weatherPainter._hasWeather(), f = this.isEnableScanEffect(), m = h || c || d || u || f;
        let g = this._postFBO;
        if (m) {
            if (!g) {
                const e = this._createSimpleFBOInfo();
                this._isUseMultiSample() && (e.depthStencil = this.regl.renderbuffer({
                    width: this.canvas.width,
                    height: this.canvas.height,
                    samples: this.layer.options.multiSamples,
                    format: "depth24 stencil8"
                })), g = this._postFBO = this.device.framebuffer(e);
            }
            const {width: e, height: t} = this.canvas;
            g.width === e && g.height === t || g.resize(e, t);
        } else g = null, this._postFBO && (this._postFBO.destroy(), delete this._postFBO);
        let _ = this._getFBOColor(this._targetFBO);
        if (this._postProcessor.fxaa(g, _, 0, +!(!t.toneMapping || !t.toneMapping.enable), +!(m || !t.sharpen || !t.sharpen.enable), n.getDevicePixelRatio(), r, i && this._outlineCounts > 0 && this._getOutlineFBO(), s, o, a, l), 
        g && (_ = this._getFBOColor(g)), h && this._bloomPainted) {
            const e = t.bloom, n = +e.threshold || 0, r = Jc(e, "factor", 1), i = Jc(e, "radius", 1);
            _ = this._postProcessor.bloom(_, null, null, n, r, i, 0);
        }
        if (c && (this._postProcessor.genSsrMipmap(_, this._blitDepthTex()), this._needUpdateSSR)) {
            const e = this._needRetireFrames;
            this.setToRedraw(), this._needRetireFrames = e, this._needUpdateSSR = !1;
        }
        this._scanEffectPainter && this.isEnableScanEffect() && (_ = this._renderScanEffect(_)), 
        this._analysisPainter && (_ = this._renderAnalysis(_)), this.isEnableWeather() && (_ = this._renderWeather(_)), 
        m && this._postProcessor.renderFBOToScreen(_, +!(!t.sharpen || !t.sharpen.enable), r, n.getDevicePixelRatio()), 
        this.layer.fire("postprocessend");
    }
    isEnableScanEffect() {
        const e = this.layer._getSceneConfig(), t = e && e.postProcess && e.postProcess.scanEffect;
        return t && t.enable && t.effects.length;
    }
    resetDrawCalls() {
        this.reglGL && this.reglGL.resetDrawCalls(), this.device && this.device.wgpu && this.device.resetDrawCalls();
    }
    getDrawCalls() {
        return this.reglGL ? this.reglGL.getDrawCalls() : this.device && this.device.wgpu ? this.device.getDrawCalls() : void 0;
    }
}

function Zc(e) {
    return "number" == typeof e && !isNaN(e);
}

function Yc(e) {
    return e._framebuffer.framebuffer;
}

function $c(e) {
    return e.depthStencil._texture.texture;
}

function Jc(e, t, n) {
    return null == e[t] ? n : e[t];
}

class Qc extends e.worker.Actor {
    constructor(e) {
        super("@maptalks/terrain"), this.mapId = e;
    }
    checkUrl(t) {
        return t && e.Util.isString(t) ? e.Util.getAbsoluteURL(t) : t;
    }
    fetchTerrain(e, t, n) {
        e = this.checkUrl(e);
        const r = t.tileImage, i = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "fetchTerrain",
            params: {
                url: e,
                origin: location.origin,
                terrainWidth: t.terrainWidth,
                type: t.type,
                accessToken: t.accessToken,
                cesiumIonTokenURL: t.cesiumIonTokenURL,
                error: t.error,
                colors: t.colors,
                tileSize: t.tileSize,
                tileImage: r
            }
        }, s = [];
        r && s.push(r), this.send(i, s, ((e, t) => {
            e ? n(e) : n(e, t);
        }));
    }
    abortTerrain(e, t) {
        const n = {
            actorId: this.actorId,
            mapId: this.mapId,
            command: "abortTerrain",
            params: {
                url: e
            }
        };
        this.broadcast(n, null, t);
    }
    addLayer(e, t, n) {
        const r = {
            actorId: this.actorId,
            mapId: this.mapId,
            layerId: e,
            command: "addLayer",
            params: {}
        };
        this.broadcast(r, null, n);
    }
    createTerrainMesh(e, t) {
        const n = {
            actorId: this.actorId,
            command: "createTerrainMesh",
            params: e
        };
        this.send(n, [ e.terrainHeights.data.buffer ], ((e, n) => {
            e ? t(e) : t(e, n);
        }));
    }
    removeLayer(e, t, n) {
        const r = {
            mapId: this.mapId,
            layerId: e,
            command: "removeLayer"
        };
        this.broadcast(r, null, n);
    }
}

class eh {
    constructor(e = 257) {
        this.gridSize = e;
        const t = e - 1;
        if (t & t - 1) throw new Error(`Expected grid size to be 2^n+1, got ${e}.`);
        this.numTriangles = t * t * 2 - 2, this.numParentTriangles = this.numTriangles - t * t, 
        this.indices = new Uint32Array(this.gridSize * this.gridSize), this.coords = new Uint16Array(4 * this.numTriangles);
        for (let e = 0; e < this.numTriangles; e++) {
            let n = e + 2, r = 0, i = 0, s = 0, o = 0, a = 0, l = 0;
            for (1 & n ? s = o = a = t : r = i = l = t; (n >>= 1) > 1; ) {
                const e = r + s >> 1, t = i + o >> 1;
                1 & n ? (s = r, o = i, r = a, i = l) : (r = s, i = o, s = a, o = l), a = e, l = t;
            }
            const c = 4 * e;
            this.coords[c + 0] = r, this.coords[c + 1] = i, this.coords[c + 2] = s, this.coords[c + 3] = o;
        }
    }
    createTile(e) {
        return new th(e, this);
    }
}

class th {
    constructor(e, t) {
        const n = t.gridSize;
        if (e.length !== n * n) throw new Error(`Expected terrain data of length ${n * n} (${n} x ${n}), got ${e.length}.`);
        this.terrain = e, this.martini = t, this.errors = new Float32Array(e.length), this.update();
    }
    update() {
        const {numTriangles: e, numParentTriangles: t, coords: n, gridSize: r} = this.martini, {terrain: i, errors: s} = this;
        for (let o = e - 1; o >= 0; o--) {
            const e = 4 * o, a = n[e + 0], l = n[e + 1], c = n[e + 2], h = n[e + 3], d = a + c >> 1, u = l + h >> 1, f = d + u - l, m = u + a - d, g = (i[l * r + a] + i[h * r + c]) / 2, _ = u * r + d, p = Math.abs(g - i[_]);
            if (s[_] = Math.max(s[_], p), o < t) {
                const e = (l + m >> 1) * r + (a + f >> 1), t = (h + m >> 1) * r + (c + f >> 1);
                s[_] = Math.max(s[_], s[e], s[t]);
            }
        }
    }
    getMesh(e = 0) {
        const {gridSize: t, indices: n} = this.martini, {errors: r} = this;
        let i = 0, s = 0;
        const o = t - 1;
        function a(o, l, c, h, d, u) {
            const f = o + c >> 1, m = l + h >> 1;
            Math.abs(o - d) + Math.abs(l - u) > 1 && r[m * t + f] > e ? (a(d, u, o, l, f, m), 
            a(c, h, d, u, f, m)) : (n[l * t + o] = n[l * t + o] || ++i, n[h * t + c] = n[h * t + c] || ++i, 
            n[u * t + d] = n[u * t + d] || ++i, s++);
        }
        n.fill(0), a(0, 0, o, o, o, 0), a(o, o, 0, 0, 0, o);
        const l = new Uint16Array(2 * i), c = new Uint32Array(3 * s);
        let h = 0;
        function d(i, s, o, a, u, f) {
            const m = i + o >> 1, g = s + a >> 1;
            if (Math.abs(i - u) + Math.abs(s - f) > 1 && r[g * t + m] > e) d(u, f, i, s, m, g), 
            d(o, a, u, f, m, g); else {
                const e = n[s * t + i] - 1, r = n[a * t + o] - 1, d = n[f * t + u] - 1;
                l[2 * e] = i, l[2 * e + 1] = s, l[2 * r] = o, l[2 * r + 1] = a, l[2 * d] = u, l[2 * d + 1] = f, 
                c[h++] = e, c[h++] = r, c[h++] = d;
            }
        }
        return d(0, 0, o, o, o, 0), d(o, o, 0, 0, 0, o), {
            vertices: l,
            triangles: c
        };
    }
    getMeshWithSkirts(e = 0, t) {
        const {gridSize: n, indices: r} = this.martini, {errors: i} = this;
        let s = 0, o = 0;
        const a = n - 1;
        let l, c, h = 0;
        const d = [], u = [], f = [], m = [];
        function g(t, _, p, v, x, y) {
            const b = t + p >> 1, w = _ + v >> 1;
            Math.abs(t - x) + Math.abs(_ - y) > 1 && i[w * n + b] > e ? (g(x, y, t, _, b, w), 
            g(p, v, x, y, b, w)) : (l = _ * n + t, c = v * n + p, h = y * n + x, 0 === r[l] && (0 === t ? d.push(s) : t === a && u.push(s), 
            0 === _ ? f.push(s) : _ === a && m.push(s), r[l] = ++s), 0 === r[c] && (0 === p ? d.push(s) : p === a && u.push(s), 
            0 === v ? f.push(s) : v === a && m.push(s), r[c] = ++s), 0 === r[h] && (0 === x ? d.push(s) : x === a && u.push(s), 
            0 === y ? f.push(s) : y === a && m.push(s), r[h] = ++s), o++);
        }
        let _;
        r.fill(0), g(0, 0, a, a, a, 0), g(a, a, 0, 0, 0, a), _ = t ? 2 * (s + 3 * d.length - 2 + 3 * u.length - 2 + 3 * f.length - 2 + 3 * m.length - 2) : 2 * (s + d.length + u.length + f.length + m.length);
        const p = 3 * (o + 2 * (d.length - 1) + 2 * (u.length - 1) + 2 * (f.length - 1) + 2 * (m.length - 1)), v = new Uint16Array(_), x = new Uint32Array(p);
        let y = 0;
        function b(t, s, o, a, l, c) {
            const h = t + o >> 1, d = s + a >> 1;
            if (Math.abs(t - l) + Math.abs(s - c) > 1 && i[d * n + h] > e) b(l, c, t, s, h, d), 
            b(o, a, l, c, h, d); else {
                const e = r[s * n + t] - 1, i = r[a * n + o] - 1, h = r[c * n + l] - 1;
                v[2 * e] = t, v[2 * e + 1] = s, v[2 * i] = o, v[2 * i + 1] = a, v[2 * h] = l, v[2 * h + 1] = c, 
                x[y++] = e, x[y++] = i, x[y++] = h;
            }
        }
        b(0, 0, a, a, a, 0), b(a, a, 0, 0, 0, a), d.sort(((e, t) => v[2 * e + 1] - v[2 * t + 1])), 
        u.sort(((e, t) => v[2 * t + 1] - v[2 * e + 1])), f.sort(((e, t) => v[2 * t] - v[2 * e])), 
        m.sort(((e, t) => v[2 * e] - v[2 * t]));
        let w, T, S, M, A = 2 * s, C = 0;
        function k(e) {
            C = e.length;
            for (let n = 0; n < C - 1; n++) w = e[n], T = e[n + 1], S = A / 2, M = (A + (t ? 6 : 2)) / 2, 
            v[A++] = 2 * w, v[A++] = 2 * w + 1, t && (v[A++] = 2 * w, v[A++] = 2 * w + 1, v[A++] = 2 * T, 
            v[A++] = 2 * T + 1), t ? (x[y++] = S + 1, x[y++] = S, x[y++] = S + 2, x[y++] = S, 
            x[y++] = M, x[y++] = S + 2) : (x[y++] = w, x[y++] = S, x[y++] = T, x[y++] = S, x[y++] = M, 
            x[y++] = T);
            v[A++] = 2 * e[C - 1], v[A++] = 2 * e[C - 1] + 1;
        }
        k(d);
        const O = A;
        k(u);
        const E = A;
        k(f);
        const P = A;
        k(m);
        return {
            vertices: v,
            triangles: x,
            numVerticesWithoutSkirts: s,
            numTrianglesWithoutSkirts: o,
            leftSkirtIndex: O,
            rightSkirtIndex: E,
            bottomSkirtIndex: P,
            topSkirtIndex: A
        };
    }
}

const nh = {};

function rh(e, t, n) {
    let r = nh[n];
    r || (r = nh[n] = new eh(n));
    const i = r.createTile(t).getMeshWithSkirts(e, !0), {triangles: s, vertices: o, leftSkirtIndex: a, rightSkirtIndex: l, bottomSkirtIndex: c, topSkirtIndex: h} = i;
    let {numVerticesWithoutSkirts: d, numTrianglesWithoutSkirts: u} = i;
    d || (d = o.length / 2, u = s.length / 3);
    const f = o.length / 2, m = new Float32Array(3 * f), g = new Float32Array(2 * f);
    let _ = 1 / 0, p = -1 / 0;
    const v = n - 1;
    for (let e = 0; e < f; e++) {
        const r = o[2 * e], i = o[2 * e + 1];
        if (e >= d) {
            const t = r / 2 * 3;
            let n, i = .001;
            (e - (e < a / 2 ? d : e < l / 2 ? a / 2 : e < c / 2 ? l / 2 : c / 2)) % 3 == 0 ? (n = Math.min(0, _), 
            i = 0) : n = m[t + 2];
            m[3 * e] = m[t], m[3 * e + 1] = m[t + 1], m[3 * e + 2] = n, g[2 * e] = m[t] / v + i, 
            g[2 * e + 1] = -m[t + 1] / v + i;
        } else {
            const s = t[i * n + r];
            m[3 * e] = 1 * r, m[3 * e + 1] = 1 * -i, m[3 * e + 2] = s, g[2 * e] = r / v, g[2 * e + 1] = i / v, 
            s < _ && (_ = s), s > p && (p = s);
        }
    }
    return {
        positions: m,
        texcoords: g,
        triangles: s,
        leftSkirtIndex: a,
        rightSkirtIndex: l,
        bottomSkirtIndex: c,
        topSkirtIndex: h,
        numTrianglesWithoutSkirts: u,
        numVerticesWithoutSkirts: d,
        minHeight: Math.min(0, _),
        maxHeight: p,
        terrainWidth: n
    };
}

function ih(e, t, n, r, i, s, o, a, l) {
    const c = {};
    for (let h = 0; h < l; h++) c[h + ""] = oh(e, t, n, r, i, s, o, a, h);
    return c;
}

const sh = [];

function oh(e, t, n, r, i, s, o, a, l) {
    if ((r -= l) <= 0) return sh;
    const c = e.getTileSize().width, h = e._getTileOffset(r, i), d = s[0] - h[0], u = h[1] - s[1], f = e._getTileConfig(), m = e.getSpatialReference().getResolution(r), g = f.tileSystem.scale.y, _ = 1e-7;
    let p = 0, v = 0, x = a /= Math.pow(2, l), y = a;
    if (d < 0 ? x += Math.ceil(-d / c - _) : d > 0 && (p -= Math.ceil(d / c - _)), u > 0 ? v -= Math.ceil(u / c - _) : u < 0 && (y += Math.ceil(-u / c - _)), 
    0 === p && 0 === v && x <= 1 && y <= 1) {
        const i = Math.floor(t * a);
        let s = Math.floor(n * a);
        const l = s;
        return g !== o && (s = ch(f, s, m)), [ {
            x: i,
            y: s,
            skinY: l,
            z: r,
            offset: h,
            tileSize: c,
            id: e._getTileId(i, s, r)
        } ];
    }
    const b = [];
    for (let i = p; i < x; i++) for (let s = v; s < y; s++) {
        const l = t * a + i;
        let d = n * a + s;
        const u = d;
        g !== o && (d = ch(f, d, m)), b.push({
            x: l,
            y: d,
            skinY: u,
            z: r,
            offset: h,
            tileSize: c,
            id: e._getTileId(l, d, r)
        });
    }
    return b;
}

function ah(e, t, n, r) {
    let i = e / n * r / t;
    return i < 1 ? (i = 1 / i, i = 1 / Math.round(i)) : i = Math.round(i), i;
}

function lh(e, t, n) {
    const r = e.getResolution(t), i = t - Math.log(n / r) * Math.LOG2E;
    return {
        zoom: i,
        res: e.getResolution(i)
    };
}

function ch(e, t, n) {
    const r = e.fullExtent, i = e.tileSize.width, s = Math.max(r.top, r.bottom), o = Math.min(r.top, r.bottom);
    return Math.ceil(s / i / n) - 1 - Math.floor(o / i / n) - t;
}

function hh(e, t) {
    const n = t * t, r = 0 !== e ? new Float32Array(n) : new Uint8Array(n);
    return r.fill(e), {
        data: r,
        width: t,
        height: t,
        max: e,
        min: e
    };
}

new e.Point(0, 0);

const dh = hh(0, 5), uh = rh(1, dh.data, dh.width);

function fh(e, t, n) {
    const r = n && n.includes;
    if (r) for (const i in r) r[i] && (n[i].uniformDeclares && t.push(...n[i].uniformDeclares), 
    n[i].defines && vl(e, n[i].defines));
}

function mh(e, t) {
    const n = t && t.includes;
    if (n) for (const r in n) n[r] && t[r].renderUniforms && vl(e, t[r].renderUniforms);
}

uh.empty = !0;

var gh = Object.freeze({
    __proto__: null,
    fillIncludes: fh,
    setIncludeUniformValues: mh
});

const _h = [], ph = [];

class vh {
    constructor(e) {
        this.layer = e;
        const t = e.getRenderer();
        this.graphics = t.regl || t.device, this.renderer = new wr(this.graphics), this._leafScene = new Pr;
        const n = new Uint8Array(16);
        n.fill(255), this._emptyTileTexture = this.graphics.texture({
            width: 2,
            height: 2,
            data: n
        }), this._resLoader = new Mr(this._emptyTileTexture), this._createEmptyTerrainGeo();
    }
    setToRedraw() {
        this.layer.getRenderer().setToRedraw();
    }
    getMap() {
        return this.layer.getMap();
    }
    startFrame(e) {
        e && e.states && e.states.includesChanged && (this.shader.dispose(), delete this.shader), 
        this.shader || this.initShader(e), this._leafScene.clear();
    }
    createTerrainMesh(e, t) {
        const {mesh: n, image: r} = t;
        let i = t.terrainMesh;
        const {positions: s, texcoords: o, triangles: a, empty: l} = n;
        if (i && i.geometry !== this._emptyTerrainGeometry) i.geometry.updateData("aPosition", s), 
        i.geometry.updateData("aTexCoord", o), i.geometry.setElements(a), i.geometry.generateBuffers(this.graphics); else {
            const e = l ? this._emptyTerrainGeometry : new Ye({
                aPosition: s,
                aTexCoord: o
            }, a, 0);
            e !== this._emptyTerrainGeometry && e.generateBuffers(this.graphics), i ? i.geometry = e : i = new xr(e, null, {
                disableVAO: !0
            });
        }
        if (!i.uniforms.skin) {
            const e = this.getEmptyTexture();
            i.setUniform("skin", e);
        }
        if (!i.uniforms.flatMask) {
            const e = this.getEmptyTexture();
            i.setUniform("flatMask", e);
        }
        return i.setUniform("heightTexture", r), this.prepareMesh(i, e, t), i;
    }
    _updateMaskDefines(e) {
        const t = this.layer.getRenderer();
        t && t.updateMaskDefines(e);
    }
    _getPositionMatrix(e) {
        const t = this._getHeightScale(), n = c.identity(e);
        return c.scale(n, n, [ 1, 1, t ]), n;
    }
    _getHeightScale() {
        let e = this.layer.options.exaggeration;
        return xl(e) && (e = 1), this._getPointZ(100) / 100 * e;
    }
    _getLocalTransform(e, t, n) {
        const r = this.getMap(), i = this.layer.getTileSize().width, s = t.res / r.getGLRes(), o = i / (n - 1), {extent2d: a, offset: l} = t;
        h.set(_h, (a.xmin - l[0]) * s, (t.extent2d.ymax - l[1]) * s, 0);
        const d = c.identity(e);
        return c.translate(d, d, _h), h.set(ph, s * o, s * o, 1), c.scale(d, d, ph), d;
    }
    prepareMesh(e, t, n) {
        if (!e.isValid()) return;
        const {mesh: r} = n;
        this._updateMaskDefines(e);
        const {triangles: i, numTrianglesWithoutSkirts: s, terrainWidth: o} = r;
        e.localTransform = this._getLocalTransform(e.localTransform || [], t, o), e.positionMatrix = this._getPositionMatrix(e.positionMatrix || []), 
        e.properties.skirtOffset = 3 * s, e.properties.skirtCount = i.length - 3 * s, e.properties.z = t.z, 
        e.properties.minHeight = r.minHeight, e.properties.maxHeight = r.maxHeight, e.properties.terrainWidth = o, 
        e.castShadow = !1, Sl(e.uniforms, "minAltitude") || Object.defineProperty(e.uniforms, "minAltitude", {
            enumerable: !0,
            get: () => n.minAltitude || 0
        });
    }
    addTerrainImage(e, t) {
        const n = t.terrainMesh;
        n && n.geometry && t.skin && (n.setUniform("skin", t.skin.color[0]), n.setUniform("flatMask", t.mask.color[0]), 
        n.setUniform("polygonOpacity", 1), this._leafScene.addMesh(n));
    }
    endFrame(e) {
        this.updateIBLDefines(this.shader);
        let t = 0;
        const n = this.getUniformValues(), r = this._getRenderFBO(e);
        return this.shader.filter = e && e.sceneFilter, mh(n, e), this._leafScene.getMeshes().forEach((e => {
            this._updateMaskDefines(e);
        })), t += this.renderer.render(this.shader, n, this._leafScene, r), t;
    }
    delete() {
        this.shader && (this.shader.dispose(), delete this.shader), this._emptyTileTexture && (this._emptyTileTexture.destroy(), 
        delete this._emptyTileTexture), this._emptyTerrainGeometry && (this._emptyTerrainGeometry.dispose(), 
        delete this._emptyTerrainGeometry);
    }
    deleteMesh(e) {
        if (!e) return;
        const t = e.geometry;
        e.dispose(), t !== this._emptyTerrainGeometry && t.dispose();
    }
    initShader(e) {
        const t = [], n = [], r = {}, i = [];
        fh(r, i, e), this.shader = new Yi({
            name: "terrain-mesh",
            vert: "#define SHADER_NAME TERRAIN_MESH\nattribute vec3 aPosition;\nattribute vec2 aTexCoord;\nuniform float minAltitude;\nuniform mat4 projViewModelMatrix;\nuniform mat4 projMatrix;\nuniform mat4 modelMatrix;\nuniform mat4 modelViewMatrix;\nuniform mat4 positionMatrix;\nuniform float heightScale;\nvarying vec2 vUv;\nuniform sampler2D flatMask;\n#include <common_pack_float>\n#include <mask_vert>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_vert>\n#endif\nvoid main() {\n  vec2 c = aTexCoord;\n  c.y = 1. - c.y;\n  vec4 d = texture2D(flatMask, c);\n  float e = aPosition.z;\n  if(length(d) < 2.) {\n    float f = decodeFloat32(d);\n    e = min(aPosition.z, f);\n  }\n  vec4 h = vec4(aPosition.xy, (e + minAltitude) * heightScale, 1.);\n  h = positionMatrix * h;\n#ifdef HAS_MASK_EXTENT\ngl_Position = projMatrix * getMaskPosition(h, modelMatrix);\n#else\ngl_Position = projViewModelMatrix * h;\n#endif\nvUv = aTexCoord;\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nshadow_computeShadowPars(h);\n#endif\n}",
            frag: "#define SHADER_NAME TERRAIN_MESH\nprecision mediump float;\nuniform sampler2D skin;\nuniform float polygonOpacity;\nuniform float layerOpacity;\nvarying vec2 vUv;\n#include <mask_frag>\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\n#include <vsm_shadow_frag>\n#endif\nvoid main() {\n  vec2 c = vec2(vUv);\n  c.y = 1. - c.y;\n  vec4 d = texture2D(skin, c);\n#if defined(HAS_SHADOWING) && !defined(HAS_BLOOM)\nfloat e = shadow_computeShadow();\n  d.rgb = shadow_blend(d.rgb, e).rgb;\n#endif\ngl_FragColor = d * polygonOpacity * layerOpacity;\n#ifdef HAS_MASK_EXTENT\ngl_FragColor = setMask(gl_FragColor);\n#endif\n}",
            wgslVert: "",
            wgslFrag: "",
            uniforms: i.concat([ {
                name: "modelViewMatrix",
                type: "function",
                fn: function(e, t) {
                    return c.multiply(n, t.viewMatrix, t.modelMatrix);
                }
            }, {
                name: "projViewModelMatrix",
                type: "function",
                fn: function(e, n) {
                    return c.multiply(t, n.projViewMatrix, n.modelMatrix);
                }
            } ]),
            defines: r,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    getExtraCommandProps() {
        const e = this.layer.getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => e ? e.width : 1,
                height: () => e ? e.height : 1
            },
            cull: {
                enable: !0,
                face: "back"
            },
            depth: {
                enable: !0,
                mask: () => !!this.layer.options.depthMask,
                func: this.layer.options.depthFunc || "<="
            },
            blend: {
                enable: !0,
                func: {
                    src: this.layer.options.blendSrc,
                    dst: this.layer.options.blendDst
                },
                equation: "add"
            }
        };
    }
    _getRenderFBO(e) {
        return e && e.renderTarget && e.renderTarget.fbo;
    }
    getUniformValues() {
        const e = this.getMap(), t = e.projViewMatrix, n = this.layer.getRenderer().getMaskUniforms();
        let r = this.layer.options.opacity;
        xl(r) && (r = 1);
        const i = {
            viewMatrix: e.viewMatrix,
            projMatrix: e.projMatrix,
            projViewMatrix: t,
            heightScale: 1,
            layerOpacity: r
        };
        return vl(i, n), i;
    }
    _getPointZ(e) {
        const t = this.layer.getMap();
        if (!t) return null;
        return t.altitudeToPoint(e, t.getGLRes());
    }
    getEmptyTexture() {
        return this._emptyTileTexture;
    }
    hasIBL() {
        const e = this.getMap().getLightManager();
        return !!(e && e.getAmbientResource());
    }
    updateIBLDefines(e) {
        const t = e.shaderDefines;
        let n = !1;
        this.hasIBL() ? t[[ "HAS_IBL_LIGHTING" ]] || (t.HAS_IBL_LIGHTING = 1, n = !0) : t[[ "HAS_IBL_LIGHTING" ]] && (delete t.HAS_IBL_LIGHTING, 
        n = !0), n && (e.shaderDefines = t);
    }
    _createEmptyTerrainGeo() {
        const e = uh, {positions: t, texcoords: n, triangles: r} = e;
        this._emptyTerrainGeometry = new Ye({
            aPosition: t,
            aTexCoord: n
        }, r, 0), this._emptyTerrainGeometry.generateBuffers(this.graphics);
    }
}

const {getIBLResOnCanvas: xh, getPBRUniforms: yh, loginIBLResOnCanvas: bh, logoutIBLResOnCanvas: wh} = Ta.PBRUtils, Th = {
    baseColorFactor: [ 1, 1, 1, 1 ],
    emissiveFactor: [ 0, 0, 0 ],
    baseColorIntensity: 1,
    emitColorFactor: 1,
    roughnessFactor: 1,
    metallicFactor: 0,
    emitMultiplicative: 1,
    outputSRGB: 1,
    hsv: [ 0, 0, 0 ],
    contrast: 1,
    alphaTest: 0
};

class Sh extends vh {
    constructor(...e) {
        super(...e), this.createIBLTextures(), this._matVer = 0;
    }
    updateMaterial(e, t) {
        this._matVer = t, this._material = this._material || {}, vl(this._material, e), 
        this.setToRedraw();
    }
    setMaterial(e, t) {
        this._matVer = t, this._material = vl({}, Th, e), this.setToRedraw();
    }
    createIBLTextures() {
        const e = this.getMap().getRenderer().canvas;
        bh(e, this.graphics, this.getMap()), this.layer.fire("iblupdated");
    }
    disposeIBLTextures() {
        const e = this.getMap().getRenderer().canvas;
        wh(e, this.getMap());
    }
    createTerrainMesh(e, t) {
        const {mesh: n, image: r} = t, {positions: i, texcoords: s, triangles: o, leftSkirtIndex: a, rightSkirtIndex: l, bottomSkirtIndex: c, numVerticesWithoutSkirts: h, tangents: d} = n, u = new Int8Array(i.length);
        for (let e = 2; e < u.length; e += 3) e < 3 * h ? u[e] = 1 : e < a / 2 * 3 ? u[e - 2] = -1 : e < l / 2 * 3 ? u[e - 2] = 1 : u[e - 1] = e < c / 2 * 3 ? -1 : 1;
        const f = new Ye({
            aPosition: i,
            aTexCoord: s,
            aNormal: u
        }, o, 0);
        let m;
        f.createTangent("aTangent", d), delete f.data.aNormal, f.generateBuffers(this.graphics), 
        m = r ? this.graphics.texture({
            width: r.width,
            height: r.height,
            data: r,
            min: "linear",
            mag: "linear"
        }) : this.getEmptyTexture();
        const g = this.getEmptyTexture(), _ = vl({}, Th, this.layer.options.material || {});
        _.skinTexture = g, _.terrainHeightTexture = m;
        const p = new Ta.StandardMaterial(_), v = new xr(f, p);
        if (v.properties.matVer = this._matVer, !v.uniforms.flatMask) {
            const e = this.getEmptyTexture();
            v.setUniform("flatMask", e);
        }
        const x = v.defines;
        return x.HAS_UV_FLIP = 1, x.HAS_TERRAIN_NORMAL = 1, x.HAS_MAP = 1, x.HAS_LAYER_OPACITY = 1, 
        x.HAS_TERRAIN_FLAT_MASK = 1, v.defines = x, this.prepareMesh(v, e, t), v;
    }
    addTerrainImage(e, t) {
        const n = t.terrainMesh;
        if (n) {
            if (this._material && n.properties.matVer !== this._matVer) {
                for (const e in this._material) n.material.set(e, this._material[e]);
                n.properties.matVer = this._matVer;
            }
            t.skin && n.material.set("skinTexture", t.skin.color[0]), t.mask && n.setUniform("flatMask", t.mask.color[0]), 
            n.setUniform("polygonOpacity", 1), this._leafScene.addMesh(n);
        }
    }
    getUniformValues() {
        const e = this.getMap(), t = e.getRenderer().canvas, {iblTexes: n, dfgLUT: r} = xh(t), i = yh(e, n, r), s = this.layer.getTileSize().width, o = this.layer.getRenderer().getMaskUniforms();
        let a = this.layer.options.opacity;
        return xl(a) && (a = 1), vl(i, {
            viewMatrix: e.viewMatrix,
            projMatrix: e.projMatrix,
            projViewMatrix: e.projViewMatrix,
            outSize: [ t.width, t.height ],
            polygonFill: [ 1, 1, 1, 1 ],
            terrainHeightMapResolution: [ s, s ],
            terrainResolution: [ t.width, t.height ],
            terrainUnpackFactors: [ 6553.6, 25.6, .1, 1e4 ],
            layerOpacity: a
        }), vl(i, o), i;
    }
    initShader(e) {
        const t = {}, n = [];
        fh(t, n, e), this.shader = new Ta.StandardShader({
            uniforms: n,
            defines: t,
            extraCommandProps: this.getExtraCommandProps()
        });
    }
    delete() {
        return this.disposeIBLTextures(), super.delete();
    }
}

function Mh(e, t, n, r) {
    const i = Ah.call(this, n, r);
    this._projViewMatrix = t;
    const {colorExtent: s, modeExtent: o} = this._extentPass.render(i, t);
    this._maskUniforms = this._maskUniforms || {}, this._maskUniforms.mask_colorExtent = s, 
    this._maskUniforms.mask_extent = e, this._maskUniforms.mask_modeExtent = o, this._maskUniforms.mask_hasFlatOut = kh.call(this, "flat-outside"), 
    this._maskUniforms.mask_hasClipOut = kh.call(this, "clip-outside"), this._maskUniforms.mask_hasVideo = kh.call(this, "video"), 
    this._maskUniforms.mask_heightRatio = n, this._maskUniforms.mask_heightOffset = r, 
    this.setToRedraw();
}

function Ah(e, t) {
    const n = [], r = this.layer.getMasks();
    for (let i = 0; i < r.length; i++) {
        const s = r[i].getMesh(this.regl, e, t);
        s && n.push(s);
    }
    return n;
}

function Ch() {
    if (!this._extentPass || !this._maskUniforms) return;
    const e = this._maskUniforms.mask_heightRatio, t = this._maskUniforms.mask_heightOffset, n = Ah.call(this, e, t);
    this._extentPass.render(n, this._projViewMatrix);
    const r = this.layer.getMasks();
    for (let e = 0; e < r.length; e++) r[e]._update && r[e]._update();
}

function kh(e) {
    const t = this.layer.getMasks();
    for (let n = 0; n < t.length; n++) if (t[n].getMode() === e) return 1;
    return 0;
}

function Oh() {
    const e = this.layer.getMasks();
    if (!e) return !1;
    for (let t = 0; t < e.length; t++) if (e[t]._needUpdate) return e[t]._needUpdate();
    return !1;
}

function Eh(e) {
    return class extends e {
        setMask(e, t, n, r) {
            this.viewport || (this.viewport = {
                x: 0,
                y: 0,
                width: () => this.canvas ? this.canvas.width : 1,
                height: () => this.canvas ? this.canvas.height : 1
            }), this._extentPass ? Mh.call(this, e, t, n, r) : this.regl ? (this._extentPass = new Fs(this.regl, this.viewport), 
            Mh.call(this, e, t, n, r)) : this.layer.once("contextcreate", (() => {
                this._extentPass = new Fs(this.regl, this.viewport), Mh.call(this, e, t, n, r);
            }), this);
        }
        needToRedraw() {
            return !!super.needToRedraw() || !!Oh.call(this);
        }
        getMaskUniforms() {
            return Oh.call(this) && Ch.call(this), this.layer.updateMaskExtent(), this._maskUniforms;
        }
        getMaskDefines() {
            return this._maskDefines || (this._maskDefines = {}), this._maskUniforms && this._maskUniforms.mask_colorExtent ? this._maskDefines.HAS_MASK_EXTENT = 1 : delete this._maskDefines.HAS_MASK_EXTENT, 
            this._maskDefines;
        }
        updateMaskDefines(e) {
            const t = e.getDefines();
            delete t.HAS_MASK_EXTENT;
            vl(t, this.getMaskDefines()), e.setDefines(t);
        }
        _clearMask() {
            this._deleteMaskUniforms(), this._extentPass && (this._extentPass.dispose(), delete this._extentPass), 
            this.setToRedraw();
        }
        _deleteMaskUniforms() {
            delete this._maskUniforms;
        }
    };
}

class Ph {
    constructor(e, t) {
        this.max = e, this.onRemove = t, this.reset();
    }
    reset() {
        if (this.data) {
            const e = this.data.values();
            for (const t of e) this.onRemove(t);
        }
        return this.data = new Map, this;
    }
    clear() {
        this.reset(), delete this.onRemove;
    }
    add(e, t) {
        return t ? (this.has(e) ? (this.data.delete(e), this.data.set(e, t)) : this.data.set(e, t), 
        this) : this;
    }
    keys() {
        const e = new Array(this.data.size);
        let t = 0;
        const n = this.data.keys();
        for (const r of n) e[t++] = r;
        return e;
    }
    has(e) {
        return this.data.has(e);
    }
    getAndRemove(e) {
        if (!this.has(e)) return null;
        const t = this.data.get(e);
        return this.data.delete(e), t;
    }
    get(e) {
        if (!this.has(e)) return null;
        return this.data.get(e);
    }
    pop() {
        if (this.data.size < this.max) return null;
        const e = this.data.keys().next();
        return this.data.get(e.value).current ? (this.max += Math.ceil(this.max / 2), null) : this.getAndRemove(e.value);
    }
    remove(e) {
        if (!this.has(e)) return this;
        const t = this.data.get(e);
        return this.data.delete(e), this.onRemove(t), this;
    }
    resetCurrent(e) {
        this.data && this.data.forEach((t => {
            t.current = e;
        }));
    }
}

const {TileLayerRendererable: Ih, LayerAbstractRenderer: Rh} = e.renderer, Lh = new e.Point(0, 0), Fh = new e.Point(0, 0), Hh = new e.PointExtent(0, 0, 0, 0), Dh = new e.Point(0, 0), Nh = {
    color: [ 0, 0, 0, 0 ],
    depth: 1,
    stencil: 0
}, Bh = {
    color: [ 1, 1, 1, 1 ],
    depth: 0,
    stencil: 0
};

class Uh extends(Eh(Ih(Rh))){
    constructor(...e) {
        super(...e), this.init();
    }
    isDrawable() {
        return !0;
    }
    getTempTileOnLoading(e, t) {
        if (t.image && !t.image.reset) return t;
        this._debugTile(e, "getTempTileOnLoading");
        const n = this._createTerrainFromParent(e);
        return n.temp = !0, t.image || (t.image = n), delete t.image.reset, t.current = !0, 
        t.info = e, vl(t.image, n), this._createMesh(t.image, e), t;
    }
    _resetTerrainImage(e, t, n) {
        t.reset = !0, delete t.data, delete t.loadTime, delete t.rendered, delete t.minAltitude;
        const r = e.id + "-temp", i = t.skinImages;
        if (i) for (let e = 0; e < i.length; e++) {
            const t = i[e];
            if (t) {
                for (let e = 0; e < t.length; e++) {
                    const i = t[e];
                    i && (i.refs.delete(r), i.refs.size || n.push(i));
                }
                delete t.currentSkins, delete t.tileIds;
            }
        }
        delete t.sourceZoom, delete t.skinImages, delete t.skinStatus, delete t.skinTileIds, 
        t.debugTexture && (t.debugTexture.destroy(), delete t.debugTexture);
    }
    _createTerrainFromParent(e, t) {
        for (t = t || this.findParentTile(e); t && t.image && (-1 === t.image.sourceZoom || t.image.originalError); ) t = this.findParentTile(t.info);
        const n = e.res, r = this.getMap().pointAtResToDistance(1, 1, n), i = t && t.image && t.image.data && this._clipParentTerrain(t, e), s = i && -1 !== t.image.sourceZoom ? t.info.z : -1;
        if (!i || i.width <= 1) {
            const n = this._findTileMinAltitude(e, t);
            return {
                data: hh(n || 0, 5),
                minAltitude: n,
                mesh: uh,
                sourceZoom: s
            };
        }
        const o = i.width;
        return {
            data: i,
            mesh: rh(r / 2, i.data, o),
            sourceZoom: s,
            colorsTexture: i.colorsTexture
        };
    }
    _findTileMinAltitude(e, t) {
        if (t && t.minAltitude) return t.minAltitude;
        const {idx: n, idy: r, z: i} = e;
        for (let e = -1; e <= 1; e++) for (let t = -1; t <= 1; t++) {
            if (0 === e && 0 === t) continue;
            const s = this.layer.getTileId(n + e, r + t, i), o = this.layer.tileInfoCache, a = o && o.get(s);
            if (a && a.minAltitude) return a.minAltitude;
        }
        return 0;
    }
    consumeTile(e, t) {
        if (this._debugTile(t, "consumeTile"), e.empty && !e.mesh) {
            const n = this.findParentTile(t);
            if (!n || n.image && n.image.empty) {
                e.mesh = uh;
                const n = this._findTileMinAltitude(t);
                e.data = hh(n || 0, 5), e.minAltitude = n, e.sourceZoom = -1;
            } else Wh(t, e = this._createTerrainFromParent(t, n));
        }
        this._createMesh(e, t), super.consumeTile(e, t), this._recenterMapOnTerrain(t);
    }
    _createMesh(e, t) {
        if (e && e.mesh) {
            e.terrainMesh = this._painter.createTerrainMesh(t, e), t.minAltitude = e.data.min, 
            t.maxAltitude = e.data.max, delete e.mesh;
            const n = this.layer.tileInfoCache;
            if (n && t.parent && !e.empty && !e.temp) {
                const e = n.get(t.parent);
                if (e) {
                    const {minAltitude: n, maxAltitude: r} = t;
                    (void 0 === e.minAltitude || e.minAltitude > n) && (e.minAltitude = n), (void 0 === e.maxAltitude || e.maxAltitude < r) && (e.maxAltitude = r);
                }
            }
        }
    }
    _recenterMapOnTerrain(e) {
        const t = this.getMap();
        if (t.updateCenterAltitude && void 0 === t.centerAltitude && e.z === this.getCurrentTileZoom()) {
            const n = t._getPrjCenter(), r = t._prjToPointAtRes(n, e.res, Dh);
            e.extent2d.contains(r) && t.updateCenterAltitude();
        }
    }
    draw(e, t) {
        this._createPainter(), this._painter.startFrame(t), super.draw(e, t), this._endFrame(t);
    }
    drawTile(e, t) {
        const n = this.getMap();
        if (!e || !n || !t) return;
        if (!this.drawingCurrentTiles && !this.drawingChildTiles) return;
        this._debugTile(e, "drawTile");
        let r = this.drawingCurrentTiles ? this.getTileOpacity(t) : 1;
        r *= this.layer.options.opacity || 1, this._painter.addTerrainImage(e, t, r);
    }
    _drawTiles(e, t, n, r, i, s, o) {
        const a = [];
        this._newTerrainTileCounter = 0;
        const l = this.layer.getSkinCount(), c = new Set;
        if (o && o.length) {
            Ml(s, o.map((e => e.info)));
            for (let e = 0; e < l; e++) this._renderChildTerrainSkin(e, o, c, a);
        }
        Ml(e, this._getTempTilesForMissed(s, a)), this._debugTile(e, "drawTiles");
        for (let t = 0; t < l; t++) this._renderChildTerrainSkin(t, e, c, a);
        for (let t = 0; t < e.length; t++) this._renderTerrainMeshSkin(e[t].info, e[t].image);
        for (let e = 0; e < a.length; e++) a[e] && a[e].texture && !a[e].refs.size && (this._skinImageCache.delete(a[e].tile.id), 
        this._deleteSkinImage(a[e]));
        return this._clearCachdeSkinImages(), super._drawTiles(...arguments);
    }
    _getTempTilesForMissed(e, t) {
        const n = [];
        let r = this._tempTilesPool;
        r || (r = this._tempTilesPool = new Ph(this.layer.options.tempTileCacheSize, (e => {
            const {info: t, image: n} = e;
            this._deleteTerrainImage(t, n);
        }))), r.resetCurrent(!1);
        for (let i = 0; i < e.length; i++) {
            const s = e[i];
            let o;
            this._debugTile(s, "getTempTilesForMissed"), r.has(s.id) ? o = r.getAndRemove(s.id) : (o = r.pop(), 
            o ? o.image && (this._resetTerrainImage(o.info, o.image, t), o.image.temp = !0) : o = {
                info: s
            }), o.current = !0, r.add(s.id, o), n.push(o);
        }
        for (let t = 0; t < e.length; t++) this.getTempTileOnLoading(e[t], n[t]);
        return n;
    }
    _clearCachdeSkinImages() {
        if (!this._skinImageCache) return;
        const e = this.getCurrentTimestamp();
        if (this._clearSkinImageTimestamp && e - this._clearSkinImageTimestamp < 1e3) return;
        const t = new Set;
        for (const e of this.tileCache.data.values()) this._collectSkinImages(e, t);
        for (const e in this.tilesInView) {
            const n = this.tilesInView[e];
            this._collectSkinImages(n, t);
        }
        if (this._tempTilesPool) for (const e of this._tempTilesPool.data.values()) this._collectSkinImages(e, t);
        t.size && (this._skinImageCache.forEach(((e, n) => {
            t.has(n) || (console.log("deleted:", n), this._deleteSkinImage(this._skinImageCache.get(n)), 
            this._skinImageCache.delete(n));
        })), this._clearSkinImageTimestamp = e);
    }
    _collectSkinImages(e, t) {
        const n = e.image && e.image.skinImages;
        if (n && n.length) for (let e = 0; e < n.length; e++) {
            const r = n[e] && n.currentSkins;
            if (r) for (const e of r) t.add(e);
        }
    }
    _renderChildTerrainSkin(e, t, n, r) {
        const i = this.layer.getSkinLayer(e).getRenderer();
        if (!i) return;
        const s = [];
        for (let i = 0; i < t.length; i++) {
            const {info: o, image: a} = t[i];
            this._prepareMask(o, a), this._debugTile(o, "renderChildTerrainSkin");
            let l = !1;
            if (this._prepareChildTerrainSkin(e, o, a, r)) {
                const t = a.skinImages[e];
                for (let e = 0; e < t.length; e++) {
                    const r = t[e].tile.info.id;
                    n.has(r) || (!l && t[e].layer.hasTerrainMask && (this._clearMask(a.mask), l = !0), 
                    t[e].terrainMaskFBO = a.mask, s.push(t[e]), n.add(r));
                }
            }
        }
        i.renderTerrainSkin(this.device, this.layer, s);
    }
    _prepareMask(e, t) {
        t.mask || (t.mask = this._createTerrainMaskTexture(e, t), t.mask.id = e.id);
    }
    _clearMask(e) {
        Bh.framebuffer = e, this.device.clear(Bh);
    }
    _prepareChildTerrainSkin(e, t, n, r) {
        const i = this.getMap();
        if (delete n.path, !t || !i || !n) return !1;
        if (!n.terrainMesh) return !1;
        const s = this.layer.getSkinLayer(e), o = s.getRenderer();
        if (!o) return !1;
        n.skinImages || (n.skinImages = []), n.skinStatus || (n.skinStatus = []), n.skinTileIds || (n.skinTileIds = []);
        const a = o.isAnimating && o.isAnimating(), l = n.skinStatus[e], c = o.needToRefreshTerrainTileOnZooming && o.needToRefreshTerrainTileOnZooming(), h = a || c && n.renderedZoom !== i.getZoom();
        if (l && !h) return !1;
        const d = s.getSpatialReference(), {x: u, y: f, z: m, res: g, offset: _} = t;
        let p = t.nw;
        p || (p = t.nw = this.getMap().pointAtResToCoord(t.extent2d.getMin(Lh), t.res));
        const v = this.layer.getTileSize().width;
        let {res: x, zoom: y} = lh(d, m, g);
        let b = ah(x, s.getTileSize().width, g, v), w = n.skinTileIds[e];
        if (!w) {
            const t = this.layer._getTileConfig().tileSystem.scale.y, r = s.options.maxAvailableZoom;
            !xl(r) && r >= 0 && y > r && (b *= Math.pow(2, r - y), y = r), w = n.skinTileIds[e] = ih(s, u, f, y, p, _, t, b, 1);
        }
        const T = w[0];
        let S = !0;
        const M = [];
        for (let e = 0; e < T.length; e++) {
            const t = o.getCachedTile(T[e], !1);
            if (t) M.push(t); else {
                S = !1;
                const t = o.findParentTile(T[e]);
                t && M.push(t);
            }
        }
        const A = n.skinImages[e] || [];
        A.currentSkins = A.currentSkins || new Set;
        const C = new Set;
        let k = !1;
        for (let e = 0; e < A.length; e++) {
            if (!A[e].tile) {
                k = !0;
                continue;
            }
            const t = A[e].tile.info.id;
            C.add(t);
        }
        if (!M.length) return A.currentSkins.clear(), n.skinImages[e] = [], !1;
        const O = M.map((e => e.info.id)).join();
        if (!h && !k && A.tileIds === O) return !1;
        A.tileIds = O;
        let E = !1;
        A.currentSkins.clear(), A.length = 0;
        const P = A.currentSkins;
        let I = t.id;
        n.temp && (I += "-temp");
        for (let e = 0; e < M.length; e++) {
            const t = M[e].info.id;
            P.add(t);
            let n = this._getCachedSkinImage(t);
            n && ((R = n) && R.texture) || (n = {
                tile: vl({}, M[e]),
                layer: s,
                refs: new Set,
                texture: o.createTerrainTexture(this.device)
            }, this._saveCachedSkinImage(t, n)), n.refs.add(I), A.push(n), E = !0;
        }
        var R;
        return this._clearPrevSkinImages(t, n, C, P, r), E && this._newTerrainTileCounter++, 
        n.skinImages[e] = A, s.fire("renderterrainskin", {
            tile: t,
            skinTiles: M
        }), S && (n.skinStatus[e] = 1), !0;
    }
    _clearPrevSkinImages(e, t, n, r, i) {
        if (!n.size) return;
        let s = e.id;
        t.temp && (s += "-temp");
        for (const e of n) if (!r || !r.has(e)) {
            const t = this._getCachedSkinImage(e);
            this._deleteCachedSkinImage(t, s, i);
        }
    }
    _getCachedSkinImage(e) {
        return this._skinImageCache || (this._skinImageCache = new Map), this._skinImageCache.get(e);
    }
    _saveCachedSkinImage(e, t) {
        this._skinImageCache.set(e, t);
    }
    _renderTerrainMeshSkin(e, t) {
        const n = this.getMap();
        if (!e || !n || !t) return;
        this._debugTile(e, "_renderTerrainMeshSkin");
        const r = this._needRefreshTerrainSkins(t.renderedZoom);
        if (t.rendered && !r) return;
        t.skin ? (Nh.framebuffer = t.skin, this.device.clear(Nh)) : (t.skin = this._createTerrainTexture(e, t), 
        this._prepareMask(e, t)), this._initSkinShader();
        const i = this.layer.options.debug, s = [], o = i && [], a = this.layer.getTileSize().width, l = t.skinImages;
        if (l) for (let t = 0; t < l.length; t++) {
            const n = l[t];
            for (let t = 0; t < n.length; t++) {
                const {tile: r, texture: i, layer: o} = n[t];
                if ((r.info.offset[0] || r.info.offset[1]) && e.skinTileIds) {
                    const t = e.skinTileIds[o.getId()];
                    for (let e = 0; e < t.length; e++) if (r.info.x === t[e].x && r.info.y === t[e].y) {
                        r.info.offset = t[e].offset;
                        break;
                    }
                }
                const l = zh(e, r, a), c = n[t].skinMesh || new xr(this._skinGeometry);
                c.setUniform("skinTexture", i);
                const h = o.getOpacity();
                c.setUniform("opacity", xl(h) ? 1 : h), c.setUniform("skinDim", l), c.setUniform("tileSize", a), 
                c.setUniform("x", e.x), c.setUniform("y", e.y), n[t].skinMesh = c, s.push(c);
            }
        }
        if (i) {
            const n = t.skinDebugMesh || new xr(this._skinGeometry);
            n.setUniform("tileSize", a);
            const r = t.debugTexture || this._createDebugTexture(e, a, t.temp);
            t.debugTexture = r, t.skinDebugMesh = n, n.setUniform("opacity", 1), n.setUniform("skinTexture", r), 
            n.setUniform("skinDim", [ 0, 0, 1 ]), n.setUniform("tileSize", a), o.push(n);
        }
        if (s.length) {
            this._skinScene.setMeshes(s);
            try {
                this.renderer.render(this._skinShader, null, this._skinScene, t.skin);
            } catch (e) {
                throw console.error(t), e;
            }
        }
        o && o.length && this.layer.options.debug && (this._skinScene.setMeshes(o), this.renderer.render(this._skinShader, null, this._skinScene, t.skin)), 
        t.rendered = this._isSkinReady(t), t.renderedZoom = n.getZoom();
    }
    _createDebugTexture(e, t, n) {
        t *= 2;
        const {x: r, y: i, z: s} = e, o = `terrain:${r}/${i}/${s}` + (n ? "-temp" : ""), a = document.createElement("canvas");
        a.width = t, a.height = t;
        const l = a.getContext("2d");
        l.font = "60px monospace";
        const c = this.layer.options.debugOutline;
        return l.fillStyle = c, l.strokeStyle = c, l.fillText(o, 20, t - 40), l.beginPath(), 
        l.lineWidth = 4, l.moveTo(0, 0), l.lineTo(t, 0), l.lineTo(t, t), l.lineTo(0, t), 
        l.lineTo(0, 0), l.stroke(), this.device.texture({
            data: a,
            flipY: !0,
            mag: "linear",
            min: "linear"
        });
    }
    _createTerrainMaskTexture() {
        const e = this.device, t = this.layer.getTileSize().width, n = t / 2, r = t / 2, i = e.texture({
            min: "nearest",
            mag: "nearest",
            type: "uint8",
            format: "rgba",
            width: n,
            height: r
        });
        this._terrainMaskDepthStencil || (this._terrainMaskDepthStencil = e.texture({
            width: n,
            height: r,
            format: "depth stencil"
        }));
        const s = {
            width: n,
            height: r,
            colors: [ i ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0
        };
        s.depthStencil = this._terrainMaskDepthStencil;
        const o = e.framebuffer(s);
        return o.colorTex = i, this._clearMask(o), o;
    }
    _createTerrainTexture(t) {
        const n = this.layer.getTileSize().width;
        let r = 2 * n, i = 2 * n;
        const s = this.device, o = t.colorsTexture;
        let a;
        e.Util.isImageBitMap(o) && o.width > 0 ? (r = o.width, i = o.height, a = s.texture({
            data: o,
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: r,
            height: i,
            flipY: !0
        })) : a = s.texture({
            min: "linear",
            mag: "linear",
            type: "uint8",
            width: r,
            height: i,
            flipY: !0
        });
        const l = {
            width: r,
            height: i,
            colors: [ a ],
            colorFormat: "rgba",
            ignoreStatusCheck: !0,
            depthStencil: !1,
            depth: !1,
            stencil: !1
        }, c = s.framebuffer(l);
        return c.colorTex = a, c;
    }
    _endFrame(e) {
        this._painter.endFrame(e) && !Object.keys(this.tilesLoading).length && this.layer.fire("terrainreadyandrender");
    }
    _clipParentTerrain(t, n) {
        const {image: r, info: i} = t, s = r.data, o = s.width, {extent2d: a, res: l} = i, {extent2d: c, res: h} = n, d = a.getWidth(), u = a.getHeight();
        let f = (c.xmin * h / l - a.xmin) / d * (o - 1), m = (a.ymax - c.ymax * h / l) / u * (o - 1);
        const g = (c.xmax * h / l - a.xmin) / d * (o - 1);
        let _ = Math.round(g - f);
        const p = Math.log2(_);
        let v;
        if (_ = Math.pow(2, Math.round(p)) + 1, f = Math.floor(f), m = Math.floor(m), i.colorsTexture) {
            const {width: t, height: n} = i.colorsTexture;
            if (t * n > 0) {
                const r = i.extent2d.xmin, s = i.extent2d.xmax, o = i.extent2d.ymin, d = t / (s - r), u = n / (i.extent2d.ymax - o), f = (c.xmin * h / l - a.xmin) * d, m = (c.xmax * h / l - a.xmin) * d, g = (c.ymin * h / l - a.ymin) * u, _ = (c.ymax * h / l - a.ymin) * u;
                v = function(t, n, r, i, s) {
                    if (e.Browser.decodeImageInWorker) {
                        jh || (jh = new OffscreenCanvas(1, 1));
                        const e = Math.floor(i - n), o = Math.floor(s - r);
                        if (!Vh(e) || !Vh(o)) return;
                        jh.width = e, jh.height = o;
                        const a = jh.getContext("2d");
                        return a.clearRect(0, 0, e, o), a.drawImage(t, n, r, e, o, 0, 0, e, o), jh.transferToImageBitmap();
                    }
                }(i.colorsTexture, f, g, m, _);
            }
        }
        const x = new Float32Array(_ * _);
        let y = 1 / 0, b = -1 / 0;
        for (let e = 0; e < _; e++) for (let t = 0; t < _; t++) {
            let n = e + f, r = t + m;
            n > o - 1 ? n = o - 1 : n < 0 && (n = 0), r > o - 1 ? r = o - 1 : r < 0 && (r = 0);
            const i = s.data[n + r * o];
            x[e + t * _] = i, i < y && (y = i), i > b && (b = i);
        }
        return {
            width: _,
            height: _,
            data: x,
            min: y,
            max: b,
            colorsTexture: v
        };
    }
    getTileOpacity(e) {
        return this._isSkinReady(e) ? super.getTileOpacity(e) : (this.resetTileLoadTime(e), 
        0);
    }
    _isSkinReady(e) {
        const t = this.layer.getSkinCount();
        if (!t) return !0;
        if (!e.skinStatus) return !1;
        for (let n = 0; n < t; n++) if (!e.skinStatus[n]) return !1;
        return !0;
    }
    _needRefreshTerrainSkins(e) {
        const t = this.getMap().getZoom(), n = this.layer.getSkinLayers();
        for (let r = 0; r < n.length; r++) {
            const i = n[r] && n[r].getRenderer();
            if (i) {
                if (i.isAnimating && i.isAnimating()) return !0;
                if (i.needToRefreshTerrainTileOnZooming && i.needToRefreshTerrainTileOnZooming() && e !== t) return !0;
            }
        }
        return !1;
    }
    isValidCachedTile(e) {
        const t = !e.image.skinStatus;
        return e.image && !e.image.temp && (t || this._isSkinReady(e.image));
    }
    isTileComplete(e) {
        return e.image && !e.image.temp && this._isSkinReady(e.image);
    }
    _getTerrainWidth() {
        const e = this.layer.options, t = this.layer.getTileSize().width;
        return xl(e.terrainWidth) ? t / 4 + 1 : e.terrainWidth;
    }
    _getParentTileRequest(e, t) {
        const n = this.layer.options.maxAvailableZoom - this.layer.options.zoomOffset, r = e.z - n, i = Math.pow(2, r), s = Math.floor(e.x / i), o = Math.floor(e.y / i), a = Math.floor(e.idx / i), l = Math.floor(e.idy / i), c = Gh(s, o);
        this._parentRequests || (this._parentRequests = {});
        const h = !this._parentRequests[c];
        return h && t && (this._parentRequests[c] = new Set, this._parentRequests[c].url = this.layer.getTileUrl(s, o, n + this.layer.options.zoomOffset)), 
        {
            x: s,
            y: o,
            idx: a,
            idy: l,
            requests: this._parentRequests[c],
            isFirst: h,
            key: c
        };
    }
    loadTile(t) {
        const n = this.layer, r = this._getTerrainWidth(), i = n.getSpatialReference().getResolution(t.z);
        let s = this.getMap().pointAtResToDistance(1, 1, i);
        const o = n.options.zoomOffset || 0, a = n.options.maxAvailableZoom && n.options.maxAvailableZoom - o;
        if (a && t.z > a) {
            const e = this._createTerrainFromParent(t);
            if (-1 !== e.sourceZoom) return Wh(t, e), this.onTileLoad(e, t), e;
            {
                const {requests: r, isFirst: i, x: o, y: l, idx: c, idy: h} = this._getParentTileRequest(t, !0);
                if (r.add(t), !i) return e;
                const d = t.z - a;
                s *= Math.pow(2, d);
                const u = [ o, l, a, c, h, t.res * Math.pow(2, d), t.error * Math.pow(2, d) ];
                t = n.createTileNode ? n.createTileNode(...u) : n._createTileNode(...u);
            }
        }
        const l = t.url, c = {}, h = n.options, d = n.getTileSize(), u = {
            terrainWidth: r,
            type: h.type,
            accessToken: h.accessToken,
            cesiumIonTokenURL: h.cesiumIonTokenURL,
            error: s,
            colors: h.colors,
            tileSize: d ? [ d.width, d.height ] : [ 256, 256 ],
            command: "loadTile"
        }, f = () => {
            this.workerConn.fetchTerrain(l, u, ((n, r) => {
                if (this._parentRequests) {
                    const e = Gh(t.x, t.y), n = this._parentRequests[e];
                    if (n && n.size) {
                        this.tileCache.add(t.id, {
                            info: t,
                            image: c
                        });
                        for (const e of n) this.removeTileLoading(e);
                    }
                    delete this._parentRequests[e];
                }
                n ? m(n) : (e.Util.extend(c, r), Wh(t, c), this.onTileLoad(c, t));
            }));
        }, m = e => {
            e && e.canceled || (console.warn(e), this.onTileError(c, t));
        };
        return this.loadTileBitmap && bl(this.loadTileBitmap) ? this.loadTileBitmap(l, t, ((e, t) => {
            e ? m(e) : t && t instanceof ImageBitmap ? (u.tileImage = t, f()) : m(new Error("bitmap is not ImageBitmap"));
        }), u) : f(), c;
    }
    deleteTile(e) {
        if (!e || !e.image) return;
        super.deleteTile(e);
        const {info: t, image: n} = e;
        n.temp || (delete t.skinTileIds, this._deleteTerrainImage(e.info, n));
    }
    _deleteTerrainImage(e, t) {
        e && e.colorsTexture && (e.colorsTexture.close && e.colorsTexture.close(), delete e.colorsTexture);
        const n = t.skin;
        n && (n.destroy(), n.colorTex.destroy(), delete n.colorTex);
        const r = t.mask;
        r && (r.destroy(), r.colorTex.destroy(), delete r.colorTex), t.debugTexture && (t.debugTexture.destroy(), 
        delete t.debugTexture, t.skinDebugMesh.dispose(), delete t.skinDebugMesh);
        const i = t.skinImages;
        if (i && i.length) {
            let n = e.id;
            t.temp && (n += "-temp");
            for (let e = 0; e < i.length; e++) {
                const t = i[e];
                if (t) {
                    for (let e = 0; e < t.length; e++) {
                        if (!t[e] || !t[e].tile) continue;
                        const r = t[e].tile.info.id, i = this._skinImageCache && this._skinImageCache.get(r);
                        i && this._deleteCachedSkinImage(i, n);
                    }
                    t.length = 0;
                }
            }
        }
        t.terrainMesh && this._painter.deleteMesh(t.terrainMesh), t.image && t.image.close && t.image.close(), 
        delete t.skinImages, delete t.skin, delete t.mask, delete t.skinStatus, delete t.skinTileIds, 
        delete t.terrainMesh, delete t.image, delete t.data, delete t.mesh, delete t.rendered;
    }
    _deleteCachedSkinImage(e, t, n) {
        e && (e.refs.delete(t), e.refs.size || (n ? n.push(e) : this._deleteSkinImage(e)));
    }
    _deleteSkinImage(e) {
        if (!e || !e.tile) return;
        const t = e.tile.info.id, n = e.layer.getRenderer();
        delete e.canvas, delete e.layer, e.refs.clear(), e.texture && (n ? n.deleteTerrainTexture(e.texture) : e.texture.destroy && e.texture.destroy(), 
        delete e.texture), e.skinMesh && (e.skinMesh.dispose(), delete e.skinMesh), n && (n.removeTileCache && n.removeTileCache(t), 
        n.deleteTile && n.constructor.prototype.deleteTile.call(n, e.tile)), delete e.tile, 
        this._skinImageCache.delete(t);
    }
    _clearSkinImageCache() {
        if (!this._skinImageCache) return;
        const e = this._skinImageCache.keys();
        for (const t of e) {
            const e = this._getCachedSkinImage(t);
            this._deleteSkinImage(e);
        }
        this._skinImageCache.clear();
    }
    abortTileLoading(e, t) {
        const n = this.layer, r = n.options.maxAvailableZoom && n.options.maxAvailableZoom - n.options.zoomOffset, i = (e, t) => {
            this.loadTileBitmap && bl(this.loadTileBitmap) ? this.loadTileBitmap(e, t, (() => {}), {
                command: "abortTile"
            }) : this.workerConn && this.workerConn.abortTerrain(e);
        };
        if (t) if (r && t.z > r) {
            const {requests: e, key: n} = this._getParentTileRequest(t);
            e && e.size && (e.delete(t), e.size || (delete this._parentRequests[n], i(e.url, t)));
        } else t && t.url && i(t.url, t);
        super.abortTileLoading(e, t);
    }
    onTileError(e, t) {
        super.onTileError(e, t);
    }
    _getTerrainTileAtPrjCoord(e) {
        const t = this.getCurrentTileZoom(), n = this.layer.getSpatialReference().getResolution(t), r = this.layer._getTileConfig().getTileIndex(e, n, this.layer.options.repeatWorld);
        return r.z = t, r;
    }
    _queryTerrain(e, t, n, r, i) {
        const s = this.layer.getMinZoom(), o = this._findTerrainData(t, n.x, n.y, n.z, s);
        if (o && o.image && o.image.data) {
            const t = o.info.extent2d, s = o.info.res / i, a = r.x - t.xmin * s, l = t.ymax * s - r.y;
            let c = this._queryAltitudeInHeights(o.image.data, a / (t.getWidth() * s), l / (t.getHeight() * s));
            const h = this.layer._getExaggeration();
            0 !== h && (c *= h), e[0] = c, e[1] = null === c ? 0 : +(o.info.z === n.z);
        } else e[0] = null, e[1] = 0;
        return e;
    }
    _findTerrainData(e, t, n, r, i) {
        e || (e = this.layer._getTileId(t, n, r));
        const s = this.tilesInView[e] || this.tileCache.get(e);
        return !s && r - 1 >= i ? this._findTerrainData(null, Math.floor(t / 2), Math.floor(n / 2), r - 1, i) : s;
    }
    _queryAltitudeInHeights(e, t, n) {
        const {width: r, height: i, data: s} = e, o = Math.floor((r - 1) * t), a = Math.floor((i - 1) * n) * r + o;
        return void 0 === s[a] ? null : s[a];
    }
    _queryTileAltitude(e, t, n) {
        e || (e = {
            tiles: {},
            dirty: !0,
            complete: !1
        });
        const r = this.layer, i = this.getCurrentTileZoom(), s = r.getSpatialReference().getResolution(i), {xmin: o, ymin: a, xmax: l, ymax: c} = t, h = r._getTileConfig();
        Lh.set(o, a)._multi(n);
        const d = h._getTileNum(Lh, n, !0);
        Fh.set(l, c)._multi(n);
        const u = h._getTileNum(Fh, n, !0), f = Math.min(d.x, u.x), m = Math.max(d.x, u.x), g = Math.min(d.y, u.y), _ = Math.max(d.y, u.y), p = n / s;
        Lh.set(o, a)._multi(p), Fh.set(l, c)._multi(p);
        const v = Hh.set(Lh.x, Lh.y, Fh.x, Fh.y), x = r.getTileSize().width + 1;
        v._expand(v.getWidth() / x), e.array = e.array || new Float32Array(x * x);
        const y = e.tiles;
        e.complete = !0, e.array.fill(0);
        for (let t = f; t <= m; t++) for (let n = g; n <= _; n++) {
            const r = this.layer._getTileId(t, n, i);
            if (y[r]) continue;
            const s = this.tileCache.get(r);
            s ? (this._fillAltitudeData(e.array, s, v, x), e.dirty = !0, y[r] = 1) : (e.dirty = e.dirty || void 0 !== e.tiles[r], 
            e.tiles[r] && delete e.tiles[r], e.complete = !1);
        }
        return e;
    }
    _fillAltitudeData(e, t, n, r) {
        const i = t.info.extent2d, s = i.intersection(n), {xmin: o, ymin: a, xmax: l, ymax: c} = s, {data: h} = t.image, d = h.width, u = n.getWidth() / r, f = Math.floor((o - n.xmin) / u), m = Math.floor((a - n.ymin) / u), g = Math.floor((l - n.xmin) / u) - f, _ = Math.floor((c - n.ymin) / u) - m, p = i.getWidth() / d, v = Math.floor((o - i.xmin) / p), x = Math.floor((a - i.ymin) / p), y = Math.floor(u / p);
        for (let t = 0; t <= g; t++) for (let n = 0; n <= _; n++) {
            const i = t + f + (m + n) * r;
            let s = 0;
            for (let e = 0; e < y; e++) for (let r = 0; r < y; r++) {
                const i = (v + Math.floor(t * y)) * d + e + x + Math.floor(n * y) + r;
                s += h.data[i];
            }
            e[i] = s / Math.max(y, 1);
        }
        return e;
    }
    clear() {
        return this.clearTempResources(), this.clearTileCaches(), super.clear();
    }
    clearTempResources() {
        this._tempTilesPool && (this._tempTilesPool.reset(), delete this._tempTilesPool), 
        this._skinImageCache && this._clearSkinImageCache();
    }
    onAdd() {
        super.onAdd(), this.prepareWorker();
    }
    onRemove() {
        this.workerConn && (this.workerConn.removeLayer(this.layer.getId(), (e => {
            if (e) throw e;
        })), this.workerConn.remove(), delete this.workerConn), this.clearTempResources(), 
        this._skinShader && (this._skinShader.dispose(), delete this._skinShader), this._skinGeometry && (this._skinGeometry.dispose(), 
        delete this._skinGeometry), this._terrainMaskDepthStencil && (this._terrainMaskDepthStencil.colorTex && this._terrainMaskDepthStencil.colorTex.destroy(), 
        this._terrainMaskDepthStencil.destroy(), delete this._terrainMaskDepthStencil), 
        delete this._parentRequests, super.onRemove(), this._painter && (this._painter.delete(), 
        delete this._painter);
    }
    prepareWorker() {
        const e = this.layer.getMap();
        this.workerConn || (this.workerConn = new Qc(e.id));
        const t = this.workerConn;
        if (!t.isActive()) return;
        const n = this.layer.options || {}, r = this.layer.getId();
        t.addLayer(r, n, (e => {
            if (e) throw e;
            this.layer && (this.ready = !0, this.setToRedraw(), this.layer.fire("workerready"));
        }));
    }
    initContext() {
        super.initContext();
        const {regl: e, device: t} = this.context;
        this.regl = e, this.device = t || e, this.renderer = new wr(e || t), this.layer.fire("contextcreate", {
            regl: e,
            device: t
        });
    }
    _createPainter() {
        const e = this._painter;
        "lit" === this.layer.options.shader || "pbr" === this.layer.options.shader ? (e && e.constructor === vh || !e) && (e && (e.delete(), 
        this.clear(), this.setToRedraw()), this._painter = new Sh(this.layer), this.layer.fire("paintercreated")) : (e && e.constructor === Sh || !e) && (e && (e.delete(), 
        this.clear(), this.setToRedraw()), this._painter = new vh(this.layer), this.layer.fire("paintercreated"));
    }
    _initSkinShader() {
        if (this._skinShader) return;
        const e = this.layer.getTileSize().width;
        this._skinShader = new Yi({
            name: "terrain-skin",
            vert: "#define SHADER_NAME TERRAIN_SKIN\nattribute vec2 aPosition;\nvoid main() {\n  gl_Position = vec4(aPosition, .0, 1.);\n}",
            frag: "#define SHADER_NAME TERRAIN_SKIN\nprecision mediump float;\nuniform float tileSize;\nuniform sampler2D skinTexture;\nuniform vec3 skinDim;\nuniform float opacity;\nvoid main() {\n  vec2 c = gl_FragCoord.xy / 2.;\n  vec2 d = vec2(tileSize);\n  vec2 e = (c - skinDim.xy) / (d * skinDim.z);\n  if(e.x >= .0 && e.x <= 1. && e.y >= .0 && e.y <= 1.) {\n    gl_FragColor = texture2D(skinTexture, e) * opacity;\n  } else {\n    gl_FragColor = vec4(.0);\n  }\n}",
            wgslVert: "",
            wgslFrag: "",
            extraCommandProps: {
                cull: {
                    enable: !1
                },
                viewport: {
                    x: 0,
                    y: 0,
                    width: 2 * e,
                    height: 2 * e
                },
                depth: {
                    enable: !1
                },
                blend: {
                    enable: !0,
                    func: {
                        src: "one",
                        dst: "one minus src alpha"
                    },
                    equation: "add"
                }
            }
        });
        const t = new Int16Array([ -1, -1, 1, 1, -1, 1, 1, 1, -1, -1, 1, -1 ]);
        this._skinGeometry = this._skinGeometry || new Ye({
            aPosition: t
        }, 0, 6, {
            positionSize: 2
        }), this._skinGeometry.generateBuffers(this.device), this._skinScene = this._skinScene || new Pr;
    }
    updateMaterial(e) {
        this._painter && e && this._painter.updateMaterial && (void 0 === this._matVer && (this._matVer = 1), 
        this._painter.updateMaterial(e, this._matVer++));
    }
    setMaterial(e) {
        this._painter && e && this._painter.setMaterial && (void 0 === this._matVer && (this._matVer = 1), 
        this._painter.setMaterial(e, this._matVer++));
    }
    getAnalysisMeshes() {
        return this._painter && this._painter._leafScene ? this._painter._leafScene.getMeshes() : [];
    }
    _debugTile(e, t, n) {
        if (this.layer.options.debugTile) {
            if (Array.isArray(e)) {
                for (let r = 0; r < e.length; r++) e[r] && this._debugTile(e[r], t + " at " + r, n);
                return;
            }
            if (!e) return;
            const {x: r, y: i, z: s} = this.layer.options.debugTile, {info: o} = e;
            o && (e = o), r === e.x && i === e.y && s === e.z && console.log(`Found debug tile in TerrainLayerRenderer.${t}:`, e);
        }
    }
}

function zh(e, t, n) {
    const {res: r, extent2d: i, offset: s} = e, {info: o} = t, a = o.res / r, l = o.offset, c = o.extent2d.xmin * a, h = o.extent2d.ymin * a, d = s[0] - l[0], u = l[1] - s[1];
    return [ c - i.xmin + d, -(i.ymin - h + u), a * o.tileSize / n ];
}

function Gh(e, t) {
    return e + "-" + t;
}

function Vh(e) {
    return !(e & e - 1) && 0 !== e;
}

let jh;

function Wh(e, t) {
    const n = t.colorsTexture;
    delete t.colorsTexture, n && (e.info ? e.info.colorsTexture = n : e.colorsTexture = n);
}

const qh = {
    "clip-inside": .1,
    "clip-outside": .2,
    "flat-inside": .3,
    "flat-outside": .4,
    "color": .5,
    "texture": .6,
    "elevate": .7
}, Xh = [], Kh = [ 1, 1, 1 ], Zh = {
    polygonFill: [ 255, 0, 0 ],
    polygonOpacity: .8
}, Yh = new t(0, 0), $h = new t(0, 0), Jh = [], Qh = new t(0, 0), ed = new r(0, 0), td = new r(0, 0), nd = new r(0, 0);

class rd extends i {
    getMode() {
        return this._mode;
    }
    remove() {
        const e = this.getLayer();
        return e ? (e.removeMask(this), this._dispose(), super.remove(), this) : this;
    }
    getMesh(e, t, n) {
        return this.isVisible() && this.getLayer() ? (this._mesh || (this._mesh = this._createMesh(e, t, n)), 
        this._updateUniforms(this._mesh, t, n), this._mesh) : null;
    }
    setCoordinates(e) {
        super.setCoordinates(e);
        const t = this.getLayer();
        if (t && (delete t._maskProjViewMatrix, delete t._maskExtentInWorld), !this._mesh) return this;
        const n = this.getMode(), r = this.toGeoJSON();
        r.geometry.coordinates[0].reverse();
        const i = ce.flatten(r.geometry.coordinates), {positions: s, uvs: o, triangles: a} = "texture" === n ? this._createBilinearPOSITON(i) : this._createPOSITION(i), l = this._mesh.geometry;
        if (l.updateData("POSITION", s), l.updateData("TEXCOORD", o), l.setElements(a), 
        this._setLocalTransform(this._mesh), this._copyMesh) {
            const e = this._createPOSITION(ce.flatten(r.geometry.coordinates), !0).positions;
            this._copyMesh.geometry.updateData("POSITION", e), this._setLocalTransform(this._copyMesh);
        }
    }
    _createGeometry(e) {
        const t = this.getMode(), n = this.toGeoJSON();
        n.geometry.coordinates[0].reverse();
        const r = ce.flatten(n.geometry.coordinates), {positions: i, uvs: s, triangles: o} = "texture" === t ? this._createBilinearPOSITON(r) : this._createPOSITION(r), a = this._createPOSITION(ce.flatten(n.geometry.coordinates), !0).positions, l = new Ye({
            POSITION: i,
            TEXCOORD: s
        }, o, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        l.generateBuffers(e);
        const c = new Ye({
            POSITION: a,
            TEXCOORD: s
        }, o, 0, {
            positionAttribute: "POSITION",
            uv0Attribute: "TEXCOORD"
        });
        return c.generateBuffers(e), "texture" === t ? {
            geometry: l,
            copyGeometry: c
        } : l;
    }
    _createPOSITION(e, t) {
        const n = this.getMap(), r = e.dimensions;
        for (let t = 0; t < e.vertices.length; t += r) {
            Qh.x = e.vertices[t], Qh.y = e.vertices[t + 1];
            const r = Ol(n, Qh);
            e.vertices[t] = r[0], e.vertices[t + 1] = r[1];
        }
        const i = Ol(n, this.getCenter()), s = [], o = .01 * this.getLayer().getMasks().indexOf(this), a = "texture" === this.getMode() ? 4 : e.vertices.length / r;
        for (let l = 0; l < a; l++) s.push(e.vertices[l * r] - i[0]), s.push(e.vertices[l * r + 1] - i[1]), 
        s.push(o + t ? n.altitudeToPoint(e.vertices[l * r + 2], n.getGLRes()) : 0);
        return {
            positions: s,
            uvs: this._createTexcoords(e.vertices, r),
            triangles: ce(s, e.holes, 3)
        };
    }
    _createTexcoords(e, t) {
        const n = [ 0, 0, 0, 1, 1, 1, 1, 0 ];
        if (this.hasHoles()) {
            const r = e.length / t * 2;
            for (let e = n.length / 2 - 1; e < r; e += 2) n[e] = n[e + 1] = 0;
        }
        return n;
    }
    _createBilinearPOSITON(e) {
        const t = e.dimensions, n = [], r = [], i = [], s = this.getMap();
        for (let n = 0; n < e.vertices.length; n += t) {
            Qh.x = e.vertices[n], Qh.y = e.vertices[n + 1];
            const t = Ol(s, Qh);
            e.vertices[n] = t[0], e.vertices[n + 1] = t[1];
        }
        const o = Ol(this.getMap(), this.getCenter()), a = {};
        a.a = {
            x: e.vertices[0 * t] - o[0],
            y: e.vertices[0 * t + 1] - o[1]
        }, a.b = {
            x: e.vertices[1 * t] - o[0],
            y: e.vertices[1 * t + 1] - o[1]
        }, a.c = {
            x: e.vertices[2 * t] - o[0],
            y: e.vertices[2 * t + 1] - o[1]
        }, a.d = {
            x: e.vertices[3 * t] - o[0],
            y: e.vertices[3 * t + 1] - o[1]
        }, this._positions = [];
        for (let n = 0; n < 4; n++) this._positions.push(e.vertices[n * t] - o[0]), this._positions.push(e.vertices[n * t + 1] - o[1]), 
        this._positions.push(0);
        for (let e = 0; e <= 20; e++) for (let t = 0; t <= 20; t++) {
            const i = t / 20, s = e / 20, o = (1 - i) * (1 - s) * a.a.x + i * (1 - s) * a.b.x + i * s * a.c.x + (1 - i) * s * a.d.x, l = (1 - i) * (1 - s) * a.a.y + i * (1 - s) * a.b.y + i * s * a.c.y + (1 - i) * s * a.d.y;
            n.push(o, l, 0), r.push(i, 1 - s);
        }
        for (let e = 0; e < 20; e++) for (let t = 0; t < 20; t++) {
            const n = 21 * e + t, r = n + 1, s = 21 * (e + 1) + t, o = s + 1;
            i.push(n, r, o), i.push(n, o, s);
        }
        return {
            positions: n,
            uvs: r,
            triangles: i
        };
    }
    clearMesh() {
        this._dispose(), delete this._mesh, this.maskGeoJSON && (this.maskGeoJSON = null);
    }
    _getMaskMode() {
        return qh[this._mode];
    }
    _getMaskColor() {
        const e = this.getSymbol(), {polygonFill: t, polygonOpacity: n} = e || Zh, r = Cl([], t);
        return r[3] = yl(n) ? n : "texture" === this.getMode() ? 1 : Zh.polygonOpacity, 
        r;
    }
    _altitudeToPoint(e = 0) {
        const t = this.getMap(), n = t.getGLRes();
        return t.altitudeToPoint(e, n);
    }
    _setLocalTransform(e) {
        const t = Ol(this.getMap(), this.getCenter()), n = c.fromRotationTranslationScale(e.localTransform, m.identity(Xh), t, Kh);
        e.localTransform = n;
    }
    _dispose() {
        this._mesh && (this._mesh.material && this._mesh.material.dispose(), this._mesh.geometry && this._mesh.geometry.dispose(), 
        this._copyMesh && this._copyMesh.geometry && (this._copyMesh.geometry.dispose(), 
        this._copyMesh.dispose()), this._mesh.dispose(), delete this._mesh, delete this._copyMesh);
    }
    containsPoint(e) {
        const t = this.getExtent();
        if (Qh.set(e[0], e[1]), !t || !t.contains(Qh)) return !1;
        const n = this.getHoles();
        for (let t = 0; t < n.length; t++) if (this._contains(n[t], e)) return !1;
        const r = this.getShell();
        return this._contains(r, e);
    }
    _contains(e, t) {
        const n = this._calArea(e);
        let r = 0;
        for (let n = 0; n < e.length; n++) {
            Yh.x = e[n].x, Yh.y = e[n].y;
            const i = n + 1 >= e.length ? 0 : n + 1;
            $h.x = e[i].x, $h.y = e[i].y, Qh.x = t[0], Qh.y = t[1], Jh[0] = Qh, Jh[1] = Yh, 
            Jh[2] = $h;
            r += this._calArea(Jh);
        }
        return !(Math.abs(r - n) > 1e-8);
    }
    _calArea(e) {
        const t = this.getMap();
        let n = 0;
        const r = t.getGLRes(), i = t.coordToPointAtRes(e[0], r, ed);
        for (let l = 1; l < e.length - 1; l++) {
            const c = t.coordToPointAtRes(e[l], r, td), h = t.coordToPointAtRes(e[l + 1], r, nd);
            n += (s = i, a = h, (((o = c).x - s.x) * (a.y - s.y) - (o.y - s.y) * (a.x - s.x)) / 2);
        }
        var s, o, a;
        /*!
* Contains code from THREE.js
* MIT License
* https://github.com/mrdoob/three.js
*/        return n;
    }
}

for (var id = [], sd = 0; sd < 6; sd++) id[sd] = [];

var od = [];

function ad(e, t, n) {
    var r, i, s, o, a, l, c, h, d, u, f, m, g, _, p, v, x;
    i = (r = e)[0], s = r[1], o = r[2], a = r[3], l = r[4], c = r[5], h = r[6], d = r[7], 
    u = r[8], f = r[9], m = r[10], g = r[11], _ = r[12], p = r[13], v = r[14], x = r[15], 
    ld(id[0], a - i, d - l, g - u, x - _), ld(id[1], a + i, d + l, g + u, x + _), ld(id[2], a + s, d + c, g + f, x + p), 
    ld(id[3], a - s, d - c, g - f, x - p), ld(id[4], a - o, d - h, g - m, x - v), ld(id[5], a + o, d + h, g + m, x + v);
    for (var y = 0; y < 6; y++) {
        var b = id[y];
        if (od[0] = b[0] > 0 ? t[1][0] : t[0][0], od[1] = b[1] > 0 ? t[1][1] : t[0][1], 
        od[2] = b[2] > 0 ? t[1][2] : t[0][2], cd(b, od) < 0) return !1;
    }
    return !0;
}

function ld(e, t, n, r, i) {
    var s = 1 / Math.sqrt(t * t + n * n + r * r);
    return e[0] = t * s, e[1] = n * s, e[2] = r * s, e[3] = i * s, e;
}

function cd(e, t) {
    return e[0] * t[0] + e[1] * t[1] + e[2] * t[2] + e[3];
}

const hd = new t(0, 0), dd = [ 0, 0, 0 ], ud = [ 0, 0, 0 ], fd = c.identity([ 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0 ]);

function md() {
    return this._maskList ? (this._maskList.forEach((e => {
        e.remove();
    })), this._maskList = [], this.updateMaskExtent(), this) : this;
}

function gd() {
    for (let e = 0; e < this._maskList.length; e++) if (this._maskList[e].isVisible()) return !0;
    return !1;
}

function _d(e) {
    return class extends e {
        removeMask(e) {
            if (!this._maskList) return this;
            if (!e) return md.call(this), this;
            const t = Array.isArray(e) ? e : [ e ];
            for (let e = 0; e < t.length; e++) {
                const n = t[e], r = this._maskList.indexOf(n);
                r > -1 && this._maskList.splice(r, 1);
            }
            return this.updateMaskExtent(), this.fire("removemask", {
                masks: e
            }), this;
        }
        setMask(e) {
            return this.removeMask(null), this._maskList || (this._maskList = []), Array.isArray(e) ? e.forEach((e => {
                this._maskList.push(e);
            })) : this._maskList.push(e), this._maskList.forEach((e => {
                e._bindLayer(this), e._updateCoordinates && e._updateCoordinates();
            })), this.updateMaskExtent(), this.fire("setmask", {
                masks: e
            }), this;
        }
        onAdd() {
            super.onAdd(), this.updateMaskExtent();
        }
        getMasks() {
            return this._maskList || [];
        }
        onGeometryEvent(e) {
            if (!e || !e.target) return;
            "shapechange" === e.type && e.target instanceof rd && e.target.clearMesh(), e.target instanceof rd && this.updateMaskExtent(), 
            super.onGeometryEvent && super.onGeometryEvent(e);
        }
        identifyMask(e, t) {
            if (!this.getMap()) return [];
            if (!this._maskList || !this._maskList.length) return [];
            const n = vl({}, t);
            n.excludeMasks = !0;
            const r = this.identifyAtPoint(e, n), i = r.length && r[0].coordinate;
            if (i) {
                const e = this._maskList;
                if (!e) return [];
                const t = [];
                for (let n = 0; n < e.length; n++) {
                    const r = e[n].getMode();
                    !e[n].containsPoint(i) || "color" !== r && "texture" !== r || t.push(e[n]);
                }
                return t;
            }
            return [];
        }
        remove() {
            this._maskList && this._maskList.length && this._maskList.forEach((e => {
                e.remove();
            })), super.remove();
        }
        updateMask(e) {
            const t = this.getMap(), {projViewMatrix: n, mapExtent: r} = this.getProjViewMatrixInOrtho(e);
            hd.x = r.xmin, hd.y = r.ymin;
            const i = pd(dd, hd, t);
            hd.x = r.xmax, hd.y = r.ymax;
            const s = pd(ud, hd, t);
            return {
                projViewMatrix: n,
                extentInWorld: [ i[0], i[1], s[0], s[1] ]
            };
        }
        getProjViewMatrixInOrtho(e) {
            const t = this.getMap(), n = t.getView(), r = t.getFitZoom(e), i = e.getCenter();
            t.setView({
                center: i,
                zoom: r,
                pitch: 0,
                bearing: 0
            });
            const s = t.getExtent(), o = c.copy(fd, t.projViewMatrix);
            return t.setView(n), {
                mapExtent: s,
                projViewMatrix: o
            };
        }
        updateMaskExtent() {
            if (!this._maskList) return;
            if (!this.getMap()) return;
            const e = this.getRenderer();
            if (e && !this._maskList.length) return void e._clearMask();
            if (e && !gd.call(this)) return e._deleteMaskUniforms(), void e.setToRedraw();
            const t = this.getMaskExtent();
            if (!t) return;
            const {extent: n, ratio: r, minHeight: i} = t, {projViewMatrix: s, extentInWorld: o} = this.updateMask(n);
            this._maskProjViewMatrix = s, this._maskExtentInWorld = o, e ? e.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, r, i) : this.once("renderercreate", (e => {
                e.renderer.setMask(this._maskExtentInWorld, this._maskProjViewMatrix, r, i);
            }));
        }
        getMaskExtent() {
            let e = 1 / 0, t = 1 / 0, n = -1 / 0, r = -1 / 0, i = -1 / 0, o = 1 / 0, a = !1;
            const l = this.getMap();
            for (let s = 0; s < this._maskList.length; s++) {
                const c = this._maskList[s];
                if (!c.isVisible()) continue;
                const h = c.getExtent();
                if (h) {
                    if (c._mesh && c.getBBox) {
                        const e = c.getBBox();
                        if (!ad(l.projViewMatrix, e)) continue;
                    }
                    if (a = !0, h.xmin < e && (e = h.xmin), h.ymin < t && (t = h.ymin), h.xmax > n && (n = h.xmax), 
                    h.ymax > r && (r = h.ymax), c._getHeightRange) {
                        const e = c._getHeightRange();
                        e[0] < o && (o = e[0]), e[1] > i && (i = e[1]);
                    }
                }
            }
            if (!a) return null;
            const {ratio: c, minHeight: h} = function(e, t) {
                const n = e === 1 / 0 ? 0 : e, r = t === -1 / 0 ? 0 : t, i = Math.abs(r - n);
                return 0 === i ? {
                    ratio: 1,
                    minHeight: 0
                } : {
                    ratio: Math.pow(i, -1),
                    minHeight: n
                };
            }(o, i);
            return {
                extent: new s(e, t, n, r),
                ratio: c,
                minHeight: h
            };
        }
    };
}

function pd(e, n, r, i = 0) {
    if (!(r && n instanceof t)) return null;
    const s = r.coordinateToPointAtRes(n, r.getGLRes());
    return e[0] = s.x, e[1] = s.y, e[2] = i, e;
}

const vd = new e.Coordinate(0, 0), xd = new e.Coordinate(0, 0), yd = new e.Point(0, 0), bd = [], wd = {
    tileGrids: [],
    count: 0
}, Td = "01", Sd = "1";

class Md extends(_d(e.TileLayer)){
    constructor(e, t) {
        t && !t.tileSystem && ("cesium" === t.type || "cesium-ion" === t.type ? t.tileSystem = [ 1, 1, -180, -90 ] : "tianditu" === t.type && (t.tileSystem = [ 1, -1, -180, 90 ])), 
        t.tileSize || "mapbox" === t.type && (t.tileSize = 512), t.spatialReference || "mapbox" === t.type && (t.spatialReference = "preset-3857-512"), 
        super(e, t);
    }
    onAdd() {
        const e = this.options, t = this.getMap().getProjection(), n = "EPSG:4326" === t.code || "EPSG:4490" === t.code, r = "EPSG:3857" === t.code;
        512 !== e.tileSize || e.spatialReference || ("mapbox" === e.type ? n ? e.spatialReference = "preset-4326-512" : r && (e.spatialReference = "preset-3857-512") : "cesium" === e.type || "cesium-ion" === e.type ? e.spatialReference = "preset-4326-512" : "tianditu" === e.type && (e.spatialReference = {
            "projection": "EPSG:4326",
            "fullExtent": {
                "top": 90,
                "left": -180,
                "bottom": -90,
                "right": 180
            },
            "resolutions": function() {
                const e = [];
                for (let t = 0; t <= 22; t++) e[t] = 90 / (128 * Math.pow(2, t));
                return e;
            }()
        })), e.terrainWidth || "tianditu" !== e.type || (e.terrainWidth = 65);
    }
    getTileUrl(e, t, n) {
        let r = super.getTileUrl(e, t, n);
        return "mapbox" === this.options.type && this.options.requireSkuToken && (this._skuToken || (this._skuToken = this._createSkuToken()), 
        r.indexOf("?") > -1 ? r += "&sku=" + this._skuToken : r += "?sku=" + this._skuToken), 
        r;
    }
    getMaxAvailableZoom() {
        return this.getSpatialReference().getMaxZoom();
    }
    _createSkuToken() {
        let e = "";
        for (let t = 0; t < 10; t++) e += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
        return [ Sd, Td, e ].join("");
    }
    _getExaggeration() {
        let e = this.options.exaggeration;
        return xl(e) && (e = 1), e;
    }
    setSkinLayers(e) {
        this._skinLayers = e;
        const t = this.getRenderer();
        t && (t.clear(), t.setToRedraw());
    }
    getSkinTiles(t) {
        const n = this.getRenderer();
        if (!n) return wd;
        const r = n.getTileGridsInCurrentFrame().tileGrids[0];
        if (!r) return wd;
        const i = t.getId(), s = this._getTileConfig().tileSystem.scale, o = t.getTileSize().width, a = r.tiles;
        if (!a.length) return wd;
        const l = this.getMap(), c = r.parents || bd, h = c.length, d = c.concat(a), u = t.getSpatialReference(), f = a[0].extent2d.getWidth(), m = s.x, g = s.y, _ = [], p = [], v = new Set, x = this._getTileConfig().tileSystem.scale.y;
        for (let n = 0; n < d.length; n++) {
            const r = d[n], {res: s} = r;
            let a = r.nw;
            a || (a = r.nw = l.pointAtResToCoord(r.extent2d.getMin(yd), r.res));
            const {res: c, zoom: y} = lh(u, r.z, s), b = c / s, w = ah(c, o, s, f), {extent2d: T, offset: S} = r, M = w * r.x, A = w * r.y;
            if (r.skinTileIds || (r.skinTileIds = {}), !r.skinTileIds[i]) {
                const n = new Set, s = [], l = oh(t, r.x, r.y, y, a, S, g, w, 0);
                for (let r = 0; r < l.length; r++) {
                    const i = l[r];
                    if (n.has(i.id)) continue;
                    i.idx = i.x, i.idy = i.y, i.res = c, i.url = t.getTileUrl(i.x, i.y, i.z + t.options.zoomOffset);
                    const a = m * (i.x - M) * o, h = g * (i.skinY - A) * o, d = T.xmin * b + a, u = T.ymax * b + h, f = T.ymin * b + h;
                    i.extent2d = x > 0 ? new e.PointExtent(d, f, d + o, f + o) : new e.PointExtent(d, u - o, d + o, u), 
                    n.add(i.id), s.push(i);
                }
                r.skinTileIds[i] = s;
            }
            const C = r.skinTileIds[i];
            for (let e = 0; e < C.length; e++) v.has(C[e].id) || (n < h ? _.push(C[e]) : p.push(C[e]), 
            v.add(C[e].id));
        }
        return {
            tileGrids: [ {
                extent: r.extent,
                tiles: p,
                parents: _,
                count: p.length
            } ],
            count: p.length
        };
    }
    getSkinLayer(e) {
        return this.getSkinLayers()[e];
    }
    getSkinLayers() {
        return this._skinLayers || bd;
    }
    getSkinCount() {
        return this._skinLayers && this._skinLayers.length || 0;
    }
    queryTerrainByProjCoord(e, t) {
        t = t || [];
        const n = this.getRenderer();
        if (!n) return t[0] = null, t[1] = 0, t;
        const r = this.getMap(), i = n._getTerrainTileAtPrjCoord(e);
        if (!i) return t[0] = null, t[1] = 0, t;
        const s = r._prjToPointAtRes(e, 1, yd);
        return n._queryTerrain(t, i.id, i, s, 1);
    }
    queryTileTerrainByProjCoord(e, t, n, r) {
        r = r || [];
        const i = this.getRenderer();
        if (!i) return r[0] = null, r[1] = 0, r;
        const s = this.getMap()._prjToPointAtRes(e, 1, yd);
        return i._queryTerrain(r, t, n, s, 1);
    }
    queryTileTerrainByPointAtRes(e, t, n, r, i) {
        i = i || [];
        const s = this.getRenderer();
        return s ? s._queryTerrain(i, n, r, e, t) : (i[0] = null, i[1] = 0, i);
    }
    queryTerrain(e, t) {
        t = t || [];
        if (!this.getRenderer()) return t[0] = null, t[1] = 0, t;
        const n = this.getMap().getProjection().project(e, vd);
        return this.queryTerrainByProjCoord(n, t);
    }
    queryTileMesh(e, t) {
        const n = this.getRenderer();
        n && n._queryTileMesh(e, t);
    }
    getTerrainTiles(t, n) {
        const {x: r, y: i, z: s, res: o, offset: a} = n, l = n.extent2d.getWidth(), c = this._getTileConfig(), h = t._getTileConfig(), d = this.getSpatialReference(), {res: u, zoom: f} = lh(d, s, o), m = this.getTileSize().width, g = ah(u, m, o, l);
        let _ = n.nw;
        _ || (_ = n.nw = this.getMap().pointAtResToCoord(n.extent2d.getMin(yd), n.res));
        const p = ih(this, r, i, f, _, a, h.tileSystem.scale.y, g, 1)[0];
        for (let t = 0; t < p.length; t++) {
            const {x: n, y: r} = p[t], i = c.getTilePointNW(n, r, u, yd);
            p[t].res = u, p[t].extent2d = new e.PointExtent(i.x, i.y, i.x + m, i.y - m);
        }
        return p;
    }
    isTerrainTileLoaded(e) {
        const t = this.getRenderer();
        return !!t && t.isTileCached(e);
    }
    updateMaterial(e) {
        if (!e) return;
        this.options.material || (this.options.material = {}), vl(this.options.material, e);
        const t = this.getRenderer();
        t && t.updateMaterial(e);
    }
    setMaterial(e) {
        if (!e) return;
        this.options.material = e;
        const t = this.getRenderer();
        t && t.setMaterial(e);
    }
    _createTileNode(e, t, n, r, i, s, o, a, l, c) {
        const h = this.getMap(), d = this.options.zoomOffset;
        if (!l) {
            l = this._getTileConfig().getTilePrjExtent(e, t, s).convertTo((e => h._prjToPointAtRes(e, s, xd)));
        }
        const u = this._getTileOffset(n);
        return {
            parent: a,
            layer: this.getId(),
            x: e,
            y: t,
            z: n,
            idx: r,
            idy: i,
            res: s,
            extent2d: l,
            id: c || this._getTileId(e, t, n),
            url: this.getTileUrl(e, t, n + d),
            offset: u,
            error: o,
            children: []
        };
    }
}

Md.mergeOptions({
    "forceRenderOnMoving": !0,
    "forceRenderOnZooming": !0,
    "forceRenderOnRotating": !0,
    "fadeAnimation": !1,
    "fadeDuration": 1e3 / 60 * 15,
    "tileLimitPerFrame": 2,
    "newTerrainTileRenderLimitPerFrameOnInteracting": 1,
    "opacity": 1,
    "renderer": "gl",
    "pyramidMode": 1,
    "tileSize": 512,
    "terrainWidth": null,
    "backZoomOffset": 0,
    "depthMask": !0,
    "blendSrc": "one",
    "blendDst": "one minus src alpha",
    "requireSkuToken": !0,
    "cesiumIonTokenURL": "https://api.cesium.com/v1/assets/1/endpoint?access_token=",
    "tileRetryCount": 0,
    "shader": "default",
    "terrainTileMode": !0,
    "tempTileCacheSize": 64,
    "tileStackStartDepth": 7,
    "tileStackDepth": 6,
    "currentTilesFirst": !1,
    "exaggeration": 1,
    "colors": []
}), Md.registerJSONType("TerrainLayer"), Md.registerRenderer("gl", Uh), Md.registerRenderer("gpu", Uh);

const Ad = [], Cd = [], kd = [], Od = [], Ed = new r(0, 0), Pd = [], Id = [], Rd = [], Ld = [], Fd = [], Hd = [], Dd = [], Nd = [], Bd = [];

class Ud {
    constructor(e, t, n = !0) {
        this._from = e, this._to = t, this._isLngLat = n;
    }
    setFromPoint(e) {
        this._from = Array.isArray(e) ? new t(e) : e;
    }
    setToPoint(e) {
        this._to = Array.isArray(e) ? new t(e) : e;
    }
    test(t, n, r = {}) {
        const i = r.count || 0, s = [];
        let o = this._from, a = this._to;
        this._isLngLat && (o = Gd(n, this._from.x, this._from.y, this._from.z), a = Gd(n, this._to.x, this._to.y, this._to.z));
        const l = new e.math.Ray(o, a);
        for (let e = 0; e < t.length; e++) {
            const r = t[e];
            if (!this._checkBBox(r.getBoundingBox(), l)) continue;
            const o = r.localTransform, a = r.geometry, h = a.data[a.desc.positionAttribute].array, d = a.data[a.desc.altitudeAttribute] && a.data[a.desc.altitudeAttribute].array || Pd, u = a.indices;
            if (!(h && h.length && u && u.length)) continue;
            const f = c.multiply(Ld, o, r.positionMatrix), m = this._testMesh(r, l, n, h, d, u, a.desc.positionSize, f, i);
            if (m) {
                const e = {
                    mesh: r,
                    coordinates: m
                };
                if (s.push(e), 0 !== i && s.length >= i) break;
            }
        }
        return s;
    }
    _testMesh(e, t, n, r, i, s, o, a, l) {
        const c = [], d = n.getGLRes();
        for (let u = 0; u < s.length && !(u > e.properties.skirtOffset); u += 3) {
            const e = s[u], f = s[u + 1], m = s[u + 2], g = e * o, _ = f * o, p = m * o;
            Fd[0] = r[g], Fd[1] = r[g + 1], Fd[2] = r[g + 2], Hd[0] = r[_], Hd[1] = r[_ + 1], 
            Hd[2] = r[_ + 2], Dd[0] = r[p], Dd[1] = r[p + 1], Dd[2] = r[p + 2];
            const v = this._toWorldPosition(Cd, n, Fd, i[e] / 100, a), x = this._toWorldPosition(kd, n, Hd, i[f] / 100, a), y = this._toWorldPosition(Od, n, Dd, i[m] / 100, a), b = h.set(Ad, v, x, y), w = h.sub(Id, v, x), T = h.sub(Rd, v, y), S = this._testIntersection(Nd, b, t);
            if (S) {
                const t = n.pointAtResToAltitude(S[2], d);
                Ed.x = S[0], Ed.y = S[1];
                const r = n.pointAtResToCoordinate(Ed, d);
                if (r.z = t, c.push({
                    coordinate: r,
                    indices: [ e, f, m ],
                    normal: h.cross([], w, T)
                }), 0 !== l && c.length >= l) break;
            }
        }
        return c.length ? c : null;
    }
    _toWorldPosition(e, t, r, i, s) {
        let o;
        return n.isNumber(i) ? (o = t.altitudeToPoint(i, t.getGLRes()), d.set(e, r[0], r[1], 0, 1), 
        d.transformMat4(e, e, s), e[2] = o) : (d.set(e, r[0], r[1], r[2], 1), d.transformMat4(e, e, s)), 
        e;
    }
    _testIntersection(e, t, n) {
        return n.intersectTriangle(t[0], t[1], t[2], !0, e);
    }
    _checkBBox(e, t) {
        return !!e && t.intersectBox(e, Bd);
    }
}

const zd = new t(0, 0);

function Gd(e, t, n, r) {
    if (!e) return null;
    zd.set(t, n);
    const i = e.coordinateToPointAtRes(zd, e.getGLRes()), s = e.altitudeToPoint(r || 0, e.getGLRes());
    return [ i.x, i.y, s ];
}

const Vd = () => {}, jd = new e.Coordinate(0, 0), Wd = [ 0, 0, 0 ], qd = [ 0, 0, 0 ], Xd = [ 0, 0, 0 ];

class Kd extends e.Layer {
    static fromJSON(t) {
        if (!t || "GroupGLLayer" !== t.type) return null;
        const n = t.layers.map((t => e.Layer.fromJSON(t)));
        return new Kd(t.id, n, t.options);
    }
    constructor(e, t, n) {
        super(e, n), this.layers = t && t.slice() || [], this.layers.forEach((e => {
            if (e.getMap()) throw new Error(`layer(${e.getId()} is already added on map`);
        })), this._checkChildren(), this.sortLayersByZIndex(), this._layerMap = {};
    }
    sortLayersByZIndex() {
        if (this.layers && this.layers.length) {
            for (let e = 0, t = this.layers.length; e < t; e++) this.layers[e].__group_gl_order = e;
            this.layers.sort(Yd);
        }
    }
    setSceneConfig(e) {
        this.options.sceneConfig = e;
        const t = this.getRenderer();
        return t && t.updateSceneConfig(), this;
    }
    getSceneConfig() {
        return JSON.parse(JSON.stringify(this._getSceneConfig()));
    }
    _getSceneConfig() {
        return this.options.sceneConfig || {};
    }
    getGroundConfig() {
        return this._getSceneConfig().ground;
    }
    getWeatherConfig() {
        return this._getSceneConfig().weather;
    }
    getScanEffectConfig() {
        const e = this._getSceneConfig();
        return e.postProcess && e.postProcess.scanEffect;
    }
    addLayer(e, t) {
        if (e.getMap()) throw new Error(`layer(${e.getId()}) is already added on map`);
        if ("gl" !== e.options.renderer) throw new Error(`layer(${e.getId()})'s renderer is canvas, not supported to be added to GroupGLLayer`);
        void 0 === t ? this.layers.push(e) : this.layers.splice(t, 0, e), this._checkChildren(), 
        this.sortLayersByZIndex();
        const n = this.getRenderer();
        return n ? (this._prepareLayer(e), this._updateTerrainSkinLayers(), n.setToRedraw(), 
        this) : this;
    }
    removeLayer(t) {
        e.Util.isString(t) && (t = this.getChildLayer(t));
        const n = this.layers.indexOf(t);
        if (n < 0) return this;
        const r = t.getRenderer();
        r && r.setTerrainHelper && r.setTerrainHelper(null), t._doRemove(), this._unbindChildListeners(t), 
        delete this._layerMap[t.getId()], this.layers.splice(n, 1);
        const i = this.getRenderer();
        return i ? (this._updateTerrainSkinLayers(), i.setToRedraw(), this) : this;
    }
    clearLayers() {
        const e = this.getLayers();
        for (let t = 0; t < e.length; t++) e[t] && e[t].remove();
        return this;
    }
    _updatePolygonOffset() {
        let e = 0;
        for (let t = 0; t < this.layers.length; t++) {
            const n = this.layers[t];
            n.setPolygonOffset && n.getPolygonOffsetCount && (e += n.getPolygonOffsetCount());
        }
        let t = 0;
        for (let n = this.layers.length - 1; n >= 0; n--) {
            const r = this.layers[n];
            r.setPolygonOffset && r.getPolygonOffsetCount && (r.setPolygonOffset(t, e), t += r.getPolygonOffsetCount());
        }
        this._polygonOffset = t;
    }
    getPolygonOffsetCount() {
        return this._polygonOffset;
    }
    getLayers() {
        return this.layers.slice();
    }
    _getLayers() {
        return this.layers;
    }
    toJSON() {
        const e = [];
        if (this.layers) for (let t = 0; t < this.layers.length; t++) {
            const n = this.layers[t];
            n && (n && n.toJSON && e.push(n.toJSON()));
        }
        return {
            "type": this.getJSONType(),
            "id": this.getId(),
            "layers": e,
            "options": this.config()
        };
    }
    onLoadEnd() {
        this.layers.forEach((e => {
            this._prepareLayer(e);
        })), this.options.terrain && this._initTerrainLayer(), super.onLoadEnd();
    }
    _prepareLayer(e) {
        const t = this.getRenderer();
        this._layerMap[e.getId()] = e, e._canvas = t.canvas, e._bindMap(this), e.once("renderercreate", this._onChildRendererCreate, this), 
        e.remove = () => (this.removeLayer(e), e.constructor.prototype.remove.call(e), delete e.remove, 
        this), e.load(), this._bindChildListeners(e);
    }
    onRemove() {
        this._removeTerrainLayer(), this.layers.forEach((e => {
            this._resetSkinLayer(e), e._doRemove(), this._unbindChildListeners(e);
        })), this._layerMap = {}, this.clearAnalysis(), super.onRemove();
    }
    getChildLayer(e) {
        return this._layerMap[e] || null;
    }
    getLayer(e) {
        return this.getChildLayer(e);
    }
    _bindChildListeners(e) {
        e.on("show hide", this._onLayerShowHide, this), e.on("idchange", this._onLayerIDChange, this);
    }
    _unbindChildListeners(e) {
        e.off("show hide", this._onLayerShowHide, this), e.off("idchange", this._onLayerIDChange, this);
    }
    _onLayerShowHide() {
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    _onLayerIDChange(e) {
        const t = e.new, n = e.old, r = this.getLayer(n);
        delete this._layerMap[n], this._layerMap[t] = r;
    }
    _onChildRendererCreate(e) {
        e.renderer.clearCanvas = Zd;
    }
    _checkChildren() {
        const e = {};
        this.layers.forEach((t => {
            const n = t.getId();
            if (e[n]) throw new Error(`Duplicate child layer id (${n}) in the GroupGLLayer (${this.getId()})`);
            e[n] = 1;
        }));
    }
    addAnalysis(e) {
        this._analysisTaskList = this._analysisTaskList || [], this._analysisTaskList.push(e);
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    removeAnalysis(e) {
        if (this._analysisTaskList) {
            const t = this._analysisTaskList.indexOf(e);
            t > -1 && (this._analysisTaskList.splice(t, 1), e.remove());
        }
        const t = this.getRenderer();
        t && t.setToRedraw();
    }
    clearAnalysis() {
        this._analysisTaskList && (this._analysisTaskList.forEach((e => {
            e.remove();
        })), this._analysisTaskList = []);
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    identify(t, n) {
        const r = this.getMap(), i = this.getRenderer();
        if (!r || !i) return [];
        const s = r.coordToContainerPoint(new e.Coordinate(t));
        return this.identifyAtPoint(s, n);
    }
    identifyAtPoint(e, t = {}) {
        const n = t.includeInternals, r = this.getLayers(), i = t && t.childLayers || r, s = this.getMap();
        if (!s) return [];
        const o = xl(t.count) ? 1 : t.count;
        let a = [];
        for (let s = i.length - 1; s >= 0; s--) {
            const o = i[s];
            if (r.indexOf(o) < 0 || !o.identifyAtPoint) continue;
            const l = o.options.geometryEvents;
            if (n && (void 0 === l || !1 === l || 0 === l)) continue;
            if (o.isGeometryListening && n && t.eventTypes.indexOf("mousemove") >= 0 && !o.isGeometryListening(t.eventTypes)) continue;
            const c = o.identifyAtPoint(e, t);
            if (!c || !c.length) continue;
            const h = o.getId();
            for (let e = 0; e < c.length; e++) c[e] && (c[e].layer = h);
            a.push(...c);
        }
        if (t.orderByCamera) {
            const e = s.cameraPosition;
            a.sort(((t, n) => n.point ? t.point ? h.dist(t.point, e) - h.dist(n.point, e) : 1 : -1));
        }
        return o && (a = a.slice(0, o)), a;
    }
    getTerrain() {
        return this.options.terrain;
    }
    setTerrain(e) {
        return this.options.terrain = e, this.getRenderer() ? (this._initTerrainLayer(), 
        this.getMap().updateCenterAltitude(), this) : this;
    }
    removeTerrain() {
        return this.setTerrain(null);
    }
    updateTerrainMaterial(e) {
        this._terrainLayer && e && (this.options.terrain.material ? vl(this.options.terrain.material, e) : this.options.terrain.material = e, 
        this._terrainLayer.updateMaterial(e));
    }
    _initTerrainLayer() {
        const e = this.getRenderer();
        e && e.setToRedraw();
        const t = this.options.terrain;
        if (this._terrainLayer) {
            const e = this._terrainLayer, n = e.options;
            if (t && n.urlTemplate === t.urlTemplate && n.spatialReference === t.spatialReference) {
                for (const n in t) "material" === n ? e.setMaterial(t[n]) : "urlTemplate" !== n && "spatialReference" !== n && e.config(n, t[n]);
                return this;
            }
            this._removeTerrainLayer();
        }
        if (this._resetTerrainSkinLayers(), !t) return this;
        this._terrainLayer = new Md("__terrain_in_group", t), this._updateTerrainSkinLayers();
        const n = this._terrainLayer;
        n.on("tileload", this._onTerrainTileLoad, this), this._prepareLayer(n);
        const r = t.masks;
        return r && r.length ? n.setMask(r) : n.removeMask(), this.fire("terrainlayercreated"), 
        this;
    }
    queryTerrain(e, t) {
        return this._terrainLayer ? this._terrainLayer.queryTerrain(e, t) : (t && (t[0] = null, 
        t[1] = 0), [ null, 0 ]);
    }
    queryTerrainAtPoint(e) {
        if (!this._terrainLayer) return null;
        const t = this._terrainLayer.getRenderer().getAnalysisMeshes();
        return this._queryRayCast(e, t);
    }
    query3DTilesAtPoint(t) {
        const n = this._getLayers().filter((e => e && e.isGeo3DTilesLayer));
        if (!n.length) return null;
        const r = {
            excludeMasks: !0
        };
        for (let i = 0; i < n.length; i++) {
            if (!n[i].getRenderer()) continue;
            const s = n[i].identifyAtPoint(t, r);
            if (s.length) return new e.Coordinate(s[0].coordinate);
        }
        return null;
    }
    _queryRayCast(t, n) {
        const r = this.getMap(), i = r.getGLRes();
        r.getContainerPointRay(qd, Xd, t);
        const s = new Ud(qd, Xd, !1).test(n, r, {
            count: 1
        }), o = [];
        s.forEach((e => {
            e.coordinates.forEach((e => {
                o.push(e.coordinate);
            }));
        }));
        const a = r.pointAtResToCoordinate(new e.Point(qd[0], qd[1]), i, jd);
        this._meterToGLPoint || (this._meterToGLPoint = r.altitudeToPoint(1, i)), a.z = qd[2] / this._meterToGLPoint;
        const l = h.set(Wd, a.x, a.y, a.z);
        return o.sort(((e, t) => h.dist(e.toArray(), l) - h.dist(t.toArray(), l))), o[0];
    }
    queryTerrainByProjCoord(e, t) {
        return this._terrainLayer ? this._terrainLayer.queryTerrainByProjCoord(e, t) : (t && (t[0] = null, 
        t[1] = 0), [ null, 0 ]);
    }
    _updateTerrainSkinLayers() {
        if (!this._terrainLayer) return;
        const e = this.layers, t = [];
        for (let n = 0; n < e.length; n++) {
            if (!e[n]) continue;
            const r = e[n], i = r.getRenderer();
            if (i.renderTerrainSkin) {
                if (i.deleteTile === Vd) {
                    t.push(e[n]);
                    continue;
                }
                const s = r.getTiles;
                r.getTiles = (...e) => r.options.awareOfTerrain ? this._terrainLayer && this._terrainLayer.getSkinTiles(r) : s.call(r, ...e);
                const o = i.drawTile;
                i.drawTileOnTerrain ? i.drawTile = (...e) => r.options.awareOfTerrain ? i.drawTileOnTerrain(...e) : o.call(i, ...e) : i.drawTile = (...e) => {
                    if (!r.options.awareOfTerrain) return o.call(i, ...e);
                };
                const a = i.deleteTile;
                i.deleteTile = (...e) => {
                    if (!r.options.awareOfTerrain) return a.call(i, ...e);
                }, t.push(e[n]);
            }
            i.setTerrainHelper && i.setTerrainHelper(this._terrainLayer);
        }
        this._terrainLayer.setSkinLayers(t);
    }
    _resetSkinLayer(e) {
        if (!function(e) {
            if (!e) return !1;
            const t = e.getRenderer();
            if (!t) return !1;
            return !!t.renderTerrainSkin;
        }(e)) return;
        const t = e.getRenderer();
        t && (t.setTerrainHelper && t.setTerrainHelper(null), t.clear && t.clear(), delete t.drawTile, 
        delete t.deleteTile), delete e.getTiles;
    }
    _resetTerrainSkinLayers() {
        const e = this.layers;
        for (let t = 0; t < e.length; t++) e[t] && this._resetSkinLayer(e[t]);
    }
    _onTerrainTileLoad() {
        const e = this.getRenderer();
        e && e.setToRedraw();
    }
    _removeTerrainLayer() {
        if (this._terrainLayer) {
            const e = this._terrainLayer;
            e.off("tileload", this._onTerrainTileLoad, this), this._unbindChildListeners(e), 
            this._terrainLayer._doRemove(), delete this._terrainLayer, this.fire("terrainlayerremoved");
        }
    }
    getTerrainLayer() {
        return this._terrainLayer;
    }
    _bindMap(...e) {
        if (this.options.single) {
            const t = e[0].getLayers();
            for (let e = 0; e < t.length; e++) if (t[e] instanceof Kd) throw new Error("Only one GroupGLLayer is allowed in a map instance. Set options.single to false if you want to add two or more GroupGLLayers.");
        }
        return super._bindMap(...e);
    }
    fire(...e) {
        if ("layerload" === e[0]) {
            const e = this._getLayers();
            for (const t of e) {
                const e = t.getRenderer();
                e && e.isRenderComplete() && t.fire("layerload");
            }
        }
        super.fire(...e);
    }
}

function Zd() {}

function Yd(e, t) {
    const n = e.getZIndex() - t.getZIndex();
    return 0 === n ? e.__group_gl_order - t.__group_gl_order : n;
}

var $d;

let Jd;

function Qd(e, t) {
    const {cubePixels: n, width: r, height: i} = e, s = n.map((e => e.buffer));
    (Jd || (Jd = new o.Actor("maplight")), Jd).send({
        cubePixels: s,
        width: r,
        height: i
    }, s, ((e, n) => {
        e ? console.error(e) : t(n.shList);
    }));
}

Kd.mergeOptions({
    renderer: "gl",
    antialias: !0,
    extensions: [],
    single: !0,
    onlyWebGL1: !1,
    optionalExtensions: [ "ANGLE_instanced_arrays", "OES_element_index_uint", "OES_standard_derivatives", "OES_vertex_array_object", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear", "WEBGL_depth_texture", "EXT_shader_texture_lod", "EXT_frag_depth", "EXT_texture_filter_anisotropic", "WEBGL_compressed_texture_astc", "WEBGL_compressed_texture_etc", "WEBGL_compressed_texture_etc1", "WEBGL_compressed_texture_pvrtc", "WEBGL_compressed_texture_s3tc", "WEBGL_compressed_texture_s3tc_srgb" ],
    forceRenderOnZooming: !0,
    forceRenderOnMoving: !0,
    forceRenderOnRotating: !0,
    viewMoveThreshold: 100,
    geometryEvents: !0,
    multiSamples: 4,
    forceRedrawPerFrame: !1
}), Kd.registerJSONType("GroupGLLayer"), Kd.registerRenderer("gl", Kc), Kd.registerRenderer("gpu", Kc), 
Kd.registerRenderer("canvas", null), function(e) {
    e[e.AMBIENT = 0] = "AMBIENT", e[e.REALISTIC = 1] = "REALISTIC";
}($d || ($d = {}));

class eu {
    constructor(e) {
        this._map = e, this._loader = new Mr, this.updateTime = n.now();
    }
    getDirectionalLight() {
        return this._config && this._config.directional || {};
    }
    getAmbientLight() {
        return this._config && this._config.ambient || {};
    }
    getAmbientResource() {
        return this._iblMaps;
    }
    setConfig(e) {
        const t = this._config;
        this._urlModifier = e.urlModifier, this._config = JSON.parse(JSON.stringify(e));
        let n = !1;
        if (e && e.ambient && e.ambient.resource) {
            if (!(t && t.ambient && function(e, t) {
                if (!e.resource) return !1;
                if (e.resource.url !== t.resource.url) return !1;
                return !0;
            }(t.ambient, e.ambient))) return void this._initAmbientResources();
            if (this._iblMaps) {
                const r = t.ambient && t.ambient.resource, i = e.ambient.resource;
                i && i.prefilterCubeSize !== r && r.prefilterCubeSize && this._onHDRLoaded(), n = !0, 
                e.ambient.resource.sh && (this._iblMaps.sh = e.ambient.resource.sh);
            }
        } else this._disposeCubeLight(), n = t && t.ambient && t.ambient.resource;
        this._map.fire("updatelights", {
            ambientUpdate: n
        });
    }
    _tryToGetREGLContext(e) {
        const t = e.getLayers();
        for (let e = 0; e < t.length; e++) {
            const n = t[e] && t[e].getRenderer();
            if (n && n.regl) return n.regl;
        }
        const n = document.createElement("canvas"), r = w({
            canvas: n,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !1
            },
            optionalExtensions: [ "OES_standard_derivatives", "OES_texture_half_float", "OES_texture_half_float_linear", "OES_texture_float", "OES_texture_float_linear" ]
        });
        return r._temp = !0, r;
    }
    _initAmbientResources() {
        const e = this._config.ambient.resource, t = e && e.url;
        if (!t) return;
        const r = [];
        let i = 0, s = 0;
        const o = () => {
            s++, s >= i && this._onSkyboxLoaded(r);
        }, a = function() {
            throw new Error(`skybox image with url(${this.src}) failed to load, please check the image's url.`);
        }, l = this._urlModifier;
        if (t.top || t.nx) {
            const {front: s, back: c, right: h, left: d, top: u, bottom: f} = t, {nx: m, ny: g, px: _, py: p, nz: v, pz: x} = t;
            let y;
            y = s ? [ d, h, c, s, u, f ] : [ m, _, v, x, p, g ], i = y.length;
            const b = e.crossOrigin;
            for (let e = 0; e < i; e++) {
                const t = new Image;
                t.onload = o, t.onerror = a, n.isNil(b) || (t.crossOrigin = b), t.src = l && l(y[e]) || y[e], 
                r[e] = t;
            }
        } else {
            const t = {
                url: e.url,
                arrayBuffer: !0,
                hdr: !0,
                flipY: !0
            };
            this._loader.setURLModifier(l), this._hdr = new qr(t, this._loader), this._hdr.once("complete", (() => {
                this._onHDRLoaded();
            })), this._hdr.once("error", (() => {
                this._onHDRError();
            }));
        }
    }
    dispose() {
        this._disposeCubeLight();
    }
    _onHDRLoaded() {
        this._hdr && this._createIBLMaps(this._hdr).then((e => {
            this._iblMaps = e, this._map.fire("updatelights", {
                "ambientUpdate": !0
            }), this.getAmbientLight().debug && console.log("ambientLight hdr loadend");
        }));
    }
    _onHDRError() {
        this._map.fire("hdrerror");
    }
    _onSkyboxLoaded(e) {
        this._createIBLMaps(e).then((e => {
            this._iblMaps = e, this._map.fire("updatelights", {
                "ambientUpdate": !0
            }), this.getAmbientLight().debug && console.log("ambientLight skybox loadend");
        }));
    }
    _createIBLMaps(e) {
        return this.updateTime = n.now(), new Promise((t => {
            const n = this._config.ambient.resource, r = n.prefilterCubeSize || 512, i = this._tryToGetREGLContext(this._map), s = n.asynchronous;
            Ta.PBRHelper.createIBLMapsAsync(i, {
                updateTime: this.updateTime,
                asynchronous: s,
                envTexture: Array.isArray(e) ? e : e.getREGLTexture(i),
                ignoreSH: !!n.sh,
                envCubeSize: r,
                prefilterCubeSize: r,
                environmentExposure: this._config.ambient.exposure,
                format: "array",
                projectEnvironmentMapCPU: s ? Qd : null
            }).then((e => {
                if (e.updateTime === this.updateTime) {
                    if (n.sh && (e.sh = n.sh, Array.isArray(e.sh[0]))) {
                        const t = e.sh, n = [];
                        for (let e = 0; e < t.length; e++) n.push(...t[e]);
                        e.sh = n;
                    }
                    i._temp && (delete this._hdr, i.destroy()), t(e);
                }
            }));
        }));
    }
    _disposeCubeLight() {
        this._hdr && (this._hdr.dispose(), delete this._hdr), delete this._iblMaps;
    }
}

let tu, nu, ru, iu, su;

a.include({
    setLights(e) {
        return this.options.lights = e, this._initLightManager(), this;
    },
    getLights() {
        return this.options.lights;
    },
    _initLightManager() {
        this._lightManager || (this._lightManager = new eu(this)), this._lightManager.setConfig(this.getLights());
    },
    getLightManager() {
        return this._lightManager ? this._lightManager : null;
    }
}), a.addOnLoadHook((function() {
    this.options.lights && this._initLightManager();
}));

const ou = {
    color: [ 0, 0, 0, 0 ]
}, au = {
    enable: !1
};

a.include({
    setPostProcessConfig(e) {
        return this.options.postProcessConfig = e, this;
    },
    getPostProcessConfig() {
        return this.options.postProcessConfig;
    }
});

const lu = l.MapCanvasRenderer.prototype.drawLayerCanvas;

l.MapCanvasRenderer.prototype.drawLayerCanvas = function() {
    const e = lu.apply(this, arguments);
    return e && function(e, t) {
        const n = e.map.getPostProcessConfig();
        if (!n || !n.enable) return;
        tu || (r = t.width, i = t.height, tu = document.createElement("canvas", r, i), nu = w({
            canvas: tu,
            attributes: {
                depth: !1,
                stencil: !1,
                alpha: !0,
                antialias: !1,
                premultipliedAlpha: !1
            }
        }), ru = nu.texture({
            mag: "linear",
            min: "linear",
            mipmap: !1,
            flipY: !0,
            width: r,
            height: i
        }), iu = nu.texture());
        var r, i;
        tu.width === t.width && tu.height === t.height || (tu.width = t.width, tu.height = t.height);
        nu.clear(ou);
        const s = n.filmicGrain || au;
        void 0 === s.enable && (s.enable = !0);
        const o = n.vignette || au;
        void 0 === o.enable && (o.enable = !0);
        const a = n.colorLUT || au;
        void 0 === a.enable && (a.enable = !0);
        e._postProcessContext || (e._postProcessContext = {});
        const l = e._postProcessContext;
        if (a.enable) {
            const e = a.lut;
            if (!l.lutTexture || l.lutTexture.url !== e) {
                const t = new Image;
                t.onload = function() {
                    const n = {
                        data: t,
                        min: "linear",
                        mag: "linear"
                    }, r = l.lutTexture ? l.lutTexture.texture(n) : nu.texture(n);
                    l.lutTexture = {
                        url: e,
                        texture: r
                    };
                }, t.src = e;
            }
        }
        const c = {
            "enableGrain": +!!s.enable,
            "grainFactor": void 0 === s.factor ? .15 : s.factor,
            "timeGrain": performance.now(),
            "enableVignette": +!!o.enable,
            "lensRadius": o.lensRadius || [ .8, .25 ],
            "frameMod": 1,
            "enableLut": +!!a.enable,
            "lookupTable": l.lutTexture ? l.lutTexture.texture : iu
        };
        su || (su = new Oc(nu));
        su.postprocess(null, c, ru({
            width: tu.width,
            height: tu.height,
            data: t,
            flipY: !0,
            mag: "linear",
            min: "linear",
            mipmap: !1
        })), e.context.drawImage(tu, 0, 0, tu.width, tu.height);
    }(this, this.canvas), e;
};

const cu = l.MapCanvasRenderer.prototype.renderFrame;

l.MapCanvasRenderer.prototype.renderFrame = function() {
    const e = cu.apply(this, arguments), t = this.map.getPostProcessConfig(), n = t && t.filmicGrain;
    return !n || void 0 !== n.enable && !0 !== n.enable || this.setToRedraw(), e;
};

class hu extends l.MapAbstractRenderer {
    clearCanvas() {
        this.device && this.device.clear({
            color: [ 0, 0, 0, 0 ]
        });
    }
    clearLayerCanvasContext(e) {
        if (!this.device) return;
        this.device.clear({
            depth: 1,
            stencil: 0
        });
        e.getRenderer().clearContext();
    }
    createContext() {
        const e = this.map, {preserveDrawingBuffer: t, onlyWebGL1: n, extensions: r, optionalExtensions: i} = e.options, s = e.getRenderer().canvas, {gl: o, regl: a, reglGL: l, context: c} = Bc(s, t, n, r, i);
        return this.gl = o, this.regl = a, this.reglGL = l, this.device = a, this.context = c, 
        Promise.resolve();
    }
    _initGL() {
        const e = this.map, t = this.gl, n = e.options.extensions;
        n && n.forEach((e => {
            t.getExtension(e);
        }));
        const r = e.options.optionalExtensions;
        r && r.forEach((e => {
            t.getExtension(e);
        }));
    }
    getContextInstance() {
        return this.gl.wrap();
    }
    isWebGL() {
        return !0;
    }
    isWebGPU() {
        return !1;
    }
}

function du(e, t, n, r) {
    return new (n || (n = Promise))((function(i, s) {
        function o(e) {
            try {
                l(r.next(e));
            } catch (e) {
                s(e);
            }
        }
        function a(e) {
            try {
                l(r.throw(e));
            } catch (e) {
                s(e);
            }
        }
        function l(e) {
            var t;
            e.done ? i(e.value) : (t = e.value, t instanceof n ? t : new n((function(e) {
                e(t);
            }))).then(o, a);
        }
        l((r = r.apply(e, t || [])).next());
    }));
}

let uu, fu;

a.registerRenderer("gl", hu), "function" == typeof SuppressedError && SuppressedError;

class mu extends hu {
    drawLayers(e, t) {
        const n = super.drawLayers(e, t);
        if (n && (this.device.submit(), this.map.options.preserveGpuDrawingBuffer)) {
            const e = this.canvas, t = e.readbackCanvas = e.readbackCanvas || document.createElement("canvas");
            this.device.preserveDrawingBuffer(t);
        }
        return n;
    }
    createContext() {
        return function() {
            return du(this, void 0, void 0, (function*() {
                var e;
                return fu || (uu = yield null === (e = navigator.gpu) || void 0 === e ? void 0 : e.requestAdapter(), 
                fu = yield null == uu ? void 0 : uu.requestDevice({})), {
                    gpuDevice: fu,
                    gpuAdapter: uu
                };
            }));
        }().then((({gpuDevice: e, gpuAdapter: t}) => {
            const n = this.canvas.getContext("webgpu");
            this.device = new ba(e, n, t), this.context = {
                context: n,
                device: this.device,
                getImageData: (e, t, n, r) => {
                    const i = new Uint8Array(n * r * 4), s = this.canvas;
                    return this.device.read({
                        x: e,
                        y: s.height - t,
                        width: n,
                        height: r,
                        data: i
                    }), new ImageData(new Uint8ClampedArray(i.buffer), n, r);
                }
            };
        }));
    }
    isWebGL() {
        return !1;
    }
    isWebGPU() {
        return !0;
    }
}

a.registerRenderer("gpu", mu);

const gu = [];

function _u(e) {
    e.properties.showOnlyTimestamp && (delete e.properties.showOnlyTimestamp, vu(e));
}

function pu(e, t) {
    const n = e.geometry.properties;
    n.oldElementsBeforeHighlight || (n.oldElementsBeforeHighlight = e.geometry.elements), 
    n.elements && (n.oldElementsArrBeforeHighlight || (n.oldElementsArrBeforeHighlight = n.elements), 
    n.elements = t);
}

function vu(e) {
    const t = e.geometry.properties.oldElementsBeforeHighlight;
    t && e.geometry.elements !== t && (e.geometry.deleteElements(), e.geometry.setElements(e.geometry.properties.oldElementsBeforeHighlight), 
    e.geometry.properties.oldElementsArrBeforeHighlight && (e.geometry.properties.elements = e.geometry.properties.oldElementsArrBeforeHighlight, 
    delete e.geometry.properties.oldElementsArrBeforeHighlight), delete e.geometry.properties.hasInvisible, 
    delete e.geometry.properties.oldElementsBeforeHighlight);
}

function xu(e) {
    if (!e.properties.highlightTimestamp) return;
    const t = e.defines;
    delete t.HAS_HIGHLIGHT_COLOR, delete t.HAS_HIGHLIGHT_OPACITY, e.setDefines(t), delete e.properties.highlightTimestamp, 
    vu(e), yu(e);
}

function yu(e) {
    if (!e) return;
    const {hlBloomMesh: t} = e.properties;
    if (t) {
        const n = t.geometry;
        n.elements && n.elements.destroy && n.deleteElements(), t.dispose(), delete e.properties.hlBloomMesh;
    }
}

var bu = Object.freeze({
    __proto__: null,
    clearHighlight: xu,
    clearShowOnly: _u,
    deleteHighlightBloomMesh: yu,
    highlightMesh: function(e, t, n, r, i) {
        const {highlightTimestamp: s} = t.properties;
        if (!n) return void (s && xu(t));
        if (r === s) return;
        const o = t instanceof yr, a = o ? t.instanceCount : t.geometry.getVertexCount();
        let {aHighlightColor: l, aHighlightOpacity: h} = t.geometry.properties;
        l && l.fill(0), h && h.fill(255);
        let u = !1, f = !1;
        const m = n.keys();
        let g = null, _ = null;
        for (const e of m) if (i.has(e)) {
            const r = n.get(e), {color: s, bloom: o, visible: c, nodeIndex: m} = r;
            if (!xl(m) && m !== t.properties.nodeIndex) continue;
            let p, {opacity: v} = r;
            if (s && (u || (l || (l = new Uint8Array(4 * a)), u = !0), p = kl(gu, s)), v = xl(v) ? 1 : v, 
            v < 1 && (f || (h || (h = new Uint8Array(a), h.fill(255)), f = !0)), !1 === c && (_ || (_ = new Set), 
            _.add(e)), p || v < 1 || o) {
                const t = i.get(e);
                if (t) for (let e = 0; e < t.length; e++) {
                    const n = t[e];
                    p && d.set(l.subarray(4 * n, 4 * n + 4), ...p), v < 1 && (h[n] = 255 * v), o && (g || (g = []), 
                    g.push(n));
                }
            }
        }
        const p = t.geometry, v = t.defines;
        if (u ? (o ? (t.updateInstancedData("aHighlightColor", l), t.generateInstancedBuffers(e)) : (p.data.aHighlightColor ? p.updateData("aHighlightColor", l) : (p.data.aHighlightColor = l, 
        p.generateBuffers(e)), p.properties.aHighlightColor = l), v.HAS_HIGHLIGHT_COLOR = 1) : v.HAS_HIGHLIGHT_COLOR && (o ? (t.updateInstancedData("aHighlightColor", l), 
        t.generateInstancedBuffers(e)) : p.updateData("aHighlightColor", l), delete v.HAS_HIGHLIGHT_COLOR), 
        f ? (o ? (t.updateInstancedData("aHighlightOpacity", h), t.generateInstancedBuffers(e)) : (p.data.aHighlightOpacity ? p.updateData("aHighlightOpacity", h) : (p.data.aHighlightOpacity = h, 
        p.generateBuffers(e)), p.properties.aHighlightOpacity = h), v.HAS_HIGHLIGHT_OPACITY = 1) : v.HAS_HIGHLIGHT_OPACITY && (o ? (t.updateInstancedData("aHighlightOpacity", h), 
        t.generateInstancedBuffers(e)) : p.updateData("aHighlightOpacity", h), delete v.HAS_HIGHLIGHT_OPACITY), 
        _ && _.size > 0) {
            let n = [];
            i.forEach(((e, t) => {
                _.has(t) || Ml(n, e);
            })), p.properties.hasInvisible = !0, pu(t, n);
            const r = {
                data: n,
                primitive: p.getPrimitive()
            };
            p.elements !== p.properties.oldElementsBeforeHighlight && p.elements.destroy && p.deleteElements(), 
            n = e.elements(r), p.setElements(n), p.generateBuffers(e);
        } else p.properties.hasInvisible && vu(t);
        t.setDefines(v), t.properties.highlightTimestamp = r;
        let x = t.properties.hlBloomMesh;
        if (g && g.length) {
            if (x) {
                const e = c.copy(x.localTransform, t.localTransform), n = c.copy(x.positionMatrix, t.positionMatrix);
                x.setLocalTransform(e), x.setPositionMatrix(n), t.properties.hlBloomMesh.geometry.setElements(g);
            } else {
                const n = new Ye(p.data, g, 0, p.desc);
                n.generateBuffers(e);
                const r = t.material;
                x = new xr(n, r, t.config);
                const i = t.uniforms;
                for (const e in i) Object.defineProperty(x.uniforms, e, {
                    enumerable: !0,
                    get: function() {
                        return t.getUniform(e);
                    }
                });
                const s = vl({}, t.defines);
                s.HAS_BLOOM = 1;
                const o = c.copy([], t.localTransform), a = c.copy([], t.positionMatrix);
                x.setLocalTransform(o), x.setPositionMatrix(a), vl(x.properties, t.properties), 
                vl(n.properties, p.properties), x.setDefines(s), x.bloom = 1;
            }
            t.properties.hlBloomMesh = x;
        } else x && yu(t);
    },
    showOnly: function(e, t, n, r, i) {
        const {showOnlyTimestamp: s} = t.properties;
        if (!n) return void (s && _u(t));
        if (r === s) return;
        t.properties.showOnlyTimestamp = r;
        const o = n.keys(), a = [];
        for (const e of o) {
            if (!i.has(e)) continue;
            const t = i.get(e);
            t && Ml(a, t);
        }
        pu(t, a), t.geometry.elements !== t.geometry.properties.oldElementsBeforeHighlight && t.geometry.elements.destroy && t.geometry.deleteElements();
        const l = {
            data: a,
            primitive: t.geometry.getPrimitive()
        };
        t.geometry.setElements(e.elements(l)), t.geometry.generateBuffers(e);
    }
});

const wu = function(e) {
    return class extends e {
        constructor() {
            super(...arguments), this._textures = [];
        }
        getTexture() {
            this._textures || (this._textures = []);
            const e = this._textures;
            return e && e.length > 0 ? e.pop() : null;
        }
        saveTexture(e) {
            this._textures.push(e);
        }
        disposeTexturePool() {
            const e = this._textures;
            for (let t = 0; t < e.length; t++) e[t].dispose();
            this._textures = [];
        }
    };
}, Tu = new e.Point(0, 0), Su = [ 1, 1, 1, 1 ];

function Mu(e, t, n, r, i, s) {
    const o = n.xmax - n.xmin, a = n.ymax - n.ymin;
    r = r || [ 0, 0 ];
    const l = Tu.set(n.xmin - r[0], n.ymax - r[1]), h = l.x * i, d = l.y * i, u = {
        data: t,
        mag: "nearest",
        mipmap: !0,
        premultiplyAlpha: !0
    };
    t && 0 !== t.width && 0 !== t.height || (t = new Uint8Array([ 0, 0, 0, 0 ]), u.width = 1, 
    u.height = 1, u.data = t);
    let f = this.getTexture();
    f ? f.setConfig(u) : f = new qr(u), s = vl(s || {}, {
        opacity: 1,
        debugLine: 0,
        alphaTest: 0,
        baseColor: Su,
        baseColorTexture: f
    });
    const m = new Ft(s), g = new xr(e, m);
    g.properties.minFilter = Gr;
    const _ = c.identity([]);
    return c.translate(_, _, [ h || 0, d || 0, 0 ]), c.scale(_, _, [ i * o, i * a, 1 ]), 
    g.localTransform = _, g;
}

function Au(t, n, r) {
    const i = e.MapStateCache[n.id], s = i ? i.zoom : n.getZoom(), o = i ? i.devicePixelRatio : n.getDevicePixelRatio(), a = function(e, t) {
        const n = e.isMoving() && e.getRenderer().isViewChanged();
        let r;
        r = n ? jr : e.getBearing() || e.getPitch() || !Number.isInteger(t) ? Vr : Gr;
        return r;
    }(n, s);
    if (t.properties.minFilter !== a) {
        t.material.get("baseColorTexture").setMinFilter(a), t.properties.minFilter = a;
    }
    const l = n.getResolution() !== r;
    let c = Gr;
    if ((1 !== o || l) && (c = Vr), t.properties.magFilter !== c) {
        t.material.get("baseColorTexture").setMagFilter(c), t.properties.magFilter = c;
    }
}

const {TileLayerRendererable: Cu, LayerAbstractRenderer: ku} = e.renderer, Ou = new Int16Array([ 0, 0, 0, -1, 1, 0, 1, -1 ]), Eu = new Uint16Array([ 0, 0, 0, 1, 1, 0, 1, 1 ]), Pu = {
    properties: {}
}, Iu = new e.Point(20, 20);

class Ru extends(wu(Uc(Cu(ku)))){
    constructor(e) {
        super(e), this.init();
    }
    onResize(e) {
        super.onResize(e), this.resizeCanvas();
    }
    onDrawTileStart(e, t) {
        if (!this._tileGeometry) {
            this._shader = new is({
                extraCommandProps: this._getCommandProps()
            }), this._tileGeometry = new Ye({
                aPosition: Ou,
                aTexCoord: Eu
            }, 4, 0, {
                positionSize: 2,
                primitive: "triangle strip"
            });
            const {regl: e, device: t} = this.context;
            this._tileGeometry.generateBuffers(e || t), this._tileMeshes = [], this._tileScene = new Pr(this._tileMeshes), 
            this._renderer = new wr(e || t);
        }
        this._tileMeshes.length = 0, this.clearStencil(t);
    }
    clearStencil(e) {
        let t;
        e && e.renderTarget && (t = e.renderTarget.fbo);
        const {regl: n, device: r} = this.context;
        (n || r).clear({
            stencil: 255,
            fbo: t
        });
    }
    onDrawTileEnd(e, t) {
        const n = this._getUniformValues();
        let r;
        t && t.renderTarget && (r = t.renderTarget.fbo), this._tileScene.setMeshes(this._tileMeshes), 
        this._renderer.render(this._shader, n, this._tileScene, r);
    }
    _getUniformValues() {
        return {
            "projViewMatrix": this.getMap().projViewMatrix
        };
    }
    consumeTile(e, t) {
        let n = e.mesh;
        return n || (n = this._createTileMesh(t, e), e.mesh = n), super.consumeTile(e, t);
    }
    drawTile(e, t, n) {
        if (n && n.sceneFilter && !n.sceneFilter(Pu)) return;
        const r = this.getMap();
        if (!e || !r || !t) return;
        let i = t.mesh;
        i || (i = this._createTileMesh(e, t), t.mesh = i);
        const s = i.getDefines();
        if (this.layer.options.debug) {
            let n = i.material.get("debugTexture");
            n || (n = this._createDebugTexture(e, t.width, t.height), i.material.set("debugTexture", n), 
            t.debugTexture = n), s.HAS_DEBUG || i.setDefines({
                "HAS_DEBUG": 1
            });
        } else s.HAS_DEBUG && i.setDefines({});
        Au(i, r, e.res);
        let o = this.getTileOpacity(t, e), a = this.layer.options.opacity;
        xl(a) && (a = 1), o *= a, i.material.set("opacity", o), i.setUniform("isCurrentTiles", +!!this.drawingCurrentTiles), 
        this._tileMeshes.push(i), this.getTileFadingOpacity(t) < 1 && this.setToRedraw();
    }
    _createDebugTexture(e, t, n) {
        const r = this.getDebugInfo(e.id), i = this.getMap().getDevicePixelRatio() > 1 ? 2 : 1, s = this._debugInfoCanvas = document.createElement("canvas");
        s.width = t * i, s.height = n * i;
        const o = s.getContext("2d");
        o.font = "20px monospace", o.scale(i, i);
        const a = this.layer.options.debugOutline;
        o.fillStyle = a, o.strokeStyle = a, o.lineWidth = 3, o.fillText(r, 20, n - 12), 
        o.beginPath(), o.moveTo(0, 0), o.lineTo(t, 0), o.lineTo(t, n), o.lineTo(0, n), o.lineTo(0, 0), 
        o.stroke();
        const l = {
            data: s,
            width: s.width,
            height: s.height
        };
        let c = this.getTexture();
        c ? c.setConfig(l) : c = new qr(l);
        const {device: h, regl: d} = this.context;
        return c.getREGLTexture(h || d), c;
    }
    _createTileMesh(e, t) {
        const n = this.getMap(), r = e.res / n.getGLRes(), i = {
            zoom: e.z
        }, s = Mu.call(this, this._tileGeometry, t, e.extent2d, e.offset, r, i), o = s.material.get("baseColorTexture");
        return t.texture = o, s;
    }
    loadTileImage(e, t) {
        const n = this.layer.options.crossOrigin;
        e.crossOrigin = null !== n ? n : "", e.src = t;
    }
    deleteTile(e) {
        if (!e || !e.image) return super.deleteTile(e);
        const t = e.image;
        t.texture && this.saveTexture(t.texture), t.debugTexture && this.saveTexture(t.debugTexture), 
        delete t.texture, delete t.debugTexture;
        const n = t.mesh;
        return n && (n.material.set("baseColorTexture", null, !1), n.material.set("debugTexture", null, !1), 
        n.material.dispose(), n.dispose(), delete t.mesh), super.deleteTile(e);
    }
    onRemove() {
        this._tileGeometry && (this._shader.dispose(), this._tileGeometry.dispose(), delete this._shader, 
        delete this._tileGeometry, delete this._renderer, delete this._tileScene, delete this._tileMeshes), 
        this.disposeTexturePool(), super.onRemove();
    }
    _getCommandProps() {
        const e = this.getMap().getRenderer().canvas, t = {
            units: 0,
            factor: 0
        };
        return {
            stencil: {
                enable: !0,
                func: {
                    cmp: "<=",
                    ref: (e, t) => Math.abs(this.getCurrentTileZoom() - t.zoom)
                },
                op: {
                    fail: "keep",
                    zfail: "keep",
                    zpass: "replace"
                }
            },
            depth: {
                enable: !0,
                func: "<=",
                mask: () => !!this.layer.options.depthMask
            },
            blend: {
                enable: !0,
                func: {
                    src: 1,
                    dst: "one minus src alpha"
                },
                equation: "add"
            },
            viewport: {
                x: 0,
                y: 0,
                width: () => e ? e.width : 1,
                height: () => e ? e.height : 1
            },
            polygonOffset: {
                enable: !0,
                offset: (e, n) => {
                    let r = this.layer.getPolygonOffset();
                    return r = n.isCurrentTiles ? r : r + 1, t.factor = r, t.units = r, t;
                }
            }
        };
    }
    renderTerrainSkin(e, t, n) {
        const r = this.layer.getTileSize().width, i = t.options.debug;
        for (let e = 0; e < n.length; e++) {
            const {tile: t, texture: s} = n[e];
            if (!t.image) continue;
            const o = document.createElement("canvas");
            n[e].canvas = o, o.width = r, o.height = r;
            const a = o.getContext("2d");
            if (a.drawImage(t.image, 0, 0), i) {
                const {x: e, y: n, z: i} = t.info;
                Lu(a, `${e}/${n}/${i}`, "yellow", 1, 0, 0, r, r, -18);
            }
            const l = {
                data: o,
                width: r,
                height: r,
                flipY: !0,
                min: "linear mipmap linear",
                mag: "linear"
            };
            s.update ? s.update(l) : s(l);
        }
    }
    createTerrainTexture(e) {
        const t = this.layer.getTileSize().width, n = {
            width: t,
            height: t,
            flipY: !0,
            min: "linear mipmap linear",
            mag: "linear",
            depthStencil: !1,
            depth: !1,
            stencil: !1
        };
        return e.texture(n);
    }
    deleteTerrainTexture(e) {
        e.destroy();
    }
    clear() {
        this.clearTileCaches(), super.clear();
    }
}

function Lu(e, t, n, r, i, s, o, a, l = 0) {
    e.font = "20px monospace", e.fillStyle = n, Iu.y = a - 30, e.globalAlpha = 1, e.fillText(t, Iu.x + i, Iu.y + s + l), 
    e.globalAlpha = .6, e.strokeStyle = n, e.lineWidth = r, e.beginPath(), e.moveTo(i, s), 
    e.lineTo(i + o, s), e.lineTo(i + o, s + a), e.lineTo(i, s + a), e.lineTo(i, s), 
    e.stroke(), e.globalAlpha = 1;
}

e.TileLayer.registerRenderer("gl", Ru), e.TileLayer.registerRenderer("gpu", Ru);

const {LayerAbstractRenderer: Fu, ImageLayerRenderable: Hu} = e.renderer, Du = new Int16Array([ 0, 0, 0, -1, 1, 0, 1, -1 ]), Nu = new Uint16Array([ 0, 0, 0, 1, 1, 0, 1, 1 ]);

class Bu extends(wu(Uc(Hu(Fu)))){
    constructor() {
        super(...arguments), this._imageMeshes = [];
    }
    isDrawable() {
        return !0;
    }
    drawImage(e, t, n) {
        let r = e.mesh;
        r || (r = this._createImageMesh(e, t), e.mesh = r);
        const i = this.getMap();
        if (Au(r, i, i.getGLRes()), i.getRenderer().canvas === this.canvas) {
            let e = this.layer.options.opacity;
            xl(e) && (e = 1), n *= e;
        }
        r.material.set("opacity", n), this._imageMeshes.push(r);
    }
    _createImageMesh(e, t) {
        const n = Mu.call(this, this._imageGeometry, e, t, null, 1), r = n.material.get("baseColorTexture");
        return e.texture = r, n;
    }
    drawImages(e, t) {
        this._imageMeshes.length = 0, super.drawImages(e, t);
        const n = this._getUniformValues();
        let r;
        t && t.renderTarget && (r = t.renderTarget.fbo), this._imageScene.setMeshes(this._imageMeshes), 
        this._renderer.render(this._shader, n, this._imageScene, r);
    }
    _getUniformValues() {
        return {
            "projViewMatrix": this.getMap().projViewMatrix
        };
    }
    retireImage(e) {
        const t = e.texture;
        if (t && (this.saveTexture(t), delete e.texture), e.mesh) {
            const t = e.mesh;
            t.material.set("baseColorTexture", null, !1), t.material.dispose(), e.mesh.dispose();
        }
        return delete e.mesh, super.retireImage(e);
    }
    initContext() {
        this._shader = new is({
            extraCommandProps: this._getCommandProps()
        }), this._imageGeometry = new Ye({
            aPosition: Du,
            aTexCoord: Nu
        }, 4, 0, {
            positionSize: 2,
            primitive: "triangle strip"
        });
        const {regl: e, device: t} = this.context;
        this._imageGeometry.generateBuffers(e || t), this._imageMeshes = [], this._imageScene = new Pr(this._imageMeshes), 
        this._renderer = new wr(e || t);
    }
    _getCommandProps() {
        const e = this.getMap().getRenderer().canvas;
        return {
            viewport: {
                x: 0,
                y: 0,
                width: () => e ? e.width : 1,
                height: () => e ? e.height : 1
            },
            depth: {
                enable: !0,
                func: this.layer.options.depthFunc,
                mask: !!this.layer.options.depthMask
            },
            blend: {
                enable: !0,
                func: {
                    src: 1,
                    dst: "one minus src alpha"
                },
                equation: "add"
            }
        };
    }
    onRemove() {
        return this.disposeTexturePool(), super.onRemove();
    }
}

e.ImageLayer.registerRenderer("gl", Bu), e.ImageLayer.registerRenderer("gpu", Bu);

const Uu = [ 0, 0, 0, 0 ];

class zu {
    constructor(e, t, n, r, i, s) {
        this.renderer = new wr(e), this.sceneConfig = t, this._layer = n, this._colorStops = r, 
        this._stencil = i, this._polygonOffset = s || {
            factor: 0,
            units: 0
        }, this._init(), this._outputSize = [];
    }
    render(e, t, n) {
        this._check();
        const r = this._layer.getMap();
        this.renderer.device.clear({
            color: Uu,
            depth: 1,
            stencil: 255,
            framebuffer: this._heatmapFBO
        }), this.renderer.render(this._heatmapShader, t, e, this._heatmapFBO);
        const i = this._layer.getRenderer().canvas;
        this._outputSize[0] = i.width, this._outputSize[1] = i.height;
        const s = vl({
            colorRamp: this._colorRampTex,
            inputTexture: this._heatmapFBO,
            projViewMatrix: r.projViewMatrix,
            textureOutputSize: this._outputSize
        }, t);
        return this._transformGround(), this.renderer.render(this._displayShader, s, this._groundScene, n);
    }
    dispose() {
        this._heatmapShader && (this._heatmapShader.dispose(), delete this._heatmapShader), 
        this._displayShader && (this._displayShader.dispose(), delete this._displayShader), 
        this._ground && (this._ground.geometry.dispose(), this._ground.dispose(), delete this._ground, 
        delete this._groundScene), this._heatmapFBO && (this._heatmapFBO.destroy(), delete this._heatmapFBO);
    }
    _createColorRamp() {
        const e = this._colorStops;
        let t = this._rampCanvas, n = this._rampCtx;
        n ? n.clearRect(0, 0, 256, 1) : (t = this._rampCanvas = document.createElement("canvas"), 
        t.width = 256, t.height = 1, n = this._rampCtx = t.getContext("2d"));
        const r = n.createLinearGradient(0, 0, 256, 1);
        for (let t = 0; t < e.length; t++) r.addColorStop(e[t][0], e[t][1]);
        n.fillStyle = r, n.fillRect(0, 0, 256, 1), this._colorRampTex && this._colorRampTex.destroy();
        const i = this.renderer.device;
        this._colorRampTex = i.texture({
            width: 256,
            height: 1,
            data: t,
            min: "linear",
            mag: "linear",
            premultiplyAlpha: !0
        });
    }
    _check() {
        const e = this._layer.getRenderer().canvas, t = Math.ceil(e.width / 4), n = Math.ceil(e.height / 4), r = this._heatmapFBO;
        r.width === t && r.height === n || r.resize(t, n);
    }
    _init() {
        this._createColorRamp(), this._createShader(), this._createHeatmapTex(), this._createGround();
    }
    _createGround() {
        const e = new Xr;
        e.generateBuffers(this.renderer.device), this._ground = new xr(e), this._groundScene = new Pr([ this._ground ]);
    }
    _transformGround() {
        const e = this._layer.getMap(), t = Jl.getGroundTransform(this._ground.localTransform, e);
        this._ground.setLocalTransform(t);
    }
    _createHeatmapTex() {
        const e = this._layer.getRenderer().canvas, t = this.renderer.device, n = t.hasExtension("OES_texture_half_float") ? "half float" : "float", r = Math.ceil(e.width / 4), i = Math.ceil(e.height / 4), s = t.texture({
            width: r,
            height: i,
            type: n,
            min: "linear",
            mag: "linear",
            format: "rgba"
        });
        this._heatmapFBO = t.framebuffer({
            width: r,
            height: i,
            color: [ s ]
        });
    }
    _createShader() {
        const e = this._layer.getRenderer().canvas, t = this.sceneConfig.depthRange, n = {
            viewport: {
                x: 0,
                y: 0,
                width: () => e ? Math.ceil(e.width / 4) : 1,
                height: () => e ? Math.ceil(e.height / 4) : 1
            },
            depth: {
                enable: !0,
                func: "always"
            }
        };
        this._stencil && (n.stencil = this._stencil), this._heatmapShader = new ms({
            extraCommandProps: n
        }), this._displayShader = new vs({
            x: 0,
            y: 0,
            width: () => e ? e.width : 1,
            height: () => e ? e.height : 1
        }, {
            extraCommandProps: {
                depth: {
                    enable: !0,
                    range: t || [ 0, 1 ],
                    func: "<="
                },
                polygonOffset: {
                    enable: !0,
                    offset: this._polygonOffset
                }
            }
        });
    }
}

class Gu extends rd {
    constructor(e, t) {
        super(e, t);
    }
    _createMesh(e) {
        const t = this._createGeometry(e), n = new xr(t);
        return this._setDefines(n), this._setLocalTransform(n), n;
    }
    _updateUniforms(e, t, n) {
        const r = this._getMaskMode();
        e.setUniform("maskMode", r);
        const i = this._getMaskColor();
        if (e.setUniform("maskColor", i), yl(t)) {
            const r = this._getHeightRange();
            r[0] = (r[0] - n) * t, r[1] = (r[1] - n) * t, e.setUniform("heightRange", r);
        }
    }
    setHeightRange(e) {
        this.options.heightRange = e, this._fireEvent("heightrangechange");
    }
    getHeightRange() {
        return this.options.heightRange;
    }
    _getHeightRange() {
        const e = [ 0, 0 ];
        return this.options.heightRange && (e[0] = this._altitudeToPoint(this.options.heightRange[0]), 
        e[1] = this._altitudeToPoint(this.options.heightRange[1])), e;
    }
    _setDefines(e) {
        const t = e.getDefines();
        t.HAS_MASK_COLOR = 1, e.setDefines(t);
    }
}

class Vu extends Gu {
    constructor(e, t) {
        super(e, t), this._mode = "clip-inside";
    }
}

class ju extends Gu {
    constructor(e, t) {
        super(e, t), this._mode = "clip-outside";
    }
}

class Wu extends rd {
    constructor(e, t) {
        super(e, t);
    }
    setFlatheight(e) {
        this.options.flatHeight = e, this._fireEvent("flatheightchange");
    }
    _createMesh(e) {
        const t = this._createGeometry(e), n = new xr(t);
        return this._setDefines(n), this._setLocalTransform(n), n;
    }
    _updateUniforms(e) {
        const t = this._getMaskMode();
        e.setUniform("maskMode", t);
        const n = this._getMaskColor();
        e.setUniform("maskColor", n);
        const r = this._altitudeToPoint(this.options.flatHeight || 0);
        e.setUniform("flatHeight", r);
    }
    _setDefines(e) {
        const t = e.getDefines();
        t.HAS_MASK_FLAT = 1, e.setDefines(t);
    }
    _getHeightRange() {
        const e = [ 0, this.options.flatHeight ];
        return e[1] = this._altitudeToPoint(e[1]), e;
    }
}

let qu = class extends Wu {
    constructor(e, t) {
        super(e, t), this._mode = "flat-inside";
    }
};

class Xu extends Wu {
    constructor(e, t) {
        super(e, t), this._mode = "flat-outside";
    }
}

class Ku extends rd {
    constructor(e, t) {
        super(e, t), this._mode = "color";
    }
    setHeightRange(e) {
        this.options.heightRange = e, this._fireEvent("heightrangechange");
    }
    _createMesh(e) {
        const t = this._createGeometry(e), n = new xr(t);
        return this._setDefines(n), this._setLocalTransform(n), n;
    }
    _updateUniforms(e, t, n) {
        const r = this._getMaskMode();
        e.setUniform("maskMode", r);
        const i = this._getMaskColor();
        if (e.setUniform("maskColor", i), yl(t)) {
            const r = this._getHeightRange();
            r[0] = (r[0] - n) * t, r[1] = (r[1] - n) * t, e.setUniform("heightRange", r);
        }
    }
    _setDefines(e) {
        const t = e.getDefines();
        t.HAS_MASK_COLOR = 1, e.setDefines(t);
    }
    _getHeightRange() {
        const e = [ 0, 0 ];
        return this.options.heightRange && (e[0] = this._altitudeToPoint(this.options.heightRange[0]), 
        e[1] = this._altitudeToPoint(this.options.heightRange[1])), e;
    }
}

class Zu extends rd {
    constructor(e, t) {
        super(e, t), this._mode = "texture";
    }
    play() {
        this._video && this._video.play();
    }
    pause() {
        this._video && this._video.pause();
    }
    setAudio(e) {
        this._video && (this.video.muted = e);
    }
    setUrl(e) {
        this.options.url = e, this._createVideo(e);
    }
    getState() {
        return this._videoState;
    }
    _createMesh(e) {
        const {geometry: t, copyGeometry: n} = this._createGeometry(e), r = new xr(t), i = this._createVideoTexture(e);
        return r.material = new Ft({
            maskTexture: i
        }), this._setDefines(r), this._setLocalTransform(r), this._copyMesh = new xr(n), 
        this._setLocalTransform(this._copyMesh), r;
    }
    _updateUniforms(e) {
        const t = this._getMaskMode();
        if (e.setUniform("maskMode", t), this._positions && this._positions.length) for (let t = 0; t < 4; t++) e.setUniform("mask_position" + t, this._positions.slice(3 * t, 3 * t + 3));
        const n = this._getMaskColor();
        e.setUniform("maskColor", n);
    }
    _setDefines(e) {
        const t = e.getDefines();
        t.HAS_TEXTURE = 1, e.setDefines(t);
    }
    _createVideoTexture(e) {
        this._createVideo();
        return e.texture();
    }
    _createVideo() {
        this._videoState = "stop";
        const e = this.options.url, t = this.options.elementId;
        let n = document.getElementById(t);
        if (e && (n = document.createElement("video"), n.src = e), !n) throw new Error("there is no element or url setting for video mask");
        n.autoplay = this.options.autoplay || !0, n.loop = this.options.loop || !0, n.muted = this.options.muted || !0, 
        n.play(), n.addEventListener("playing", (() => {
            this._videoState = "playing";
        })), n.addEventListener("pause", (() => {
            this._videoState = "pause";
        })), this._video = n;
    }
    _update() {
        const e = this._mesh;
        if (e && e.material) {
            const t = e.material.get("maskTexture");
            t && this._video && this._needUpdate() && t(this._video);
        }
    }
    _needUpdate() {
        return "playing" === this._videoState;
    }
}

class Yu extends rd {
    constructor(e, t) {
        super(e, t), this._mode = "texture";
    }
    setUrl(e) {
        this.options.url = e;
        const t = this._mesh;
        if (t && t.material) {
            const e = t.material.get("maskTexture");
            if (e) {
                this._createTexture(e);
                const t = this.getLayer();
                t && t.getRenderer().setToRedraw();
            }
        }
    }
    _createMesh(e) {
        const {geometry: t, copyGeometry: n} = this._createGeometry(e), r = new xr(t), i = e.texture();
        return this._createTexture(i), r.material = new Ft({
            maskTexture: i
        }), this._setDefines(r), this._setLocalTransform(r), this._copyMesh = new xr(n), 
        this._setLocalTransform(this._copyMesh), r;
    }
    _updateUniforms(e) {
        const t = this._getMaskMode();
        e.setUniform("maskMode", t);
        const n = this._getMaskColor();
        if (e.setUniform("maskColor", n), this._positions && this._positions.length) for (let t = 0; t < 4; t++) e.setUniform("mask_position" + t, this._positions.slice(3 * t, 3 * t + 3));
    }
    _setDefines(e) {
        const t = e.getDefines();
        t.HAS_TEXTURE = 1, e.setDefines(t);
    }
    _createTexture(e) {
        const t = new Image;
        t.src = this.options.url, t.crossOrigin = "anonymous", t.onload = function() {
            e(t);
        }, t.onerror = function() {
            console.warn("Image load error");
        };
    }
    getBBox() {
        return this._copyMesh.getBoundingBox();
    }
}

class $u extends Wu {
    constructor(e, t) {
        super(e, t), this.setElevation(t.elevation), this._mode = "elevate";
    }
    setElevation(e) {
        this.options.elevation = e, this.setFlatheight(this.options.elevation);
    }
}

const Ju = new r(0, 0), Qu = new r(0, 0), ef = new r(0, 0), tf = new r(0, 0);

class nf extends Gu {
    constructor(e, t) {
        super([], t), this._position = e;
    }
    setPosition(e) {
        this._position = e, this._updateCoordinates();
    }
    getPosition() {
        return this._position;
    }
    setWidth(e) {
        this.options.width = e, this._updateCoordinates();
    }
    setLength(e) {
        this.options.length = e, this._updateCoordinates();
    }
    setHeight(e) {
        this.options.height = e, this._updateCoordinates();
    }
    setRotation(e) {
        this.options.rotation = e, this._updateCoordinates();
    }
    _updateCoordinates() {
        const e = this.getLayer();
        if (!e) return;
        const t = e.getMap();
        if (t) {
            const {length: e, width: n, height: r} = this.options, i = this._position, s = this.options.rotation || 0, {coordinates: o, heightRange: a} = this._generateCoordinates(t, i, e, n, r, s);
            this.setCoordinates(o), this.setHeightRange(a);
        }
    }
    _generateCoordinates(e, t, n, r, i, s) {
        const o = e.getGLRes(), a = e.distanceToPointAtRes(r / 2, 0, o, Ju), l = e.distanceToPointAtRes(0, n / 2, o, Qu), c = e.coordinateToPointAtRes(t, o, ef), h = c.x - a.x, d = c.x + a.x, u = c.y + l.y, f = c.y - l.y, m = this._rotatePoint([ [ h, u ], [ d, u ], [ d, f ], [ h, f ] ], c, s);
        tf.set(m[0][0], m[0][1]);
        const g = e.pointAtResToCoordinate(tf, o);
        tf.set(m[1][0], m[1][1]);
        const _ = e.pointAtResToCoordinate(tf, o);
        tf.set(m[2][0], m[2][1]);
        const p = e.pointAtResToCoordinate(tf, o);
        tf.set(m[3][0], m[3][1]);
        const v = e.pointAtResToCoordinate(tf, o), x = t.z - i / 2, y = [ x, t.z + i / 2 ];
        return {
            coordinates: [ [ g.x, g.y, x ], [ _.x, _.y, x ], [ p.x, p.y, x ], [ v.x, v.y, x ], [ g.x, g.y, x ] ],
            heightRange: y
        };
    }
    _rotatePoint(e, t, n) {
        for (let r = 0; r < e.length; r++) f.rotate(e[r], e[r], [ t.x, t.y ], n * Math.PI / 180);
        return e;
    }
}

class rf extends nf {
    constructor(e, t) {
        super(e, t), this._mode = "clip-inside";
    }
}

class sf extends nf {
    constructor(e, t) {
        super(e, t), this._mode = "clip-outside";
    }
}

class of extends e.DrawTool {
    constructor(e) {
        super(e), this.on("enable", this._afterEnable, this), this.on("disable", this._afterDisable, this), 
        this._drawCoordinates = [];
    }
    addTo(e) {
        return e && (super.addTo(e), this._map = e, this._addHelperLayer()), this;
    }
    _addHelperLayer() {
        const t = e.INTERNAL_LAYER_PREFIX + "drawtool", n = this._map.getLayer(t);
        n && n.hide();
    }
    _afterEnable() {
        this.on("drawstart", this._msOnDrawStart, this).on("drawvertex", this._msOnDrawVertex, this).on("mousemove", this._msOnMouseMove, this).on("drawend", this._msOnDrawEnd, this);
    }
    _afterDisable() {
        this.off("drawstart", this._msOnDrawStart, this).off("drawvertex", this._msOnDrawVertex, this).off("mousemove", this._msOnMouseMove, this).off("drawend", this._msOnDrawEnd, this);
    }
    _getPickedCoordinate(t) {
        const {coordinate: n, containerPoint: r} = t, i = this._map.getLayers((e => e.queryTerrainAtPoint))[0];
        if (!i) return n.z = n.z || 0, n;
        const s = i.identify(n, {
            includeInternals: !1
        })[0];
        let o = null;
        if (s && s.coordinate ? o = new e.Coordinate(s.coordinate) : (n.z = n.z || 0, o = n), 
        i.getTerrainLayer()) {
            const e = i.queryTerrainAtPoint(r);
            return e && e.z > o.z ? e : o;
        }
        return o;
    }
    _msOnDrawStart(e) {
        const t = this._getPickedCoordinate(e);
        t && (this._first = !0, this._drawCoordinates.push(t), this._addHelperGeometry(t));
    }
    _msOnDrawVertex(e) {
        const t = this._getPickedCoordinate(e);
        if (!t) return;
        this._first = !0, this._drawCoordinates[this._drawCoordinates.length - 1] = t, this._drawVertexMarker();
        const n = this.getTempGeometry();
        n && n.hide();
    }
    _msOnMouseMove(e) {
        const t = this._getPickedCoordinate(e);
        t && (this._first ? this._drawCoordinates.push(t) : this._drawCoordinates[this._drawCoordinates.length - 1] = t, 
        this._drawVertexMarker(), this._first = !1);
    }
    _msOnDrawEnd(e) {
        const t = this._getPickedCoordinate(e);
        t && (this._drawCoordinates.push(t), this._drawEnd());
    }
    _drawEnd() {
        this._drawVertexMarker(), this._drawCoordinates = [], this._helperGeometry = null, 
        this._label = null;
    }
    remove() {
        this._helperLayer && this._helperLayer.remove(), this._markerLayer && this._markerLayer.remove();
    }
    clear() {
        this._helperLayer && this._helperLayer.clear(), this._markerLayer && this._markerLayer.clear();
    }
}

of.mergeOptions({
    "mode": "LineString",
    "language": "zh-CN",
    "metric": !0,
    "imperial": !1,
    "once": !0,
    "symbol": {
        "lineColor": "#e8542b",
        "lineWidth": 2,
        "polygonFill": "#eee",
        "polygonOpacity": .5
    },
    "vertexSymbol": {
        "markerType": "ellipse",
        "markerFill": "#e8542b",
        "markerLineColor": "#fff",
        "markerLineWidth": 2,
        "markerWidth": 10,
        "markerHeight": 10,
        "markerDy": 0
    },
    "labelSymbol": {
        "boxStyle": {
            "padding": [ 15, 6 ],
            "verticalAlignment": "top",
            "horizontalAlignment": "left",
            "minWidth": 150,
            "minHeight": 30,
            "symbol": {
                "markerType": "square",
                "markerFill": "rgb(60, 60, 60)",
                "markerFillOpacity": .8,
                "markerLineColor": "#fff",
                "markerLineWidth": 2,
                "textDx": -110
            }
        },
        "textSymbol": {
            "textFill": "#fff",
            "textSize": 16,
            "textVerticalAlignment": "top"
        }
    }
});

class af extends of {
    _addHelperLayer() {
        super._addHelperLayer(), this._helperLayer = new e.DrawToolLayer(e.INTERNAL_LAYER_PREFIX + "_distance3dtool").addTo(this._map), 
        this._markerLayer = new e.DrawToolLayer(e.INTERNAL_LAYER_PREFIX + "_distance3dtool_marker").addTo(this._map);
    }
    _drawVertexMarker() {
        this._helperGeometry.setCoordinates(this._drawCoordinates);
        const t = this._markerLayer.getGeometries(), n = this._helperLayer.getGeometries().length;
        for (let e = 0; e < t.length; e++) {
            const r = t[e].getId();
            r !== "label" + n && r.indexOf(`${n}_`) > -1 && t[e].remove();
        }
        for (let t = 0; t < this._drawCoordinates.length; t++) new e.Marker(this._drawCoordinates[t], {
            id: n + "_" + t,
            symbol: this.options.vertexSymbol
        }).addTo(this._markerLayer);
        this._drawLabel();
    }
    _drawLabel() {
        const t = this.getMeasureResult(), n = (("zh-CN" === this.options.language ? 0 : 1) ? "distance: " : "距离: ") + this._getUnitContent(t), r = this._drawCoordinates[this._drawCoordinates.length - 1], i = this._helperLayer.getGeometries().length, s = e.Util.extend({
            id: "label" + i
        }, this.options.labelSymbol);
        this._label ? (this._label.setContent(n), this._label.setCoordinates(r)) : this._label = new e.Label(n, r, s).addTo(this._markerLayer);
    }
    _getUnitContent(e) {
        let t;
        t = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let n = "";
        return this.options.metric && (this._measure = e < 1e3 ? e.toFixed(1) : (e / 1e3).toFixed(2), 
        this._units = e < 1e3 ? t[0] : t[1]), this.options.imperial && (e *= 3.2808399, 
        n.length > 0 && (n += "\n"), this._measure = e < 5280 ? e.toFixed(1) : (e / 5280).toFixed(2), 
        this._units = e < 5280 ? t[2] : t[3]), n += this._measure + this._units, n;
    }
    _addHelperGeometry(t) {
        this._helperGeometry || (this._helperGeometry = new e.LineString([ t ], {
            symbol: this.options.symbol
        }).addTo(this._helperLayer)), this._drawVertexMarker(), this._first = !0;
    }
    getMeasureResult() {
        return this._helperGeometry.getLength();
    }
}

class lf extends of {
    _addHelperLayer() {
        super._addHelperLayer(), this._helperLayer = new e.DrawToolLayer(e.INTERNAL_LAYER_PREFIX + "_area3dtool").addTo(this._map), 
        this._markerLayer = new e.DrawToolLayer(e.INTERNAL_LAYER_PREFIX + "_area3dtool_marker").addTo(this._map);
    }
    _drawVertexMarker() {
        const t = this._getPolygonCoordinates(this._drawCoordinates);
        this._helperGeometry.setCoordinates(t), this._polygon.setCoordinates(t);
        const n = this._markerLayer.getGeometries(), r = this._helperLayer.getGeometries().length;
        for (let e = 0; e < n.length; e++) {
            const t = n[e].getId();
            t !== "label" + r && t.indexOf(`${r}_`) > -1 && n[e].remove();
        }
        for (let t = 0; t < this._drawCoordinates.length; t++) new e.Marker(this._drawCoordinates[t], {
            id: r + "_" + t,
            symbol: this.options.vertexSymbol
        }).addTo(this._markerLayer);
        this._drawLabel();
    }
    _getPolygonCoordinates(e) {
        const t = e.map((e => e));
        return e.length > 2 && t.push(e[0]), t;
    }
    _drawLabel() {
        const t = this.getMeasureResult(), n = (("zh-CN" === this.options.language ? 0 : 1) ? "area: " : "面积: ") + this._getUnitContent(t), r = this._drawCoordinates[this._drawCoordinates.length - 1], i = this._helperLayer.getGeometries().length, s = e.Util.extend({
            id: "label" + i
        }, this.options.labelSymbol);
        this._label ? (this._label.setContent(n), this._label.setCoordinates(r)) : this._label = new e.Label(n, r, s).addTo(this._markerLayer);
    }
    _getUnitContent(e) {
        let t;
        t = "zh-CN" === this.options.language ? [ " 平方米", " 平方公里", " 平方英尺", " 平方英里" ] : [ " sq.m", " sq.km", " sq.ft", " sq.mi" ];
        let n = "";
        if (this.options.metric && (this._measure = e < 1e6 ? e.toFixed(2) : (e / 1e6).toFixed(2), 
        this._units = e < 1e6 ? t[0] : t[1]), this.options.imperial) {
            e *= 3.2808399, n.length > 0 && (n += "\n");
            const r = 27878400;
            this._measure = e < r ? e.toFixed(2) : (e / r).toFixed(2), this._units = e < r ? t[2] : t[3];
        }
        return n += this._measure + this._units, n;
    }
    _addHelperGeometry(t) {
        this._helperGeometry || (this._helperGeometry = new e.LineString([ t ], {
            symbol: this.options.symbol
        }).addTo(this._helperLayer), this._polygon = new e.Polygon([ t ])), this._drawVertexMarker(), 
        this._first = !0;
    }
    getMeasureResult() {
        return this._polygon.getArea();
    }
}

const cf = [ [ "直线距离", "垂直高度", "水平距离" ], [ "spatial distance", "vertical height", "horizontal distance" ] ];

class hf extends of {
    _addHelperLayer() {
        super._addHelperLayer(), this._helperLayer = new e.DrawToolLayer(e.INTERNAL_LAYER_PREFIX + "_height3dtool").addTo(this._map), 
        this._markerLayer = new e.DrawToolLayer(e.INTERNAL_LAYER_PREFIX + "_height3dtool_marker").addTo(this._map);
    }
    _msOnDrawVertex(e) {
        super._msOnDrawVertex(e), this._drawCoordinates.length > 1 && (this._drawEnd(), 
        this.disable());
    }
    _drawVertexMarker() {
        const t = this._markerLayer.getGeometries(), n = this._helperLayer.getGeometries().length;
        for (let e = 0; e < t.length; e++) {
            const r = t[e].getId();
            r !== "label" + n + "_" + e && 0 === r.indexOf(`${n}_`) && t[e].remove();
        }
        for (let t = 0; t < this._drawCoordinates.length; t++) new e.Marker(this._drawCoordinates[t], {
            id: n + "_" + t,
            symbol: this.options.vertexSymbol
        }).addTo(this._markerLayer);
        const r = this._drawCoordinates.length;
        if (r > 1) {
            const t = this._drawCoordinates[r - 1].x, i = this._drawCoordinates[r - 1].y, s = this._drawCoordinates[r - 2].z, o = new e.Coordinate([ t, i, s ]);
            new e.Marker(o, {
                id: n + "_2",
                symbol: this.options.vertexSymbol
            }).addTo(this._markerLayer);
            const a = [].concat(this._drawCoordinates);
            a.push(o), a.push(this._drawCoordinates[0]);
            const l = a.map((e => e.z));
            this._helperGeometry.setCoordinates(a), this._helperGeometry.setProperties({
                altitude: l
            });
            const c = this._map.getProjection().measureLenBetween(a[0], a[2]), h = a[1].z - a[2].z, d = Math.sqrt(Math.pow(c, 2) + Math.pow(h, 2));
            this._drawLabel(a, [ d, h, c ]);
        }
    }
    _drawLabel(t, n) {
        for (let r = 0; r < t.length - 1; r++) {
            const i = t[r], s = t[r + 1], o = n[r], a = "zh-CN" === this.options.language ? 0 : 1, l = this._getUnitContent(o), c = cf[a][r] + ":" + l, h = "label" + this._helperLayer.getGeometries().length + "_" + r, d = JSON.parse(JSON.stringify(this.options.labelSymbol));
            d.id = h, r < 2 && (d.boxStyle.symbol.textDx *= -1);
            const u = 1 === r ? i : new e.Coordinate((i.x + s.x) / 2, (i.y + s.y) / 2, (i.z + s.z) / 2), f = this._markerLayer.getGeometryById(h), m = `${h}_marker`, g = this._markerLayer.getGeometryById(m);
            f ? (f.setContent(c), f.setCoordinates(u), g.setCoordinates(u)) : (new e.Label(c, u, d).addTo(this._markerLayer), 
            new e.Marker(u, {
                id: m,
                symbol: this.options.vertexSymbol
            }).addTo(this._markerLayer));
        }
    }
    _getUnitContent(e) {
        let t;
        t = "zh-CN" === this.options.language ? [ " 米", " 公里", " 英尺", " 英里" ] : [ " m", " km", " feet", " mile" ];
        let n = "";
        return this.options.metric && (this._measure = e < 1e3 ? e.toFixed(1) : (e / 1e3).toFixed(2), 
        this._units = e < 1e3 ? t[0] : t[1]), this.options.imperial && (e *= 3.2808399, 
        n.length > 0 && (n += "\n"), this._measure = e < 5280 ? e.toFixed(1) : (e / 5280).toFixed(2), 
        this._units = e < 5280 ? t[2] : t[3]), n += this._measure + this._units, n;
    }
    _addHelperGeometry(t) {
        this._helperGeometry || (this._helperGeometry = new e.LineString([ t ], {
            symbol: this.options.symbol
        }).addTo(this._helperLayer)), this._drawVertexMarker(), this._first = !0;
    }
    getMeasureResult() {
        return this._helperGeometry.getLength();
    }
}

export { lf as Area3DTool, rf as BoxInsideClipMask, sf as BoxOutsideClipMask, Uc as CanvasCompatible, Vu as ClipInsideMask, ju as ClipOutsideMask, Ku as ColorMask, gh as ContextUtil, af as Distance3DTool, $u as ElevateMask, qu as FlatInsideMask, Xu as FlatOutsideMask, Jl as GroundPainter, Kd as GroupGLLayer, zu as HeatmapProcess, hf as Height3DTool, bu as HighlightUtil, Yu as ImageMask, hu as MapGLRenderer, mu as MapGPURenderer, _d as MaskLayerMixin, Eh as MaskRendererMixin, of as Measure3DTool, Ud as RayCaster, Zu as VideoMask, gl as color, ce as earcut, Ma as reshader };
//# sourceMappingURL=gl.es.js.map
